"use strict";
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
    }
    return arr2;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
    }
    return _typeof(obj);
}
function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf =
        Object.setPrototypeOf ||
        function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function _getPrototypeOf(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
          };
    return _getPrototypeOf(o);
}
(function e(t, n, r) {
    function s(o, u) {
        if (!n[o]) {
            if (!t[o]) {
                var a = typeof require == "function" && require;
                if (!u && a) return a(o, !0);
                if (i) return i(o, !0);
                throw new Error("Cannot find module '" + o + "'");
            }
            var f = (n[o] = { exports: {} });
            t[o][0].call(
                f.exports,
                function (e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                },
                f,
                f.exports,
                e,
                t,
                n,
                r
            );
        }
        return n[o].exports;
    }
    var i = typeof require == "function" && require;
    for (var o = 0; o < r.length; o++) {
        s(r[o]);
    }
    return s;
})(
    {
        1: [
            function (require, module, exports) {
                /*============================================================================  Other   ==============================================================================*/ // theme.clickEvent;
                theme.sizeChart_defaultTab;
                theme.clickEvent = function () {
                    // static page side-navbar click event for mobile
                    if ($(".static-page").length > 0) {
                        $(".static-page .left-nav--categories .opener").click(function () {
                            $(this).toggleClass("is-on").closest(".left-nav--categories").find(".dropdown").slideToggle(200);
                        });
                    } // sizechart Fancy box event
                    if ($(".template-product").length > 0) {
                        $(document).on("click", ".size-chart--trigger", function () {
                            var sizeChart = $(this).attr("data-tag");
                            theme.sizeChart_defaultTab = $(this).attr('data-chart-tab');

                            $.fancybox.open("#size-chart--popup", {
                                afterClose: function () {
                                    $(".ct-lazyloaded-iframe").html(decodeURIComponent($(".ct-lazyloaded-iframe").attr('data-yt')));
                                }
                            });
                            $(".size-chart").hide();
                            /*$("#" + sizeChart).show();*/
                            $('.size-chart-header ul li#nav-'+theme.sizeChart_defaultTab).click();
                        });
                    }
                    if ($(".page-faq").length > 0) {
                        $(document).on("click", ".faq-size-chart--trigger", function () {
                            var sizeChart = $(this).attr("data-tag");
                            $.fancybox.open("#size-chart--popup");
                            $(".size-chart").hide();
                            $("#" + sizeChart).show();
                        });
                    } // footer contact click event
                    $(document).on("click", ".contact-title", function () {
                        if ($(window).width() < 767) {
                            $(this).parent().toggleClass("active");
                        }
                    }); // straw hat page navigation tab event
                    $(document).on("click", ".straw-hats .nav-wrapper li a", function (e) {
                        e.preventDefault();
                        var target = $(this).attr("href");
                        if (target) {
                            var targetOffsetTop = $(target).offset().top - 70;
                            $("html,body").animate({ scrollTop: targetOffsetTop + "px" }, 1000);
                        }
                    });
                }; // min height
                theme.miniHeightAction = function (selector) {
                    var min_height = 0;
                    selector.each(function () {
                        var height = $(this).outerHeight();
                        if (height > min_height) {
                            min_height = height;
                        }
                    });
                    return min_height;
                };
                theme.miniHeight = function (parent, select) {
                    var parentWrapper = $(parent).closest(".shopify-section");
                    parentWrapper.each(function (index, item) {
                        if ($(parent, item).length > 0) {
                            var result = theme.miniHeightAction($(select, item));
                            $(parent, item).css("height", result);
                        }
                    });
                };
                /**
                 *On product swatch mouse hover change image src
                 * common for recently view, collection page, search page products
                 */ theme.initSwatchHoverEvent = function () {
                    function toggleSwatchImage($el) {
                        if ($el.length === 0) {
                            return false;
                        }
                        var $parent = $el.closest(".product-box");
                        var swatches = JSON.parse($parent.find(".swatch-box").attr("data-swatches"));
                        var title = $el.find(".swatch-item").attr("data-title").toLowerCase().trim().replace(" ", "-");
                        if (swatches != null && swatches != undefined && swatches.length) {
                            for (var key in swatches) {
                                if (swatches[key].colorValueName === title) {
                                    var src = swatches[key].variantImgUrl;
                                    $(".product-main-img", $parent).attr("src", src);
                                }
                            }
                        }
                    }
                };
                theme.AccountPageSidebar = function () {
                    $("#customer-wrapper .sidemenu h3").click(function () {
                        $(this).next().slideToggle("slow");
                    });
                };// common function to identify videos in banners, provide play/pause function
                theme.videoFrame = function () {
                    var rootElm = $(".promo-banner");
                    rootElm.each(function () {
                        var $elm = $(this);
                        if ($elm.attr("data-section-type") == "video") {
                            var iframe = $(".vimeo-video-wrapper", $elm);
                            var player = new Vimeo.Player(iframe);
                            var autoplay = iframe.attr("data-autoplay");
                            if (autoplay == 1) {
                                player.play();
                            }
                            $(".play-btn", $elm).click(function (e) {
                                e.stopPropagation();
                                var play_btn = $(this);
                                if (!play_btn.hasClass("loaded")) {
                                    play_btn.addClass("loaded");
                                    $("h4", play_btn).text("Loading");
                                    setTimeout(function () {
                                        play_btn.hide().removeClass("active");
                                        $("h4", play_btn).text("Play");
                                        $(".pause-btn", $elm).show().addClass("active");
                                    }, 2500);
                                } else {
                                    play_btn.hide().removeClass("active");
                                    $(".pause-btn", $elm).show().addClass("active");
                                }
                                player.on("load", function () {
                                    console.log("loaded");
                                });
                                player.play();
                            });
                            $(".pause-btn", $elm).click(function (e) {
                                e.stopPropagation();
                                $(this).hide().removeClass("active");
                                $(".play-btn", $elm).show().addClass("active");
                                player.pause();
                            });
                            $(".btn-wrapper", $elm).click(function () {
                                if ($(window).width() < 1024) {
                                    $(".player-btn.active", $elm).click();
                                }
                            }); // To open fancybox on button click
                            $(".popup-btn a", $elm).click(function (e) {
                                e.preventDefault();
                                var source = $(".video-wrapper iframe", $elm).attr("src").replace("&background=1", "").replace("&autoplay=1", "");
                                $.fancybox({ autoScale: true, transitionIn: "fade", transitionOut: "fade", href: source, type: "iframe", wrapCSS: "promo-video-popup", helpers: { overlay: { locked: false } } });
                            });
                        }
                    });
                }; // function to move PLP footer banner to the end
                theme.setCollectionFooter = function () {
                    var footerBanner = $(".collection-footer-banner");
                    if (footerBanner && footerBanner.length == 1) {
                        $("#content").append(footerBanner);
                        footerBanner.removeClass("hide");
                    }
                };
                theme.setSlider = function (el, slides, dots) {
                    $(el).slick({ dots: dots, infinite: true, speed: 300, slidesToShow: slides, slidesToScroll: 1, arrows: false });
                };
                theme.load = function () {
                    theme.initSwatchHoverEvent();
                    theme.clickEvent();
                    theme.setCollectionFooter();
                };
                $(document).ready(function () {
                    theme.load();
                    theme.AccountPageSidebar();
                    if ($(window).width() < 768) {
                        theme.setSlider($(".straw-hats .main-wrapper-style-guide"), 1, true);
                        theme.setSlider($(".straw-hats .straw-hats-slider-mobile"), 1, true);
                        theme.setSlider($(".straw-hats .main-wrapper-type-straw"), 1, true);
                    } else {
                        theme.setSlider($(".straw-hats .straw-hats-slider-desktop"), 1, true);
                    }
                });
                $(window).load(function () {
                    if ($(".template-index").length > 0 || $(".template-collection").length > 0) {
                        setTimeout(function () {
                            theme.videoFrame();
                        }, 1000);
                    }
                });
                $(window).on("scroll", function (e) {
                    var video = $(".straw-hats .video-section video");
                    video.map(function (index, data) {
                        var isVisible = theme.isElementInView($(data), false);
                        if (isVisible) {
                            $(data).trigger("play");
                        } else {
                            $(data).trigger("pause");
                        }
                    });
                });
            },
            {},
        ],
        2: [
            function (require, module, exports) {
                "use strict"; // GLOBAL NAMESPACES
                window.theme = window.theme || {}; // window.React = require( './vendor/react.js' ); // Remove the .min to see full errors in console
                theme.utils = theme.utils || {}; // UTILS - add functionality modules we can later port out to other files
                require("./utils/global-utils.js");
                theme.utils.filterUtils = require("./utils/filter-utils.js");
                theme.utils.productUtils = require("./utils/product-utils.js");
                theme.utils.stickyUtils = require("./utils/sticky-utils.js");
                theme.utils.cartUtils = require("./utils/cart-utils.js");
                theme.utils.emailUtils = require("./utils/email-utils.js");
                theme.utils.preOrderUtils = require("./utils/preorder-utils.js"); // SECTIONS
                require("./sections/sections.js");
                require("./sections/header.js");
                require("./sections/newsletter.js");
                require("./sections/testimonials.js");
                require("./sections/columns-carousel.js");
                require("./sections/slideshow.js");
                require("./sections/featured-collections.js"); // require('./sections/parallax.js');
                // require('./sections/maps.js');
                require("./sections/product.js");
                require("./sections/collection.js");
                require("./sections/search.js");
                require("./sections/footer.js");
                require("./sections/account.js");
                require("./sections/bourbon-age-gate.js"); // SNIPPETS - Usually used in multiple places, most of these are global components
                require("./bol/other.js");
                require("./snippets/newsletter-popup.js");
                require("./snippets/cookie-banner.js");
                require("./snippets/scroll-to-top.js");
                /*============================================================================
  Registering Sections
==============================================================================*/ $(document).ready(function () {
                    var sections = new theme.Sections();
                    sections.register("header-section", theme.Header);
                    sections.register("newsletter-social", theme.Newsletter);
                    sections.register("featured-collections", theme.FeaturedCollections);
                    sections.register("homepage-products", theme.FeaturedProducts);
                    sections.register("slideshow-section", theme.Slideshow);
                    sections.register("columns-carousel-section", theme.ColumnsCarousel); // sections.register('parallax-section', theme.Parallax);
                    // sections.register('map', theme.Maps);
                    sections.register("homepage-testimonials", theme.Testimonials);
                    sections.register("mobile-navigation", theme.mobileNav);
                    sections.register("product-section", theme.Product);
                    sections.register("search-template", theme.Search);
                    sections.register("footer-section", theme.Footer);
                    sections.register("bourbon-age-gate", theme.Bourbon);
                });
            },
            {
                "./bol/other.js": 1,
                "./sections/account.js": 19,
                "./sections/bourbon-age-gate.js": 20,
                "./sections/collection.js": 22,
                "./sections/columns-carousel.js": 23,
                "./sections/featured-collections.js": 24,
                "./sections/footer.js": 25,
                "./sections/header.js": 26,
                "./sections/newsletter.js": 28,
                "./sections/product.js": 29,
                "./sections/search.js": 31,
                "./sections/sections.js": 32,
                "./sections/slideshow.js": 33,
                "./sections/testimonials.js": 34,
                "./snippets/cookie-banner.js": 35,
                "./snippets/newsletter-popup.js": 36,
                "./snippets/scroll-to-top.js": 41,
                "./utils/cart-utils.js": 43,
                "./utils/email-utils.js": 44,
                "./utils/filter-utils.js": 45,
                "./utils/global-utils.js": 46,
                "./utils/preorder-utils.js": 47,
                "./utils/product-utils.js": 48,
                "./utils/sticky-utils.js": 49,
            },
        ],
        3: [
            function (require, module, exports) {
                /*============================================================================
 Back In Stock Notify : (Snippet = back-in-stock-notify.liquid)

 TAKE NOTE:
    - When using this on a Merge'd PDP template, if you have sizes that dont
    exist on other colorways that are merged, the link CANNOT show becuase there
    is no variant ID in Shopify for a size that doesn't exist on a color. Thus,
    the link will only show up when its possible to notify the user.
==============================================================================*/ var NotifyForm = require("./NotifyForm.js");
                var BackInStock = /*#__PURE__*/ (function (_React$Component) {
                    _inherits(BackInStock, _React$Component);
                    var _super = _createSuper(BackInStock);
                    function BackInStock(props) {
                        var _this6;
                        _classCallCheck2(this, BackInStock);
                        _this6 = _super.call(this, props);
                        _this6.state = {
                            email: "",
                            mailListingSubscribe: true,
                            listSubscribeError: false,
                            subscribeList: 'URf5EE',
                            subscribeKey: 'pk_a5e51d23695d1a05eb8b588b074b914199',
                            phoneNumber: "",
                            formShow: false,
                            formEmailValid: false,
                            formNumberValid: false,
                            msgError: false,
                            msgShow: false,
                            msgValue: "",
                            productId: null,
                            signupComplete: false,
                            variantId: null,
                            variants: [],
                            product: {},
                        }; // DEFAULTS : Deep copy, dont want inheritance
                        _this6.defaultState = Object.assign({}, _this6.state); // BIND CONTEXTS (only those needing it)
                        _this6.closePopup = _this6.closePopup.bind(_assertThisInitialized(_this6));
                        _this6.updateEmail = _this6.updateEmail.bind(_assertThisInitialized(_this6));
                        _this6.updateSubscribe = _this6.updateSubscribe.bind(_assertThisInitialized(_this6));
                        _this6.submitEmail = _this6.submitEmail.bind(_assertThisInitialized(_this6));
                        _this6.updateNumber = _this6.updateNumber.bind(_assertThisInitialized(_this6));
                        _this6.submitNumber = _this6.submitNumber.bind(_assertThisInitialized(_this6));
                        return _this6;
                    }
                    _createClass2(BackInStock, [
                        {
                            key: "componentDidMount",
                            value: function componentDidMount() {
                                var _this7 = this;
                                var product = this.props.product;
                                var defaults = this.defaultState; // RESET : Setup the vars for a fresh start on variant change
                                var setState = this.setState.bind(this);
                                var refreshSticky = this.refreshStickyKit;
                                var newState = Object.assign({}, defaults);
                                newState.variants = product.variants;
                                newState.product = product;
                                var unavailableVariant = product.variants.find(function (variant) {
                                    return !variant.available;
                                });
                                if (unavailableVariant) {
                                    newState.variantId = unavailableVariant.id;
                                    newState.productId = product.id;
                                } // UPDATE STATE
                                setState(newState);
                                refreshSticky(0); // EVENTS (VARIANT CHANGE) : Show Link + Update form data on variant changes where its possible to fulfill a notification signup
                                Events.on("variantchange:precise", function (variant) {
                                    var newState = _this7.state; // CHECK : Do we have all required props to fulfill the form usage?
                                    if (variant && variant.id && product && product.info && product.info[variant.id]) {
                                        newState.variantId = variant.id;
                                        newState.productId = product.info[variant.id].product_id || product.id;
                                    } else if (variant && variant.id && variant.featured_image && variant.featured_image.product_id) {
                                        newState.variantId = variant.id;
                                        newState.productId = variant.featured_image.product_id;
                                    } else {
                                        console.log("Could not find product id");
                                    } // UPDATE STATE
                                    setState(newState);
                                    if (variant && !variant.available) {
                                        _this7.showBISModal();
                                    } else {
                                        _this7.hideBISWidget();
                                    }
                                });
                            }, // show BIS modal
                        },
                        {
                            key: "showBISModal",
                            value: function showBISModal() {
                                $("#product-add").hide();
                                $(".react-back-in-stock").show(); // $('body').removeClass('hide-overflow').addClass('hide-overflow');
                            }, // show Product Add widget
                        },
                        {
                            key: "hideBISWidget",
                            value: function hideBISWidget() {
                                $(".react-back-in-stock").hide(); // $('body').removeClass('hide-overflow');
                                $("#product-add").show();
                            }, // UTIL - Update sticky UI nodes on layout changes, delay in ms to wait for animations to complete
                        },
                        {
                            key: "refreshStickyKit",
                            value: function refreshStickyKit() {
                                var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                                setTimeout(function () {
                                    $(document.body).trigger("sticky_kit:recalc"); //For sticky kit layout refresh
                                }, delay);
                            },
                        },
                        {
                            key: "closePopup",
                            value: function closePopup() {
                                this.toggleForm(false);
                                $(".react-back-in-stock").hide();
                                $("body").removeClass("hide-overflow");
                            }, // TOGGLE - FORM
                        },
                        {
                            key: "toggleForm",
                            value: function toggleForm(formShow) {
                                this.setState({ formShow: formShow, msgValue: "" }); // Refresh sticky nodes after .25s animation completes
                                // this.refreshStickyKit( 255 );
                            }, // UPDATE - POPULATE MESSAGE + SHOW/HIDE
                        },
                        {
                            key: "updateMsg",
                            value: function updateMsg(msgValue) {
                                var msgError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                                var signupComplete = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                                var show = msgValue && msgValue.length > 0;
                                this.setState({ msgError: msgError, msgValue: msgValue, msgShow: show, signupComplete: signupComplete });
                            }, // UPDATE - EMAIL : Email Input updated
                        },
                        {
                            key: "updateEmail",
                            value: function updateEmail(email) {
                                var regexEmail = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i);
                                var isValid = regexEmail.test(email); // CHECK : Is the given email a valid one?
                                if (isValid) {
                                    // NOTE : Can also use "updateMsg" for msg state, but this saves 1 render cycle doing at once
                                    this.setState({ email: email, formEmailValid: true, msgValue: "", msgError: false, msgShow: false });
                                } else {
                                    this.setState({ formEmailValid: false });
                                }
                            },
                        },
                        {
                          key: "updateSubscribe",
                          value: function updateSubscribe(subscribe){
                            
                            this.setState({  mailListingSubscribe: subscribe })
                          }
                        },
                        {
                            key: "updateNumber",
                            value: function updateNumber(phoneNumber) {
                                // E.164 number
                                var regexNumber = new RegExp(/^\+?[1-9]\d{1,14}$/i);
                                var isValid = regexNumber.test(phoneNumber); // CHECK : Is the given number a valid one?
                                if (isValid) {
                                    // NOTE : Can also use "updateMsg" for msg state, but this saves 1 render cycle doing at once
                                    this.setState({ phoneNumber: phoneNumber, formNumberValid: true, msgValue: "", msgError: false, msgShow: false });
                                } else {
                                    this.setState({ formNumberValid: false });
                                }
                            }, // SUBMIT - EMAIL : Submit data to BIS app
                        },
                        {
                            key: "submitEmail",
                            value: function submitEmail() {
                                var _this8 = this;
                                var defaultErrorMsg = "Unable to submit, please check connection and try again.";
                                
                                // Check if BIS script is loaded
                                if (typeof BIS === 'undefined' || !BIS || !BIS.create) {
                                    this.updateMsg("Please wait a moment and try again.", true);
                                    return false;
                                }
                                
                                try {
                                    var _this$state = this.state,
                                        email = _this$state.email,
                                        subscribe = _this$state.mailListingSubscribe,
                                        list = _this$state.subscribeList,
                                        key = _this$state.subscribeKey,
                                        variantId = _this$state.variantId,
                                        productId = _this$state.productId,
                                        formEmailValid = _this$state.formEmailValid;

                                    if (!formEmailValid) {
                                        return false;
                                    } // SUBMIT TO BIS API
                                    
                                    // BIS uses JSONP which can't catch HTTP errors like 422
                                    // Use a timeout to detect failed requests
                                    var bisResponseReceived = false;
                                    var bisTimeout = setTimeout(function() {
                                        if (!bisResponseReceived) {
                                            _this8.updateMsg("We could not submit your request. This email may already be registered, or an error occurred. Please try again.", true);
                                        }
                                    }, 3000); // 3 second timeout
                                    
                                    BIS.create(email, variantId, productId).then(function (res) {
                                        bisResponseReceived = true;
                                        clearTimeout(bisTimeout);
                                        // SUCCESS
                                        if (res.status === "OK") {
                                            _this8.toggleForm(false);
                                            _this8.updateMsg("Success! We will notify you at ".concat(email, " when more are available."), false, true);
                                            
                                            // Subscribe to Klaviyo after BIS success
                                            if (subscribe) {
                                                let klaviyoForm = $("#email_signup");
                                                klaviyoForm.find("#k_id_email").val(email);
                                                klaviyoForm.trigger('submit');
                                            }
                                        } else {
                                            var errorMsg = res.errors && res.errors.email ? res.errors.email : defaultErrorMsg;
                                            if (res.errors && res.errors.base && res.errors.base[0]) {
                                                errorMsg = res.errors.base[0];
                                            }
                                            _this8.updateMsg(errorMsg, true);
                                        }
                                    }, function(err) {
                                        bisResponseReceived = true;
                                        clearTimeout(bisTimeout);
                                        _this8.updateMsg(defaultErrorMsg, true);
                                    });
                                } catch (err) {
                                    this.updateMsg(defaultErrorMsg, true);
                                }
                            }, // SUBMIT - Number : Submit data to BIS app
                        },
                        {
                            key: "submitNumber",
                            value: function submitNumber() {
                                var _this9 = this;
                                var defaultErrorMsg = "Unable to submit, please check connection and try again.";
                                
                                // Check if BIS script is loaded
                                if (typeof BIS === 'undefined' || !BIS || !BIS.create) {
                                    this.updateMsg("Please wait a moment and try again.", true);
                                    return false;
                                }
                                
                                try {
                                    var _this$state2 = this.state,
                                        phoneNumber = _this$state2.phoneNumber,
                                        variantId = _this$state2.variantId,
                                        productId = _this$state2.productId,
                                        formNumberValid = _this$state2.formNumberValid;
                                    if (!formNumberValid) {
                                        return false;
                                    } // SUBMIT TO BIS API
                                    BIS.create(null, variantId, productId, { phone_number: phoneNumber }).then(function (res) {
                                        // SUCCESS
                                        if (res.status === "OK") {
                                            _this9.toggleForm(false);
                                            _this9.updateMsg("Success! We will notify you at ".concat(phoneNumber, " when more are available."), false, true); // FAILURE
                                        } else {
                                            var errorMsg = res.errors && res.errors.phone_number ? res.errors.phone_number : defaultErrorMsg;
                                            if (res.errors && res.errors.base && res.errors.base[0]) {
                                                errorMsg = res.errors.base[0];
                                            }
                                            if (_typeof(errorMsg) === "object") {
                                                errorMsg = errorMsg[0];
                                            }
                                            _this9.updateMsg(errorMsg, true);
                                        }
                                    }, function(err) {
                                        // jQuery Deferred uses fail callback as second arg to .then()
                                        _this9.updateMsg(defaultErrorMsg, true);
                                    });
                                } catch (err) {
                                    this.updateMsg(defaultErrorMsg, true);
                                }
                            }, // show as popup format   (parent class format-popup)
                        },
                        {
                            key: "renderBISPopup",
                            value: function renderBISPopup(email, phoneNumber, mailListingSubscribe, formShow, formEmailValid, formNumberValid, msgError, msgShow, msgValue, signupComplete) {
                                return React.createElement(
                                    "div",
                                    { id: "back-in-stock-form" },
                                    React.createElement("div", { className: "close-popup", onClick: this.closePopup }, "X"),
                                    React.createElement(
                                        "div",
                                        { className: "out-of-stock-notify--wrapper" },
                                        React.createElement(NotifyForm, {
                                            email: email,
                                            phoneNumber: phoneNumber,
                                            formShow: formShow,
                                            subscribed: mailListingSubcribe,
                                            formEmailValid: formEmailValid,
                                            formNumberValid: formNumberValid,
                                            submitEmail: this.submitEmail,
                                            updateEmail: this.updateEmail,
                                            updateSubscribe: this.updateSubscribe,
                                            submitNumber: this.submitNumber,
                                            updateNumber: this.updateNumber,
                                        }),
                                        React.createElement("div", { className: "out-of-stock--msgs", "data-show": msgShow, "data-error": msgError, "data-complete": signupComplete }, msgValue)
                                    )
                                );
                            }, // show as element widget  (parent class format-widget)
                        },
                        {
                            key: "renderBISWidget",
                            value: function renderBISWidget(email, phoneNumber, mailListingSubscribe, formShow, formEmailValid, formNumberValid, msgError, msgShow, msgValue, signupComplete) {
                                return React.createElement(
                                    "div",
                                    { id: "back-in-stock-form" },
                                    React.createElement(
                                        "div",
                                        { className: "out-of-stock-notify--wrapper" },
                                        React.createElement(NotifyForm, {
                                            email: email,
                                            phoneNumber: phoneNumber,
                                            formShow: formShow,
                                            subscribed: mailListingSubscribe,
                                            formEmailValid: formEmailValid,
                                            formNumberValid: formNumberValid,
                                            submitEmail: this.submitEmail,
                                            updateEmail: this.updateEmail,
                                            submitNumber: this.submitNumber,
                                            updateSubscribe: this.updateSubscribe,
                                            updateNumber: this.updateNumber,
                                        }),
                                        React.createElement("div", { className: "out-of-stock--msgs", "data-show": msgShow, "data-error": msgError, "data-complete": signupComplete }, msgValue)
                                    )
                                );
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this$state3 = this.state,
                                    email = _this$state3.email,
                                    phoneNumber = _this$state3.phoneNumber,
                                    mailListingSubscribe = _this$state3.mailListingSubscribe,
                                    formEmailValid = _this$state3.formEmailValid,
                                    formNumberValid = _this$state3.formNumberValid,
                                    formShow = _this$state3.formShow,
                                    msgError = _this$state3.msgError,
                                    msgShow = _this$state3.msgShow,
                                    msgValue = _this$state3.msgValue,
                                    signupComplete = _this$state3.signupComplete;
                             
                                return this.renderBISWidget(email, phoneNumber, mailListingSubscribe, formShow, formEmailValid, formNumberValid, msgError, msgShow, msgValue, signupComplete);
                            },
                        },
                    ]);
                    return BackInStock;
                })(React.Component);
                module.exports = BackInStock;
            },
            { "./NotifyForm.js": 5 },
        ],
        4: [
            function (require, module, exports) {
                /*
                 * BACK-IN-STOCK : REACT (APP = Back In Stock)
                 *  - Displays a link and sign up form to be emailed when a specific variant
                 *    is back in stock.
                 *
                 * REQUIRED DATA:
                 *  - Must also include the snippet 'back-in-stock-notify.liquid' into the
                 *    page somewhere for the react component to mount into
                 *
                 *****************************************************************************/ var BackInStock = require("./BackInStock.js");
                var ReactDOM = require("./../../vendor/react-dom.min.js"); // RENDER : Find all back in stock nodes and render the component into them
                $(document).ready(function () {
                    theme.backInStockform();

                    // $(document).mouseup(function (e) {
                    //
                    //   const container = $(".react-back-in-stock");
                    //   if (!container.is(e.target) && container.has(e.target).length === 0) {
                    //     container.fadeOut();
                    //     $('body').removeClass('hide-overflow');
                    //   }
                    //
                    // });
                });
                theme.backInStockform = function () {
                    var elements = document.getElementsByClassName("react-back-in-stock") || [];
                    _toConsumableArray(elements).forEach(function (el) {
                        // RENDER : Create our back in stock component
                        try {
                            // PRODUCT : Gather product data from global object
                            var product = window.Shopify.productObj || {};
                            if (product && product.variants) {
                                // RENDER : Create the component
                                ReactDOM.render(React.createElement(BackInStock, { product: product }), el); // ABORT : No product variants, component cannot function as intended, skipping mount
                            } else {
                                console.log("::: WARNING : [ BackInStockParent.js ] -- Skipping mount due to missing product / variant data oject");
                            } // SAFETY : Node was not present or something else crazy happened, surprised if you enter this
                        } catch (err) {
                            console.log("Unable to render Back in Stock component into the node:\n    >".concat(err.message || err));
                        }
                    }); // close opened BIS popup on clicking site's other place (for format popup only)
                };
            },
            { "./../../vendor/react-dom.min.js": 50, "./BackInStock.js": 3 },
        ],
        5: [
            function (require, module, exports) {
                var PropTypes = require("prop-types");
                var NotifyForm = /*#__PURE__*/ (function (_React$Component2) {
                    _inherits(NotifyForm, _React$Component2);
                    var _super2 = _createSuper(NotifyForm);
                    function NotifyForm(props) {
                        var _this10;
                        _classCallCheck2(this, NotifyForm);
                        _this10 = _super2.call(this, props);
                        _this10.state = { emailValue: props.email, phoneNumberValue: props.phoneNumber, subscribeValue: props.subscribed };
                        _this10.updateEmail = debounce(_this10.props.updateEmail, 250);
                       _this10.updateSubscribe = debounce(_this10.props.updateSubscribe, 250);
                        _this10.updateNumber = debounce(_this10.props.updateNumber, 250);
                        _this10.handleUpdateEmail = _this10.handleUpdateEmail.bind(_assertThisInitialized(_this10));
                        _this10.handleUpdateSubscribe = _this10.handleUpdateSubscribe.bind(_assertThisInitialized(_this10));
                        _this10.handleUpdateNumber = _this10.handleUpdateNumber.bind(_assertThisInitialized(_this10));
                        _this10.showEmailForm = _this10.showEmailForm.bind(_assertThisInitialized(_this10));
                        _this10.showSMSForm = _this10.showSMSForm.bind(_assertThisInitialized(_this10));
                        return _this10;
                    }
                    _createClass2(NotifyForm, [
                        {
                            key: "handleUpdateEmail",
                            value: function handleUpdateEmail(e) {
                                var email = e.target.value;
                                this.updateEmail(email);
                            },
                        },
                        {
                          key: "handleUpdateSubscribe",
                          value: function handleUpdateSubscribe(e) {
                            let subscribe = e.target.checked;
                            this.updateSubscribe(subscribe);
                          }
                        },
                        {
                            key: "handleUpdateNumber",
                            value: function handleUpdateNumber(e) {
                                var number = e.target.value;
                                this.updateNumber(number);
                            },
                        },
                        {
                            key: "showEmailForm",
                            value: function showEmailForm(e) {
                                if (!$(".type-email").hasClass("active")) {
                                    $(".out-of-stock--form .type-sms").removeClass("active");
                                    $(".out-of-stock--form .number-form").removeClass("active");
                                    $(".out-of-stock--form .type-email").addClass("active");
                                    $(".out-of-stock--form .email-form").addClass("active");
                                }
                            },
                        },
                        {
                            key: "showSMSForm",
                            value: function showSMSForm(e) {
                                if (!$(".type-sms").hasClass("active")) {
                                    $(".out-of-stock--form .type-sms").addClass("active");
                                    $(".out-of-stock--form .number-form").addClass("active");
                                    $(".out-of-stock--form .type-email").removeClass("active");
                                    $(".out-of-stock--form .email-form").removeClass("active");
                                }
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this$props = this.props,
                                    emailValue = _this$props.emailValue,
                                    subscribeValue = _this$props.subscribed,
                                    phoneNumberValue = _this$props.phoneNumberValue,
                                    formShow = _this$props.formShow,
                                    formEmailValid = _this$props.formEmailValid,
                                    formNumberValid = _this$props.formNumberValid,
                                    submitEmail = _this$props.submitEmail,
                                    submitNumber = _this$props.submitNumber;

                             
                                return React.createElement(
                                    "div",
                                    null,
                                    React.createElement("p", null, window.msg_BIS_widget),
                                    React.createElement(
                                        "div",
                                        { className: "out-of-stock--form", "data-show": formShow },
                                        React.createElement(
                                            "div",
                                            { className: "form-type" },
                                            React.createElement("div", { className: "type-email active", onClick: this.showEmailForm }, "Email"),
                                            React.createElement("div", { className: "type-sms", onClick: this.showSMSForm }, "SMS")
                                        ),
                                        React.createElement(
                                            "div",
                                            { className: "email-form active" },
                                            React.createElement("input", { className: "oos-email", type: "email", name: "oos-email", value: emailValue, onChange: this.handleUpdateEmail, placeholder: "Email Address" }),
                                            React.createElement("div", 
                                                                { className: 'oos-mail-subscribe'},
                                            React.createElement("div", 
                                                                { className: "subscribe-checkbox" },
                                                                React.createElement("input", { type: "checkbox", id: "oos-subscribe", onChange: this.handleUpdateSubscribe, checked: subscribeValue }),
                                                                React.createElement("label", 
                                                                                    { for: "oos-subscribe" },
                                                                                    React.createElement('svg', 
                                                                                                        { className: 'checkmark-icon', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512"},
                                                                                                        React.createElement('path', { d: "M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"})
                                                                                                       )
                                                                                   )
                                            ),
                                            React.createElement('span', { className: 'oos-text'}, "Opt in to receive Stetson emails")
                                            ),
                                            React.createElement("div", { className: "oos-submit", "data-enable": formEmailValid, onClick: submitEmail }, "Join Waitlist")
                                        ),
                                        React.createElement(
                                            "div",
                                            { className: "number-form" },
                                            React.createElement("input", { className: "oos-sms", type: "text", name: "oos-sms", value: phoneNumberValue, onChange: this.handleUpdateNumber, placeholder: "Phone Number ex: +15551234567" }),
                                            React.createElement("div", { className: "oos-submit", "data-enable": formNumberValid, onClick: submitNumber }, "Join Waitlist")
                                        )
                                    )
                                );
                            },
                        },
                    ]);
                    return NotifyForm;
                })(React.Component);
                NotifyForm.propTypes = {
                    email: PropTypes.string.isRequired,
                    subscribed: PropTypes.bool.isRequired,
                    phoneNumber: PropTypes.string.isRequired,
                    formShow: PropTypes.bool.isRequired,
                    formEmailValid: PropTypes.bool.isRequired,
                    submitEmail: PropTypes.func.isRequired,
                    updateEmail: PropTypes.func.isRequired,
                    updateSubscribe: PropTypes.func.isRequired,
                    formNumberValid: PropTypes.bool.isRequired,
                    submitNumber: PropTypes.func.isRequired,
                    updateNumber: PropTypes.func.isRequired,
                };
                module.exports = NotifyForm;
            },
            { "prop-types": 70 },
        ],
        6: [
            function (require, module, exports) {
                var BadgeItem = /*#__PURE__*/ (function (_React$Component3) {
                    _inherits(BadgeItem, _React$Component3);
                    var _super3 = _createSuper(BadgeItem);
                    function BadgeItem(props) {
                        var _this11;
                        _classCallCheck2(this, BadgeItem);
                        _this11 = _super3.call(this, props);
                        _this11.populateText = _this11.populateText.bind(_assertThisInitialized(_this11));
                        _this11.findLongWord = _this11.findLongWord.bind(_assertThisInitialized(_this11));
                        return _this11;
                    } // TEXT : Replace Spaces with <BR> so words flow as designed
                    //           -- Why? Padding can't account for "Back in Stock" on 3 lines
                    _createClass2(BadgeItem, [
                        {
                            key: "populateText",
                            value: function populateText(text) {
                                text = text.replace(/ /g, "<BR>");
                                return { __html: text };
                            }, // TEXT : Finds the longest word in the string for our sizing logic
                        },
                        {
                            key: "findLongWord",
                            value: function findLongWord(text) {
                                var wordArr = text.split(" ");
                                var longest = 0;
                                wordArr.forEach(function (word) {
                                    if (longest < word.length) {
                                        longest = word.length;
                                    }
                                });
                                return longest;
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this$props2 = this.props,
                                    bg = _this$props2.bg,
                                    color = _this$props2.color,
                                    shape = _this$props2.shape,
                                    text = _this$props2.text;
                                var style = {}; // CUSTOM COLORS : Product supplied custom color / bg tags, apply style
                                if (bg) {
                                    style.background = bg;
                                }
                                if (color) {
                                    style.color = color;
                                } // TEXT : Size text based on length
                                var spaceLess = text.replace(/ /g, ""); // Don't count spaces for length since they become <BR> in populateText
                                var textLength = spaceLess.length;
                                var longWord = this.findLongWord(text);
                                var textSize = "tiny";
                                switch (true) {
                                    case textLength < 4: // 1-3
                                        textSize = "large";
                                        break;
                                    case textLength < 6 && longWord < 6: // 4-6
                                        textSize = "medium";
                                        break;
                                    case textLength < 11 && longWord < 7: // (A.) 7-10 Chars -- (B.) Longest less than 7 chars
                                        textSize = "small";
                                        break;
                                    case textLength > 10 || longWord >= 7: // (A.) 11+ chars -- (B.) Longest word 7+ chars
                                        textSize = "tiny";
                                        break;
                                    default:
                                        textSize = "tiny";
                                        break;
                                }
                                return React.createElement("div", { className: "item-badge " + shape, style: style }, React.createElement("div", { class: "item-badge-text " + textSize, dangerouslySetInnerHTML: this.populateText(text) }));
                            },
                        },
                    ]);
                    return BadgeItem;
                })(React.Component);
                module.exports = BadgeItem;
            },
            {},
        ],
        7: [
            function (require, module, exports) {
                /*
                 * BADGES : REACT
                 *  - Displays a badge on the item's image (or whever you like really..)
                 *
                 * REQUIRED DATA:
                 *  - Root EL(s) need 'data-badge' as stringified JSON array of swatch objects
                 *  - Badge HTML Snippet for Usage:
                 *      <div class="react-badge" data-badge='{{BADGE DATA ARRAY}}'></div>
                 *
                 *  - Badge Data Sample:
                 *      [
                 *          "item_badge_shape_diamond",
                 *          "item_badge_color_#0ff0ff",
                 *          "item_badge_text_BACK IN STOCK",
                 *          "item_badge_bg_#000000"
                 *      ]
                 *********************************************/ var BadgeItem = require("./BadgeItem.js");
                var badgeData = []; // Top level so findTag() can use it also
                // HELPER : Tag Finder
                var findTag = function findTag(searchString) {
                    var foundTag = badgeData.find(function (tag) {
                        return tag.indexOf(searchString) >= 0;
                    });
                    return foundTag;
                }; // HELPER : Builds Proper data object to pass to component
                var prepData = function prepData() {
                    var badgeTextTag = findTag("item_badge_text_"); // Required
                    var badgeShapeTag = findTag("item_badge_shape_"); // Optional, default is square
                    var badgeColorTag = findTag("item_badge_color_"); // Optional
                    var badgeBgTag = findTag("item_badge_bg_"); // Optional
                    // ADD BADGE : text tag content required
                    if (badgeTextTag) {
                        // MAP : Parse + Build needed info
                        return {
                            text: badgeTextTag.split("item_badge_text_")[1],
                            shape: badgeShapeTag ? badgeShapeTag.split("item_badge_shape_")[1] : null,
                            color: badgeColorTag ? badgeColorTag.split("item_badge_color_")[1] : null,
                            bg: badgeBgTag ? badgeBgTag.split("item_badge_bg_")[1] : null,
                        }; // ERROR : Required badge data missing
                    } else {
                        return { error: true, msg: 'The badge text is empty, please supply a tag in the format of "item_badge_text_MY TEXT".' };
                    }
                }; // BUILD : Parses Badge Data + Builds Component
                var buildBadges = function buildBadges() {
                    var elements = document.getElementsByClassName("react-badge") || [];
                    _toConsumableArray(elements).forEach(function (el) {
                        //htmlCollection isn't a true array, use spread operator to convert
                        // SAFETY : Ensure data exists
                        if (el.dataset && el.dataset.badge) {
                            // PARSE : Read + Pass data to component if valid JSON
                            try {
                                badgeData = JSON.parse(el.dataset.badge); // PREP : Build data for component render
                                if (badgeData.length > 0) {
                                    var preparedData = prepData(); // BUILD : No errors, Render badge component
                                    if (!preparedData.error) {
                                        var bg = preparedData.bg,
                                            color = preparedData.color,
                                            text = preparedData.text,
                                            shape = preparedData.shape;
                                        ReactDOM.render(React.createElement(BadgeItem, { bg: bg, color: color, shape: shape, text: text }), el);
                                    } else {
                                        console.log(preparedData.msg);
                                    }
                                } // SAFETY : Malformatted JSON = most common error
                            } catch (err) {
                                console.log("Badge Data malformed (JSON.parse failed), please check 'data-badge' prop on element.\n  >".concat(err.message || err));
                            }
                        }
                    });
                };
                module.exports = buildBadges;
            },
            { "./BadgeItem.js": 6 },
        ],
        8: [
            function (require, module, exports) {
                /* REACT COMPONENT : DISCOUNT MANAGERtotal_price ?
                 *
                 * ..:: SAMPLES - DISCOUNT CONFIG ::..
                 *
                 *
                 *  #1 - Spend X, Get Y item free (or whatever you set its price to)
                 *
                 *        thresholdDiscounts: [{
                 *            discountId: 1,                    // DISCOUNT ID -- Unique identifier for this discount, so we can tell if its already applied
                 *            giftId: 17667671031906,         // VARIANT ID --- Item being given for free, see docs for formatting rules
                 *            grantType: 'all',                // GRANT TYPE --- Does user get this gift if higher threshold is met? -- (OPTIONS: 'all' or 'pick')
                 *            inventoryId: 17275313422434,    // INVENTORY ID - Variant ID of full-price original version (gift is untracked usually, uses full-cost variant to see how many left)
                 *            message: "For spending over $200, here is your free gift!",
                 *            minSpend: 200,                    // THRESHOLD ---- Dollar (or current currency) amount to trigger free gift
                 *            productHandle: 'mens-northwest-territory-socks'
                 *        }]
                 *
                 *****************************************************************************/ var PropTypes = require("prop-types");
                var Promise = require("bluebird");
                var Entities = require("html-entities").AllHtmlEntities;
                var entities = new Entities();
                var DiscountModal = require("./DiscountModal.js");
                var DiscountManager = /*#__PURE__*/ (function (_React$Component4) {
                    _inherits(DiscountManager, _React$Component4);
                    var _super4 = _createSuper(DiscountManager);
                    function DiscountManager(props) {
                        var _this12;
                        _classCallCheck2(this, DiscountManager);
                        _this12 = _super4.call(this, props); // CONFIG : Discount Configuration Manifest
                        _this12.config = props.config;
                        _this12.config.thresholdDiscounts = _this12.config.thresholdDiscounts || []; // Safety net
                        _this12.config.currencySymbol = _this12.config.currencySymbol
                            ? entities.decode(_this12.config.currencySymbol)
                            : "$"; /* EXAMPLE CONFIG : 3 Gift items set to "Pick" after spending $200+ in cart total (Sample is on muckboot-dev)
            {
                cookieExpireInDays: 60,                        // COOKIE : # of days before cookie expires
                thresholdDiscounts: [
                    // SAMPLE : Pick Style, spend over 200 and pick among these..        
                    {
                        discountId: 1,                        // DISCOUNT ID -- Unique identifier for this discount, so we can tell if its already applied
                        displayName: 'Wigwam Hat (Black)',    // DISPLAY NAME - Name displayed under item in the ModalItem component (Falls back to "title" provided during the item inventory check)
                        giftId: 18107441610850,             // VARIANT ID --- Item being given for free, see docs for formatting rules
                        grantType: 'pick',                    // GRANT TYPE --- Does user get this gift if higher threshold is met? -- (OPTIONS: 'all' or 'pick')
                        inventoryId: 18107441610850,        // INVENTORY ID - Variant ID of full-price original version (gift is untracked usually, uses full-cost variant to see how many left)
                        minSpend: 200,                        // THRESHOLD ---- Dollar (or current currency) amount to trigger free gift
                        productHandle: 'wigwam-winter-hat'  // HANDLE NAME -- Handle name of product (found in seo-block on product page in admin)
                    },
                    {
                        discountId: 2,                        // DISCOUNT ID -- Unique identifier for this discount, so we can tell if its already applied
                        displayName: 'Wigwam Hat (Gray)',    // DISPLAY NAME - Name displayed under item in the ModalItem component
                        giftId: 18107441643618,             // VARIANT ID --- Item being given for free, see docs for formatting rules
                        grantType: 'pick',                    // GRANT TYPE --- Does user get this gift if higher threshold is met? -- (OPTIONS: 'all' or 'pick')
                        inventoryId: 18107441643618,        // INVENTORY ID - Variant ID of full-price original version (gift is untracked usually, uses full-cost variant to see how many left)
                        minSpend: 200,                        // THRESHOLD ---- Dollar (or current currency) amount to trigger free gift
                        productHandle: 'wigwam-winter-hat'    // HANDLE NAME -- Handle name of product (found in seo-block on product page in admin)
                    },
                    {
                        discountId: 3,                        // DISCOUNT ID -- Unique identifier for this discount, so we can tell if its already applied
                        displayName: 'Wigwam Hat (Natural)',// DISPLAY NAME - Name displayed under item in the ModalItem component
                        giftId: 18107441676386,             // VARIANT ID --- Item being given for free, see docs for formatting rules
                        grantType: 'pick',                    // GRANT TYPE --- Does user get this gift if higher threshold is met? -- (OPTIONS: 'all' or 'pick')
                        inventoryId: 18107441676386,        // INVENTORY ID - Variant ID of full-price original version (gift is untracked usually, uses full-cost variant to see how many left)
                        minSpend: 200,                        // THRESHOLD ---- Dollar (or current currency) amount to trigger free gift
                        productHandle: 'wigwam-winter-hat'    // HANDLE NAME -- Handle name of product (found in seo-block on product page in admin)
                    }
                ]
            }
        */ // ENABLED : Did the user disable showing the modal?
                        var doNotShowAgain = $.cookie("BOL_hide_discounts_modal"); // LAST SESSION : Do we have any discount data saved from a previous session?
                        var savedUsedDiscounts = $.cookie("BOL_used_discounts");
                        var savedRejectedDiscounts = $.cookie("BOL_rejected_discounts");
                        try {
                            if (savedUsedDiscounts) {
                                savedUsedDiscounts = JSON.parse(savedUsedDiscounts);
                            }
                            if (savedRejectedDiscounts) {
                                savedRejectedDiscounts = JSON.parse(savedRejectedDiscounts);
                            }
                        } catch (err) {
                            console.log("DiscountManager : Choked while eating the cookies, they may have gone bad...\n".concat(err));
                        } // STATE : Current state in manager
                        _this12.state = { cartTotal: 0, discountsToApply: [], doNotShowAgain: doNotShowAgain || false, rejectedDiscounts: savedRejectedDiscounts || [], removedDiscounts: [], usedDiscounts: savedUsedDiscounts || [] };
                        _this12.inFlightIds = []; // EVENTS : Bind functions to current context
                        _this12.calcCartTotal = _this12.calcCartTotal.bind(_assertThisInitialized(_this12));
                        _this12.calcThresholdDiscounts = _this12.calcThresholdDiscounts.bind(_assertThisInitialized(_this12));
                        _this12.confirmRemoval = _this12.confirmRemoval.bind(_assertThisInitialized(_this12));
                        _this12.enableDoNotShowAgain = _this12.enableDoNotShowAgain.bind(_assertThisInitialized(_this12));
                        _this12.markDiscountUsed = _this12.markDiscountUsed.bind(_assertThisInitialized(_this12));
                        _this12.onCartUpdate = _this12.onCartUpdate.bind(_assertThisInitialized(_this12));
                        _this12.rejectDiscount = _this12.rejectDiscount.bind(_assertThisInitialized(_this12));
                        _this12.rejectOnGiftRemoval = _this12.rejectOnGiftRemoval.bind(_assertThisInitialized(_this12));
                        _this12.removeCartItem = _this12.removeCartItem.bind(_assertThisInitialized(_this12));
                        _this12.updateInFlightIds = _this12.updateInFlightIds.bind(_assertThisInitialized(_this12));
                        return _this12;
                    }
                    _createClass2(DiscountManager, [
                        {
                            key: "componentDidMount",
                            value: function componentDidMount() {
                                $(document).on("cartUpdated", this.onCartUpdate); // Listen for cart updates
                                $(document).on("giftItemRemoved", this.rejectOnGiftRemoval); // Listen for user manually removing gift, mark as rejected
                                // INIT : If on /cart, must gather cart data to adjust any deals potentially
                                var onCartPage = window.location.pathname.indexOf("/cart") !== -1;
                                if (onCartPage) {
                                    ShopifyAPI.getCart(ajaxCart.cartUpdateCallback);
                                }
                            },
                        },
                        {
                            key: "componentDidUnmount",
                            value: function componentDidUnmount() {
                                $(document).off("cartUpdated", this.onCartUpdate);
                            },
                        },
                        {
                            key: "calcCartTotal",
                            value: function calcCartTotal() {
                                var total_price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0; // CONVERT : Change cart value to a whole dollar (or other currency) amount
                                var dollar,
                                    cents,
                                    cartTotal,
                                    total = JSON.stringify(total_price);
                                if (total.length < 3) {
                                    dollar = 0;
                                    cents = total;
                                } else {
                                    dollar = total.substring(0, total.length - 2);
                                    cents = total.substring(total.length - 2, total.length);
                                }
                                cartTotal = JSON.parse(dollar + "." + cents); // console.log( `::: DEBUG : Parsed cart total: $${cartTotal}` );
                                return cartTotal;
                            },
                        },
                        {
                            key: "calcThresholdDiscounts",
                            value: function calcThresholdDiscounts(cartTotal, cartItems) {
                                var thresholdDiscounts = this.config.thresholdDiscounts;
                                var _this$state4 = this.state,
                                    rejectedDiscounts = _this$state4.rejectedDiscounts,
                                    usedDiscounts = _this$state4.usedDiscounts;
                                var metDiscounts = []; // CHECK : Did we meet any discount thresholds? (Safety, as this evolves..)
                                if (thresholdDiscounts.length > 0) {
                                    // SCAN CART : Check cart items to ensure no other discounts are met, if they are lets remove their other pick choices (ones set to grantType: 'pick' that are also met)
                                    cartItems.forEach(function (item) {
                                        var discountInCart = thresholdDiscounts.find(function (rule) {
                                            return rule.giftId === item.variant_id;
                                        }); // MATCH : Remove any other discounts that would be prevented by having added this one
                                        if (discountInCart) {
                                            // FILTER : Remove any other discounts that are pick type and under our spend threshold
                                            thresholdDiscounts = thresholdDiscounts.filter(function (discount) {
                                                var spendConflict = discount.minSpend <= discountInCart.minSpend;
                                                var isPickType = discount.grantType === "pick";
                                                if (!spendConflict && !isPickType) {
                                                    return discount;
                                                }
                                            });
                                        }
                                    }); // BUILD : ARRAY : Discounts NOT used yet + Past "minSpend" Threshold + No other "Pick" discounts at same minSpend are met
                                    metDiscounts = thresholdDiscounts.filter(function (rule) {
                                        var hasBeenUsed = usedDiscounts.find(function (discountObj) {
                                            return discountObj.discountId === rule.discountId;
                                        });
                                        var hasBeenRejected = rejectedDiscounts.find(function (rejectId) {
                                            return rejectId === rule.discountId;
                                        });
                                        var hasBeenMet = rule.minSpend <= cartTotal; // TIME RANGE : Ensure discount is currently in its active time window
                                        if (rule.time_start && rule.time_end) {
                                            var now = new Date();
                                            var start = new Date(rule.time_start);
                                            var end = new Date(rule.time_end);
                                            var meetsTimeWindow = now >= start && now < end;
                                            return !hasBeenUsed && !hasBeenRejected && hasBeenMet && meetsTimeWindow;
                                        } else {
                                            console.log("ERROR : [ GWP - DiscountManager.js ] : Time range on discount '".concat(rule.displayName, "' is invalid:\n   Start: ").concat(rule.time_start, "\n   End: ").concat(rule.time_end));
                                            return false; // Skip this discount
                                        }
                                    });
                                }
                                return metDiscounts; //Extra protection is all here..
                            },
                        },
                        {
                            key: "confirmRemoval",
                            value: function confirmRemoval() {
                                // CONFIRMED : Clear out the "removedDiscounts" array since we've informed the user now
                                this.setState(function (state) {
                                    return { removedDiscounts: [] };
                                });
                            },
                        },
                        {
                            key: "enableDoNotShowAgain",
                            value: function enableDoNotShowAgain() {
                                $.cookie("BOL_hide_discounts_modal", "true", { expires: 90, path: "/" }); //Expire in days
                                this.setState({ doNotShowAgain: true });
                            },
                        },
                        {
                            key: "fetchProduct",
                            value: function fetchProduct(productHandle) {
                                return fetch("/products/".concat(productHandle, "?view=availability"))
                                    .then(function (res) {
                                        if (res.status >= 400) {
                                            throw new Error("Bad res from server");
                                        }
                                        return res.json();
                                    })
                                    .then(function (productJson) {
                                        return productJson;
                                    })
                                    ["catch"](function (err) {
                                        var theError = err && err.message ? err.message : err || "Request failed for an unknown reason with no error object returned..";
                                        console.log("[ DiscountManager -- fetchProduct() ] : Failed request :\n".concat(theError));
                                        throw new Error(theError);
                                    });
                            },
                        },
                        {
                            key: "markDiscountUsed",
                            value: function markDiscountUsed(discountId) {
                                var _this13 = this;
                                var usedDiscounts = this.state.usedDiscounts; // CHECK : If not present, add to the list
                                var isAlreadyMarked = usedDiscounts.find(function (used) {
                                    return used.discountId === discountId;
                                });
                                if (!isAlreadyMarked) {
                                    // UPDATE : Create new array to for state-based render update
                                    this.setState(function (state) {
                                        // USED : Update the used list with our fully-built discount obj (includes image_url)
                                        var appliedDiscount = state.discountsToApply.find(function (discount) {
                                            return discount.discountId === discountId;
                                        });
                                        var updatedUsedList = appliedDiscount ? state.usedDiscounts.concat([appliedDiscount]) : state.usedDiscounts; // TO APPLY : Remove the now applied discount from the manifest of those to apply still
                                        var updatedApplyList = state.discountsToApply.filter(function (discount) {
                                            return discount.discountId !== discountId;
                                        });
                                        var discountsToApply = [].concat(updatedApplyList); // SAVE : Save our data before updating the app, in case user leaves site
                                        $.cookie("BOL_used_discounts", JSON.stringify(updatedUsedList), { expires: _this13.config.cookieExpireInDays, path: "/" });
                                        return { discountsToApply: discountsToApply, usedDiscounts: updatedUsedList };
                                    });
                                }
                            },
                        },
                        {
                            key: "markDiscountUnused",
                            value: function markDiscountUnused(discountId) {
                                var _this14 = this;
                                var usedDiscounts = this.state.usedDiscounts;
                                var isOnList = usedDiscounts.find(function (used) {
                                    return used.discountId === discountId;
                                });
                                if (isOnList) {
                                    // UPDATE : Create new array to for state-based render update
                                    this.setState(function (state) {
                                        // FILTER : Find matching ID and remove from the list of used IDs
                                        var filteredUsed = usedDiscounts.filter(function (usedObj) {
                                            return usedObj.discountId !== discountId;
                                        });
                                        var updatedUsedList = [].concat(filteredUsed); // UPDATE STATE + COOKIE : Save our data before updating the app, in case user leaves site
                                        $.cookie("BOL_used_discounts", JSON.stringify(updatedUsedList), { expires: _this14.config.cookieExpireInDays, path: "/" });
                                        return { usedDiscounts: updatedUsedList };
                                    });
                                }
                            },
                        },
                        {
                            key: "onCartUpdate",
                            value: function onCartUpdate(e) {
                                var _this15 = this;
                                var thresholdDiscounts = this.config.thresholdDiscounts; // ARRAY : Configured threshold discount objects (if any setup)
                                var _this$state5 = this.state,
                                    cartTotal = _this$state5.cartTotal,
                                    removedDiscounts = _this$state5.removedDiscounts,
                                    usedDiscounts = _this$state5.usedDiscounts; // We mod / repush the usedDiscounts arr, hence var
                                var discountsToApply = []; // Array of Discount Objects
                                var discountsToRemove = []; // Array of Discount objects
                                // CART : ITEMS : Store current cart manifest so we can check it for removal needs
                                var cartItems = e.cart.items || []; // CART : CONVERT TOTAL : Calc $$$ in cart (comes as "12345" which === "$123.45" )
                                //         (Assumes base10 -- last two digits seen as "cents" -- WILL NOT WORK on Yen-type currency)
                                var newCartTotal = this.calcCartTotal(e.cart.total_price);
                                try {
                                    // SAFETY FIRST!
                                    // ADD CHECK : THRESHOLD : Did we meet any new discounts with this cart change?
                                    if (thresholdDiscounts && thresholdDiscounts.length > 0) {
                                        discountsToApply = this.calcThresholdDiscounts(newCartTotal, cartItems);
                                    } // ADD CHECK : IN STOCK : Are the 'discountsToApply' in stock?
                                    if (discountsToApply.length !== this.state.discountsToApply.length || discountsToApply.length > 0) {
                                        var inStockDiscounts = []; // ITERATE : Map each discount to check if its gift is available
                                        Promise.all(
                                            discountsToApply.map(function (discount) {
                                                return _this15.fetchProduct(discount.productHandle).then(function (res) {
                                                    // IN STOCK : Are any variants in the giftData available?
                                                    if (res && res.availableVariants) {
                                                        var inStockObj = res.availableVariants.find(function (variant) {
                                                            return variant.variantId === discount.inventoryId;
                                                        }); // DISCOUNT IN STOCK?
                                                        if (inStockObj) {
                                                            inStockDiscounts.push(Object.assign({}, discount, inStockObj));
                                                        }
                                                    }
                                                });
                                            })
                                        ).then(function () {
                                            // UPDATE : Set the discounts we have into state so they can be offered
                                            _this15.setState({ discountsToApply: inStockDiscounts });
                                        });
                                    } // REMOVE CHECK : CART SCAN : Check cart items, if any match a discount in config, check if it still qualifies
                                    cartItems.forEach(function (item, index) {
                                        var matchedDiscount = thresholdDiscounts.find(function (rule) {
                                            return rule.giftId === item.variant_id;
                                        }); // CHECK : Do we still meet this deals requirements?
                                        if (matchedDiscount && matchedDiscount.minSpend > newCartTotal) {
                                            // CHECK : Have we already flagged this item to be removed?
                                            var isAlreadyMarked = discountsToRemove.find(function (rule) {
                                                return rule.discountId === matchedDiscount.discountId;
                                            }); //Undef if not found
                                            var isInFlight = _this15.inFlightIds.find(function (id) {
                                                return id === matchedDiscount.discountId;
                                            }); // SAFETY : Ensure item was in cart still
                                            if (!isAlreadyMarked && !isInFlight) {
                                                matchedDiscount.line_item = index + 1; // +1 as line_item starts @ 1 not 0 for API calls
                                                discountsToRemove.push(matchedDiscount);
                                            }
                                        }
                                    }); // REMOVE CHECK : PROCESS REMOVALS : Pull any items that are unmet and alert user to their removal
                                    if (discountsToRemove.length > 0) {
                                        // REMOVE : For each item, call shopify API and await confirmation, then inform user of removal
                                        Promise.all(
                                            discountsToRemove.map(function (discount) {
                                                // If we found it in the cart...
                                                if (discount.line_item) {
                                                    return _this15
                                                        .removeCartItem(discount.line_item, discount)
                                                        .then(function (res) {
                                                            // SUCCESS : Remove discount from "usedDiscounts" list state
                                                            var removalIndex = usedDiscounts.findIndex(function (used) {
                                                                return used.discountId === discount.discountId;
                                                            });
                                                            var removed = usedDiscounts.splice(removalIndex, 1); // Remove 1 key from 'usedDiscounts' @ removalIndex
                                                            // FLAG : Mark removed discounts to show user we pulled them from the cart
                                                            if (removed[0] && removed[0].imageUrl) {
                                                                removedDiscounts.push(removed[0]);
                                                            } // CART PAGE : Extra clean up for if we're on the actual /cart page itself
                                                            if (window.location.pathname.indexOf("/cart") !== -1) {
                                                                $("#cart-line-item-" + discount.line_item).remove(); // Remove line item we purged
                                                            }
                                                        })
                                                        ["catch"](function (err) {
                                                            var theError = err ? err : "Server failed to supply an error object from Shopify side.";
                                                            console.log("Error Removing Deal Item: ".concat(JSON.stringify(theError)));
                                                        });
                                                }
                                            })
                                        ).then(function (res) {
                                            // NOTE : Each individual removal resolution call then pulls that ID from the usedDiscounts array above in the promise.all
                                            // REMOVE CHECK : UPDATE : Save our data in cookie and state
                                            $.cookie("BOL_used_discounts", JSON.stringify(usedDiscounts), { expires: _this15.config.cookieExpireInDays, path: "/" });
                                            _this15.setState({ removedDiscounts: removedDiscounts, usedDiscounts: usedDiscounts });
                                        });
                                    } // USED SYNC : If user manually removed item, and now we are under the threshold, re-enable that discount and remove from used list.
                                    //               If its in the discountsToRemove array we will take care of it after showing the user we did, so skip any on that list.
                                    usedDiscounts.forEach(function (item, index) {
                                        var removalInFlight = discountsToRemove.find(function (discountObj) {
                                            return discountObj.discountId === item.discountId;
                                        }); // If not slated to remove, check if cart total is back below threshold, as it means the user manually removed the item.
                                        // This way if they remove the item and go back below the threshold, we can re-offer them the item when they add stuff back in cart
                                        if (!removalInFlight) {
                                            if (newCartTotal < item.minSpend) {
                                                _this15.markDiscountUnused(item.discountId);
                                            }
                                        }
                                    });
                                } catch (err) {
                                    var theError = err ? err : "Error object was not captured, entered the catch for [onCartUpdate] in DiscountManager";
                                    console.log("::: ERROR [ DiscountManager -- onCartUpdate() ] : Something went wrong!\n  MSG: ".concat(JSON.stringify(theError)));
                                } // TOTAL : Always update cart total
                                this.setState({ cartTotal: newCartTotal });
                            },
                        },
                        {
                            key: "rejectDiscount",
                            value: function rejectDiscount(discountIds) {
                                var _this16 = this;
                                var _this$state6 = this.state,
                                    discountsToApply = _this$state6.discountsToApply,
                                    rejectedDiscounts = _this$state6.rejectedDiscounts; // ALREADY TRACKED : Mark if already tracked
                                discountIds = discountIds.filter(function (discountId) {
                                    var isMarked = rejectedDiscounts.find(function (rejectId) {
                                        return rejectId === discountId;
                                    });
                                    if (!isMarked) {
                                        return discountId;
                                    }
                                });
                                this.setState(function (state) {
                                    var updatedRejectList = rejectedDiscounts.concat(discountIds); // ADD : Rejected ID to the list
                                    var updatedApplyList = discountsToApply.filter(function (discount) {
                                        // REMOVE : Discount from queue of ones to apply
                                        var matchedDiscount = discountIds.find(function (discountId) {
                                            return discountId === discount.discountId;
                                        });
                                        if (!matchedDiscount) {
                                            return discount;
                                        }
                                    }); // SAVE : Save our data before updating the app, in case user leaves site
                                    $.cookie("BOL_rejected_discounts", JSON.stringify(updatedRejectList), { expires: _this16.config.cookieExpireInDays, path: "/" });
                                    return { discountsToApply: updatedApplyList, rejectedDiscounts: updatedRejectList };
                                });
                            },
                        },
                        {
                            key: "rejectOnGiftRemoval",
                            value: function rejectOnGiftRemoval(event) {
                                if (event && event.discountId) {
                                    var discountId = event.discountId; // CONVERT : make into number if string
                                    if (typeof discountId === "string") {
                                        try {
                                            discountId = JSON.parse(discountId);
                                        } catch (err) {
                                            console.log("ERROR : [ DiscountManager.js - rejectOnGiftRemoval ] : Unable to parse removed Discount ID of '".concat(event.discountId));
                                        }
                                    } // REJECT : Add to reject list
                                    this.rejectDiscount([discountId]);
                                } else {
                                    console.log("ERROR : [ DiscountManager.js - rejectOnGiftRemoval ] : Discount ID was missing from data attributes from ajax-cart.js.liquid @ 'giftItemRemoved' event trigger.");
                                }
                            },
                        },
                        {
                            key: "removeCartItem",
                            value: function removeCartItem(line_item, discount) {
                                // PRE-FLIGHT : Remove current entry from discountsToRemove so subsequent cart changes don't re-fire this guy during flight
                                var _this = this; // RETURN : Promisifed request handler
                                return new Promise(function (resolve, reject) {
                                    // SUCCESS : Callback for success handling
                                    var onSuccess = function onSuccess(cart) {
                                        _this.updateInFlightIds(discount.discountId, "remove");
                                        resolve(discount);
                                    }; // FAILED : Callback for failure handling
                                    var onFailure = function onFailure(XMLHttpRequest, textStatus) {
                                        _this.updateInFlightIds(discount.discountId, "remove");
                                        reject(XMLHttpRequest, textStatus);
                                    }; // REMOVE : Use API from ajax-cart.js.liquid to set item quantity to 0 for a removal
                                    if (_this.inFlightIds.indexOf(discount.discountId) === -1) {
                                        // IN FLIGHT : Add Discount ID to in-flight manifest
                                        _this.updateInFlightIds(discount.discountId, "add"); // FIRE : Enact the removal!
                                        ShopifyAPI.changeItem(
                                            line_item, // LINE ITEM : Which cart item is being removed
                                            0, // AMOUNT : Set quantity to 0 to remove an item
                                            onSuccess, // SUCCESS : Callback Handler for Successful Updates
                                            onFailure // FAILED : Callback handler for failed updates
                                        );
                                    } else {
                                        reject("[ DiscountManager -- removeCartItem() ] : Request to remove Line Item #" + line_item + " for Discount ID:" + discount.discountId + " is already in flight...");
                                    }
                                });
                            },
                        },
                        {
                            key: "updateInFlightIds",
                            value: function updateInFlightIds(id, addOrRemove) {
                                // Have to call this from inside shopifyAPI removal call, so needed a helper function
                                // instead of binding the list to a new var and modding that inside the remove call
                                if (addOrRemove === "add") {
                                    this.inFlightIds.push(id);
                                } else {
                                    this.inFlightIds = this.inFlightIds.filter(function (inFlightId) {
                                        return inFlightId !== id;
                                    });
                                }
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this$state7 = this.state,
                                    cartTotal = _this$state7.cartTotal,
                                    discountsToApply = _this$state7.discountsToApply,
                                    doNotShowAgain = _this$state7.doNotShowAgain,
                                    removedDiscounts = _this$state7.removedDiscounts;
                                return React.createElement(
                                    "div",
                                    { id: "react-discount-manager", "data-component": "DiscountManager" },
                                    React.createElement(DiscountModal, {
                                        cartTotal: cartTotal,
                                        confirmRemoval: this.confirmRemoval,
                                        currencySymbol: this.config.currencySymbol,
                                        discountsToApply: discountsToApply,
                                        doNotShowAgain: doNotShowAgain,
                                        enableDoNotShowAgain: this.enableDoNotShowAgain,
                                        markDiscountUsed: this.markDiscountUsed,
                                        rejectDiscount: this.rejectDiscount,
                                        removedDiscounts: removedDiscounts,
                                    })
                                );
                            },
                        },
                    ]);
                    return DiscountManager;
                })(React.Component);
                module.exports = DiscountManager;
            },
            { "./DiscountModal.js": 9, bluebird: 52, "html-entities": 61, "prop-types": 70 },
        ],
        9: [
            function (require, module, exports) {
                var PropTypes = require("prop-types");
                var fetch = require("isomorphic-fetch");
                var ModalList = require("./ModalList.js");
                var ModalRemoved = require("./ModalRemoved.js");
                var DiscountModal = /*#__PURE__*/ (function (_React$Component5) {
                    _inherits(DiscountModal, _React$Component5);
                    var _super5 = _createSuper(DiscountModal);
                    function DiscountModal(props) {
                        var _this17;
                        _classCallCheck2(this, DiscountModal);
                        _this17 = _super5.call(this, props);
                        _this17.state = { disableButtons: false, showModal: false };
                        _this17.addItemToCart = _this17.addItemToCart.bind(_assertThisInitialized(_this17));
                        _this17.getDiscountById = _this17.getDiscountById.bind(_assertThisInitialized(_this17));
                        _this17.handleSelection = _this17.handleSelection.bind(_assertThisInitialized(_this17));
                        _this17.updateModal = _this17.updateModal.bind(_assertThisInitialized(_this17));
                        _this17.onAddItemError = _this17.onAddItemError.bind(_assertThisInitialized(_this17));
                        _this17.toggleButtonEnable = _this17.toggleButtonEnable.bind(_assertThisInitialized(_this17));
                        return _this17;
                    }
                    _createClass2(DiscountModal, [
                        {
                            key: "componentDidMount",
                            value: function componentDidMount() {
                                this.updateModal();
                            },
                        },
                        {
                            key: "componentDidUpdate",
                            value: function componentDidUpdate() {
                                this.updateModal();
                            },
                        },
                        {
                            key: "addItemToCart",
                            value: function addItemToCart(discount) {
                                var _this18 = this; // SUCCESS : Callback for success handling
                                var markUsedOnSuccess = function markUsedOnSuccess() {
                                    _this18.props.markDiscountUsed(discount.discountId);
                                    _this18.toggleButtonEnable(true); // re-enable the UI buttons in case there are more items for user to add
                                    // The /Cart route page itself is a shitshow and doesn't play nice with the ajax cart, so lets just refresh it to reflect the added item
                                    if (window.location.pathname.indexOf("/cart") > -1) {
                                        window.location.reload();
                                    }
                                }; // ADD : Use API from ajax-cart.js.liquid to add item to cart!
                                ShopifyAPI.addItemById(
                                    discount.giftId, // Gift ID (must be a Variant ID)
                                    markUsedOnSuccess, // Success Callback
                                    this.onAddItemError, // Error Callback
                                    true // isGift Flag (adds note property to item so we can hide things like cart quantity modifiers)
                                );
                            },
                        },
                        {
                            key: "getDiscountById",
                            value: function getDiscountById(discountId) {
                                var discountsToApply = this.props.discountsToApply;
                                return discountsToApply.find(function (rule) {
                                    return rule.discountId === discountId;
                                });
                            },
                        },
                        {
                            key: "handleSelection",
                            value: function handleSelection(discountIds) {
                                var _this19 = this;
                                var addToCart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false; // ADD : If user clicked "Add to Cart"
                                if (addToCart) {
                                    discountIds.forEach(function (discountId) {
                                        var discount = _this19.getDiscountById(discountId);
                                        _this19.addItemToCart(discount); //Cart marks as used once added successfully
                                    }); // NO THANKS : Mark discount as used
                                } else {
                                    this.props.rejectDiscount(discountIds);
                                }
                            },
                        },
                        {
                            key: "updateModal",
                            value: function updateModal() {
                                var _this20 = this;
                                var _this$props3 = this.props,
                                    discountsToApply = _this$props3.discountsToApply,
                                    doNotShowAgain = _this$props3.doNotShowAgain,
                                    removedDiscounts = _this$props3.removedDiscounts;
                                var showModal = false; // CHECK #1 : Discounts to Apply : Check for auto-add status and handle accordingly
                                if (!doNotShowAgain && discountsToApply.length > 0) {
                                    discountsToApply.forEach(function (discountObj) {
                                        // AUTO-ADD : Only add automatically if proper setting + grantType are set
                                        if (discountObj.autoAddToCart && discountObj.grantType === "all") {
                                            _this20.handleSelection([discountObj.discountId], true); // SHOW DISCOUNT : If not, show the discount modal so user can pick their item to add to cart
                                        } else {
                                            showModal = true;
                                        }
                                    });
                                } // CHECK #2 : Discounts to Remove : If already set to show, skip check, otherwise check this array as well
                                if (!doNotShowAgain && !showModal && removedDiscounts.length > 0) {
                                    showModal = true;
                                } // STATE : SHOW MODAL : If already shown no need to update state again, just update on show changes
                                if (this.state.showModal !== showModal) {
                                    this.setState({ showModal: showModal });
                                }
                            },
                        },
                        {
                            key: "onAddItemError",
                            value: function onAddItemError(err) {
                                console.log("Looks like adding to cart failed, error message:\n".concat(JSON.stringify(err))); // TODO : Handle errors better here! -- Probably want to set up a message into the template that shows error message
                            },
                        },
                        {
                            key: "toggleButtonEnable",
                            value: function toggleButtonEnable(passedValue) {
                                var newState = passedValue ? passedValue : !this.state.disableButtons;
                                this.setState({ disableButtons: newState });
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this$props4 = this.props,
                                    confirmRemoval = _this$props4.confirmRemoval,
                                    currencySymbol = _this$props4.currencySymbol,
                                    discountsToApply = _this$props4.discountsToApply,
                                    removedDiscounts = _this$props4.removedDiscounts; // CHECK : OFFER DISCOUNT : Do we have any discounts to offer the user?
                                var modalList = null;
                                if (discountsToApply.length > 0) {
                                    modalList = React.createElement(ModalList, { currencySymbol: currencySymbol, discountsToApply: discountsToApply, handleSelection: this.handleSelection, toggleButtonEnable: this.toggleButtonEnable });
                                } // CHECK : ALERT REMOVAL : Were any discounts removed for not meeting the requirements?
                                //           (Hide if offering discounts at same time, subsequent render will kick us into here)
                                var removedItems = null;
                                if (!modalList && removedDiscounts.length > 0) {
                                    removedItems = React.createElement(ModalRemoved, { confirmRemoval: confirmRemoval, removedDiscounts: removedDiscounts });
                                } //TODO : Add a div so the user can tap black area to close as well
                                return React.createElement(
                                    "div",
                                    { id: "react-discount-modal", "data-component": "DiscountModal", className: this.state.showModal ? "show-modal" : "" },
                                    React.createElement(
                                        "div",
                                        { id: "react-discount-modal-content" },
                                        modalList,
                                        removedItems,
                                        React.createElement("div", { id: "react-discount-do-not-show", onClick: this.props.enableDoNotShowAgain }, "Do not show deals again")
                                    )
                                );
                            },
                        },
                    ]);
                    return DiscountModal;
                })(React.Component);
                DiscountModal.propTypes = {
                    cartTotal: PropTypes.number.isRequired,
                    currencySymbol: PropTypes.string.isRequired,
                    discountsToApply: PropTypes.array,
                    doNotShowAgain: PropTypes.bool.isRequired,
                    enableDoNotShowAgain: PropTypes.func.isRequired,
                    markDiscountUsed: PropTypes.func.isRequired,
                    rejectDiscount: PropTypes.func.isRequired,
                    removedDiscounts: PropTypes.array,
                };
                module.exports = DiscountModal;
            },
            { "./ModalList.js": 12, "./ModalRemoved.js": 13, "isomorphic-fetch": 64, "prop-types": 70 },
        ],
        10: [
            function (require, module, exports) {
                /*
                 * DISCOUNTS : REACT
                 *  - Handles discounts based on things like...
                 *      "Spend $___ and get Product Y for Free / Discounted" (currently)
                 *      "Spend $___ pick from set of products"
                 *
                 *  - DOES NOT handle Coupon Code stuff, "Buy 2 get 1 free" are done via shopify scripts (For now)
                 *
                 * REQUIRED DATA:
                 *  - Root EL with ID "react-discounts" in root of theme layout and a base64, stringified config object on data-discount-config prop
                 *
                 *
                 * OPTIONAL DATA:
                 *  - Element with ID "react-discount-meter" in the cart slideout (or wherever)
                 *
                 *********************************************/ var DiscountManager = require("./DiscountManager.js"); // PARENT : Initialize discounts manager + Render into Root el
                $(document).ready(function () {
                    // SAFETY : I can haz DOM Node + Config settings?
                    var rootEl = document.getElementById("react-discounts"); // SAFETY : DOM Node + Proper Config
                    if (rootEl) {
                        var discountConfig = rootEl.dataset.discountConfig;
                        var parsedConfig = null; // SAFETY : Attempt to parse config from dom data
                        if (discountConfig && discountConfig.length > 0) {
                            try {
                                parsedConfig = JSON.parse(discountConfig);
                            } catch (err) {
                                console.log("[ DiscountParent -- init() ] ERROR : Looks like the discountConfig was not parsable, printout below:\n".concat(discountConfig));
                            }
                        } // RENDER : If we have a config and a DOM Node, lets render the component!
                        if (parsedConfig && parsedConfig.cookieExpireInDays) {
                            ReactDOM.render(React.createElement(DiscountManager, { config: parsedConfig }), rootEl);
                        } // SAFETY : No DOM Node : Report node is missing, but script was invoked still
                    } else {
                        // console.log('::: DEBUG : React-Discounts is being invoked, but was unable to locate the "react-discounts" DOM Node..');
                    }
                });
            },
            { "./DiscountManager.js": 8 },
        ],
        11: [
            function (require, module, exports) {
                var PropTypes = require("prop-types");
                var ModalItem = /*#__PURE__*/ (function (_React$Component6) {
                    _inherits(ModalItem, _React$Component6);
                    var _super6 = _createSuper(ModalItem);
                    function ModalItem(props) {
                        var _this21;
                        _classCallCheck2(this, ModalItem);
                        _this21 = _super6.call(this, props);
                        _this21.addToCart = _this21.addToCart.bind(_assertThisInitialized(_this21));
                        return _this21;
                    }
                    _createClass2(ModalItem, [
                        {
                            key: "addToCart",
                            value: function addToCart(e) {
                                var _this$props5 = this.props,
                                    discountId = _this$props5.discountId,
                                    handleSelection = _this$props5.handleSelection,
                                    toggleButtonEnable = _this$props5.toggleButtonEnable;
                                toggleButtonEnable(false); // BUTTONS : Prevent multiple clicks
                                handleSelection([discountId], true); // ADD : Submit item to the cart
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this$props6 = this.props,
                                    grantType = _this$props6.grantType,
                                    handleSelection = _this$props6.handleSelection,
                                    imageUrl = _this$props6.imageUrl,
                                    name = _this$props6.name;
                                return React.createElement(
                                    "div",
                                    { className: "modal-item" },
                                    React.createElement("div", { className: "modal-item-image", style: { backgroundImage: "url(".concat(imageUrl, " )") } }),
                                    React.createElement("div", { className: "modal-item-name" }, name),
                                    React.createElement("div", { className: "modal-item-buttons" }, React.createElement("button", { className: "modal-item-btn-add", onClick: this.addToCart }, grantType === "pick" ? "Select" : "Add"))
                                );
                            },
                        },
                    ]);
                    return ModalItem;
                })(React.Component);
                ModalItem.propTypes = {
                    discountId: PropTypes.number.isRequired,
                    grantType: PropTypes.string.isRequired,
                    handleSelection: PropTypes.func.isRequired,
                    imageUrl: PropTypes.string.isRequired,
                    name: PropTypes.string.isRequired,
                    toggleButtonEnable: PropTypes.func.isRequired,
                };
                module.exports = ModalItem;
            },
            { "prop-types": 70 },
        ],
        12: [
            function (require, module, exports) {
                var PropTypes = require("prop-types");
                var ModalItem = require("./ModalItem.js");
                var ModalList = /*#__PURE__*/ (function (_React$Component7) {
                    _inherits(ModalList, _React$Component7);
                    var _super7 = _createSuper(ModalList);
                    function ModalList(props) {
                        var _this22;
                        _classCallCheck2(this, ModalList);
                        _this22 = _super7.call(this, props);
                        _this22.selectNoThanks = _this22.selectNoThanks.bind(_assertThisInitialized(_this22));
                        return _this22;
                    }
                    _createClass2(ModalList, [
                        {
                            key: "selectNoThanks",
                            value: function selectNoThanks() {
                                var _this$props7 = this.props,
                                    discountsToApply = _this$props7.discountsToApply,
                                    handleSelection = _this$props7.handleSelection,
                                    toggleButtonEnable = _this$props7.toggleButtonEnable; // UI : Disable buttons to prevent repeated clicks
                                toggleButtonEnable(false); // FLAG : Mark all presented deals as used
                                var rejectedDiscountIds = [];
                                discountsToApply.forEach(function (discount) {
                                    rejectedDiscountIds.push(discount.discountId);
                                });
                                handleSelection(rejectedDiscountIds, false);
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this$props8 = this.props,
                                    currencySymbol = _this$props8.currencySymbol,
                                    disableButtons = _this$props8.disableButtons,
                                    discountsToApply = _this$props8.discountsToApply,
                                    handleSelection = _this$props8.handleSelection,
                                    toggleButtonEnable = _this$props8.toggleButtonEnable;
                                var priceThreshold = 0; // CHECK : OFFER DISCOUNT : Do we have any discounts to offer the user?
                                var modalItems = null;
                                if (discountsToApply && discountsToApply.length > 0) {
                                    modalItems = discountsToApply.map(function (discount) {
                                        // THRESHOLD : Set Price Threshold for header msg
                                        priceThreshold = priceThreshold < discount.minSpend ? discount.minSpend : priceThreshold; // ITEM : Build list item for this component
                                        return React.createElement(ModalItem, {
                                            discountId: discount.discountId,
                                            grantType: discount.grantType,
                                            handleSelection: handleSelection,
                                            imageUrl: discount.imageUrl || "",
                                            name: discount.displayName || discount.title || "Free Item!",
                                            toggleButtonEnable: toggleButtonEnable,
                                        });
                                    });
                                }
                                return React.createElement(
                                    "div",
                                    { id: "discount-modal-list", "data-option-count": discountsToApply ? discountsToApply.length : "0", "data-enable-buttons": disableButtons },
                                    React.createElement("div", { className: "modal-list-heading" }, "For spending over ".concat(currencySymbol).concat(priceThreshold, ", you've earned a gift!")),
                                    React.createElement("div", { className: "modal-list-content" }, modalItems),
                                    React.createElement("button", { className: "modal-list-btn-no-thanks", onClick: this.selectNoThanks }, "No Thanks")
                                );
                            },
                        },
                    ]);
                    return ModalList;
                })(React.Component);
                ModalList.propTypes = { currencySymbol: PropTypes.string.isRequired, discountsToApply: PropTypes.array, handleSelection: PropTypes.func.isRequired, toggleButtonEnable: PropTypes.func.isRequired };
                module.exports = ModalList;
            },
            { "./ModalItem.js": 11, "prop-types": 70 },
        ],
        13: [
            function (require, module, exports) {
                var PropTypes = require("prop-types");
                var ModalRemoved = /*#__PURE__*/ (function (_React$Component8) {
                    _inherits(ModalRemoved, _React$Component8);
                    var _super8 = _createSuper(ModalRemoved);
                    function ModalRemoved(props) {
                        _classCallCheck2(this, ModalRemoved);
                        return _super8.call(this, props);
                    }
                    _createClass2(ModalRemoved, [
                        {
                            key: "render",
                            value: function render() {
                                var _this$props9 = this.props,
                                    confirmRemoval = _this$props9.confirmRemoval,
                                    removedDiscounts = _this$props9.removedDiscounts;
                                var removedItems = removedDiscounts.map(function (discount) {
                                    return React.createElement(
                                        "li",
                                        { className: "modal-removal-item" },
                                        React.createElement("div", { className: "modal-removal-image", style: { backgroundImage: "url(".concat(discount.imageUrl || "", " )") } }),
                                        React.createElement("div", { className: "modal-removal-title" }, discount.displayName || discount.title || "Free Gift Item")
                                    );
                                });
                                return React.createElement(
                                    "div",
                                    { className: "modal-item removed-discounts" },
                                    React.createElement("div", { className: "modal-item-removal-header" }, "Your cart no longer meets the requirements for these deals:"),
                                    React.createElement("ul", { className: "modal-item-removal-list" }, removedItems),
                                    React.createElement("div", { className: "modal-item-buttons" }, React.createElement("button", { className: "modal-item-btn-confirm", onClick: confirmRemoval }, "OK"))
                                );
                            },
                        },
                    ]);
                    return ModalRemoved;
                })(React.Component);
                ModalRemoved.propTypes = { confirmRemoval: PropTypes.func.isRequired, removedDiscounts: PropTypes.array.isRequired };
                module.exports = ModalRemoved;
            },
            { "prop-types": 70 },
        ],
        14: [
            function (require, module, exports) {
                var LowStock = /*#__PURE__*/ (function (_React$Component9) {
                    _inherits(LowStock, _React$Component9);
                    var _super9 = _createSuper(LowStock);
                    function LowStock(props) {
                        var _this23;
                        _classCallCheck2(this, LowStock);
                        _this23 = _super9.call(this, props);
                        _this23.state = { msgShow: false, msgValue: "", productId: null, variantId: null }; // DEFAULTS : Deep copy, dont want inheritance
                        _this23.defaultState = Object.assign({}, _this23.state);
                        return _this23;
                    }
                    _createClass2(LowStock, [
                        {
                            key: "componentDidMount",
                            value: function componentDidMount() {
                                var product = this.props.product;
                                var threshold = this.props.threshold;
                                var defaults = this.defaultState; // RESET : Setup the vars for a fresh start on variant change
                                var setState = this.setState.bind(this); // EVENTS (VARIANT CHANGE) : Update low stock message on variant changes
                                Events.on("variantchange:precise", function (variant) {
                                    var newState = Object.assign({}, defaults); // CHECK : Do we have all required props
                                    if (threshold && variant && variant.id && product && product.info && product.info[variant.id]) {
                                        var variantInfo = product.info[variant.id]; // CHECK: If quantity is at/below threshold to show message
                                        if (variantInfo.inventoryQuantity <= threshold && variantInfo.inventoryQuantity > 0) {
                                            newState.msgShow = true;
                                            newState.msgValue = "Only " + variantInfo.inventoryQuantity + " Left";
                                        } else {
                                            newState.msgShow = false;
                                            newState.msgValue = "";
                                        } // STATE : Update state to keep sync with current variant selection
                                        newState.variantId = variant.id;
                                        newState.productId = variantInfo.product_id;
                                    } // UPDATE STATE
                                    setState(newState);
                                });
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this$state8 = this.state,
                                    msgShow = _this$state8.msgShow,
                                    msgValue = _this$state8.msgValue;
                                return React.createElement("div", { className: "low-stock--msg", "data-show": msgShow }, msgValue);
                            },
                        },
                    ]);
                    return LowStock;
                })(React.Component);
                module.exports = LowStock;
            },
            {},
        ],
        15: [
            function (require, module, exports) {
                /*
                 * LOW STOCK :
                 *  - Displays a low stock message when a specific variant is under a specific
                 *    quantity threshold.
                 *
                 * REQUIRED DATA:
                 *  - Must also include the snippet 'low-stock-notify.liquid' into the
                 *    page somewhere for the react component to mount into
                 *
                 *****************************************************************************/ var LowStock = require("./LowStock.js");
                var ReactDOM = require("../../vendor/react-dom.min.js"); // RENDER : Find all low stock nodes and render the component into them
                $(document).ready(function () {
                    var elements = document.getElementsByClassName("react-low-stock") || [];
                    _toConsumableArray(elements).forEach(function (el) {
                        // RENDER : Create our low stock component
                        try {
                            // PRODUCT : Gather product data from global object
                            var product = window.Shopify.productObj || {}; // THRESHOLD : Gather product quantity threshold from node
                            var threshold = el.dataset.threshold || 0;
                            if (product && product.variants && threshold) {
                                // RENDER : Create the component
                                ReactDOM.render(React.createElement(LowStock, { product: product, threshold: threshold }), el); // ABORT : No product variants, component cannot function as intended, skipping mount
                            } else {
                                console.log("::: WARNING : [ LowStockParent.js ] -- Skipping mount due to missing product / variant data oject");
                            } // SAFETY : Node was not present or something else crazy happened, surprised if you enter this
                        } catch (err) {
                            console.log("Unable to render Low Stock component into the node:\n    >".concat(err.message || err));
                        }
                    });
                });
            },
            { "../../vendor/react-dom.min.js": 50, "./LowStock.js": 14 },
        ],
        16: [
            function (require, module, exports) {
                var PropTypes = require("prop-types");
                var SwatchItem = /*#__PURE__*/ (function (_React$Component10) {
                    _inherits(SwatchItem, _React$Component10);
                    var _super10 = _createSuper(SwatchItem);
                    function SwatchItem(props) {
                        var _this24;
                        _classCallCheck2(this, SwatchItem);
                        _this24 = _super10.call(this, props);
                        _this24.callSelectSwatch = _this24.callSelectSwatch.bind(_assertThisInitialized(_this24));
                        _this24.hoverSwatch = _this24.hoverSwatch.bind(_assertThisInitialized(_this24));
                        return _this24;
                    } // SWAP IMAGE : Select swatch changes image and sets active state
                    _createClass2(SwatchItem, [
                        {
                            key: "callSelectSwatch",
                            value: function callSelectSwatch(isHover) {
                                var _this$props10 = this.props,
                                    selectSwatch = _this$props10.selectSwatch,
                                    swatchId = _this$props10.swatchId,
                                    variantImgUrl = _this$props10.variantImgUrl;
                                var isHoverState = isHover === true; //Click events cause this to be the "event" object instead
                                selectSwatch(swatchId, variantImgUrl, isHoverState);
                            }, // HOVER TILE : Swap variant image on hover, don't store as selection
                        },
                        {
                            key: "hoverSwatch",
                            value: function hoverSwatch() {
                                this.callSelectSwatch(true);
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this$props11 = this.props,
                                    active = _this$props11.active,
                                    colorValueName = _this$props11.colorValueName,
                                    resetProductImg = _this$props11.resetProductImg,
                                    swatchId = _this$props11.swatchId,
                                    swatchImgUrl = _this$props11.swatchImgUrl,
                                    variantImgUrl = _this$props11.variantImgUrl; // Destructuring = verbosity save
                                var isActive = active ? "active" : "";
                                var swatchColorStyle = {
                                    backgroundColor: colorValueName,
                                    backgroundImage: "url( ".concat(swatchImgUrl, " )"), //May or may not have swatch img
                                };
                                var colorLabel = colorValueName
                                    .toLowerCase()
                                    .replace("-", " ")
                                    .split(" ")
                                    .map(function (s) {
                                        return s.charAt(0).toUpperCase() + s.substring(1);
                                    })
                                    .join(" ");
                                return React.createElement(
                                    "div",
                                    { className: "swatch-item-wrap " + isActive, onMouseEnter: this.hoverSwatch, onMouseLeave: resetProductImg, onClick: this.callSelectSwatch },
                                    React.createElement("div", { className: "swatch-highlight" }),
                                    React.createElement("div", { title: colorLabel, "data-title": colorLabel, "aria-label": colorLabel, style: swatchColorStyle, className: "swatch-item " + colorValueName })
                                );
                            },
                        },
                    ]);
                    return SwatchItem;
                })(React.Component);
                SwatchItem.propTypes = {
                    active: PropTypes.bool.isRequired,
                    colorValueName: PropTypes.string.isRequired,
                    selectSwatch: PropTypes.func.isRequired,
                    swatchId: PropTypes.string.isRequired,
                    swatchImgUrl: PropTypes.string,
                    variantImgUrl: PropTypes.string.isRequired,
                };
                module.exports = SwatchItem;
            },
            { "prop-types": 70 },
        ],
        17: [
            function (require, module, exports) {
                /* REACT COMPONENT : SWATCHES
                 *
                 * ..:: REQUIRED - SWATCH OBJ: Required data in each swatch ::..
                 *   colorDisplayName: option['title'],                // NAME : Color Name that user sees in tooltip
                 *   colorValueName: this.slugify( option['title'] ),  // NAME : CSS name for color style fallback
                 *
                 *   productId: data.id,                               // ID : Product ID
                 *   swatchId: data.id + '-' + option['title'],        // ID : Swatch : Swatch Color Unique ID
                 *
                 *   productImgUrl,                                    // IMAGE : Product image original (for restoring after hover)
                 *   swatchImgUrl,                                     // SWATCH : Image url for swatch (fallback = name as color)
                 *   variantImgUrl                                     // IMAGE : Product Variant Image for that color option
                 *
                 * ..:: REQUIRED - IMAGE LOCATION: ID of image to swap src ::..
                 *   'product-image-PRODUCT_ID_HERE' (EX: 'product-image-13243223')
                 *****************************************************************************/ var PropTypes = require("prop-types");
                var SwatchItem = require("./SwatchItem.js");
                var SwatchList = /*#__PURE__*/ (function (_React$Component11) {
                    _inherits(SwatchList, _React$Component11);
                    var _super11 = _createSuper(SwatchList);
                    function SwatchList(props) {
                        var _this25;
                        _classCallCheck2(this, SwatchList);
                        _this25 = _super11.call(this, props); // Ensure Product Info is Present
                        var _ref2 = _this25.props.swatchData[0] || {},
                            productId = _ref2.productId,
                            productImgUrl = _ref2.productImgUrl;
                        if (!productId || !productImgUrl) {
                            var culprit = !productId ? "Product ID" : "Product Img URL";
                            console.log("[SwatchList.js] -- Swatch data is missing the " + culprit + "!");
                        }
                        _this25.state = { activeSwatchId: null, activeImgUrl: productImgUrl, productId: productId }; // BIND CONTEXT : Imperative, bind 'this' context to the current class scope
                        _this25.selectSwatch = _this25.selectSwatch.bind(_assertThisInitialized(_this25));
                        _this25.resetProductImg = _this25.resetProductImg.bind(_assertThisInitialized(_this25));
                        _this25.setOOSText = _this25.setOOSText.bind(_assertThisInitialized(_this25));
                        return _this25;
                    } // SWAP IMAGE : Change to variant image and set active state if clicked (handles hover also)
                    _createClass2(SwatchList, [
                        {
                            key: "selectSwatch",
                            value: function selectSwatch(swatchId, variantImgUrl) {
                                var isHover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                                var _this$state9 = this.state,
                                    activeImgUrl = _this$state9.activeImgUrl,
                                    productId = _this$state9.productId; // SWAP IMAGE : When hover / click swap image to that color variant if it is present
                                if (variantImgUrl && variantImgUrl.length > 10) {
                                    var targetImg = document.getElementById("product-image-" + productId);
                                    targetImg.src = variantImgUrl;
                                } // Show/ Hide OOS Text
                                if (swatchId) {
                                    this.setOOSText(swatchId);
                                } // SET ACTIVE : Indicate which swatch is active currently
                                if (!isHover) {
                                    this.setState({ activeSwatchId: swatchId, activeImgUrl: variantImgUrl.length > 10 ? variantImgUrl : activeImgUrl });
                                }
                            }, // Set OOS Text
                        },
                        {
                            key: "setOOSText",
                            value: function setOOSText(activeSwatchId) {
                                var swatchData = this.props.swatchData; // Destructuring = verbosity saver
                                var productId = this.state.productId;
                                if (swatchData && activeSwatchId) {
                                    var exactSwatch = swatchData.filter(function (s) {
                                        return activeSwatchId === s.swatchId;
                                    });
                                    if (exactSwatch && exactSwatch.length) {
                                        var isSwatchAvailable = exactSwatch[0].available;
                                        var selector = document.querySelector(".product-box-".concat(productId, " .oos-text"));
                                        if (selector) {
                                            if (isSwatchAvailable) {
                                                selector.classList.add("hide");
                                            } else {
                                                selector.classList.remove("hide");
                                            }
                                        }
                                    }
                                }
                            }, // RESET IMAGE : Set image back to main product img after hover exit
                        },
                        {
                            key: "resetProductImg",
                            value: function resetProductImg() {
                                var _this$state10 = this.state,
                                    activeImgUrl = _this$state10.activeImgUrl,
                                    productId = _this$state10.productId,
                                    activeSwatchId = _this$state10.activeSwatchId;
                                var targetImg = document.getElementById("product-image-" + productId);
                                targetImg.src = activeImgUrl; // Show/ Hide OOS Text
                                if (activeSwatchId) {
                                    this.setOOSText(activeSwatchId);
                                }
                            },
                        },
                        {
                            key: "render",
                            value: function render() {
                                var _this26 = this;
                                var swatchData = this.props.swatchData; // Destructuring = verbosity saver
                                var activeSwatchId = this.state.activeSwatchId; // Destructuring = verbosity saver
                                var swatches = null;
                                var showAfter = null;
                                if (swatchData.length > 0) {
                                    var usedColors = [];
                                    swatches = swatchData.map(function (swatchObj) {
                                        var colorValueName = swatchObj.colorValueName,
                                            swatchId = swatchObj.swatchId,
                                            swatchImgUrl = swatchObj.swatchImgUrl,
                                            variantImgUrl = swatchObj.variantImgUrl;
                                        var isAlreadyDisplayed = usedColors.find(function (color) {
                                            return color === colorValueName;
                                        }); //colorValueName = this-is-my-color-name
                                        // UNUSED - Lets add to list and render swatch
                                        if (!isAlreadyDisplayed) {
                                            usedColors.push(colorValueName); //Add color to list of used colors
                                            return React.createElement(SwatchItem, {
                                                active: swatchId === activeSwatchId,
                                                colorValueName: colorValueName,
                                                key: swatchId,
                                                resetProductImg: _this26.resetProductImg,
                                                selectSwatch: _this26.selectSwatch,
                                                swatchId: swatchId,
                                                swatchImgUrl: swatchImgUrl,
                                                variantImgUrl: variantImgUrl,
                                            });
                                        }
                                    });
                                }
                                if (swatchData.length > 3) {
                                    showAfter = swatchData.length - 3;
                                }
                                return React.createElement("div", { className: "swatch-list", "data-showAfter": showAfter }, swatches, showAfter && React.createElement("a", null, "+", showAfter));
                            },
                        },
                    ]);
                    return SwatchList;
                })(React.Component);
                SwatchList.propTypes = { swatchData: PropTypes.array.isRequired };
                module.exports = SwatchList;
            },
            { "./SwatchItem.js": 16, "prop-types": 70 },
        ],
        18: [
            function (require, module, exports) {
                /*
                 * SWATCHES : REACT
                 *  - Displays swatch options for a product
                 *
                 * REQUIRED DATA:
                 *  - Root EL(s) need 'data-swatches' as stringified JSON array of swatch objects
                 *  - Swatch Object Sample:
                 *    {
                 *      colorDisplayName: STRING,                    // NAME : Color Name that user sees in tooltip
                 *      colorValueName: STRING (word-word),          // NAME : CSS name for color style fallback
                 *      productId: STRING,                           // ID : Product ID
                 *      productImgUrl: STRING,                       // IMAGE : Product image original (for restoring after hover)
                 *      swatchId: STRING (productId-colorValueName), // ID : Swatch : Swatch Color Unique ID
                 *      swatchImgUrl: STRING,                        // SWATCH : Image url for swatch (fallback = name as color)
                 *      variantImgUrl: STRING                        // IMAGE : Product Variant Image for that color option
                 *    }
                 *********************************************/ var SwatchList = require("./SwatchList"); // RENDER : Find all swatch elements and render a SwatchList in each element
                var buildSwatches = function buildSwatches() {
                    var elements = document.getElementsByClassName("react-swatch-list") || [];
                    _toConsumableArray(elements).forEach(function (el) {
                        // SAFETY : Ensure data exists
                        if (el.dataset && el.dataset.swatches) {
                            // PARSE : Read + Pass data to component if valid JSON
                            try {
                                var swatchData = JSON.parse(el.dataset.swatches); // RENDER : If > 1 color, Render SwatchList into target el
                                if (swatchData.length > 0) {
                                    ReactDOM.render(React.createElement(SwatchList, { swatchData: swatchData }), el);
                                } // SAFETY : Malformatted JSON = most common error
                            } catch (err) {
                                console.log("Swatch Data malformed, please check 'data-swatches' info on element\n  >".concat(err.message || err));
                            }
                        }
                    });
                };
                module.exports = buildSwatches;
            },
            { "./SwatchList": 17 },
        ],
        19: [
            function (require, module, exports) {
                theme.AccountSidebar = function () {
                    if ($(".account-page").length > 0) {
                        $(".account-sidemenu h3").click(function () {
                            $(this).toggleClass("active");
                            $(this).next().slideToggle("slow");
                        });
                    }
                };
                $(document).ready(function () {
                    theme.AccountSidebar();
                });
            },
            {},
        ],
        20: [
            function (require, module, exports) {
                // Function to calculate the age
                theme.calculateAge = function (selectedMonth, selectedDay, selectedYear, ageThreshold, todayDate) {
                    // Calculate age difference
                    var today = new Date(todayDate);
                    var dob = selectedMonth + "/" + selectedDay + "/" + selectedYear;
                    var birthDate = new Date(dob);
                    var age = today.getFullYear() - birthDate.getFullYear();
                    var m = today.getMonth() - birthDate.getMonth();
                    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                        age = age - 1;
                    }
                    return age;
                };
                theme.dateOptionSelection = function () {
                    // Dropdown toggle event
                    $(".dob-wrapper .option-select").click(function () {
                        $(".selection-error-msg").fadeOut("fast");
                        $(this).closest(".dropdown").siblings().find(".age-gate-options").slideUp("fast");
                        $(this).closest(".dropdown").siblings().find(".option-select").removeClass("active");
                        $(this).toggleClass("active").siblings(".age-gate-options").stop().slideToggle("fast");
                    }); // Dropdown option selection click event
                    $(".dob-wrapper .age-gate-options li").click(function () {
                        $(this).closest(".age-gate-options").find("li").removeClass("selected");
                        $(this).addClass("selected").closest(".age-gate-options").slideUp("fast");
                        $(this).closest(".age-gate-options").siblings(".option-select").removeClass("active").text($(this).attr("value"));
                    }); // Button click submit event
                    $(".dob-wrapper .age-submit-button .submit-btn").click(function () {
                        // Get base context variables set
                        var $parent = $(".dob-wrapper");
                        var $currentData = $parent.find(".current-date"); // Get required data with context to base variables
                        var selectedMonth = $parent.find(".month .age-gate-month li.selected").attr("data-month-value"),
                            selectedDay = $parent.find(".date .age-gate-date li.selected").attr("value"),
                            selectedYear = $parent.find(".year .age-gate-year li.selected").attr("value"),
                            todayDate = $currentData.attr("data-current-date"),
                            ageThreshold = parseInt($currentData.attr("data-age-limit")),
                            allSelected = true;
                        if (typeof selectedDay == "undefined" || typeof selectedMonth == "undefined" || typeof selectedYear == "undefined") {
                            allSelected = false;
                        }
                        var age = theme.calculateAge(selectedMonth, selectedDay, selectedYear, ageThreshold, todayDate);
                        if (allSelected) {
                            if (ageThreshold < age) {
                                $.cookie("BOLDEV_showBourbonPage", "true");
                                location.reload(true);
                            } else {
                                $(".dob-wrapper .dob-inner").hide();
                                $(".dob-wrapper .errors").fadeIn("fast");
                                $.cookie("BOLDEV_showBourbonPage", "false");
                            }
                        } else {
                            $(".selection-error-msg").fadeIn("fast");
                        }
                    });
                };
                theme.showBourbonPage = function () {
                    var showPage = $.cookie("BOLDEV_showBourbonPage");
                    if (showPage == "true") {
                        $(".bourbon-wrapper").show();
                        $(".bourbon-age-gate-wrapper").remove();
                        $(window).load(function () {
                            $(window).scrollTop(0);
                        });
                    } else {
                        theme.dateOptionSelection();
                        $(".bourbon-age-gate-wrapper").show();
                        $(".bourbon-wrapper").remove();
                    }
                };
                $(document).ready(function () {
                    theme.showBourbonPage();
                });
            },
            {},
        ],
        22: [
            function (require, module, exports) {
                /*============================================================================
  Collection template
==============================================================================*/ theme.Collection = (function () {
                    function Collection(container) {
                        var ui = {
                            backingShadow: $("#filter-bg-shadow"),
                            collectionWrap: $("#shopify-section-collection-template"), //Can store these b/c they are unaffected by the filter app JS re-renders
                            collectionInner: $("#shopify-section-collection-template .collection-template"),
                            desktopApplyBtn: $("#filter-apply-button-desktop"),
                            desktopClearBtn: $("#filter-clear-button-desktop"),
                            desktopFilterBtn: $("#filter-button-desktop"),
                            desktopFilterSet: $(".filter-list-desktop"),
                            mobileFilterBtn: $("#filter-button-mobile"),
                            seoBlockWrap: $("#collection-seo-wrap"),
                            seoReadMoreBtn: $("#collection-seo-read-more"),
                        }; // TRANSPARENT LANDING : When a banner is present, add the transparent landing class to body so header goes transparent
                        var config = ui.collectionInner.data();
                        if (config.transparentLanding) {
                            // MOBILE : If banner present, set mobile transparent class
                            if (config.hasBannerMobile) {
                                $("body").addClass("show-transparent-landing-mobile");
                            } // DESKTOP : If banner present, set desktop transparent class
                            if (config.hasBannerDesktop) {
                                $("body").addClass("show-transparent-landing-desktop");
                            }
                        } // EVENTS : Bind DOM events when ready
                        $(document).ready(function () {
                            // FILTER MENU : STATE : Open state indicator for filters
                            var toggleFilterOpen = function toggleFilterOpen() {
                                ui.collectionWrap.toggleClass("filter-open");
                            }; // FILTER MENU : EVENT BINDING : Attach open/close handles
                            ui.mobileFilterBtn.click(function () {
                                toggleFilterOpen();
                            }); // DESKTOP - IF desktop filter is mocked as hidden panel that opens, use these to show whole panel + copy filters.scss.liquid from aqua
                            // ui.desktopFilterBtn.click( () => {
                            //   toggleFilterOpen();
                            // });
                            // ui.backingShadow.click( () => {
                            //   toggleFilterOpen();
                            // });
                            // ATTACH : Apply All event
                            theme.utils.filterUtils.init("#shopify-section-collection-template"); // SEO PARAGRAPH : OPEN / CLOSE : Reveals the rest of the SEO Paragraph text on click
                            var seoExpanded = false;
                            ui.seoReadMoreBtn.click(function () {
                                if (!seoExpanded) {
                                    seoExpanded = true;
                                    ui.seoBlockWrap
                                        .addClass("seo-open")
                                        .delay(250)
                                        .queue(function () {
                                            $(this).addClass("seo-visible").dequeue();
                                        });
                                } else {
                                    seoExpanded = false;
                                    ui.seoBlockWrap
                                        .removeClass("seo-visible")
                                        .delay(250)
                                        .queue(function () {
                                            $(this).removeClass("seo-open").dequeue();
                                        });
                                }
                            });
                        });
                    }
                    Collection.prototype = _.assignIn({}, Collection.prototype, {});
                    return Collection;
                });
            },
            {},
        ],
        23: [
            function (require, module, exports) {
                /*============================================================================
  Columns Carousel on index
==============================================================================*/ theme.ColumnsCarousel = (function () {
                    function ColumnsCarousel(container) {
                        var $container = (this.$container = $(container));
                        var ui = {
                            carousel: $container.find(".columns-carousel--columns"),
                            nav: $container.find(".columns-carousel--nav"),
                            prev: $container.find(".columns-carousel--prev"),
                            next: $container.find(".columns-carousel--next"),
                            currentSlide: $container.find(".columns-carousel--current-slide"),
                            totalSlides: $container.find(".columns-carousel--total-slides"),
                            item: $container.find(".column-item"),
                        }; // CAROUSEL INIT
                        var initColumnsCarousel = function initColumnsCarousel(Columnscarousel) {
                            var current = 0;
                            var cols = Columnscarousel.owlCarousel({
                                lazyLoad: true,
                                responsive: { 0: { items: 1 }, 767: { items: 3 }, 1024: { items: 4 } },
                                onInitialized: function onInitialized(event) {
                                    current = event.item.index + 1;
                                    ui.currentSlide.text(current);
                                    ui.totalSlides.text(event.item.count);
                                },
                                onChanged: function onChanged(event) {
                                    current = event.item.index + 1; // iOS - Library wasn't updated for swipes
                                    if (ui.currentSlide.length > 0) {
                                        ui.currentSlide.text(current);
                                    }
                                },
                            }); // NAVIGATION CONTROLS
                            ui.prev.on("click", function (e) {
                                cols.trigger("prev.owl.carousel");
                            });
                            ui.next.on("click", function (e) {
                                cols.trigger("next.owl.carousel");
                            }); // ITEM HOVER
                            ui.item
                                .on("mouseenter", this, function () {
                                    ui.item.removeClass("hovered");
                                    $(this).addClass("hovered"); // get the index of the currently hovered item
                                    ui.currentSlide.text($(".column-item").index(this) + 1);
                                })
                                .on("mouseleave", function () {
                                    // restore the current slide from the carousel index
                                    //ui.currentSlide.text(current);
                                });
                        }; // Run the carousel
                        initColumnsCarousel(ui.carousel); // Shopify section load / unload functions
                        $(document).on("shopify:section:unload", function (event) {
                            var target = $(event.target);
                            target.find(".columns-carousel--columns").owlCarousel("destroy");
                            $(document).off(".columns-carousel--columns");
                        });
                        $(document).on("shopify:section:load", function (event) {
                            initColumnsCarousel($(event.target).find(".columns-carousel--columns"));
                        });
                    }
                    ColumnsCarousel.prototype = _.assignIn({}, ColumnsCarousel.prototype, {});
                    return ColumnsCarousel;
                })();
            },
            {},
        ],
        24: [
            function (require, module, exports) {
                /*============================================================================
  Featured Collections
==============================================================================*/ theme.FeaturedCollections = (function () {
                    function FeaturedCollections(container) {
                        var $container = (this.$container = $(container));
                        var sectionId = $container.data("section-id");
                        $("ul#tabbed-collections-" + sectionId).each(function () {
                            var active,
                                content,
                                links = $(this).find("a");
                            active = links.first().addClass("active");
                            content = $(active.attr("href"));
                            links.not(":first").each(function () {
                                $($(this).attr("href")).hide();
                            });
                            $(this)
                                .find("a")
                                .click(function (e) {
                                    active.removeClass("active");
                                    content.hide();
                                    active = $(this);
                                    content = $($(this).attr("href"));
                                    active.addClass("active");
                                    content.show();
                                    return false;
                                });
                        });
                        $(document).on("shopify:block:select", function (event) {
                            var activeTab = $(event.target);
                            var tabLink = $(event.target).children();
                            $(tabLink).trigger("click");
                        });
                    }
                    FeaturedCollections.prototype = _.assignIn({}, FeaturedCollections.prototype, {});
                    return FeaturedCollections;
                })();
            },
            {},
        ],
        25: [
            function (require, module, exports) {
                /*============================================================================
  Footer template
==============================================================================*/ theme.Footer = (function () {
                    function Footer() {
                        // EVENTS : Bind DOM events when ready
                        $(document).ready(function () {
                            // FILTER MENU : OPEN / CLOSE : Indicator for the whole footer menu (mobile)
                            if ($(window).width() < 768) {
                                $(document).on("click", ".footer-sub-nav-wrapper .nav-sub-header", function (e) {
                                    var parent = $(".footer-sub-nav-wrapper");
                                    $(".footer-sub-nav-wrapper .nav-sub-header").next().stop().slideUp("fast");
                                    $(this).closest(parent).siblings().removeClass("active");
                                    $(this).toggleClass("active").closest(parent).toggleClass("active").siblings().children(".nav-sub-header").removeClass("active");
                                    $(this).next().stop().slideToggle("fast", "swing");
                                });
                            }
                        });
                    }
                    Footer.prototype = _.assignIn({}, Footer.prototype, {});
                    return Footer;
                })();
            },
            {},
        ],
        26: [
            function (require, module, exports) {
                /*============================================================================
  Header on Index
==============================================================================*/ theme.Header = (function () {
                    function Header(container) {
                        var _this27 = this;
                        var $container = (this.$container = $(container));
                        var ui = {
                            arrows: $("#promo-arrow-left, #promo-arrow-right"),
                            body: $("body"),
                            desktopNavWrap: $("#nav-bar-wrapper"),
                            desktopNavItem: $(".nav-primary-link"),
                            html: $("html"),
                            mobileNavButton: $("#icon-nav-mobile-menu-btn"),
                            mobileNavMenu: $("#nav-menu-mobile"),
                            mobileHeaders: $("#accordion").find(".accordion-header"),
                            mobileSitesPicker: $("#nav-sites-picker-mobile"),
                            mobileSubHeaders: $("#accordion").find(".accordion-sub-header"),
                            promoWrap: $("#double-promo-wrapper"),
                          promoWrapTh: $("#triple-promo-wrapper"),  
                          searchIcon: $(".nav-search"),
                            searchBar: $("#nav-search-bar-wrapper"),
                            searchClose: $(".nav-search-bar-close"),
                            subMenuHeader: $(".has_sub_menu"),
                            swapRate: $container.attr("data-swap-rate"),
                            searchInput: $(".nav-search-input"),
                        };
                        this.initStickyNav();
                        var self = this; // Announcement bar close button event
                        $("#super-banner-wrap .btn-close").on("click", function () {
                            $(this).closest("#super-banner-wrap").fadeOut();
                        }); // MOBILE NAV : Attach menu toggle event
                        if (ui.mobileNavButton && ui.mobileNavMenu) {
                            ui.mobileNavButton.on("click", function () {
                                ui.mobileNavMenu.toggleClass("mobile-nav-open"); // TOGGLE : Menu itself
                                ui.desktopNavWrap.toggleClass("mobile-nav-open"); // TOGGLE : Transparent landing mode needs an extra flag to color right
                                ui.body.toggleClass("js-drawer-open"); // TOGGLE : Page scrolling (built in to a lib so tied to this classname)
                                // ui.html.toggleClass( 'menu-open' ); // TOGGLE : Html has some oddness from the theme, this clears it so iPoos can render right
                            });
                        } // MOBILE NAV : Attach Sites-Picker toggle event
                        if (ui.mobileSitesPicker) {
                            ui.mobileSitesPicker.on("click", function () {
                                ui.mobileSitesPicker.toggleClass("open");
                            });
                        } // MOBILE NAV : LEVEL 1 HEADER ACCORDION : Accordion Functionality
                        ui.mobileHeaders.click(function () {
                            var header = $(this); //Expand or collapse this panel
                            if (!header.hasClass("open")) {
                                $(".accordion-header").removeClass("open"); // Clear other major sections that are open
                            }
                            header.toggleClass("open"); // Add open class to the requested header
                            header.next().slideToggle("fast"); // Reveal accordion content for requested header
                            //Hide the other panels
                            $(".accordion-content").not(header.next()).slideUp("fast");
                        }); // MOBILE NAV : LEVEL 2 - SUB-HEADER ACCORDION : Accordion Functionality
                        ui.mobileSubHeaders.click(function () {
                            var subHead = $(this); //Expand or collapse this panel
                            if (!subHead.hasClass("open")) {
                                $(".accordion-sub-header").removeClass("open"); // Clear other major sections that are open
                            }
                            subHead.toggleClass("open"); // Open this header
                            subHead.next().slideToggle("fast"); // Reveal requested panel
                            //Hide the other panels
                            $(".accordion-content2").not(subHead.next()).slideUp("fast");
                        }); // ARIA-LABEL (NAV) : Marks expanded attribute on nav menu when open / closed via hover
                        ui.subMenuHeader.hover(function () {
                            $(this).attr("aria-expanded", function (index, attr) {
                                return attr == "false" ? true : "false";
                            });
                        }); // SEARCH BAR : When user clicks search icon, a new search bar will reveal itself
                        // NOTE : This is also used by the transparent setup..
                        if (ui.searchIcon && ui.searchIcon.length > 0) {
                            ui.searchIcon.on("click", function (e) {
                                e.stopPropagation();
                                ui.searchInput.focus();
                                ui.desktopNavWrap.toggleClass("show-search-bar");
                            });
                            ui.searchClose.on("click", function (e) {
                                e.stopPropagation();
                                ui.desktopNavWrap.removeClass("show-search-bar");
                            });
                            window.addEventListener('click', function() {
                                ui.desktopNavWrap.removeClass("show-search-bar");
                            });
                            ui.searchInput.on("click", function(e) {
                                e.stopPropagation();
                            });
                        } //Code for close search box on scroll start
                        $(".index-sections").on("click touchstart", function () {
                            $("header").removeClass("show-search-bar");
                        });
                        $("#nav-menu-mobile").on("click touchstart", function () {
                            $("header").removeClass("show-search-bar");
                        }); //Code for close search box on scroll end
                        // PROMO BANNER : If 2+ Promos enabled, connect swapping and arrow functionality
                        if (ui.promoWrap && ui.arrows && ui.swapRate) {
                            // METHOD : SWAP : Swap promo functionality
                            var swapPromos = function swapPromos() {
                                ui.promoWrap.toggleClass("show-promo-two");
                            }; // METHOD : TOGGLE : Swap promos every 5 seconds
                            var start = function start() {
                                _this27.autoToggle = setInterval(function () {
                                    swapPromos();
                                }, ui.swapRate * 1000);
                            }; // METHOD : RESUME : Resume toggle after 25 secs of no user activity
                            var resume = function resume() {
                                if (_this27.resumeTimer) {
                                    clearTimeout(_this27.resumeTimer);
                                }
                                _this27.resumeTimer = setTimeout(function () {
                                    start();
                                }, 25000);
                            }; // EVENT : CLICK : User clicks either arrow, banner toggles and pauses swapping for ~30 secs
                            ui.arrows.on("click", function () {
                                swapPromos(); // DISABLE : Pause auto-toggle, user is focusing on banner
                                if (_this27.autoToggle) {
                                    clearInterval(_this27.autoToggle);
                                } // RESUME : Begin 30 sec countdown timer to resume swapping (25 + 'ui.swapToggle' in sec )
                                resume();
                            }); // START : Begin auto-toggle until user interaction
                            start();
                        } //  Header dektop main menu Hover effect
                        // PROMO BANNER THREE : If 3+ Promos enabled, swapping functionality
                        if (ui.promoWrapTh && ui.arrows && ui.swapRate) {
                            // METHOD : SWAP : Swap promo functionality
                            var swapPromosTH = function swapPromosTH() {
                                ui.promoWrapTh.toggleClass("show-promo-two");
                            }; // METHOD : TOGGLE : Swap promos
							var swapPromosTHT = function swapPromosTHT() {
                                ui.promoWrapTh.toggleClass("show-promo-three");
                            }; // METHOD : TOGGLE : Swap promos
                            var startTH = function startTH() {
                                var check_slide_counter = 0;
                                _this27.autoToggle = setInterval(function () {
                                    if((check_slide_counter % 3) === 0){
                                      swapPromosTH();
                                      ui.promoWrapTh.removeClass("show-promo-three");
                                    }
                                    if((check_slide_counter % 3) === 1){
                                      swapPromosTHT();
                                      ui.promoWrapTh.removeClass("show-promo-two");
                                    }
                                    if((check_slide_counter % 3) === 2){
                                      ui.promoWrapTh.removeClass("show-promo-two");
                                      ui.promoWrapTh.removeClass("show-promo-three");
                                    }
                                    check_slide_counter++;
                                }, ui.swapRate * 1000);
                            }; // METHOD : RESUME
                            var resumeTH = function resumeTH() {
                                if (_this27.resumeTimer) {
                                    clearTimeout(_this27.resumeTimer);
                                }
                                _this27.resumeTimer = setTimeout(function () {
                                    startTH();
                                }, 25000);
                            }; // EVENT : CLICK : User clicks either arrow, banner toggles and pauses swapping for ~30 secs
                            ui.arrows.on("click", function () {
                                swapPromosTH(); // DISABLE : Pause auto-toggle, user is focusing on banner
								swapPromosTHT();
                                if (_this27.autoToggle) {
                                    clearInterval(_this27.autoToggle);
                                } // RESUME : Begin 30 sec countdown timer to resume swapping (25 + 'ui.swapToggle' in sec )
                                resumeTH();
                            }); // START : Begin auto-toggle until user interaction
                            startTH();
                        }
                        /* var megamenuTime;$(".nav-primary-link").mouseenter(function(){if(megamenuTime){clearTimeout(megamenuTime);}var that=$(this);$(this).siblings(".nav-primary-link").find('.submenu-wrap').stop().fadeOut(100,function(){that.siblings(".nav-primary-link").removeClass('active');});$(this).addClass('active').find('.submenu-wrap').stop().fadeIn(200);$(this).closest("#nav-menu-desktop-list").mouseleave(function(){megamenuTime=setTimeout(function(){that.find(".submenu-wrap").stop().fadeOut(300,function(){that.removeClass('active');clearTimeout(megamenuTime);});},500);});}) */
                    }
                    Header.prototype = _.assignIn({}, Header.prototype, {
                        initStickyNav: function initStickyNav() {
                            this.navState = { offsetY: 0, height: 0, shouldPhantom: false, isSticky: false };
                            this.cache = this.cache || {};
                            this.cache.$topBar = $("#top-bar");
                            this.cache.$navContainer = $("#header-section");
                            this.cache.$nav = $("#nav-bar-wrapper");
                            this.cache.$window = $(window);
                            this.initNavState();
                            this.handleNavResize();
                            this.handleNavScroll();
                            this.bindNavEvents();
                        },
                        initNavState: function initNavState() {
                            var initPosition = this.cache.$nav.css("position");
                            this.navState.shouldPhantom = initPosition !== "fixed" && initPosition !== "absolute";
                            this.navState.offsetY = this.cache.$topBar.outerHeight();
                        },
                        setNavSticky: function setNavSticky() {
                            this.cache.$nav.addClass("isStuck").css({ position: "fixed", top: "0"});
                            this.navState.isSticky = true;
                            
                            const nav_height = this.navState.height;
                            const page_wrapper = document.querySelector('.page-main-wrapper');
                            if (page_wrapper) {
                                page_wrapper.style.paddingTop = nav_height + "px";
                            }
                        },
                        phantomNav: function phantomNav() {
                            this.cache.$navContainer.css({ /*paddingBottom: this.navState.height + "px"*/ });
                            this.setNavSticky();
                        },
                        unphantomNav: function unphantomNav() {
                            this.cache.$navContainer.removeAttr("style");
                            this.cache.$nav.removeAttr("style").removeClass("isStuck");
                            this.navState.isSticky = false;
                            const page_wrapper = document.querySelector('.page-main-wrapper');
                            if (page_wrapper) {
                                page_wrapper.style.paddingTop = "0px";
                            }
                        },
                        handleNavResize: function handleNavResize() {
                            var nextHeight = this.cache.$nav.outerHeight();
                            var nextOffsetY = this.cache.$topBar.outerHeight();
                            if (this.navState.height !== nextHeight) {
                                this.navState.height = nextHeight;
                            }
                            if (this.navState.offsetY !== nextOffsetY) {
                                this.navState.offsetY = nextOffsetY;
                            }
                        },
                        handleNavScroll: function handleNavScroll() {
                            var windowY = this.cache.$window.scrollTop();
                            var isBelow = windowY > this.navState.offsetY && !this.navState.isSticky;
                            var isAbove = windowY <= this.navState.offsetY && this.navState.isSticky;
                            if (isBelow) {
                                if (this.navState.shouldPhantom) {
                                    this.phantomNav();
                                } else {
                                    this.setNavSticky();
                                }
                            } else if (isAbove) {
                                this.unphantomNav();
                            }
                        },
                        bindNavEvents: function bindNavEvents() {
                            this.cache.$window.on("resize", $.proxy(this.handleNavResize, this)).on("scroll touchmove", $.proxy(this.handleNavScroll, this)).on("modal-close", $.proxy(this.handleNavScroll, this));
                        },
                    });
                    return Header;
                })();
            },
            {},
        ],
        28: [
            function (require, module, exports) {
                /*============================================================================
  Footer Newsletter
==============================================================================*/ theme.Newsletter = (function () {
                    function Newsletter(container) {
                        var $container = (this.$container = $(container));
                        var ui = { formId: $("#footer-newsletter"), textbox: $("#email"), submit: $("#button-footer-newsletter-submit"), errorMsg: $("#newsletter-error-response"), successMsg: $("#newsletter-success-response") }; // regex for valid email
                        var regexEmail = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i);
                        if (ui.formId) {
                            ui.textbox.on("focus", function () {
                                // remove any pre-existing error class
                                ui.formId.removeClass("has-error");
                                ui.errorMsg.fadeOut();
                            }); // submit form
                            ui.formId.submit(function (e) {
                                e.preventDefault(); // validation code
                                var validEmail = regexEmail.test(ui.textbox.val());
                                if (!validEmail) {
                                    // error state
                                    ui.formId.addClass("has-error");
                                    ui.errorMsg.fadeIn();
                                } else {
                                    // success state
                                    if (typeof zaius !== "undefined") {
                                        zaius.subscribe(
                                            { list_id: "newsletter", email: ui.textbox.val() }, // success state
                                            function () {
                                                ui.formId.fadeOut(function () {
                                                    ui.successMsg.fadeIn();
                                                });
                                            }, // fail state
                                            function (error) {
                                                console.log(error);
                                            }
                                        );
                                    }
                                }
                            });
                        }
                    }
                    Newsletter.prototype = _.assignIn({}, Newsletter.prototype, {});
                    return Newsletter;
                })();
            },
            {},
        ],
        29: [
            function (require, module, exports) {
                require("../snippets/product-form.js");
                require("../snippets/product-gallery.js");
                require("../snippets/product-gallery-mobile.js");
                /*============================================================================
    ONLY SHOW THOSE IMAGES WHOSE COLOR IN SWATCH HAS BEEN SELECTED
============================================================================*/ 
                theme.showSelectedSwatchProdImages = function () {
                    if ($(".template-product").length > 0) {
                        // This is for initial page load
                        if ($(window).width() > 767) {
                            $("#product-photos .thumbnail-inner").find(".product-thumbnail").addClass("show").show();
                            $("#product-photos .thumbnail-inner").find(".product-thumbnail.show:first-child").addClass("selected"); // For only showing product images of selected color
                            $(".product-main-images .product-image-container").find(".product-main-image").addClass("show").show();
                            $(".product-main-images .product-image-container").find(".product-main-image.show:first-child").addClass("selected");
                        } // For mobile
                        else {
                            // For only showing product images of selected color
                            $("#mobile-product-photos").find(".mthumb").show();
                            theme.ProductGalleryMobile(Events);
                        }
                    }
                }; // PRODUCT COMPONENT
                theme.Product = (function () {
                    function Product(container) {
                        var ui = {
                            sizeChartPopup: $("#size-chart--popup"),
                            freeShippingAccordionHeader: $("#free-shipping--accordion-header"),
                            freeShippingAccordionContent: $("#free-shipping--accordion-content"),
                            descriptionMobileTrigger: $("#product-description--mobile-dropdown-trigger"),
                            descriptionMobileContent: $("#product-description--mobile-dropdown"),
                            campaignVideoTrigger: $(".campaign-video--trigger"),
                        };
                        container.querySelectorAll("[data-product-gallery]").forEach(function (context) {
                            theme.ProductGallery(context, Events);
                        });
                        container.querySelectorAll("[data-product-form]").forEach(function (context) {
                            theme.ProductForm(context, Events);
                        }); // UPDATE : Fire on layout height changes to update sticky calculations
                        function updateUi() {
                            stickyUtils.refresh();
                        }
                        Events.on("product:updateUi", updateUi); // BADGES : BUILD : Method to build react-badges component on collection updates (rebuilt in JS)
                        var buildBadges = require("../react-components/badges/BadgeParent.js");
                        $(document).ready(function () {
                            // BADGES : Generate badge in div slot if present
                            buildBadges(); // FREE SHIPPING : Accordion
                            if (ui.freeShippingAccordionContent.length > 0) {
                                ui.freeShippingAccordionHeader.click(function () {
                                    ui.freeShippingAccordionHeader.toggleClass("open");
                                    ui.freeShippingAccordionContent.slideToggle(250);
                                });
                            } // DESCRIPTION : Accordion
                            if (ui.descriptionMobileContent.length > 0) {
                                ui.descriptionMobileTrigger.click(function () {
                                    ui.descriptionMobileTrigger.toggleClass("open");
                                    ui.descriptionMobileContent.slideToggle(350);
                                });
                            } // CAMPAIGN VIDEO
                            if (ui.campaignVideoTrigger.length > 0) {
                                ui.campaignVideoTrigger.fancybox({ width: 900, height: 506, padding: 0, aspectRatio: true, helpers: { media: true, overlay: { locked: false } } });
                            } // SIZE CHART
                            if (ui.sizeChartPopup.length > 0) {
                                var size_chart_type = ui.sizeChartPopup.data("size-chart-type");
                                if (size_chart_type != "all") {
                                    ui.sizeChartPopup.find(".size-chart--wrapper").hide();
                                    ui.sizeChartPopup.find("#size-chart--" + size_chart_type).show();
                                }
                            }
                        });
                    }
                    Product.prototype = _.assignIn({}, Product.prototype, {});
                    return Product;
                })();
                Events.on("quickview:load", function (container) {
                    theme.Product(container);
                }); // Check if size and color is selected or not
                theme.checkOptionSelection = function () {
                    if ($(".template-product").length > 0) {
                        var checkSelected = function checkSelected(e) {
                            if (!$(".swatch.size").find(".swatch-element input").is(":checked") && $(".swatch.size").length > 0) {
                                $(element).prev(".size-error-msg").fadeIn();
                                e.preventDefault();
                                return false;
                            }
                        };
                        var element = $("#product-add .AddtoCart");
                        $("#product-add .AddtoCart").click(function (e) {
                            checkSelected(e);
                        });
                        $(".swatch.size label").click(function (e) {
                            $(element).prev(".size-error-msg").fadeOut();
                        });
                    }
                };
                /*============================================================================
    CHECK IF ELEMENT IS IN VIEWPORT : Element to be checked, fullyInView
    set to true if we want true only when element is fully visible in view,
    offsetMarginBottom and offsetMarginTop are the cutoff which if you want 
    to set to make element visible before its actual end or start
==============================================================================*/ theme.isElementInView = function (
                    element,
                    fullyInView,
                    offsetMargin
                ) {
                    var pageTop = $(window).scrollTop();
                    var pageBottom = pageTop + $(window).height();
                    var elementTop = $(element).offset().top;
                    var elementBottom = elementTop + $(element).height();
                    if (typeof offsetMargin == "undefined") {
                        offsetMargin = { marginTop: 0, marginBottom: 0 };
                    } else {
                        if (typeof offsetMargin.marginTop == "undefined") {
                            offsetMargin.marginTop = 0;
                        } else if (typeof offsetMargin.marginBottom == "undefined") {
                            offsetMargin.marginBottom = 0;
                        }
                    }
                    if (fullyInView === true) {
                        return pageTop < elementTop && pageBottom > elementBottom;
                    } else {
                        return elementTop + offsetMargin.marginTop <= pageBottom && elementBottom - offsetMargin.marginBottom >= pageTop;
                    }
                }; // Make the right section and left image thumbnails sticky until main images scroll
                theme.stickySidebar;
                theme.stickySidebarDrawerObserver;
                theme.refreshStickySidebar = function () {
                    var refresh = function refresh() {
                        if (theme.stickySidebar && typeof theme.stickySidebar.updateSticky === "function") {
                            theme.stickySidebar.updateSticky({type: "resize"});
                        }
                    };
                    if (window.requestAnimationFrame) {
                        window.requestAnimationFrame(refresh);
                    } else {
                        setTimeout(refresh, 0);
                    }
                };
                theme.makeStickySideColumns = function () {
                    var galleryDisplayMode = $("#product-photos").attr("data-gallery-display-mode");
                    if (galleryDisplayMode === "sticky_list") {
                        var resizeId;
                        var isCartDrawerOpen = function isCartDrawerOpen() {
                            return $("body").hasClass("js-drawer-open-right") || $("html").hasClass("js-drawer-open-right");
                        };
                        var destroyStickySidebar = function destroyStickySidebar() {
                            if (theme.stickySidebar) {
                                theme.stickySidebar.destroy();
                                theme.stickySidebar = null;
                            }
                        };
                        $(window).resize(function () {
                            clearTimeout(resizeId);
                            resizeId = setTimeout(doneResizing, 500);
                        });

                        function doneResizing() {
                            function stickdescription() {
                                if ($('#product-right').length) {
                                    if (window.matchMedia('(min-width: 768px)').matches && !isCartDrawerOpen()) {
                                        destroyStickySidebar();
                                        theme.stickySidebar = new StickySidebar('#product-right', {topSpacing: 80});
                                    } else {
                                        destroyStickySidebar();
                                    }
                                }
                            }
                            stickdescription();
                        }

                        if (!theme.stickySidebarDrawerObserver && window.MutationObserver) {
                            theme.stickySidebarDrawerObserver = new MutationObserver(function () {
                                clearTimeout(resizeId);
                                resizeId = setTimeout(doneResizing, 50);
                            });
                            if (document.documentElement) {
                                theme.stickySidebarDrawerObserver.observe(document.documentElement, {attributes: true, attributeFilter: ["class"]});
                            }
                            if (document.body) {
                                theme.stickySidebarDrawerObserver.observe(document.body, {attributes: true, attributeFilter: ["class"]});
                            }
                        }

                        doneResizing();
                    }
                    if ($(window).width() > 768 && $(".template-product").length > 0) {
                        /*var galleryDisplayMode = $("#product-photos").attr("data-gallery-display-mode");
                        var _stickyUtils = theme.utils.stickyUtils;
                        if (galleryDisplayMode === "sticky_list") {
                            // GALLERY MODE : Sticky Elements Init
                            //_stickyUtils.attach("#product-description", ".product-details--top", 100, 768);
                            //_stickyUtils.attach(".thumbnail-inner", ".product-details--top", 100); // hides on mobile, doesn't need sticky breakpoint prop
                        }*/
                        var element = $("#product-photos .product-main-images");
                        $(window).scroll(function () {
                            // To change visible image thumbnail active on scroll of images
                            var thumbnails = $("#product-photos .thumbnail-inner").find(".product-thumbnail.show");
                            var imagesArr = $(element).find(".product-main-image.show");
                            imagesArr.map(function (index, data) {
                                var el = $(data);
                                var activeImageMargin = { marginTop: el.outerHeight() * 0.4, marginBottom: el.outerHeight() * 0.4 };
                                var isVisible = theme.isElementInView(el, false, activeImageMargin);
                                if (isVisible) {
                                    $(imagesArr).removeClass("selected");
                                    $(el).addClass("selected");
                                    var id = el.data("image-id");
                                    var activeThumbnail = $(thumbnails).filter(".product-thumbnail.show[data-image-id=" + id + "]");
                                    $(thumbnails).removeClass("selected");
                                    $(activeThumbnail).addClass("selected");
                                }
                            });
                        });
                    }
                };
                theme.refreshStickySize = function () {
                    var stickyUtils = theme.utils.stickyUtils; // Timeout just to allow form open and close animation to complete
                    setTimeout(function () {
                        stickyUtils.refresh(); // Recalc sticky nodes
                        if (theme.refreshStickySidebar) {
                            theme.refreshStickySidebar();
                        }
                    }, 500);
                }; // Show review count next to name and
                theme.shopifyReview = function () {
                    if ($(".template-product").length > 0) {
                        setTimeout(function () {
                            var $parent = $(".reviews-wrapper .spr-container").find(".spr-summary"); // For Review Badge below title
                            var $parentTop = "";
                            if ($(window).width() < 768) {
                                $parentTop = $(".product--mobile-header .spr-badge .spr-starrating");
                            } else {
                                $parentTop = $("#product-description .spr-badge .spr-starrating");
                            }

                            //$parent.find(".spr-summary-actions").clone().insertAfter($parentTop);
                          
                            /*$parentTop
                                .closest(".spr-badge")
                                .find(".spr-summary-actions a")
                                .click(function () {
                                    theme.refreshStickySize();
                                    $("html, body").animate({ scrollTop: $parent.offset().top }, 300);
                                });*/ // For main reviews section
                            if($('#shopify-product-reviews').length){
                              $('.redirect-review-link').click(function () {
                                  theme.refreshStickySize();
                                  $("html, body").animate({ scrollTop: $('.reviews-wrapper').find('.review-title').offset().top - 80 }, 300);
                              });
                            }
                            var $target = $(".reviews-wrapper .spr-container").find(".spr-header-title");
                            $parent.find(".spr-summary-starrating").insertBefore("#shopify-product-reviews");
                            $parent.find(".spr-summary-caption").insertAfter(".spr-header-title");
                        }, 1100);
                    }
                };
                theme.sizeChartClickEvent = function () {
                    $('body').on(
                        'click',
                        '#size-chart--popup .size-chart-header li',
                        function () {
                            $(this).addClass("active").siblings().removeClass("active");
                            var target = $(this).attr("data-target");
                            $(".size-chart-content").find("div").removeClass("active").filter(target).addClass("active");
                        }
                    );
                };
                theme.sizeChartSplitMobile = function () {
                    if ($(".template-product").length > 0 || $(".page-fit-guide-wrapper")) {
                        if ($(window).width() < 767) {
                            var splitTable = function splitTable(original) {
                                original.wrap("<div class='table-wrapper' />");
                                var copy = original.clone();
                                copy.find("td:not(:first-child), th:not(:first-child)").remove();
                                copy.removeClass("responsive");
                                original.closest(".table-wrapper").prepend(copy);
                                copy.wrap("<div class='pinned' />");
                                original.wrap("<div class='scrollable' />");
                            };
                            var updateTables = function updateTables() {
                                $("table.responsive").each(function (i, element) {
                                    splitTable($(element));
                                });
                                return true;
                            };
                            $(window).load(updateTables);
                        }
                    }
                };
                theme.prodDescriptionToggle = function () {
                    if ($(".template-product").length > 0) {
                        var scrollToElement = function scrollToElement(element) {
                            $("html, body").animate({ scrollTop: $(element).offset().top - 100 }, 100);
                        };
                        var $parent = $(".product-desc-wrap");
                        var readMoreBtn = $parent.find(".read-more-link");
                        var showLessBtn = $parent.find(".show-less-link");
                        var descTop = $parent.find(".product-desc");
                        var descriptionContent = $parent.find(".product-description-content");
                        var heightThreshold = 130;
                        var resizeId;
                        var updateDescriptionToggle = function updateDescriptionToggle() {
                            if (!descriptionContent.length || $(window).width() >= 768) {
                                descriptionContent.addClass("trimmed-text");
                                $(descTop).removeClass("active");
                                $(readMoreBtn).hide();
                                $(showLessBtn).hide();
                                return;
                            }
                            if (descriptionContent.outerHeight() < heightThreshold) {
                                $(readMoreBtn).hide();
                                $(showLessBtn).hide();
                            } else if (descriptionContent.hasClass("trimmed-text")) {
                                $(readMoreBtn).show();
                                $(showLessBtn).hide();
                            } else {
                                $(readMoreBtn).hide();
                                $(showLessBtn).show();
                            }
                        };
                        // Read more button click
                        $(readMoreBtn).off("click.prodDescriptionToggle").on("click.prodDescriptionToggle", function () {
                            descriptionContent.removeClass("trimmed-text");
                            $(descTop).addClass("active");
                            $(readMoreBtn).hide();
                            $(showLessBtn).show();
                            theme.refreshStickySize();
                            scrollToElement(descTop);
                        }); // Show less button click
                        $(showLessBtn).off("click.prodDescriptionToggle").on("click.prodDescriptionToggle", function () {
                            descriptionContent.addClass("trimmed-text");
                            $(showLessBtn).hide();
                            $(readMoreBtn).show();
                            $(descTop).removeClass("active");
                            theme.refreshStickySize();
                            scrollToElement(descTop);
                        });
                        $(window).off("resize.prodDescriptionToggle").on("resize.prodDescriptionToggle", function () {
                            clearTimeout(resizeId);
                            resizeId = setTimeout(updateDescriptionToggle, 150);
                        });
                        updateDescriptionToggle();
                    }
                };
                theme.breadcrumbsPos = function () {
                    if ($(".template-product").length > 0 && $(window).width() > 767) {
                        var calcPos = function calcPos() {
                            $("#breadcrumb").css({ marginRight: $(".product-thumbnail").offset().left, marginLeft: $(".product-thumbnail").offset().left });
                        };
                        calcPos();
                        $(window).resize(function () {
                            calcPos();
                        });
                    }
                };
                theme.initImageZoom = function () {
                    const $template = $(".template-product");
                    const $gallery = $(".product-main-images");
                  
                    if (!$template.length || !$gallery.hasClass("show-zoom")) return;
                  
                    // Wait until product images exist
                    const waitForImages = () => {
                      const $images = $(".product-main-image img");
                      if ($images.length === 0) {
                        requestAnimationFrame(waitForImages);
                        return;
                      }
                  
                      // Remove previous click handlers to prevent duplicates
                      $(".product-fancybox").off("click");
                      $(".product-main-image").off("click");
                  
                      // Disable fancybox click
                      $(".product-fancybox").on("click", function (e) {
                        e.preventDefault();
                      });
                  
                      // Attach new zoom click logic
                      $(".product-main-image").on("click", function (e) {
                        const $target = $(e.currentTarget).find("img.zoomImg");
                        if ($target.length === 0) {
                          document.querySelectorAll("[data-product-gallery]").forEach((context, index) => {
                            const imgId = e.currentTarget?.dataset.imageId || null;
                            theme.zoom(context);
                            theme.isZooming = true;
                            if (index === 0) theme.elIndex = imgId;
                          });
                        }
                      });
                  
                      console.log("✅ theme.initImageZoom: handlers attached");
                    };
                  
                    waitForImages();
                };
                  
                /*============================================================================
    QUICK VIEW MODAL : Use Fancybox to Ajax in product quick view template
==============================================================================*/ $(
                    document
                ).ready(function () {
                    theme.breadcrumbsPos();
                    theme.showSelectedSwatchProdImages();
                    theme.checkOptionSelection();
                    theme.initImageZoom();
                    theme.sizeChartClickEvent();
                    theme.sizeChartSplitMobile();
                    theme.prodDescriptionToggle(); // Call Fancybox for product modal + stop scroll to top
                    $(".product-modal").fancybox({
                        padding: 0,
                        margin: 0,
                        transitionIn: "fade",
                        afterShow: function afterShow() {
                            var container = document.querySelector("#product-quick-view");
                            Events.trigger("quickview:load", container);
                        },
                        wrapCSS: "fancybox-quickview",
                        helpers: { overlay: { locked: false } },
                    });
                });
                $(window).load(function () {
                    theme.makeStickySideColumns();
                    theme.shopifyReview();
                    var stickyUtils = theme.utils.stickyUtils;
                    stickyUtils.refresh(); // Recalc sticky nodes
                });
            },
            { "../react-components/badges/BadgeParent.js": 7, "../snippets/product-form.js": 37, "../snippets/product-gallery-mobile.js": 38, "../snippets/product-gallery.js": 39 },
        ],
        31: [
            function (require, module, exports) {
                /*============================================================================
  Search template
==============================================================================*/ theme.Search = (function () {
                    function Search(container) {
                        var ui = { mobileFilterBtn: "#filter-button-mobile", desktopFilterBtn: "#filter-button-desktop", searchWrap: "#search-template" }; // EVENTS : Bind DOM events when ready
                        $(document).ready(function () {
                            // FILTER MENU : OPEN / CLOSE : Indicator for the whole filter menu (mobile)
                            $(ui.mobileFilterBtn).click(function () {
                                $(ui.searchWrap).toggleClass("filter-open");
                            });
                            $(ui.desktopFilterBtn).on("click", function () {
                                $(ui.searchWrap).toggleClass("filter-open");
                            }); // ATTACH : Apply All event
                            theme.utils.filterUtils.init("#shopify-section-search-template");
                        });
                    }
                    Search.prototype = _.assignIn({}, Search.prototype, {});
                    return Search;
                })();
            },
            {},
        ],
        32: [
            function (require, module, exports) {
                /*============================================================================
  Sections
==============================================================================*/ theme.Sections = function Sections() {
                    this.constructors = {};
                    this.instances = [];
                    $(document)
                        .on("shopify:section:load", this._onSectionLoad.bind(this))
                        .on("shopify:section:unload", this._onSectionUnload.bind(this))
                        .on("shopify:section:select", this._onSelect.bind(this))
                        .on("shopify:section:deselect", this._onDeselect.bind(this))
                        .on("shopify:block:select", this._onBlockSelect.bind(this))
                        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
                };
                theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
                    _createInstance: function _createInstance(container, constructor) {
                        var $container = $(container);
                        var id = $container.attr("data-section-id");
                        var type = $container.attr("data-section-type");
                        constructor = constructor || this.constructors[type];
                        if (_.isUndefined(constructor)) {
                            return;
                        }
                        var instance = _.assignIn(new constructor(container), { id: id, type: type, container: container });
                        this.instances.push(instance);
                    },
                    _onSectionLoad: function _onSectionLoad(evt) {
                        var container = $("[data-section-id]", evt.target)[0];
                        if (container) {
                            this._createInstance(container);
                        }
                    },
                    _onSectionUnload: function _onSectionUnload(evt) {
                        this.instances = _.filter(this.instances, function (instance) {
                            var isEventInstance = instance.id === evt.detail.sectionId;
                            if (isEventInstance) {
                                if (_.isFunction(instance.onUnload)) {
                                    instance.onUnload(evt);
                                }
                            }
                            return !isEventInstance;
                        });
                    },
                    _onSelect: function _onSelect(evt) {
                        // eslint-disable-next-line no-shadow
                        var instance = _.find(this.instances, function (instance) {
                            return instance.id === evt.detail.sectionId;
                        });
                        if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
                            instance.onSelect(evt);
                        }
                    },
                    _onDeselect: function _onDeselect(evt) {
                        // eslint-disable-next-line no-shadow
                        var instance = _.find(this.instances, function (instance) {
                            return instance.id === evt.detail.sectionId;
                        });
                        if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
                            instance.onDeselect(evt);
                        }
                    },
                    _onBlockSelect: function _onBlockSelect(evt) {
                        // eslint-disable-next-line no-shadow
                        var instance = _.find(this.instances, function (instance) {
                            return instance.id === evt.detail.sectionId;
                        });
                        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
                            instance.onBlockSelect(evt);
                        }
                    },
                    _onBlockDeselect: function _onBlockDeselect(evt) {
                        // eslint-disable-next-line no-shadow
                        var instance = _.find(this.instances, function (instance) {
                            return instance.id === evt.detail.sectionId;
                        });
                        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
                            instance.onBlockDeselect(evt);
                        }
                    },
                    register: function register(type, constructor) {
                        this.constructors[type] = constructor;
                        $("[data-section-type=" + type + "]").each(
                            function (index, container) {
                                this._createInstance(container, constructor);
                            }.bind(this)
                        );
                    },
                });
            },
            {},
        ],
        33: [
            function (require, module, exports) {
                /*============================================================================
  Slideshow on index
==============================================================================*/ theme.Slideshow = (function () {
                    function Slideshow(container) {
                        var $container = (this.$container = $(container)),
                            sectionId = $container.attr("data-section-id"),
                            $flexslider = $container.find(".flexslider"),
                            $sliderNav = $flexslider.next(".slider--nav"),
                            speed = $flexslider.data("speed");
                        $flexslider.flexslider({
                            animation: "fade",
                            slideshowSpeed: speed,
                            animationSpeed: 600,
                            controlNav: true,
                            pauseOnHover: true,
                            pauseOnAction: true,
                            customDirectionNav: $(".slider--nav > a"),
                            directionNav: false,
                            smoothHeight: false,
                            /* adds a custom pagination */ start: function start(slider) {
                                $sliderNav.find(".flexslider--current-slide").text(slider.currentSlide + 1);
                                $sliderNav.find(".flexslider--total-slides").text(slider.count);
                            },
                            before: function before(slider) {
                                $sliderNav.find(".flexslider--current-slide").text(slider.animatingTo + 1);
                            },
                            start: function(slider){
                              $('ul.slides').addClass('loaded-slider');
                              positionSliderDots();
                            }
                        }); // get box ratio's height since it is available immediately to calculate slider dot position
                        function positionSliderDots() {
                            var firstSlideImgHeight = $flexslider.find("ul li.flex-active-slide .box-ratio").outerHeight();
                            var $flexSlideControlNav = $flexslider.find(".flex-control-nav");
                            if ($(window).width() < 768 && $flexSlideControlNav.length) {
                                var h = firstSlideImgHeight + 20;
                                $flexSlideControlNav.css("top", h + "px");
                            } else if ($(window).width() >= 768 && $flexSlideControlNav.length) {
                                $flexSlideControlNav.css("top", "");
                            }
                        }
                        positionSliderDots();
                        $(window).on("resize", positionSliderDots);
                    }
                    return Slideshow;
                })();
                theme.Slideshow.prototype = _.assignIn({}, theme.Slideshow.prototype, {
                    onBlockSelect: function onBlockSelect(event) {
                        // Ignore the cloned version
                        var Slider = $(event.target).closest(".flexslider").data("flexslider");
                        var $slide = $(event.target);
                        var slideIndex = $slide.data("flexslider-index"); // Go to selected slide, pause autoplay
                        Slider.flexslider(slideIndex);
                        Slider.flexslider("pause");
                    },
                    onBlockDeselect: function onBlockDeselect() {
                        var Slider = $(event.target).closest(".flexslider").data("flexslider"); // Resume autoplay
                        Slider.flexslider("play");
                    },
                });
            },
            {},
        ],
        34: [
            function (require, module, exports) {
                /*============================================================================
  Testimonials on index
==============================================================================*/ theme.Testimonials = (function () {
                    function Testimonials(container) {
                        var initTestimonials = function initTestimonials(Testimonialcarousel) {
                            Testimonialcarousel.owlCarousel({
                                itemsCustom: [
                                    [0, 1],
                                    [450, 1],
                                    [600, 1],
                                    [700, 1],
                                    [1000, 2],
                                    [1200, 3],
                                    [1400, 3],
                                    [1600, 3],
                                ],
                                navigation: false,
                                pagination: true,
                            }); // Custom Navigation Events
                            $(".next").click(function () {
                                owl.trigger("owl.next");
                            });
                            $(".prev").click(function () {
                                owl.trigger("owl.prev");
                            });
                        };
                        initTestimonials($(".testimonial-container"));
                        $(document).on("shopify:section:unload", function (event) {
                            var target = $(event.target);
                            target.find(".testimonial-container").owlCarousel("destroy");
                            $(document).off(".testimonial-container");
                        });
                        $(document).on("shopify:section:load", function (event) {
                            initTestimonials($(event.target).find(".testimonial-container"));
                        });
                    }
                    Testimonials.prototype = _.assignIn({}, Testimonials.prototype, {});
                    return Testimonials;
                })();
            },
            {},
        ],
        35: [
            function (require, module, exports) {
                /*============================================================================
 Cookie Banner
==============================================================================*/ function setGDPRCookie() {
                    // close the button
                    $(".cc-window .cc-dismiss").click(function () {
                        $.cookie("gdpr_banner_read", "true", { path: "/", expires: 180 });
                    }); // accept button click
                    $(".cc-window .cc-allow").click(function () {
                        $.cookie("gdpr_banner_read", "true", { path: "/", expires: 180 }); // make the cookie, expires in 180 days
                    });
                }
                $(window).load(function () {
                    (function cookie_banner() {
                        // check the cookie
                        var check_banner_cookie = $.cookie("gdpr_banner_read");
                        if (!check_banner_cookie) {
                            var hasCookieConsentLoaded = false;
                            var interval = setInterval(function () {
                                if ($(".cc-window").length > 0) {
                                    hasCookieConsentLoaded = true;
                                }
                                if (hasCookieConsentLoaded) {
                                    setGDPRCookie();
                                    clearInterval(interval);
                                }
                            }, 500);
                        }
                    })();
                });
            },
            {},
        ],
        36: [
            function (require, module, exports) {
                /*============================================================================
 Email Popup
==============================================================================*/ $(document).ready(function () {
                    (function email_popup() {
                        // SETUP : Config
                        var emailPopupDelay = 5000; // in ms (5000 = 5s)
                        if (window.emailPopupDelayTime) {
                            // load from settings_schema
                            emailPopupDelay = parseInt(window.emailPopupDelayTime) * 1000;
                        }
                        if (window.emailPopupDelayTimeManual) {
                            // load from settings_schema
                            emailPopupDelayTimeManual = parseInt(window.emailPopupDelayTimeManual) * 1000;
                        } // COOKIES : Check cookies (including GDPR)
                        var check_popup_cookie = $.cookie("mailing_list_delay_popup"); // var check_banner_cookie = $.cookie('gdpr_banner_read');
                        // by default, the cookie banner will popup first. once the user hits "accept", then load the newsletter.
                        // the newsletter is set to popup again after 7 days. though the cookie banner has already been read,
                        if (!check_popup_cookie) {
                            setTimeout(function () {
                                theme.utils.emailUtils.email_popup_load();
                            }, emailPopupDelay);
                        }
                        var pageQueryStr = window.location.search.substring(1);
                        var popupCount = pageQueryStr.split("=");
                        if (popupCount[0] === "popup" && popupCount[1] === "1") {
                            setTimeout(function () {
                                theme.utils.emailUtils.email_popup_load();
                            }, emailPopupDelayTimeManual);
                        }
                    })();
                });
            },
            {},
        ],
        37: [
            function (require, module, exports) {
                theme.ProductForm = function (context, events) {
                    var backInStock = require("../react-components/back-in-stock/BackInStockParent.js");
                    var LowStock = require("../react-components/low-stock/LowStockParent.js");
                    var $context = $(context);
                    var config = JSON.parse(context.dataset.productForm || "{}");
                    var product = window.Shopify.productObj || {};
                    var optionsCount = product && product.options && product.options.length;
                    var _theme$utils = theme.utils,
                        productUtils = _theme$utils.productUtils,
                        stickyUtils = _theme$utils.stickyUtils,
                        preOrderUtils = _theme$utils.preOrderUtils;
                    var mainOptInfo = { available: false, name: "color", position: 0, optName: "option1" }; // SAFETY : If no variants / missing config, skip render as it will crash page
                    if (!product || !product.variants || !config) {
                        return false;
                    } // UI : Cache DOM Nodes
                    var ui = {
                        comparePrice: context.querySelector(".was"),
                        descriptions: document.querySelectorAll(".content-description, .product-description-content"),
                        details: document.querySelectorAll(".content-details"),
                        floatingAdd: $("#floating-add"),
                        inlineAdd: document.querySelector(".add:not(.product--mobile-header--add)"),
                        price: context.querySelector(".product-price .money") || context.querySelector(".product-price"),
                        priceMobile: document.querySelector("#product-price--mobile .product-price .money"),
                        priceWrap: context.querySelector("#product-price"),
                        skus: document.querySelectorAll(".product-sku"),
                        skuStyle: document.querySelectorAll(".product-style"),
                        smartPayment: context.querySelector(".shopify-payment-button"),
                        titles: document.querySelectorAll(".product-title-content"),
                    };
                    checkIsColorBasedProduct(); // DISPLAY MODE : Swatches or Dropdowns?
                    var optionDisplayMode = config.variant_display_type;
                    if (optionDisplayMode === "swatches") {
                        swatches();
                    } else {
                        dropdowns();
                    } // DATA LISTENERS : Attach all product datapoint listeners to 'variantchange' event + set initial landing data
                    attachInfoListeners();
                    setInitialData();
                    /* check if this product is colorbased.
                     * -------------------------------------------- */ function checkIsColorBasedProduct() {
                        if (product && product.options && product.options.length) {
                            var opt1Name = product.options[0].toLowerCase();
                            if (opt1Name === "color" || opt1Name === "colour") {
                                mainOptInfo.available = true;
                            }
                        }
                    }
                    /* OPTION MODE : SWATCHES (color, size, etc)
                     * -------------------------------------------- */ function swatches() {
                        // INIT : Seed Selected Options : Finds selected options for each option slot and stores into state
                        function initSwatches() {
                            var selections = document.querySelectorAll(".swatch input:checked");
                            var selectedOptions = {};
                            if (selections && selections.length > 0) {
                                selections.forEach(function (selection) {
                                    var value = selection.getAttribute("value");
                                    var optionPosition = selection.getAttribute("option-position");
                                    if (!value || !optionPosition) {
                                        var missingProp = !value ? "value" : "option-position";
                                        console.log("ERROR : [ ProductForm - swatches() ] -- Selected swatches are missing the attribute ".concat(missingProp, ", please add it (Note: Shouldn't have data- prefix)."));
                                    } // SET : Set the selected option value
                                    selectedOptions["option".concat(optionPosition)] = value;
                                });
                            } // STORE : Init productUtils w/ selectedOptions + Ensure proper URL handle
                            productUtils.init(product, selectedOptions);
                            var nearestVariant = productUtils.findNearestVariant();
                            productUtils.updateUrlHandle(nearestVariant);
                        } // START! : Initalize productUtils states + each swatch via the 'Swatch' constructor
                        initSwatches();
                        var swatches = context.querySelectorAll("[type=radio]") || []; //safety
                        swatches.forEach(Swatch); // update button color, button text, some details by preorder information
                        function updateProductDetailByPreOrder(variant) {
                            if (preOrderUtils.checkVariant(variant, preOrderProductInfo)) {
                                var availabilityMsg = preOrderUtils.getAvailabilityMsg(variant, preOrderProductInfo, preOrderShopInfo);
                                var estimatedArrivalDate = preOrderUtils.getEstimatedArrivalDate(variant, preOrderProductInfo);
                                var estimatedArrivalDateTxt = estimatedArrivalDate ? "Estimated Delivery: " + estimatedArrivalDate : "";
                                if ($("#preorder_details").length) {
                                    // $('#preorder_availability_message').text(estimatedArrivalDateTxt);
                                    $("#preorder_variant_availability_msg").val(estimatedArrivalDate);
                                    $("#preorder_estimated_arrival_date").text(estimatedArrivalDateTxt); // $('#preorder_variant_estimated_date').val(estimatedArrivalDate);
                                } else {
                                    $("#AddToCartForm .preorder-details").append(
                                        '<div id="preorder_details">' +
                                            '<input type="hidden" id="is_preorder_variant" name="properties[preorder_variant_private]" value="true">' +
                                            '<input type="hidden" id="preorder_variant_availability_msg" name="properties[Estimated Delivery]" value="' +
                                            estimatedArrivalDate +
                                            '">' +
                                            (estimatedArrivalDateTxt ? '<span id="preorder_estimated_arrival_date">' + estimatedArrivalDateTxt + "</span>" : "") +
                                            "</div>"
                                    );
                                }
                                if (preOrderUtils.getPreOrderBtnColor(preOrderShopInfo)) {
                                    $("input.AddtoCart").css("background-color", preOrderUtils.getPreOrderBtnColor(preOrderShopInfo));
                                }
                            } else {
                                if ($("#preorder_details").length) {
                                    $("#preorder_details").remove();
                                }
                                $("input.AddtoCart").css("background-color", "");
                            }
                        } // UTIL : SWATCH EVENTS + FUNCTIONALITY
                        function Swatch(element) {
                            if (!element) {
                                // SAFETY CHECK
                                console.log("* Error : [ProductForm -- Swatch()] : Element was not passed, cannot build swatch controls on non-existent elements");
                                return false;
                            } // SETUP : Properties for swatch interaction
                            var optionList = ["option1", "option2", "option3"];
                            var optionName = element.getAttribute("name"); // NOTE: Option name lowercased in liquid
                            var optionPosition = element.getAttribute("option-position");
                            var otherOptions = optionList.filter(function (option) {
                                return option !== "option".concat(optionPosition);
                            }); // SAFETY : If values are missing, someone has pulled these from the template
                            if (!optionName || !optionPosition) {
                                var missingProp = optionName ? '"name"' : '"option-position"';
                                console.log("ERROR : [Theme.js : Product Form - Swatch() ] -- Swatch elements are missing the property " + missingProp + "\n    --> Unable to generate swatch controls.");
                            } // EVENT LISTENER : CHANGE : When swatch changes occur, update to reflect newly selected option data
                            element.addEventListener("change", function (event) {
                                // STATE : Update state with newly user-selected option
                                productUtils.updateSelectedOption(optionPosition, element.value); // UPDATE : Reflect the new state within the form data
                                updateSwatchState();
                            }); // SWATCH - UTIL : UPDATE FORM DATA : Updates swatch selection text, sets swatch as checked, and updates hidden Variant ID input when relevant.
                            function updateSwatchState() {
                                var ui = { optionDisplay: element.closest(".swatch").querySelector(".current-option"), selectedVariantInput: document.querySelector("#selected-variant-id") }; // FIND : CURRENT VARIANT : Merged PDP templates can contain various combos of option data, ensures right variant being emitted
                                var nearestVariant = productUtils.findNearestVariant();
                                console.log(productUtils);
                                console.log(nearestVariant);
                                var exactVariant = productUtils.findExactVariant(); // UPDATE : SELECTED OPTION TEXT : Show the name of which option is currently selected
                                if (ui.optionDisplay) {
                                    ui.optionDisplay.innerHTML = element.value;
                                } // UPDATE : If the selected option is not available, show 'sold out' label in size option value
                                var set_available = false;
                                if (exactVariant !== undefined || nearestVariant !== undefined) {
                                    set_available = true;
                                    var currentSizeOpt = $(".swatch.size .current-option");
                                    if (exactVariant && !exactVariant.available) {
                                        currentSizeOpt.text("Sold out");
                                    } else {
                                        currentSizeOpt.text($(".swatch.size input:checked").val());
                                    }
                                } // UPDATE : CHECK SWATCH : Mark Swatch element as "checked" for submit action to scrape
                                element.checked = true; // UPDATE : VARIANT ID : Update the hidden input that tells addToCart which variant ID is selected currently
                                if (ui.selectedVariantInput && exactVariant) {
                                    ui.selectedVariantInput.value = exactVariant.id; // check if this variant is preorder one
                                    updateProductDetailByPreOrder(exactVariant);
                                } // UPDATE : AVAILABILITY + URL : Reflect new item availabilities and update the URL for the current selection
                                
                                productUtils.updateUrlHandle(nearestVariant); // UPDATE : BROADCAST CHANGE EVENTS : Broadcasts the event to various listener functions across the theme watching the product form (Most are the functions defined below though)
                                events.trigger("variantchange", nearestVariant || {}); // Uses NEAREST Variant - Feeds: price / sku handlers (so we don't show blank prices in merge templates)
                                events.trigger("variantchange:".concat(optionName), element.value); // Uses Selected Option - Feeds: Image filtering handler (only listens for color so we don't filter every time we change size)
                                events.trigger("variantchange:precise", exactVariant); // Uses EXACT Variant --- Feeds: 'add_to_cart', null if not found (Merge sees cases with size 6, but doesn't exist in chosen color)
                                
                            } // init swatches on loading page
                        }
                    }
                    /* OPTION MODE : DROPDOWN SELECTORS
                     *  - NOTE, this will probably need some work if a brand wants to use this, it wasn't refactored with the swatch setup
                     * ---------------------------------- */ function dropdowns() {
                        var elements = context.querySelectorAll("[type=radio]") || []; //safety
                        // DROPDOWN : Util - Unavailable Handler : 'variantunavailable' triggered when the variant object isn't found during a change
                        function set_unavailable() {
                            var selected = {};
                            var selected_elements = $(elements).filter(":checked").toArray();
                            selected_elements.forEach(function (element) {
                                var option = "option" + element.getAttribute("option-position");
                                var value = element.value;
                                selected[option] = value;
                            });
                            elements.forEach(function (element) {
                                var available = false;
                                var current_option = "option" + element.getAttribute("option-position");
                                var current_value = element.value;
                                var other_options = ["option1", "option2", "option3"].filter(function (option) {
                                    return selected[option] && option != current_option;
                                });
                                product.variants.forEach(function (variant) {
                                    if (!variant.available) {
                                        return;
                                    }
                                    if (variant[current_option] != current_value) {
                                        return;
                                    }
                                    if (variant[other_options[0]] == selected[other_options[0]] && variant[other_options[1]] == selected[other_options[1]]) {
                                        available = true;
                                        return;
                                    }
                                });
                                if (available) {
                                    states.available(element);
                                } else {
                                    states.sold_out(element);
                                }
                            });
                        }
                        events.on("variantunavailable", set_unavailable); // DROPDOWN : Constructor for selector (dropdown mode only, not used with swatches)
                        new Shopify.OptionSelectors("product-select-" + product.id, {
                            product: product,
                            onVariantSelected: function onVariantSelected(variant, selector) {
                                if (!variant) {
                                    events.trigger("variantunavailable");
                                    return;
                                }
                                if (product.variants.length == 1) {
                                    return;
                                }
                                console.log("onVaraintSelected -- Fired "); // Investigate what this is truly doing..
                                events.trigger("variantchange", variant);
                                events.trigger("variantchange:option1:" + variant.option1);
                                events.trigger("variantchange:option2:" + variant.option2);
                                events.trigger("variantchange:option3:" + variant.option3);
                                if (variant.featured_image) {
                                    events.trigger("variantchange:image", variant.featured_image.id);
                                }
                            },
                            enableHistoryState: config.enable_history,
                        }); // DROPDOWN : Option selection handler
                        (function single_option_selectors() {
                            var elements = context.querySelectorAll(".single-option-selector");
                            elements.forEach(Selector);
                            function Selector(element, index) {
                                var option_position = index + 1;
                                events.on("swatch:change:" + option_position, change);
                                function change(value) {
                                    $(element).val(value).trigger("change");
                                }
                            }
                        })();
                    } // UTIL - INIT CONTENT LISTENERS : Binds given elements to update given property from variant
                    function attachListeners() {
                        var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                        var refresh = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        var event = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "variantchange";
                        elements.forEach(function (el) {
                            events.on(event, function () {
                                var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                if (variant[property]) {
                                    el.innerHTML = variant[property];
                                    if (refresh) {
                                        stickyUtils.refresh(); // Recalc sticky nodes
                                        if (theme.refreshStickySidebar) {
                                            theme.refreshStickySidebar();
                                            setTimeout(theme.refreshStickySidebar, 250);
                                        }
                                        if (property === "description" && theme.prodDescriptionToggle) {
                                            theme.prodDescriptionToggle();
                                        }
                                    }
                                }
                            });
                        });
                    } // Sku Style UTIL - INIT CONTENT LISTENERS : Binds given elements to update given property from variant
                    function attachListenersForSkuStyle() {
                        var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "sku";
                        var refresh = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        var event = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "variantchange";
                        elements.forEach(function (el) {
                            events.on(event, function () {
                                var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                if (variant.sku) {
                                    var splittedSku = variant.sku.split("-");
                                    var skuStyle = variant.sku;
                                    if (splittedSku.length > 1) {
                                        skuStyle = splittedSku[1];
                                    } else {
                                        skuStyle = splittedSku[0];
                                    }
                                    el.innerHTML = skuStyle;
                                }
                            });
                        });
                    } // UTIL : MONEY FORMATTING
                    function money(cents) {
                        if (config.currency_switcher_enabled) {
                            var converted = Currency.convert(cents, defaultCurrency, Currency.currentCurrency);
                            var format = Currency.moneyFormats[Currency.currentCurrency][Currency.format];
                            return Currency.formatMoney(converted, format);
                        } else {
                            return Shopify.formatMoney(cents, config.money_format);
                        }
                    } // UTIL : SET DATA : Takes an array and applies the given string to each items innerHTML
                    function setData() {
                        var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var string = arguments.length > 1 ? arguments[1] : undefined;
                        elements.forEach(function (el) {
                            el.innerHTML = string;
                        });
                    } // ATTACH : ALL DATAPOINTS : Bind product datapoints to update on 'variantchange' events
                    function attachInfoListeners() {
                        attachListeners(ui.skus, "sku");
                        attachListenersForSkuStyle(ui.skuStyle);
                        attachListeners(ui.titles, "title");
                        attachListeners(ui.descriptions, "description", true);
                        attachListeners(ui.details, "details", true);
                        add_to_cart();
                        compare_price();
                        price();
                        smart_payment_buttons();
                    } // DATA : SET INITIAL DATA : liquid "product" is incorrect if landing color is removed by out of stock filtering, fill title/description/details via initial pass
                    function setInitialData() {
                        var landingVariantId = $("#selected-variant-id").val();
                        var landingData = {}; // Fallback in case something breaks product.info flowing in
                        // LANDING DATA : Grab first variant data if all sold out and none selected
                        if (product.info) {
                            landingData = product.info[landingVariantId] ? product.info[landingVariantId] : Object.keys(product.info)[0];
                        }
                        var _landingData = landingData,
                            description = _landingData.description,
                            details = _landingData.details,
                            title = _landingData.title; // FALLBACK : product.info missing somehow, fallback to parent product as data source so something PDP still has labels
                        if (!title) {
                            description = product.description;
                            title = product.title;
                            var descArray = description.split("<!-- split -->");
                            details = descArray[1] || "";
                            description = descArray[0];
                        } // FILL : Apply the data regardless of its source so page isn't empty
                        setData(ui.descriptions, description);
                        setData(ui.details, details);
                        setData(ui.titles, title);
                    } // ITEM : PRICE
                    function price() {
                        if (!ui.price) {
                            return false;
                        }
                        events.on("variantchange", function () {
                            var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            var available = variant.available,
                                featured_image = variant.featured_image,
                                price = variant.price,
                                tags = variant.tags;
                            var displayPrice = price ? money(price) : 0;
                            var isFinalSale = tags
                                ? tags.find(function (tag) {
                                      return tag === "final_sale";
                                  })
                                : false; // var isPreOrder = tags ? tags.find( tag => tag === 'preorder' ) : false;
                            // SOLD OUT : Show "sold Out" if toggle enabled

                            //CT- KLARNA
                            // document.querySelector('klarna-placement').dataset.purchaseAmount = variant.price;
                            // window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });

                          
                            if (!available && config.hide_price_on_unavailable) {
                                displayPrice = config.sold_out;
                            }
                            if (preOrderUtils.checkProduct(preOrderProductInfo)) {
                                displayPrice += '<div class="preorder-text">- Pre-Order</div>';
                            } // FINAL SALE: if tag "final_sale" present, mark as such
                            if (isFinalSale) {
                                displayPrice += '<div class="final-sale-text">- Final Sale</div>'; // Add _final_sale property input to be used by ajax cart
                                if ($("#final-sale-property-flag").length == 0) {
                                    $("#product-add").prepend('<input type="text" id="final-sale-property-flag" value"true" name="properties[_final_sale]" style="display: none !important;"/>');
                                }
                            } else {
                                // Remove _final_sale property input to be used by ajax cart
                                $("#final-sale-property-flag").remove();
                            } // UPDATE : Set new price on DOM Nodelist
                            ui.price.innerHTML = displayPrice;
                            if ($(window).width() < 768) {
                                ui.priceMobile.innerHTML = displayPrice;
                            }
                            if (config.hide_price_on_unavailable) {
                                events.on("variantunavailable", function (variant) {
                                    displayPrice = config.sold_out;
                                    ui.price.innerHTML = displayPrice;
                                });
                            }
                        });
                    } // ITEM : COMPARE AT PRICE
                    function compare_price() {
                        events.on("variantchange", function (variant) {
                            var price = ""; // COMPARE PRICE : If discounted, create the "previous" price, otherwise remove the compare class so price isn't red
                            if (variant.compare_at_price > variant.price) {
                                price = money(variant.compare_at_price).split(".")[0];
                                ui.priceWrap.classList.add("has-compare-price");
                            } else {
                                ui.priceWrap.classList.remove("has-compare-price");
                            }
                            if (ui.comparePrice && ui.comparePrice.length) {
                                ui.comparePrice.innerHTML = '<span class="money bfx-price">' + price + "</span>";
                            }
                        });
                    } // ITEM : ADD TO CART
                    function add_to_cart() {
                        // SWATCH STYLE
                        events.on("variantchange:precise", function (variant) {
                            var selectedOptions = productUtils.getSelectedOptions();
                            var sizeOptionIndex = product.options.findIndex(function (option) {
                                return option.toLowerCase() === "size";
                            });
                            var sizeOptionName = sizeOptionIndex > -1 ? "option".concat(sizeOptionIndex + 1) : null;
                            var text = config.button;
                            var isDisabled = false;

                            // Check if we're on the personalized template

                            var isPersonalizedTemplate = document.body.classList.contains('product-personalized');
           
                            // SOLD OUT : Set Text + Disable button
                            if (!variant || !variant.available) {
                                text = config.sold_out;
                                isDisabled = true;
                            }

                            // PERSONALIZED TEMPLATE: Check options sequentially
                            if (isPersonalizedTemplate && product.options && product.options.length > 2) {
                                for (var i = 0; i < product.options.length; i++) {
                                    var optionKey = "option".concat(i + 1);
                                    if (selectedOptions[optionKey] === null) {
                                        // Check if this option is Size
                                        var isSize = product.options[i].toLowerCase() === "size";
                                        if (isSize) {
                                            text = "Select a Size";
                                        } else {
                                            text = "Select a " + product.options[i];
                                        }
                                        var nearestVariant = productUtils.findNearestVariant();
                                        if (!nearestVariant.available) {
                                            text = config.sold_out;
                                        }
                                        isDisabled = true;
                                        break; // Stop at first unselected option
                                    }
                                }
                            } else {
                                // STANDARD TEMPLATE: SIZE NOT SELECTED : Set Text + Disable Button
                                if (sizeOptionName && selectedOptions[sizeOptionName] === null) {
                                    text = "Select a Size";
                                    isDisabled = true;
                                } else if (product.options && product.options.length > 2) {
                                    var otherOptionIndex = product.options.findIndex(function (option) {
                                        return option.toLowerCase() !== "size" && option !== product.options[0];
                                    });
                                    var otherOptionName = otherOptionIndex > -1 ? "option".concat(otherOptionIndex + 1) : null;
                                    if (otherOptionName && selectedOptions[otherOptionName] === null) {
                                        text = "Select a " + product.options[otherOptionIndex];
                                        isDisabled = true;
                                    }
                                }
                            } 
                            // Pre order: Set Text + preorder button (only if all options selected)
                            if (variant && variant.available && !isDisabled) {
                                // check if preorder is enabled
                                if (preOrderUtils.checkVariant(variant, preOrderProductInfo)) {
                                    text =
                                        (preOrderProductInfo.variants[variant.id] && preOrderProductInfo.variants[variant.id].button_text) ||
                                        preOrderProductInfo.product.preorder_button_text ||
                                        (preOrderShopInfo && preOrderShopInfo.button_text);
                                    isDisabled = false;
                                }
                            } 
                            
                            // APPLY : Form Button
                            var ATCButton = document.querySelector(".add:not(.product--mobile-header--add)");
                            if (ATCButton) {
                                ATCButton.value = text;
                                ATCButton.disabled = isDisabled;
                            } // APPLY : Customily Button
                            var customilyATCButton = document.querySelector("#customily-cart-btn");
                            if (customilyATCButton) {
                                customilyATCButton.textContent = text;
                                customilyATCButton.disabled = isDisabled;
                            } 
                            // APPLY : Mobile Floating Button
                            if (ui.floatingAdd.length) {
                                ui.floatingAdd.text(text);
                                ui.floatingAdd.attr("data-disable", isDisabled);
                            }
                        }); // DROPDOWN STYLE
                        events.on("variantunavailable", function () {
                            var ATCButton = document.querySelector(".add:not(.product--mobile-header--add)");
                            if (ATCButton) {
                                ATCButton.value = config.sold_out;
                                ATCButton.disabled = true;
                            }
                            var customilyATCButton = document.querySelector("#customily-cart-btn");
                            if (customilyATCButton) {
                                customilyATCButton.value = config.sold_out;
                                customilyATCButton.disabled = true;
                            } 
                            if (ui.floatingAdd.length) {
                                ui.floatingAdd.text(config.sold_out);
                                ui.floatingAdd.attr("data-disable", true);
                            }
                        }); // FLOATING BUTTON - CLICK
                        var ATCButton = document.querySelector(".add:not(.product--mobile-header--add)");
                        if (ui.floatingAdd.length && ATCButton) {
                            ui.floatingAdd.on("click", function () {
                                $(ATCButton).click();
                            });
                        }
                    } // ITEM : SMART PAYMENT BUTTONS
                    function smart_payment_buttons() {
                        if (!ui.smartPayment) {
                            return false;
                        }
                        events.on("variantchange:precise", function (variant) {
                            if (!variant || !variant.available) {
                                ui.smartPayment.style.display = "none";
                            } else {
                                ui.smartPayment.style.display = "inline-block";
                            }
                        });
                    }
                    $(function () {
                        function showColorSwatch() {
                            if ($(".swatch.color").length) {
                                setTimeout(function () {
                                    $(".swatch.color").css("visibility", "visible");
                                }, 200);
                            } else {
                                setTimeout(function () {
                                    showColorSwatch();
                                }, 200);
                            }
                        }
                        showColorSwatch();
                    });
                };
            },
            { "../react-components/back-in-stock/BackInStockParent.js": 4, "../react-components/low-stock/LowStockParent.js": 15 },
        ],
        38: [
            function (require, module, exports) {
                theme.ProductGalleryMobile = function (events) {
                    var $slideshow = $("#mobile-product-photos");
                    var dominantOptions = theme.utils.productUtils.getDominantOptions();
                    if (!$slideshow) {
                        return false;
                    }
                    $slideshow.owlCarousel({
                        items: 1,
                        margin: 20,
                        nav: true,
                        navText: [$(".mobile-product-carousel--prev"), $(".mobile-product-carousel--next")],
                        lazyLoad: true,
                        dots: true,
                        center: true,
                        autoHeight: true, // EXTRA PROPERTIES AVAILABLE:
                        //  navigation : true, // Show next and prev buttons
                        //  navigationText: ["",""],
                        //  slideSpeed : 300,
                        //  paginationSpeed : 400,
                        //  singleItem: true,
                        //  pagination: false,
                        //  addClassActive: false
                    });
                    $slideshow.on("changed.owl.carousel", function (event) {
                        events.trigger("productVideo:pauseAll");
                    }); // INITALIZE : SLIDE SELECTION + LISTENERS:
                    dominantOptions.forEach(function (optionName) {
                        var element = $(".swatch-element.".concat(optionName, " input[checked]")); // INITIALIZE : SLIDE SELECTION : trigger the filtering of images based on what dominant options are currently selected
                        if (element.length > 0) {
                            var initValue = element.closest(".swatch-element").data("swatch-value");
                            if (initValue) selectByOption(optionName, initValue);
                        } // INITALIZE : EVENTS : Setup event listeners, updates set of images based on color swatch selected
                        events.on("variantchange:".concat(optionName), function (optionValue) {
                            selectByOption(optionName, optionValue);
                        });
                    }); // UTIL : SELECT SLIDE BY COLOR NAME : Respond to color variant selections to show user that color's images
                    function selectByOption(optionName, optionValue) {
                        // FIND + SELECT : First image with that optionValue name & go to that image slide
                        var firstImg = document.querySelector(".mthumb[data-".concat(optionName, '="').concat(optionValue, '"]'));
                        if (firstImg) {
                            var id = firstImg.getAttribute("data-image-id");
                            if (id) {
                                goToImage(id);
                            } else {
                                console.log('ERROR : [ ProductMobileGallery - selectByOption() ] -- "data-image-id" is missing on the slide item template, unable to parse Image Slide ID.');
                            }
                        }
                    } // UTIL : GO TO IMAGE : Util to move user to first image with that matching dominant option they selected
                    function goToImage(id) {
                        var slides = $slideshow.find("[data-image-id]");
                        var slide = slides.filter('[data-image-id="' + id + '"]');
                        var index = slides.index(slide);
                        $slideshow.trigger("to.owl.carousel", index);
                    }
                };
            },
            {},
        ],
        39: [
            function (require, module, exports) {
                theme.zoom = function (context) {
                    var elements = context.querySelectorAll(".product-main-image");
                    if (!elements) {
                        return false;
                    }
                    /* check to see if the settings for Zoom is on */ var productMainImages = document.querySelector(".product-main-images");
                    if (productMainImages && productMainImages.classList.contains("no-zoom")) {
                        return false;
                    }
                    if (window.matchMedia("(max-width: 740px)").matches) {
                        return false;
                    }
                    /* elemental loop */ elements.forEach(function (element) {
                        /* check to see if element is a video */ if (element.classList.contains("product-video")) {
                            return false;
                        }
                        if (!element.querySelector("img").getAttribute("data-zoom-src")) {
                            return false;
                        }
                        var src = element.querySelector("img"),
                            src = src.getAttribute("data-zoom-src"),
                            src = src.replace("{width}", "1000");
                        $(element).zoom({ magnify: 1, target: ".zoom-box", url: src });
                        $(element).hover(function () {
                            $(".product-gallery-controls").show();
                            $(".product-gallery-controls").hide();
                        }); // ZOOM : CLICK : Zoom in / out on click instead of mouseover
                        $(element).click(function (e) {
                            var zoomImg = $(this).find(".zoomImg");
                            if (zoomImg.length) {
                                var newState = !theme.isZooming; // Enable / disable on click based on current state
                                zoomImg[0].dataset.show = newState;
                                theme.isZooming = newState; // Reverse state to match
                            }
                        }); // ZOOM : MOUSE OUT : Zoom out if user leaves the viewport of the zoom
                        $(element).mouseout(function () {
                            var zoomImg = $(this).find(".zoomImg");
                            if (zoomImg.length) {
                                theme.isZooming = false;
                                zoomImg[0].dataset.show = false;
                            }
                        });
                    });
                };
                theme.ProductGallery = function (context, events) {
                    // VIDEOS : Product Video Module, init( events ) inside a gallery component and it does rest
                    var ProductVideos = require("./product-videos.js");
                    ProductVideos.init(events);
                    (function thumbnails() {
                        var $elements = $(".product-thumbnail", context);
                        if (!$elements.length > 0) {
                            return false;
                        }
                        $elements.on("click", function (event) {
                            event.preventDefault();
                            var id = this.dataset.imageId;
                            selectThumb(id);
                            events.trigger("thumbnail:click", id);
                        });
                        function selectThumb(id) {
                            var image = $elements.filter("[data-image-id=" + id + "]");
                            if (!image.length > 0) {
                                return false;
                            }
                            $elements.removeClass("selected").filter(image).addClass("selected");
                        }
                    })();
                    (function controls() {
                        var thumbs = $(".product-thumbnail"); // find other thumbs
                        $(".next-image").click(function () {
                            var current = thumbs.filter(".selected"); // active thumb
                            var next = thumbs.eq(thumbs.index(current) + 1); // next thumb
                            $(next).trigger("click");
                        });
                        $(".prev-image").click(function () {
                            var current = thumbs.filter(".selected"); // active thumb
                            var previous = thumbs.eq(thumbs.index(current) - 1); // prev thumb
                            $(previous).trigger("click");
                        });
                    })();
                    (function main_images() {
                        var $elements = $(".product-main-image", context);
                        if (!$elements.length) {
                            // None Found = 0 length, thus false
                            return false;
                        }
                        events.on("thumbnail:click", selectMainImg);
                        function scrollToElement(selector) {
                            $("html, body").animate({ scrollTop: $(selector).offset().top - 80 }, 300);
                        }
                        function selectMainImg(id) {
                            var image = $elements.filter(".product-main-image[data-image-id=" + id + "]");
                            if (!image.length) {
                                return false;
                            } else {
                                // prevents scrolling if the page hasn't loaded yet
                                // fixes content bouncing around from scrolling on load
                                // from selecting swatch on page load
                                //if (document.readyState === 'complete') {
                                // diff fix for same issue
                                // if first thumbnail, scroll to top instead of to image
                                // still technically scrolls on page load just don't see it
                                if (image.is(":first-child") || !image.prevAll(".show").length) {
                                    scrollToElement($("body"));
                                } else {
                                    scrollToElement(image);
                                }
                            }
                            $elements.removeClass("selected");
                            $(image).addClass("selected");
                        }
                    })();
                    (function thumbnail_slider() {
                        // UTIL : Creates thumbnail slider with proper event listeners attached
                        var initThumbSlider = function initThumbSlider(prodSlideshow) {
                            var slider_type = $("#thumbnail-gallery").attr("data-slider-type");
                            var $slideshow = $(prodSlideshow);
                            var dominantOptions = theme.utils.productUtils.getDominantOptions(); // Option Names to update image filtering for when user selects a different one
                            // INITALIZE : Declare initial config / start image gallery
                            if (slider_type == "bottom") {
                                $slideshow.owlCarousel({
                                    navigation: true, // Show next and prev buttons
                                    navigationText: ["", ""],
                                    slideSpeed: 300,
                                    paginationSpeed: 400,
                                    singleItem: false,
                                    pagination: false,
                                    lazyLoad: true,
                                    responsive: true,
                                    addClassActive: false,
                                });
                            } else {
                                $slideshow.slick({
                                    vertical: true,
                                    arrows: false,
                                    rows: 0, // 'slickFilter' will NOT WORK without this, since 1.8.0 been a bug with nesting divs it generates
                                    verticalSwiping: true,
                                    slidesToShow: 7,
                                    slidesToScroll: 1,
                                    slide: ".product-thumbnail",
                                });
                            } // INITALIZE : FILTER + LISTENERS : Iterate Dominant Options & initialize
                            dominantOptions.forEach(function (optionName) {
                                var element = $(".swatch-element.".concat(optionName, " input[checked]")); // INITIALIZE : FILTER : trigger the filtering of images based on what dominant options are currently selected
                                if (element.length > 0) {
                                    var initValue = element.closest(".swatch-element").data("swatch-value");
                                    if (initValue) filterImages(optionName, initValue);
                                } // INITALIZE : EVENTS : Setup event listeners, updates set of images based on color swatch selected
                                events.on("variantchange:".concat(optionName), function (value) {
                                    filterImages(optionName, value);
                                });
                            }); // UTIL : FILTER IMAGES : Show images with matching "image.alt" property to selected color (EX: image.alt = 'Red' shows those images when Red swatch selected)
                            function filterImages(optionName, optionValue) {
                                // FILTER : Update set of slide images
                                $slideshow.slick("slickUnfilter");
                                $slideshow.find(".product-thumbnail").removeClass("active");
                                $slideshow.find(".product-video-thumbnail").addClass("active"); // Always show video tiles
                                $slideshow.find("[data-".concat(optionName, '="').concat(optionValue, '"]')).addClass("active");
                                $slideshow.slick("slickFilter", ".active"); // MAIN IMAGE : Update main image after completing filter on thumbnails
                                var activeImages = document.querySelectorAll(".product-thumbnail[data-".concat(optionName, '="').concat(optionValue, '"]'));
                                if (activeImages.length > 0) {
                                    // SELECTED THUMB STATE : Reset selection state on thumbnails and apply to first thumb
                                    activeImages.forEach(function (img) {
                                        img.classList.remove("selected");
                                    }); // SHOW FIRST IMG : Set the first image as the new active one in the big image space
                                    var img = activeImages[0];
                                    var id = img.dataset.imageId;
                                    img.classList.add("selected"); // Mark first image as selected state
                                    events.trigger("thumbnail:click", id); // Render first image to main viewer
                                }
                            }
                        }; // START : Create thumbnail slider on given element
                        initThumbSlider($(".thumbnail-slider")); // SECTION : UNLOAD : Remove event listeners on components when exiting section
                        $(document).on("shopify:section:unload", function (event) {
                            var target = $(event.target); // REMOVE : Gallery + Main Image Zoom
                            target.find(".thumbnail-slider").slick("unslick");
                            target.find(".product-main-image").zoom("destroy"); // REMOVE : Listeners from these nodes
                            $(document).off(".thumbnail-slider");
                            $(document).off(".product-main-image");
                        }); // SECTION : LOAD : Re-Initalize gallery should a subsequent section load event occur
                        $(document).on("shopify:section:load", function (event) {
                            initThumbSlider($(event.target).find(".thumbnail-slider"));
                        });
                    })();
                };
            },
            { "./product-videos.js": 40 },
        ],
        40: [
            function (require, module, exports) {
                module.exports = (function () {
                    var Vimeo = require("@vimeo/player");
                    var YouTubeIframeLoader = require("youtube-iframe");
                    window.Shopify.Product.videoState = { activeId: null }; // RESET STATE : Event emitter can't see module state, global state ensures 1 video plays at a time
                    // INIT : Any videos to generate? (none found = 0 length, thus false)
                    function init(events) {
                        var $vimeoThumbs = document.querySelectorAll(".vimeo-thumbnail");
                        var $youtubeThumbs = document.querySelectorAll(".youtube-thumbnail");
                        var $vimeoMobileSlides = document.querySelectorAll(".vimeo-mobile");
                        var $youtubeMobileSlides = document.querySelectorAll(".youtube-mobile"); // CHECK : Should we even run?
                        if (!$vimeoThumbs.length && !$youtubeThumbs.length) {
                            return false; // YES : Initalize video setup
                        } else {
                            // VIMEO : Build any Vimeo Elements (don't link with 'else' in case both types present)
                            if ($vimeoThumbs.length > 0 || $vimeoMobileSlides.length > 0) {
                                $vimeoThumbs.forEach(function (thumb) {
                                    vimeoPlayer(thumb, false);
                                });
                                $vimeoMobileSlides.forEach(function (slide) {
                                    vimeoPlayer(slide, true);
                                });
                            } // YOUTUBE : Build any YT Elements
                            if ($youtubeThumbs.length > 0 || $youtubeMobileSlides.length > 0) {
                                $youtubeThumbs.forEach(function (thumb) {
                                    youtubePlayer(thumb, false);
                                });
                                $youtubeMobileSlides.forEach(function (slide) {
                                    youtubePlayer(slide, true);
                                });
                            } // EVENTS : Attach thumbnail event listener
                            events.on("thumbnail:click", playOnThumbSelect);
                            events.on("productVideo:pauseAll", updateVideoStates);
                        }
                    } // PLAYER - VIMEO : Player for Vimeo type videos
                    function vimeoPlayer(thumb) {
                        var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        var videoId = thumb.getAttribute("data-video-id");
                        var stateId = isMobile ? videoId + "-mobile" : videoId; // FETCH : THUMBNAIL IMG : Vimeo requires fetching thumbnail img url (Mobile Gallery displays the video player as thumb, so it skips for mobile)
                        if (!isMobile) {
                            $.ajax({
                                type: "GET",
                                url: "https://vimeo.com/api/oembed.json?url=https://www.vimeo.com/" + videoId,
                                dataType: "json",
                                error: function error(xhr, _error) {
                                    console.log("ERROR : [ ProductVideos.js - vimeoPlayer() ] -- Failed to fetch Vimeo thumbnail.\n  ERROR MSG: ".concat(_error, "\n  ERROR XHR: ").concat(xhr));
                                },
                                success: function success(data) {
                                    thumb.setAttribute("src", data.thumbnail_url);
                                },
                            });
                        } // BUILD : PLAYER : Create vimeo player itself now
                        var playerDomNodeId = isMobile ? "mobile-product-video--vimeo-".concat(videoId) : "product-video--vimeo-".concat(videoId);
                        var player = new Vimeo(playerDomNodeId, { id: videoId, width: 850 }); // STATE : UPDATE : Add new state object for video, using ID as key
                        window.Shopify.Product.videoState[stateId] = { player: player, playing: false, type: "vimeo" };
                    } // PLAYER - YOUTUBE : Player for youtube type urls
                    function youtubePlayer(thumb, isMobile) {
                        var videoId = thumb.getAttribute("data-video-id");
                        var stateId = isMobile ? videoId + "-mobile" : videoId; // THUMB IMG : Create thumbnail img if not mobile (Mobile slide uses player as its image)
                        if (!isMobile) {
                            var thumbUrl = thumb.getAttribute("data-src");
                            thumb.setAttribute("src", thumbUrl); // Youtube videos use ID in url so building thumb without fetch is possible
                        } // BUILD : PLAYER : Create youtube player for video element (hidden until thumb is clicked)
                        var playerDomNodeId = isMobile ? "mobile-product-video--youtube-".concat(videoId) : "product-video--youtube-".concat(videoId);
                        YouTubeIframeLoader.load(function (YT) {
                            var player = new YT.Player(playerDomNodeId, { width: "850", height: "480", playerVars: { rel: 0, showinfo: 0, modestbranding: 0, origin: window.location.protocol + window.location.hostname }, videoId: videoId }); // STATE : UPDATE : Add new state object for video, using ID as key
                            window.Shopify.Product.videoState[stateId] = { player: player, playing: false, type: "youtube" };
                        });
                    } // UTIL : VIDEO STATE UPDATE : Pause All / Update video state (Pause all when non-video selected)
                    function updateVideoStates(passedId, passedPlayState) {
                        var state = window.Shopify.Product.videoState; // UPDATE : Set new playing state on passed ID's video object
                        if (passedId && typeof passedPlayState !== "undefined") {
                            window.Shopify.Product.videoState[passedId].playing = passedPlayState;
                            state.activeId = passedId; // set active video as latest one passed in
                        } // PAUSE ALL (Except passed in one, let it manage its own changing state)
                        for (var id in state) {
                            if (id !== passedId && id !== "activeId") {
                                var _state$id = state[id],
                                    player = _state$id.player,
                                    type = _state$id.type; // PAUSE ALL INACTIVE : Wrapped in try because youtube throws errors on inital load when not ready
                                try {
                                    if (type === "vimeo") {
                                        player.pause();
                                    } else {
                                        player.pauseVideo();
                                    }
                                } catch (err) {
                                    console.log("Video cleared from dom, skipping pause action.");
                                }
                                window.Shopify.Product.videoState[id].playing = false;
                            }
                        }
                    } // THUMBNAIL : CONTROLS : Reveals and plays video for selected video thumbnail
                    function playOnThumbSelect(id) {
                        var state = window.Shopify.Product.videoState;
                        var videoObj = state[id]; // CHECK : Is ID a video thumbnail?
                        if (videoObj) {
                            var player = videoObj.player,
                                playing = videoObj.playing,
                                type = videoObj.type; // PLAY : Trigger video playback on thumb selection
                            if (!playing) {
                                // TRIGGER : PLAY
                                if (type === "vimeo") {
                                    player.play();
                                } else {
                                    player.playVideo();
                                } // PAUSE : User clicks same thumb, pause the video
                            } else {
                                // TRIGGER : PAUSE
                                if (type === "vimeo") {
                                    player.pause();
                                } else {
                                    player.pauseVideo();
                                }
                            } // UPDATE : Set new playback state and pause all other videos if any are playing
                            updateVideoStates(id, !playing); // NOT VIDEO THUMB : Pause all videos just to be safe
                        } else {
                            updateVideoStates();
                        }
                    } // PUBLIC METHODS
                    return { init: init };
                })();
            },
            { "@vimeo/player": 51, "youtube-iframe": 76 },
        ],
        41: [
            function (require, module, exports) {
                /*============================================================================
Scroll to top
==============================================================================*/ $(window).scroll(function () {
                    if ($(this).scrollTop() > 100) {
                        $(".scrollup").fadeIn();
                    } else {
                        $(".scrollup").fadeOut();
                    }
                });
                $(".scrollup").click(function () {
                    $("html, body").animate({ scrollTop: 0 }, 600);
                    return false;
                });
            },
            {},
        ],
        42: [
            function (require, module, exports) {
                /* Boardshort js Start */ $(document).ready(function ($) {
                    $(".shg-c.bottom-menu .menu-wrapper").click(function (event) {
                        if ($(window).width() <= 767) {
                            $(".menu", $(this)).slideToggle();
                        }
                    });
                });
                /* Boardshort js End */ /* Wetsuits js start */ $(document).ready(function ($) {
                    $(".shg-c.bottom-menu .menu-section").click(function (event) {
                        if ($(window).width() <= 767) {
                            $(".menu", $(this)).slideToggle();
                        }
                    });
                    $(".menu-collapse .icon-wrapper").on("click", function () {
                        $(this).parent().siblings().closest(".menu").css("height", "auto");
                        $(this).parent().hide();
                    });
                }); /* Wetsuits js End */
            },
            {},
        ],
        43: [
            function (require, module, exports) {
                /*============================================================================
  CART UTILS
==============================================================================*/ module.exports = (function () {
                    // Setup QTY increment/decrement on cart line items
                    var setupQtyInput = function setupQtyInput(wrapperId) {
                        var qtyWrapper = $(wrapperId),
                            decrementEl = qtyWrapper.find(".qty-decrement"),
                            incrementEl = qtyWrapper.find(".qty-increment"),
                            inputEl = qtyWrapper.find("input.cart-qty"); // Decrement Qty field by 1
                        decrementEl.on("click", function () {
                            if (inputEl.val() > 0) {
                                inputEl.val(parseInt(inputEl.val()) - 1);
                            }
                        }); // Increment Qty field by 1
                        incrementEl.on("click", function () {
                            inputEl.val(parseInt(inputEl.val()) + 1);
                        });
                    }; // Move item to wishlist, let call remove function
                    var moveToWishlist = function moveToWishlist(productId, variantId, el) {
                        var line_item_to_remove = $(el).closest(".cart-line-item").index() + 1;
                        var _product = Appmate.wk.getProduct(productId);
                        Appmate.wk
                            .addProduct(productId, variantId)
                            .then(function () {
                                theme.utils.cartUtils.removeItem(el);
                            })
                            ["catch"](console.error);
                    }; // Remove product from cart
                    var removeItem = function removeItem(el) {
                        function successCallback(cart) {
                            // REMOVE : Line item we removed via api
                            $("#cart-line-item-" + line_item).remove(); // UPDATE : update cart line item ID's
                            var lineItemRows = $('[id*="cart-line-item-"]');
                            for (var i = 0; i < lineItemRows.length; i++) {
                                lineItemRows.eq(i).attr("id", "cart-line-item-" + (i + 1));
                            }
                            if (!lineItemRows.length) {
                                window.location.reload();
                            } else {
                                // UPDATE : Price now currently in the cart
                                var cartTotal = calcCartTotal(cart.total_price);
                                $("#cart-page-price").html(cartTotal);
                                console.log("Just set priceEl inner html as " + cartTotal);
                            }
                        }
                        function calcCartTotal(total_price) {
                            // CONVERT : Change cart value to a whole dollar (or other currency) amount
                            var dollar,
                                cents,
                                cartTotal,
                                total = JSON.stringify(total_price);
                            if (total.length < 3) {
                                dollar = 0;
                                cents = total.length < 2 ? "0" + total : total; // So "9" becomes "0.09" at the end
                            } else {
                                dollar = total.substring(0, total.length - 2);
                                cents = total.substring(total.length - 2, total.length);
                            }
                            return "$" + dollar + "." + cents;
                        } // REMOVE : Use API from ajax-cart.js.liquid to set item quantity to 0 for a removal
                        var line_item = $(el).closest(".cart-line-item").index() + 1;
                        var vId = $(el).closest(".cart-line-item").data("id");
                        ShopifyAPI.changeItem(vId, 0, successCallback);
                    }; // PUBLIC METHODS
                    return { setupQtyInput: setupQtyInput, moveToWishlist: moveToWishlist, removeItem: removeItem };
                })();
            },
            {},
        ],
        44: [
            function (require, module, exports) {
                /* ----------------------------------------------------------------------------------------------------
                 * EMAIL POPUP LOADER UTIL (used by snippets cookie-banner.js & newsletter-popup.js)
                 * ---------------------------------------------------------------------------------------------------- */ module.exports = (function () {
                    // LOAD : Email signup form popup (thing from bottom right of page)
                    function email_popup_load() {
                        var $popup = $("#subscribe--popup");
                        if (!$popup.length > 0) {
                            return false;
                        }
                        $.cookie("mailing_list_delay_popup", "expires_seven_days", { path: "/", expires: 7 });
                        $.fancybox({
                            href: "#subscribe--popup",
                            tpl: { wrap: '<div class="fancybox-wrap" tabIndex="-1" id="subscribe--popup-wrapper"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>' },
                            helpers: { overlay: null },
                            openEffect: "elastic",
                            closeEffect: "none",
                            closeSpeed: "slow",
                        });
                        $("#subscribe--close, #subscribe--popup .skip").click(function () {
                            parent.$.fancybox.close();
                        });
                    } // PUBLIC UTIL METHODS
                    return { email_popup_load: email_popup_load };
                })();
            },
            {},
        ],
        45: [
            function (require, module, exports) {
                /*
                 * FILTER UTILS
                 *    - Utility methods intended for use in the PLP Filter / Search App
                 *
                 * ------------------------------------------------------------------------- */ require("isomorphic-fetch");
                var Entities = require("html-entities").AllHtmlEntities;
                var entities = new Entities();
                var Promise = require("bluebird");
                Promise.onPossiblyUnhandledRejection(function (error) {
                    // Ensures errors aren't swallowed by promise chain
                    throw error;
                });
                var buildSwatches = require("../react-components/swatches/SwatchParent.js");
                var buildBadges = require("../react-components/badges/BadgeParent.js");
                module.exports = (function () {
                    var ui = {
                        // UI : DOM nodes congruent across filter implementations
                        desktopApplyBtn: "#filter-apply-button-desktop",
                        desktopFilterSet: ".filter-list-desktop",
                    };
                    var state = { filter: {}, total_product: 0 };
                    /* STATE - UPDATE FILTER STATE (Public) :
                     *    Updates filterUtils copy of the filter state for PLP Render passes.
                     *
                     *  IN  : (Object) New properties set on state object.
                     * ----------------------------------------------------------------------- */ var updateFilterState = function updateFilterState() {
                        var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        for (var prop in newState) {
                            state[prop] = newState[prop];
                        }
                    };
                    /* DATA - FETCH MERGE DATA (Private - Promise) :
                     *    Fetches single handle's merge data + returns a promise w/ the data
                     *    Response API object built @ 'templates > product.merge-data.liquid'
                     *
                     *  IN  : (String) Product Handle
                     *  OUT : (Object) Merged Product Obj data
                     * ----------------------------------------------------------------------- */ var fetchMergeItem = function fetchMergeItem(handle) {
                        return new Promise(function (resolve, reject) {
                            fetch("".concat(window.location.origin, "/products/").concat(handle, "?view=merge-data"))
                                .then(function (res) {
                                    return res.json();
                                }) // CHECK : Return object if good, otherwise resolve as {} to avoid breaking Promise.All & purge in normalizer
                                .then(function (mergeData) {
                                    if (mergeData) {
                                        resolve(mergeData);
                                    } else {
                                        throw new Error("> Bad merge data was returned - 'product.merge-data.liquid' may have an issue / be missing.");
                                    }
                                }) // FALLBACK : Do not fail chain, return empty object to purge via normalizer step
                                ["catch"](function (err) {
                                    console.log("::: ERROR : Unable to fetch data for: ".concat(handle, " -- Product may no longer exist and filter app needs re-sync.\n   ").concat(err));
                                    resolve({});
                                });
                        });
                    };
                    /* DATA - GET ALL MERGE DATA (Private - Promise) :
                     *    Takes array of handles & fetches merge data for all asynchronously
                     *
                     *  IN  : (Array) Product Objects ( *Handle Prop Required )
                     *  OUT : (Array) Array of merged product object data
                     * ----------------------------------------------------------------------- */ var getMergeData = function getMergeData() {
                        var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        return Promise.all(
                            products.map(function (product, index) {
                                return fetchMergeItem(product.handle).then(function (mergeData) {
                                    return mergeData;
                                });
                            })
                        )["catch"](function (err) {
                            throw new Error(err);
                        });
                    };
                    /* DATA - GET SWATCHES FROM PRODUCT (Public) :
                     *
                     *  IN  : (Array) Product Objects
                     *  IN  : (String) Fallback Image URL
                     *  OUT : (Array) Color objects in a common format for swatch data usage
                     * ----------------------------------------------------------------------- */ var getSwatchesFromProduct = function getSwatchesFromProduct() {
                        var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var fallbackImgUrl = arguments.length > 1 ? arguments[1] : undefined; // COLOR VALUES : Collect all color values to use for generation of swatches
                        var colorOptionIndex = product.options.findIndex(function (opt) {
                            return opt === "colour" || opt === "color";
                        });
                        var colorOptionNum = colorOptionIndex + 1;
                        var colorValues = product["option".concat(colorOptionNum, "Values")] || [];
                        var productInfo = product.productInfo; // SWATCH DATA : Build swatch data from parsed color values
                        var swatchData = [];
                        colorValues.forEach(function (color) {
                            // FALLBACK : Setup fallback image in case no variant in that color has an image attached
                            var colorObj = {
                                image: fallbackImgUrl, // Prevent broken img situations
                                imageAlt: fallbackImgUrl, // Prevent broken img situations
                                title: color,
                                sku: "__No image on variants__", // Only missing img / sku when none of that color have a variant image attached (only needs 1, doesn't have to be all)
                            };
                            var colorVariants = product.variants.filter(function (v) {
                                return v["option".concat(colorOptionNum)] === color;
                            });
                            colorObj.available = true;
                            if (colorVariants.length) {
                                var soldoutVariants = colorVariants.filter(function (v) {
                                    return !v.available;
                                });
                                colorObj.available = soldoutVariants.length === colorVariants.length ? false : true;
                            } // POPULATE : SKU + HANDLE (for linking to exact color variant)
                            var matchedVariant = product.variants.find(function (variant) {
                                return variant["option".concat(colorOptionNum)] === color;
                            });
                            if (matchedVariant) {
                                var p_variant = productInfo && productInfo[matchedVariant.id];
                                colorObj.sku = matchedVariant.sku;
                                colorObj.handle = p_variant ? p_variant.handle : product.handle;
                            } // POPULATE : IMAGE
                            var matchedImg = product.images.find(function (image) {
                                return image.alt === color;
                            });
                            if (product.hasOwnProperty("imgArr") && product.imgArr.length) {
                                matchedImg = product.imgArr.find(function (image) {
                                    return image.alt.toLowerCase() === color.toLowerCase();
                                });
                            }
                            if (matchedImg) {
                                colorObj.image = matchedImg.src;
                            } // add alt image in obj
                            var matchedColorArr = product.imgArr.filter(function (img) {
                                if (img.alt.toLowerCase() == color.toLowerCase()) {
                                    return img;
                                }
                            });
                            if (matchedColorArr.length > 1) {
                                colorObj.imageAlt = matchedColorArr[1].src;
                            } // ADD DATA
                            swatchData.push(colorObj);
                        });
                        return swatchData;
                    };
                    /* UI - UPDATE TEMPLATE :
                     *    Fires all build functions for the various components on the PLP Layout
                     * ----------------------------------------------------------------------- */ var updateTemplate = function updateTemplate() {
                        buildSwatches();
                        buildBadges();
                    };
                    /* UI - CLOSE FILTER PANEL :
                     *    Closes PLP Filter drawer + applies passed in filter query params
                     *
                     *  IN  : (String) DOM Node ID for wrapper (jquery format)
                     *  IN  : (String) Product Filter query params + any existing params
                     * ----------------------------------------------------------------------- */ var closeAndApply = function closeAndApply(wrapperId) {
                        var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ""; // location.search = '' when none present
                        var wrapEl = $(wrapperId); // APPLY : Close Panel
                        wrapEl.removeClass("filter-open"); // APPLY : If selections have changed, wait for panel close then apply new filters
                        if (location && location.search !== queryParams) {
                            // LOADING : Show user filters are applying
                            wrapEl.addClass("applying-filters"); // APPLY : Filter application via query params
                            setTimeout(function () {
                                location.search = queryParams; // Triggers reload
                            }, 250); // 0.25s is close animation time
                        }
                    };
                    /* UI - INITIALIZER :
                     *    Attaches "apply all" filter events & subscribes collections to
                     *    updates made via the filter UI / app
                     *
                     *  IN  : (String) DOM Node ID for wrapper (jquery format)
                     * ----------------------------------------------------------------------- */ var init = function init(wrapperId) {
                        $(document).on("collectionUpdated", updateTemplate);
                    }; // PUBLIC METHODS
                    return { getSwatchesFromProduct: getSwatchesFromProduct, init: init, updateFilterState: updateFilterState };
                })();
            },
            { "../react-components/badges/BadgeParent.js": 7, "../react-components/swatches/SwatchParent.js": 18, bluebird: 52, "html-entities": 61, "isomorphic-fetch": 64 },
        ],
        46: [
            function (require, module, exports) {
                /* For IE 11+ Nodelist forEach Function */ if (window.NodeList && !NodeList.prototype.forEach) {
                    NodeList.prototype.forEach = function (callback, thisArg) {
                        thisArg = thisArg || window;
                        for (var i = 0; i < this.length; i++) {
                            callback.call(thisArg, this[i], i, this);
                        }
                    };
                } /*============================================================================
  Debounce for window resizing
  - Added to prevent multiple calls, when using an event for resizing
==============================================================================*/ // UTIL : DEBOUNCE : Prevent multiple calls of function for X ms (resize, keydown)
                window.debounce = function (fn) {
                    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
                    var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                    var timeout;
                    return function () {
                        var context = this,
                            args = arguments;
                        var later = function later() {
                            timeout = null;
                            if (!immediate) {
                                fn.apply(context, args);
                            }
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            fn.apply(context, args);
                        }
                    };
                }; // POLYFILL : Object.assign (IE 11)
                require("es6-object-assign/auto"); //812 bytes, pretty safe and small :D
                // UTIL : EVENTS EMITTER : Creates a single event emitter bus for the theme to leverage
                window.Events = new EventEmitter3();
                Events.trigger = Events.emit; // trigger alias
                /**
                 * ----------------------------------------------------------------------------------------------------
                 * AJAX CART
                 * ----------------------------------------------------------------------------------------------------
                 */ /* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */ function replaceUrlParam(e, r, a) {
                    var n = new RegExp("(" + r + "=).*?(&|$)"),
                        c = e;
                    return (c = e.search(n) >= 0 ? e.replace(n, "$1" + a + "$2") : c + (c.indexOf("?") > 0 ? "&" : "?") + r + "=" + a);
                }
                /*
                 * ----------------------------------------------------------------------------------------------------
                 * ELEMENT.CLOSEST() POLYFILL -- This fixes IE 11 bug when changing swatches and others
                 * ----------------------------------------------------------------------------------------------------
                 */ if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
                if (!Element.prototype.closest) {
                    Element.prototype.closest = function (s) {
                        var el = this;
                        if (!document.documentElement.contains(el)) return null;
                        do {
                            if (el.matches(s)) return el;
                            el = el.parentElement || el.parentNode;
                        } while (el !== null && el.nodeType === 1);
                        return null;
                    };
                }
                /**
                 * ----------------------------------------------------------------------------------------------------
                 * PLACEHOLDERS
                 * ----------------------------------------------------------------------------------------------------
                 */ !(function (e, a, t) {
                    function l(e) {
                        var a = {},
                            l = /^jQuery\d+$/;
                        return (
                            t.each(e.attributes, function (e, t) {
                                t.specified && !l.test(t.name) && (a[t.name] = t.value);
                            }),
                            a
                        );
                    }
                    function r(e, l) {
                        var r = this,
                            o = t(r);
                        if (r.value == o.attr("placeholder") && o.hasClass("placeholder"))
                            if (o.data("placeholder-password")) {
                                if (((o = o.hide().next().show().attr("id", o.removeAttr("id").data("placeholder-id"))), e === !0)) return (o[0].value = l);
                                o.focus();
                            } else (r.value = ""), o.removeClass("placeholder"), r == a.activeElement && r.select();
                    }
                    function o() {
                        var e,
                            a = this,
                            o = t(a),
                            d = this.id;
                        if ("" == a.value) {
                            if ("password" == a.type) {
                                if (!o.data("placeholder-textinput")) {
                                    try {
                                        e = o.clone().attr({ type: "text" });
                                    } catch (c) {
                                        e = t("<input>").attr(t.extend(l(this), { type: "text" }));
                                    }
                                    e.removeAttr("name").data({ "placeholder-password": !0, "placeholder-id": d }).bind("focus.placeholder", r), o.data({ "placeholder-textinput": e, "placeholder-id": d }).before(e);
                                }
                                o = o.removeAttr("id").hide().prev().attr("id", d).show();
                            }
                            o.addClass("placeholder"), (o[0].value = o.attr("placeholder"));
                        } else o.removeClass("placeholder");
                    }
                    var d,
                        c,
                        n = "placeholder" in a.createElement("input"),
                        i = "placeholder" in a.createElement("textarea"),
                        h = t.fn,
                        u = t.valHooks;
                    n && i
                        ? ((c = h.placeholder = function () {
                              return this;
                          }),
                          (c.input = c.textarea = !0))
                        : ((c = h.placeholder = function () {
                              var e = this;
                              return (
                                  e
                                      .filter((n ? "textarea" : ":input") + "[placeholder]")
                                      .not(".placeholder")
                                      .bind({ "focus.placeholder": r, "blur.placeholder": o })
                                      .data("placeholder-enabled", !0)
                                      .trigger("blur.placeholder"),
                                  e
                              );
                          }),
                          (c.input = n),
                          (c.textarea = i),
                          (d = {
                              get: function get(e) {
                                  var a = t(e);
                                  return a.data("placeholder-enabled") && a.hasClass("placeholder") ? "" : e.value;
                              },
                              set: function set(e, l) {
                                  var d = t(e);
                                  return d.data("placeholder-enabled") ? ("" == l ? ((e.value = l), e != a.activeElement && o.call(e)) : d.hasClass("placeholder") ? r.call(e, !0, l) || (e.value = l) : (e.value = l), d) : (e.value = l);
                              },
                          }),
                          n || (u.input = d),
                          i || (u.textarea = d),
                          t(function () {
                              t(a).delegate("form", "submit.placeholder", function () {
                                  var e = t(".placeholder", this).each(r);
                                  setTimeout(function () {
                                      e.each(o);
                                  }, 10);
                              });
                          }),
                          t(e).bind("beforeunload.placeholder", function () {
                              t(".placeholder").each(function () {
                                  this.value = "";
                              });
                          }));
                })(this, document, jQuery);
                /**
                 * ----------------------------------------------------------------------------------------------------
                 * COOKIES
                 * ----------------------------------------------------------------------------------------------------
                 */ !(function (e) {
                    "function" == typeof define && define.amd ? define(["jquery"], e) : e(jQuery);
                })(function (e) {
                    function n(e) {
                        return u.raw ? e : encodeURIComponent(e);
                    }
                    function o(e) {
                        return u.raw ? e : decodeURIComponent(e);
                    }
                    function i(e) {
                        return n(u.json ? JSON.stringify(e) : String(e));
                    }
                    function r(e) {
                        0 === e.indexOf('"') && (e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
                        try {
                            return (e = decodeURIComponent(e.replace(c, " "))), u.json ? JSON.parse(e) : e;
                        } catch (n) {}
                    }
                    function t(n, o) {
                        var i = u.raw ? n : r(n);
                        return e.isFunction(o) ? o(i) : i;
                    }
                    var c = /\+/g,
                        u = (e.cookie = function (r, c, a) {
                            if (void 0 !== c && !e.isFunction(c)) {
                                if (((a = e.extend({}, u.defaults, a)), "number" == typeof a.expires)) {
                                    var d = a.expires,
                                        f = (a.expires = new Date());
                                    f.setTime(+f + 864e5 * d);
                                }
                                return (document.cookie = [n(r), "=", i(c), a.expires ? "; expires=" + a.expires.toUTCString() : "", a.path ? "; path=" + a.path : "", a.domain ? "; domain=" + a.domain : "", a.secure ? "; secure" : ""].join(
                                    ""
                                ));
                            }
                            for (var s = r ? void 0 : {}, p = document.cookie ? document.cookie.split("; ") : [], m = 0, v = p.length; v > m; m++) {
                                var x = p[m].split("="),
                                    k = o(x.shift()),
                                    l = x.join("=");
                                if (r && r === k) {
                                    s = t(l, c);
                                    break;
                                }
                                r || void 0 === (l = t(l)) || (s[k] = l);
                            }
                            return s;
                        });
                    (u.defaults = {}),
                        (e.removeCookie = function (n, o) {
                            return void 0 === e.cookie(n) ? !1 : (e.cookie(n, "", e.extend({}, o, { expires: -1 })), !e.cookie(n));
                        });
                });
                /*
                 * ----------------------------------------------------------------------------------------------------
                 * DISCOUNT ENGINE (React Component)
                 * ----------------------------------------------------------------------------------------------------
                 */ require("../react-components/discounts/DiscountParent.js");
                $(document).ready(function () {
                    /*============================================================================
    Fancybox
  ==============================================================================*/ $(".fancybox").fancybox({
                        helpers: { overlay: { locked: false } },
                    });
                });
            },
            { "../react-components/discounts/DiscountParent.js": 10, "es6-object-assign/auto": 53 },
        ],
        47: [
            function (require, module, exports) {
                module.exports = (function () {
                    function checkVariant(variant, preOrderProductInfo) {
                        return (
                            preOrderProductInfo &&
                            preOrderProductInfo.variants &&
                            preOrderProductInfo.variants.preorder &&
                            variant &&
                            variant.inventoryQuantity &&
                            (!preOrderProductInfo.variants[variant.id] || (preOrderProductInfo.variants[variant.id] && preOrderProductInfo.variants[variant.id].preorder))
                        );
                    }
                    function checkProduct(preOrderProductInfo) {
                        return preOrderProductInfo && preOrderProductInfo.product && preOrderProductInfo.product.is_preorder_product;
                    }
                    function getAvailabilityMsg(variant, preOrderProductInfo, preOrderShopInfo) {
                        if (!variant) {
                            return "";
                        }
                        var availabilityMsg = "";
                        if (preOrderProductInfo.variants[variant.id] && preOrderProductInfo.variants[variant.id].availability_message && preOrderProductInfo.variants[variant.id].availability_message.trim()) {
                            availabilityMsg = preOrderProductInfo.variants[variant.id].availability_message;
                        } else if (preOrderProductInfo.product.preorder_availability_message && preOrderProductInfo.product.preorder_availability_message.trim()) {
                            availabilityMsg = preOrderProductInfo.product.preorder_availability_message;
                        } else if (preOrderShopInfo.availability_message && preOrderShopInfo.availability_message.trim()) {
                            availabilityMsg = preOrderShopInfo.availability_message;
                        }
                        return availabilityMsg;
                    }
                    function getEstimatedArrivalDate(variant, preOrderProductInfo) {
                        if (!variant) {
                            return "";
                        }
                        var arrivalDate = "";
                        if (preOrderProductInfo.variants[variant.id] && preOrderProductInfo.variants[variant.id].estimated_arrival_date && preOrderProductInfo.variants[variant.id].estimated_arrival_date.trim()) {
                            arrivalDate = preOrderProductInfo.variants[variant.id].estimated_arrival_date;
                        } else if (preOrderProductInfo.product.preorder_estimated_arrival_date && preOrderProductInfo.product.preorder_estimated_arrival_date.trim()) {
                            arrivalDate = preOrderProductInfo.product.preorder_estimated_arrival_date;
                        } else {
                            return "";
                        }
                        return arrivalDate;
                    }
                    function getPreOrderBtnColor(preOrderShopInfo) {
                        return preOrderShopInfo.button_color && preOrderShopInfo.button_color.trim();
                    } // PUBLIC METHODS
                    return { checkVariant: checkVariant, checkProduct: checkProduct, getAvailabilityMsg: getAvailabilityMsg, getEstimatedArrivalDate: getEstimatedArrivalDate, getPreOrderBtnColor: getPreOrderBtnColor };
                })();
            },
            {},
        ],
        48: [
            function (require, module, exports) {
                module.exports = (function () {
                    // STATE : Maintain a product obj + selection options for use by gallery and swatch handlers
                    var state = { dominantOptions: ["color", "colour", "imageset"], product: {}, selectedOptions: { option1: null, option2: null, option3: null } };
                    var dominantOptionsRgx = new RegExp(state.dominantOptions.join("|"), "i"); // /color|colour/i;  (Don't use g flag or iteration will save state and get screwy)
                    // DATA : EXACT VARIANT (PUBLIC) : Find the exact variant match for the current state or passed in state
                    function findExactVariant() {
                        var passedOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state.selectedOptions;
                        var product = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : state.product;
                        var perfectMatch = ""; // BUILD : PERFECT MATCH : First use current selections to try to find the exact match (size + color, for example)
                        for (var key in passedOptions) {
                            if (passedOptions[key] !== null) {
                                perfectMatch = perfectMatch.length > 0 ? "".concat(perfectMatch, " / ").concat(passedOptions[key]) : "".concat(passedOptions[key]);
                            }
                        } // FIND : VARIANT : Try to find the exact match, returns undefined if no match found (which we want)
                        if (product.variants) {
                            var exactMatch = product.variants.find(function (variant) {
                                return variant.title === perfectMatch;
                            }); // EXTRAS : Add the extra info like "handle" and Inventory Quantity into the variant Object for usage in the product-form url rewriting
                            if (exactMatch && exactMatch.id) {
                                var extraInfo = product.info[exactMatch.id]; // MERGE : Extend matched variant object with extra product info from its original parent
                                if (extraInfo) {
                                    exactMatch = Object.assign({}, exactMatch, extraInfo);
                                }
                            }
                            return exactMatch;
                        }
                        return null; // No exact match found, return null
                    } // DATA : NEAREST VARIANT (PUBLIC) : Finds current variant based on user selection state (or nearest possible match based on dominant option)
                    function findNearestVariant() {
                        var passedOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state.selectedOptions;
                        var product =
                            arguments.length > 1 && arguments[1] !== undefined
                                ? arguments[1]
                                : state.product; /* NOTES: 
        - When merging multiple products, we may have cases like this: "Red" - Size 7, 8, 9 + "Green" - Size 4, 5, 6
        - Because of this, when an exact match isn't found, we fallback to finding the dominant variant match (re: color), 
          as sizes more than likely don't vary in price, and since this size isn't on that color, user will likely next
          pick a new size and the perfect match will be found next pass. We don't want the data to change to the "9" on Red
          when the user has the green swatch selected, as that 9 doesn't exist and if prices vary on color, it would show red price. 
    */ // FIND : VARIANT : Try to find an exact matching variant object to the current selection state
                        var nearestVariant = findExactVariant(passedOptions); // FALLBACK : No Exact, Use "Dominant Option" to find nearest matching variant (Note, accounts for single dominant option # currently..)
                        if (!nearestVariant) {
                            // BUILD : DOMINANT OPTION : Use dominant option to find nearest matching variant (Defined in 'dominantOptionsRgx' )
                            var dominantPosition =
                                product.options.findIndex(function (option) {
                                    return dominantOptionsRgx.test(option);
                                }) + 1; //index starts @ 0, regex ignores casing
                            var dominantOption = "option".concat(dominantPosition);
                            var dominantValue = passedOptions[dominantOption];
                            nearestVariant = product.variants.find(function (variant) {
                                return variant[dominantOption] === dominantValue;
                            }); // MERGE INFO : Extend matched variant object with extra product info from its original parent (Handle, Description, Quantity, etc)
                            if (nearestVariant && nearestVariant.id) {
                                var extraInfo = product.info[nearestVariant.id];
                                if (extraInfo) {
                                    nearestVariant = Object.assign({}, nearestVariant, extraInfo);
                                }
                            }
                        }
                        return nearestVariant;
                    } // DATA : GET DOMINANT OPTIONS (PUBLIC) : Returens the dominantOptions array
                    function getDominantOptions() {
                        return state.dominantOptions;
                    } // DATA : GET SELECTED OPTIONS (PUBLIC) : Returns the selected options object
                    function getSelectedOptions() {
                        return state.selectedOptions;
                    } // INIT (PUBLIC) : Call this to initalize state with product / options selections
                    function init(product, passedOptions) {
                        if (!product || !product.variants) {
                            console.log("ERROR : [ productUtils - init() ] -- Product object was not present or missing variants array.");
                        }
                        state.product = product;
                        state.selectedOptions = Object.assign({}, state.selectedOptions, passedOptions);
                    } // UI STATE : SET AVAILABLITY (PUBLIC) : Single Element Class Updater for product-form
                    function setAvailable(element, isAvailable) {
                        if (!element) {
                            console.log("ERROR : [ ProductForm - setAvailable() ] -- Element was not passed in, so setting the available state failed.");
                            return;
                        }
                        var parentClasses = element.parentElement.classList;
                        isAvailable ? parentClasses.remove("soldout") : parentClasses.add("soldout");
                    } // UI STATE : SET AVAILABLITY (PUBLIC) : Single Element Class Updater for product-form
                    function setShowHide(element, isShow) {
                        var isValueChanged = false;
                        if (!element) {
                            console.log("ERROR : [ ProductForm - setShowHide() ] -- Element was not passed in, so setting the viewable state failed.");
                            return isValueChanged;
                        }
                        var parentClasses = element.parentElement.classList;
                        parentClasses.remove("hide");
                        if (!isShow) {
                            parentClasses.add("hide");
                            if ($(element).is(":checked")) {
                                $(element).prop("checked", false);
                                isValueChanged = true;
                            }
                        }
                        return isValueChanged;
                    } // UPDATE SELECTED OPTIONS (PUBLIC) : Updates the selected options state with the new selection
                    function updateSelectedOption(optionPosition, value, optionName) {
                        if (!optionPosition && !optionName) {
                            console.log("ERROR : [ productUtils - updateSelectedOption() ] -- Option position was not passed, unable to update selection state.");
                            return;
                        }
                        if (optionPosition) {
                            state.selectedOptions["option".concat(optionPosition)] = value;
                        } else if (optionName) {
                            state.selectedOptions[optionName] = value;
                        }
                    } // URL : REWRITE URL's HANDLE (PUBLIC) : Updates URL to reflects currently chosen swatch handle (Merge PDP)
                    function updateUrlHandle(variant) {
                        if (variant && variant.handle) {
                            var urlFragments = window.location.pathname.split("/");
                            var oldHandle = urlFragments[urlFragments.length - 1]; // CHECK : If different handle, replace and update router history
                            if (variant.handle !== oldHandle) {
                                var newUrl = window.location.href;
                                newUrl = newUrl.replace(oldHandle, variant.handle);
                                window.history.replaceState("", variant.title, newUrl); // Replace current history entry only
                                document.title = "".concat(variant.title, " | ").concat(variant.shopName);
                            }
                        }
                    } // find swatch option in product. So it will make sure if the product has the swatchOption
                    function findSwatchOpt() {
                        var mainOptInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        var swatchObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var swatchOption = arguments.length > 2 ? arguments[2] : undefined;
                        var product = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : state.product;
                        if (product.variants && product.variants.length && swatchOption !== mainOptInfo.optName) {
                            var thirdOpt = null;
                            for (var key in swatchObj) {
                                if (key !== mainOptInfo.optName && key !== swatchOption && swatchObj[key]) {
                                    thirdOpt = key;
                                    break;
                                }
                            }
                            var foundSwatchOpt = product.variants.find(function (variant) {
                                return variant[mainOptInfo.optName] === swatchObj[mainOptInfo.optName] && variant[swatchOption] === swatchObj[swatchOption] && (!thirdOpt || (thirdOpt && variant[thirdOpt] === swatchObj[thirdOpt]));
                            });
                            return !!foundSwatchOpt;
                        }
                        return true;
                    } // PUBLIC METHODS
                    return {
                        findExactVariant: findExactVariant,
                        findNearestVariant: findNearestVariant,
                        findSwatchOpt: findSwatchOpt,
                        getDominantOptions: getDominantOptions,
                        getSelectedOptions: getSelectedOptions,
                        init: init,
                        setAvailable: setAvailable,
                        setShowHide: setShowHide,
                        updateSelectedOption: updateSelectedOption,
                        updateUrlHandle: updateUrlHandle,
                    };
                })();
            },
            {},
        ],
        49: [
            function (require, module, exports) {
                module.exports = (function () {
                    // STATE : Module tracks currently attached elements if passed with a breakpoint
                    var state = { elements: [], initalized: false }; // ATTACH : PUBLIC : Exposed event for attach sticky kit to a ui node, fires init on first attach event
                    function attach(target, parent) {
                        var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                        var breakpoint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                        if (typeof target !== "string" || typeof parent !== "string") {
                            // PRE-FLIGHT CHECKS
                            console.log('ERROR : [ StickyUtils - attach() ] -- Target and Parent must be Strings like "#my_id"');
                            return;
                        } // SETUP : Base vars
                        var active = true;
                        var isTracked = state.elements.find(function (node) {
                            return node.target === target;
                        }); // CHECK : HEIGHT ADJUSTMENT : Checks target vs parent height to ensure no jumping issues arise
                        checkParentHeight(target, parent); // BREAKPOINTS : Only attach sticky at or above given breakpoint, remove it when below
                        if (breakpoint && typeof breakpoint === "number") {
                            active = false; // Only active if attached, default here to false until width check below
                            var width = window.innerWidth; // ATTACH : If at a resolution that meets the breakpoint (track check prevents duplicate attachments)
                            if (!isTracked && width >= breakpoint) {
                                attachSticky(target, parent, offset);
                                active = true;
                            } // REGULAR : Attach breakpoint, no need for extra setup
                        } else {
                            attachSticky(target, parent, offset);
                        } // TRACK : Add this element setup to the elements state array so it listens to resizes
                        if (!isTracked) {
                            state.elements.push({ active: active, breakpoint: breakpoint, offset: offset, parent: parent, target: target });
                        } // INITALIZE : If this is the first attach event passed, also init the module to watch for resizes
                        if (!state.initalized) {
                            init();
                        }
                    } // ATTACH : PRIVATE : Bind sticky event to given target / parent
                    function attachSticky(target, parent, offset) {
                        var options = {
                            parent: parent,
                            offset_top: offset, //When scrolling back up, adds extra padding so it accounts for sticky navbar
                        }; // PDP right column stay static until bottom is reached in scroll
                        if (!!target && target === "#product-description") {
                            options.inner_scrolling = false;
                        }
                        $(target).stick_in_parent(options);
                    } // PARENT HEIGHT : PRIVATE : Ensures parent height is at least as tall as the target to avoid visual jerk issues
                    function checkParentHeight(target, parent) {
                        var targetHeight = $(target).height();
                        var $parent = $(parent); // RESET : Parent height reset for an accurate calculation
                        $parent.height("auto"); // HEIGHT FIX : If info is taller than gallery, must set height on parent to avoid visual jumping
                        if ($parent.height() < targetHeight) {
                            $parent.height(targetHeight);
                        }
                    } // INITALIZE : PRIVATE : Attaches the window resize listener to handle disable/re-attachment of sticky nodes
                    function init() {
                        var elements = state.elements;
                        $(window).resize(
                            debounce(function (e) {
                                var width = e.target.innerWidth; // UPDATE : Update sticky nodes based on new width, respect breakpoints
                                elements.forEach(function (node) {
                                    var active = node.active,
                                        breakpoint = node.breakpoint,
                                        offset = node.offset,
                                        parent = node.parent,
                                        target = node.target; // CHECK : HEIGHT ADJUSTMENT : Checks target vs parent height to ensure no jumping issues arise from target
                                    checkParentHeight(target, parent); // CHECK : BELOW BREAKPOINT : Detach sticky if its currently active
                                    if (width < breakpoint && active) {
                                        $(target).trigger("sticky_kit:detach");
                                        updateBreakpoint(target, false); // CHECK : ABOVE BREAKPOINT : Re-bind sticky if inactive and moved at/above breakpoint
                                    } else if (width >= breakpoint && !active) {
                                        attachSticky(target, parent, offset);
                                        updateBreakpoint(target, true);
                                    }
                                }); // REFRESH ALL NODES:
                                refresh();
                            })
                        );
                    } // REFRESH : Cause all sticky elements to recalculate themselves
                    function refresh() {
                        $(document.body).trigger("sticky_kit:recalc"); // HEIGHT CHECK : Ensure UI height changes don't break layout
                        state.elements.forEach(function (node) {
                            checkParentHeight(node.target, node.parent);
                        });
                    } // UPDATE BREAKPOINT : Updates active state on given breakpoint node
                    function updateBreakpoint(target, active) {
                        var index = state.elements.findIndex(function (node) {
                            return node.target === target;
                        });
                        if (index !== -1) {
                            state.elements[index].active = active;
                        }
                    } // PUBLIC METHODS
                    return { attach: attach, refresh: refresh };
                })();
            },
            {},
        ],
        50: [
            function (require, module, exports) {
                /** @license React v16.4.2
                 * react-dom.production.min.js
                 *
                 * Copyright (c) 2013-present, Facebook, Inc.
                 *
                 * This source code is licensed under the MIT license found in the
                 * LICENSE file in the root directory of this source tree.
                 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
                (function (ma, m) {
                    "object" === _typeof(exports) && "undefined" !== typeof module ? (module.exports = m(require("react"))) : "function" === typeof define && define.amd ? define(["react"], m) : (ma.ReactDOM = m(ma.React));
                })(this, function (ma) {
                    function m(a) {
                        for (var b = arguments.length - 1, c = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, d = 0; d < b; d++) {
                            c += "&args[]=" + encodeURIComponent(arguments[d + 1]);
                        }
                        Tg(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", c);
                    }
                    function Sd() {
                        if (Eb)
                            for (var a in ua) {
                                var b = ua[a],
                                    c = Eb.indexOf(a);
                                -1 < c ? void 0 : m("96", a);
                                if (!Ua[c]) {
                                    b.extractEvents ? void 0 : m("97", a);
                                    Ua[c] = b;
                                    c = b.eventTypes;
                                    for (var d in c) {
                                        var e = void 0;
                                        var f = c[d],
                                            g = b,
                                            h = d;
                                        vc.hasOwnProperty(h) ? m("99", h) : void 0;
                                        vc[h] = f;
                                        var k = f.phasedRegistrationNames;
                                        if (k) {
                                            for (e in k) {
                                                k.hasOwnProperty(e) && Td(k[e], g, h);
                                            }
                                            e = !0;
                                        } else f.registrationName ? (Td(f.registrationName, g, h), (e = !0)) : (e = !1);
                                        e ? void 0 : m("98", d, a);
                                    }
                                }
                            }
                    }
                    function Td(a, b, c) {
                        na[a] ? m("100", a) : void 0;
                        na[a] = b;
                        Fb[a] = b.eventTypes[c].dependencies;
                    }
                    function Ud(a) {
                        Eb ? m("101") : void 0;
                        Eb = Array.prototype.slice.call(a);
                        Sd();
                    }
                    function Vd(a) {
                        var b = !1,
                            c;
                        for (c in a) {
                            if (a.hasOwnProperty(c)) {
                                var d = a[c];
                                (ua.hasOwnProperty(c) && ua[c] === d) || (ua[c] ? m("102", c) : void 0, (ua[c] = d), (b = !0));
                            }
                        }
                        b && Sd();
                    }
                    function Gb(a) {
                        return function () {
                            return a;
                        };
                    }
                    function Wd(a, b, c, d) {
                        b = a.type || "unknown-event";
                        a.currentTarget = Xd(d);
                        r.invokeGuardedCallbackAndCatchFirstError(b, c, void 0, a);
                        a.currentTarget = null;
                    }
                    function va(a, b) {
                        null == b ? m("30") : void 0;
                        if (null == a) return b;
                        if (Array.isArray(a)) {
                            if (Array.isArray(b)) return a.push.apply(a, b), a;
                            a.push(b);
                            return a;
                        }
                        return Array.isArray(b) ? [a].concat(b) : [a, b];
                    }
                    function Va(a, b, c) {
                        Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
                    }
                    function wc(a, b) {
                        var c = a.stateNode;
                        if (!c) return null;
                        var d = xc(c);
                        if (!d) return null;
                        c = d[b];
                        a: switch (b) {
                            case "onClick":
                            case "onClickCapture":
                            case "onDoubleClick":
                            case "onDoubleClickCapture":
                            case "onMouseDown":
                            case "onMouseDownCapture":
                            case "onMouseMove":
                            case "onMouseMoveCapture":
                            case "onMouseUp":
                            case "onMouseUpCapture":
                                (d = !d.disabled) || ((a = a.type), (d = !("button" === a || "input" === a || "select" === a || "textarea" === a)));
                                a = !d;
                                break a;
                            default:
                                a = !1;
                        }
                        if (a) return null;
                        c && "function" !== typeof c ? m("231", b, _typeof(c)) : void 0;
                        return c;
                    }
                    function yc(a, b) {
                        null !== a && (Wa = va(Wa, a));
                        a = Wa;
                        Wa = null;
                        a && (b ? Va(a, Ug) : Va(a, Vg), Wa ? m("95") : void 0, r.rethrowCaughtError());
                    }
                    function Yd(a, b, c, d) {
                        for (var e = null, f = 0; f < Ua.length; f++) {
                            var g = Ua[f];
                            g && (g = g.extractEvents(a, b, c, d)) && (e = va(e, g));
                        }
                        yc(e, !1);
                    }
                    function Zd(a, b) {
                        b[wa] = a;
                    }
                    function Xa(a) {
                        if (a[wa]) return a[wa];
                        for (; !a[wa]; ) {
                            if (a.parentNode) a = a.parentNode;
                            else return null;
                        }
                        a = a[wa];
                        return 5 === a.tag || 6 === a.tag ? a : null;
                    }
                    function xa(a) {
                        if (5 === a.tag || 6 === a.tag) return a.stateNode;
                        m("33");
                    }
                    function $d(a) {
                        return a[ae] || null;
                    }
                    function be(a, b) {
                        a[ae] = b;
                    }
                    function S(a) {
                        do {
                            a = a["return"];
                        } while (a && 5 !== a.tag);
                        return a ? a : null;
                    }
                    function ce(a, b, c) {
                        for (var d = []; a; ) {
                            d.push(a), (a = S(a));
                        }
                        for (a = d.length; 0 < a--; ) {
                            b(d[a], "captured", c);
                        }
                        for (a = 0; a < d.length; a++) {
                            b(d[a], "bubbled", c);
                        }
                    }
                    function de(a, b, c) {
                        if ((b = wc(a, c.dispatchConfig.phasedRegistrationNames[b]))) (c._dispatchListeners = va(c._dispatchListeners, b)), (c._dispatchInstances = va(c._dispatchInstances, a));
                    }
                    function Wg(a) {
                        a && a.dispatchConfig.phasedRegistrationNames && ce(a._targetInst, de, a);
                    }
                    function Xg(a) {
                        if (a && a.dispatchConfig.phasedRegistrationNames) {
                            var b = a._targetInst;
                            b = b ? S(b) : null;
                            ce(b, de, a);
                        }
                    }
                    function zc(a, b, c) {
                        a && c && c.dispatchConfig.registrationName && (b = wc(a, c.dispatchConfig.registrationName)) && ((c._dispatchListeners = va(c._dispatchListeners, b)), (c._dispatchInstances = va(c._dispatchInstances, a)));
                    }
                    function Yg(a) {
                        a && a.dispatchConfig.registrationName && zc(a._targetInst, null, a);
                    }
                    function ya(a) {
                        Va(a, Wg);
                    }
                    function ee(a, b, c, d) {
                        if (c && d)
                            a: {
                                var e = c;
                                for (var f = d, g = 0, h = e; h; h = S(h)) {
                                    g++;
                                }
                                h = 0;
                                for (var k = f; k; k = S(k)) {
                                    h++;
                                }
                                for (; 0 < g - h; ) {
                                    (e = S(e)), g--;
                                }
                                for (; 0 < h - g; ) {
                                    (f = S(f)), h--;
                                }
                                for (; g--; ) {
                                    if (e === f || e === f.alternate) break a;
                                    e = S(e);
                                    f = S(f);
                                }
                                e = null;
                            }
                        else e = null;
                        f = e;
                        for (e = []; c && c !== f; ) {
                            g = c.alternate;
                            if (null !== g && g === f) break;
                            e.push(c);
                            c = S(c);
                        }
                        for (c = []; d && d !== f; ) {
                            g = d.alternate;
                            if (null !== g && g === f) break;
                            c.push(d);
                            d = S(d);
                        }
                        for (d = 0; d < e.length; d++) {
                            zc(e[d], "bubbled", a);
                        }
                        for (a = c.length; 0 < a--; ) {
                            zc(c[a], "captured", b);
                        }
                    }
                    function Hb(a, b) {
                        var c = {};
                        c[a.toLowerCase()] = b.toLowerCase();
                        c["Webkit" + a] = "webkit" + b;
                        c["Moz" + a] = "moz" + b;
                        c["ms" + a] = "MS" + b;
                        c["O" + a] = "o" + b.toLowerCase();
                        return c;
                    }
                    function Ib(a) {
                        if (Ac[a]) return Ac[a];
                        if (!za[a]) return a;
                        var b = za[a],
                            c;
                        for (c in b) {
                            if (b.hasOwnProperty(c) && c in fe) return (Ac[a] = b[c]);
                        }
                        return a;
                    }
                    function ge() {
                        !Bc && T.canUseDOM && (Bc = "textContent" in document.documentElement ? "textContent" : "innerText");
                        return Bc;
                    }
                    function he() {
                        if (z._fallbackText) return z._fallbackText;
                        var a,
                            b = z._startText,
                            c = b.length,
                            d,
                            e = ie(),
                            f = e.length;
                        for (a = 0; a < c && b[a] === e[a]; a++) {}
                        var g = c - a;
                        for (d = 1; d <= g && b[c - d] === e[f - d]; d++) {}
                        z._fallbackText = e.slice(a, 1 < d ? 1 - d : void 0);
                        return z._fallbackText;
                    }
                    function ie() {
                        return "value" in z._root ? z._root.value : z._root[ge()];
                    }
                    function L(a, b, c, d) {
                        this.dispatchConfig = a;
                        this._targetInst = b;
                        this.nativeEvent = c;
                        a = this.constructor.Interface;
                        for (var e in a) {
                            a.hasOwnProperty(e) && ((b = a[e]) ? (this[e] = b(c)) : "target" === e ? (this.target = d) : (this[e] = c[e]));
                        }
                        this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? M.thatReturnsTrue : M.thatReturnsFalse;
                        this.isPropagationStopped = M.thatReturnsFalse;
                        return this;
                    }
                    function Zg(a, b, c, d) {
                        if (this.eventPool.length) {
                            var e = this.eventPool.pop();
                            this.call(e, a, b, c, d);
                            return e;
                        }
                        return new this(a, b, c, d);
                    }
                    function $g(a) {
                        a instanceof this ? void 0 : m("223");
                        a.destructor();
                        10 > this.eventPool.length && this.eventPool.push(a);
                    }
                    function je(a) {
                        a.eventPool = [];
                        a.getPooled = Zg;
                        a.release = $g;
                    }
                    function ke(a, b) {
                        switch (a) {
                            case "keyup":
                                return -1 !== ah.indexOf(b.keyCode);
                            case "keydown":
                                return 229 !== b.keyCode;
                            case "keypress":
                            case "mousedown":
                            case "blur":
                                return !0;
                            default:
                                return !1;
                        }
                    }
                    function le(a) {
                        a = a.detail;
                        return "object" === _typeof(a) && "data" in a ? a.data : null;
                    }
                    function bh(a, b) {
                        switch (a) {
                            case "compositionend":
                                return le(b);
                            case "keypress":
                                if (32 !== b.which) return null;
                                me = !0;
                                return ne;
                            case "textInput":
                                return (a = b.data), a === ne && me ? null : a;
                            default:
                                return null;
                        }
                    }
                    function ch(a, b) {
                        if (Aa) return "compositionend" === a || (!Cc && ke(a, b)) ? ((a = he()), (z._root = null), (z._startText = null), (z._fallbackText = null), (Aa = !1), a) : null;
                        switch (a) {
                            case "paste":
                                return null;
                            case "keypress":
                                if (!(b.ctrlKey || b.altKey || b.metaKey) || (b.ctrlKey && b.altKey)) {
                                    if (b["char"] && 1 < b["char"].length) return b["char"];
                                    if (b.which) return String.fromCharCode(b.which);
                                }
                                return null;
                            case "compositionend":
                                return oe ? null : b.data;
                            default:
                                return null;
                        }
                    }
                    function pe(a) {
                        if ((a = qe(a))) {
                            Jb && "function" === typeof Jb.restoreControlledState ? void 0 : m("194");
                            var b = xc(a.stateNode);
                            Jb.restoreControlledState(a.stateNode, a.type, b);
                        }
                    }
                    function re(a) {
                        Ba ? (Ca ? Ca.push(a) : (Ca = [a])) : (Ba = a);
                    }
                    function se() {
                        return null !== Ba || null !== Ca;
                    }
                    function te() {
                        if (Ba) {
                            var a = Ba,
                                b = Ca;
                            Ca = Ba = null;
                            pe(a);
                            if (b)
                                for (a = 0; a < b.length; a++) {
                                    pe(b[a]);
                                }
                        }
                    }
                    function ue(a, b) {
                        if (Dc) return a(b);
                        Dc = !0;
                        try {
                            return ve(a, b);
                        } finally {
                            (Dc = !1), se() && (we(), te());
                        }
                    }
                    function xe(a) {
                        var b = a && a.nodeName && a.nodeName.toLowerCase();
                        return "input" === b ? !!dh[a.type] : "textarea" === b ? !0 : !1;
                    }
                    function Ec(a) {
                        a = a.target || a.srcElement || window;
                        a.correspondingUseElement && (a = a.correspondingUseElement);
                        return 3 === a.nodeType ? a.parentNode : a;
                    }
                    function ye(a, b) {
                        if (!T.canUseDOM || (b && !("addEventListener" in document))) return !1;
                        a = "on" + a;
                        b = a in document;
                        b || ((b = document.createElement("div")), b.setAttribute(a, "return;"), (b = "function" === typeof b[a]));
                        return b;
                    }
                    function ze(a) {
                        var b = a.type;
                        return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
                    }
                    function eh(a) {
                        var b = ze(a) ? "checked" : "value",
                            c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
                            d = "" + a[b];
                        if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
                            var e = c.get,
                                f = c.set;
                            Object.defineProperty(a, b, {
                                configurable: !0,
                                get: function get() {
                                    return e.call(this);
                                },
                                set: function set(a) {
                                    d = "" + a;
                                    f.call(this, a);
                                },
                            });
                            Object.defineProperty(a, b, { enumerable: c.enumerable });
                            return {
                                getValue: function getValue() {
                                    return d;
                                },
                                setValue: function setValue(a) {
                                    d = "" + a;
                                },
                                stopTracking: function stopTracking() {
                                    a._valueTracker = null;
                                    delete a[b];
                                },
                            };
                        }
                    }
                    function Kb(a) {
                        a._valueTracker || (a._valueTracker = eh(a));
                    }
                    function Ae(a) {
                        if (!a) return !1;
                        var b = a._valueTracker;
                        if (!b) return !0;
                        var c = b.getValue();
                        var d = "";
                        a && (d = ze(a) ? (a.checked ? "true" : "false") : a.value);
                        a = d;
                        return a !== c ? (b.setValue(a), !0) : !1;
                    }
                    function Ya(a) {
                        if (null === a || "undefined" === typeof a) return null;
                        a = (Be && a[Be]) || a["@@iterator"];
                        return "function" === typeof a ? a : null;
                    }
                    function Za(a) {
                        var b = a.type;
                        if ("function" === typeof b) return b.displayName || b.name;
                        if ("string" === typeof b) return b;
                        switch (b) {
                            case Ce:
                                return "AsyncMode";
                            case De:
                                return "Context.Consumer";
                            case ea:
                                return "ReactFragment";
                            case Da:
                                return "ReactPortal";
                            case Fc:
                                return "Profiler(" + a.pendingProps.id + ")";
                            case Ee:
                                return "Context.Provider";
                            case Fe:
                                return "StrictMode";
                            case Ge:
                                return "Timeout";
                        }
                        if ("object" === _typeof(b) && null !== b)
                            switch (b.$$typeof) {
                                case He:
                                    return (a = b.render.displayName || b.render.name || ""), "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef";
                            }
                        return null;
                    }
                    function Ie(a) {
                        var b = "";
                        do {
                            a: switch (a.tag) {
                                case 0:
                                case 1:
                                case 2:
                                case 5:
                                    var c = a._debugOwner,
                                        d = a._debugSource;
                                    var e = Za(a);
                                    var f = null;
                                    c && (f = Za(c));
                                    c = d;
                                    e = "\n    in " + (e || "Unknown") + (c ? " (at " + c.fileName.replace(/^.*[\\\/]/, "") + ":" + c.lineNumber + ")" : f ? " (created by " + f + ")" : "");
                                    break a;
                                default:
                                    e = "";
                            }
                            b += e;
                            a = a["return"];
                        } while (a);
                        return b;
                    }
                    function fh(a) {
                        if (Je.call(Ke, a)) return !0;
                        if (Je.call(Le, a)) return !1;
                        if (gh.test(a)) return (Ke[a] = !0);
                        Le[a] = !0;
                        return !1;
                    }
                    function hh(a, b, c, d) {
                        if (null !== c && 0 === c.type) return !1;
                        switch (_typeof(b)) {
                            case "function":
                            case "symbol":
                                return !0;
                            case "boolean":
                                if (d) return !1;
                                if (null !== c) return !c.acceptsBooleans;
                                a = a.toLowerCase().slice(0, 5);
                                return "data-" !== a && "aria-" !== a;
                            default:
                                return !1;
                        }
                    }
                    function ih(a, b, c, d) {
                        if (null === b || "undefined" === typeof b || hh(a, b, c, d)) return !0;
                        if (d) return !1;
                        if (null !== c)
                            switch (c.type) {
                                case 3:
                                    return !b;
                                case 4:
                                    return !1 === b;
                                case 5:
                                    return isNaN(b);
                                case 6:
                                    return isNaN(b) || 1 > b;
                            }
                        return !1;
                    }
                    function N(a, b, c, d, e) {
                        this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
                        this.attributeName = d;
                        this.attributeNamespace = e;
                        this.mustUseProperty = c;
                        this.propertyName = a;
                        this.type = b;
                    }
                    function Gc(a, b, c, d) {
                        var e = u.hasOwnProperty(b) ? u[b] : null;
                        var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || ("o" !== b[0] && "O" !== b[0]) || ("n" !== b[1] && "N" !== b[1]) ? !1 : !0;
                        f ||
                            (ih(b, c, e, d) && (c = null),
                            d || null === e
                                ? fh(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c))
                                : e.mustUseProperty
                                ? (a[e.propertyName] = null === c ? (3 === e.type ? !1 : "") : c)
                                : ((b = e.attributeName),
                                  (d = e.attributeNamespace),
                                  null === c ? a.removeAttribute(b) : ((e = e.type), (c = 3 === e || (4 === e && !0 === c) ? "" : "" + c), d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
                    }
                    function Hc(a, b) {
                        var c = b.checked;
                        return G({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });
                    }
                    function Me(a, b) {
                        var c = null == b.defaultValue ? "" : b.defaultValue,
                            d = null != b.checked ? b.checked : b.defaultChecked;
                        c = Ic(null != b.value ? b.value : c);
                        a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
                    }
                    function Ne(a, b) {
                        b = b.checked;
                        null != b && Gc(a, "checked", b, !1);
                    }
                    function Jc(a, b) {
                        Ne(a, b);
                        var c = Ic(b.value);
                        if (null != c)
                            if ("number" === b.type) {
                                if ((0 === c && "" === a.value) || a.value != c) a.value = "" + c;
                            } else a.value !== "" + c && (a.value = "" + c);
                        b.hasOwnProperty("value") ? Kc(a, b.type, c) : b.hasOwnProperty("defaultValue") && Kc(a, b.type, Ic(b.defaultValue));
                        null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
                    }
                    function Oe(a, b, c) {
                        if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
                            b = "" + a._wrapperState.initialValue;
                            var d = a.value;
                            c || b === d || (a.value = b);
                            a.defaultValue = b;
                        }
                        c = a.name;
                        "" !== c && (a.name = "");
                        a.defaultChecked = !a.defaultChecked;
                        a.defaultChecked = !a.defaultChecked;
                        "" !== c && (a.name = c);
                    }
                    function Kc(a, b, c) {
                        if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? (a.defaultValue = "" + a._wrapperState.initialValue) : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
                    }
                    function Ic(a) {
                        switch (_typeof(a)) {
                            case "boolean":
                            case "number":
                            case "object":
                            case "string":
                            case "undefined":
                                return a;
                            default:
                                return "";
                        }
                    }
                    function Pe(a, b, c) {
                        a = L.getPooled(Qe.change, a, b, c);
                        a.type = "change";
                        re(c);
                        ya(a);
                        return a;
                    }
                    function jh(a) {
                        yc(a, !1);
                    }
                    function Lb(a) {
                        var b = xa(a);
                        if (Ae(b)) return a;
                    }
                    function kh(a, b) {
                        if ("change" === a) return b;
                    }
                    function Re() {
                        $a && ($a.detachEvent("onpropertychange", Se), (ab = $a = null));
                    }
                    function Se(a) {
                        "value" === a.propertyName && Lb(ab) && ((a = Pe(ab, a, Ec(a))), ue(jh, a));
                    }
                    function lh(a, b, c) {
                        "focus" === a ? (Re(), ($a = b), (ab = c), $a.attachEvent("onpropertychange", Se)) : "blur" === a && Re();
                    }
                    function mh(a, b) {
                        if ("selectionchange" === a || "keyup" === a || "keydown" === a) return Lb(ab);
                    }
                    function nh(a, b) {
                        if ("click" === a) return Lb(b);
                    }
                    function oh(a, b) {
                        if ("input" === a || "change" === a) return Lb(b);
                    }
                    function ph(a) {
                        var b = this.nativeEvent;
                        return b.getModifierState ? b.getModifierState(a) : (a = qh[a]) ? !!b[a] : !1;
                    }
                    function Lc(a) {
                        return ph;
                    }
                    function Te(a, b) {
                        return a === b ? 0 !== a || 0 !== b || 1 / a === 1 / b : a !== a && b !== b;
                    }
                    function bb(a) {
                        var b = a;
                        if (a.alternate)
                            for (; b["return"]; ) {
                                b = b["return"];
                            }
                        else {
                            if (0 !== (b.effectTag & 2)) return 1;
                            for (; b["return"]; ) {
                                if (((b = b["return"]), 0 !== (b.effectTag & 2))) return 1;
                            }
                        }
                        return 3 === b.tag ? 2 : 3;
                    }
                    function Ue(a) {
                        2 !== bb(a) ? m("188") : void 0;
                    }
                    function Ve(a) {
                        var b = a.alternate;
                        if (!b) return (b = bb(a)), 3 === b ? m("188") : void 0, 1 === b ? null : a;
                        for (var c = a, d = b; ; ) {
                            var e = c["return"],
                                f = e ? e.alternate : null;
                            if (!e || !f) break;
                            if (e.child === f.child) {
                                for (var g = e.child; g; ) {
                                    if (g === c) return Ue(e), a;
                                    if (g === d) return Ue(e), b;
                                    g = g.sibling;
                                }
                                m("188");
                            }
                            if (c["return"] !== d["return"]) (c = e), (d = f);
                            else {
                                g = !1;
                                for (var h = e.child; h; ) {
                                    if (h === c) {
                                        g = !0;
                                        c = e;
                                        d = f;
                                        break;
                                    }
                                    if (h === d) {
                                        g = !0;
                                        d = e;
                                        c = f;
                                        break;
                                    }
                                    h = h.sibling;
                                }
                                if (!g) {
                                    for (h = f.child; h; ) {
                                        if (h === c) {
                                            g = !0;
                                            c = f;
                                            d = e;
                                            break;
                                        }
                                        if (h === d) {
                                            g = !0;
                                            d = f;
                                            c = e;
                                            break;
                                        }
                                        h = h.sibling;
                                    }
                                    g ? void 0 : m("189");
                                }
                            }
                            c.alternate !== d ? m("190") : void 0;
                        }
                        3 !== c.tag ? m("188") : void 0;
                        return c.stateNode.current === c ? a : b;
                    }
                    function We(a) {
                        a = Ve(a);
                        if (!a) return null;
                        for (var b = a; ; ) {
                            if (5 === b.tag || 6 === b.tag) return b;
                            if (b.child) (b.child["return"] = b), (b = b.child);
                            else {
                                if (b === a) break;
                                for (; !b.sibling; ) {
                                    if (!b["return"] || b["return"] === a) return null;
                                    b = b["return"];
                                }
                                b.sibling["return"] = b["return"];
                                b = b.sibling;
                            }
                        }
                        return null;
                    }
                    function rh(a) {
                        a = Ve(a);
                        if (!a) return null;
                        for (var b = a; ; ) {
                            if (5 === b.tag || 6 === b.tag) return b;
                            if (b.child && 4 !== b.tag) (b.child["return"] = b), (b = b.child);
                            else {
                                if (b === a) break;
                                for (; !b.sibling; ) {
                                    if (!b["return"] || b["return"] === a) return null;
                                    b = b["return"];
                                }
                                b.sibling["return"] = b["return"];
                                b = b.sibling;
                            }
                        }
                        return null;
                    }
                    function Mb(a) {
                        var b = a.keyCode;
                        "charCode" in a ? ((a = a.charCode), 0 === a && 13 === b && (a = 13)) : (a = b);
                        10 === a && (a = 13);
                        return 32 <= a || 13 === a ? a : 0;
                    }
                    function Xe(a, b) {
                        var c = a[0];
                        a = a[1];
                        var d = "on" + (a[0].toUpperCase() + a.slice(1));
                        b = { phasedRegistrationNames: { bubbled: d, captured: d + "Capture" }, dependencies: [c], isInteractive: b };
                        Ye[a] = b;
                        Mc[c] = b;
                    }
                    function sh(a) {
                        var b = a.targetInst;
                        do {
                            if (!b) {
                                a.ancestors.push(b);
                                break;
                            }
                            var c;
                            for (c = b; c["return"]; ) {
                                c = c["return"];
                            }
                            c = 3 !== c.tag ? null : c.stateNode.containerInfo;
                            if (!c) break;
                            a.ancestors.push(b);
                            b = Xa(c);
                        } while (b);
                        for (c = 0; c < a.ancestors.length; c++) {
                            (b = a.ancestors[c]), Yd(a.topLevelType, b, a.nativeEvent, Ec(a.nativeEvent));
                        }
                    }
                    function Nc(a) {
                        cb = !!a;
                    }
                    function p(a, b) {
                        if (!b) return null;
                        var c = (Ze(a) ? $e : Nb).bind(null, a);
                        b.addEventListener(a, c, !1);
                    }
                    function db(a, b) {
                        if (!b) return null;
                        var c = (Ze(a) ? $e : Nb).bind(null, a);
                        b.addEventListener(a, c, !0);
                    }
                    function $e(a, b) {
                        af(Nb, a, b);
                    }
                    function Nb(a, b) {
                        if (cb) {
                            var c = Ec(b);
                            c = Xa(c);
                            null === c || "number" !== typeof c.tag || 2 === bb(c) || (c = null);
                            if (Ob.length) {
                                var d = Ob.pop();
                                d.topLevelType = a;
                                d.nativeEvent = b;
                                d.targetInst = c;
                                a = d;
                            } else a = { topLevelType: a, nativeEvent: b, targetInst: c, ancestors: [] };
                            try {
                                ue(sh, a);
                            } finally {
                                (a.topLevelType = null), (a.nativeEvent = null), (a.targetInst = null), (a.ancestors.length = 0), 10 > Ob.length && Ob.push(a);
                            }
                        }
                    }
                    function bf(a) {
                        Object.prototype.hasOwnProperty.call(a, Pb) || ((a[Pb] = th++), (cf[a[Pb]] = {}));
                        return cf[a[Pb]];
                    }
                    function df(a, b) {
                        return a && b ? (a === b ? !0 : ef(a) ? !1 : ef(b) ? df(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1) : !1;
                    }
                    function ff(a) {
                        for (; a && a.firstChild; ) {
                            a = a.firstChild;
                        }
                        return a;
                    }
                    function gf(a, b) {
                        var c = ff(a);
                        a = 0;
                        for (var d; c; ) {
                            if (3 === c.nodeType) {
                                d = a + c.textContent.length;
                                if (a <= b && d >= b) return { node: c, offset: b - a };
                                a = d;
                            }
                            a: {
                                for (; c; ) {
                                    if (c.nextSibling) {
                                        c = c.nextSibling;
                                        break a;
                                    }
                                    c = c.parentNode;
                                }
                                c = void 0;
                            }
                            c = ff(c);
                        }
                    }
                    function Oc(a) {
                        var b = a && a.nodeName && a.nodeName.toLowerCase();
                        return b && (("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type)) || "textarea" === b || "true" === a.contentEditable);
                    }
                    function hf(a, b) {
                        if (Pc || null == Ea || Ea !== Qc()) return null;
                        var c = Ea;
                        "selectionStart" in c && Oc(c)
                            ? (c = { start: c.selectionStart, end: c.selectionEnd })
                            : window.getSelection
                            ? ((c = window.getSelection()), (c = { anchorNode: c.anchorNode, anchorOffset: c.anchorOffset, focusNode: c.focusNode, focusOffset: c.focusOffset }))
                            : (c = void 0);
                        return eb && Rc(eb, c) ? null : ((eb = c), (a = L.getPooled(jf.select, Sc, a, b)), (a.type = "select"), (a.target = Ea), ya(a), a);
                    }
                    function uh(a) {
                        var b = "";
                        ma.Children.forEach(a, function (a) {
                            null == a || ("string" !== typeof a && "number" !== typeof a) || (b += a);
                        });
                        return b;
                    }
                    function Tc(a, b) {
                        a = G({ children: void 0 }, b);
                        if ((b = uh(b.children))) a.children = b;
                        return a;
                    }
                    function Fa(a, b, c, d) {
                        a = a.options;
                        if (b) {
                            b = {};
                            for (var e = 0; e < c.length; e++) {
                                b["$" + c[e]] = !0;
                            }
                            for (c = 0; c < a.length; c++) {
                                (e = b.hasOwnProperty("$" + a[c].value)), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
                            }
                        } else {
                            c = "" + c;
                            b = null;
                            for (e = 0; e < a.length; e++) {
                                if (a[e].value === c) {
                                    a[e].selected = !0;
                                    d && (a[e].defaultSelected = !0);
                                    return;
                                }
                                null !== b || a[e].disabled || (b = a[e]);
                            }
                            null !== b && (b.selected = !0);
                        }
                    }
                    function kf(a, b) {
                        var c = b.value;
                        a._wrapperState = { initialValue: null != c ? c : b.defaultValue, wasMultiple: !!b.multiple };
                    }
                    function Uc(a, b) {
                        null != b.dangerouslySetInnerHTML ? m("91") : void 0;
                        return G({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
                    }
                    function lf(a, b) {
                        var c = b.value;
                        null == c && ((c = b.defaultValue), (b = b.children), null != b && (null != c ? m("92") : void 0, Array.isArray(b) && (1 >= b.length ? void 0 : m("93"), (b = b[0])), (c = "" + b)), null == c && (c = ""));
                        a._wrapperState = { initialValue: "" + c };
                    }
                    function mf(a, b) {
                        var c = b.value;
                        null != c && ((c = "" + c), c !== a.value && (a.value = c), null == b.defaultValue && (a.defaultValue = c));
                        null != b.defaultValue && (a.defaultValue = b.defaultValue);
                    }
                    function nf(a) {
                        switch (a) {
                            case "svg":
                                return "http://www.w3.org/2000/svg";
                            case "math":
                                return "http://www.w3.org/1998/Math/MathML";
                            default:
                                return "http://www.w3.org/1999/xhtml";
                        }
                    }
                    function Vc(a, b) {
                        return null == a || "http://www.w3.org/1999/xhtml" === a ? nf(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
                    }
                    function of(a, b, c) {
                        a = a.style;
                        for (var d in b) {
                            if (b.hasOwnProperty(d)) {
                                c = 0 === d.indexOf("--");
                                var e = d;
                                var f = b[d];
                                e = null == f || "boolean" === typeof f || "" === f ? "" : c || "number" !== typeof f || 0 === f || (fb.hasOwnProperty(e) && fb[e]) ? ("" + f).trim() : f + "px";
                                "float" === d && (d = "cssFloat");
                                c ? a.setProperty(d, e) : (a[d] = e);
                            }
                        }
                    }
                    function Wc(a, b, c) {
                        b &&
                            (vh[a] && (null != b.children || null != b.dangerouslySetInnerHTML ? m("137", a, c()) : void 0),
                            null != b.dangerouslySetInnerHTML && (null != b.children ? m("60") : void 0, "object" === _typeof(b.dangerouslySetInnerHTML) && "__html" in b.dangerouslySetInnerHTML ? void 0 : m("61")),
                            null != b.style && "object" !== _typeof(b.style) ? m("62", c()) : void 0);
                    }
                    function Xc(a, b) {
                        if (-1 === a.indexOf("-")) return "string" === typeof b.is;
                        switch (a) {
                            case "annotation-xml":
                            case "color-profile":
                            case "font-face":
                            case "font-face-src":
                            case "font-face-uri":
                            case "font-face-format":
                            case "font-face-name":
                            case "missing-glyph":
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    function W(a, b) {
                        a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
                        var c = bf(a);
                        b = Fb[b];
                        for (var d = 0; d < b.length; d++) {
                            var e = b[d];
                            if (!c.hasOwnProperty(e) || !c[e]) {
                                switch (e) {
                                    case "scroll":
                                        db("scroll", a);
                                        break;
                                    case "focus":
                                    case "blur":
                                        db("focus", a);
                                        db("blur", a);
                                        c.blur = !0;
                                        c.focus = !0;
                                        break;
                                    case "cancel":
                                    case "close":
                                        ye(e, !0) && db(e, a);
                                        break;
                                    case "invalid":
                                    case "submit":
                                    case "reset":
                                        break;
                                    default:
                                        -1 === gb.indexOf(e) && p(e, a);
                                }
                                c[e] = !0;
                            }
                        }
                    }
                    function pf(a, b, c, d) {
                        c = 9 === c.nodeType ? c : c.ownerDocument;
                        "http://www.w3.org/1999/xhtml" === d && (d = nf(a));
                        "http://www.w3.org/1999/xhtml" === d
                            ? "script" === a
                                ? ((a = c.createElement("div")), (a.innerHTML = "<script>\x3c/script>"), (a = a.removeChild(a.firstChild)))
                                : (a = "string" === typeof b.is ? c.createElement(a, { is: b.is }) : c.createElement(a))
                            : (a = c.createElementNS(d, a));
                        return a;
                    }
                    function qf(a, b) {
                        return (9 === b.nodeType ? b : b.ownerDocument).createTextNode(a);
                    }
                    function rf(a, b, c, d) {
                        var e = Xc(b, c);
                        switch (b) {
                            case "iframe":
                            case "object":
                                p("load", a);
                                var f = c;
                                break;
                            case "video":
                            case "audio":
                                for (f = 0; f < gb.length; f++) {
                                    p(gb[f], a);
                                }
                                f = c;
                                break;
                            case "source":
                                p("error", a);
                                f = c;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                p("error", a);
                                p("load", a);
                                f = c;
                                break;
                            case "form":
                                p("reset", a);
                                p("submit", a);
                                f = c;
                                break;
                            case "details":
                                p("toggle", a);
                                f = c;
                                break;
                            case "input":
                                Me(a, c);
                                f = Hc(a, c);
                                p("invalid", a);
                                W(d, "onChange");
                                break;
                            case "option":
                                f = Tc(a, c);
                                break;
                            case "select":
                                kf(a, c);
                                f = G({}, c, { value: void 0 });
                                p("invalid", a);
                                W(d, "onChange");
                                break;
                            case "textarea":
                                lf(a, c);
                                f = Uc(a, c);
                                p("invalid", a);
                                W(d, "onChange");
                                break;
                            default:
                                f = c;
                        }
                        Wc(b, f, hb);
                        var g = f,
                            h;
                        for (h in g) {
                            if (g.hasOwnProperty(h)) {
                                var k = g[h];
                                "style" === h
                                    ? of(a, k, hb)
                                    : "dangerouslySetInnerHTML" === h
                                    ? ((k = k ? k.__html : void 0), null != k && sf(a, k))
                                    : "children" === h
                                    ? "string" === typeof k
                                        ? ("textarea" !== b || "" !== k) && ib(a, k)
                                        : "number" === typeof k && ib(a, "" + k)
                                    : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (na.hasOwnProperty(h) ? null != k && W(d, h) : null != k && Gc(a, h, k, e));
                            }
                        }
                        switch (b) {
                            case "input":
                                Kb(a);
                                Oe(a, c, !1);
                                break;
                            case "textarea":
                                Kb(a);
                                c = a.textContent;
                                c === a._wrapperState.initialValue && (a.value = c);
                                break;
                            case "option":
                                null != c.value && a.setAttribute("value", c.value);
                                break;
                            case "select":
                                a.multiple = !!c.multiple;
                                b = c.value;
                                null != b ? Fa(a, !!c.multiple, b, !1) : null != c.defaultValue && Fa(a, !!c.multiple, c.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof f.onClick && (a.onclick = M);
                        }
                    }
                    function tf(a, b, c, d, e) {
                        var f = null;
                        switch (b) {
                            case "input":
                                c = Hc(a, c);
                                d = Hc(a, d);
                                f = [];
                                break;
                            case "option":
                                c = Tc(a, c);
                                d = Tc(a, d);
                                f = [];
                                break;
                            case "select":
                                c = G({}, c, { value: void 0 });
                                d = G({}, d, { value: void 0 });
                                f = [];
                                break;
                            case "textarea":
                                c = Uc(a, c);
                                d = Uc(a, d);
                                f = [];
                                break;
                            default:
                                "function" !== typeof c.onClick && "function" === typeof d.onClick && (a.onclick = M);
                        }
                        Wc(b, d, hb);
                        b = a = void 0;
                        var g = null;
                        for (a in c) {
                            if (!d.hasOwnProperty(a) && c.hasOwnProperty(a) && null != c[a])
                                if ("style" === a) {
                                    var h = c[a];
                                    for (b in h) {
                                        h.hasOwnProperty(b) && (g || (g = {}), (g[b] = ""));
                                    }
                                } else
                                    "dangerouslySetInnerHTML" !== a &&
                                        "children" !== a &&
                                        "suppressContentEditableWarning" !== a &&
                                        "suppressHydrationWarning" !== a &&
                                        "autoFocus" !== a &&
                                        (na.hasOwnProperty(a) ? f || (f = []) : (f = f || []).push(a, null));
                        }
                        for (a in d) {
                            var k = d[a];
                            h = null != c ? c[a] : void 0;
                            if (d.hasOwnProperty(a) && k !== h && (null != k || null != h))
                                if ("style" === a) {
                                    if (h) {
                                        for (b in h) {
                                            !h.hasOwnProperty(b) || (k && k.hasOwnProperty(b)) || (g || (g = {}), (g[b] = ""));
                                        }
                                        for (b in k) {
                                            k.hasOwnProperty(b) && h[b] !== k[b] && (g || (g = {}), (g[b] = k[b]));
                                        }
                                    } else g || (f || (f = []), f.push(a, g)), (g = k);
                                } else
                                    "dangerouslySetInnerHTML" === a
                                        ? ((k = k ? k.__html : void 0), (h = h ? h.__html : void 0), null != k && h !== k && (f = f || []).push(a, "" + k))
                                        : "children" === a
                                        ? h === k || ("string" !== typeof k && "number" !== typeof k) || (f = f || []).push(a, "" + k)
                                        : "suppressContentEditableWarning" !== a && "suppressHydrationWarning" !== a && (na.hasOwnProperty(a) ? (null != k && W(e, a), f || h === k || (f = [])) : (f = f || []).push(a, k));
                        }
                        g && (f = f || []).push("style", g);
                        return f;
                    }
                    function uf(a, b, c, d, e) {
                        "input" === c && "radio" === e.type && null != e.name && Ne(a, e);
                        Xc(c, d);
                        d = Xc(c, e);
                        for (var f = 0; f < b.length; f += 2) {
                            var g = b[f],
                                h = b[f + 1];
                            "style" === g ? of(a, h, hb) : "dangerouslySetInnerHTML" === g ? sf(a, h) : "children" === g ? ib(a, h) : Gc(a, g, h, d);
                        }
                        switch (c) {
                            case "input":
                                Jc(a, e);
                                break;
                            case "textarea":
                                mf(a, e);
                                break;
                            case "select":
                                (a._wrapperState.initialValue = void 0),
                                    (b = a._wrapperState.wasMultiple),
                                    (a._wrapperState.wasMultiple = !!e.multiple),
                                    (c = e.value),
                                    null != c ? Fa(a, !!e.multiple, c, !1) : b !== !!e.multiple && (null != e.defaultValue ? Fa(a, !!e.multiple, e.defaultValue, !0) : Fa(a, !!e.multiple, e.multiple ? [] : "", !1));
                        }
                    }
                    function vf(a, b, c, d, e) {
                        switch (b) {
                            case "iframe":
                            case "object":
                                p("load", a);
                                break;
                            case "video":
                            case "audio":
                                for (d = 0; d < gb.length; d++) {
                                    p(gb[d], a);
                                }
                                break;
                            case "source":
                                p("error", a);
                                break;
                            case "img":
                            case "image":
                            case "link":
                                p("error", a);
                                p("load", a);
                                break;
                            case "form":
                                p("reset", a);
                                p("submit", a);
                                break;
                            case "details":
                                p("toggle", a);
                                break;
                            case "input":
                                Me(a, c);
                                p("invalid", a);
                                W(e, "onChange");
                                break;
                            case "select":
                                kf(a, c);
                                p("invalid", a);
                                W(e, "onChange");
                                break;
                            case "textarea":
                                lf(a, c), p("invalid", a), W(e, "onChange");
                        }
                        Wc(b, c, hb);
                        d = null;
                        for (var f in c) {
                            if (c.hasOwnProperty(f)) {
                                var g = c[f];
                                "children" === f
                                    ? "string" === typeof g
                                        ? a.textContent !== g && (d = ["children", g])
                                        : "number" === typeof g && a.textContent !== "" + g && (d = ["children", "" + g])
                                    : na.hasOwnProperty(f) && null != g && W(e, f);
                            }
                        }
                        switch (b) {
                            case "input":
                                Kb(a);
                                Oe(a, c, !0);
                                break;
                            case "textarea":
                                Kb(a);
                                b = a.textContent;
                                b === a._wrapperState.initialValue && (a.value = b);
                                break;
                            case "select":
                            case "option":
                                break;
                            default:
                                "function" === typeof c.onClick && (a.onclick = M);
                        }
                        return d;
                    }
                    function wf(a, b) {
                        return a.nodeValue !== b;
                    }
                    function xf(a, b) {
                        switch (a) {
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                return !!b.autoFocus;
                        }
                        return !1;
                    }
                    function Yc(a, b) {
                        return (
                            "textarea" === a ||
                            "string" === typeof b.children ||
                            "number" === typeof b.children ||
                            ("object" === _typeof(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && "string" === typeof b.dangerouslySetInnerHTML.__html)
                        );
                    }
                    function Zc(a) {
                        for (a = a.nextSibling; a && 1 !== a.nodeType && 3 !== a.nodeType; ) {
                            a = a.nextSibling;
                        }
                        return a;
                    }
                    function yf(a) {
                        for (a = a.firstChild; a && 1 !== a.nodeType && 3 !== a.nodeType; ) {
                            a = a.nextSibling;
                        }
                        return a;
                    }
                    function fa(a) {
                        return { current: a };
                    }
                    function v(a, b) {
                        0 > Ga || ((a.current = $c[Ga]), ($c[Ga] = null), Ga--);
                    }
                    function y(a, b, c) {
                        Ga++;
                        $c[Ga] = a.current;
                        a.current = b;
                    }
                    function Ha(a) {
                        return jb(a) ? ad : X.current;
                    }
                    function Ia(a, b) {
                        var c = a.type.contextTypes;
                        if (!c) return Y;
                        var d = a.stateNode;
                        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
                        var e = {},
                            f;
                        for (f in c) {
                            e[f] = b[f];
                        }
                        d && ((a = a.stateNode), (a.__reactInternalMemoizedUnmaskedChildContext = b), (a.__reactInternalMemoizedMaskedChildContext = e));
                        return e;
                    }
                    function jb(a) {
                        return 2 === a.tag && null != a.type.childContextTypes;
                    }
                    function bd(a) {
                        jb(a) && (v(x, a), v(X, a));
                    }
                    function cd(a) {
                        v(x, a);
                        v(X, a);
                    }
                    function zf(a, b, c) {
                        X.current !== Y ? m("168") : void 0;
                        y(X, b, a);
                        y(x, c, a);
                    }
                    function Af(a, b) {
                        var c = a.stateNode,
                            d = a.type.childContextTypes;
                        if ("function" !== typeof c.getChildContext) return b;
                        c = c.getChildContext();
                        for (var e in c) {
                            e in d ? void 0 : m("108", Za(a) || "Unknown", e);
                        }
                        return G({}, b, c);
                    }
                    function dd(a) {
                        if (!jb(a)) return !1;
                        var b = a.stateNode;
                        b = (b && b.__reactInternalMemoizedMergedChildContext) || Y;
                        ad = X.current;
                        y(X, b, a);
                        y(x, x.current, a);
                        return !0;
                    }
                    function Bf(a, b) {
                        var c = a.stateNode;
                        c ? void 0 : m("169");
                        if (b) {
                            var d = Af(a, ad);
                            c.__reactInternalMemoizedMergedChildContext = d;
                            v(x, a);
                            v(X, a);
                            y(X, d, a);
                        } else v(x, a);
                        y(x, b, a);
                    }
                    function ha(a, b, c, d) {
                        this.tag = a;
                        this.key = c;
                        this.sibling = this.child = this["return"] = this.stateNode = this.type = null;
                        this.index = 0;
                        this.ref = null;
                        this.pendingProps = b;
                        this.memoizedState = this.updateQueue = this.memoizedProps = null;
                        this.mode = d;
                        this.effectTag = 0;
                        this.lastEffect = this.firstEffect = this.nextEffect = null;
                        this.expirationTime = 0;
                        this.alternate = null;
                    }
                    function Qb(a, b, c) {
                        var d = a.alternate;
                        null === d
                            ? ((d = new ha(a.tag, b, a.key, a.mode)), (d.type = a.type), (d.stateNode = a.stateNode), (d.alternate = a), (a.alternate = d))
                            : ((d.pendingProps = b), (d.effectTag = 0), (d.nextEffect = null), (d.firstEffect = null), (d.lastEffect = null));
                        d.expirationTime = c;
                        d.child = a.child;
                        d.memoizedProps = a.memoizedProps;
                        d.memoizedState = a.memoizedState;
                        d.updateQueue = a.updateQueue;
                        d.sibling = a.sibling;
                        d.index = a.index;
                        d.ref = a.ref;
                        return d;
                    }
                    function ed(a, b, c) {
                        var d = a.type,
                            e = a.key;
                        a = a.props;
                        if ("function" === typeof d) var f = d.prototype && d.prototype.isReactComponent ? 2 : 0;
                        else if ("string" === typeof d) f = 5;
                        else
                            switch (d) {
                                case ea:
                                    return Rb(a.children, b, c, e);
                                case Ce:
                                    f = 11;
                                    b |= 3;
                                    break;
                                case Fe:
                                    f = 11;
                                    b |= 2;
                                    break;
                                case Fc:
                                    return (d = new ha(15, a, e, b | 4)), (d.type = Fc), (d.expirationTime = c), d;
                                case Ge:
                                    f = 16;
                                    b |= 2;
                                    break;
                                default:
                                    a: {
                                        switch ("object" === _typeof(d) && null !== d ? d.$$typeof : null) {
                                            case Ee:
                                                f = 13;
                                                break a;
                                            case De:
                                                f = 12;
                                                break a;
                                            case He:
                                                f = 14;
                                                break a;
                                            default:
                                                m("130", null == d ? d : _typeof(d), "");
                                        }
                                        f = void 0;
                                    }
                            }
                        b = new ha(f, a, e, b);
                        b.type = d;
                        b.expirationTime = c;
                        return b;
                    }
                    function Rb(a, b, c, d) {
                        a = new ha(10, a, d, b);
                        a.expirationTime = c;
                        return a;
                    }
                    function fd(a, b, c) {
                        a = new ha(6, a, null, b);
                        a.expirationTime = c;
                        return a;
                    }
                    function gd(a, b, c) {
                        b = new ha(4, null !== a.children ? a.children : [], a.key, b);
                        b.expirationTime = c;
                        b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };
                        return b;
                    }
                    function Cf(a, b, c) {
                        b = new ha(3, null, null, b ? 3 : 0);
                        a = {
                            current: b,
                            containerInfo: a,
                            pendingChildren: null,
                            earliestPendingTime: 0,
                            latestPendingTime: 0,
                            earliestSuspendedTime: 0,
                            latestSuspendedTime: 0,
                            latestPingedTime: 0,
                            pendingCommitExpirationTime: 0,
                            finishedWork: null,
                            context: null,
                            pendingContext: null,
                            hydrate: c,
                            remainingExpirationTime: 0,
                            firstBatch: null,
                            nextScheduledRoot: null,
                        };
                        return (b.stateNode = a);
                    }
                    function Df(a) {
                        return function (b) {
                            try {
                                return a(b);
                            } catch (c) {}
                        };
                    }
                    function wh(a) {
                        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
                        var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                        if (b.isDisabled || !b.supportsFiber) return !0;
                        try {
                            var c = b.inject(a);
                            hd = Df(function (a) {
                                return b.onCommitFiberRoot(c, a);
                            });
                            id = Df(function (a) {
                                return b.onCommitFiberUnmount(c, a);
                            });
                        } catch (d) {}
                        return !0;
                    }
                    function Ef(a) {
                        "function" === typeof hd && hd(a);
                    }
                    function Ff(a) {
                        "function" === typeof id && id(a);
                    }
                    function Sb(a) {
                        return {
                            expirationTime: 0,
                            baseState: a,
                            firstUpdate: null,
                            lastUpdate: null,
                            firstCapturedUpdate: null,
                            lastCapturedUpdate: null,
                            firstEffect: null,
                            lastEffect: null,
                            firstCapturedEffect: null,
                            lastCapturedEffect: null,
                        };
                    }
                    function jd(a) {
                        return {
                            expirationTime: a.expirationTime,
                            baseState: a.baseState,
                            firstUpdate: a.firstUpdate,
                            lastUpdate: a.lastUpdate,
                            firstCapturedUpdate: null,
                            lastCapturedUpdate: null,
                            firstEffect: null,
                            lastEffect: null,
                            firstCapturedEffect: null,
                            lastCapturedEffect: null,
                        };
                    }
                    function Ja(a) {
                        return { expirationTime: a, tag: 0, payload: null, callback: null, next: null, nextEffect: null };
                    }
                    function Tb(a, b, c) {
                        null === a.lastUpdate ? (a.firstUpdate = a.lastUpdate = b) : ((a.lastUpdate.next = b), (a.lastUpdate = b));
                        if (0 === a.expirationTime || a.expirationTime > c) a.expirationTime = c;
                    }
                    function oa(a, b, c) {
                        var d = a.alternate;
                        if (null === d) {
                            var e = a.updateQueue;
                            var f = null;
                            null === e && (e = a.updateQueue = Sb(a.memoizedState));
                        } else (e = a.updateQueue), (f = d.updateQueue), null === e ? (null === f ? ((e = a.updateQueue = Sb(a.memoizedState)), (f = d.updateQueue = Sb(d.memoizedState))) : (e = a.updateQueue = jd(f))) : null === f && (f = d.updateQueue = jd(e));
                        null === f || e === f ? Tb(e, b, c) : null === e.lastUpdate || null === f.lastUpdate ? (Tb(e, b, c), Tb(f, b, c)) : (Tb(e, b, c), (f.lastUpdate = b));
                    }
                    function Gf(a, b, c) {
                        var d = a.updateQueue;
                        d = null === d ? (a.updateQueue = Sb(a.memoizedState)) : Hf(a, d);
                        null === d.lastCapturedUpdate ? (d.firstCapturedUpdate = d.lastCapturedUpdate = b) : ((d.lastCapturedUpdate.next = b), (d.lastCapturedUpdate = b));
                        if (0 === d.expirationTime || d.expirationTime > c) d.expirationTime = c;
                    }
                    function Hf(a, b) {
                        var c = a.alternate;
                        null !== c && b === c.updateQueue && (b = a.updateQueue = jd(b));
                        return b;
                    }
                    function If(a, b, c, d, e, f) {
                        switch (c.tag) {
                            case 1:
                                return (a = c.payload), "function" === typeof a ? a.call(f, d, e) : a;
                            case 3:
                                a.effectTag = (a.effectTag & -1025) | 64;
                            case 0:
                                a = c.payload;
                                e = "function" === typeof a ? a.call(f, d, e) : a;
                                if (null === e || void 0 === e) break;
                                return G({}, d, e);
                            case 2:
                                ia = !0;
                        }
                        return d;
                    }
                    function kb(a, b, c, d, e) {
                        ia = !1;
                        if (!(0 === b.expirationTime || b.expirationTime > e)) {
                            b = Hf(a, b);
                            for (var f = b.baseState, g = null, h = 0, k = b.firstUpdate, m = f; null !== k; ) {
                                var l = k.expirationTime;
                                if (l > e) {
                                    if ((null === g && ((g = k), (f = m)), 0 === h || h > l)) h = l;
                                } else
                                    (m = If(a, b, k, m, c, d)),
                                        null !== k.callback && ((a.effectTag |= 32), (k.nextEffect = null), null === b.lastEffect ? (b.firstEffect = b.lastEffect = k) : ((b.lastEffect.nextEffect = k), (b.lastEffect = k)));
                                k = k.next;
                            }
                            l = null;
                            for (k = b.firstCapturedUpdate; null !== k; ) {
                                var p = k.expirationTime;
                                if (p > e) {
                                    if ((null === l && ((l = k), null === g && (f = m)), 0 === h || h > p)) h = p;
                                } else
                                    (m = If(a, b, k, m, c, d)),
                                        null !== k.callback &&
                                            ((a.effectTag |= 32),
                                            (k.nextEffect = null),
                                            null === b.lastCapturedEffect ? (b.firstCapturedEffect = b.lastCapturedEffect = k) : ((b.lastCapturedEffect.nextEffect = k), (b.lastCapturedEffect = k)));
                                k = k.next;
                            }
                            null === g && (b.lastUpdate = null);
                            null === l ? (b.lastCapturedUpdate = null) : (a.effectTag |= 32);
                            null === g && null === l && (f = m);
                            b.baseState = f;
                            b.firstUpdate = g;
                            b.firstCapturedUpdate = l;
                            b.expirationTime = h;
                            a.memoizedState = m;
                        }
                    }
                    function Kf(a, b) {
                        "function" !== typeof a ? m("191", a) : void 0;
                        a.call(b);
                    }
                    function Lf(a, b, c, d) {
                        null !== b.firstCapturedUpdate && (null !== b.lastUpdate && ((b.lastUpdate.next = b.firstCapturedUpdate), (b.lastUpdate = b.lastCapturedUpdate)), (b.firstCapturedUpdate = b.lastCapturedUpdate = null));
                        a = b.firstEffect;
                        for (b.firstEffect = b.lastEffect = null; null !== a; ) {
                            (d = a.callback), null !== d && ((a.callback = null), Kf(d, c)), (a = a.nextEffect);
                        }
                        a = b.firstCapturedEffect;
                        for (b.firstCapturedEffect = b.lastCapturedEffect = null; null !== a; ) {
                            (b = a.callback), null !== b && ((a.callback = null), Kf(b, c)), (a = a.nextEffect);
                        }
                    }
                    function Ub(a, b) {
                        return { value: a, source: b, stack: Ie(b) };
                    }
                    function Ka(a) {
                        var b = a.type._context;
                        y(kd, b._changedBits, a);
                        y(ld, b._currentValue, a);
                        y(Mf, a, a);
                        b._currentValue = a.pendingProps.value;
                        b._changedBits = a.stateNode;
                    }
                    function md(a) {
                        var b = kd.current,
                            c = ld.current;
                        v(Mf, a);
                        v(ld, a);
                        v(kd, a);
                        a = a.type._context;
                        a._currentValue = c;
                        a._changedBits = b;
                    }
                    function pa(a) {
                        a === lb ? m("174") : void 0;
                        return a;
                    }
                    function nd(a, b) {
                        y(mb, b, a);
                        y(nb, a, a);
                        y(U, lb, a);
                        var c = b.nodeType;
                        switch (c) {
                            case 9:
                            case 11:
                                b = (b = b.documentElement) ? b.namespaceURI : Vc(null, "");
                                break;
                            default:
                                (c = 8 === c ? b.parentNode : b), (b = c.namespaceURI || null), (c = c.tagName), (b = Vc(b, c));
                        }
                        v(U, a);
                        y(U, b, a);
                    }
                    function La(a) {
                        v(U, a);
                        v(nb, a);
                        v(mb, a);
                    }
                    function od(a) {
                        nb.current === a && (v(U, a), v(nb, a));
                    }
                    function Vb(a, b, c) {
                        var d = a.memoizedState;
                        b = b(c, d);
                        d = null === b || void 0 === b ? d : G({}, d, b);
                        a.memoizedState = d;
                        a = a.updateQueue;
                        null !== a && 0 === a.expirationTime && (a.baseState = d);
                    }
                    function Nf(a, b, c, d, e, f) {
                        var g = a.stateNode;
                        a = a.type;
                        return "function" === typeof g.shouldComponentUpdate ? g.shouldComponentUpdate(c, e, f) : a.prototype && a.prototype.isPureReactComponent ? !Rc(b, c) || !Rc(d, e) : !0;
                    }
                    function Of(a, b, c, d) {
                        a = b.state;
                        "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
                        "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
                        b.state !== a && Wb.enqueueReplaceState(b, b.state, null);
                    }
                    function Pf(a, b) {
                        var c = a.type,
                            d = a.stateNode,
                            e = a.pendingProps,
                            f = Ha(a);
                        d.props = e;
                        d.state = a.memoizedState;
                        d.refs = Y;
                        d.context = Ia(a, f);
                        f = a.updateQueue;
                        null !== f && (kb(a, f, e, d, b), (d.state = a.memoizedState));
                        f = a.type.getDerivedStateFromProps;
                        "function" === typeof f && (Vb(a, f, e), (d.state = a.memoizedState));
                        "function" === typeof c.getDerivedStateFromProps ||
                            "function" === typeof d.getSnapshotBeforeUpdate ||
                            ("function" !== typeof d.UNSAFE_componentWillMount && "function" !== typeof d.componentWillMount) ||
                            ((c = d.state),
                            "function" === typeof d.componentWillMount && d.componentWillMount(),
                            "function" === typeof d.UNSAFE_componentWillMount && d.UNSAFE_componentWillMount(),
                            c !== d.state && Wb.enqueueReplaceState(d, d.state, null),
                            (f = a.updateQueue),
                            null !== f && (kb(a, f, e, d, b), (d.state = a.memoizedState)));
                        "function" === typeof d.componentDidMount && (a.effectTag |= 4);
                    }
                    function ob(a, b, c) {
                        a = c.ref;
                        if (null !== a && "function" !== typeof a && "object" !== _typeof(a)) {
                            if (c._owner) {
                                c = c._owner;
                                var d = void 0;
                                c && (2 !== c.tag ? m("110") : void 0, (d = c.stateNode));
                                d ? void 0 : m("147", a);
                                var e = "" + a;
                                if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
                                b = function b(a) {
                                    var b = d.refs === Y ? (d.refs = {}) : d.refs;
                                    null === a ? delete b[e] : (b[e] = a);
                                };
                                b._stringRef = e;
                                return b;
                            }
                            "string" !== typeof a ? m("148") : void 0;
                            c._owner ? void 0 : m("254", a);
                        }
                        return a;
                    }
                    function Xb(a, b) {
                        "textarea" !== a.type && m("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
                    }
                    function Qf(a) {
                        function b(b, c) {
                            if (a) {
                                var d = b.lastEffect;
                                null !== d ? ((d.nextEffect = c), (b.lastEffect = c)) : (b.firstEffect = b.lastEffect = c);
                                c.nextEffect = null;
                                c.effectTag = 8;
                            }
                        }
                        function c(c, d) {
                            if (!a) return null;
                            for (; null !== d; ) {
                                b(c, d), (d = d.sibling);
                            }
                            return null;
                        }
                        function d(a, b) {
                            for (a = new Map(); null !== b; ) {
                                null !== b.key ? a.set(b.key, b) : a.set(b.index, b), (b = b.sibling);
                            }
                            return a;
                        }
                        function e(a, b, c) {
                            a = Qb(a, b, c);
                            a.index = 0;
                            a.sibling = null;
                            return a;
                        }
                        function f(b, c, d) {
                            b.index = d;
                            if (!a) return c;
                            d = b.alternate;
                            if (null !== d) return (d = d.index), d < c ? ((b.effectTag = 2), c) : d;
                            b.effectTag = 2;
                            return c;
                        }
                        function g(b) {
                            a && null === b.alternate && (b.effectTag = 2);
                            return b;
                        }
                        function h(a, b, c, d) {
                            if (null === b || 6 !== b.tag) return (b = fd(c, a.mode, d)), (b["return"] = a), b;
                            b = e(b, c, d);
                            b["return"] = a;
                            return b;
                        }
                        function k(a, b, c, d) {
                            if (null !== b && b.type === c.type) return (d = e(b, c.props, d)), (d.ref = ob(a, b, c)), (d["return"] = a), d;
                            d = ed(c, a.mode, d);
                            d.ref = ob(a, b, c);
                            d["return"] = a;
                            return d;
                        }
                        function l(a, b, c, d) {
                            if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return (b = gd(c, a.mode, d)), (b["return"] = a), b;
                            b = e(b, c.children || [], d);
                            b["return"] = a;
                            return b;
                        }
                        function p(a, b, c, d, f) {
                            if (null === b || 10 !== b.tag) return (b = Rb(c, a.mode, d, f)), (b["return"] = a), b;
                            b = e(b, c, d);
                            b["return"] = a;
                            return b;
                        }
                        function Jf(a, b, c) {
                            if ("string" === typeof b || "number" === typeof b) return (b = fd("" + b, a.mode, c)), (b["return"] = a), b;
                            if ("object" === _typeof(b) && null !== b) {
                                switch (b.$$typeof) {
                                    case Yb:
                                        return (c = ed(b, a.mode, c)), (c.ref = ob(a, null, b)), (c["return"] = a), c;
                                    case Da:
                                        return (b = gd(b, a.mode, c)), (b["return"] = a), b;
                                }
                                if (Zb(b) || Ya(b)) return (b = Rb(b, a.mode, c, null)), (b["return"] = a), b;
                                Xb(a, b);
                            }
                            return null;
                        }
                        function r(a, b, c, d) {
                            var e = null !== b ? b.key : null;
                            if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
                            if ("object" === _typeof(c) && null !== c) {
                                switch (c.$$typeof) {
                                    case Yb:
                                        return c.key === e ? (c.type === ea ? p(a, b, c.props.children, d, e) : k(a, b, c, d)) : null;
                                    case Da:
                                        return c.key === e ? l(a, b, c, d) : null;
                                }
                                if (Zb(c) || Ya(c)) return null !== e ? null : p(a, b, c, d, null);
                                Xb(a, c);
                            }
                            return null;
                        }
                        function x(a, b, c, d, e) {
                            if ("string" === typeof d || "number" === typeof d) return (a = a.get(c) || null), h(b, a, "" + d, e);
                            if ("object" === _typeof(d) && null !== d) {
                                switch (d.$$typeof) {
                                    case Yb:
                                        return (a = a.get(null === d.key ? c : d.key) || null), d.type === ea ? p(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                                    case Da:
                                        return (a = a.get(null === d.key ? c : d.key) || null), l(b, a, d, e);
                                }
                                if (Zb(d) || Ya(d)) return (a = a.get(c) || null), p(b, a, d, e, null);
                                Xb(b, d);
                            }
                            return null;
                        }
                        function v(e, g, h, k) {
                            for (var m = null, q = null, l = g, t = (g = 0), w = null; null !== l && t < h.length; t++) {
                                l.index > t ? ((w = l), (l = null)) : (w = l.sibling);
                                var n = r(e, l, h[t], k);
                                if (null === n) {
                                    null === l && (l = w);
                                    break;
                                }
                                a && l && null === n.alternate && b(e, l);
                                g = f(n, g, t);
                                null === q ? (m = n) : (q.sibling = n);
                                q = n;
                                l = w;
                            }
                            if (t === h.length) return c(e, l), m;
                            if (null === l) {
                                for (; t < h.length; t++) {
                                    if ((l = Jf(e, h[t], k))) (g = f(l, g, t)), null === q ? (m = l) : (q.sibling = l), (q = l);
                                }
                                return m;
                            }
                            for (l = d(e, l); t < h.length; t++) {
                                if ((w = x(l, e, t, h[t], k))) a && null !== w.alternate && l["delete"](null === w.key ? t : w.key), (g = f(w, g, t)), null === q ? (m = w) : (q.sibling = w), (q = w);
                            }
                            a &&
                                l.forEach(function (a) {
                                    return b(e, a);
                                });
                            return m;
                        }
                        function D(e, g, h, k) {
                            var l = Ya(h);
                            "function" !== typeof l ? m("150") : void 0;
                            h = l.call(h);
                            null == h ? m("151") : void 0;
                            for (var q = (l = null), t = g, w = (g = 0), A = null, n = h.next(); null !== t && !n.done; w++, n = h.next()) {
                                t.index > w ? ((A = t), (t = null)) : (A = t.sibling);
                                var p = r(e, t, n.value, k);
                                if (null === p) {
                                    t || (t = A);
                                    break;
                                }
                                a && t && null === p.alternate && b(e, t);
                                g = f(p, g, w);
                                null === q ? (l = p) : (q.sibling = p);
                                q = p;
                                t = A;
                            }
                            if (n.done) return c(e, t), l;
                            if (null === t) {
                                for (; !n.done; w++, n = h.next()) {
                                    (n = Jf(e, n.value, k)), null !== n && ((g = f(n, g, w)), null === q ? (l = n) : (q.sibling = n), (q = n));
                                }
                                return l;
                            }
                            for (t = d(e, t); !n.done; w++, n = h.next()) {
                                (n = x(t, e, w, n.value, k)), null !== n && (a && null !== n.alternate && t["delete"](null === n.key ? w : n.key), (g = f(n, g, w)), null === q ? (l = n) : (q.sibling = n), (q = n));
                            }
                            a &&
                                t.forEach(function (a) {
                                    return b(e, a);
                                });
                            return l;
                        }
                        return function (a, d, f, h) {
                            var k = "object" === _typeof(f) && null !== f && f.type === ea && null === f.key;
                            k && (f = f.props.children);
                            var l = "object" === _typeof(f) && null !== f;
                            if (l)
                                switch (f.$$typeof) {
                                    case Yb:
                                        a: {
                                            l = f.key;
                                            for (k = d; null !== k; ) {
                                                if (k.key === l) {
                                                    if (10 === k.tag ? f.type === ea : k.type === f.type) {
                                                        c(a, k.sibling);
                                                        d = e(k, f.type === ea ? f.props.children : f.props, h);
                                                        d.ref = ob(a, k, f);
                                                        d["return"] = a;
                                                        a = d;
                                                        break a;
                                                    } else {
                                                        c(a, k);
                                                        break;
                                                    }
                                                } else b(a, k);
                                                k = k.sibling;
                                            }
                                            f.type === ea ? ((d = Rb(f.props.children, a.mode, h, f.key)), (d["return"] = a), (a = d)) : ((h = ed(f, a.mode, h)), (h.ref = ob(a, d, f)), (h["return"] = a), (a = h));
                                        }
                                        return g(a);
                                    case Da:
                                        a: {
                                            for (k = f.key; null !== d; ) {
                                                if (d.key === k) {
                                                    if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                                        c(a, d.sibling);
                                                        d = e(d, f.children || [], h);
                                                        d["return"] = a;
                                                        a = d;
                                                        break a;
                                                    } else {
                                                        c(a, d);
                                                        break;
                                                    }
                                                } else b(a, d);
                                                d = d.sibling;
                                            }
                                            d = gd(f, a.mode, h);
                                            d["return"] = a;
                                            a = d;
                                        }
                                        return g(a);
                                }
                            if ("string" === typeof f || "number" === typeof f)
                                return (f = "" + f), null !== d && 6 === d.tag ? (c(a, d.sibling), (d = e(d, f, h)), (d["return"] = a), (a = d)) : (c(a, d), (d = fd(f, a.mode, h)), (d["return"] = a), (a = d)), g(a);
                            if (Zb(f)) return v(a, d, f, h);
                            if (Ya(f)) return D(a, d, f, h);
                            l && Xb(a, f);
                            if ("undefined" === typeof f && !k)
                                switch (a.tag) {
                                    case 2:
                                    case 1:
                                        (h = a.type), m("152", h.displayName || h.name || "Component");
                                }
                            return c(a, d);
                        };
                    }
                    function Rf(a, b) {
                        var c = new ha(5, null, null, 0);
                        c.type = "DELETED";
                        c.stateNode = b;
                        c["return"] = a;
                        c.effectTag = 8;
                        null !== a.lastEffect ? ((a.lastEffect.nextEffect = c), (a.lastEffect = c)) : (a.firstEffect = a.lastEffect = c);
                    }
                    function Sf(a, b) {
                        switch (a.tag) {
                            case 5:
                                var c = a.type;
                                b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
                                return null !== b ? ((a.stateNode = b), !0) : !1;
                            case 6:
                                return (b = "" === a.pendingProps || 3 !== b.nodeType ? null : b), null !== b ? ((a.stateNode = b), !0) : !1;
                            default:
                                return !1;
                        }
                    }
                    function Tf(a) {
                        if (qa) {
                            var b = Ma;
                            if (b) {
                                var c = b;
                                if (!Sf(a, b)) {
                                    b = Zc(c);
                                    if (!b || !Sf(a, b)) {
                                        a.effectTag |= 2;
                                        qa = !1;
                                        Z = a;
                                        return;
                                    }
                                    Rf(Z, c);
                                }
                                Z = a;
                                Ma = yf(b);
                            } else (a.effectTag |= 2), (qa = !1), (Z = a);
                        }
                    }
                    function Uf(a) {
                        for (a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag; ) {
                            a = a["return"];
                        }
                        Z = a;
                    }
                    function pd(a) {
                        if (a !== Z) return !1;
                        if (!qa) return Uf(a), (qa = !0), !1;
                        var b = a.type;
                        if (5 !== a.tag || ("head" !== b && "body" !== b && !Yc(b, a.memoizedProps)))
                            for (b = Ma; b; ) {
                                Rf(a, b), (b = Zc(b));
                            }
                        Uf(a);
                        Ma = Z ? Zc(a.stateNode) : null;
                        return !0;
                    }
                    function qd() {
                        Ma = Z = null;
                        qa = !1;
                    }
                    function O(a, b, c) {
                        rd(a, b, c, b.expirationTime);
                    }
                    function rd(a, b, c, d) {
                        b.child = null === a ? Vf(b, null, c, d) : Wf(b, a.child, c, d);
                    }
                    function Xf(a, b) {
                        var c = b.ref;
                        if ((null === a && null !== c) || (null !== a && a.ref !== c)) b.effectTag |= 128;
                    }
                    function Yf(a, b, c, d, e) {
                        Xf(a, b);
                        var f = 0 !== (b.effectTag & 64);
                        if (!c && !f) return d && Bf(b, !1), D(a, b);
                        c = b.stateNode;
                        sd.current = b;
                        var g = f ? null : c.render();
                        b.effectTag |= 1;
                        f && (rd(a, b, null, e), (b.child = null));
                        rd(a, b, g, e);
                        b.memoizedState = c.state;
                        b.memoizedProps = c.props;
                        d && Bf(b, !0);
                        return b.child;
                    }
                    function Zf(a) {
                        var b = a.stateNode;
                        b.pendingContext ? zf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && zf(a, b.context, !1);
                        nd(a, b.containerInfo);
                    }
                    function $f(a, b, c, d) {
                        var e = a.child;
                        null !== e && (e["return"] = a);
                        for (; null !== e; ) {
                            switch (e.tag) {
                                case 12:
                                    var f = e.stateNode | 0;
                                    if (e.type === b && 0 !== (f & c)) {
                                        for (f = e; null !== f; ) {
                                            var g = f.alternate;
                                            if (0 === f.expirationTime || f.expirationTime > d) (f.expirationTime = d), null !== g && (0 === g.expirationTime || g.expirationTime > d) && (g.expirationTime = d);
                                            else if (null !== g && (0 === g.expirationTime || g.expirationTime > d)) g.expirationTime = d;
                                            else break;
                                            f = f["return"];
                                        }
                                        f = null;
                                    } else f = e.child;
                                    break;
                                case 13:
                                    f = e.type === a.type ? null : e.child;
                                    break;
                                default:
                                    f = e.child;
                            }
                            if (null !== f) f["return"] = e;
                            else
                                for (f = e; null !== f; ) {
                                    if (f === a) {
                                        f = null;
                                        break;
                                    }
                                    e = f.sibling;
                                    if (null !== e) {
                                        e["return"] = f["return"];
                                        f = e;
                                        break;
                                    }
                                    f = f["return"];
                                }
                            e = f;
                        }
                    }
                    function yh(a, b, c) {
                        var d = b.type._context,
                            e = b.pendingProps,
                            f = b.memoizedProps,
                            g = !0;
                        if (x.current) g = !1;
                        else if (f === e) return (b.stateNode = 0), Ka(b), D(a, b);
                        var h = e.value;
                        b.memoizedProps = e;
                        if (null === f) h = 1073741823;
                        else if (f.value === e.value) {
                            if (f.children === e.children && g) return (b.stateNode = 0), Ka(b), D(a, b);
                            h = 0;
                        } else {
                            var k = f.value;
                            if ((k === h && (0 !== k || 1 / k === 1 / h)) || (k !== k && h !== h)) {
                                if (f.children === e.children && g) return (b.stateNode = 0), Ka(b), D(a, b);
                                h = 0;
                            } else if (((h = "function" === typeof d._calculateChangedBits ? d._calculateChangedBits(k, h) : 1073741823), (h |= 0), 0 === h)) {
                                if (f.children === e.children && g) return (b.stateNode = 0), Ka(b), D(a, b);
                            } else $f(b, d, h, c);
                        }
                        b.stateNode = h;
                        Ka(b);
                        O(a, b, e.children);
                        return b.child;
                    }
                    function D(a, b) {
                        null !== a && b.child !== a.child ? m("153") : void 0;
                        if (null !== b.child) {
                            a = b.child;
                            var c = Qb(a, a.pendingProps, a.expirationTime);
                            b.child = c;
                            for (c["return"] = b; null !== a.sibling; ) {
                                (a = a.sibling), (c = c.sibling = Qb(a, a.pendingProps, a.expirationTime)), (c["return"] = b);
                            }
                            c.sibling = null;
                        }
                        return b.child;
                    }
                    function zh(a, b, c) {
                        if (0 === b.expirationTime || b.expirationTime > c) {
                            switch (b.tag) {
                                case 3:
                                    Zf(b);
                                    break;
                                case 2:
                                    dd(b);
                                    break;
                                case 4:
                                    nd(b, b.stateNode.containerInfo);
                                    break;
                                case 13:
                                    Ka(b);
                            }
                            return null;
                        }
                        switch (b.tag) {
                            case 0:
                                null !== a ? m("155") : void 0;
                                var d = b.type,
                                    e = b.pendingProps,
                                    f = Ha(b);
                                f = Ia(b, f);
                                d = d(e, f);
                                b.effectTag |= 1;
                                "object" === _typeof(d) && null !== d && "function" === typeof d.render && void 0 === d.$$typeof
                                    ? ((f = b.type),
                                      (b.tag = 2),
                                      (b.memoizedState = null !== d.state && void 0 !== d.state ? d.state : null),
                                      (f = f.getDerivedStateFromProps),
                                      "function" === typeof f && Vb(b, f, e),
                                      (e = dd(b)),
                                      (d.updater = Wb),
                                      (b.stateNode = d),
                                      (d._reactInternalFiber = b),
                                      Pf(b, c),
                                      (a = Yf(a, b, !0, e, c)))
                                    : ((b.tag = 1), O(a, b, d), (b.memoizedProps = e), (a = b.child));
                                return a;
                            case 1:
                                return (
                                    (e = b.type),
                                    (c = b.pendingProps),
                                    x.current || b.memoizedProps !== c ? ((d = Ha(b)), (d = Ia(b, d)), (e = e(c, d)), (b.effectTag |= 1), O(a, b, e), (b.memoizedProps = c), (a = b.child)) : (a = D(a, b)),
                                    a
                                );
                            case 2:
                                e = dd(b);
                                if (null === a) {
                                    if (null === b.stateNode) {
                                        var g = b.pendingProps,
                                            h = b.type;
                                        d = Ha(b);
                                        var k = 2 === b.tag && null != b.type.contextTypes;
                                        f = k ? Ia(b, d) : Y;
                                        g = new h(g, f);
                                        b.memoizedState = null !== g.state && void 0 !== g.state ? g.state : null;
                                        g.updater = Wb;
                                        b.stateNode = g;
                                        g._reactInternalFiber = b;
                                        k && ((k = b.stateNode), (k.__reactInternalMemoizedUnmaskedChildContext = d), (k.__reactInternalMemoizedMaskedChildContext = f));
                                        Pf(b, c);
                                        d = !0;
                                    } else {
                                        h = b.type;
                                        d = b.stateNode;
                                        k = b.memoizedProps;
                                        f = b.pendingProps;
                                        d.props = k;
                                        var l = d.context;
                                        g = Ha(b);
                                        g = Ia(b, g);
                                        var p = h.getDerivedStateFromProps;
                                        (h = "function" === typeof p || "function" === typeof d.getSnapshotBeforeUpdate) ||
                                            ("function" !== typeof d.UNSAFE_componentWillReceiveProps && "function" !== typeof d.componentWillReceiveProps) ||
                                            ((k !== f || l !== g) && Of(b, d, f, g));
                                        ia = !1;
                                        var r = b.memoizedState;
                                        l = d.state = r;
                                        var v = b.updateQueue;
                                        null !== v && (kb(b, v, f, d, c), (l = b.memoizedState));
                                        k !== f || r !== l || x.current || ia
                                            ? ("function" === typeof p && (Vb(b, p, f), (l = b.memoizedState)),
                                              (k = ia || Nf(b, k, f, r, l, g))
                                                  ? (h ||
                                                        ("function" !== typeof d.UNSAFE_componentWillMount && "function" !== typeof d.componentWillMount) ||
                                                        ("function" === typeof d.componentWillMount && d.componentWillMount(), "function" === typeof d.UNSAFE_componentWillMount && d.UNSAFE_componentWillMount()),
                                                    "function" === typeof d.componentDidMount && (b.effectTag |= 4))
                                                  : ("function" === typeof d.componentDidMount && (b.effectTag |= 4), (b.memoizedProps = f), (b.memoizedState = l)),
                                              (d.props = f),
                                              (d.state = l),
                                              (d.context = g),
                                              (d = k))
                                            : ("function" === typeof d.componentDidMount && (b.effectTag |= 4), (d = !1));
                                    }
                                } else (h = b.type), (d = b.stateNode), (f = b.memoizedProps), (k = b.pendingProps), (d.props = f), (l = d.context), (g = Ha(b)), (g = Ia(b, g)), (p = h.getDerivedStateFromProps), (h = "function" === typeof p || "function" === typeof d.getSnapshotBeforeUpdate) || ("function" !== typeof d.UNSAFE_componentWillReceiveProps && "function" !== typeof d.componentWillReceiveProps) || ((f !== k || l !== g) && Of(b, d, k, g)), (ia = !1), (l = b.memoizedState), (r = d.state = l), (v = b.updateQueue), null !== v && (kb(b, v, k, d, c), (r = b.memoizedState)), f !== k || l !== r || x.current || ia ? ("function" === typeof p && (Vb(b, p, k), (r = b.memoizedState)), (p = ia || Nf(b, f, k, l, r, g)) ? (h || ("function" !== typeof d.UNSAFE_componentWillUpdate && "function" !== typeof d.componentWillUpdate) || ("function" === typeof d.componentWillUpdate && d.componentWillUpdate(k, r, g), "function" === typeof d.UNSAFE_componentWillUpdate && d.UNSAFE_componentWillUpdate(k, r, g)), "function" === typeof d.componentDidUpdate && (b.effectTag |= 4), "function" === typeof d.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof d.componentDidUpdate || (f === a.memoizedProps && l === a.memoizedState) || (b.effectTag |= 4), "function" !== typeof d.getSnapshotBeforeUpdate || (f === a.memoizedProps && l === a.memoizedState) || (b.effectTag |= 256), (b.memoizedProps = k), (b.memoizedState = r)), (d.props = k), (d.state = r), (d.context = g), (d = p)) : ("function" !== typeof d.componentDidUpdate || (f === a.memoizedProps && l === a.memoizedState) || (b.effectTag |= 4), "function" !== typeof d.getSnapshotBeforeUpdate || (f === a.memoizedProps && l === a.memoizedState) || (b.effectTag |= 256), (d = !1));
                                return Yf(a, b, d, e, c);
                            case 3:
                                Zf(b);
                                e = b.updateQueue;
                                if (null !== e) {
                                    if (((d = b.memoizedState), (d = null !== d ? d.element : null), kb(b, e, b.pendingProps, null, c), (e = b.memoizedState.element), e === d)) qd(), (a = D(a, b));
                                    else {
                                        d = b.stateNode;
                                        if ((d = (null === a || null === a.child) && d.hydrate)) (Ma = yf(b.stateNode.containerInfo)), (Z = b), (d = qa = !0);
                                        d ? ((b.effectTag |= 2), (b.child = Vf(b, null, e, c))) : (qd(), O(a, b, e));
                                        a = b.child;
                                    }
                                } else qd(), (a = D(a, b));
                                return a;
                            case 5:
                                a: {
                                    pa(mb.current);
                                    e = pa(U.current);
                                    d = Vc(e, b.type);
                                    e !== d && (y(nb, b, b), y(U, d, b));
                                    null === a && Tf(b);
                                    e = b.type;
                                    k = b.memoizedProps;
                                    d = b.pendingProps;
                                    f = null !== a ? a.memoizedProps : null;
                                    if (!x.current && k === d) {
                                        if ((k = b.mode & 1 && !!d.hidden)) b.expirationTime = 1073741823;
                                        if (!k || 1073741823 !== c) {
                                            a = D(a, b);
                                            break a;
                                        }
                                    }
                                    k = d.children;
                                    Yc(e, d) ? (k = null) : f && Yc(e, f) && (b.effectTag |= 16);
                                    Xf(a, b);
                                    1073741823 !== c && b.mode & 1 && d.hidden ? ((b.expirationTime = 1073741823), (b.memoizedProps = d), (a = null)) : (O(a, b, k), (b.memoizedProps = d), (a = b.child));
                                }
                                return a;
                            case 6:
                                return null === a && Tf(b), (b.memoizedProps = b.pendingProps), null;
                            case 16:
                                return null;
                            case 4:
                                return (
                                    nd(b, b.stateNode.containerInfo),
                                    (e = b.pendingProps),
                                    x.current || b.memoizedProps !== e ? (null === a ? (b.child = Wf(b, null, e, c)) : O(a, b, e), (b.memoizedProps = e), (a = b.child)) : (a = D(a, b)),
                                    a
                                );
                            case 14:
                                return (
                                    (e = b.type.render),
                                    (c = b.pendingProps),
                                    (d = b.ref),
                                    x.current || b.memoizedProps !== c || d !== (null !== a ? a.ref : null) ? ((e = e(c, d)), O(a, b, e), (b.memoizedProps = c), (a = b.child)) : (a = D(a, b)),
                                    a
                                );
                            case 10:
                                return (c = b.pendingProps), x.current || b.memoizedProps !== c ? (O(a, b, c), (b.memoizedProps = c), (a = b.child)) : (a = D(a, b)), a;
                            case 11:
                                return (c = b.pendingProps.children), x.current || (null !== c && b.memoizedProps !== c) ? (O(a, b, c), (b.memoizedProps = c), (a = b.child)) : (a = D(a, b)), a;
                            case 15:
                                return (c = b.pendingProps), b.memoizedProps === c ? (a = D(a, b)) : (O(a, b, c.children), (b.memoizedProps = c), (a = b.child)), a;
                            case 13:
                                return yh(a, b, c);
                            case 12:
                                a: if (((d = b.type), (f = b.pendingProps), (k = b.memoizedProps), (e = d._currentValue), (g = d._changedBits), x.current || 0 !== g || k !== f)) {
                                    b.memoizedProps = f;
                                    h = f.unstable_observedBits;
                                    if (void 0 === h || null === h) h = 1073741823;
                                    b.stateNode = h;
                                    if (0 !== (g & h)) $f(b, d, g, c);
                                    else if (k === f) {
                                        a = D(a, b);
                                        break a;
                                    }
                                    c = f.children;
                                    c = c(e);
                                    b.effectTag |= 1;
                                    O(a, b, c);
                                    a = b.child;
                                } else a = D(a, b);
                                return a;
                            default:
                                m("156");
                        }
                    }
                    function pb(a) {
                        a.effectTag |= 4;
                    }
                    function Ah(a, b, c) {
                        var d = b.pendingProps;
                        switch (b.tag) {
                            case 1:
                                return null;
                            case 2:
                                return bd(b), null;
                            case 3:
                                La(b);
                                cd(b);
                                c = b.stateNode;
                                c.pendingContext && ((c.context = c.pendingContext), (c.pendingContext = null));
                                if (null === a || null === a.child) pd(b), (b.effectTag &= -3);
                                td(b);
                                return null;
                            case 5:
                                od(b);
                                c = pa(mb.current);
                                var e = b.type;
                                if (null !== a && null != b.stateNode) {
                                    var f = a.memoizedProps,
                                        g = b.stateNode,
                                        h = pa(U.current);
                                    g = Bh(g, e, f, d, c);
                                    ag(a, b, g, e, f, d, c, h);
                                    a.ref !== b.ref && (b.effectTag |= 128);
                                } else {
                                    if (!d) return null === b.stateNode ? m("166") : void 0, null;
                                    a = pa(U.current);
                                    if (pd(b)) (d = b.stateNode), (e = b.type), (f = b.memoizedProps), $b(b, d), ud(d, f), (c = Ch(d, e, f, a, c)), (b.updateQueue = c), null !== c && pb(b);
                                    else {
                                        a = Dh(e, d, c, a);
                                        $b(b, a);
                                        ud(a, d);
                                        a: for (f = b.child; null !== f; ) {
                                            if (5 === f.tag || 6 === f.tag) a.appendChild(f.stateNode);
                                            else if (4 !== f.tag && null !== f.child) {
                                                f.child["return"] = f;
                                                f = f.child;
                                                continue;
                                            }
                                            if (f === b) break;
                                            for (; null === f.sibling; ) {
                                                if (null === f["return"] || f["return"] === b) break a;
                                                f = f["return"];
                                            }
                                            f.sibling["return"] = f["return"];
                                            f = f.sibling;
                                        }
                                        Eh(a, e, d, c);
                                        xf(e, d) && pb(b);
                                        b.stateNode = a;
                                    }
                                    null !== b.ref && (b.effectTag |= 128);
                                }
                                return null;
                            case 6:
                                if (a && null != b.stateNode) bg(a, b, a.memoizedProps, d);
                                else {
                                    if ("string" !== typeof d) return null === b.stateNode ? m("166") : void 0, null;
                                    c = pa(mb.current);
                                    pa(U.current);
                                    pd(b) ? ((c = b.stateNode), (d = b.memoizedProps), $b(b, c), Fh(c, d) && pb(b)) : ((c = Gh(d, c)), $b(b, c), (b.stateNode = c));
                                }
                                return null;
                            case 14:
                                return null;
                            case 16:
                                return null;
                            case 10:
                                return null;
                            case 11:
                                return null;
                            case 15:
                                return null;
                            case 4:
                                return La(b), td(b), null;
                            case 13:
                                return md(b), null;
                            case 12:
                                return null;
                            case 0:
                                m("167");
                            default:
                                m("156");
                        }
                    }
                    function cg(a, b) {
                        var c = b.source;
                        null === b.stack && null !== c && Ie(c);
                        null !== c && Za(c);
                        b = b.value;
                        null !== a && 2 === a.tag && Za(a);
                        try {
                            (b && b.suppressReactErrorLogging) || console.error(b);
                        } catch (d) {
                            (d && d.suppressReactErrorLogging) || console.error(d);
                        }
                    }
                    function dg(a) {
                        var b = a.ref;
                        if (null !== b)
                            if ("function" === typeof b)
                                try {
                                    b(null);
                                } catch (c) {
                                    qb(a, c);
                                }
                            else b.current = null;
                    }
                    function eg(a) {
                        "function" === typeof Ff && Ff(a);
                        switch (a.tag) {
                            case 2:
                                dg(a);
                                var b = a.stateNode;
                                if ("function" === typeof b.componentWillUnmount)
                                    try {
                                        (b.props = a.memoizedProps), (b.state = a.memoizedState), b.componentWillUnmount();
                                    } catch (c) {
                                        qb(a, c);
                                    }
                                break;
                            case 5:
                                dg(a);
                                break;
                            case 4:
                                fg(a);
                        }
                    }
                    function gg(a) {
                        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
                    }
                    function hg(a) {
                        a: {
                            for (var b = a["return"]; null !== b; ) {
                                if (gg(b)) {
                                    var c = b;
                                    break a;
                                }
                                b = b["return"];
                            }
                            m("160");
                            c = void 0;
                        }
                        var d = (b = void 0);
                        switch (c.tag) {
                            case 5:
                                b = c.stateNode;
                                d = !1;
                                break;
                            case 3:
                                b = c.stateNode.containerInfo;
                                d = !0;
                                break;
                            case 4:
                                b = c.stateNode.containerInfo;
                                d = !0;
                                break;
                            default:
                                m("161");
                        }
                        c.effectTag & 16 && (ib(b, ""), (c.effectTag &= -17));
                        a: b: for (c = a; ; ) {
                            for (; null === c.sibling; ) {
                                if (null === c["return"] || gg(c["return"])) {
                                    c = null;
                                    break a;
                                }
                                c = c["return"];
                            }
                            c.sibling["return"] = c["return"];
                            for (c = c.sibling; 5 !== c.tag && 6 !== c.tag; ) {
                                if (c.effectTag & 2) continue b;
                                if (null === c.child || 4 === c.tag) continue b;
                                else (c.child["return"] = c), (c = c.child);
                            }
                            if (!(c.effectTag & 2)) {
                                c = c.stateNode;
                                break a;
                            }
                        }
                        for (var e = a; ; ) {
                            if (5 === e.tag || 6 === e.tag) {
                                if (c) {
                                    if (d) {
                                        var f = b,
                                            g = e.stateNode,
                                            h = c;
                                        8 === f.nodeType ? f.parentNode.insertBefore(g, h) : f.insertBefore(g, h);
                                    } else b.insertBefore(e.stateNode, c);
                                } else d ? ((f = b), (g = e.stateNode), 8 === f.nodeType ? f.parentNode.insertBefore(g, f) : f.appendChild(g)) : b.appendChild(e.stateNode);
                            } else if (4 !== e.tag && null !== e.child) {
                                e.child["return"] = e;
                                e = e.child;
                                continue;
                            }
                            if (e === a) break;
                            for (; null === e.sibling; ) {
                                if (null === e["return"] || e["return"] === a) return;
                                e = e["return"];
                            }
                            e.sibling["return"] = e["return"];
                            e = e.sibling;
                        }
                    }
                    function fg(a) {
                        for (var b = a, c = !1, d = void 0, e = void 0; ; ) {
                            if (!c) {
                                c = b["return"];
                                a: for (;;) {
                                    null === c ? m("160") : void 0;
                                    switch (c.tag) {
                                        case 5:
                                            d = c.stateNode;
                                            e = !1;
                                            break a;
                                        case 3:
                                            d = c.stateNode.containerInfo;
                                            e = !0;
                                            break a;
                                        case 4:
                                            d = c.stateNode.containerInfo;
                                            e = !0;
                                            break a;
                                    }
                                    c = c["return"];
                                }
                                c = !0;
                            }
                            if (5 === b.tag || 6 === b.tag) {
                                a: for (var f = b, g = f; ; ) {
                                    if ((eg(g), null !== g.child && 4 !== g.tag)) (g.child["return"] = g), (g = g.child);
                                    else {
                                        if (g === f) break;
                                        for (; null === g.sibling; ) {
                                            if (null === g["return"] || g["return"] === f) break a;
                                            g = g["return"];
                                        }
                                        g.sibling["return"] = g["return"];
                                        g = g.sibling;
                                    }
                                }
                                e ? ((f = d), (g = b.stateNode), 8 === f.nodeType ? f.parentNode.removeChild(g) : f.removeChild(g)) : d.removeChild(b.stateNode);
                            } else if ((4 === b.tag ? (d = b.stateNode.containerInfo) : eg(b), null !== b.child)) {
                                b.child["return"] = b;
                                b = b.child;
                                continue;
                            }
                            if (b === a) break;
                            for (; null === b.sibling; ) {
                                if (null === b["return"] || b["return"] === a) return;
                                b = b["return"];
                                4 === b.tag && (c = !1);
                            }
                            b.sibling["return"] = b["return"];
                            b = b.sibling;
                        }
                    }
                    function ig(a, b) {
                        switch (b.tag) {
                            case 2:
                                break;
                            case 5:
                                var c = b.stateNode;
                                if (null != c) {
                                    var d = b.memoizedProps;
                                    a = null !== a ? a.memoizedProps : d;
                                    var e = b.type,
                                        f = b.updateQueue;
                                    b.updateQueue = null;
                                    null !== f && (ud(c, d), Hh(c, f, e, a, d));
                                }
                                break;
                            case 6:
                                null === b.stateNode ? m("162") : void 0;
                                b.stateNode.nodeValue = b.memoizedProps;
                                break;
                            case 3:
                                break;
                            case 15:
                                break;
                            case 16:
                                break;
                            default:
                                m("163");
                        }
                    }
                    function vd(a, b, c) {
                        c = Ja(c);
                        c.tag = 3;
                        c.payload = { element: null };
                        var d = b.value;
                        c.callback = function () {
                            wd(d);
                            cg(a, b);
                        };
                        return c;
                    }
                    function jg(a, b, c) {
                        c = Ja(c);
                        c.tag = 3;
                        var d = a.stateNode;
                        null !== d &&
                            "function" === typeof d.componentDidCatch &&
                            (c.callback = function () {
                                null === ja ? (ja = new Set([this])) : ja.add(this);
                                var c = b.value,
                                    d = b.stack;
                                cg(a, b);
                                this.componentDidCatch(c, { componentStack: null !== d ? d : "" });
                            });
                        return c;
                    }
                    function Ih(a, b, c, d, e, f, g) {
                        c.effectTag |= 512;
                        c.firstEffect = c.lastEffect = null;
                        d = Ub(d, c);
                        a = b;
                        do {
                            switch (a.tag) {
                                case 3:
                                    a.effectTag |= 1024;
                                    d = vd(a, d, f);
                                    Gf(a, d, f);
                                    return;
                                case 2:
                                    if (((b = d), (c = a.stateNode), 0 === (a.effectTag & 64) && null !== c && "function" === typeof c.componentDidCatch && (null === ja || !ja.has(c)))) {
                                        a.effectTag |= 1024;
                                        d = jg(a, b, f);
                                        Gf(a, d, f);
                                        return;
                                    }
                            }
                            a = a["return"];
                        } while (null !== a);
                    }
                    function Jh(a, b, c) {
                        switch (a.tag) {
                            case 2:
                                return bd(a), (b = a.effectTag), b & 1024 ? ((a.effectTag = (b & -1025) | 64), a) : null;
                            case 3:
                                return La(a), cd(a), (b = a.effectTag), b & 1024 ? ((a.effectTag = (b & -1025) | 64), a) : null;
                            case 5:
                                return od(a), null;
                            case 16:
                                return (b = a.effectTag), b & 1024 ? ((a.effectTag = (b & -1025) | 64), a) : null;
                            case 4:
                                return La(a), null;
                            case 13:
                                return md(a), null;
                            default:
                                return null;
                        }
                    }
                    function kg() {
                        if (null !== F)
                            for (var a = F["return"]; null !== a; ) {
                                var b = a;
                                switch (b.tag) {
                                    case 2:
                                        bd(b);
                                        break;
                                    case 3:
                                        La(b);
                                        cd(b);
                                        break;
                                    case 5:
                                        od(b);
                                        break;
                                    case 4:
                                        La(b);
                                        break;
                                    case 13:
                                        md(b);
                                }
                                a = a["return"];
                            }
                        rb = null;
                        K = 0;
                        ac = -1;
                        sb = !1;
                        F = null;
                        xd = !1;
                    }
                    function lg(a) {
                        for (;;) {
                            var b = a.alternate,
                                c = a["return"],
                                d = a.sibling;
                            if (0 === (a.effectTag & 512)) {
                                b = Ah(b, a, K);
                                var e = a;
                                if (1073741823 === K || 1073741823 !== e.expirationTime) {
                                    var f = 0;
                                    switch (e.tag) {
                                        case 3:
                                        case 2:
                                            var g = e.updateQueue;
                                            null !== g && (f = g.expirationTime);
                                    }
                                    for (g = e.child; null !== g; ) {
                                        0 !== g.expirationTime && (0 === f || f > g.expirationTime) && (f = g.expirationTime), (g = g.sibling);
                                    }
                                    e.expirationTime = f;
                                }
                                if (null !== b) return b;
                                null !== c &&
                                    0 === (c.effectTag & 512) &&
                                    (null === c.firstEffect && (c.firstEffect = a.firstEffect),
                                    null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), (c.lastEffect = a.lastEffect)),
                                    1 < a.effectTag && (null !== c.lastEffect ? (c.lastEffect.nextEffect = a) : (c.firstEffect = a), (c.lastEffect = a)));
                                if (null !== d) return d;
                                if (null !== c) a = c;
                                else {
                                    xd = !0;
                                    break;
                                }
                            } else {
                                a = Jh(a, sb, K);
                                if (null !== a) return (a.effectTag &= 511), a;
                                null !== c && ((c.firstEffect = c.lastEffect = null), (c.effectTag |= 512));
                                if (null !== d) return d;
                                if (null !== c) a = c;
                                else break;
                            }
                        }
                        return null;
                    }
                    function mg(a) {
                        var b = zh(a.alternate, a, K);
                        null === b && (b = lg(a));
                        sd.current = null;
                        return b;
                    }
                    function ng(a, b, c) {
                        aa ? m("243") : void 0;
                        aa = !0;
                        if (b !== K || a !== rb || null === F) kg(), (rb = a), (K = b), (ac = -1), (F = Qb(rb.current, null, K)), (a.pendingCommitExpirationTime = 0);
                        var d = !1;
                        sb = !c || K <= og;
                        do {
                            try {
                                if (c)
                                    for (; null !== F && !pg(); ) {
                                        F = mg(F);
                                    }
                                else
                                    for (; null !== F; ) {
                                        F = mg(F);
                                    }
                            } catch (f) {
                                if (null === F) (d = !0), wd(f);
                                else {
                                    null === F ? m("271") : void 0;
                                    c = F;
                                    var e = c["return"];
                                    if (null === e) {
                                        d = !0;
                                        wd(f);
                                        break;
                                    }
                                    Ih(a, e, c, f, sb, K, yd);
                                    F = lg(c);
                                }
                            }
                            break;
                        } while (1);
                        aa = !1;
                        if (d) return null;
                        if (null === F) {
                            if (xd) return (a.pendingCommitExpirationTime = b), a.current.alternate;
                            sb ? m("262") : void 0;
                            0 <= ac &&
                                setTimeout(function () {
                                    var b = a.current.expirationTime;
                                    0 !== b && (0 === a.remainingExpirationTime || a.remainingExpirationTime < b) && zd(a, b);
                                }, ac);
                            Kh(a.current.expirationTime);
                        }
                        return null;
                    }
                    function qb(a, b) {
                        var c;
                        a: {
                            aa && !tb ? m("263") : void 0;
                            for (c = a["return"]; null !== c; ) {
                                switch (c.tag) {
                                    case 2:
                                        var d = c.stateNode;
                                        if ("function" === typeof c.type.getDerivedStateFromCatch || ("function" === typeof d.componentDidCatch && (null === ja || !ja.has(d)))) {
                                            a = Ub(b, a);
                                            a = jg(c, a, 1);
                                            oa(c, a, 1);
                                            ra(c, 1);
                                            c = void 0;
                                            break a;
                                        }
                                        break;
                                    case 3:
                                        a = Ub(b, a);
                                        a = vd(c, a, 1);
                                        oa(c, a, 1);
                                        ra(c, 1);
                                        c = void 0;
                                        break a;
                                }
                                c = c["return"];
                            }
                            3 === a.tag && ((c = Ub(b, a)), (c = vd(a, c, 1)), oa(a, c, 1), ra(a, 1));
                            c = void 0;
                        }
                        return c;
                    }
                    function qg() {
                        var a = 2 + 25 * ((((ba() - 2 + 500) / 25) | 0) + 1);
                        a <= Ad && (a = Ad + 1);
                        return (Ad = a);
                    }
                    function bc(a, b) {
                        a = 0 !== ka ? ka : aa ? (tb ? 1 : K) : b.mode & 1 ? (Na ? 2 + 10 * ((((a - 2 + 15) / 10) | 0) + 1) : 2 + 25 * ((((a - 2 + 500) / 25) | 0) + 1)) : 1;
                        Na && (0 === ca || a > ca) && (ca = a);
                        return a;
                    }
                    function ra(a, b) {
                        for (; null !== a; ) {
                            if (0 === a.expirationTime || a.expirationTime > b) a.expirationTime = b;
                            null !== a.alternate && (0 === a.alternate.expirationTime || a.alternate.expirationTime > b) && (a.alternate.expirationTime = b);
                            if (null === a["return"])
                                if (3 === a.tag) {
                                    var c = a.stateNode;
                                    !aa && 0 !== K && b < K && kg();
                                    var d = c.current.expirationTime;
                                    (aa && !tb && rb === c) || zd(c, d);
                                    cc > Lh && m("185");
                                } else break;
                            a = a["return"];
                        }
                    }
                    function ba() {
                        yd = Bd() - Cd;
                        return (og = ((yd / 10) | 0) + 2);
                    }
                    function rg(a) {
                        var b = ka;
                        ka = 2 + 25 * ((((ba() - 2 + 500) / 25) | 0) + 1);
                        try {
                            return a();
                        } finally {
                            ka = b;
                        }
                    }
                    function Dd(a, b, c, d, e) {
                        var f = ka;
                        ka = 1;
                        try {
                            return a(b, c, d, e);
                        } finally {
                            ka = f;
                        }
                    }
                    function sg(a) {
                        if (0 !== dc) {
                            if (a > dc) return;
                            null !== ec && Mh(ec);
                        }
                        var b = Bd() - Cd;
                        dc = a;
                        ec = Nh(Oh, { timeout: 10 * (a - 2) - b });
                    }
                    function zd(a, b) {
                        if (null === a.nextScheduledRoot) (a.remainingExpirationTime = b), null === E ? ((sa = E = a), (a.nextScheduledRoot = a)) : ((E = E.nextScheduledRoot = a), (E.nextScheduledRoot = sa));
                        else {
                            var c = a.remainingExpirationTime;
                            if (0 === c || b < c) a.remainingExpirationTime = b;
                        }
                        Q || (H ? fc && ((P = a), (I = 1), gc(a, 1, !1)) : 1 === b ? ub() : sg(b));
                    }
                    function Ed() {
                        var a = 0,
                            b = null;
                        if (null !== E)
                            for (var c = E, d = sa; null !== d; ) {
                                var e = d.remainingExpirationTime;
                                if (0 === e) {
                                    null === c || null === E ? m("244") : void 0;
                                    if (d === d.nextScheduledRoot) {
                                        sa = E = d.nextScheduledRoot = null;
                                        break;
                                    } else if (d === sa) (sa = e = d.nextScheduledRoot), (E.nextScheduledRoot = e), (d.nextScheduledRoot = null);
                                    else if (d === E) {
                                        E = c;
                                        E.nextScheduledRoot = sa;
                                        d.nextScheduledRoot = null;
                                        break;
                                    } else (c.nextScheduledRoot = d.nextScheduledRoot), (d.nextScheduledRoot = null);
                                    d = c.nextScheduledRoot;
                                } else {
                                    if (0 === a || e < a) (a = e), (b = d);
                                    if (d === E) break;
                                    c = d;
                                    d = d.nextScheduledRoot;
                                }
                            }
                        c = P;
                        null !== c && c === b && 1 === a ? cc++ : (cc = 0);
                        P = b;
                        I = a;
                    }
                    function Oh(a) {
                        vb(0, !0, a);
                    }
                    function ub() {
                        vb(1, !1, null);
                    }
                    function vb(a, b, c) {
                        wb = c;
                        Ed();
                        if (b)
                            for (; null !== P && 0 !== I && (0 === a || a >= I) && (!hc || ba() >= I); ) {
                                ba(), gc(P, I, !hc), Ed();
                            }
                        else
                            for (; null !== P && 0 !== I && (0 === a || a >= I); ) {
                                gc(P, I, !1), Ed();
                            }
                        null !== wb && ((dc = 0), (ec = null));
                        0 !== I && sg(I);
                        wb = null;
                        hc = !1;
                        tg();
                    }
                    function ug(a, b) {
                        Q ? m("253") : void 0;
                        P = a;
                        I = b;
                        gc(a, b, !1);
                        ub();
                        tg();
                    }
                    function tg() {
                        cc = 0;
                        if (null !== Oa) {
                            var a = Oa;
                            Oa = null;
                            for (var b = 0; b < a.length; b++) {
                                var c = a[b];
                                try {
                                    c._onComplete();
                                } catch (d) {
                                    Pa || ((Pa = !0), (ic = d));
                                }
                            }
                        }
                        if (Pa) throw ((a = ic), (ic = null), (Pa = !1), a);
                    }
                    function gc(a, b, c) {
                        Q ? m("245") : void 0;
                        Q = !0;
                        c
                            ? ((c = a.finishedWork), null !== c ? jc(a, c, b) : ((c = ng(a, b, !0)), null !== c && (pg() ? (a.finishedWork = c) : jc(a, c, b))))
                            : ((c = a.finishedWork), null !== c ? jc(a, c, b) : ((c = ng(a, b, !1)), null !== c && jc(a, c, b)));
                        Q = !1;
                    }
                    function jc(a, b, c) {
                        var d = a.firstBatch;
                        if (null !== d && d._expirationTime <= c && (null === Oa ? (Oa = [d]) : Oa.push(d), d._defer)) {
                            a.finishedWork = b;
                            a.remainingExpirationTime = 0;
                            return;
                        }
                        a.finishedWork = null;
                        tb = aa = !0;
                        c = b.stateNode;
                        c.current === b ? m("177") : void 0;
                        d = c.pendingCommitExpirationTime;
                        0 === d ? m("261") : void 0;
                        c.pendingCommitExpirationTime = 0;
                        ba();
                        sd.current = null;
                        if (1 < b.effectTag) {
                            if (null !== b.lastEffect) {
                                b.lastEffect.nextEffect = b;
                                var e = b.firstEffect;
                            } else e = b;
                        } else e = b.firstEffect;
                        Fd = cb;
                        var f = Qc();
                        if (Oc(f)) {
                            if ("selectionStart" in f) var g = { start: f.selectionStart, end: f.selectionEnd };
                            else
                                a: {
                                    var h = window.getSelection && window.getSelection();
                                    if (h && 0 !== h.rangeCount) {
                                        g = h.anchorNode;
                                        var k = h.anchorOffset,
                                            p = h.focusNode;
                                        h = h.focusOffset;
                                        try {
                                            g.nodeType, p.nodeType;
                                        } catch (Qa) {
                                            g = null;
                                            break a;
                                        }
                                        var r = 0,
                                            v = -1,
                                            x = -1,
                                            D = 0,
                                            F = 0,
                                            u = f,
                                            w = null;
                                        b: for (;;) {
                                            for (var t; ; ) {
                                                u !== g || (0 !== k && 3 !== u.nodeType) || (v = r + k);
                                                u !== p || (0 !== h && 3 !== u.nodeType) || (x = r + h);
                                                3 === u.nodeType && (r += u.nodeValue.length);
                                                if (null === (t = u.firstChild)) break;
                                                w = u;
                                                u = t;
                                            }
                                            for (;;) {
                                                if (u === f) break b;
                                                w === g && ++D === k && (v = r);
                                                w === p && ++F === h && (x = r);
                                                if (null !== (t = u.nextSibling)) break;
                                                u = w;
                                                w = u.parentNode;
                                            }
                                            u = t;
                                        }
                                        g = -1 === v || -1 === x ? null : { start: v, end: x };
                                    } else g = null;
                                }
                            g = g || { start: 0, end: 0 };
                        } else g = null;
                        Gd = { focusedElem: f, selectionRange: g };
                        Nc(!1);
                        for (l = e; null !== l; ) {
                            f = !1;
                            g = void 0;
                            try {
                                for (; null !== l; ) {
                                    if (l.effectTag & 256) {
                                        var q = l.alternate;
                                        k = l;
                                        switch (k.tag) {
                                            case 2:
                                                if (k.effectTag & 256 && null !== q) {
                                                    var A = q.memoizedProps,
                                                        J = q.memoizedState,
                                                        y = k.stateNode;
                                                    y.props = k.memoizedProps;
                                                    y.state = k.memoizedState;
                                                    var H = y.getSnapshotBeforeUpdate(A, J);
                                                    y.__reactInternalSnapshotBeforeUpdate = H;
                                                }
                                                break;
                                            case 3:
                                            case 5:
                                            case 6:
                                            case 4:
                                                break;
                                            default:
                                                m("163");
                                        }
                                    }
                                    l = l.nextEffect;
                                }
                            } catch (Qa) {
                                (f = !0), (g = Qa);
                            }
                            f && (null === l ? m("178") : void 0, qb(l, g), null !== l && (l = l.nextEffect));
                        }
                        for (l = e; null !== l; ) {
                            q = !1;
                            A = void 0;
                            try {
                                for (; null !== l; ) {
                                    var B = l.effectTag;
                                    B & 16 && ib(l.stateNode, "");
                                    if (B & 128) {
                                        var C = l.alternate;
                                        if (null !== C) {
                                            var n = C.ref;
                                            null !== n && ("function" === typeof n ? n(null) : (n.current = null));
                                        }
                                    }
                                    switch (B & 14) {
                                        case 2:
                                            hg(l);
                                            l.effectTag &= -3;
                                            break;
                                        case 6:
                                            hg(l);
                                            l.effectTag &= -3;
                                            ig(l.alternate, l);
                                            break;
                                        case 4:
                                            ig(l.alternate, l);
                                            break;
                                        case 8:
                                            (J = l), fg(J), (J["return"] = null), (J.child = null), J.alternate && ((J.alternate.child = null), (J.alternate["return"] = null));
                                    }
                                    l = l.nextEffect;
                                }
                            } catch (Qa) {
                                (q = !0), (A = Qa);
                            }
                            q && (null === l ? m("178") : void 0, qb(l, A), null !== l && (l = l.nextEffect));
                        }
                        n = Gd;
                        C = Qc();
                        B = n.focusedElem;
                        q = n.selectionRange;
                        if (C !== B && Ph(document.documentElement, B)) {
                            null !== q &&
                                Oc(B) &&
                                ((C = q.start),
                                (n = q.end),
                                void 0 === n && (n = C),
                                "selectionStart" in B
                                    ? ((B.selectionStart = C), (B.selectionEnd = Math.min(n, B.value.length)))
                                    : window.getSelection &&
                                      ((C = window.getSelection()),
                                      (A = B[ge()].length),
                                      (n = Math.min(q.start, A)),
                                      (q = void 0 === q.end ? n : Math.min(q.end, A)),
                                      !C.extend && n > q && ((A = q), (q = n), (n = A)),
                                      (A = gf(B, n)),
                                      (J = gf(B, q)),
                                      A &&
                                          J &&
                                          (1 !== C.rangeCount || C.anchorNode !== A.node || C.anchorOffset !== A.offset || C.focusNode !== J.node || C.focusOffset !== J.offset) &&
                                          ((y = document.createRange()), y.setStart(A.node, A.offset), C.removeAllRanges(), n > q ? (C.addRange(y), C.extend(J.node, J.offset)) : (y.setEnd(J.node, J.offset), C.addRange(y)))));
                            C = [];
                            for (n = B; (n = n.parentNode); ) {
                                1 === n.nodeType && C.push({ element: n, left: n.scrollLeft, top: n.scrollTop });
                            }
                            "function" === typeof B.focus && B.focus();
                            for (B = 0; B < C.length; B++) {
                                (n = C[B]), (n.element.scrollLeft = n.left), (n.element.scrollTop = n.top);
                            }
                        }
                        Gd = null;
                        Nc(Fd);
                        Fd = null;
                        c.current = b;
                        for (l = e; null !== l; ) {
                            e = !1;
                            B = void 0;
                            try {
                                for (C = d; null !== l; ) {
                                    var G = l.effectTag;
                                    if (G & 36) {
                                        var E = l.alternate;
                                        n = l;
                                        q = C;
                                        switch (n.tag) {
                                            case 2:
                                                var z = n.stateNode;
                                                if (n.effectTag & 4)
                                                    if (null === E) (z.props = n.memoizedProps), (z.state = n.memoizedState), z.componentDidMount();
                                                    else {
                                                        var L = E.memoizedProps,
                                                            N = E.memoizedState;
                                                        z.props = n.memoizedProps;
                                                        z.state = n.memoizedState;
                                                        z.componentDidUpdate(L, N, z.__reactInternalSnapshotBeforeUpdate);
                                                    }
                                                var K = n.updateQueue;
                                                null !== K && ((z.props = n.memoizedProps), (z.state = n.memoizedState), Lf(n, K, z, q));
                                                break;
                                            case 3:
                                                var M = n.updateQueue;
                                                if (null !== M) {
                                                    A = null;
                                                    if (null !== n.child)
                                                        switch (n.child.tag) {
                                                            case 5:
                                                                A = n.child.stateNode;
                                                                break;
                                                            case 2:
                                                                A = n.child.stateNode;
                                                        }
                                                    Lf(n, M, A, q);
                                                }
                                                break;
                                            case 5:
                                                var P = n.stateNode;
                                                null === E && n.effectTag & 4 && xf(n.type, n.memoizedProps) && P.focus();
                                                break;
                                            case 6:
                                                break;
                                            case 4:
                                                break;
                                            case 15:
                                                break;
                                            case 16:
                                                break;
                                            default:
                                                m("163");
                                        }
                                    }
                                    if (G & 128) {
                                        n = void 0;
                                        var I = l.ref;
                                        if (null !== I) {
                                            var O = l.stateNode;
                                            switch (l.tag) {
                                                case 5:
                                                    n = O;
                                                    break;
                                                default:
                                                    n = O;
                                            }
                                            "function" === typeof I ? I(n) : (I.current = n);
                                        }
                                    }
                                    var Q = l.nextEffect;
                                    l.nextEffect = null;
                                    l = Q;
                                }
                            } catch (Qa) {
                                (e = !0), (B = Qa);
                            }
                            e && (null === l ? m("178") : void 0, qb(l, B), null !== l && (l = l.nextEffect));
                        }
                        aa = tb = !1;
                        "function" === typeof Ef && Ef(b.stateNode);
                        b = c.current.expirationTime;
                        0 === b && (ja = null);
                        a.remainingExpirationTime = b;
                    }
                    function pg() {
                        return null === wb || wb.timeRemaining() > Qh ? !1 : (hc = !0);
                    }
                    function wd(a) {
                        null === P ? m("246") : void 0;
                        P.remainingExpirationTime = 0;
                        Pa || ((Pa = !0), (ic = a));
                    }
                    function Kh(a) {
                        null === P ? m("246") : void 0;
                        P.remainingExpirationTime = a;
                    }
                    function vg(a, b) {
                        var c = H;
                        H = !0;
                        try {
                            return a(b);
                        } finally {
                            (H = c) || Q || ub();
                        }
                    }
                    function Hd(a, b) {
                        if (H && !fc) {
                            fc = !0;
                            try {
                                return a(b);
                            } finally {
                                fc = !1;
                            }
                        }
                        return a(b);
                    }
                    function wg(a, b) {
                        Q ? m("187") : void 0;
                        var c = H;
                        H = !0;
                        try {
                            return Dd(a, b);
                        } finally {
                            (H = c), ub();
                        }
                    }
                    function xg(a, b, c) {
                        if (Na) return a(b, c);
                        H || Q || 0 === ca || (vb(ca, !1, null), (ca = 0));
                        var d = Na,
                            e = H;
                        H = Na = !0;
                        try {
                            return a(b, c);
                        } finally {
                            (Na = d), (H = e) || Q || ub();
                        }
                    }
                    function yg(a) {
                        var b = H;
                        H = !0;
                        try {
                            Dd(a);
                        } finally {
                            (H = b) || Q || vb(1, !1, null);
                        }
                    }
                    function Id(a, b, c, d, e) {
                        var f = b.current;
                        if (c) {
                            c = c._reactInternalFiber;
                            var g;
                            b: {
                                2 === bb(c) && 2 === c.tag ? void 0 : m("170");
                                for (g = c; 3 !== g.tag; ) {
                                    if (jb(g)) {
                                        g = g.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break b;
                                    }
                                    (g = g["return"]) ? void 0 : m("171");
                                }
                                g = g.stateNode.context;
                            }
                            c = jb(c) ? Af(c, g) : g;
                        } else c = Y;
                        null === b.context ? (b.context = c) : (b.pendingContext = c);
                        b = e;
                        e = Ja(d);
                        e.payload = { element: a };
                        b = void 0 === b ? null : b;
                        null !== b && (e.callback = b);
                        oa(f, e, d);
                        ra(f, d);
                        return d;
                    }
                    function zg(a) {
                        var b = a._reactInternalFiber;
                        void 0 === b && ("function" === typeof a.render ? m("188") : m("268", Object.keys(a)));
                        a = We(b);
                        return null === a ? null : a.stateNode;
                    }
                    function kc(a, b, c, d) {
                        var e = b.current,
                            f = ba();
                        e = bc(f, e);
                        return Id(a, b, c, e, d);
                    }
                    function lc(a) {
                        a = a.current;
                        if (!a.child) return null;
                        switch (a.child.tag) {
                            case 5:
                                return a.child.stateNode;
                            default:
                                return a.child.stateNode;
                        }
                    }
                    function Ag(a) {
                        var b = a.findFiberByHostInstance;
                        return wh(
                            G({}, a, {
                                findHostInstanceByFiber: function findHostInstanceByFiber(a) {
                                    a = We(a);
                                    return null === a ? null : a.stateNode;
                                },
                                findFiberByHostInstance: function findFiberByHostInstance(a) {
                                    return b ? b(a) : null;
                                },
                            })
                        );
                    }
                    function Rh(a, b, c) {
                        var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
                        return { $$typeof: Da, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };
                    }
                    function xb(a) {
                        this._expirationTime = qg();
                        this._root = a;
                        this._callbacks = this._next = null;
                        this._hasChildren = this._didComplete = !1;
                        this._children = null;
                        this._defer = !0;
                    }
                    function Ra() {
                        this._callbacks = null;
                        this._didCommit = !1;
                        this._onCommit = this._onCommit.bind(this);
                    }
                    function Sa(a, b, c) {
                        this._internalRoot = Cf(a, b, c);
                    }
                    function Jd(a) {
                        return !(!a || (1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue)));
                    }
                    function Sh(a, b) {
                        b || ((b = a ? (9 === a.nodeType ? a.documentElement : a.firstChild) : null), (b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot"))));
                        if (!b)
                            for (var c; (c = a.lastChild); ) {
                                a.removeChild(c);
                            }
                        return new Sa(a, !1, b);
                    }
                    function mc(a, b, c, d, e) {
                        Jd(c) ? void 0 : m("200");
                        var f = c._reactRootContainer;
                        if (f) {
                            if ("function" === typeof e) {
                                var g = e;
                                e = function e() {
                                    var a = lc(f._internalRoot);
                                    g.call(a);
                                };
                            }
                            null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
                        } else {
                            f = c._reactRootContainer = Sh(c, d);
                            if ("function" === typeof e) {
                                var h = e;
                                e = function e() {
                                    var a = lc(f._internalRoot);
                                    h.call(a);
                                };
                            }
                            Hd(function () {
                                null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
                            });
                        }
                        return lc(f._internalRoot);
                    }
                    function Bg(a, b) {
                        var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
                        Jd(b) ? void 0 : m("200");
                        return Rh(a, b, null, c);
                    }
                    var Tg = function Tg(a, b, c, d, e, f, g, h) {
                        if (!a) {
                            if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
                            else {
                                var k = [c, d, e, f, g, h],
                                    l = 0;
                                a = Error(
                                    b.replace(/%s/g, function () {
                                        return k[l++];
                                    })
                                );
                                a.name = "Invariant Violation";
                            }
                            a.framesToPop = 1;
                            throw a;
                        }
                    };
                    ma ? void 0 : m("227");
                    var Th = function Th(a, b, c, d, e, f, g, h, k) {
                            this._hasCaughtError = !1;
                            this._caughtError = null;
                            var l = Array.prototype.slice.call(arguments, 3);
                            try {
                                b.apply(c, l);
                            } catch (xh) {
                                (this._caughtError = xh), (this._hasCaughtError = !0);
                            }
                        },
                        r = {
                            _caughtError: null,
                            _hasCaughtError: !1,
                            _rethrowError: null,
                            _hasRethrowError: !1,
                            invokeGuardedCallback: function invokeGuardedCallback(a, b, c, d, e, f, g, h, k) {
                                Th.apply(r, arguments);
                            },
                            invokeGuardedCallbackAndCatchFirstError: function invokeGuardedCallbackAndCatchFirstError(a, b, c, d, e, f, g, h, k) {
                                r.invokeGuardedCallback.apply(this, arguments);
                                if (r.hasCaughtError()) {
                                    var l = r.clearCaughtError();
                                    r._hasRethrowError || ((r._hasRethrowError = !0), (r._rethrowError = l));
                                }
                            },
                            rethrowCaughtError: function rethrowCaughtError() {
                                return Uh.apply(r, arguments);
                            },
                            hasCaughtError: function hasCaughtError() {
                                return r._hasCaughtError;
                            },
                            clearCaughtError: function clearCaughtError() {
                                if (r._hasCaughtError) {
                                    var a = r._caughtError;
                                    r._caughtError = null;
                                    r._hasCaughtError = !1;
                                    return a;
                                }
                                m("198");
                            },
                        },
                        Uh = function Uh() {
                            if (r._hasRethrowError) {
                                var a = r._rethrowError;
                                r._rethrowError = null;
                                r._hasRethrowError = !1;
                                throw a;
                            }
                        },
                        Eb = null,
                        ua = {},
                        Ua = [],
                        vc = {},
                        na = {},
                        Fb = {},
                        Vh = { plugins: Ua, eventNameDispatchConfigs: vc, registrationNameModules: na, registrationNameDependencies: Fb, possibleRegistrationNames: null, injectEventPluginOrder: Ud, injectEventPluginsByName: Vd },
                        ta = function ta() {};
                    ta.thatReturns = Gb;
                    ta.thatReturnsFalse = Gb(!1);
                    ta.thatReturnsTrue = Gb(!0);
                    ta.thatReturnsNull = Gb(null);
                    ta.thatReturnsThis = function () {
                        return this;
                    };
                    ta.thatReturnsArgument = function (a) {
                        return a;
                    };
                    var M = ta,
                        xc = null,
                        qe = null,
                        Xd = null,
                        Wa = null,
                        Cg = function Cg(a, b) {
                            if (a) {
                                var c = a._dispatchListeners,
                                    d = a._dispatchInstances;
                                if (Array.isArray(c))
                                    for (var e = 0; e < c.length && !a.isPropagationStopped(); e++) {
                                        Wd(a, b, c[e], d[e]);
                                    }
                                else c && Wd(a, b, c, d);
                                a._dispatchListeners = null;
                                a._dispatchInstances = null;
                                a.isPersistent() || a.constructor.release(a);
                            }
                        },
                        Ug = function Ug(a) {
                            return Cg(a, !0);
                        },
                        Vg = function Vg(a) {
                            return Cg(a, !1);
                        },
                        Kd = { injectEventPluginOrder: Ud, injectEventPluginsByName: Vd },
                        Wh = { injection: Kd, getListener: wc, runEventsInBatch: yc, runExtractedEventsInBatch: Yd },
                        Dg = Math.random().toString(36).slice(2),
                        wa = "__reactInternalInstance$" + Dg,
                        ae = "__reactEventHandlers$" + Dg,
                        Eg = {
                            precacheFiberNode: Zd,
                            getClosestInstanceFromNode: Xa,
                            getInstanceFromNode: function getInstanceFromNode(a) {
                                a = a[wa];
                                return !a || (5 !== a.tag && 6 !== a.tag) ? null : a;
                            },
                            getNodeFromInstance: xa,
                            getFiberCurrentPropsFromNode: $d,
                            updateFiberProps: be,
                        },
                        Xh = {
                            accumulateTwoPhaseDispatches: ya,
                            accumulateTwoPhaseDispatchesSkipTarget: function accumulateTwoPhaseDispatchesSkipTarget(a) {
                                Va(a, Xg);
                            },
                            accumulateEnterLeaveDispatches: ee,
                            accumulateDirectDispatches: function accumulateDirectDispatches(a) {
                                Va(a, Yg);
                            },
                        },
                        nc = !("undefined" === typeof window || !window.document || !window.document.createElement),
                        T = { canUseDOM: nc, canUseWorkers: "undefined" !== typeof Worker, canUseEventListeners: nc && !(!window.addEventListener && !window.attachEvent), canUseViewport: nc && !!window.screen, isInWorker: !nc },
                        za = { animationend: Hb("Animation", "AnimationEnd"), animationiteration: Hb("Animation", "AnimationIteration"), animationstart: Hb("Animation", "AnimationStart"), transitionend: Hb("Transition", "TransitionEnd") },
                        Ac = {},
                        fe = {};
                    T.canUseDOM &&
                        ((fe = document.createElement("div").style),
                        "AnimationEvent" in window || (delete za.animationend.animation, delete za.animationiteration.animation, delete za.animationstart.animation),
                        "TransitionEvent" in window || delete za.transitionend.transition);
                    var Fg = Ib("animationend"),
                        Gg = Ib("animationiteration"),
                        Hg = Ib("animationstart"),
                        Ig = Ib("transitionend"),
                        gb = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(
                            " "
                        ),
                        Bc = null,
                        z = { _root: null, _startText: null, _fallbackText: null },
                        G = ma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.assign,
                        Jg = "dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),
                        Yh = {
                            type: null,
                            target: null,
                            currentTarget: M.thatReturnsNull,
                            eventPhase: null,
                            bubbles: null,
                            cancelable: null,
                            timeStamp: function timeStamp(a) {
                                return a.timeStamp || Date.now();
                            },
                            defaultPrevented: null,
                            isTrusted: null,
                        };
                    G(L.prototype, {
                        preventDefault: function preventDefault() {
                            this.defaultPrevented = !0;
                            var a = this.nativeEvent;
                            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), (this.isDefaultPrevented = M.thatReturnsTrue));
                        },
                        stopPropagation: function stopPropagation() {
                            var a = this.nativeEvent;
                            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), (this.isPropagationStopped = M.thatReturnsTrue));
                        },
                        persist: function persist() {
                            this.isPersistent = M.thatReturnsTrue;
                        },
                        isPersistent: M.thatReturnsFalse,
                        destructor: function destructor() {
                            var a = this.constructor.Interface,
                                b;
                            for (b in a) {
                                this[b] = null;
                            }
                            for (a = 0; a < Jg.length; a++) {
                                this[Jg[a]] = null;
                            }
                        },
                    });
                    L.Interface = Yh;
                    L.extend = function (a) {
                        function b() {
                            return c.apply(this, arguments);
                        }
                        var c = this,
                            d = function d() {};
                        d.prototype = c.prototype;
                        d = new d();
                        G(d, b.prototype);
                        b.prototype = d;
                        b.prototype.constructor = b;
                        b.Interface = G({}, c.Interface, a);
                        b.extend = c.extend;
                        je(b);
                        return b;
                    };
                    je(L);
                    var Zh = L.extend({ data: null }),
                        $h = L.extend({ data: null }),
                        ah = [9, 13, 27, 32],
                        Cc = T.canUseDOM && "CompositionEvent" in window,
                        yb = null;
                    T.canUseDOM && "documentMode" in document && (yb = document.documentMode);
                    var ai = T.canUseDOM && "TextEvent" in window && !yb,
                        oe = T.canUseDOM && (!Cc || (yb && 8 < yb && 11 >= yb)),
                        ne = String.fromCharCode(32),
                        da = {
                            beforeInput: { phasedRegistrationNames: { bubbled: "onBeforeInput", captured: "onBeforeInputCapture" }, dependencies: ["compositionend", "keypress", "textInput", "paste"] },
                            compositionEnd: { phasedRegistrationNames: { bubbled: "onCompositionEnd", captured: "onCompositionEndCapture" }, dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ") },
                            compositionStart: { phasedRegistrationNames: { bubbled: "onCompositionStart", captured: "onCompositionStartCapture" }, dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ") },
                            compositionUpdate: { phasedRegistrationNames: { bubbled: "onCompositionUpdate", captured: "onCompositionUpdateCapture" }, dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ") },
                        },
                        me = !1,
                        Aa = !1,
                        bi = {
                            eventTypes: da,
                            extractEvents: function extractEvents(a, b, c, d) {
                                var e = void 0;
                                var f = void 0;
                                if (Cc)
                                    b: {
                                        switch (a) {
                                            case "compositionstart":
                                                e = da.compositionStart;
                                                break b;
                                            case "compositionend":
                                                e = da.compositionEnd;
                                                break b;
                                            case "compositionupdate":
                                                e = da.compositionUpdate;
                                                break b;
                                        }
                                        e = void 0;
                                    }
                                else Aa ? ke(a, c) && (e = da.compositionEnd) : "keydown" === a && 229 === c.keyCode && (e = da.compositionStart);
                                e
                                    ? (oe && (Aa || e !== da.compositionStart ? e === da.compositionEnd && Aa && (f = he()) : ((z._root = d), (z._startText = ie()), (Aa = !0))),
                                      (e = Zh.getPooled(e, b, c, d)),
                                      f ? (e.data = f) : ((f = le(c)), null !== f && (e.data = f)),
                                      ya(e),
                                      (f = e))
                                    : (f = null);
                                (a = ai ? bh(a, c) : ch(a, c)) ? ((b = $h.getPooled(da.beforeInput, b, c, d)), (b.data = a), ya(b)) : (b = null);
                                return null === f ? b : null === b ? f : [f, b];
                            },
                        },
                        Jb = null,
                        Ba = null,
                        Ca = null,
                        Kg = {
                            injectFiberControlledHostComponent: function injectFiberControlledHostComponent(a) {
                                Jb = a;
                            },
                        },
                        ci = { injection: Kg, enqueueStateRestore: re, needsStateRestore: se, restoreStateIfNeeded: te },
                        ve = function ve(a, b) {
                            return a(b);
                        },
                        af = function af(a, b, c) {
                            return a(b, c);
                        },
                        we = function we() {},
                        Dc = !1,
                        dh = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 },
                        sd = ma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
                        V = "function" === typeof Symbol && Symbol["for"],
                        Yb = V ? Symbol["for"]("react.element") : 60103,
                        Da = V ? Symbol["for"]("react.portal") : 60106,
                        ea = V ? Symbol["for"]("react.fragment") : 60107,
                        Fe = V ? Symbol["for"]("react.strict_mode") : 60108,
                        Fc = V ? Symbol["for"]("react.profiler") : 60114,
                        Ee = V ? Symbol["for"]("react.provider") : 60109,
                        De = V ? Symbol["for"]("react.context") : 60110,
                        Ce = V ? Symbol["for"]("react.async_mode") : 60111,
                        He = V ? Symbol["for"]("react.forward_ref") : 60112,
                        Ge = V ? Symbol["for"]("react.timeout") : 60113,
                        Be = "function" === typeof Symbol && Symbol.iterator,
                        gh = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
                        Je = Object.prototype.hasOwnProperty,
                        Le = {},
                        Ke = {},
                        u = {};
                    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
                        u[a] = new N(a, 0, !1, a, null);
                    });
                    [
                        ["acceptCharset", "accept-charset"],
                        ["className", "class"],
                        ["htmlFor", "for"],
                        ["httpEquiv", "http-equiv"],
                    ].forEach(function (a) {
                        var b = a[0];
                        u[b] = new N(b, 1, !1, a[1], null);
                    });
                    ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
                        u[a] = new N(a, 2, !1, a.toLowerCase(), null);
                    });
                    ["autoReverse", "externalResourcesRequired", "preserveAlpha"].forEach(function (a) {
                        u[a] = new N(a, 2, !1, a, null);
                    });
                    "allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
                        .split(" ")
                        .forEach(function (a) {
                            u[a] = new N(a, 3, !1, a.toLowerCase(), null);
                        });
                    ["checked", "multiple", "muted", "selected"].forEach(function (a) {
                        u[a] = new N(a, 3, !0, a.toLowerCase(), null);
                    });
                    ["capture", "download"].forEach(function (a) {
                        u[a] = new N(a, 4, !1, a.toLowerCase(), null);
                    });
                    ["cols", "rows", "size", "span"].forEach(function (a) {
                        u[a] = new N(a, 6, !1, a.toLowerCase(), null);
                    });
                    ["rowSpan", "start"].forEach(function (a) {
                        u[a] = new N(a, 5, !1, a.toLowerCase(), null);
                    });
                    var Ld = /[\-:]([a-z])/g,
                        Md = function Md(a) {
                            return a[1].toUpperCase();
                        };
                    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
                        .split(" ")
                        .forEach(function (a) {
                            var b = a.replace(Ld, Md);
                            u[b] = new N(b, 1, !1, a, null);
                        });
                    "xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
                        var b = a.replace(Ld, Md);
                        u[b] = new N(b, 1, !1, a, "http://www.w3.org/1999/xlink");
                    });
                    ["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
                        var b = a.replace(Ld, Md);
                        u[b] = new N(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
                    });
                    u.tabIndex = new N("tabIndex", 1, !1, "tabindex", null);
                    var Qe = { change: { phasedRegistrationNames: { bubbled: "onChange", captured: "onChangeCapture" }, dependencies: "blur change click focus input keydown keyup selectionchange".split(" ") } },
                        $a = null,
                        ab = null,
                        Nd = !1;
                    T.canUseDOM && (Nd = ye("input") && (!document.documentMode || 9 < document.documentMode));
                    var di = {
                            eventTypes: Qe,
                            _isInputEventSupported: Nd,
                            extractEvents: function extractEvents(a, b, c, d) {
                                var e = b ? xa(b) : window,
                                    f = void 0,
                                    g = void 0,
                                    h = e.nodeName && e.nodeName.toLowerCase();
                                "select" === h || ("input" === h && "file" === e.type)
                                    ? (f = kh)
                                    : xe(e)
                                    ? Nd
                                        ? (f = oh)
                                        : ((f = mh), (g = lh))
                                    : (h = e.nodeName) && "input" === h.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (f = nh);
                                if (f && (f = f(a, b))) return Pe(f, c, d);
                                g && g(a, e, b);
                                "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Kc(e, "number", e.value);
                            },
                        },
                        zb = L.extend({ view: null, detail: null }),
                        qh = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" },
                        Ab = zb.extend({
                            screenX: null,
                            screenY: null,
                            clientX: null,
                            clientY: null,
                            pageX: null,
                            pageY: null,
                            ctrlKey: null,
                            shiftKey: null,
                            altKey: null,
                            metaKey: null,
                            getModifierState: Lc,
                            button: null,
                            buttons: null,
                            relatedTarget: function relatedTarget(a) {
                                return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
                            },
                        }),
                        Lg = Ab.extend({ pointerId: null, width: null, height: null, pressure: null, tiltX: null, tiltY: null, pointerType: null, isPrimary: null }),
                        Bb = {
                            mouseEnter: { registrationName: "onMouseEnter", dependencies: ["mouseout", "mouseover"] },
                            mouseLeave: { registrationName: "onMouseLeave", dependencies: ["mouseout", "mouseover"] },
                            pointerEnter: { registrationName: "onPointerEnter", dependencies: ["pointerout", "pointerover"] },
                            pointerLeave: { registrationName: "onPointerLeave", dependencies: ["pointerout", "pointerover"] },
                        },
                        ei = {
                            eventTypes: Bb,
                            extractEvents: function extractEvents(a, b, c, d) {
                                var e = "mouseover" === a || "pointerover" === a,
                                    f = "mouseout" === a || "pointerout" === a;
                                if ((e && (c.relatedTarget || c.fromElement)) || (!f && !e)) return null;
                                e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;
                                f ? ((f = b), (b = (b = c.relatedTarget || c.toElement) ? Xa(b) : null)) : (f = null);
                                if (f === b) return null;
                                var g = void 0,
                                    h = void 0,
                                    k = void 0,
                                    l = void 0;
                                if ("mouseout" === a || "mouseover" === a) (g = Ab), (h = Bb.mouseLeave), (k = Bb.mouseEnter), (l = "mouse");
                                else if ("pointerout" === a || "pointerover" === a) (g = Lg), (h = Bb.pointerLeave), (k = Bb.pointerEnter), (l = "pointer");
                                a = null == f ? e : xa(f);
                                e = null == b ? e : xa(b);
                                h = g.getPooled(h, f, c, d);
                                h.type = l + "leave";
                                h.target = a;
                                h.relatedTarget = e;
                                c = g.getPooled(k, b, c, d);
                                c.type = l + "enter";
                                c.target = e;
                                c.relatedTarget = a;
                                ee(h, c, f, b);
                                return [h, c];
                            },
                        },
                        Qc = function Qc(a) {
                            a = a || ("undefined" !== typeof document ? document : void 0);
                            if ("undefined" === typeof a) return null;
                            try {
                                return a.activeElement || a.body;
                            } catch (b) {
                                return a.body;
                            }
                        },
                        fi = Object.prototype.hasOwnProperty,
                        Rc = function Rc(a, b) {
                            if (Te(a, b)) return !0;
                            if ("object" !== _typeof(a) || null === a || "object" !== _typeof(b) || null === b) return !1;
                            var c = Object.keys(a),
                                d = Object.keys(b);
                            if (c.length !== d.length) return !1;
                            for (d = 0; d < c.length; d++) {
                                if (!fi.call(b, c[d]) || !Te(a[c[d]], b[c[d]])) return !1;
                            }
                            return !0;
                        },
                        gi = L.extend({ animationName: null, elapsedTime: null, pseudoElement: null }),
                        hi = L.extend({
                            clipboardData: function clipboardData(a) {
                                return "clipboardData" in a ? a.clipboardData : window.clipboardData;
                            },
                        }),
                        ii = zb.extend({ relatedTarget: null }),
                        ji = {
                            Esc: "Escape",
                            Spacebar: " ",
                            Left: "ArrowLeft",
                            Up: "ArrowUp",
                            Right: "ArrowRight",
                            Down: "ArrowDown",
                            Del: "Delete",
                            Win: "OS",
                            Menu: "ContextMenu",
                            Apps: "ContextMenu",
                            Scroll: "ScrollLock",
                            MozPrintableKey: "Unidentified",
                        },
                        ki = {
                            8: "Backspace",
                            9: "Tab",
                            12: "Clear",
                            13: "Enter",
                            16: "Shift",
                            17: "Control",
                            18: "Alt",
                            19: "Pause",
                            20: "CapsLock",
                            27: "Escape",
                            32: " ",
                            33: "PageUp",
                            34: "PageDown",
                            35: "End",
                            36: "Home",
                            37: "ArrowLeft",
                            38: "ArrowUp",
                            39: "ArrowRight",
                            40: "ArrowDown",
                            45: "Insert",
                            46: "Delete",
                            112: "F1",
                            113: "F2",
                            114: "F3",
                            115: "F4",
                            116: "F5",
                            117: "F6",
                            118: "F7",
                            119: "F8",
                            120: "F9",
                            121: "F10",
                            122: "F11",
                            123: "F12",
                            144: "NumLock",
                            145: "ScrollLock",
                            224: "Meta",
                        },
                        li = zb.extend({
                            key: function key(a) {
                                if (a.key) {
                                    var b = ji[a.key] || a.key;
                                    if ("Unidentified" !== b) return b;
                                }
                                return "keypress" === a.type ? ((a = Mb(a)), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? ki[a.keyCode] || "Unidentified" : "";
                            },
                            location: null,
                            ctrlKey: null,
                            shiftKey: null,
                            altKey: null,
                            metaKey: null,
                            repeat: null,
                            locale: null,
                            getModifierState: Lc,
                            charCode: function charCode(a) {
                                return "keypress" === a.type ? Mb(a) : 0;
                            },
                            keyCode: function keyCode(a) {
                                return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
                            },
                            which: function which(a) {
                                return "keypress" === a.type ? Mb(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
                            },
                        }),
                        mi = Ab.extend({ dataTransfer: null }),
                        ni = zb.extend({ touches: null, targetTouches: null, changedTouches: null, altKey: null, metaKey: null, ctrlKey: null, shiftKey: null, getModifierState: Lc }),
                        oi = L.extend({ propertyName: null, elapsedTime: null, pseudoElement: null }),
                        pi = Ab.extend({
                            deltaX: function deltaX(a) {
                                return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
                            },
                            deltaY: function deltaY(a) {
                                return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
                            },
                            deltaZ: null,
                            deltaMode: null,
                        }),
                        qi = [
                            ["abort", "abort"],
                            [Fg, "animationEnd"],
                            [Gg, "animationIteration"],
                            [Hg, "animationStart"],
                            ["canplay", "canPlay"],
                            ["canplaythrough", "canPlayThrough"],
                            ["drag", "drag"],
                            ["dragenter", "dragEnter"],
                            ["dragexit", "dragExit"],
                            ["dragleave", "dragLeave"],
                            ["dragover", "dragOver"],
                            ["durationchange", "durationChange"],
                            ["emptied", "emptied"],
                            ["encrypted", "encrypted"],
                            ["ended", "ended"],
                            ["error", "error"],
                            ["gotpointercapture", "gotPointerCapture"],
                            ["load", "load"],
                            ["loadeddata", "loadedData"],
                            ["loadedmetadata", "loadedMetadata"],
                            ["loadstart", "loadStart"],
                            ["lostpointercapture", "lostPointerCapture"],
                            ["mousemove", "mouseMove"],
                            ["mouseout", "mouseOut"],
                            ["mouseover", "mouseOver"],
                            ["playing", "playing"],
                            ["pointermove", "pointerMove"],
                            ["pointerout", "pointerOut"],
                            ["pointerover", "pointerOver"],
                            ["progress", "progress"],
                            ["scroll", "scroll"],
                            ["seeking", "seeking"],
                            ["stalled", "stalled"],
                            ["suspend", "suspend"],
                            ["timeupdate", "timeUpdate"],
                            ["toggle", "toggle"],
                            ["touchmove", "touchMove"],
                            [Ig, "transitionEnd"],
                            ["waiting", "waiting"],
                            ["wheel", "wheel"],
                        ],
                        Ye = {},
                        Mc = {};
                    [
                        ["blur", "blur"],
                        ["cancel", "cancel"],
                        ["click", "click"],
                        ["close", "close"],
                        ["contextmenu", "contextMenu"],
                        ["copy", "copy"],
                        ["cut", "cut"],
                        ["dblclick", "doubleClick"],
                        ["dragend", "dragEnd"],
                        ["dragstart", "dragStart"],
                        ["drop", "drop"],
                        ["focus", "focus"],
                        ["input", "input"],
                        ["invalid", "invalid"],
                        ["keydown", "keyDown"],
                        ["keypress", "keyPress"],
                        ["keyup", "keyUp"],
                        ["mousedown", "mouseDown"],
                        ["mouseup", "mouseUp"],
                        ["paste", "paste"],
                        ["pause", "pause"],
                        ["play", "play"],
                        ["pointercancel", "pointerCancel"],
                        ["pointerdown", "pointerDown"],
                        ["pointerup", "pointerUp"],
                        ["ratechange", "rateChange"],
                        ["reset", "reset"],
                        ["seeked", "seeked"],
                        ["submit", "submit"],
                        ["touchcancel", "touchCancel"],
                        ["touchend", "touchEnd"],
                        ["touchstart", "touchStart"],
                        ["volumechange", "volumeChange"],
                    ].forEach(function (a) {
                        Xe(a, !0);
                    });
                    qi.forEach(function (a) {
                        Xe(a, !1);
                    });
                    var Mg = {
                            eventTypes: Ye,
                            isInteractiveTopLevelEventType: function isInteractiveTopLevelEventType(a) {
                                a = Mc[a];
                                return void 0 !== a && !0 === a.isInteractive;
                            },
                            extractEvents: function extractEvents(a, b, c, d) {
                                var e = Mc[a];
                                if (!e) return null;
                                switch (a) {
                                    case "keypress":
                                        if (0 === Mb(c)) return null;
                                    case "keydown":
                                    case "keyup":
                                        a = li;
                                        break;
                                    case "blur":
                                    case "focus":
                                        a = ii;
                                        break;
                                    case "click":
                                        if (2 === c.button) return null;
                                    case "dblclick":
                                    case "mousedown":
                                    case "mousemove":
                                    case "mouseup":
                                    case "mouseout":
                                    case "mouseover":
                                    case "contextmenu":
                                        a = Ab;
                                        break;
                                    case "drag":
                                    case "dragend":
                                    case "dragenter":
                                    case "dragexit":
                                    case "dragleave":
                                    case "dragover":
                                    case "dragstart":
                                    case "drop":
                                        a = mi;
                                        break;
                                    case "touchcancel":
                                    case "touchend":
                                    case "touchmove":
                                    case "touchstart":
                                        a = ni;
                                        break;
                                    case Fg:
                                    case Gg:
                                    case Hg:
                                        a = gi;
                                        break;
                                    case Ig:
                                        a = oi;
                                        break;
                                    case "scroll":
                                        a = zb;
                                        break;
                                    case "wheel":
                                        a = pi;
                                        break;
                                    case "copy":
                                    case "cut":
                                    case "paste":
                                        a = hi;
                                        break;
                                    case "gotpointercapture":
                                    case "lostpointercapture":
                                    case "pointercancel":
                                    case "pointerdown":
                                    case "pointermove":
                                    case "pointerout":
                                    case "pointerover":
                                    case "pointerup":
                                        a = Lg;
                                        break;
                                    default:
                                        a = L;
                                }
                                b = a.getPooled(e, b, c, d);
                                ya(b);
                                return b;
                            },
                        },
                        Ze = Mg.isInteractiveTopLevelEventType,
                        Ob = [],
                        cb = !0,
                        ri = {
                            get _enabled() {
                                return cb;
                            },
                            setEnabled: Nc,
                            isEnabled: function isEnabled() {
                                return cb;
                            },
                            trapBubbledEvent: p,
                            trapCapturedEvent: db,
                            dispatchEvent: Nb,
                        },
                        cf = {},
                        th = 0,
                        Pb = "_reactListenersID" + ("" + Math.random()).slice(2),
                        ef = function ef(a) {
                            var b = (a ? a.ownerDocument || a : document).defaultView || window;
                            return !!(a && ("function" === typeof b.Node ? a instanceof b.Node : "object" === _typeof(a) && "number" === typeof a.nodeType && "string" === typeof a.nodeName)) && 3 == a.nodeType;
                        },
                        Ph = df,
                        si = T.canUseDOM && "documentMode" in document && 11 >= document.documentMode,
                        jf = { select: { phasedRegistrationNames: { bubbled: "onSelect", captured: "onSelectCapture" }, dependencies: "blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ") } },
                        Ea = null,
                        Sc = null,
                        eb = null,
                        Pc = !1,
                        ti = {
                            eventTypes: jf,
                            extractEvents: function extractEvents(a, b, c, d) {
                                var e = d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument,
                                    f;
                                if (!(f = !e)) {
                                    a: {
                                        e = bf(e);
                                        f = Fb.onSelect;
                                        for (var g = 0; g < f.length; g++) {
                                            var h = f[g];
                                            if (!e.hasOwnProperty(h) || !e[h]) {
                                                e = !1;
                                                break a;
                                            }
                                        }
                                        e = !0;
                                    }
                                    f = !e;
                                }
                                if (f) return null;
                                e = b ? xa(b) : window;
                                switch (a) {
                                    case "focus":
                                        if (xe(e) || "true" === e.contentEditable) (Ea = e), (Sc = b), (eb = null);
                                        break;
                                    case "blur":
                                        eb = Sc = Ea = null;
                                        break;
                                    case "mousedown":
                                        Pc = !0;
                                        break;
                                    case "contextmenu":
                                    case "mouseup":
                                        return (Pc = !1), hf(c, d);
                                    case "selectionchange":
                                        if (si) break;
                                    case "keydown":
                                    case "keyup":
                                        return hf(c, d);
                                }
                                return null;
                            },
                        };
                    Kd.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
                    (function (a) {
                        xc = a.getFiberCurrentPropsFromNode;
                        qe = a.getInstanceFromNode;
                        Xd = a.getNodeFromInstance;
                    })(Eg);
                    Kd.injectEventPluginsByName({ SimpleEventPlugin: Mg, EnterLeaveEventPlugin: ei, ChangeEventPlugin: di, SelectEventPlugin: ti, BeforeInputEventPlugin: bi });
                    var Y = {},
                        Ng = "function" === typeof requestAnimationFrame ? requestAnimationFrame : void 0,
                        ui = Date,
                        vi = setTimeout,
                        wi = clearTimeout,
                        la = void 0;
                    if ("object" === (typeof performance === "undefined" ? "undefined" : _typeof(performance)) && "function" === typeof performance.now) {
                        var xi = performance;
                        la = function la() {
                            return xi.now();
                        };
                    } else
                        la = function la() {
                            return ui.now();
                        };
                    var Od = void 0,
                        oc = void 0;
                    if (T.canUseDOM) {
                        var Og =
                                "function" === typeof Ng
                                    ? Ng
                                    : function (a) {
                                          m("276");
                                      },
                            R = null,
                            pc = null,
                            Ta = -1,
                            qc = !1,
                            Cb = !1,
                            rc = 0,
                            sc = 33,
                            Db = 33,
                            tc = {
                                didTimeout: !1,
                                timeRemaining: function timeRemaining() {
                                    var a = rc - la();
                                    return 0 < a ? a : 0;
                                },
                            },
                            Pg = function Pg(a, b) {
                                var c = a.scheduledCallback,
                                    d = !1;
                                try {
                                    c(b), (d = !0);
                                } finally {
                                    oc(a), d || ((qc = !0), window.postMessage(Pd, "*"));
                                }
                            },
                            Pd = "__reactIdleCallback$" + Math.random().toString(36).slice(2);
                        window.addEventListener(
                            "message",
                            function (a) {
                                if (a.source === window && a.data === Pd && ((qc = !1), null !== R)) {
                                    if (null !== R) {
                                        var b = la();
                                        if (!(-1 === Ta || Ta > b)) {
                                            a = -1;
                                            for (var c = [], d = R; null !== d; ) {
                                                var e = d.timeoutTime;
                                                -1 !== e && e <= b ? c.push(d) : -1 !== e && (-1 === a || e < a) && (a = e);
                                                d = d.next;
                                            }
                                            if (0 < c.length)
                                                for (tc.didTimeout = !0, b = 0, d = c.length; b < d; b++) {
                                                    Pg(c[b], tc);
                                                }
                                            Ta = a;
                                        }
                                    }
                                    for (a = la(); 0 < rc - a && null !== R; ) {
                                        (a = R), (tc.didTimeout = !1), Pg(a, tc), (a = la());
                                    }
                                    null === R || Cb || ((Cb = !0), Og(Qg));
                                }
                            },
                            !1
                        );
                        var Qg = function Qg(a) {
                            Cb = !1;
                            var b = a - rc + Db;
                            b < Db && sc < Db ? (8 > b && (b = 8), (Db = b < sc ? sc : b)) : (sc = b);
                            rc = a + Db;
                            qc || ((qc = !0), window.postMessage(Pd, "*"));
                        };
                        Od = function Od(a, b) {
                            var c = -1;
                            null != b && "number" === typeof b.timeout && (c = la() + b.timeout);
                            if (-1 === Ta || (-1 !== c && c < Ta)) Ta = c;
                            a = { scheduledCallback: a, timeoutTime: c, prev: null, next: null };
                            null === R ? (R = a) : ((b = a.prev = pc), null !== b && (b.next = a));
                            pc = a;
                            Cb || ((Cb = !0), Og(Qg));
                            return a;
                        };
                        oc = function oc(a) {
                            if (null !== a.prev || R === a) {
                                var b = a.next,
                                    c = a.prev;
                                a.next = null;
                                a.prev = null;
                                null !== b ? (null !== c ? ((c.next = b), (b.prev = c)) : ((b.prev = null), (R = b))) : null !== c ? ((c.next = null), (pc = c)) : (pc = R = null);
                            }
                        };
                    } else {
                        var Qd = new Map();
                        Od = function Od(a, b) {
                            b = { scheduledCallback: a, timeoutTime: 0, next: null, prev: null };
                            var c = vi(function () {
                                a({
                                    timeRemaining: function timeRemaining() {
                                        return Infinity;
                                    },
                                    didTimeout: !1,
                                });
                            });
                            Qd.set(a, c);
                            return b;
                        };
                        oc = function oc(a) {
                            var b = Qd.get(a.scheduledCallback);
                            Qd["delete"](a);
                            wi(b);
                        };
                    }
                    var uc = void 0,
                        sf = (function (a) {
                            return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction
                                ? function (b, c, d, e) {
                                      MSApp.execUnsafeLocalFunction(function () {
                                          return a(b, c, d, e);
                                      });
                                  }
                                : a;
                        })(function (a, b) {
                            if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
                            else {
                                uc = uc || document.createElement("div");
                                uc.innerHTML = "<svg>" + b + "</svg>";
                                for (b = uc.firstChild; a.firstChild; ) {
                                    a.removeChild(a.firstChild);
                                }
                                for (; b.firstChild; ) {
                                    a.appendChild(b.firstChild);
                                }
                            }
                        }),
                        ib = function ib(a, b) {
                            if (b) {
                                var c = a.firstChild;
                                if (c && c === a.lastChild && 3 === c.nodeType) {
                                    c.nodeValue = b;
                                    return;
                                }
                            }
                            a.textContent = b;
                        },
                        fb = {
                            animationIterationCount: !0,
                            borderImageOutset: !0,
                            borderImageSlice: !0,
                            borderImageWidth: !0,
                            boxFlex: !0,
                            boxFlexGroup: !0,
                            boxOrdinalGroup: !0,
                            columnCount: !0,
                            columns: !0,
                            flex: !0,
                            flexGrow: !0,
                            flexPositive: !0,
                            flexShrink: !0,
                            flexNegative: !0,
                            flexOrder: !0,
                            gridRow: !0,
                            gridRowEnd: !0,
                            gridRowSpan: !0,
                            gridRowStart: !0,
                            gridColumn: !0,
                            gridColumnEnd: !0,
                            gridColumnSpan: !0,
                            gridColumnStart: !0,
                            fontWeight: !0,
                            lineClamp: !0,
                            lineHeight: !0,
                            opacity: !0,
                            order: !0,
                            orphans: !0,
                            tabSize: !0,
                            widows: !0,
                            zIndex: !0,
                            zoom: !0,
                            fillOpacity: !0,
                            floodOpacity: !0,
                            stopOpacity: !0,
                            strokeDasharray: !0,
                            strokeDashoffset: !0,
                            strokeMiterlimit: !0,
                            strokeOpacity: !0,
                            strokeWidth: !0,
                        },
                        yi = ["Webkit", "ms", "Moz", "O"];
                    Object.keys(fb).forEach(function (a) {
                        yi.forEach(function (b) {
                            b = b + a.charAt(0).toUpperCase() + a.substring(1);
                            fb[b] = fb[a];
                        });
                    });
                    var vh = G({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 }),
                        hb = M.thatReturns(""),
                        zi = {
                            createElement: pf,
                            createTextNode: qf,
                            setInitialProperties: rf,
                            diffProperties: tf,
                            updateProperties: uf,
                            diffHydratedProperties: vf,
                            diffHydratedText: wf,
                            warnForUnmatchedText: function warnForUnmatchedText(a, b) {},
                            warnForDeletedHydratableElement: function warnForDeletedHydratableElement(a, b) {},
                            warnForDeletedHydratableText: function warnForDeletedHydratableText(a, b) {},
                            warnForInsertedHydratedElement: function warnForInsertedHydratedElement(a, b, c) {},
                            warnForInsertedHydratedText: function warnForInsertedHydratedText(a, b) {},
                            restoreControlledState: function restoreControlledState(a, b, c) {
                                switch (b) {
                                    case "input":
                                        Jc(a, c);
                                        b = c.name;
                                        if ("radio" === c.type && null != b) {
                                            for (c = a; c.parentNode; ) {
                                                c = c.parentNode;
                                            }
                                            c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                                            for (b = 0; b < c.length; b++) {
                                                var d = c[b];
                                                if (d !== a && d.form === a.form) {
                                                    var e = $d(d);
                                                    e ? void 0 : m("90");
                                                    Ae(d);
                                                    Jc(d, e);
                                                }
                                            }
                                        }
                                        break;
                                    case "textarea":
                                        mf(a, c);
                                        break;
                                    case "select":
                                        (b = c.value), null != b && Fa(a, !!c.multiple, b, !1);
                                }
                            },
                        },
                        Dh = pf,
                        Gh = qf,
                        Eh = rf,
                        Bh = tf,
                        Hh = uf,
                        Ch = vf,
                        Fh = wf,
                        $b = Zd,
                        ud = be,
                        Fd = null,
                        Gd = null,
                        Bd = la,
                        Nh = Od,
                        Mh = oc;
                    new Set();
                    var $c = [],
                        Ga = -1,
                        X = fa(Y),
                        x = fa(!1),
                        ad = Y,
                        hd = null,
                        id = null,
                        ia = !1,
                        Mf = fa(null),
                        ld = fa(null),
                        kd = fa(0),
                        lb = {},
                        U = fa(lb),
                        nb = fa(lb),
                        mb = fa(lb),
                        Wb = {
                            isMounted: function isMounted(a) {
                                return (a = a._reactInternalFiber) ? 2 === bb(a) : !1;
                            },
                            enqueueSetState: function enqueueSetState(a, b, c) {
                                a = a._reactInternalFiber;
                                var d = ba();
                                d = bc(d, a);
                                var e = Ja(d);
                                e.payload = b;
                                void 0 !== c && null !== c && (e.callback = c);
                                oa(a, e, d);
                                ra(a, d);
                            },
                            enqueueReplaceState: function enqueueReplaceState(a, b, c) {
                                a = a._reactInternalFiber;
                                var d = ba();
                                d = bc(d, a);
                                var e = Ja(d);
                                e.tag = 1;
                                e.payload = b;
                                void 0 !== c && null !== c && (e.callback = c);
                                oa(a, e, d);
                                ra(a, d);
                            },
                            enqueueForceUpdate: function enqueueForceUpdate(a, b) {
                                a = a._reactInternalFiber;
                                var c = ba();
                                c = bc(c, a);
                                var d = Ja(c);
                                d.tag = 2;
                                void 0 !== b && null !== b && (d.callback = b);
                                oa(a, d, c);
                                ra(a, c);
                            },
                        },
                        Zb = Array.isArray,
                        Wf = Qf(!0),
                        Vf = Qf(!1),
                        Z = null,
                        Ma = null,
                        qa = !1,
                        td = void 0,
                        ag = void 0,
                        bg = void 0;
                    td = function td(a) {};
                    ag = function ag(a, b, c, d, e, f, g, h) {
                        (b.updateQueue = c) && pb(b);
                    };
                    bg = function bg(a, b, c, d) {
                        c !== d && pb(b);
                    };
                    var Cd = Bd(),
                        og = 2,
                        yd = Cd,
                        Ad = 0,
                        ka = 0,
                        aa = !1,
                        F = null,
                        rb = null,
                        K = 0,
                        ac = -1,
                        sb = !1,
                        l = null,
                        tb = !1,
                        xd = !1,
                        ja = null,
                        sa = null,
                        E = null,
                        dc = 0,
                        ec = void 0,
                        Q = !1,
                        P = null,
                        I = 0,
                        ca = 0,
                        hc = !1,
                        Pa = !1,
                        ic = null,
                        wb = null,
                        H = !1,
                        fc = !1,
                        Na = !1,
                        Oa = null,
                        Lh = 1e3,
                        cc = 0,
                        Qh = 1,
                        Ai = {
                            updateContainerAtExpirationTime: Id,
                            createContainer: function createContainer(a, b, c) {
                                return Cf(a, b, c);
                            },
                            updateContainer: kc,
                            flushRoot: ug,
                            requestWork: zd,
                            computeUniqueAsyncExpiration: qg,
                            batchedUpdates: vg,
                            unbatchedUpdates: Hd,
                            deferredUpdates: rg,
                            syncUpdates: Dd,
                            interactiveUpdates: xg,
                            flushInteractiveUpdates: function flushInteractiveUpdates() {
                                Q || 0 === ca || (vb(ca, !1, null), (ca = 0));
                            },
                            flushControlled: yg,
                            flushSync: wg,
                            getPublicRootInstance: lc,
                            findHostInstance: zg,
                            findHostInstanceWithNoPortals: function findHostInstanceWithNoPortals(a) {
                                a = rh(a);
                                return null === a ? null : a.stateNode;
                            },
                            injectIntoDevTools: Ag,
                        };
                    Kg.injectFiberControlledHostComponent(zi);
                    xb.prototype.render = function (a) {
                        this._defer ? void 0 : m("250");
                        this._hasChildren = !0;
                        this._children = a;
                        var b = this._root._internalRoot,
                            c = this._expirationTime,
                            d = new Ra();
                        Id(a, b, null, c, d._onCommit);
                        return d;
                    };
                    xb.prototype.then = function (a) {
                        if (this._didComplete) a();
                        else {
                            var b = this._callbacks;
                            null === b && (b = this._callbacks = []);
                            b.push(a);
                        }
                    };
                    xb.prototype.commit = function () {
                        var a = this._root._internalRoot,
                            b = a.firstBatch;
                        this._defer && null !== b ? void 0 : m("251");
                        if (this._hasChildren) {
                            var c = this._expirationTime;
                            if (b !== this) {
                                this._hasChildren && ((c = this._expirationTime = b._expirationTime), this.render(this._children));
                                for (var d = null, e = b; e !== this; ) {
                                    (d = e), (e = e._next);
                                }
                                null === d ? m("251") : void 0;
                                d._next = e._next;
                                this._next = b;
                                a.firstBatch = this;
                            }
                            this._defer = !1;
                            ug(a, c);
                            b = this._next;
                            this._next = null;
                            b = a.firstBatch = b;
                            null !== b && b._hasChildren && b.render(b._children);
                        } else (this._next = null), (this._defer = !1);
                    };
                    xb.prototype._onComplete = function () {
                        if (!this._didComplete) {
                            this._didComplete = !0;
                            var a = this._callbacks;
                            if (null !== a)
                                for (var b = 0; b < a.length; b++) {
                                    (0, a[b])();
                                }
                        }
                    };
                    Ra.prototype.then = function (a) {
                        if (this._didCommit) a();
                        else {
                            var b = this._callbacks;
                            null === b && (b = this._callbacks = []);
                            b.push(a);
                        }
                    };
                    Ra.prototype._onCommit = function () {
                        if (!this._didCommit) {
                            this._didCommit = !0;
                            var a = this._callbacks;
                            if (null !== a)
                                for (var b = 0; b < a.length; b++) {
                                    var c = a[b];
                                    "function" !== typeof c ? m("191", c) : void 0;
                                    c();
                                }
                        }
                    };
                    Sa.prototype.render = function (a, b) {
                        var c = this._internalRoot,
                            d = new Ra();
                        b = void 0 === b ? null : b;
                        null !== b && d.then(b);
                        kc(a, c, null, d._onCommit);
                        return d;
                    };
                    Sa.prototype.unmount = function (a) {
                        var b = this._internalRoot,
                            c = new Ra();
                        a = void 0 === a ? null : a;
                        null !== a && c.then(a);
                        kc(null, b, null, c._onCommit);
                        return c;
                    };
                    Sa.prototype.legacy_renderSubtreeIntoContainer = function (a, b, c) {
                        var d = this._internalRoot,
                            e = new Ra();
                        c = void 0 === c ? null : c;
                        null !== c && e.then(c);
                        kc(b, d, a, e._onCommit);
                        return e;
                    };
                    Sa.prototype.createBatch = function () {
                        var a = new xb(this),
                            b = a._expirationTime,
                            c = this._internalRoot,
                            d = c.firstBatch;
                        if (null === d) (c.firstBatch = a), (a._next = null);
                        else {
                            for (c = null; null !== d && d._expirationTime <= b; ) {
                                (c = d), (d = d._next);
                            }
                            a._next = d;
                            null !== c && (c._next = a);
                        }
                        return a;
                    };
                    (function (a) {
                        ve = a.batchedUpdates;
                        af = a.interactiveUpdates;
                        we = a.flushInteractiveUpdates;
                    })(Ai);
                    var Rg = {
                        createPortal: Bg,
                        findDOMNode: function findDOMNode(a) {
                            return null == a ? null : 1 === a.nodeType ? a : zg(a);
                        },
                        hydrate: function hydrate(a, b, c) {
                            return mc(null, a, b, !0, c);
                        },
                        render: function render(a, b, c) {
                            return mc(null, a, b, !1, c);
                        },
                        unstable_renderSubtreeIntoContainer: function unstable_renderSubtreeIntoContainer(a, b, c, d) {
                            null == a || void 0 === a._reactInternalFiber ? m("38") : void 0;
                            return mc(a, b, c, !1, d);
                        },
                        unmountComponentAtNode: function unmountComponentAtNode(a) {
                            Jd(a) ? void 0 : m("40");
                            return a._reactRootContainer
                                ? (Hd(function () {
                                      mc(null, null, a, !1, function () {
                                          a._reactRootContainer = null;
                                      });
                                  }),
                                  !0)
                                : !1;
                        },
                        unstable_createPortal: function unstable_createPortal() {
                            return Bg.apply(void 0, arguments);
                        },
                        unstable_batchedUpdates: vg,
                        unstable_deferredUpdates: rg,
                        unstable_interactiveUpdates: xg,
                        flushSync: wg,
                        unstable_flushControlled: yg,
                        __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { EventPluginHub: Wh, EventPluginRegistry: Vh, EventPropagators: Xh, ReactControlledComponent: ci, ReactDOMComponentTree: Eg, ReactDOMEventListener: ri },
                        unstable_createRoot: function unstable_createRoot(a, b) {
                            return new Sa(a, !0, null != b && !0 === b.hydrate);
                        },
                    };
                    Ag({ findFiberByHostInstance: Xa, bundleType: 0, version: "16.4.2", rendererPackageName: "react-dom" });
                    var Sg = { default: Rg },
                        Rd = (Sg && Rg) || Sg;
                    return Rd["default"] ? Rd["default"] : Rd;
                });
            },
            { react: 74 },
        ],
        51: [
            function (require, module, exports) {
                (function (global) {
                    /*! @vimeo/player v2.15.0 | (c) 2021 Vimeo | MIT License | https://github.com/vimeo/player.js */ (function (global, factory) {
                        _typeof(exports) === "object" && typeof module !== "undefined"
                            ? (module.exports = factory())
                            : typeof define === "function" && define.amd
                            ? define(factory)
                            : ((global = typeof globalThis !== "undefined" ? globalThis : global || self), ((global.Vimeo = global.Vimeo || {}), (global.Vimeo.Player = factory())));
                    })(this, function () {
                        "use strict";
                        function _classCallCheck(instance, Constructor) {
                            if (!(instance instanceof Constructor)) {
                                throw new TypeError("Cannot call a class as a function");
                            }
                        }
                        function _defineProperties(target, props) {
                            for (var i = 0; i < props.length; i++) {
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }
                        function _createClass(Constructor, protoProps, staticProps) {
                            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) _defineProperties(Constructor, staticProps);
                            return Constructor;
                        }
                        /**
                         * @module lib/functions
                         */ /**
                         * Check to see this is a node environment.
                         * @type {Boolean}
                         */ /* global global */ var isNode = typeof global !== "undefined" && {}.toString.call(global) === "[object global]";
                        /**
                         * Get the name of the method for a given getter or setter.
                         *
                         * @param {string} prop The name of the property.
                         * @param {string} type Either “get” or “set”.
                         * @return {string}
                         */ function getMethodName(prop, type) {
                            if (prop.indexOf(type.toLowerCase()) === 0) {
                                return prop;
                            }
                            return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
                        }
                        /**
                         * Check to see if the object is a DOM Element.
                         *
                         * @param {*} element The object to check.
                         * @return {boolean}
                         */ function isDomElement(element) {
                            return Boolean(element && element.nodeType === 1 && "nodeName" in element && element.ownerDocument && element.ownerDocument.defaultView);
                        }
                        /**
                         * Check to see whether the value is a number.
                         *
                         * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
                         * @param {*} value The value to check.
                         * @param {boolean} integer Check if the value is an integer.
                         * @return {boolean}
                         */ function isInteger(value) {
                            // eslint-disable-next-line eqeqeq
                            return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
                        }
                        /**
                         * Check to see if the URL is a Vimeo url.
                         *
                         * @param {string} url The url string.
                         * @return {boolean}
                         */ function isVimeoUrl(url) {
                            return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
                        }
                        /**
                         * Get the Vimeo URL from an element.
                         * The element must have either a data-vimeo-id or data-vimeo-url attribute.
                         *
                         * @param {object} oEmbedParameters The oEmbed parameters.
                         * @return {string}
                         */ function getVimeoUrl() {
                            var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            var id = oEmbedParameters.id;
                            var url = oEmbedParameters.url;
                            var idOrUrl = id || url;
                            if (!idOrUrl) {
                                throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
                            }
                            if (isInteger(idOrUrl)) {
                                return "https://vimeo.com/".concat(idOrUrl);
                            }
                            if (isVimeoUrl(idOrUrl)) {
                                return idOrUrl.replace("http:", "https:");
                            }
                            if (id) {
                                throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
                            }
                            throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
                        }
                        var arrayIndexOfSupport = typeof Array.prototype.indexOf !== "undefined";
                        var postMessageSupport = typeof window !== "undefined" && typeof window.postMessage !== "undefined";
                        if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
                            throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
                        }
                        var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
                        function createCommonjsModule(fn, module) {
                            return (module = { exports: {} }), fn(module, module.exports), module.exports;
                        }
                        /*!
                         * weakmap-polyfill v2.0.1 - ECMAScript6 WeakMap polyfill
                         * https://github.com/polygonplanet/weakmap-polyfill
                         * Copyright (c) 2015-2020 Polygon Planet <polygon.planet.aqua@gmail.com>
                         * @license MIT
                         */ (function (self) {
                            if (self.WeakMap) {
                                return;
                            }
                            var hasOwnProperty = Object.prototype.hasOwnProperty;
                            var defineProperty = function defineProperty(object, name, value) {
                                if (Object.defineProperty) {
                                    Object.defineProperty(object, name, { configurable: true, writable: true, value: value });
                                } else {
                                    object[name] = value;
                                }
                            };
                            self.WeakMap = (function () {
                                // ECMA-262 23.3 WeakMap Objects
                                function WeakMap() {
                                    if (this === void 0) {
                                        throw new TypeError("Constructor WeakMap requires 'new'");
                                    }
                                    defineProperty(this, "_id", genId("_WeakMap")); // ECMA-262 23.3.1.1 WeakMap([iterable])
                                    if (arguments.length > 0) {
                                        // Currently, WeakMap `iterable` argument is not supported
                                        throw new TypeError("WeakMap iterable is not supported");
                                    }
                                } // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
                                defineProperty(WeakMap.prototype, "delete", function (key) {
                                    checkInstance(this, "delete");
                                    if (!isObject(key)) {
                                        return false;
                                    }
                                    var entry = key[this._id];
                                    if (entry && entry[0] === key) {
                                        delete key[this._id];
                                        return true;
                                    }
                                    return false;
                                }); // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
                                defineProperty(WeakMap.prototype, "get", function (key) {
                                    checkInstance(this, "get");
                                    if (!isObject(key)) {
                                        return void 0;
                                    }
                                    var entry = key[this._id];
                                    if (entry && entry[0] === key) {
                                        return entry[1];
                                    }
                                    return void 0;
                                }); // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
                                defineProperty(WeakMap.prototype, "has", function (key) {
                                    checkInstance(this, "has");
                                    if (!isObject(key)) {
                                        return false;
                                    }
                                    var entry = key[this._id];
                                    if (entry && entry[0] === key) {
                                        return true;
                                    }
                                    return false;
                                }); // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
                                defineProperty(WeakMap.prototype, "set", function (key, value) {
                                    checkInstance(this, "set");
                                    if (!isObject(key)) {
                                        throw new TypeError("Invalid value used as weak map key");
                                    }
                                    var entry = key[this._id];
                                    if (entry && entry[0] === key) {
                                        entry[1] = value;
                                        return this;
                                    }
                                    defineProperty(key, this._id, [key, value]);
                                    return this;
                                });
                                function checkInstance(x, methodName) {
                                    if (!isObject(x) || !hasOwnProperty.call(x, "_id")) {
                                        throw new TypeError(methodName + " method called on incompatible receiver " + _typeof(x));
                                    }
                                }
                                function genId(prefix) {
                                    return prefix + "_" + rand() + "." + rand();
                                }
                                function rand() {
                                    return Math.random().toString().substring(2);
                                }
                                defineProperty(WeakMap, "_polyfill", true);
                                return WeakMap;
                            })();
                            function isObject(x) {
                                return Object(x) === x;
                            }
                        })(typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof commonjsGlobal !== "undefined" ? commonjsGlobal : commonjsGlobal);
                        var npo_src = createCommonjsModule(function (module) {
                            /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */ (function UMD(name, context, definition) {
                                // special form of UMD for polyfilling across evironments
                                context[name] = context[name] || definition();
                                if (module.exports) {
                                    module.exports = context[name];
                                }
                            })("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {
                                var builtInProp,
                                    cycle,
                                    scheduling_queue,
                                    ToString = Object.prototype.toString,
                                    timer =
                                        typeof setImmediate != "undefined"
                                            ? function timer(fn) {
                                                  return setImmediate(fn);
                                              }
                                            : setTimeout; // dammit, IE8.
                                try {
                                    Object.defineProperty({}, "x", {});
                                    builtInProp = function builtInProp(obj, name, val, config) {
                                        return Object.defineProperty(obj, name, { value: val, writable: true, configurable: config !== false });
                                    };
                                } catch (err) {
                                    builtInProp = function builtInProp(obj, name, val) {
                                        obj[name] = val;
                                        return obj;
                                    };
                                } // Note: using a queue instead of array for efficiency
                                scheduling_queue = (function Queue() {
                                    var first, last, item;
                                    function Item(fn, self) {
                                        this.fn = fn;
                                        this.self = self;
                                        this.next = void 0;
                                    }
                                    return {
                                        add: function add(fn, self) {
                                            item = new Item(fn, self);
                                            if (last) {
                                                last.next = item;
                                            } else {
                                                first = item;
                                            }
                                            last = item;
                                            item = void 0;
                                        },
                                        drain: function drain() {
                                            var f = first;
                                            first = last = cycle = void 0;
                                            while (f) {
                                                f.fn.call(f.self);
                                                f = f.next;
                                            }
                                        },
                                    };
                                })();
                                function schedule(fn, self) {
                                    scheduling_queue.add(fn, self);
                                    if (!cycle) {
                                        cycle = timer(scheduling_queue.drain);
                                    }
                                } // promise duck typing
                                function isThenable(o) {
                                    var _then,
                                        o_type = _typeof(o);
                                    if (o != null && (o_type == "object" || o_type == "function")) {
                                        _then = o.then;
                                    }
                                    return typeof _then == "function" ? _then : false;
                                }
                                function notify() {
                                    for (var i = 0; i < this.chain.length; i++) {
                                        notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
                                    }
                                    this.chain.length = 0;
                                } // NOTE: This is a separate function to isolate
                                // the `try..catch` so that other code can be
                                // optimized better
                                function notifyIsolated(self, cb, chain) {
                                    var ret, _then;
                                    try {
                                        if (cb === false) {
                                            chain.reject(self.msg);
                                        } else {
                                            if (cb === true) {
                                                ret = self.msg;
                                            } else {
                                                ret = cb.call(void 0, self.msg);
                                            }
                                            if (ret === chain.promise) {
                                                chain.reject(TypeError("Promise-chain cycle"));
                                            } else if ((_then = isThenable(ret))) {
                                                _then.call(ret, chain.resolve, chain.reject);
                                            } else {
                                                chain.resolve(ret);
                                            }
                                        }
                                    } catch (err) {
                                        chain.reject(err);
                                    }
                                }
                                function resolve(msg) {
                                    var _then,
                                        self = this; // already triggered?
                                    if (self.triggered) {
                                        return;
                                    }
                                    self.triggered = true; // unwrap
                                    if (self.def) {
                                        self = self.def;
                                    }
                                    try {
                                        if ((_then = isThenable(msg))) {
                                            schedule(function () {
                                                var def_wrapper = new MakeDefWrapper(self);
                                                try {
                                                    _then.call(
                                                        msg,
                                                        function $resolve$() {
                                                            resolve.apply(def_wrapper, arguments);
                                                        },
                                                        function $reject$() {
                                                            reject.apply(def_wrapper, arguments);
                                                        }
                                                    );
                                                } catch (err) {
                                                    reject.call(def_wrapper, err);
                                                }
                                            });
                                        } else {
                                            self.msg = msg;
                                            self.state = 1;
                                            if (self.chain.length > 0) {
                                                schedule(notify, self);
                                            }
                                        }
                                    } catch (err) {
                                        reject.call(new MakeDefWrapper(self), err);
                                    }
                                }
                                function reject(msg) {
                                    var self = this; // already triggered?
                                    if (self.triggered) {
                                        return;
                                    }
                                    self.triggered = true; // unwrap
                                    if (self.def) {
                                        self = self.def;
                                    }
                                    self.msg = msg;
                                    self.state = 2;
                                    if (self.chain.length > 0) {
                                        schedule(notify, self);
                                    }
                                }
                                function iteratePromises(Constructor, arr, resolver, rejecter) {
                                    for (var idx = 0; idx < arr.length; idx++) {
                                        (function IIFE(idx) {
                                            Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
                                                resolver(idx, msg);
                                            }, rejecter);
                                        })(idx);
                                    }
                                }
                                function MakeDefWrapper(self) {
                                    this.def = self;
                                    this.triggered = false;
                                }
                                function MakeDef(self) {
                                    this.promise = self;
                                    this.state = 0;
                                    this.triggered = false;
                                    this.chain = [];
                                    this.msg = void 0;
                                }
                                function Promise(executor) {
                                    if (typeof executor != "function") {
                                        throw TypeError("Not a function");
                                    }
                                    if (this.__NPO__ !== 0) {
                                        throw TypeError("Not a promise");
                                    } // instance shadowing the inherited "brand"
                                    // to signal an already "initialized" promise
                                    this.__NPO__ = 1;
                                    var def = new MakeDef(this);
                                    this["then"] = function then(success, failure) {
                                        var o = { success: typeof success == "function" ? success : true, failure: typeof failure == "function" ? failure : false }; // Note: `then(..)` itself can be borrowed to be used against
                                        // a different promise constructor for making the chained promise,
                                        // by substituting a different `this` binding.
                                        o.promise = new this.constructor(function extractChain(resolve, reject) {
                                            if (typeof resolve != "function" || typeof reject != "function") {
                                                throw TypeError("Not a function");
                                            }
                                            o.resolve = resolve;
                                            o.reject = reject;
                                        });
                                        def.chain.push(o);
                                        if (def.state !== 0) {
                                            schedule(notify, def);
                                        }
                                        return o.promise;
                                    };
                                    this["catch"] = function $catch$(failure) {
                                        return this.then(void 0, failure);
                                    };
                                    try {
                                        executor.call(
                                            void 0,
                                            function publicResolve(msg) {
                                                resolve.call(def, msg);
                                            },
                                            function publicReject(msg) {
                                                reject.call(def, msg);
                                            }
                                        );
                                    } catch (err) {
                                        reject.call(def, err);
                                    }
                                }
                                var PromisePrototype = builtInProp({}, "constructor", Promise, /*configurable=*/ false); // Note: Android 4 cannot use `Object.defineProperty(..)` here
                                Promise.prototype = PromisePrototype; // built-in "brand" to signal an "uninitialized" promise
                                builtInProp(PromisePrototype, "__NPO__", 0, /*configurable=*/ false);
                                builtInProp(Promise, "resolve", function Promise$resolve(msg) {
                                    var Constructor = this; // spec mandated checks
                                    // note: best "isPromise" check that's practical for now
                                    if (msg && _typeof(msg) == "object" && msg.__NPO__ === 1) {
                                        return msg;
                                    }
                                    return new Constructor(function executor(resolve, reject) {
                                        if (typeof resolve != "function" || typeof reject != "function") {
                                            throw TypeError("Not a function");
                                        }
                                        resolve(msg);
                                    });
                                });
                                builtInProp(Promise, "reject", function Promise$reject(msg) {
                                    return new this(function executor(resolve, reject) {
                                        if (typeof resolve != "function" || typeof reject != "function") {
                                            throw TypeError("Not a function");
                                        }
                                        reject(msg);
                                    });
                                });
                                builtInProp(Promise, "all", function Promise$all(arr) {
                                    var Constructor = this; // spec mandated checks
                                    if (ToString.call(arr) != "[object Array]") {
                                        return Constructor.reject(TypeError("Not an array"));
                                    }
                                    if (arr.length === 0) {
                                        return Constructor.resolve([]);
                                    }
                                    return new Constructor(function executor(resolve, reject) {
                                        if (typeof resolve != "function" || typeof reject != "function") {
                                            throw TypeError("Not a function");
                                        }
                                        var len = arr.length,
                                            msgs = Array(len),
                                            count = 0;
                                        iteratePromises(
                                            Constructor,
                                            arr,
                                            function resolver(idx, msg) {
                                                msgs[idx] = msg;
                                                if (++count === len) {
                                                    resolve(msgs);
                                                }
                                            },
                                            reject
                                        );
                                    });
                                });
                                builtInProp(Promise, "race", function Promise$race(arr) {
                                    var Constructor = this; // spec mandated checks
                                    if (ToString.call(arr) != "[object Array]") {
                                        return Constructor.reject(TypeError("Not an array"));
                                    }
                                    return new Constructor(function executor(resolve, reject) {
                                        if (typeof resolve != "function" || typeof reject != "function") {
                                            throw TypeError("Not a function");
                                        }
                                        iteratePromises(
                                            Constructor,
                                            arr,
                                            function resolver(idx, msg) {
                                                resolve(msg);
                                            },
                                            reject
                                        );
                                    });
                                });
                                return Promise;
                            });
                        });
                        /**
                         * @module lib/callbacks
                         */ var callbackMap = new WeakMap();
                        /**
                         * Store a callback for a method or event for a player.
                         *
                         * @param {Player} player The player object.
                         * @param {string} name The method or event name.
                         * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
                         *        The callback to call or an object with resolve and reject functions for a promise.
                         * @return {void}
                         */ function storeCallback(player, name, callback) {
                            var playerCallbacks = callbackMap.get(player.element) || {};
                            if (!(name in playerCallbacks)) {
                                playerCallbacks[name] = [];
                            }
                            playerCallbacks[name].push(callback);
                            callbackMap.set(player.element, playerCallbacks);
                        }
                        /**
                         * Get the callbacks for a player and event or method.
                         *
                         * @param {Player} player The player object.
                         * @param {string} name The method or event name
                         * @return {function[]}
                         */ function getCallbacks(player, name) {
                            var playerCallbacks = callbackMap.get(player.element) || {};
                            return playerCallbacks[name] || [];
                        }
                        /**
                         * Remove a stored callback for a method or event for a player.
                         *
                         * @param {Player} player The player object.
                         * @param {string} name The method or event name
                         * @param {function} [callback] The specific callback to remove.
                         * @return {boolean} Was this the last callback?
                         */ function removeCallback(player, name, callback) {
                            var playerCallbacks = callbackMap.get(player.element) || {};
                            if (!playerCallbacks[name]) {
                                return true;
                            } // If no callback is passed, remove all callbacks for the event
                            if (!callback) {
                                playerCallbacks[name] = [];
                                callbackMap.set(player.element, playerCallbacks);
                                return true;
                            }
                            var index = playerCallbacks[name].indexOf(callback);
                            if (index !== -1) {
                                playerCallbacks[name].splice(index, 1);
                            }
                            callbackMap.set(player.element, playerCallbacks);
                            return playerCallbacks[name] && playerCallbacks[name].length === 0;
                        }
                        /**
                         * Return the first stored callback for a player and event or method.
                         *
                         * @param {Player} player The player object.
                         * @param {string} name The method or event name.
                         * @return {function} The callback, or false if there were none
                         */ function shiftCallbacks(player, name) {
                            var playerCallbacks = getCallbacks(player, name);
                            if (playerCallbacks.length < 1) {
                                return false;
                            }
                            var callback = playerCallbacks.shift();
                            removeCallback(player, name, callback);
                            return callback;
                        }
                        /**
                         * Move callbacks associated with an element to another element.
                         *
                         * @param {HTMLElement} oldElement The old element.
                         * @param {HTMLElement} newElement The new element.
                         * @return {void}
                         */ function swapCallbacks(oldElement, newElement) {
                            var playerCallbacks = callbackMap.get(oldElement);
                            callbackMap.set(newElement, playerCallbacks);
                            callbackMap["delete"](oldElement);
                        }
                        /**
                         * @module lib/embed
                         */ var oEmbedParameters = [
                            "autopause",
                            "autoplay",
                            "background",
                            "byline",
                            "color",
                            "controls",
                            "dnt",
                            "height",
                            "id",
                            "loop",
                            "maxheight",
                            "maxwidth",
                            "muted",
                            "playsinline",
                            "portrait",
                            "responsive",
                            "speed",
                            "texttrack",
                            "title",
                            "transparent",
                            "url",
                            "width",
                        ];
                        /**
                         * Get the 'data-vimeo'-prefixed attributes from an element as an object.
                         *
                         * @param {HTMLElement} element The element.
                         * @param {Object} [defaults={}] The default values to use.
                         * @return {Object<string, string>}
                         */ function getOEmbedParameters(element) {
                            var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            return oEmbedParameters.reduce(function (params, param) {
                                var value = element.getAttribute("data-vimeo-".concat(param));
                                if (value || value === "") {
                                    params[param] = value === "" ? 1 : value;
                                }
                                return params;
                            }, defaults);
                        }
                        /**
                         * Create an embed from oEmbed data inside an element.
                         *
                         * @param {object} data The oEmbed data.
                         * @param {HTMLElement} element The element to put the iframe in.
                         * @return {HTMLIFrameElement} The iframe embed.
                         */ function createEmbed(_ref, element) {
                            var html = _ref.html;
                            if (!element) {
                                throw new TypeError("An element must be provided");
                            }
                            if (element.getAttribute("data-vimeo-initialized") !== null) {
                                return element.querySelector("iframe");
                            }
                            var div = document.createElement("div");
                            div.innerHTML = html;
                            element.appendChild(div.firstChild);
                            element.setAttribute("data-vimeo-initialized", "true");
                            return element.querySelector("iframe");
                        }
                        /**
                         * Make an oEmbed call for the specified URL.
                         *
                         * @param {string} videoUrl The vimeo.com url for the video.
                         * @param {Object} [params] Parameters to pass to oEmbed.
                         * @param {HTMLElement} element The element.
                         * @return {Promise}
                         */ function getOEmbedData(videoUrl) {
                            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var element = arguments.length > 2 ? arguments[2] : undefined;
                            return new Promise(function (resolve, reject) {
                                if (!isVimeoUrl(videoUrl)) {
                                    throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
                                }
                                var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));
                                for (var param in params) {
                                    if (params.hasOwnProperty(param)) {
                                        url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
                                    }
                                }
                                var xhr = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
                                xhr.open("GET", url, true);
                                xhr.onload = function () {
                                    if (xhr.status === 404) {
                                        reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
                                        return;
                                    }
                                    if (xhr.status === 403) {
                                        reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
                                        return;
                                    }
                                    try {
                                        var json = JSON.parse(xhr.responseText); // Check api response for 403 on oembed
                                        if (json.domain_status_code === 403) {
                                            // We still want to create the embed to give users visual feedback
                                            createEmbed(json, element);
                                            reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
                                            return;
                                        }
                                        resolve(json);
                                    } catch (error) {
                                        reject(error);
                                    }
                                };
                                xhr.onerror = function () {
                                    var status = xhr.status ? " (".concat(xhr.status, ")") : "";
                                    reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
                                };
                                xhr.send();
                            });
                        }
                        /**
                         * Initialize all embeds within a specific element
                         *
                         * @param {HTMLElement} [parent=document] The parent element.
                         * @return {void}
                         */ function initializeEmbeds() {
                            var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
                            var elements = [].slice.call(parent.querySelectorAll("[data-vimeo-id], [data-vimeo-url]"));
                            var handleError = function handleError(error) {
                                if ("console" in window && console.error) {
                                    console.error("There was an error creating an embed: ".concat(error));
                                }
                            };
                            elements.forEach(function (element) {
                                try {
                                    // Skip any that have data-vimeo-defer
                                    if (element.getAttribute("data-vimeo-defer") !== null) {
                                        return;
                                    }
                                    var params = getOEmbedParameters(element);
                                    var url = getVimeoUrl(params);
                                    getOEmbedData(url, params, element)
                                        .then(function (data) {
                                            return createEmbed(data, element);
                                        })
                                        ["catch"](handleError);
                                } catch (error) {
                                    handleError(error);
                                }
                            });
                        }
                        /**
                         * Resize embeds when messaged by the player.
                         *
                         * @param {HTMLElement} [parent=document] The parent element.
                         * @return {void}
                         */ function resizeEmbeds() {
                            var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document; // Prevent execution if users include the player.js script multiple times.
                            if (window.VimeoPlayerResizeEmbeds_) {
                                return;
                            }
                            window.VimeoPlayerResizeEmbeds_ = true;
                            var onMessage = function onMessage(event) {
                                if (!isVimeoUrl(event.origin)) {
                                    return;
                                } // 'spacechange' is fired only on embeds with cards
                                if (!event.data || event.data.event !== "spacechange") {
                                    return;
                                }
                                var iframes = parent.querySelectorAll("iframe");
                                for (var i = 0; i < iframes.length; i++) {
                                    if (iframes[i].contentWindow !== event.source) {
                                        continue;
                                    } // Change padding-bottom of the enclosing div to accommodate
                                    // card carousel without distorting aspect ratio
                                    var space = iframes[i].parentElement;
                                    space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
                                    break;
                                }
                            };
                            window.addEventListener("message", onMessage);
                        }
                        /**
                         * @module lib/postmessage
                         */ /**
                         * Parse a message received from postMessage.
                         *
                         * @param {*} data The data received from postMessage.
                         * @return {object}
                         */ function parseMessageData(data) {
                            if (typeof data === "string") {
                                try {
                                    data = JSON.parse(data);
                                } catch (error) {
                                    // If the message cannot be parsed, throw the error as a warning
                                    console.warn(error);
                                    return {};
                                }
                            }
                            return data;
                        }
                        /**
                         * Post a message to the specified target.
                         *
                         * @param {Player} player The player object to use.
                         * @param {string} method The API method to call.
                         * @param {object} params The parameters to send to the player.
                         * @return {void}
                         */ function postMessage(player, method, params) {
                            if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
                                return;
                            }
                            var message = { method: method };
                            if (params !== undefined) {
                                message.value = params;
                            } // IE 8 and 9 do not support passing messages, so stringify them
                            var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
                            if (ieVersion >= 8 && ieVersion < 10) {
                                message = JSON.stringify(message);
                            }
                            player.element.contentWindow.postMessage(message, player.origin);
                        }
                        /**
                         * Parse the data received from a message event.
                         *
                         * @param {Player} player The player that received the message.
                         * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
                         * @return {void}
                         */ function processData(player, data) {
                            data = parseMessageData(data);
                            var callbacks = [];
                            var param;
                            if (data.event) {
                                if (data.event === "error") {
                                    var promises = getCallbacks(player, data.data.method);
                                    promises.forEach(function (promise) {
                                        var error = new Error(data.data.message);
                                        error.name = data.data.name;
                                        promise.reject(error);
                                        removeCallback(player, data.data.method, promise);
                                    });
                                }
                                callbacks = getCallbacks(player, "event:".concat(data.event));
                                param = data.data;
                            } else if (data.method) {
                                var callback = shiftCallbacks(player, data.method);
                                if (callback) {
                                    callbacks.push(callback);
                                    param = data.value;
                                }
                            }
                            callbacks.forEach(function (callback) {
                                try {
                                    if (typeof callback === "function") {
                                        callback.call(player, param);
                                        return;
                                    }
                                    callback.resolve(param);
                                } catch (e) {
                                    // empty
                                }
                            });
                        }
                        /* MIT License

  Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  Terms */ function initializeScreenfull() {
                            var fn = (function () {
                                var val;
                                var fnMap = [
                                    ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"], // New WebKit
                                    ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"], // Old WebKit
                                    ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
                                    ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
                                    ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"],
                                ];
                                var i = 0;
                                var l = fnMap.length;
                                var ret = {};
                                for (; i < l; i++) {
                                    val = fnMap[i];
                                    if (val && val[1] in document) {
                                        for (i = 0; i < val.length; i++) {
                                            ret[fnMap[0][i]] = val[i];
                                        }
                                        return ret;
                                    }
                                }
                                return false;
                            })();
                            var eventNameMap = { fullscreenchange: fn.fullscreenchange, fullscreenerror: fn.fullscreenerror };
                            var screenfull = {
                                request: function request(element) {
                                    return new Promise(function (resolve, reject) {
                                        var onFullScreenEntered = function onFullScreenEntered() {
                                            screenfull.off("fullscreenchange", onFullScreenEntered);
                                            resolve();
                                        };
                                        screenfull.on("fullscreenchange", onFullScreenEntered);
                                        element = element || document.documentElement;
                                        var returnPromise = element[fn.requestFullscreen]();
                                        if (returnPromise instanceof Promise) {
                                            returnPromise.then(onFullScreenEntered)["catch"](reject);
                                        }
                                    });
                                },
                                exit: function exit() {
                                    return new Promise(function (resolve, reject) {
                                        if (!screenfull.isFullscreen) {
                                            resolve();
                                            return;
                                        }
                                        var onFullScreenExit = function onFullScreenExit() {
                                            screenfull.off("fullscreenchange", onFullScreenExit);
                                            resolve();
                                        };
                                        screenfull.on("fullscreenchange", onFullScreenExit);
                                        var returnPromise = document[fn.exitFullscreen]();
                                        if (returnPromise instanceof Promise) {
                                            returnPromise.then(onFullScreenExit)["catch"](reject);
                                        }
                                    });
                                },
                                on: function on(event, callback) {
                                    var eventName = eventNameMap[event];
                                    if (eventName) {
                                        document.addEventListener(eventName, callback);
                                    }
                                },
                                off: function off(event, callback) {
                                    var eventName = eventNameMap[event];
                                    if (eventName) {
                                        document.removeEventListener(eventName, callback);
                                    }
                                },
                            };
                            Object.defineProperties(screenfull, {
                                isFullscreen: {
                                    get: function get() {
                                        return Boolean(document[fn.fullscreenElement]);
                                    },
                                },
                                element: {
                                    enumerable: true,
                                    get: function get() {
                                        return document[fn.fullscreenElement];
                                    },
                                },
                                isEnabled: {
                                    enumerable: true,
                                    get: function get() {
                                        // Coerce to boolean in case of old WebKit
                                        return Boolean(document[fn.fullscreenEnabled]);
                                    },
                                },
                            });
                            return screenfull;
                        }
                        var playerMap = new WeakMap();
                        var readyMap = new WeakMap();
                        var screenfull = {};
                        var Player = /*#__PURE__*/ (function () {
                            /**
                             * Create a Player.
                             *
                             * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
                             *        player iframe, and id, or a jQuery object.
                             * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
                             * @return {Player}
                             */ function Player(element) {
                                var _this = this;
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                                _classCallCheck(this, Player);
                                /* global jQuery */ if (window.jQuery && element instanceof jQuery) {
                                    if (element.length > 1 && window.console && console.warn) {
                                        console.warn("A jQuery object with multiple elements was passed, using the first element.");
                                    }
                                    element = element[0];
                                } // Find an element by ID
                                if (typeof document !== "undefined" && typeof element === "string") {
                                    element = document.getElementById(element);
                                } // Not an element!
                                if (!isDomElement(element)) {
                                    throw new TypeError("You must pass either a valid element or a valid id.");
                                } // Already initialized an embed in this div, so grab the iframe
                                if (element.nodeName !== "IFRAME") {
                                    var iframe = element.querySelector("iframe");
                                    if (iframe) {
                                        element = iframe;
                                    }
                                } // iframe url is not a Vimeo url
                                if (element.nodeName === "IFRAME" && !isVimeoUrl(element.getAttribute("src") || "")) {
                                    throw new Error("The player element passed isn’t a Vimeo embed.");
                                } // If there is already a player object in the map, return that
                                if (playerMap.has(element)) {
                                    return playerMap.get(element);
                                }
                                this._window = element.ownerDocument.defaultView;
                                this.element = element;
                                this.origin = "*";
                                var readyPromise = new npo_src(function (resolve, reject) {
                                    _this._onMessage = function (event) {
                                        if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
                                            return;
                                        }
                                        if (_this.origin === "*") {
                                            _this.origin = event.origin;
                                        }
                                        var data = parseMessageData(event.data);
                                        var isError = data && data.event === "error";
                                        var isReadyError = isError && data.data && data.data.method === "ready";
                                        if (isReadyError) {
                                            var error = new Error(data.data.message);
                                            error.name = data.data.name;
                                            reject(error);
                                            return;
                                        }
                                        var isReadyEvent = data && data.event === "ready";
                                        var isPingResponse = data && data.method === "ping";
                                        if (isReadyEvent || isPingResponse) {
                                            _this.element.setAttribute("data-ready", "true");
                                            resolve();
                                            return;
                                        }
                                        processData(_this, data);
                                    };
                                    _this._window.addEventListener("message", _this._onMessage);
                                    if (_this.element.nodeName !== "IFRAME") {
                                        var params = getOEmbedParameters(element, options);
                                        var url = getVimeoUrl(params);
                                        getOEmbedData(url, params, element)
                                            .then(function (data) {
                                                var iframe = createEmbed(data, element); // Overwrite element with the new iframe,
                                                // but store reference to the original element
                                                _this.element = iframe;
                                                _this._originalElement = element;
                                                swapCallbacks(element, iframe);
                                                playerMap.set(_this.element, _this);
                                                return data;
                                            })
                                            ["catch"](reject);
                                    }
                                }); // Store a copy of this Player in the map
                                readyMap.set(this, readyPromise);
                                playerMap.set(this.element, this); // Send a ping to the iframe so the ready promise will be resolved if
                                // the player is already ready.
                                if (this.element.nodeName === "IFRAME") {
                                    postMessage(this, "ping");
                                }
                                if (screenfull.isEnabled) {
                                    var exitFullscreen = function exitFullscreen() {
                                        return screenfull.exit();
                                    };
                                    screenfull.on("fullscreenchange", function () {
                                        if (screenfull.isFullscreen) {
                                            storeCallback(_this, "event:exitFullscreen", exitFullscreen);
                                        } else {
                                            removeCallback(_this, "event:exitFullscreen", exitFullscreen);
                                        } // eslint-disable-next-line
                                        _this.ready().then(function () {
                                            postMessage(_this, "fullscreenchange", screenfull.isFullscreen);
                                        });
                                    });
                                }
                                return this;
                            }
                            /**
                             * Get a promise for a method.
                             *
                             * @param {string} name The API method to call.
                             * @param {Object} [args={}] Arguments to send via postMessage.
                             * @return {Promise}
                             */ _createClass(Player, [
                                {
                                    key: "callMethod",
                                    value: function callMethod(name) {
                                        var _this2 = this;
                                        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                                        return new npo_src(function (resolve, reject) {
                                            // We are storing the resolve/reject handlers to call later, so we
                                            // can’t return here.
                                            // eslint-disable-next-line promise/always-return
                                            return _this2
                                                .ready()
                                                .then(function () {
                                                    storeCallback(_this2, name, { resolve: resolve, reject: reject });
                                                    postMessage(_this2, name, args);
                                                })
                                                ["catch"](reject);
                                        });
                                    }
                                    /**
                                     * Get a promise for the value of a player property.
                                     *
                                     * @param {string} name The property name
                                     * @return {Promise}
                                     */,
                                },
                                {
                                    key: "get",
                                    value: function get(name) {
                                        var _this3 = this;
                                        return new npo_src(function (resolve, reject) {
                                            name = getMethodName(name, "get"); // We are storing the resolve/reject handlers to call later, so we
                                            // can’t return here.
                                            // eslint-disable-next-line promise/always-return
                                            return _this3
                                                .ready()
                                                .then(function () {
                                                    storeCallback(_this3, name, { resolve: resolve, reject: reject });
                                                    postMessage(_this3, name);
                                                })
                                                ["catch"](reject);
                                        });
                                    }
                                    /**
                                     * Get a promise for setting the value of a player property.
                                     *
                                     * @param {string} name The API method to call.
                                     * @param {mixed} value The value to set.
                                     * @return {Promise}
                                     */,
                                },
                                {
                                    key: "set",
                                    value: function set(name, value) {
                                        var _this4 = this;
                                        return new npo_src(function (resolve, reject) {
                                            name = getMethodName(name, "set");
                                            if (value === undefined || value === null) {
                                                throw new TypeError("There must be a value to set.");
                                            } // We are storing the resolve/reject handlers to call later, so we
                                            // can’t return here.
                                            // eslint-disable-next-line promise/always-return
                                            return _this4
                                                .ready()
                                                .then(function () {
                                                    storeCallback(_this4, name, { resolve: resolve, reject: reject });
                                                    postMessage(_this4, name, value);
                                                })
                                                ["catch"](reject);
                                        });
                                    }
                                    /**
                                     * Add an event listener for the specified event. Will call the
                                     * callback with a single parameter, `data`, that contains the data for
                                     * that event.
                                     *
                                     * @param {string} eventName The name of the event.
                                     * @param {function(*)} callback The function to call when the event fires.
                                     * @return {void}
                                     */,
                                },
                                {
                                    key: "on",
                                    value: function on(eventName, callback) {
                                        if (!eventName) {
                                            throw new TypeError("You must pass an event name.");
                                        }
                                        if (!callback) {
                                            throw new TypeError("You must pass a callback function.");
                                        }
                                        if (typeof callback !== "function") {
                                            throw new TypeError("The callback must be a function.");
                                        }
                                        var callbacks = getCallbacks(this, "event:".concat(eventName));
                                        if (callbacks.length === 0) {
                                            this.callMethod("addEventListener", eventName)["catch"](function () {
                                                // Ignore the error. There will be an error event fired that
                                                // will trigger the error callback if they are listening.
                                            });
                                        }
                                        storeCallback(this, "event:".concat(eventName), callback);
                                    }
                                    /**
                                     * Remove an event listener for the specified event. Will remove all
                                     * listeners for that event if a `callback` isn’t passed, or only that
                                     * specific callback if it is passed.
                                     *
                                     * @param {string} eventName The name of the event.
                                     * @param {function} [callback] The specific callback to remove.
                                     * @return {void}
                                     */,
                                },
                                {
                                    key: "off",
                                    value: function off(eventName, callback) {
                                        if (!eventName) {
                                            throw new TypeError("You must pass an event name.");
                                        }
                                        if (callback && typeof callback !== "function") {
                                            throw new TypeError("The callback must be a function.");
                                        }
                                        var lastCallback = removeCallback(this, "event:".concat(eventName), callback); // If there are no callbacks left, remove the listener
                                        if (lastCallback) {
                                            this.callMethod("removeEventListener", eventName)["catch"](function (e) {
                                                // Ignore the error. There will be an error event fired that
                                                // will trigger the error callback if they are listening.
                                            });
                                        }
                                    }
                                    /**
                                     * A promise to load a new video.
                                     *
                                     * @promise LoadVideoPromise
                                     * @fulfill {number} The video with this id successfully loaded.
                                     * @reject {TypeError} The id was not a number.
                                     */
                                    /**
                                     * Load a new video into this embed. The promise will be resolved if
                                     * the video is successfully loaded, or it will be rejected if it could
                                     * not be loaded.
                                     *
                                     * @param {number|object} options The id of the video or an object with embed options.
                                     * @return {LoadVideoPromise}
                                     */,
                                },
                                {
                                    key: "loadVideo",
                                    value: function loadVideo(options) {
                                        return this.callMethod("loadVideo", options);
                                    }
                                    /**
                                     * A promise to perform an action when the Player is ready.
                                     *
                                     * @todo document errors
                                     * @promise LoadVideoPromise
                                     * @fulfill {void}
                                     */
                                    /**
                                     * Trigger a function when the player iframe has initialized. You do not
                                     * need to wait for `ready` to trigger to begin adding event listeners
                                     * or calling other methods.
                                     *
                                     * @return {ReadyPromise}
                                     */,
                                },
                                {
                                    key: "ready",
                                    value: function ready() {
                                        var readyPromise =
                                            readyMap.get(this) ||
                                            new npo_src(function (resolve, reject) {
                                                reject(new Error("Unknown player. Probably unloaded."));
                                            });
                                        return npo_src.resolve(readyPromise);
                                    }
                                    /**
                                     * A promise to add a cue point to the player.
                                     *
                                     * @promise AddCuePointPromise
                                     * @fulfill {string} The id of the cue point to use for removeCuePoint.
                                     * @reject {RangeError} the time was less than 0 or greater than the
                                     *         video’s duration.
                                     * @reject {UnsupportedError} Cue points are not supported with the current
                                     *         player or browser.
                                     */
                                    /**
                                     * Add a cue point to the player.
                                     *
                                     * @param {number} time The time for the cue point.
                                     * @param {object} [data] Arbitrary data to be returned with the cue point.
                                     * @return {AddCuePointPromise}
                                     */,
                                },
                                {
                                    key: "addCuePoint",
                                    value: function addCuePoint(time) {
                                        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                                        return this.callMethod("addCuePoint", { time: time, data: data });
                                    }
                                    /**
                                     * A promise to remove a cue point from the player.
                                     *
                                     * @promise AddCuePointPromise
                                     * @fulfill {string} The id of the cue point that was removed.
                                     * @reject {InvalidCuePoint} The cue point with the specified id was not
                                     *         found.
                                     * @reject {UnsupportedError} Cue points are not supported with the current
                                     *         player or browser.
                                     */
                                    /**
                                     * Remove a cue point from the video.
                                     *
                                     * @param {string} id The id of the cue point to remove.
                                     * @return {RemoveCuePointPromise}
                                     */,
                                },
                                {
                                    key: "removeCuePoint",
                                    value: function removeCuePoint(id) {
                                        return this.callMethod("removeCuePoint", id);
                                    }
                                    /**
                                     * A representation of a text track on a video.
                                     *
                                     * @typedef {Object} VimeoTextTrack
                                     * @property {string} language The ISO language code.
                                     * @property {string} kind The kind of track it is (captions or subtitles).
                                     * @property {string} label The human‐readable label for the track.
                                     */
                                    /**
                                     * A promise to enable a text track.
                                     *
                                     * @promise EnableTextTrackPromise
                                     * @fulfill {VimeoTextTrack} The text track that was enabled.
                                     * @reject {InvalidTrackLanguageError} No track was available with the
                                     *         specified language.
                                     * @reject {InvalidTrackError} No track was available with the specified
                                     *         language and kind.
                                     */
                                    /**
                                     * Enable the text track with the specified language, and optionally the
                                     * specified kind (captions or subtitles).
                                     *
                                     * When set via the API, the track language will not change the viewer’s
                                     * stored preference.
                                     *
                                     * @param {string} language The two‐letter language code.
                                     * @param {string} [kind] The kind of track to enable (captions or subtitles).
                                     * @return {EnableTextTrackPromise}
                                     */,
                                },
                                {
                                    key: "enableTextTrack",
                                    value: function enableTextTrack(language, kind) {
                                        if (!language) {
                                            throw new TypeError("You must pass a language.");
                                        }
                                        return this.callMethod("enableTextTrack", { language: language, kind: kind });
                                    }
                                    /**
                                     * A promise to disable the active text track.
                                     *
                                     * @promise DisableTextTrackPromise
                                     * @fulfill {void} The track was disabled.
                                     */
                                    /**
                                     * Disable the currently-active text track.
                                     *
                                     * @return {DisableTextTrackPromise}
                                     */,
                                },
                                {
                                    key: "disableTextTrack",
                                    value: function disableTextTrack() {
                                        return this.callMethod("disableTextTrack");
                                    }
                                    /**
                                     * A promise to pause the video.
                                     *
                                     * @promise PausePromise
                                     * @fulfill {void} The video was paused.
                                     */
                                    /**
                                     * Pause the video if it’s playing.
                                     *
                                     * @return {PausePromise}
                                     */,
                                },
                                {
                                    key: "pause",
                                    value: function pause() {
                                        return this.callMethod("pause");
                                    }
                                    /**
                                     * A promise to play the video.
                                     *
                                     * @promise PlayPromise
                                     * @fulfill {void} The video was played.
                                     */
                                    /**
                                     * Play the video if it’s paused. **Note:** on iOS and some other
                                     * mobile devices, you cannot programmatically trigger play. Once the
                                     * viewer has tapped on the play button in the player, however, you
                                     * will be able to use this function.
                                     *
                                     * @return {PlayPromise}
                                     */,
                                },
                                {
                                    key: "play",
                                    value: function play() {
                                        return this.callMethod("play");
                                    }
                                    /**
                                     * Request that the player enters fullscreen.
                                     * @return {Promise}
                                     */,
                                },
                                {
                                    key: "requestFullscreen",
                                    value: function requestFullscreen() {
                                        if (screenfull.isEnabled) {
                                            return screenfull.request(this.element);
                                        }
                                        return this.callMethod("requestFullscreen");
                                    }
                                    /**
                                     * Request that the player exits fullscreen.
                                     * @return {Promise}
                                     */,
                                },
                                {
                                    key: "exitFullscreen",
                                    value: function exitFullscreen() {
                                        if (screenfull.isEnabled) {
                                            return screenfull.exit();
                                        }
                                        return this.callMethod("exitFullscreen");
                                    }
                                    /**
                                     * Returns true if the player is currently fullscreen.
                                     * @return {Promise}
                                     */,
                                },
                                {
                                    key: "getFullscreen",
                                    value: function getFullscreen() {
                                        if (screenfull.isEnabled) {
                                            return npo_src.resolve(screenfull.isFullscreen);
                                        }
                                        return this.get("fullscreen");
                                    }
                                    /**
                                     * Request that the player enters picture-in-picture.
                                     * @return {Promise}
                                     */,
                                },
                                {
                                    key: "requestPictureInPicture",
                                    value: function requestPictureInPicture() {
                                        return this.callMethod("requestPictureInPicture");
                                    }
                                    /**
                                     * Request that the player exits picture-in-picture.
                                     * @return {Promise}
                                     */,
                                },
                                {
                                    key: "exitPictureInPicture",
                                    value: function exitPictureInPicture() {
                                        return this.callMethod("exitPictureInPicture");
                                    }
                                    /**
                                     * Returns true if the player is currently picture-in-picture.
                                     * @return {Promise}
                                     */,
                                },
                                {
                                    key: "getPictureInPicture",
                                    value: function getPictureInPicture() {
                                        return this.get("pictureInPicture");
                                    }
                                    /**
                                     * A promise to unload the video.
                                     *
                                     * @promise UnloadPromise
                                     * @fulfill {void} The video was unloaded.
                                     */
                                    /**
                                     * Return the player to its initial state.
                                     *
                                     * @return {UnloadPromise}
                                     */,
                                },
                                {
                                    key: "unload",
                                    value: function unload() {
                                        return this.callMethod("unload");
                                    }
                                    /**
                                     * Cleanup the player and remove it from the DOM
                                     *
                                     * It won't be usable and a new one should be constructed
                                     *  in order to do any operations.
                                     *
                                     * @return {Promise}
                                     */,
                                },
                                {
                                    key: "destroy",
                                    value: function destroy() {
                                        var _this5 = this;
                                        return new npo_src(function (resolve) {
                                            readyMap["delete"](_this5);
                                            playerMap["delete"](_this5.element);
                                            if (_this5._originalElement) {
                                                playerMap["delete"](_this5._originalElement);
                                                _this5._originalElement.removeAttribute("data-vimeo-initialized");
                                            }
                                            if (_this5.element && _this5.element.nodeName === "IFRAME" && _this5.element.parentNode) {
                                                _this5.element.parentNode.removeChild(_this5.element);
                                            } // If the clip is private there is a case where the element stays the
                                            // div element. Destroy should reset the div and remove the iframe child.
                                            if (_this5.element && _this5.element.nodeName === "DIV" && _this5.element.parentNode) {
                                                _this5.element.removeAttribute("data-vimeo-initialized");
                                                var iframe = _this5.element.querySelector("iframe");
                                                if (iframe && iframe.parentNode) {
                                                    iframe.parentNode.removeChild(iframe);
                                                }
                                            }
                                            _this5._window.removeEventListener("message", _this5._onMessage);
                                            resolve();
                                        });
                                    }
                                    /**
                                     * A promise to get the autopause behavior of the video.
                                     *
                                     * @promise GetAutopausePromise
                                     * @fulfill {boolean} Whether autopause is turned on or off.
                                     * @reject {UnsupportedError} Autopause is not supported with the current
                                     *         player or browser.
                                     */
                                    /**
                                     * Get the autopause behavior for this player.
                                     *
                                     * @return {GetAutopausePromise}
                                     */,
                                },
                                {
                                    key: "getAutopause",
                                    value: function getAutopause() {
                                        return this.get("autopause");
                                    }
                                    /**
                                     * A promise to set the autopause behavior of the video.
                                     *
                                     * @promise SetAutopausePromise
                                     * @fulfill {boolean} Whether autopause is turned on or off.
                                     * @reject {UnsupportedError} Autopause is not supported with the current
                                     *         player or browser.
                                     */
                                    /**
                                     * Enable or disable the autopause behavior of this player.
                                     *
                                     * By default, when another video is played in the same browser, this
                                     * player will automatically pause. Unless you have a specific reason
                                     * for doing so, we recommend that you leave autopause set to the
                                     * default (`true`).
                                     *
                                     * @param {boolean} autopause
                                     * @return {SetAutopausePromise}
                                     */,
                                },
                                {
                                    key: "setAutopause",
                                    value: function setAutopause(autopause) {
                                        return this.set("autopause", autopause);
                                    }
                                    /**
                                     * A promise to get the buffered property of the video.
                                     *
                                     * @promise GetBufferedPromise
                                     * @fulfill {Array} Buffered Timeranges converted to an Array.
                                     */
                                    /**
                                     * Get the buffered property of the video.
                                     *
                                     * @return {GetBufferedPromise}
                                     */,
                                },
                                {
                                    key: "getBuffered",
                                    value: function getBuffered() {
                                        return this.get("buffered");
                                    }
                                    /**
                                     * @typedef {Object} CameraProperties
                                     * @prop {number} props.yaw - Number between 0 and 360.
                                     * @prop {number} props.pitch - Number between -90 and 90.
                                     * @prop {number} props.roll - Number between -180 and 180.
                                     * @prop {number} props.fov - The field of view in degrees.
                                     */
                                    /**
                                     * A promise to get the camera properties of the player.
                                     *
                                     * @promise GetCameraPromise
                                     * @fulfill {CameraProperties} The camera properties.
                                     */
                                    /**
                                     * For 360° videos get the camera properties for this player.
                                     *
                                     * @return {GetCameraPromise}
                                     */,
                                },
                                {
                                    key: "getCameraProps",
                                    value: function getCameraProps() {
                                        return this.get("cameraProps");
                                    }
                                    /**
                                     * A promise to set the camera properties of the player.
                                     *
                                     * @promise SetCameraPromise
                                     * @fulfill {Object} The camera was successfully set.
                                     * @reject {RangeError} The range was out of bounds.
                                     */
                                    /**
                                     * For 360° videos set the camera properties for this player.
                                     *
                                     * @param {CameraProperties} camera The camera properties
                                     * @return {SetCameraPromise}
                                     */,
                                },
                                {
                                    key: "setCameraProps",
                                    value: function setCameraProps(camera) {
                                        return this.set("cameraProps", camera);
                                    }
                                    /**
                                     * A representation of a chapter.
                                     *
                                     * @typedef {Object} VimeoChapter
                                     * @property {number} startTime The start time of the chapter.
                                     * @property {object} title The title of the chapter.
                                     * @property {number} index The place in the order of Chapters. Starts at 1.
                                     */
                                    /**
                                     * A promise to get chapters for the video.
                                     *
                                     * @promise GetChaptersPromise
                                     * @fulfill {VimeoChapter[]} The chapters for the video.
                                     */
                                    /**
                                     * Get an array of all the chapters for the video.
                                     *
                                     * @return {GetChaptersPromise}
                                     */,
                                },
                                {
                                    key: "getChapters",
                                    value: function getChapters() {
                                        return this.get("chapters");
                                    }
                                    /**
                                     * A promise to get the currently active chapter.
                                     *
                                     * @promise GetCurrentChaptersPromise
                                     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
                                     */
                                    /**
                                     * Get the currently active chapter for the video.
                                     *
                                     * @return {GetCurrentChaptersPromise}
                                     */,
                                },
                                {
                                    key: "getCurrentChapter",
                                    value: function getCurrentChapter() {
                                        return this.get("currentChapter");
                                    }
                                    /**
                                     * A promise to get the color of the player.
                                     *
                                     * @promise GetColorPromise
                                     * @fulfill {string} The hex color of the player.
                                     */
                                    /**
                                     * Get the color for this player.
                                     *
                                     * @return {GetColorPromise}
                                     */,
                                },
                                {
                                    key: "getColor",
                                    value: function getColor() {
                                        return this.get("color");
                                    }
                                    /**
                                     * A promise to set the color of the player.
                                     *
                                     * @promise SetColorPromise
                                     * @fulfill {string} The color was successfully set.
                                     * @reject {TypeError} The string was not a valid hex or rgb color.
                                     * @reject {ContrastError} The color was set, but the contrast is
                                     *         outside of the acceptable range.
                                     * @reject {EmbedSettingsError} The owner of the player has chosen to
                                     *         use a specific color.
                                     */
                                    /**
                                     * Set the color of this player to a hex or rgb string. Setting the
                                     * color may fail if the owner of the video has set their embed
                                     * preferences to force a specific color.
                                     *
                                     * @param {string} color The hex or rgb color string to set.
                                     * @return {SetColorPromise}
                                     */,
                                },
                                {
                                    key: "setColor",
                                    value: function setColor(color) {
                                        return this.set("color", color);
                                    }
                                    /**
                                     * A representation of a cue point.
                                     *
                                     * @typedef {Object} VimeoCuePoint
                                     * @property {number} time The time of the cue point.
                                     * @property {object} data The data passed when adding the cue point.
                                     * @property {string} id The unique id for use with removeCuePoint.
                                     */
                                    /**
                                     * A promise to get the cue points of a video.
                                     *
                                     * @promise GetCuePointsPromise
                                     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
                                     * @reject {UnsupportedError} Cue points are not supported with the current
                                     *         player or browser.
                                     */
                                    /**
                                     * Get an array of the cue points added to the video.
                                     *
                                     * @return {GetCuePointsPromise}
                                     */,
                                },
                                {
                                    key: "getCuePoints",
                                    value: function getCuePoints() {
                                        return this.get("cuePoints");
                                    }
                                    /**
                                     * A promise to get the current time of the video.
                                     *
                                     * @promise GetCurrentTimePromise
                                     * @fulfill {number} The current time in seconds.
                                     */
                                    /**
                                     * Get the current playback position in seconds.
                                     *
                                     * @return {GetCurrentTimePromise}
                                     */,
                                },
                                {
                                    key: "getCurrentTime",
                                    value: function getCurrentTime() {
                                        return this.get("currentTime");
                                    }
                                    /**
                                     * A promise to set the current time of the video.
                                     *
                                     * @promise SetCurrentTimePromise
                                     * @fulfill {number} The actual current time that was set.
                                     * @reject {RangeError} the time was less than 0 or greater than the
                                     *         video’s duration.
                                     */
                                    /**
                                     * Set the current playback position in seconds. If the player was
                                     * paused, it will remain paused. Likewise, if the player was playing,
                                     * it will resume playing once the video has buffered.
                                     *
                                     * You can provide an accurate time and the player will attempt to seek
                                     * to as close to that time as possible. The exact time will be the
                                     * fulfilled value of the promise.
                                     *
                                     * @param {number} currentTime
                                     * @return {SetCurrentTimePromise}
                                     */,
                                },
                                {
                                    key: "setCurrentTime",
                                    value: function setCurrentTime(currentTime) {
                                        return this.set("currentTime", currentTime);
                                    }
                                    /**
                                     * A promise to get the duration of the video.
                                     *
                                     * @promise GetDurationPromise
                                     * @fulfill {number} The duration in seconds.
                                     */
                                    /**
                                     * Get the duration of the video in seconds. It will be rounded to the
                                     * nearest second before playback begins, and to the nearest thousandth
                                     * of a second after playback begins.
                                     *
                                     * @return {GetDurationPromise}
                                     */,
                                },
                                {
                                    key: "getDuration",
                                    value: function getDuration() {
                                        return this.get("duration");
                                    }
                                    /**
                                     * A promise to get the ended state of the video.
                                     *
                                     * @promise GetEndedPromise
                                     * @fulfill {boolean} Whether or not the video has ended.
                                     */
                                    /**
                                     * Get the ended state of the video. The video has ended if
                                     * `currentTime === duration`.
                                     *
                                     * @return {GetEndedPromise}
                                     */,
                                },
                                {
                                    key: "getEnded",
                                    value: function getEnded() {
                                        return this.get("ended");
                                    }
                                    /**
                                     * A promise to get the loop state of the player.
                                     *
                                     * @promise GetLoopPromise
                                     * @fulfill {boolean} Whether or not the player is set to loop.
                                     */
                                    /**
                                     * Get the loop state of the player.
                                     *
                                     * @return {GetLoopPromise}
                                     */,
                                },
                                {
                                    key: "getLoop",
                                    value: function getLoop() {
                                        return this.get("loop");
                                    }
                                    /**
                                     * A promise to set the loop state of the player.
                                     *
                                     * @promise SetLoopPromise
                                     * @fulfill {boolean} The loop state that was set.
                                     */
                                    /**
                                     * Set the loop state of the player. When set to `true`, the player
                                     * will start over immediately once playback ends.
                                     *
                                     * @param {boolean} loop
                                     * @return {SetLoopPromise}
                                     */,
                                },
                                {
                                    key: "setLoop",
                                    value: function setLoop(loop) {
                                        return this.set("loop", loop);
                                    }
                                    /**
                                     * A promise to set the muted state of the player.
                                     *
                                     * @promise SetMutedPromise
                                     * @fulfill {boolean} The muted state that was set.
                                     */
                                    /**
                                     * Set the muted state of the player. When set to `true`, the player
                                     * volume will be muted.
                                     *
                                     * @param {boolean} muted
                                     * @return {SetMutedPromise}
                                     */,
                                },
                                {
                                    key: "setMuted",
                                    value: function setMuted(muted) {
                                        return this.set("muted", muted);
                                    }
                                    /**
                                     * A promise to get the muted state of the player.
                                     *
                                     * @promise GetMutedPromise
                                     * @fulfill {boolean} Whether or not the player is muted.
                                     */
                                    /**
                                     * Get the muted state of the player.
                                     *
                                     * @return {GetMutedPromise}
                                     */,
                                },
                                {
                                    key: "getMuted",
                                    value: function getMuted() {
                                        return this.get("muted");
                                    }
                                    /**
                                     * A promise to get the paused state of the player.
                                     *
                                     * @promise GetLoopPromise
                                     * @fulfill {boolean} Whether or not the video is paused.
                                     */
                                    /**
                                     * Get the paused state of the player.
                                     *
                                     * @return {GetLoopPromise}
                                     */,
                                },
                                {
                                    key: "getPaused",
                                    value: function getPaused() {
                                        return this.get("paused");
                                    }
                                    /**
                                     * A promise to get the playback rate of the player.
                                     *
                                     * @promise GetPlaybackRatePromise
                                     * @fulfill {number} The playback rate of the player on a scale from 0.5 to 2.
                                     */
                                    /**
                                     * Get the playback rate of the player on a scale from `0.5` to `2`.
                                     *
                                     * @return {GetPlaybackRatePromise}
                                     */,
                                },
                                {
                                    key: "getPlaybackRate",
                                    value: function getPlaybackRate() {
                                        return this.get("playbackRate");
                                    }
                                    /**
                                     * A promise to set the playbackrate of the player.
                                     *
                                     * @promise SetPlaybackRatePromise
                                     * @fulfill {number} The playback rate was set.
                                     * @reject {RangeError} The playback rate was less than 0.5 or greater than 2.
                                     */
                                    /**
                                     * Set the playback rate of the player on a scale from `0.5` to `2`. When set
                                     * via the API, the playback rate will not be synchronized to other
                                     * players or stored as the viewer's preference.
                                     *
                                     * @param {number} playbackRate
                                     * @return {SetPlaybackRatePromise}
                                     */,
                                },
                                {
                                    key: "setPlaybackRate",
                                    value: function setPlaybackRate(playbackRate) {
                                        return this.set("playbackRate", playbackRate);
                                    }
                                    /**
                                     * A promise to get the played property of the video.
                                     *
                                     * @promise GetPlayedPromise
                                     * @fulfill {Array} Played Timeranges converted to an Array.
                                     */
                                    /**
                                     * Get the played property of the video.
                                     *
                                     * @return {GetPlayedPromise}
                                     */,
                                },
                                {
                                    key: "getPlayed",
                                    value: function getPlayed() {
                                        return this.get("played");
                                    }
                                    /**
                                     * A promise to get the qualities available of the current video.
                                     *
                                     * @promise GetQualitiesPromise
                                     * @fulfill {Array} The qualities of the video.
                                     */
                                    /**
                                     * Get the qualities of the current video.
                                     *
                                     * @return {GetQualitiesPromise}
                                     */,
                                },
                                {
                                    key: "getQualities",
                                    value: function getQualities() {
                                        return this.get("qualities");
                                    }
                                    /**
                                     * A promise to get the current set quality of the video.
                                     *
                                     * @promise GetQualityPromise
                                     * @fulfill {string} The current set quality.
                                     */
                                    /**
                                     * Get the current set quality of the video.
                                     *
                                     * @return {GetQualityPromise}
                                     */,
                                },
                                {
                                    key: "getQuality",
                                    value: function getQuality() {
                                        return this.get("quality");
                                    }
                                    /**
                                     * A promise to set the video quality.
                                     *
                                     * @promise SetQualityPromise
                                     * @fulfill {number} The quality was set.
                                     * @reject {RangeError} The quality is not available.
                                     */
                                    /**
                                     * Set a video quality.
                                     *
                                     * @param {string} quality
                                     * @return {SetQualityPromise}
                                     */,
                                },
                                {
                                    key: "setQuality",
                                    value: function setQuality(quality) {
                                        return this.set("quality", quality);
                                    }
                                    /**
                                     * A promise to get the seekable property of the video.
                                     *
                                     * @promise GetSeekablePromise
                                     * @fulfill {Array} Seekable Timeranges converted to an Array.
                                     */
                                    /**
                                     * Get the seekable property of the video.
                                     *
                                     * @return {GetSeekablePromise}
                                     */,
                                },
                                {
                                    key: "getSeekable",
                                    value: function getSeekable() {
                                        return this.get("seekable");
                                    }
                                    /**
                                     * A promise to get the seeking property of the player.
                                     *
                                     * @promise GetSeekingPromise
                                     * @fulfill {boolean} Whether or not the player is currently seeking.
                                     */
                                    /**
                                     * Get if the player is currently seeking.
                                     *
                                     * @return {GetSeekingPromise}
                                     */,
                                },
                                {
                                    key: "getSeeking",
                                    value: function getSeeking() {
                                        return this.get("seeking");
                                    }
                                    /**
                                     * A promise to get the text tracks of a video.
                                     *
                                     * @promise GetTextTracksPromise
                                     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
                                     */
                                    /**
                                     * Get an array of the text tracks that exist for the video.
                                     *
                                     * @return {GetTextTracksPromise}
                                     */,
                                },
                                {
                                    key: "getTextTracks",
                                    value: function getTextTracks() {
                                        return this.get("textTracks");
                                    }
                                    /**
                                     * A promise to get the embed code for the video.
                                     *
                                     * @promise GetVideoEmbedCodePromise
                                     * @fulfill {string} The `<iframe>` embed code for the video.
                                     */
                                    /**
                                     * Get the `<iframe>` embed code for the video.
                                     *
                                     * @return {GetVideoEmbedCodePromise}
                                     */,
                                },
                                {
                                    key: "getVideoEmbedCode",
                                    value: function getVideoEmbedCode() {
                                        return this.get("videoEmbedCode");
                                    }
                                    /**
                                     * A promise to get the id of the video.
                                     *
                                     * @promise GetVideoIdPromise
                                     * @fulfill {number} The id of the video.
                                     */
                                    /**
                                     * Get the id of the video.
                                     *
                                     * @return {GetVideoIdPromise}
                                     */,
                                },
                                {
                                    key: "getVideoId",
                                    value: function getVideoId() {
                                        return this.get("videoId");
                                    }
                                    /**
                                     * A promise to get the title of the video.
                                     *
                                     * @promise GetVideoTitlePromise
                                     * @fulfill {number} The title of the video.
                                     */
                                    /**
                                     * Get the title of the video.
                                     *
                                     * @return {GetVideoTitlePromise}
                                     */,
                                },
                                {
                                    key: "getVideoTitle",
                                    value: function getVideoTitle() {
                                        return this.get("videoTitle");
                                    }
                                    /**
                                     * A promise to get the native width of the video.
                                     *
                                     * @promise GetVideoWidthPromise
                                     * @fulfill {number} The native width of the video.
                                     */
                                    /**
                                     * Get the native width of the currently‐playing video. The width of
                                     * the highest‐resolution available will be used before playback begins.
                                     *
                                     * @return {GetVideoWidthPromise}
                                     */,
                                },
                                {
                                    key: "getVideoWidth",
                                    value: function getVideoWidth() {
                                        return this.get("videoWidth");
                                    }
                                    /**
                                     * A promise to get the native height of the video.
                                     *
                                     * @promise GetVideoHeightPromise
                                     * @fulfill {number} The native height of the video.
                                     */
                                    /**
                                     * Get the native height of the currently‐playing video. The height of
                                     * the highest‐resolution available will be used before playback begins.
                                     *
                                     * @return {GetVideoHeightPromise}
                                     */,
                                },
                                {
                                    key: "getVideoHeight",
                                    value: function getVideoHeight() {
                                        return this.get("videoHeight");
                                    }
                                    /**
                                     * A promise to get the vimeo.com url for the video.
                                     *
                                     * @promise GetVideoUrlPromise
                                     * @fulfill {number} The vimeo.com url for the video.
                                     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
                                     */
                                    /**
                                     * Get the vimeo.com url for the video.
                                     *
                                     * @return {GetVideoUrlPromise}
                                     */,
                                },
                                {
                                    key: "getVideoUrl",
                                    value: function getVideoUrl() {
                                        return this.get("videoUrl");
                                    }
                                    /**
                                     * A promise to get the volume level of the player.
                                     *
                                     * @promise GetVolumePromise
                                     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
                                     */
                                    /**
                                     * Get the current volume level of the player on a scale from `0` to `1`.
                                     *
                                     * Most mobile devices do not support an independent volume from the
                                     * system volume. In those cases, this method will always return `1`.
                                     *
                                     * @return {GetVolumePromise}
                                     */,
                                },
                                {
                                    key: "getVolume",
                                    value: function getVolume() {
                                        return this.get("volume");
                                    }
                                    /**
                                     * A promise to set the volume level of the player.
                                     *
                                     * @promise SetVolumePromise
                                     * @fulfill {number} The volume was set.
                                     * @reject {RangeError} The volume was less than 0 or greater than 1.
                                     */
                                    /**
                                     * Set the volume of the player on a scale from `0` to `1`. When set
                                     * via the API, the volume level will not be synchronized to other
                                     * players or stored as the viewer’s preference.
                                     *
                                     * Most mobile devices do not support setting the volume. An error will
                                     * *not* be triggered in that situation.
                                     *
                                     * @param {number} volume
                                     * @return {SetVolumePromise}
                                     */,
                                },
                                {
                                    key: "setVolume",
                                    value: function setVolume(volume) {
                                        return this.set("volume", volume);
                                    },
                                },
                            ]);
                            return Player;
                        })(); // Setup embed only if this is not a node environment
                        if (!isNode) {
                            screenfull = initializeScreenfull();
                            initializeEmbeds();
                            resizeEmbeds();
                        }
                        return Player;
                    });
                }.call(this, typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {}));
            },
            {},
        ],
        52: [
            function (require, module, exports) {
                (function (process, global) {
                    /* @preserve
                     * The MIT License (MIT)
                     *
                     * Copyright (c) 2013-2018 Petka Antonov
                     *
                     * Permission is hereby granted, free of charge, to any person obtaining a copy
                     * of this software and associated documentation files (the "Software"), to deal
                     * in the Software without restriction, including without limitation the rights
                     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                     * copies of the Software, and to permit persons to whom the Software is
                     * furnished to do so, subject to the following conditions:
                     *
                     * The above copyright notice and this permission notice shall be included in
                     * all copies or substantial portions of the Software.
                     *
                     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
                     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
                     * THE SOFTWARE.
                     *
                     */ /**
                     * bluebird build version 3.7.2
                     * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
                     */ !(function (e) {
                        if ("object" == _typeof(exports) && "undefined" != typeof module) module.exports = e();
                        else if ("function" == typeof define && define.amd) define([], e);
                        else {
                            var f;
                            "undefined" != typeof window ? (f = window) : "undefined" != typeof global ? (f = global) : "undefined" != typeof self && (f = self), (f.Promise = e());
                        }
                    })(function () {
                        var define, module, exports;
                        return (function e(t, n, r) {
                            function s(o, u) {
                                if (!n[o]) {
                                    if (!t[o]) {
                                        var a = typeof _dereq_ == "function" && _dereq_;
                                        if (!u && a) return a(o, !0);
                                        if (i) return i(o, !0);
                                        var f = new Error("Cannot find module '" + o + "'");
                                        throw ((f.code = "MODULE_NOT_FOUND"), f);
                                    }
                                    var l = (n[o] = { exports: {} });
                                    t[o][0].call(
                                        l.exports,
                                        function (e) {
                                            var n = t[o][1][e];
                                            return s(n ? n : e);
                                        },
                                        l,
                                        l.exports,
                                        e,
                                        t,
                                        n,
                                        r
                                    );
                                }
                                return n[o].exports;
                            }
                            var i = typeof _dereq_ == "function" && _dereq_;
                            for (var o = 0; o < r.length; o++) {
                                s(r[o]);
                            }
                            return s;
                        })(
                            {
                                1: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise) {
                                            var SomePromiseArray = Promise._SomePromiseArray;
                                            function any(promises) {
                                                var ret = new SomePromiseArray(promises);
                                                var promise = ret.promise();
                                                ret.setHowMany(1);
                                                ret.setUnwrap();
                                                ret.init();
                                                return promise;
                                            }
                                            Promise.any = function (promises) {
                                                return any(promises);
                                            };
                                            Promise.prototype.any = function () {
                                                return any(this);
                                            };
                                        };
                                    },
                                    {},
                                ],
                                2: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        var firstLineError;
                                        try {
                                            throw new Error();
                                        } catch (e) {
                                            firstLineError = e;
                                        }
                                        var schedule = _dereq_("./schedule");
                                        var Queue = _dereq_("./queue");
                                        function Async() {
                                            this._customScheduler = false;
                                            this._isTickUsed = false;
                                            this._lateQueue = new Queue(16);
                                            this._normalQueue = new Queue(16);
                                            this._haveDrainedQueues = false;
                                            var self = this;
                                            this.drainQueues = function () {
                                                self._drainQueues();
                                            };
                                            this._schedule = schedule;
                                        }
                                        Async.prototype.setScheduler = function (fn) {
                                            var prev = this._schedule;
                                            this._schedule = fn;
                                            this._customScheduler = true;
                                            return prev;
                                        };
                                        Async.prototype.hasCustomScheduler = function () {
                                            return this._customScheduler;
                                        };
                                        Async.prototype.haveItemsQueued = function () {
                                            return this._isTickUsed || this._haveDrainedQueues;
                                        };
                                        Async.prototype.fatalError = function (e, isNode) {
                                            if (isNode) {
                                                process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
                                                process.exit(2);
                                            } else {
                                                this.throwLater(e);
                                            }
                                        };
                                        Async.prototype.throwLater = function (fn, arg) {
                                            if (arguments.length === 1) {
                                                arg = fn;
                                                fn = function fn() {
                                                    throw arg;
                                                };
                                            }
                                            if (typeof setTimeout !== "undefined") {
                                                setTimeout(function () {
                                                    fn(arg);
                                                }, 0);
                                            } else
                                                try {
                                                    this._schedule(function () {
                                                        fn(arg);
                                                    });
                                                } catch (e) {
                                                    throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
                                                }
                                        };
                                        function AsyncInvokeLater(fn, receiver, arg) {
                                            this._lateQueue.push(fn, receiver, arg);
                                            this._queueTick();
                                        }
                                        function AsyncInvoke(fn, receiver, arg) {
                                            this._normalQueue.push(fn, receiver, arg);
                                            this._queueTick();
                                        }
                                        function AsyncSettlePromises(promise) {
                                            this._normalQueue._pushOne(promise);
                                            this._queueTick();
                                        }
                                        Async.prototype.invokeLater = AsyncInvokeLater;
                                        Async.prototype.invoke = AsyncInvoke;
                                        Async.prototype.settlePromises = AsyncSettlePromises;
                                        function _drainQueue(queue) {
                                            while (queue.length() > 0) {
                                                _drainQueueStep(queue);
                                            }
                                        }
                                        function _drainQueueStep(queue) {
                                            var fn = queue.shift();
                                            if (typeof fn !== "function") {
                                                fn._settlePromises();
                                            } else {
                                                var receiver = queue.shift();
                                                var arg = queue.shift();
                                                fn.call(receiver, arg);
                                            }
                                        }
                                        Async.prototype._drainQueues = function () {
                                            _drainQueue(this._normalQueue);
                                            this._reset();
                                            this._haveDrainedQueues = true;
                                            _drainQueue(this._lateQueue);
                                        };
                                        Async.prototype._queueTick = function () {
                                            if (!this._isTickUsed) {
                                                this._isTickUsed = true;
                                                this._schedule(this.drainQueues);
                                            }
                                        };
                                        Async.prototype._reset = function () {
                                            this._isTickUsed = false;
                                        };
                                        module.exports = Async;
                                        module.exports.firstLineError = firstLineError;
                                    },
                                    { "./queue": 26, "./schedule": 29 },
                                ],
                                3: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, INTERNAL, tryConvertToPromise, debug) {
                                            var calledBind = false;
                                            var rejectThis = function rejectThis(_, e) {
                                                this._reject(e);
                                            };
                                            var targetRejected = function targetRejected(e, context) {
                                                context.promiseRejectionQueued = true;
                                                context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
                                            };
                                            var bindingResolved = function bindingResolved(thisArg, context) {
                                                if ((this._bitField & 50397184) === 0) {
                                                    this._resolveCallback(context.target);
                                                }
                                            };
                                            var bindingRejected = function bindingRejected(e, context) {
                                                if (!context.promiseRejectionQueued) this._reject(e);
                                            };
                                            Promise.prototype.bind = function (thisArg) {
                                                if (!calledBind) {
                                                    calledBind = true;
                                                    Promise.prototype._propagateFrom = debug.propagateFromFunction();
                                                    Promise.prototype._boundValue = debug.boundValueFunction();
                                                }
                                                var maybePromise = tryConvertToPromise(thisArg);
                                                var ret = new Promise(INTERNAL);
                                                ret._propagateFrom(this, 1);
                                                var target = this._target();
                                                ret._setBoundTo(maybePromise);
                                                if (maybePromise instanceof Promise) {
                                                    var context = { promiseRejectionQueued: false, promise: ret, target: target, bindingPromise: maybePromise };
                                                    target._then(INTERNAL, targetRejected, undefined, ret, context);
                                                    maybePromise._then(bindingResolved, bindingRejected, undefined, ret, context);
                                                    ret._setOnCancel(maybePromise);
                                                } else {
                                                    ret._resolveCallback(target);
                                                }
                                                return ret;
                                            };
                                            Promise.prototype._setBoundTo = function (obj) {
                                                if (obj !== undefined) {
                                                    this._bitField = this._bitField | 2097152;
                                                    this._boundTo = obj;
                                                } else {
                                                    this._bitField = this._bitField & ~2097152;
                                                }
                                            };
                                            Promise.prototype._isBound = function () {
                                                return (this._bitField & 2097152) === 2097152;
                                            };
                                            Promise.bind = function (thisArg, value) {
                                                return Promise.resolve(value).bind(thisArg);
                                            };
                                        };
                                    },
                                    {},
                                ],
                                4: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        var old;
                                        if (typeof Promise !== "undefined") old = Promise;
                                        function noConflict() {
                                            try {
                                                if (Promise === bluebird) Promise = old;
                                            } catch (e) {}
                                            return bluebird;
                                        }
                                        var bluebird = _dereq_("./promise")();
                                        bluebird.noConflict = noConflict;
                                        module.exports = bluebird;
                                    },
                                    { "./promise": 22 },
                                ],
                                5: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        var cr = Object.create;
                                        if (cr) {
                                            var callerCache = cr(null);
                                            var getterCache = cr(null);
                                            callerCache[" size"] = getterCache[" size"] = 0;
                                        }
                                        module.exports = function (Promise) {
                                            var util = _dereq_("./util");
                                            var canEvaluate = util.canEvaluate;
                                            var isIdentifier = util.isIdentifier;
                                            var getMethodCaller;
                                            var getGetter;
                                            if (!true) {
                                                var makeMethodCaller = function makeMethodCaller(methodName) {
                                                    return new Function(
                                                        "ensureMethod",
                                                        "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(
                                                            /methodName/g,
                                                            methodName
                                                        )
                                                    )(ensureMethod);
                                                };
                                                var makeGetter = function makeGetter(propertyName) {
                                                    return new Function(
                                                        "obj",
                                                        "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace(
                                                            "propertyName",
                                                            propertyName
                                                        )
                                                    );
                                                };
                                                var getCompiled = function getCompiled(name, compiler, cache) {
                                                    var ret = cache[name];
                                                    if (typeof ret !== "function") {
                                                        if (!isIdentifier(name)) {
                                                            return null;
                                                        }
                                                        ret = compiler(name);
                                                        cache[name] = ret;
                                                        cache[" size"]++;
                                                        if (cache[" size"] > 512) {
                                                            var keys = Object.keys(cache);
                                                            for (var i = 0; i < 256; ++i) {
                                                                delete cache[keys[i]];
                                                            }
                                                            cache[" size"] = keys.length - 256;
                                                        }
                                                    }
                                                    return ret;
                                                };
                                                getMethodCaller = function getMethodCaller(name) {
                                                    return getCompiled(name, makeMethodCaller, callerCache);
                                                };
                                                getGetter = function getGetter(name) {
                                                    return getCompiled(name, makeGetter, getterCache);
                                                };
                                            }
                                            function ensureMethod(obj, methodName) {
                                                var fn;
                                                if (obj != null) fn = obj[methodName];
                                                if (typeof fn !== "function") {
                                                    var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
                                                    throw new Promise.TypeError(message);
                                                }
                                                return fn;
                                            }
                                            function caller(obj) {
                                                var methodName = this.pop();
                                                var fn = ensureMethod(obj, methodName);
                                                return fn.apply(obj, this);
                                            }
                                            Promise.prototype.call = function (methodName) {
                                                var args = [].slice.call(arguments, 1);
                                                if (!true) {
                                                    if (canEvaluate) {
                                                        var maybeCaller = getMethodCaller(methodName);
                                                        if (maybeCaller !== null) {
                                                            return this._then(maybeCaller, undefined, undefined, args, undefined);
                                                        }
                                                    }
                                                }
                                                args.push(methodName);
                                                return this._then(caller, undefined, undefined, args, undefined);
                                            };
                                            function namedGetter(obj) {
                                                return obj[this];
                                            }
                                            function indexedGetter(obj) {
                                                var index = +this;
                                                if (index < 0) index = Math.max(0, index + obj.length);
                                                return obj[index];
                                            }
                                            Promise.prototype.get = function (propertyName) {
                                                var isIndex = typeof propertyName === "number";
                                                var getter;
                                                if (!isIndex) {
                                                    if (canEvaluate) {
                                                        var maybeGetter = getGetter(propertyName);
                                                        getter = maybeGetter !== null ? maybeGetter : namedGetter;
                                                    } else {
                                                        getter = namedGetter;
                                                    }
                                                } else {
                                                    getter = indexedGetter;
                                                }
                                                return this._then(getter, undefined, undefined, propertyName, undefined);
                                            };
                                        };
                                    },
                                    { "./util": 36 },
                                ],
                                6: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, PromiseArray, apiRejection, debug) {
                                            var util = _dereq_("./util");
                                            var tryCatch = util.tryCatch;
                                            var errorObj = util.errorObj;
                                            var async = Promise._async;
                                            Promise.prototype["break"] = Promise.prototype.cancel = function () {
                                                if (!debug.cancellation()) return this._warn("cancellation is disabled");
                                                var promise = this;
                                                var child = promise;
                                                while (promise._isCancellable()) {
                                                    if (!promise._cancelBy(child)) {
                                                        if (child._isFollowing()) {
                                                            child._followee().cancel();
                                                        } else {
                                                            child._cancelBranched();
                                                        }
                                                        break;
                                                    }
                                                    var parent = promise._cancellationParent;
                                                    if (parent == null || !parent._isCancellable()) {
                                                        if (promise._isFollowing()) {
                                                            promise._followee().cancel();
                                                        } else {
                                                            promise._cancelBranched();
                                                        }
                                                        break;
                                                    } else {
                                                        if (promise._isFollowing()) promise._followee().cancel();
                                                        promise._setWillBeCancelled();
                                                        child = promise;
                                                        promise = parent;
                                                    }
                                                }
                                            };
                                            Promise.prototype._branchHasCancelled = function () {
                                                this._branchesRemainingToCancel--;
                                            };
                                            Promise.prototype._enoughBranchesHaveCancelled = function () {
                                                return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0;
                                            };
                                            Promise.prototype._cancelBy = function (canceller) {
                                                if (canceller === this) {
                                                    this._branchesRemainingToCancel = 0;
                                                    this._invokeOnCancel();
                                                    return true;
                                                } else {
                                                    this._branchHasCancelled();
                                                    if (this._enoughBranchesHaveCancelled()) {
                                                        this._invokeOnCancel();
                                                        return true;
                                                    }
                                                }
                                                return false;
                                            };
                                            Promise.prototype._cancelBranched = function () {
                                                if (this._enoughBranchesHaveCancelled()) {
                                                    this._cancel();
                                                }
                                            };
                                            Promise.prototype._cancel = function () {
                                                if (!this._isCancellable()) return;
                                                this._setCancelled();
                                                async.invoke(this._cancelPromises, this, undefined);
                                            };
                                            Promise.prototype._cancelPromises = function () {
                                                if (this._length() > 0) this._settlePromises();
                                            };
                                            Promise.prototype._unsetOnCancel = function () {
                                                this._onCancelField = undefined;
                                            };
                                            Promise.prototype._isCancellable = function () {
                                                return this.isPending() && !this._isCancelled();
                                            };
                                            Promise.prototype.isCancellable = function () {
                                                return this.isPending() && !this.isCancelled();
                                            };
                                            Promise.prototype._doInvokeOnCancel = function (onCancelCallback, internalOnly) {
                                                if (util.isArray(onCancelCallback)) {
                                                    for (var i = 0; i < onCancelCallback.length; ++i) {
                                                        this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
                                                    }
                                                } else if (onCancelCallback !== undefined) {
                                                    if (typeof onCancelCallback === "function") {
                                                        if (!internalOnly) {
                                                            var e = tryCatch(onCancelCallback).call(this._boundValue());
                                                            if (e === errorObj) {
                                                                this._attachExtraTrace(e.e);
                                                                async.throwLater(e.e);
                                                            }
                                                        }
                                                    } else {
                                                        onCancelCallback._resultCancelled(this);
                                                    }
                                                }
                                            };
                                            Promise.prototype._invokeOnCancel = function () {
                                                var onCancelCallback = this._onCancel();
                                                this._unsetOnCancel();
                                                async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
                                            };
                                            Promise.prototype._invokeInternalOnCancel = function () {
                                                if (this._isCancellable()) {
                                                    this._doInvokeOnCancel(this._onCancel(), true);
                                                    this._unsetOnCancel();
                                                }
                                            };
                                            Promise.prototype._resultCancelled = function () {
                                                this.cancel();
                                            };
                                        };
                                    },
                                    { "./util": 36 },
                                ],
                                7: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (NEXT_FILTER) {
                                            var util = _dereq_("./util");
                                            var getKeys = _dereq_("./es5").keys;
                                            var tryCatch = util.tryCatch;
                                            var errorObj = util.errorObj;
                                            function catchFilter(instances, cb, promise) {
                                                return function (e) {
                                                    var boundTo = promise._boundValue();
                                                    predicateLoop: for (var i = 0; i < instances.length; ++i) {
                                                        var item = instances[i];
                                                        if (item === Error || (item != null && item.prototype instanceof Error)) {
                                                            if (e instanceof item) {
                                                                return tryCatch(cb).call(boundTo, e);
                                                            }
                                                        } else if (typeof item === "function") {
                                                            var matchesPredicate = tryCatch(item).call(boundTo, e);
                                                            if (matchesPredicate === errorObj) {
                                                                return matchesPredicate;
                                                            } else if (matchesPredicate) {
                                                                return tryCatch(cb).call(boundTo, e);
                                                            }
                                                        } else if (util.isObject(e)) {
                                                            var keys = getKeys(item);
                                                            for (var j = 0; j < keys.length; ++j) {
                                                                var key = keys[j];
                                                                if (item[key] != e[key]) {
                                                                    continue predicateLoop;
                                                                }
                                                            }
                                                            return tryCatch(cb).call(boundTo, e);
                                                        }
                                                    }
                                                    return NEXT_FILTER;
                                                };
                                            }
                                            return catchFilter;
                                        };
                                    },
                                    { "./es5": 13, "./util": 36 },
                                ],
                                8: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise) {
                                            var longStackTraces = false;
                                            var contextStack = [];
                                            Promise.prototype._promiseCreated = function () {};
                                            Promise.prototype._pushContext = function () {};
                                            Promise.prototype._popContext = function () {
                                                return null;
                                            };
                                            Promise._peekContext = Promise.prototype._peekContext = function () {};
                                            function Context() {
                                                this._trace = new Context.CapturedTrace(peekContext());
                                            }
                                            Context.prototype._pushContext = function () {
                                                if (this._trace !== undefined) {
                                                    this._trace._promiseCreated = null;
                                                    contextStack.push(this._trace);
                                                }
                                            };
                                            Context.prototype._popContext = function () {
                                                if (this._trace !== undefined) {
                                                    var trace = contextStack.pop();
                                                    var ret = trace._promiseCreated;
                                                    trace._promiseCreated = null;
                                                    return ret;
                                                }
                                                return null;
                                            };
                                            function createContext() {
                                                if (longStackTraces) return new Context();
                                            }
                                            function peekContext() {
                                                var lastIndex = contextStack.length - 1;
                                                if (lastIndex >= 0) {
                                                    return contextStack[lastIndex];
                                                }
                                                return undefined;
                                            }
                                            Context.CapturedTrace = null;
                                            Context.create = createContext;
                                            Context.deactivateLongStackTraces = function () {};
                                            Context.activateLongStackTraces = function () {
                                                var Promise_pushContext = Promise.prototype._pushContext;
                                                var Promise_popContext = Promise.prototype._popContext;
                                                var Promise_PeekContext = Promise._peekContext;
                                                var Promise_peekContext = Promise.prototype._peekContext;
                                                var Promise_promiseCreated = Promise.prototype._promiseCreated;
                                                Context.deactivateLongStackTraces = function () {
                                                    Promise.prototype._pushContext = Promise_pushContext;
                                                    Promise.prototype._popContext = Promise_popContext;
                                                    Promise._peekContext = Promise_PeekContext;
                                                    Promise.prototype._peekContext = Promise_peekContext;
                                                    Promise.prototype._promiseCreated = Promise_promiseCreated;
                                                    longStackTraces = false;
                                                };
                                                longStackTraces = true;
                                                Promise.prototype._pushContext = Context.prototype._pushContext;
                                                Promise.prototype._popContext = Context.prototype._popContext;
                                                Promise._peekContext = Promise.prototype._peekContext = peekContext;
                                                Promise.prototype._promiseCreated = function () {
                                                    var ctx = this._peekContext();
                                                    if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
                                                };
                                            };
                                            return Context;
                                        };
                                    },
                                    {},
                                ],
                                9: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, Context, enableAsyncHooks, disableAsyncHooks) {
                                            var async = Promise._async;
                                            var Warning = _dereq_("./errors").Warning;
                                            var util = _dereq_("./util");
                                            var es5 = _dereq_("./es5");
                                            var canAttachTrace = util.canAttachTrace;
                                            var unhandledRejectionHandled;
                                            var possiblyUnhandledRejection;
                                            var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
                                            var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
                                            var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
                                            var stackFramePattern = null;
                                            var formatStack = null;
                                            var indentStackFrames = false;
                                            var printWarning;
                                            var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && (true || util.env("BLUEBIRD_DEBUG") || util.env("NODE_ENV") === "development"));
                                            var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
                                            var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
                                            var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
                                            var deferUnhandledRejectionCheck;
                                            (function () {
                                                var promises = [];
                                                function unhandledRejectionCheck() {
                                                    for (var i = 0; i < promises.length; ++i) {
                                                        promises[i]._notifyUnhandledRejection();
                                                    }
                                                    unhandledRejectionClear();
                                                }
                                                function unhandledRejectionClear() {
                                                    promises.length = 0;
                                                }
                                                deferUnhandledRejectionCheck = function deferUnhandledRejectionCheck(promise) {
                                                    promises.push(promise);
                                                    setTimeout(unhandledRejectionCheck, 1);
                                                };
                                                es5.defineProperty(Promise, "_unhandledRejectionCheck", { value: unhandledRejectionCheck });
                                                es5.defineProperty(Promise, "_unhandledRejectionClear", { value: unhandledRejectionClear });
                                            })();
                                            Promise.prototype.suppressUnhandledRejections = function () {
                                                var target = this._target();
                                                target._bitField = (target._bitField & ~1048576) | 524288;
                                            };
                                            Promise.prototype._ensurePossibleRejectionHandled = function () {
                                                if ((this._bitField & 524288) !== 0) return;
                                                this._setRejectionIsUnhandled();
                                                deferUnhandledRejectionCheck(this);
                                            };
                                            Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
                                                fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
                                            };
                                            Promise.prototype._setReturnedNonUndefined = function () {
                                                this._bitField = this._bitField | 268435456;
                                            };
                                            Promise.prototype._returnedNonUndefined = function () {
                                                return (this._bitField & 268435456) !== 0;
                                            };
                                            Promise.prototype._notifyUnhandledRejection = function () {
                                                if (this._isRejectionUnhandled()) {
                                                    var reason = this._settledValue();
                                                    this._setUnhandledRejectionIsNotified();
                                                    fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
                                                }
                                            };
                                            Promise.prototype._setUnhandledRejectionIsNotified = function () {
                                                this._bitField = this._bitField | 262144;
                                            };
                                            Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
                                                this._bitField = this._bitField & ~262144;
                                            };
                                            Promise.prototype._isUnhandledRejectionNotified = function () {
                                                return (this._bitField & 262144) > 0;
                                            };
                                            Promise.prototype._setRejectionIsUnhandled = function () {
                                                this._bitField = this._bitField | 1048576;
                                            };
                                            Promise.prototype._unsetRejectionIsUnhandled = function () {
                                                this._bitField = this._bitField & ~1048576;
                                                if (this._isUnhandledRejectionNotified()) {
                                                    this._unsetUnhandledRejectionIsNotified();
                                                    this._notifyUnhandledRejectionIsHandled();
                                                }
                                            };
                                            Promise.prototype._isRejectionUnhandled = function () {
                                                return (this._bitField & 1048576) > 0;
                                            };
                                            Promise.prototype._warn = function (message, shouldUseOwnTrace, promise) {
                                                return warn(message, shouldUseOwnTrace, promise || this);
                                            };
                                            Promise.onPossiblyUnhandledRejection = function (fn) {
                                                var context = Promise._getContext();
                                                possiblyUnhandledRejection = util.contextBind(context, fn);
                                            };
                                            Promise.onUnhandledRejectionHandled = function (fn) {
                                                var context = Promise._getContext();
                                                unhandledRejectionHandled = util.contextBind(context, fn);
                                            };
                                            var disableLongStackTraces = function disableLongStackTraces() {};
                                            Promise.longStackTraces = function () {
                                                if (async.haveItemsQueued() && !config.longStackTraces) {
                                                    throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
                                                }
                                                if (!config.longStackTraces && longStackTracesIsSupported()) {
                                                    var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
                                                    var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
                                                    var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
                                                    config.longStackTraces = true;
                                                    disableLongStackTraces = function disableLongStackTraces() {
                                                        if (async.haveItemsQueued() && !config.longStackTraces) {
                                                            throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
                                                        }
                                                        Promise.prototype._captureStackTrace = Promise_captureStackTrace;
                                                        Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
                                                        Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
                                                        Context.deactivateLongStackTraces();
                                                        config.longStackTraces = false;
                                                    };
                                                    Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
                                                    Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
                                                    Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
                                                    Context.activateLongStackTraces();
                                                }
                                            };
                                            Promise.hasLongStackTraces = function () {
                                                return config.longStackTraces && longStackTracesIsSupported();
                                            };
                                            var legacyHandlers = {
                                                unhandledrejection: {
                                                    before: function before() {
                                                        var ret = util.global.onunhandledrejection;
                                                        util.global.onunhandledrejection = null;
                                                        return ret;
                                                    },
                                                    after: function after(fn) {
                                                        util.global.onunhandledrejection = fn;
                                                    },
                                                },
                                                rejectionhandled: {
                                                    before: function before() {
                                                        var ret = util.global.onrejectionhandled;
                                                        util.global.onrejectionhandled = null;
                                                        return ret;
                                                    },
                                                    after: function after(fn) {
                                                        util.global.onrejectionhandled = fn;
                                                    },
                                                },
                                            };
                                            var fireDomEvent = (function () {
                                                var dispatch = function dispatch(legacy, e) {
                                                    if (legacy) {
                                                        var fn;
                                                        try {
                                                            fn = legacy.before();
                                                            return !util.global.dispatchEvent(e);
                                                        } finally {
                                                            legacy.after(fn);
                                                        }
                                                    } else {
                                                        return !util.global.dispatchEvent(e);
                                                    }
                                                };
                                                try {
                                                    if (typeof CustomEvent === "function") {
                                                        var event = new CustomEvent("CustomEvent");
                                                        util.global.dispatchEvent(event);
                                                        return function (name, event) {
                                                            name = name.toLowerCase();
                                                            var eventData = { detail: event, cancelable: true };
                                                            var domEvent = new CustomEvent(name, eventData);
                                                            es5.defineProperty(domEvent, "promise", { value: event.promise });
                                                            es5.defineProperty(domEvent, "reason", { value: event.reason });
                                                            return dispatch(legacyHandlers[name], domEvent);
                                                        };
                                                    } else if (typeof Event === "function") {
                                                        var event = new Event("CustomEvent");
                                                        util.global.dispatchEvent(event);
                                                        return function (name, event) {
                                                            name = name.toLowerCase();
                                                            var domEvent = new Event(name, { cancelable: true });
                                                            domEvent.detail = event;
                                                            es5.defineProperty(domEvent, "promise", { value: event.promise });
                                                            es5.defineProperty(domEvent, "reason", { value: event.reason });
                                                            return dispatch(legacyHandlers[name], domEvent);
                                                        };
                                                    } else {
                                                        var event = document.createEvent("CustomEvent");
                                                        event.initCustomEvent("testingtheevent", false, true, {});
                                                        util.global.dispatchEvent(event);
                                                        return function (name, event) {
                                                            name = name.toLowerCase();
                                                            var domEvent = document.createEvent("CustomEvent");
                                                            domEvent.initCustomEvent(name, false, true, event);
                                                            return dispatch(legacyHandlers[name], domEvent);
                                                        };
                                                    }
                                                } catch (e) {}
                                                return function () {
                                                    return false;
                                                };
                                            })();
                                            var fireGlobalEvent = (function () {
                                                if (util.isNode) {
                                                    return function () {
                                                        return process.emit.apply(process, arguments);
                                                    };
                                                } else {
                                                    if (!util.global) {
                                                        return function () {
                                                            return false;
                                                        };
                                                    }
                                                    return function (name) {
                                                        var methodName = "on" + name.toLowerCase();
                                                        var method = util.global[methodName];
                                                        if (!method) return false;
                                                        method.apply(util.global, [].slice.call(arguments, 1));
                                                        return true;
                                                    };
                                                }
                                            })();
                                            function generatePromiseLifecycleEventObject(name, promise) {
                                                return { promise: promise };
                                            }
                                            var eventToObjectGenerator = {
                                                promiseCreated: generatePromiseLifecycleEventObject,
                                                promiseFulfilled: generatePromiseLifecycleEventObject,
                                                promiseRejected: generatePromiseLifecycleEventObject,
                                                promiseResolved: generatePromiseLifecycleEventObject,
                                                promiseCancelled: generatePromiseLifecycleEventObject,
                                                promiseChained: function promiseChained(name, promise, child) {
                                                    return { promise: promise, child: child };
                                                },
                                                warning: function warning(name, _warning) {
                                                    return { warning: _warning };
                                                },
                                                unhandledRejection: function unhandledRejection(name, reason, promise) {
                                                    return { reason: reason, promise: promise };
                                                },
                                                rejectionHandled: generatePromiseLifecycleEventObject,
                                            };
                                            var activeFireEvent = function activeFireEvent(name) {
                                                var globalEventFired = false;
                                                try {
                                                    globalEventFired = fireGlobalEvent.apply(null, arguments);
                                                } catch (e) {
                                                    async.throwLater(e);
                                                    globalEventFired = true;
                                                }
                                                var domEventFired = false;
                                                try {
                                                    domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
                                                } catch (e) {
                                                    async.throwLater(e);
                                                    domEventFired = true;
                                                }
                                                return domEventFired || globalEventFired;
                                            };
                                            Promise.config = function (opts) {
                                                opts = Object(opts);
                                                if ("longStackTraces" in opts) {
                                                    if (opts.longStackTraces) {
                                                        Promise.longStackTraces();
                                                    } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
                                                        disableLongStackTraces();
                                                    }
                                                }
                                                if ("warnings" in opts) {
                                                    var warningsOption = opts.warnings;
                                                    config.warnings = !!warningsOption;
                                                    wForgottenReturn = config.warnings;
                                                    if (util.isObject(warningsOption)) {
                                                        if ("wForgottenReturn" in warningsOption) {
                                                            wForgottenReturn = !!warningsOption.wForgottenReturn;
                                                        }
                                                    }
                                                }
                                                if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
                                                    if (async.haveItemsQueued()) {
                                                        throw new Error("cannot enable cancellation after promises are in use");
                                                    }
                                                    Promise.prototype._clearCancellationData = cancellationClearCancellationData;
                                                    Promise.prototype._propagateFrom = cancellationPropagateFrom;
                                                    Promise.prototype._onCancel = cancellationOnCancel;
                                                    Promise.prototype._setOnCancel = cancellationSetOnCancel;
                                                    Promise.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
                                                    Promise.prototype._execute = cancellationExecute;
                                                    _propagateFromFunction = cancellationPropagateFrom;
                                                    config.cancellation = true;
                                                }
                                                if ("monitoring" in opts) {
                                                    if (opts.monitoring && !config.monitoring) {
                                                        config.monitoring = true;
                                                        Promise.prototype._fireEvent = activeFireEvent;
                                                    } else if (!opts.monitoring && config.monitoring) {
                                                        config.monitoring = false;
                                                        Promise.prototype._fireEvent = defaultFireEvent;
                                                    }
                                                }
                                                if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
                                                    var prev = config.asyncHooks;
                                                    var cur = !!opts.asyncHooks;
                                                    if (prev !== cur) {
                                                        config.asyncHooks = cur;
                                                        if (cur) {
                                                            enableAsyncHooks();
                                                        } else {
                                                            disableAsyncHooks();
                                                        }
                                                    }
                                                }
                                                return Promise;
                                            };
                                            function defaultFireEvent() {
                                                return false;
                                            }
                                            Promise.prototype._fireEvent = defaultFireEvent;
                                            Promise.prototype._execute = function (executor, resolve, reject) {
                                                try {
                                                    executor(resolve, reject);
                                                } catch (e) {
                                                    return e;
                                                }
                                            };
                                            Promise.prototype._onCancel = function () {};
                                            Promise.prototype._setOnCancel = function (handler) {};
                                            Promise.prototype._attachCancellationCallback = function (onCancel) {};
                                            Promise.prototype._captureStackTrace = function () {};
                                            Promise.prototype._attachExtraTrace = function () {};
                                            Promise.prototype._dereferenceTrace = function () {};
                                            Promise.prototype._clearCancellationData = function () {};
                                            Promise.prototype._propagateFrom = function (parent, flags) {};
                                            function cancellationExecute(executor, resolve, reject) {
                                                var promise = this;
                                                try {
                                                    executor(resolve, reject, function (onCancel) {
                                                        if (typeof onCancel !== "function") {
                                                            throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
                                                        }
                                                        promise._attachCancellationCallback(onCancel);
                                                    });
                                                } catch (e) {
                                                    return e;
                                                }
                                            }
                                            function cancellationAttachCancellationCallback(onCancel) {
                                                if (!this._isCancellable()) return this;
                                                var previousOnCancel = this._onCancel();
                                                if (previousOnCancel !== undefined) {
                                                    if (util.isArray(previousOnCancel)) {
                                                        previousOnCancel.push(onCancel);
                                                    } else {
                                                        this._setOnCancel([previousOnCancel, onCancel]);
                                                    }
                                                } else {
                                                    this._setOnCancel(onCancel);
                                                }
                                            }
                                            function cancellationOnCancel() {
                                                return this._onCancelField;
                                            }
                                            function cancellationSetOnCancel(onCancel) {
                                                this._onCancelField = onCancel;
                                            }
                                            function cancellationClearCancellationData() {
                                                this._cancellationParent = undefined;
                                                this._onCancelField = undefined;
                                            }
                                            function cancellationPropagateFrom(parent, flags) {
                                                if ((flags & 1) !== 0) {
                                                    this._cancellationParent = parent;
                                                    var branchesRemainingToCancel = parent._branchesRemainingToCancel;
                                                    if (branchesRemainingToCancel === undefined) {
                                                        branchesRemainingToCancel = 0;
                                                    }
                                                    parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
                                                }
                                                if ((flags & 2) !== 0 && parent._isBound()) {
                                                    this._setBoundTo(parent._boundTo);
                                                }
                                            }
                                            function bindingPropagateFrom(parent, flags) {
                                                if ((flags & 2) !== 0 && parent._isBound()) {
                                                    this._setBoundTo(parent._boundTo);
                                                }
                                            }
                                            var _propagateFromFunction = bindingPropagateFrom;
                                            function _boundValueFunction() {
                                                var ret = this._boundTo;
                                                if (ret !== undefined) {
                                                    if (ret instanceof Promise) {
                                                        if (ret.isFulfilled()) {
                                                            return ret.value();
                                                        } else {
                                                            return undefined;
                                                        }
                                                    }
                                                }
                                                return ret;
                                            }
                                            function longStackTracesCaptureStackTrace() {
                                                this._trace = new CapturedTrace(this._peekContext());
                                            }
                                            function longStackTracesAttachExtraTrace(error, ignoreSelf) {
                                                if (canAttachTrace(error)) {
                                                    var trace = this._trace;
                                                    if (trace !== undefined) {
                                                        if (ignoreSelf) trace = trace._parent;
                                                    }
                                                    if (trace !== undefined) {
                                                        trace.attachExtraTrace(error);
                                                    } else if (!error.__stackCleaned__) {
                                                        var parsed = parseStackAndMessage(error);
                                                        util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
                                                        util.notEnumerableProp(error, "__stackCleaned__", true);
                                                    }
                                                }
                                            }
                                            function longStackTracesDereferenceTrace() {
                                                this._trace = undefined;
                                            }
                                            function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent) {
                                                if (returnValue === undefined && promiseCreated !== null && wForgottenReturn) {
                                                    if (parent !== undefined && parent._returnedNonUndefined()) return;
                                                    if ((promise._bitField & 65535) === 0) return;
                                                    if (name) name = name + " ";
                                                    var handlerLine = "";
                                                    var creatorLine = "";
                                                    if (promiseCreated._trace) {
                                                        var traceLines = promiseCreated._trace.stack.split("\n");
                                                        var stack = cleanStack(traceLines);
                                                        for (var i = stack.length - 1; i >= 0; --i) {
                                                            var line = stack[i];
                                                            if (!nodeFramePattern.test(line)) {
                                                                var lineMatches = line.match(parseLinePattern);
                                                                if (lineMatches) {
                                                                    handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                                                                }
                                                                break;
                                                            }
                                                        }
                                                        if (stack.length > 0) {
                                                            var firstUserLine = stack[0];
                                                            for (var i = 0; i < traceLines.length; ++i) {
                                                                if (traceLines[i] === firstUserLine) {
                                                                    if (i > 0) {
                                                                        creatorLine = "\n" + traceLines[i - 1];
                                                                    }
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, " + "see http://goo.gl/rRqMUw" + creatorLine;
                                                    promise._warn(msg, true, promiseCreated);
                                                }
                                            }
                                            function deprecated(name, replacement) {
                                                var message = name + " is deprecated and will be removed in a future version.";
                                                if (replacement) message += " Use " + replacement + " instead.";
                                                return warn(message);
                                            }
                                            function warn(message, shouldUseOwnTrace, promise) {
                                                if (!config.warnings) return;
                                                var warning = new Warning(message);
                                                var ctx;
                                                if (shouldUseOwnTrace) {
                                                    promise._attachExtraTrace(warning);
                                                } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
                                                    ctx.attachExtraTrace(warning);
                                                } else {
                                                    var parsed = parseStackAndMessage(warning);
                                                    warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
                                                }
                                                if (!activeFireEvent("warning", warning)) {
                                                    formatAndLogError(warning, "", true);
                                                }
                                            }
                                            function reconstructStack(message, stacks) {
                                                for (var i = 0; i < stacks.length - 1; ++i) {
                                                    stacks[i].push("From previous event:");
                                                    stacks[i] = stacks[i].join("\n");
                                                }
                                                if (i < stacks.length) {
                                                    stacks[i] = stacks[i].join("\n");
                                                }
                                                return message + "\n" + stacks.join("\n");
                                            }
                                            function removeDuplicateOrEmptyJumps(stacks) {
                                                for (var i = 0; i < stacks.length; ++i) {
                                                    if (stacks[i].length === 0 || (i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0])) {
                                                        stacks.splice(i, 1);
                                                        i--;
                                                    }
                                                }
                                            }
                                            function removeCommonRoots(stacks) {
                                                var current = stacks[0];
                                                for (var i = 1; i < stacks.length; ++i) {
                                                    var prev = stacks[i];
                                                    var currentLastIndex = current.length - 1;
                                                    var currentLastLine = current[currentLastIndex];
                                                    var commonRootMeetPoint = -1;
                                                    for (var j = prev.length - 1; j >= 0; --j) {
                                                        if (prev[j] === currentLastLine) {
                                                            commonRootMeetPoint = j;
                                                            break;
                                                        }
                                                    }
                                                    for (var j = commonRootMeetPoint; j >= 0; --j) {
                                                        var line = prev[j];
                                                        if (current[currentLastIndex] === line) {
                                                            current.pop();
                                                            currentLastIndex--;
                                                        } else {
                                                            break;
                                                        }
                                                    }
                                                    current = prev;
                                                }
                                            }
                                            function cleanStack(stack) {
                                                var ret = [];
                                                for (var i = 0; i < stack.length; ++i) {
                                                    var line = stack[i];
                                                    var isTraceLine = "    (No stack trace)" === line || stackFramePattern.test(line);
                                                    var isInternalFrame = isTraceLine && shouldIgnore(line);
                                                    if (isTraceLine && !isInternalFrame) {
                                                        if (indentStackFrames && line.charAt(0) !== " ") {
                                                            line = "    " + line;
                                                        }
                                                        ret.push(line);
                                                    }
                                                }
                                                return ret;
                                            }
                                            function stackFramesAsArray(error) {
                                                var stack = error.stack.replace(/\s+$/g, "").split("\n");
                                                for (var i = 0; i < stack.length; ++i) {
                                                    var line = stack[i];
                                                    if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
                                                        break;
                                                    }
                                                }
                                                if (i > 0 && error.name != "SyntaxError") {
                                                    stack = stack.slice(i);
                                                }
                                                return stack;
                                            }
                                            function parseStackAndMessage(error) {
                                                var stack = error.stack;
                                                var message = error.toString();
                                                stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : ["    (No stack trace)"];
                                                return { message: message, stack: error.name == "SyntaxError" ? stack : cleanStack(stack) };
                                            }
                                            function formatAndLogError(error, title, isSoft) {
                                                if (typeof console !== "undefined") {
                                                    var message;
                                                    if (util.isObject(error)) {
                                                        var stack = error.stack;
                                                        message = title + formatStack(stack, error);
                                                    } else {
                                                        message = title + String(error);
                                                    }
                                                    if (typeof printWarning === "function") {
                                                        printWarning(message, isSoft);
                                                    } else if (typeof console.log === "function" || _typeof(console.log) === "object") {
                                                        console.log(message);
                                                    }
                                                }
                                            }
                                            function fireRejectionEvent(name, localHandler, reason, promise) {
                                                var localEventFired = false;
                                                try {
                                                    if (typeof localHandler === "function") {
                                                        localEventFired = true;
                                                        if (name === "rejectionHandled") {
                                                            localHandler(promise);
                                                        } else {
                                                            localHandler(reason, promise);
                                                        }
                                                    }
                                                } catch (e) {
                                                    async.throwLater(e);
                                                }
                                                if (name === "unhandledRejection") {
                                                    if (!activeFireEvent(name, reason, promise) && !localEventFired) {
                                                        formatAndLogError(reason, "Unhandled rejection ");
                                                    }
                                                } else {
                                                    activeFireEvent(name, promise);
                                                }
                                            }
                                            function formatNonError(obj) {
                                                var str;
                                                if (typeof obj === "function") {
                                                    str = "[function " + (obj.name || "anonymous") + "]";
                                                } else {
                                                    str = obj && typeof obj.toString === "function" ? obj.toString() : util.toString(obj);
                                                    var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
                                                    if (ruselessToString.test(str)) {
                                                        try {
                                                            var newStr = JSON.stringify(obj);
                                                            str = newStr;
                                                        } catch (e) {}
                                                    }
                                                    if (str.length === 0) {
                                                        str = "(empty array)";
                                                    }
                                                }
                                                return "(<" + snip(str) + ">, no stack trace)";
                                            }
                                            function snip(str) {
                                                var maxChars = 41;
                                                if (str.length < maxChars) {
                                                    return str;
                                                }
                                                return str.substr(0, maxChars - 3) + "...";
                                            }
                                            function longStackTracesIsSupported() {
                                                return typeof captureStackTrace === "function";
                                            }
                                            var shouldIgnore = function shouldIgnore() {
                                                return false;
                                            };
                                            var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
                                            function parseLineInfo(line) {
                                                var matches = line.match(parseLineInfoRegex);
                                                if (matches) {
                                                    return { fileName: matches[1], line: parseInt(matches[2], 10) };
                                                }
                                            }
                                            function setBounds(firstLineError, lastLineError) {
                                                if (!longStackTracesIsSupported()) return;
                                                var firstStackLines = (firstLineError.stack || "").split("\n");
                                                var lastStackLines = (lastLineError.stack || "").split("\n");
                                                var firstIndex = -1;
                                                var lastIndex = -1;
                                                var firstFileName;
                                                var lastFileName;
                                                for (var i = 0; i < firstStackLines.length; ++i) {
                                                    var result = parseLineInfo(firstStackLines[i]);
                                                    if (result) {
                                                        firstFileName = result.fileName;
                                                        firstIndex = result.line;
                                                        break;
                                                    }
                                                }
                                                for (var i = 0; i < lastStackLines.length; ++i) {
                                                    var result = parseLineInfo(lastStackLines[i]);
                                                    if (result) {
                                                        lastFileName = result.fileName;
                                                        lastIndex = result.line;
                                                        break;
                                                    }
                                                }
                                                if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) {
                                                    return;
                                                }
                                                shouldIgnore = function shouldIgnore(line) {
                                                    if (bluebirdFramePattern.test(line)) return true;
                                                    var info = parseLineInfo(line);
                                                    if (info) {
                                                        if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) {
                                                            return true;
                                                        }
                                                    }
                                                    return false;
                                                };
                                            }
                                            function CapturedTrace(parent) {
                                                this._parent = parent;
                                                this._promisesCreated = 0;
                                                var length = (this._length = 1 + (parent === undefined ? 0 : parent._length));
                                                captureStackTrace(this, CapturedTrace);
                                                if (length > 32) this.uncycle();
                                            }
                                            util.inherits(CapturedTrace, Error);
                                            Context.CapturedTrace = CapturedTrace;
                                            CapturedTrace.prototype.uncycle = function () {
                                                var length = this._length;
                                                if (length < 2) return;
                                                var nodes = [];
                                                var stackToIndex = {};
                                                for (var i = 0, node = this; node !== undefined; ++i) {
                                                    nodes.push(node);
                                                    node = node._parent;
                                                }
                                                length = this._length = i;
                                                for (var i = length - 1; i >= 0; --i) {
                                                    var stack = nodes[i].stack;
                                                    if (stackToIndex[stack] === undefined) {
                                                        stackToIndex[stack] = i;
                                                    }
                                                }
                                                for (var i = 0; i < length; ++i) {
                                                    var currentStack = nodes[i].stack;
                                                    var index = stackToIndex[currentStack];
                                                    if (index !== undefined && index !== i) {
                                                        if (index > 0) {
                                                            nodes[index - 1]._parent = undefined;
                                                            nodes[index - 1]._length = 1;
                                                        }
                                                        nodes[i]._parent = undefined;
                                                        nodes[i]._length = 1;
                                                        var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
                                                        if (index < length - 1) {
                                                            cycleEdgeNode._parent = nodes[index + 1];
                                                            cycleEdgeNode._parent.uncycle();
                                                            cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
                                                        } else {
                                                            cycleEdgeNode._parent = undefined;
                                                            cycleEdgeNode._length = 1;
                                                        }
                                                        var currentChildLength = cycleEdgeNode._length + 1;
                                                        for (var j = i - 2; j >= 0; --j) {
                                                            nodes[j]._length = currentChildLength;
                                                            currentChildLength++;
                                                        }
                                                        return;
                                                    }
                                                }
                                            };
                                            CapturedTrace.prototype.attachExtraTrace = function (error) {
                                                if (error.__stackCleaned__) return;
                                                this.uncycle();
                                                var parsed = parseStackAndMessage(error);
                                                var message = parsed.message;
                                                var stacks = [parsed.stack];
                                                var trace = this;
                                                while (trace !== undefined) {
                                                    stacks.push(cleanStack(trace.stack.split("\n")));
                                                    trace = trace._parent;
                                                }
                                                removeCommonRoots(stacks);
                                                removeDuplicateOrEmptyJumps(stacks);
                                                util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
                                                util.notEnumerableProp(error, "__stackCleaned__", true);
                                            };
                                            var captureStackTrace = (function stackDetection() {
                                                var v8stackFramePattern = /^\s*at\s*/;
                                                var v8stackFormatter = function v8stackFormatter(stack, error) {
                                                    if (typeof stack === "string") return stack;
                                                    if (error.name !== undefined && error.message !== undefined) {
                                                        return error.toString();
                                                    }
                                                    return formatNonError(error);
                                                };
                                                if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
                                                    Error.stackTraceLimit += 6;
                                                    stackFramePattern = v8stackFramePattern;
                                                    formatStack = v8stackFormatter;
                                                    var captureStackTrace = Error.captureStackTrace;
                                                    shouldIgnore = function shouldIgnore(line) {
                                                        return bluebirdFramePattern.test(line);
                                                    };
                                                    return function (receiver, ignoreUntil) {
                                                        Error.stackTraceLimit += 6;
                                                        captureStackTrace(receiver, ignoreUntil);
                                                        Error.stackTraceLimit -= 6;
                                                    };
                                                }
                                                var err = new Error();
                                                if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
                                                    stackFramePattern = /@/;
                                                    formatStack = v8stackFormatter;
                                                    indentStackFrames = true;
                                                    return function captureStackTrace(o) {
                                                        o.stack = new Error().stack;
                                                    };
                                                }
                                                var hasStackAfterThrow;
                                                try {
                                                    throw new Error();
                                                } catch (e) {
                                                    hasStackAfterThrow = "stack" in e;
                                                }
                                                if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
                                                    stackFramePattern = v8stackFramePattern;
                                                    formatStack = v8stackFormatter;
                                                    return function captureStackTrace(o) {
                                                        Error.stackTraceLimit += 6;
                                                        try {
                                                            throw new Error();
                                                        } catch (e) {
                                                            o.stack = e.stack;
                                                        }
                                                        Error.stackTraceLimit -= 6;
                                                    };
                                                }
                                                formatStack = function formatStack(stack, error) {
                                                    if (typeof stack === "string") return stack;
                                                    if ((_typeof(error) === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) {
                                                        return error.toString();
                                                    }
                                                    return formatNonError(error);
                                                };
                                                return null;
                                            })([]);
                                            if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
                                                printWarning = function printWarning(message) {
                                                    console.warn(message);
                                                };
                                                if (util.isNode && process.stderr.isTTY) {
                                                    printWarning = function printWarning(message, isSoft) {
                                                        var color = isSoft ? "\x1B[33m" : "\x1B[31m";
                                                        console.warn(color + message + "\x1B[0m\n");
                                                    };
                                                } else if (!util.isNode && typeof new Error().stack === "string") {
                                                    printWarning = function printWarning(message, isSoft) {
                                                        console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
                                                    };
                                                }
                                            }
                                            var config = { warnings: warnings, longStackTraces: false, cancellation: false, monitoring: false, asyncHooks: false };
                                            if (longStackTraces) Promise.longStackTraces();
                                            return {
                                                asyncHooks: function asyncHooks() {
                                                    return config.asyncHooks;
                                                },
                                                longStackTraces: function longStackTraces() {
                                                    return config.longStackTraces;
                                                },
                                                warnings: function warnings() {
                                                    return config.warnings;
                                                },
                                                cancellation: function cancellation() {
                                                    return config.cancellation;
                                                },
                                                monitoring: function monitoring() {
                                                    return config.monitoring;
                                                },
                                                propagateFromFunction: function propagateFromFunction() {
                                                    return _propagateFromFunction;
                                                },
                                                boundValueFunction: function boundValueFunction() {
                                                    return _boundValueFunction;
                                                },
                                                checkForgottenReturns: checkForgottenReturns,
                                                setBounds: setBounds,
                                                warn: warn,
                                                deprecated: deprecated,
                                                CapturedTrace: CapturedTrace,
                                                fireDomEvent: fireDomEvent,
                                                fireGlobalEvent: fireGlobalEvent,
                                            };
                                        };
                                    },
                                    { "./errors": 12, "./es5": 13, "./util": 36 },
                                ],
                                10: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise) {
                                            function returner() {
                                                return this.value;
                                            }
                                            function thrower() {
                                                throw this.reason;
                                            }
                                            Promise.prototype["return"] = Promise.prototype.thenReturn = function (value) {
                                                if (value instanceof Promise) value.suppressUnhandledRejections();
                                                return this._then(returner, undefined, undefined, { value: value }, undefined);
                                            };
                                            Promise.prototype["throw"] = Promise.prototype.thenThrow = function (reason) {
                                                return this._then(thrower, undefined, undefined, { reason: reason }, undefined);
                                            };
                                            Promise.prototype.catchThrow = function (reason) {
                                                if (arguments.length <= 1) {
                                                    return this._then(undefined, thrower, undefined, { reason: reason }, undefined);
                                                } else {
                                                    var _reason = arguments[1];
                                                    var handler = function handler() {
                                                        throw _reason;
                                                    };
                                                    return this.caught(reason, handler);
                                                }
                                            };
                                            Promise.prototype.catchReturn = function (value) {
                                                if (arguments.length <= 1) {
                                                    if (value instanceof Promise) value.suppressUnhandledRejections();
                                                    return this._then(undefined, returner, undefined, { value: value }, undefined);
                                                } else {
                                                    var _value = arguments[1];
                                                    if (_value instanceof Promise) _value.suppressUnhandledRejections();
                                                    var handler = function handler() {
                                                        return _value;
                                                    };
                                                    return this.caught(value, handler);
                                                }
                                            };
                                        };
                                    },
                                    {},
                                ],
                                11: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, INTERNAL) {
                                            var PromiseReduce = Promise.reduce;
                                            var PromiseAll = Promise.all;
                                            function promiseAllThis() {
                                                return PromiseAll(this);
                                            }
                                            function PromiseMapSeries(promises, fn) {
                                                return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
                                            }
                                            Promise.prototype.each = function (fn) {
                                                return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, this, undefined);
                                            };
                                            Promise.prototype.mapSeries = function (fn) {
                                                return PromiseReduce(this, fn, INTERNAL, INTERNAL);
                                            };
                                            Promise.each = function (promises, fn) {
                                                return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, promises, undefined);
                                            };
                                            Promise.mapSeries = PromiseMapSeries;
                                        };
                                    },
                                    {},
                                ],
                                12: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        var es5 = _dereq_("./es5");
                                        var Objectfreeze = es5.freeze;
                                        var util = _dereq_("./util");
                                        var inherits = util.inherits;
                                        var notEnumerableProp = util.notEnumerableProp;
                                        function subError(nameProperty, defaultMessage) {
                                            function SubError(message) {
                                                if (!(this instanceof SubError)) return new SubError(message);
                                                notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
                                                notEnumerableProp(this, "name", nameProperty);
                                                if (Error.captureStackTrace) {
                                                    Error.captureStackTrace(this, this.constructor);
                                                } else {
                                                    Error.call(this);
                                                }
                                            }
                                            inherits(SubError, Error);
                                            return SubError;
                                        }
                                        var _TypeError, _RangeError;
                                        var Warning = subError("Warning", "warning");
                                        var CancellationError = subError("CancellationError", "cancellation error");
                                        var TimeoutError = subError("TimeoutError", "timeout error");
                                        var AggregateError = subError("AggregateError", "aggregate error");
                                        try {
                                            _TypeError = TypeError;
                                            _RangeError = RangeError;
                                        } catch (e) {
                                            _TypeError = subError("TypeError", "type error");
                                            _RangeError = subError("RangeError", "range error");
                                        }
                                        var methods = ("join pop push shift unshift slice filter forEach some " + "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
                                        for (var i = 0; i < methods.length; ++i) {
                                            if (typeof Array.prototype[methods[i]] === "function") {
                                                AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
                                            }
                                        }
                                        es5.defineProperty(AggregateError.prototype, "length", { value: 0, configurable: false, writable: true, enumerable: true });
                                        AggregateError.prototype["isOperational"] = true;
                                        var level = 0;
                                        AggregateError.prototype.toString = function () {
                                            var indent = Array(level * 4 + 1).join(" ");
                                            var ret = "\n" + indent + "AggregateError of:" + "\n";
                                            level++;
                                            indent = Array(level * 4 + 1).join(" ");
                                            for (var i = 0; i < this.length; ++i) {
                                                var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
                                                var lines = str.split("\n");
                                                for (var j = 0; j < lines.length; ++j) {
                                                    lines[j] = indent + lines[j];
                                                }
                                                str = lines.join("\n");
                                                ret += str + "\n";
                                            }
                                            level--;
                                            return ret;
                                        };
                                        function OperationalError(message) {
                                            if (!(this instanceof OperationalError)) return new OperationalError(message);
                                            notEnumerableProp(this, "name", "OperationalError");
                                            notEnumerableProp(this, "message", message);
                                            this.cause = message;
                                            this["isOperational"] = true;
                                            if (message instanceof Error) {
                                                notEnumerableProp(this, "message", message.message);
                                                notEnumerableProp(this, "stack", message.stack);
                                            } else if (Error.captureStackTrace) {
                                                Error.captureStackTrace(this, this.constructor);
                                            }
                                        }
                                        inherits(OperationalError, Error);
                                        var errorTypes = Error["__BluebirdErrorTypes__"];
                                        if (!errorTypes) {
                                            errorTypes = Objectfreeze({
                                                CancellationError: CancellationError,
                                                TimeoutError: TimeoutError,
                                                OperationalError: OperationalError,
                                                RejectionError: OperationalError,
                                                AggregateError: AggregateError,
                                            });
                                            es5.defineProperty(Error, "__BluebirdErrorTypes__", { value: errorTypes, writable: false, enumerable: false, configurable: false });
                                        }
                                        module.exports = {
                                            Error: Error,
                                            TypeError: _TypeError,
                                            RangeError: _RangeError,
                                            CancellationError: errorTypes.CancellationError,
                                            OperationalError: errorTypes.OperationalError,
                                            TimeoutError: errorTypes.TimeoutError,
                                            AggregateError: errorTypes.AggregateError,
                                            Warning: Warning,
                                        };
                                    },
                                    { "./es5": 13, "./util": 36 },
                                ],
                                13: [
                                    function (_dereq_, module, exports) {
                                        var isES5 = (function () {
                                            "use strict";
                                            return this === undefined;
                                        })();
                                        if (isES5) {
                                            module.exports = {
                                                freeze: Object.freeze,
                                                defineProperty: Object.defineProperty,
                                                getDescriptor: Object.getOwnPropertyDescriptor,
                                                keys: Object.keys,
                                                names: Object.getOwnPropertyNames,
                                                getPrototypeOf: Object.getPrototypeOf,
                                                isArray: Array.isArray,
                                                isES5: isES5,
                                                propertyIsWritable: function propertyIsWritable(obj, prop) {
                                                    var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
                                                    return !!(!descriptor || descriptor.writable || descriptor.set);
                                                },
                                            };
                                        } else {
                                            var has = {}.hasOwnProperty;
                                            var str = {}.toString;
                                            var proto = {}.constructor.prototype;
                                            var ObjectKeys = function ObjectKeys(o) {
                                                var ret = [];
                                                for (var key in o) {
                                                    if (has.call(o, key)) {
                                                        ret.push(key);
                                                    }
                                                }
                                                return ret;
                                            };
                                            var ObjectGetDescriptor = function ObjectGetDescriptor(o, key) {
                                                return { value: o[key] };
                                            };
                                            var ObjectDefineProperty = function ObjectDefineProperty(o, key, desc) {
                                                o[key] = desc.value;
                                                return o;
                                            };
                                            var ObjectFreeze = function ObjectFreeze(obj) {
                                                return obj;
                                            };
                                            var ObjectGetPrototypeOf = function ObjectGetPrototypeOf(obj) {
                                                try {
                                                    return Object(obj).constructor.prototype;
                                                } catch (e) {
                                                    return proto;
                                                }
                                            };
                                            var ArrayIsArray = function ArrayIsArray(obj) {
                                                try {
                                                    return str.call(obj) === "[object Array]";
                                                } catch (e) {
                                                    return false;
                                                }
                                            };
                                            module.exports = {
                                                isArray: ArrayIsArray,
                                                keys: ObjectKeys,
                                                names: ObjectKeys,
                                                defineProperty: ObjectDefineProperty,
                                                getDescriptor: ObjectGetDescriptor,
                                                freeze: ObjectFreeze,
                                                getPrototypeOf: ObjectGetPrototypeOf,
                                                isES5: isES5,
                                                propertyIsWritable: function propertyIsWritable() {
                                                    return true;
                                                },
                                            };
                                        }
                                    },
                                    {},
                                ],
                                14: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, INTERNAL) {
                                            var PromiseMap = Promise.map;
                                            Promise.prototype.filter = function (fn, options) {
                                                return PromiseMap(this, fn, options, INTERNAL);
                                            };
                                            Promise.filter = function (promises, fn, options) {
                                                return PromiseMap(promises, fn, options, INTERNAL);
                                            };
                                        };
                                    },
                                    {},
                                ],
                                15: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, tryConvertToPromise, NEXT_FILTER) {
                                            var util = _dereq_("./util");
                                            var CancellationError = Promise.CancellationError;
                                            var errorObj = util.errorObj;
                                            var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
                                            function PassThroughHandlerContext(promise, type, handler) {
                                                this.promise = promise;
                                                this.type = type;
                                                this.handler = handler;
                                                this.called = false;
                                                this.cancelPromise = null;
                                            }
                                            PassThroughHandlerContext.prototype.isFinallyHandler = function () {
                                                return this.type === 0;
                                            };
                                            function FinallyHandlerCancelReaction(finallyHandler) {
                                                this.finallyHandler = finallyHandler;
                                            }
                                            FinallyHandlerCancelReaction.prototype._resultCancelled = function () {
                                                checkCancel(this.finallyHandler);
                                            };
                                            function checkCancel(ctx, reason) {
                                                if (ctx.cancelPromise != null) {
                                                    if (arguments.length > 1) {
                                                        ctx.cancelPromise._reject(reason);
                                                    } else {
                                                        ctx.cancelPromise._cancel();
                                                    }
                                                    ctx.cancelPromise = null;
                                                    return true;
                                                }
                                                return false;
                                            }
                                            function succeed() {
                                                return finallyHandler.call(this, this.promise._target()._settledValue());
                                            }
                                            function fail(reason) {
                                                if (checkCancel(this, reason)) return;
                                                errorObj.e = reason;
                                                return errorObj;
                                            }
                                            function finallyHandler(reasonOrValue) {
                                                var promise = this.promise;
                                                var handler = this.handler;
                                                if (!this.called) {
                                                    this.called = true;
                                                    var ret = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);
                                                    if (ret === NEXT_FILTER) {
                                                        return ret;
                                                    } else if (ret !== undefined) {
                                                        promise._setReturnedNonUndefined();
                                                        var maybePromise = tryConvertToPromise(ret, promise);
                                                        if (maybePromise instanceof Promise) {
                                                            if (this.cancelPromise != null) {
                                                                if (maybePromise._isCancelled()) {
                                                                    var reason = new CancellationError("late cancellation observer");
                                                                    promise._attachExtraTrace(reason);
                                                                    errorObj.e = reason;
                                                                    return errorObj;
                                                                } else if (maybePromise.isPending()) {
                                                                    maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
                                                                }
                                                            }
                                                            return maybePromise._then(succeed, fail, undefined, this, undefined);
                                                        }
                                                    }
                                                }
                                                if (promise.isRejected()) {
                                                    checkCancel(this);
                                                    errorObj.e = reasonOrValue;
                                                    return errorObj;
                                                } else {
                                                    checkCancel(this);
                                                    return reasonOrValue;
                                                }
                                            }
                                            Promise.prototype._passThrough = function (handler, type, success, fail) {
                                                if (typeof handler !== "function") return this.then();
                                                return this._then(success, fail, undefined, new PassThroughHandlerContext(this, type, handler), undefined);
                                            };
                                            Promise.prototype.lastly = Promise.prototype["finally"] = function (handler) {
                                                return this._passThrough(handler, 0, finallyHandler, finallyHandler);
                                            };
                                            Promise.prototype.tap = function (handler) {
                                                return this._passThrough(handler, 1, finallyHandler);
                                            };
                                            Promise.prototype.tapCatch = function (handlerOrPredicate) {
                                                var len = arguments.length;
                                                if (len === 1) {
                                                    return this._passThrough(handlerOrPredicate, 1, undefined, finallyHandler);
                                                } else {
                                                    var catchInstances = new Array(len - 1),
                                                        j = 0,
                                                        i;
                                                    for (i = 0; i < len - 1; ++i) {
                                                        var item = arguments[i];
                                                        if (util.isObject(item)) {
                                                            catchInstances[j++] = item;
                                                        } else {
                                                            return Promise.reject(new TypeError("tapCatch statement predicate: " + "expecting an object but got " + util.classString(item)));
                                                        }
                                                    }
                                                    catchInstances.length = j;
                                                    var handler = arguments[i];
                                                    return this._passThrough(catchFilter(catchInstances, handler, this), 1, undefined, finallyHandler);
                                                }
                                            };
                                            return PassThroughHandlerContext;
                                        };
                                    },
                                    { "./catch_filter": 7, "./util": 36 },
                                ],
                                16: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
                                            var errors = _dereq_("./errors");
                                            var TypeError = errors.TypeError;
                                            var util = _dereq_("./util");
                                            var errorObj = util.errorObj;
                                            var tryCatch = util.tryCatch;
                                            var yieldHandlers = [];
                                            function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
                                                for (var i = 0; i < yieldHandlers.length; ++i) {
                                                    traceParent._pushContext();
                                                    var result = tryCatch(yieldHandlers[i])(value);
                                                    traceParent._popContext();
                                                    if (result === errorObj) {
                                                        traceParent._pushContext();
                                                        var ret = Promise.reject(errorObj.e);
                                                        traceParent._popContext();
                                                        return ret;
                                                    }
                                                    var maybePromise = tryConvertToPromise(result, traceParent);
                                                    if (maybePromise instanceof Promise) return maybePromise;
                                                }
                                                return null;
                                            }
                                            function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
                                                if (debug.cancellation()) {
                                                    var internal = new Promise(INTERNAL);
                                                    var _finallyPromise = (this._finallyPromise = new Promise(INTERNAL));
                                                    this._promise = internal.lastly(function () {
                                                        return _finallyPromise;
                                                    });
                                                    internal._captureStackTrace();
                                                    internal._setOnCancel(this);
                                                } else {
                                                    var promise = (this._promise = new Promise(INTERNAL));
                                                    promise._captureStackTrace();
                                                }
                                                this._stack = stack;
                                                this._generatorFunction = generatorFunction;
                                                this._receiver = receiver;
                                                this._generator = undefined;
                                                this._yieldHandlers = typeof yieldHandler === "function" ? [yieldHandler].concat(yieldHandlers) : yieldHandlers;
                                                this._yieldedPromise = null;
                                                this._cancellationPhase = false;
                                            }
                                            util.inherits(PromiseSpawn, Proxyable);
                                            PromiseSpawn.prototype._isResolved = function () {
                                                return this._promise === null;
                                            };
                                            PromiseSpawn.prototype._cleanup = function () {
                                                this._promise = this._generator = null;
                                                if (debug.cancellation() && this._finallyPromise !== null) {
                                                    this._finallyPromise._fulfill();
                                                    this._finallyPromise = null;
                                                }
                                            };
                                            PromiseSpawn.prototype._promiseCancelled = function () {
                                                if (this._isResolved()) return;
                                                var implementsReturn = typeof this._generator["return"] !== "undefined";
                                                var result;
                                                if (!implementsReturn) {
                                                    var reason = new Promise.CancellationError("generator .return() sentinel");
                                                    Promise.coroutine.returnSentinel = reason;
                                                    this._promise._attachExtraTrace(reason);
                                                    this._promise._pushContext();
                                                    result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                                                    this._promise._popContext();
                                                } else {
                                                    this._promise._pushContext();
                                                    result = tryCatch(this._generator["return"]).call(this._generator, undefined);
                                                    this._promise._popContext();
                                                }
                                                this._cancellationPhase = true;
                                                this._yieldedPromise = null;
                                                this._continue(result);
                                            };
                                            PromiseSpawn.prototype._promiseFulfilled = function (value) {
                                                this._yieldedPromise = null;
                                                this._promise._pushContext();
                                                var result = tryCatch(this._generator.next).call(this._generator, value);
                                                this._promise._popContext();
                                                this._continue(result);
                                            };
                                            PromiseSpawn.prototype._promiseRejected = function (reason) {
                                                this._yieldedPromise = null;
                                                this._promise._attachExtraTrace(reason);
                                                this._promise._pushContext();
                                                var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                                                this._promise._popContext();
                                                this._continue(result);
                                            };
                                            PromiseSpawn.prototype._resultCancelled = function () {
                                                if (this._yieldedPromise instanceof Promise) {
                                                    var promise = this._yieldedPromise;
                                                    this._yieldedPromise = null;
                                                    promise.cancel();
                                                }
                                            };
                                            PromiseSpawn.prototype.promise = function () {
                                                return this._promise;
                                            };
                                            PromiseSpawn.prototype._run = function () {
                                                this._generator = this._generatorFunction.call(this._receiver);
                                                this._receiver = this._generatorFunction = undefined;
                                                this._promiseFulfilled(undefined);
                                            };
                                            PromiseSpawn.prototype._continue = function (result) {
                                                var promise = this._promise;
                                                if (result === errorObj) {
                                                    this._cleanup();
                                                    if (this._cancellationPhase) {
                                                        return promise.cancel();
                                                    } else {
                                                        return promise._rejectCallback(result.e, false);
                                                    }
                                                }
                                                var value = result.value;
                                                if (result.done === true) {
                                                    this._cleanup();
                                                    if (this._cancellationPhase) {
                                                        return promise.cancel();
                                                    } else {
                                                        return promise._resolveCallback(value);
                                                    }
                                                } else {
                                                    var maybePromise = tryConvertToPromise(value, this._promise);
                                                    if (!(maybePromise instanceof Promise)) {
                                                        maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
                                                        if (maybePromise === null) {
                                                            this._promiseRejected(
                                                                new TypeError(
                                                                    "A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s", String(value)) +
                                                                        "From coroutine:\n" +
                                                                        this._stack.split("\n").slice(1, -7).join("\n")
                                                                )
                                                            );
                                                            return;
                                                        }
                                                    }
                                                    maybePromise = maybePromise._target();
                                                    var bitField = maybePromise._bitField;
                                                    if ((bitField & 50397184) === 0) {
                                                        this._yieldedPromise = maybePromise;
                                                        maybePromise._proxy(this, null);
                                                    } else if ((bitField & 33554432) !== 0) {
                                                        Promise._async.invoke(this._promiseFulfilled, this, maybePromise._value());
                                                    } else if ((bitField & 16777216) !== 0) {
                                                        Promise._async.invoke(this._promiseRejected, this, maybePromise._reason());
                                                    } else {
                                                        this._promiseCancelled();
                                                    }
                                                }
                                            };
                                            Promise.coroutine = function (generatorFunction, options) {
                                                if (typeof generatorFunction !== "function") {
                                                    throw new TypeError("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
                                                }
                                                var yieldHandler = Object(options).yieldHandler;
                                                var PromiseSpawn$ = PromiseSpawn;
                                                var stack = new Error().stack;
                                                return function () {
                                                    var generator = generatorFunction.apply(this, arguments);
                                                    var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
                                                    var ret = spawn.promise();
                                                    spawn._generator = generator;
                                                    spawn._promiseFulfilled(undefined);
                                                    return ret;
                                                };
                                            };
                                            Promise.coroutine.addYieldHandler = function (fn) {
                                                if (typeof fn !== "function") {
                                                    throw new TypeError("expecting a function but got " + util.classString(fn));
                                                }
                                                yieldHandlers.push(fn);
                                            };
                                            Promise.spawn = function (generatorFunction) {
                                                debug.deprecated("Promise.spawn()", "Promise.coroutine()");
                                                if (typeof generatorFunction !== "function") {
                                                    return apiRejection("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
                                                }
                                                var spawn = new PromiseSpawn(generatorFunction, this);
                                                var ret = spawn.promise();
                                                spawn._run(Promise.spawn);
                                                return ret;
                                            };
                                        };
                                    },
                                    { "./errors": 12, "./util": 36 },
                                ],
                                17: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, PromiseArray, tryConvertToPromise, INTERNAL, async) {
                                            var util = _dereq_("./util");
                                            var canEvaluate = util.canEvaluate;
                                            var tryCatch = util.tryCatch;
                                            var errorObj = util.errorObj;
                                            var reject;
                                            if (!true) {
                                                if (canEvaluate) {
                                                    var thenCallback = function thenCallback(i) {
                                                        return new Function(
                                                            "value",
                                                            "holder",
                                                            "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(
                                                                /Index/g,
                                                                i
                                                            )
                                                        );
                                                    };
                                                    var promiseSetter = function promiseSetter(i) {
                                                        return new Function(
                                                            "promise",
                                                            "holder",
                                                            "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(
                                                                /Index/g,
                                                                i
                                                            )
                                                        );
                                                    };
                                                    var generateHolderClass = function generateHolderClass(total) {
                                                        var props = new Array(total);
                                                        for (var i = 0; i < props.length; ++i) {
                                                            props[i] = "this.p" + (i + 1);
                                                        }
                                                        var assignment = props.join(" = ") + " = null;";
                                                        var cancellationCode =
                                                            "var promise;\n" +
                                                            props
                                                                .map(function (prop) {
                                                                    return (
                                                                        "                                                         \n\
                promise = " +
                                                                        prop +
                                                                        ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            "
                                                                    );
                                                                })
                                                                .join("\n");
                                                        var passedArguments = props.join(", ");
                                                        var name = "Holder$" + total;
                                                        var code =
                                                            "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";
                                                        code = code
                                                            .replace(/\[TheName\]/g, name)
                                                            .replace(/\[TheTotal\]/g, total)
                                                            .replace(/\[ThePassedArguments\]/g, passedArguments)
                                                            .replace(/\[TheProperties\]/g, assignment)
                                                            .replace(/\[CancellationCode\]/g, cancellationCode);
                                                        return new Function("tryCatch", "errorObj", "Promise", "async", code)(tryCatch, errorObj, Promise, async);
                                                    };
                                                    var holderClasses = [];
                                                    var thenCallbacks = [];
                                                    var promiseSetters = [];
                                                    for (var i = 0; i < 8; ++i) {
                                                        holderClasses.push(generateHolderClass(i + 1));
                                                        thenCallbacks.push(thenCallback(i + 1));
                                                        promiseSetters.push(promiseSetter(i + 1));
                                                    }
                                                    reject = function reject(reason) {
                                                        this._reject(reason);
                                                    };
                                                }
                                            }
                                            Promise.join = function () {
                                                var last = arguments.length - 1;
                                                var fn;
                                                if (last > 0 && typeof arguments[last] === "function") {
                                                    fn = arguments[last];
                                                    if (!true) {
                                                        if (last <= 8 && canEvaluate) {
                                                            var ret = new Promise(INTERNAL);
                                                            ret._captureStackTrace();
                                                            var HolderClass = holderClasses[last - 1];
                                                            var holder = new HolderClass(fn);
                                                            var callbacks = thenCallbacks;
                                                            for (var i = 0; i < last; ++i) {
                                                                var maybePromise = tryConvertToPromise(arguments[i], ret);
                                                                if (maybePromise instanceof Promise) {
                                                                    maybePromise = maybePromise._target();
                                                                    var bitField = maybePromise._bitField;
                                                                    if ((bitField & 50397184) === 0) {
                                                                        maybePromise._then(callbacks[i], reject, undefined, ret, holder);
                                                                        promiseSetters[i](maybePromise, holder);
                                                                        holder.asyncNeeded = false;
                                                                    } else if ((bitField & 33554432) !== 0) {
                                                                        callbacks[i].call(ret, maybePromise._value(), holder);
                                                                    } else if ((bitField & 16777216) !== 0) {
                                                                        ret._reject(maybePromise._reason());
                                                                    } else {
                                                                        ret._cancel();
                                                                    }
                                                                } else {
                                                                    callbacks[i].call(ret, maybePromise, holder);
                                                                }
                                                            }
                                                            if (!ret._isFateSealed()) {
                                                                if (holder.asyncNeeded) {
                                                                    var context = Promise._getContext();
                                                                    holder.fn = util.contextBind(context, holder.fn);
                                                                }
                                                                ret._setAsyncGuaranteed();
                                                                ret._setOnCancel(holder);
                                                            }
                                                            return ret;
                                                        }
                                                    }
                                                }
                                                var args = [].slice.call(arguments);
                                                if (fn) args.pop();
                                                var ret = new PromiseArray(args).promise();
                                                return fn !== undefined ? ret.spread(fn) : ret;
                                            };
                                        };
                                    },
                                    { "./util": 36 },
                                ],
                                18: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                                            var util = _dereq_("./util");
                                            var tryCatch = util.tryCatch;
                                            var errorObj = util.errorObj;
                                            var async = Promise._async;
                                            function MappingPromiseArray(promises, fn, limit, _filter) {
                                                this.constructor$(promises);
                                                this._promise._captureStackTrace();
                                                var context = Promise._getContext();
                                                this._callback = util.contextBind(context, fn);
                                                this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
                                                this._limit = limit;
                                                this._inFlight = 0;
                                                this._queue = [];
                                                async.invoke(this._asyncInit, this, undefined);
                                                if (util.isArray(promises)) {
                                                    for (var i = 0; i < promises.length; ++i) {
                                                        var maybePromise = promises[i];
                                                        if (maybePromise instanceof Promise) {
                                                            maybePromise.suppressUnhandledRejections();
                                                        }
                                                    }
                                                }
                                            }
                                            util.inherits(MappingPromiseArray, PromiseArray);
                                            MappingPromiseArray.prototype._asyncInit = function () {
                                                this._init$(undefined, -2);
                                            };
                                            MappingPromiseArray.prototype._init = function () {};
                                            MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
                                                var values = this._values;
                                                var length = this.length();
                                                var preservedValues = this._preservedValues;
                                                var limit = this._limit;
                                                if (index < 0) {
                                                    index = index * -1 - 1;
                                                    values[index] = value;
                                                    if (limit >= 1) {
                                                        this._inFlight--;
                                                        this._drainQueue();
                                                        if (this._isResolved()) return true;
                                                    }
                                                } else {
                                                    if (limit >= 1 && this._inFlight >= limit) {
                                                        values[index] = value;
                                                        this._queue.push(index);
                                                        return false;
                                                    }
                                                    if (preservedValues !== null) preservedValues[index] = value;
                                                    var promise = this._promise;
                                                    var callback = this._callback;
                                                    var receiver = promise._boundValue();
                                                    promise._pushContext();
                                                    var ret = tryCatch(callback).call(receiver, value, index, length);
                                                    var promiseCreated = promise._popContext();
                                                    debug.checkForgottenReturns(ret, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);
                                                    if (ret === errorObj) {
                                                        this._reject(ret.e);
                                                        return true;
                                                    }
                                                    var maybePromise = tryConvertToPromise(ret, this._promise);
                                                    if (maybePromise instanceof Promise) {
                                                        maybePromise = maybePromise._target();
                                                        var bitField = maybePromise._bitField;
                                                        if ((bitField & 50397184) === 0) {
                                                            if (limit >= 1) this._inFlight++;
                                                            values[index] = maybePromise;
                                                            maybePromise._proxy(this, (index + 1) * -1);
                                                            return false;
                                                        } else if ((bitField & 33554432) !== 0) {
                                                            ret = maybePromise._value();
                                                        } else if ((bitField & 16777216) !== 0) {
                                                            this._reject(maybePromise._reason());
                                                            return true;
                                                        } else {
                                                            this._cancel();
                                                            return true;
                                                        }
                                                    }
                                                    values[index] = ret;
                                                }
                                                var totalResolved = ++this._totalResolved;
                                                if (totalResolved >= length) {
                                                    if (preservedValues !== null) {
                                                        this._filter(values, preservedValues);
                                                    } else {
                                                        this._resolve(values);
                                                    }
                                                    return true;
                                                }
                                                return false;
                                            };
                                            MappingPromiseArray.prototype._drainQueue = function () {
                                                var queue = this._queue;
                                                var limit = this._limit;
                                                var values = this._values;
                                                while (queue.length > 0 && this._inFlight < limit) {
                                                    if (this._isResolved()) return;
                                                    var index = queue.pop();
                                                    this._promiseFulfilled(values[index], index);
                                                }
                                            };
                                            MappingPromiseArray.prototype._filter = function (booleans, values) {
                                                var len = values.length;
                                                var ret = new Array(len);
                                                var j = 0;
                                                for (var i = 0; i < len; ++i) {
                                                    if (booleans[i]) ret[j++] = values[i];
                                                }
                                                ret.length = j;
                                                this._resolve(ret);
                                            };
                                            MappingPromiseArray.prototype.preservedValues = function () {
                                                return this._preservedValues;
                                            };
                                            function map(promises, fn, options, _filter) {
                                                if (typeof fn !== "function") {
                                                    return apiRejection("expecting a function but got " + util.classString(fn));
                                                }
                                                var limit = 0;
                                                if (options !== undefined) {
                                                    if (_typeof(options) === "object" && options !== null) {
                                                        if (typeof options.concurrency !== "number") {
                                                            return Promise.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
                                                        }
                                                        limit = options.concurrency;
                                                    } else {
                                                        return Promise.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
                                                    }
                                                }
                                                limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
                                                return new MappingPromiseArray(promises, fn, limit, _filter).promise();
                                            }
                                            Promise.prototype.map = function (fn, options) {
                                                return map(this, fn, options, null);
                                            };
                                            Promise.map = function (promises, fn, options, _filter) {
                                                return map(promises, fn, options, _filter);
                                            };
                                        };
                                    },
                                    { "./util": 36 },
                                ],
                                19: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
                                            var util = _dereq_("./util");
                                            var tryCatch = util.tryCatch;
                                            Promise.method = function (fn) {
                                                if (typeof fn !== "function") {
                                                    throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
                                                }
                                                return function () {
                                                    var ret = new Promise(INTERNAL);
                                                    ret._captureStackTrace();
                                                    ret._pushContext();
                                                    var value = tryCatch(fn).apply(this, arguments);
                                                    var promiseCreated = ret._popContext();
                                                    debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret);
                                                    ret._resolveFromSyncValue(value);
                                                    return ret;
                                                };
                                            };
                                            Promise.attempt = Promise["try"] = function (fn) {
                                                if (typeof fn !== "function") {
                                                    return apiRejection("expecting a function but got " + util.classString(fn));
                                                }
                                                var ret = new Promise(INTERNAL);
                                                ret._captureStackTrace();
                                                ret._pushContext();
                                                var value;
                                                if (arguments.length > 1) {
                                                    debug.deprecated("calling Promise.try with more than 1 argument");
                                                    var arg = arguments[1];
                                                    var ctx = arguments[2];
                                                    value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg) : tryCatch(fn).call(ctx, arg);
                                                } else {
                                                    value = tryCatch(fn)();
                                                }
                                                var promiseCreated = ret._popContext();
                                                debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret);
                                                ret._resolveFromSyncValue(value);
                                                return ret;
                                            };
                                            Promise.prototype._resolveFromSyncValue = function (value) {
                                                if (value === util.errorObj) {
                                                    this._rejectCallback(value.e, false);
                                                } else {
                                                    this._resolveCallback(value, true);
                                                }
                                            };
                                        };
                                    },
                                    { "./util": 36 },
                                ],
                                20: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        var util = _dereq_("./util");
                                        var maybeWrapAsError = util.maybeWrapAsError;
                                        var errors = _dereq_("./errors");
                                        var OperationalError = errors.OperationalError;
                                        var es5 = _dereq_("./es5");
                                        function isUntypedError(obj) {
                                            return obj instanceof Error && es5.getPrototypeOf(obj) === Error.prototype;
                                        }
                                        var rErrorKey = /^(?:name|message|stack|cause)$/;
                                        function wrapAsOperationalError(obj) {
                                            var ret;
                                            if (isUntypedError(obj)) {
                                                ret = new OperationalError(obj);
                                                ret.name = obj.name;
                                                ret.message = obj.message;
                                                ret.stack = obj.stack;
                                                var keys = es5.keys(obj);
                                                for (var i = 0; i < keys.length; ++i) {
                                                    var key = keys[i];
                                                    if (!rErrorKey.test(key)) {
                                                        ret[key] = obj[key];
                                                    }
                                                }
                                                return ret;
                                            }
                                            util.markAsOriginatingFromRejection(obj);
                                            return obj;
                                        }
                                        function nodebackForPromise(promise, multiArgs) {
                                            return function (err, value) {
                                                if (promise === null) return;
                                                if (err) {
                                                    var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
                                                    promise._attachExtraTrace(wrapped);
                                                    promise._reject(wrapped);
                                                } else if (!multiArgs) {
                                                    promise._fulfill(value);
                                                } else {
                                                    var args = [].slice.call(arguments, 1);
                                                    promise._fulfill(args);
                                                }
                                                promise = null;
                                            };
                                        }
                                        module.exports = nodebackForPromise;
                                    },
                                    { "./errors": 12, "./es5": 13, "./util": 36 },
                                ],
                                21: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise) {
                                            var util = _dereq_("./util");
                                            var async = Promise._async;
                                            var tryCatch = util.tryCatch;
                                            var errorObj = util.errorObj;
                                            function spreadAdapter(val, nodeback) {
                                                var promise = this;
                                                if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
                                                var ret = tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
                                                if (ret === errorObj) {
                                                    async.throwLater(ret.e);
                                                }
                                            }
                                            function successAdapter(val, nodeback) {
                                                var promise = this;
                                                var receiver = promise._boundValue();
                                                var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
                                                if (ret === errorObj) {
                                                    async.throwLater(ret.e);
                                                }
                                            }
                                            function errorAdapter(reason, nodeback) {
                                                var promise = this;
                                                if (!reason) {
                                                    var newReason = new Error(reason + "");
                                                    newReason.cause = reason;
                                                    reason = newReason;
                                                }
                                                var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
                                                if (ret === errorObj) {
                                                    async.throwLater(ret.e);
                                                }
                                            }
                                            Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback, options) {
                                                if (typeof nodeback == "function") {
                                                    var adapter = successAdapter;
                                                    if (options !== undefined && Object(options).spread) {
                                                        adapter = spreadAdapter;
                                                    }
                                                    this._then(adapter, errorAdapter, undefined, this, nodeback);
                                                }
                                                return this;
                                            };
                                        };
                                    },
                                    { "./util": 36 },
                                ],
                                22: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function () {
                                            var makeSelfResolutionError = function makeSelfResolutionError() {
                                                return new TypeError("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n");
                                            };
                                            var reflectHandler = function reflectHandler() {
                                                return new Promise.PromiseInspection(this._target());
                                            };
                                            var apiRejection = function apiRejection(msg) {
                                                return Promise.reject(new TypeError(msg));
                                            };
                                            function Proxyable() {}
                                            var UNDEFINED_BINDING = {};
                                            var util = _dereq_("./util");
                                            util.setReflectHandler(reflectHandler);
                                            var getDomain = function getDomain() {
                                                var domain = process.domain;
                                                if (domain === undefined) {
                                                    return null;
                                                }
                                                return domain;
                                            };
                                            var getContextDefault = function getContextDefault() {
                                                return null;
                                            };
                                            var getContextDomain = function getContextDomain() {
                                                return { domain: getDomain(), async: null };
                                            };
                                            var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ? _dereq_("async_hooks").AsyncResource : null;
                                            var getContextAsyncHooks = function getContextAsyncHooks() {
                                                return { domain: getDomain(), async: new AsyncResource("Bluebird::Promise") };
                                            };
                                            var getContext = util.isNode ? getContextDomain : getContextDefault;
                                            util.notEnumerableProp(Promise, "_getContext", getContext);
                                            var enableAsyncHooks = function enableAsyncHooks() {
                                                getContext = getContextAsyncHooks;
                                                util.notEnumerableProp(Promise, "_getContext", getContextAsyncHooks);
                                            };
                                            var disableAsyncHooks = function disableAsyncHooks() {
                                                getContext = getContextDomain;
                                                util.notEnumerableProp(Promise, "_getContext", getContextDomain);
                                            };
                                            var es5 = _dereq_("./es5");
                                            var Async = _dereq_("./async");
                                            var async = new Async();
                                            es5.defineProperty(Promise, "_async", { value: async });
                                            var errors = _dereq_("./errors");
                                            var TypeError = (Promise.TypeError = errors.TypeError);
                                            Promise.RangeError = errors.RangeError;
                                            var CancellationError = (Promise.CancellationError = errors.CancellationError);
                                            Promise.TimeoutError = errors.TimeoutError;
                                            Promise.OperationalError = errors.OperationalError;
                                            Promise.RejectionError = errors.OperationalError;
                                            Promise.AggregateError = errors.AggregateError;
                                            var INTERNAL = function INTERNAL() {};
                                            var APPLY = {};
                                            var NEXT_FILTER = {};
                                            var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
                                            var PromiseArray = _dereq_("./promise_array")(Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);
                                            var Context = _dereq_("./context")(Promise);
                                            /*jshint unused:false*/ var createContext = Context.create;
                                            var debug = _dereq_("./debuggability")(Promise, Context, enableAsyncHooks, disableAsyncHooks);
                                            var CapturedTrace = debug.CapturedTrace;
                                            var PassThroughHandlerContext = _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);
                                            var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
                                            var nodebackForPromise = _dereq_("./nodeback");
                                            var errorObj = util.errorObj;
                                            var tryCatch = util.tryCatch;
                                            function check(self, executor) {
                                                if (self == null || self.constructor !== Promise) {
                                                    throw new TypeError("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");
                                                }
                                                if (typeof executor !== "function") {
                                                    throw new TypeError("expecting a function but got " + util.classString(executor));
                                                }
                                            }
                                            function Promise(executor) {
                                                if (executor !== INTERNAL) {
                                                    check(this, executor);
                                                }
                                                this._bitField = 0;
                                                this._fulfillmentHandler0 = undefined;
                                                this._rejectionHandler0 = undefined;
                                                this._promise0 = undefined;
                                                this._receiver0 = undefined;
                                                this._resolveFromExecutor(executor);
                                                this._promiseCreated();
                                                this._fireEvent("promiseCreated", this);
                                            }
                                            Promise.prototype.toString = function () {
                                                return "[object Promise]";
                                            };
                                            Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
                                                var len = arguments.length;
                                                if (len > 1) {
                                                    var catchInstances = new Array(len - 1),
                                                        j = 0,
                                                        i;
                                                    for (i = 0; i < len - 1; ++i) {
                                                        var item = arguments[i];
                                                        if (util.isObject(item)) {
                                                            catchInstances[j++] = item;
                                                        } else {
                                                            return apiRejection("Catch statement predicate: " + "expecting an object but got " + util.classString(item));
                                                        }
                                                    }
                                                    catchInstances.length = j;
                                                    fn = arguments[i];
                                                    if (typeof fn !== "function") {
                                                        throw new TypeError("The last argument to .catch() " + "must be a function, got " + util.toString(fn));
                                                    }
                                                    return this.then(undefined, catchFilter(catchInstances, fn, this));
                                                }
                                                return this.then(undefined, fn);
                                            };
                                            Promise.prototype.reflect = function () {
                                                return this._then(reflectHandler, reflectHandler, undefined, this, undefined);
                                            };
                                            Promise.prototype.then = function (didFulfill, didReject) {
                                                if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
                                                    var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
                                                    if (arguments.length > 1) {
                                                        msg += ", " + util.classString(didReject);
                                                    }
                                                    this._warn(msg);
                                                }
                                                return this._then(didFulfill, didReject, undefined, undefined, undefined);
                                            };
                                            Promise.prototype.done = function (didFulfill, didReject) {
                                                var promise = this._then(didFulfill, didReject, undefined, undefined, undefined);
                                                promise._setIsFinal();
                                            };
                                            Promise.prototype.spread = function (fn) {
                                                if (typeof fn !== "function") {
                                                    return apiRejection("expecting a function but got " + util.classString(fn));
                                                }
                                                return this.all()._then(fn, undefined, undefined, APPLY, undefined);
                                            };
                                            Promise.prototype.toJSON = function () {
                                                var ret = { isFulfilled: false, isRejected: false, fulfillmentValue: undefined, rejectionReason: undefined };
                                                if (this.isFulfilled()) {
                                                    ret.fulfillmentValue = this.value();
                                                    ret.isFulfilled = true;
                                                } else if (this.isRejected()) {
                                                    ret.rejectionReason = this.reason();
                                                    ret.isRejected = true;
                                                }
                                                return ret;
                                            };
                                            Promise.prototype.all = function () {
                                                if (arguments.length > 0) {
                                                    this._warn(".all() was passed arguments but it does not take any");
                                                }
                                                return new PromiseArray(this).promise();
                                            };
                                            Promise.prototype.error = function (fn) {
                                                return this.caught(util.originatesFromRejection, fn);
                                            };
                                            Promise.getNewLibraryCopy = module.exports;
                                            Promise.is = function (val) {
                                                return val instanceof Promise;
                                            };
                                            Promise.fromNode = Promise.fromCallback = function (fn) {
                                                var ret = new Promise(INTERNAL);
                                                ret._captureStackTrace();
                                                var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
                                                var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
                                                if (result === errorObj) {
                                                    ret._rejectCallback(result.e, true);
                                                }
                                                if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
                                                return ret;
                                            };
                                            Promise.all = function (promises) {
                                                return new PromiseArray(promises).promise();
                                            };
                                            Promise.cast = function (obj) {
                                                var ret = tryConvertToPromise(obj);
                                                if (!(ret instanceof Promise)) {
                                                    ret = new Promise(INTERNAL);
                                                    ret._captureStackTrace();
                                                    ret._setFulfilled();
                                                    ret._rejectionHandler0 = obj;
                                                }
                                                return ret;
                                            };
                                            Promise.resolve = Promise.fulfilled = Promise.cast;
                                            Promise.reject = Promise.rejected = function (reason) {
                                                var ret = new Promise(INTERNAL);
                                                ret._captureStackTrace();
                                                ret._rejectCallback(reason, true);
                                                return ret;
                                            };
                                            Promise.setScheduler = function (fn) {
                                                if (typeof fn !== "function") {
                                                    throw new TypeError("expecting a function but got " + util.classString(fn));
                                                }
                                                return async.setScheduler(fn);
                                            };
                                            Promise.prototype._then = function (didFulfill, didReject, _, receiver, internalData) {
                                                var haveInternalData = internalData !== undefined;
                                                var promise = haveInternalData ? internalData : new Promise(INTERNAL);
                                                var target = this._target();
                                                var bitField = target._bitField;
                                                if (!haveInternalData) {
                                                    promise._propagateFrom(this, 3);
                                                    promise._captureStackTrace();
                                                    if (receiver === undefined && (this._bitField & 2097152) !== 0) {
                                                        if (!((bitField & 50397184) === 0)) {
                                                            receiver = this._boundValue();
                                                        } else {
                                                            receiver = target === this ? undefined : this._boundTo;
                                                        }
                                                    }
                                                    this._fireEvent("promiseChained", this, promise);
                                                }
                                                var context = getContext();
                                                if (!((bitField & 50397184) === 0)) {
                                                    var handler,
                                                        value,
                                                        settler = target._settlePromiseCtx;
                                                    if ((bitField & 33554432) !== 0) {
                                                        value = target._rejectionHandler0;
                                                        handler = didFulfill;
                                                    } else if ((bitField & 16777216) !== 0) {
                                                        value = target._fulfillmentHandler0;
                                                        handler = didReject;
                                                        target._unsetRejectionIsUnhandled();
                                                    } else {
                                                        settler = target._settlePromiseLateCancellationObserver;
                                                        value = new CancellationError("late cancellation observer");
                                                        target._attachExtraTrace(value);
                                                        handler = didReject;
                                                    }
                                                    async.invoke(settler, target, { handler: util.contextBind(context, handler), promise: promise, receiver: receiver, value: value });
                                                } else {
                                                    target._addCallbacks(didFulfill, didReject, promise, receiver, context);
                                                }
                                                return promise;
                                            };
                                            Promise.prototype._length = function () {
                                                return this._bitField & 65535;
                                            };
                                            Promise.prototype._isFateSealed = function () {
                                                return (this._bitField & 117506048) !== 0;
                                            };
                                            Promise.prototype._isFollowing = function () {
                                                return (this._bitField & 67108864) === 67108864;
                                            };
                                            Promise.prototype._setLength = function (len) {
                                                this._bitField = (this._bitField & -65536) | (len & 65535);
                                            };
                                            Promise.prototype._setFulfilled = function () {
                                                this._bitField = this._bitField | 33554432;
                                                this._fireEvent("promiseFulfilled", this);
                                            };
                                            Promise.prototype._setRejected = function () {
                                                this._bitField = this._bitField | 16777216;
                                                this._fireEvent("promiseRejected", this);
                                            };
                                            Promise.prototype._setFollowing = function () {
                                                this._bitField = this._bitField | 67108864;
                                                this._fireEvent("promiseResolved", this);
                                            };
                                            Promise.prototype._setIsFinal = function () {
                                                this._bitField = this._bitField | 4194304;
                                            };
                                            Promise.prototype._isFinal = function () {
                                                return (this._bitField & 4194304) > 0;
                                            };
                                            Promise.prototype._unsetCancelled = function () {
                                                this._bitField = this._bitField & ~65536;
                                            };
                                            Promise.prototype._setCancelled = function () {
                                                this._bitField = this._bitField | 65536;
                                                this._fireEvent("promiseCancelled", this);
                                            };
                                            Promise.prototype._setWillBeCancelled = function () {
                                                this._bitField = this._bitField | 8388608;
                                            };
                                            Promise.prototype._setAsyncGuaranteed = function () {
                                                if (async.hasCustomScheduler()) return;
                                                var bitField = this._bitField;
                                                this._bitField = bitField | (((bitField & 536870912) >> 2) ^ 134217728);
                                            };
                                            Promise.prototype._setNoAsyncGuarantee = function () {
                                                this._bitField = (this._bitField | 536870912) & ~134217728;
                                            };
                                            Promise.prototype._receiverAt = function (index) {
                                                var ret = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];
                                                if (ret === UNDEFINED_BINDING) {
                                                    return undefined;
                                                } else if (ret === undefined && this._isBound()) {
                                                    return this._boundValue();
                                                }
                                                return ret;
                                            };
                                            Promise.prototype._promiseAt = function (index) {
                                                return this[index * 4 - 4 + 2];
                                            };
                                            Promise.prototype._fulfillmentHandlerAt = function (index) {
                                                return this[index * 4 - 4 + 0];
                                            };
                                            Promise.prototype._rejectionHandlerAt = function (index) {
                                                return this[index * 4 - 4 + 1];
                                            };
                                            Promise.prototype._boundValue = function () {};
                                            Promise.prototype._migrateCallback0 = function (follower) {
                                                var bitField = follower._bitField;
                                                var fulfill = follower._fulfillmentHandler0;
                                                var reject = follower._rejectionHandler0;
                                                var promise = follower._promise0;
                                                var receiver = follower._receiverAt(0);
                                                if (receiver === undefined) receiver = UNDEFINED_BINDING;
                                                this._addCallbacks(fulfill, reject, promise, receiver, null);
                                            };
                                            Promise.prototype._migrateCallbackAt = function (follower, index) {
                                                var fulfill = follower._fulfillmentHandlerAt(index);
                                                var reject = follower._rejectionHandlerAt(index);
                                                var promise = follower._promiseAt(index);
                                                var receiver = follower._receiverAt(index);
                                                if (receiver === undefined) receiver = UNDEFINED_BINDING;
                                                this._addCallbacks(fulfill, reject, promise, receiver, null);
                                            };
                                            Promise.prototype._addCallbacks = function (fulfill, reject, promise, receiver, context) {
                                                var index = this._length();
                                                if (index >= 65535 - 4) {
                                                    index = 0;
                                                    this._setLength(0);
                                                }
                                                if (index === 0) {
                                                    this._promise0 = promise;
                                                    this._receiver0 = receiver;
                                                    if (typeof fulfill === "function") {
                                                        this._fulfillmentHandler0 = util.contextBind(context, fulfill);
                                                    }
                                                    if (typeof reject === "function") {
                                                        this._rejectionHandler0 = util.contextBind(context, reject);
                                                    }
                                                } else {
                                                    var base = index * 4 - 4;
                                                    this[base + 2] = promise;
                                                    this[base + 3] = receiver;
                                                    if (typeof fulfill === "function") {
                                                        this[base + 0] = util.contextBind(context, fulfill);
                                                    }
                                                    if (typeof reject === "function") {
                                                        this[base + 1] = util.contextBind(context, reject);
                                                    }
                                                }
                                                this._setLength(index + 1);
                                                return index;
                                            };
                                            Promise.prototype._proxy = function (proxyable, arg) {
                                                this._addCallbacks(undefined, undefined, arg, proxyable, null);
                                            };
                                            Promise.prototype._resolveCallback = function (value, shouldBind) {
                                                if ((this._bitField & 117506048) !== 0) return;
                                                if (value === this) return this._rejectCallback(makeSelfResolutionError(), false);
                                                var maybePromise = tryConvertToPromise(value, this);
                                                if (!(maybePromise instanceof Promise)) return this._fulfill(value);
                                                if (shouldBind) this._propagateFrom(maybePromise, 2);
                                                var promise = maybePromise._target();
                                                if (promise === this) {
                                                    this._reject(makeSelfResolutionError());
                                                    return;
                                                }
                                                var bitField = promise._bitField;
                                                if ((bitField & 50397184) === 0) {
                                                    var len = this._length();
                                                    if (len > 0) promise._migrateCallback0(this);
                                                    for (var i = 1; i < len; ++i) {
                                                        promise._migrateCallbackAt(this, i);
                                                    }
                                                    this._setFollowing();
                                                    this._setLength(0);
                                                    this._setFollowee(maybePromise);
                                                } else if ((bitField & 33554432) !== 0) {
                                                    this._fulfill(promise._value());
                                                } else if ((bitField & 16777216) !== 0) {
                                                    this._reject(promise._reason());
                                                } else {
                                                    var reason = new CancellationError("late cancellation observer");
                                                    promise._attachExtraTrace(reason);
                                                    this._reject(reason);
                                                }
                                            };
                                            Promise.prototype._rejectCallback = function (reason, synchronous, ignoreNonErrorWarnings) {
                                                var trace = util.ensureErrorObject(reason);
                                                var hasStack = trace === reason;
                                                if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
                                                    var message = "a promise was rejected with a non-error: " + util.classString(reason);
                                                    this._warn(message, true);
                                                }
                                                this._attachExtraTrace(trace, synchronous ? hasStack : false);
                                                this._reject(reason);
                                            };
                                            Promise.prototype._resolveFromExecutor = function (executor) {
                                                if (executor === INTERNAL) return;
                                                var promise = this;
                                                this._captureStackTrace();
                                                this._pushContext();
                                                var synchronous = true;
                                                var r = this._execute(
                                                    executor,
                                                    function (value) {
                                                        promise._resolveCallback(value);
                                                    },
                                                    function (reason) {
                                                        promise._rejectCallback(reason, synchronous);
                                                    }
                                                );
                                                synchronous = false;
                                                this._popContext();
                                                if (r !== undefined) {
                                                    promise._rejectCallback(r, true);
                                                }
                                            };
                                            Promise.prototype._settlePromiseFromHandler = function (handler, receiver, value, promise) {
                                                var bitField = promise._bitField;
                                                if ((bitField & 65536) !== 0) return;
                                                promise._pushContext();
                                                var x;
                                                if (receiver === APPLY) {
                                                    if (!value || typeof value.length !== "number") {
                                                        x = errorObj;
                                                        x.e = new TypeError("cannot .spread() a non-array: " + util.classString(value));
                                                    } else {
                                                        x = tryCatch(handler).apply(this._boundValue(), value);
                                                    }
                                                } else {
                                                    x = tryCatch(handler).call(receiver, value);
                                                }
                                                var promiseCreated = promise._popContext();
                                                bitField = promise._bitField;
                                                if ((bitField & 65536) !== 0) return;
                                                if (x === NEXT_FILTER) {
                                                    promise._reject(value);
                                                } else if (x === errorObj) {
                                                    promise._rejectCallback(x.e, false);
                                                } else {
                                                    debug.checkForgottenReturns(x, promiseCreated, "", promise, this);
                                                    promise._resolveCallback(x);
                                                }
                                            };
                                            Promise.prototype._target = function () {
                                                var ret = this;
                                                while (ret._isFollowing()) {
                                                    ret = ret._followee();
                                                }
                                                return ret;
                                            };
                                            Promise.prototype._followee = function () {
                                                return this._rejectionHandler0;
                                            };
                                            Promise.prototype._setFollowee = function (promise) {
                                                this._rejectionHandler0 = promise;
                                            };
                                            Promise.prototype._settlePromise = function (promise, handler, receiver, value) {
                                                var isPromise = promise instanceof Promise;
                                                var bitField = this._bitField;
                                                var asyncGuaranteed = (bitField & 134217728) !== 0;
                                                if ((bitField & 65536) !== 0) {
                                                    if (isPromise) promise._invokeInternalOnCancel();
                                                    if (receiver instanceof PassThroughHandlerContext && receiver.isFinallyHandler()) {
                                                        receiver.cancelPromise = promise;
                                                        if (tryCatch(handler).call(receiver, value) === errorObj) {
                                                            promise._reject(errorObj.e);
                                                        }
                                                    } else if (handler === reflectHandler) {
                                                        promise._fulfill(reflectHandler.call(receiver));
                                                    } else if (receiver instanceof Proxyable) {
                                                        receiver._promiseCancelled(promise);
                                                    } else if (isPromise || promise instanceof PromiseArray) {
                                                        promise._cancel();
                                                    } else {
                                                        receiver.cancel();
                                                    }
                                                } else if (typeof handler === "function") {
                                                    if (!isPromise) {
                                                        handler.call(receiver, value, promise);
                                                    } else {
                                                        if (asyncGuaranteed) promise._setAsyncGuaranteed();
                                                        this._settlePromiseFromHandler(handler, receiver, value, promise);
                                                    }
                                                } else if (receiver instanceof Proxyable) {
                                                    if (!receiver._isResolved()) {
                                                        if ((bitField & 33554432) !== 0) {
                                                            receiver._promiseFulfilled(value, promise);
                                                        } else {
                                                            receiver._promiseRejected(value, promise);
                                                        }
                                                    }
                                                } else if (isPromise) {
                                                    if (asyncGuaranteed) promise._setAsyncGuaranteed();
                                                    if ((bitField & 33554432) !== 0) {
                                                        promise._fulfill(value);
                                                    } else {
                                                        promise._reject(value);
                                                    }
                                                }
                                            };
                                            Promise.prototype._settlePromiseLateCancellationObserver = function (ctx) {
                                                var handler = ctx.handler;
                                                var promise = ctx.promise;
                                                var receiver = ctx.receiver;
                                                var value = ctx.value;
                                                if (typeof handler === "function") {
                                                    if (!(promise instanceof Promise)) {
                                                        handler.call(receiver, value, promise);
                                                    } else {
                                                        this._settlePromiseFromHandler(handler, receiver, value, promise);
                                                    }
                                                } else if (promise instanceof Promise) {
                                                    promise._reject(value);
                                                }
                                            };
                                            Promise.prototype._settlePromiseCtx = function (ctx) {
                                                this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
                                            };
                                            Promise.prototype._settlePromise0 = function (handler, value, bitField) {
                                                var promise = this._promise0;
                                                var receiver = this._receiverAt(0);
                                                this._promise0 = undefined;
                                                this._receiver0 = undefined;
                                                this._settlePromise(promise, handler, receiver, value);
                                            };
                                            Promise.prototype._clearCallbackDataAtIndex = function (index) {
                                                var base = index * 4 - 4;
                                                this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = undefined;
                                            };
                                            Promise.prototype._fulfill = function (value) {
                                                var bitField = this._bitField;
                                                if ((bitField & 117506048) >>> 16) return;
                                                if (value === this) {
                                                    var err = makeSelfResolutionError();
                                                    this._attachExtraTrace(err);
                                                    return this._reject(err);
                                                }
                                                this._setFulfilled();
                                                this._rejectionHandler0 = value;
                                                if ((bitField & 65535) > 0) {
                                                    if ((bitField & 134217728) !== 0) {
                                                        this._settlePromises();
                                                    } else {
                                                        async.settlePromises(this);
                                                    }
                                                    this._dereferenceTrace();
                                                }
                                            };
                                            Promise.prototype._reject = function (reason) {
                                                var bitField = this._bitField;
                                                if ((bitField & 117506048) >>> 16) return;
                                                this._setRejected();
                                                this._fulfillmentHandler0 = reason;
                                                if (this._isFinal()) {
                                                    return async.fatalError(reason, util.isNode);
                                                }
                                                if ((bitField & 65535) > 0) {
                                                    async.settlePromises(this);
                                                } else {
                                                    this._ensurePossibleRejectionHandled();
                                                }
                                            };
                                            Promise.prototype._fulfillPromises = function (len, value) {
                                                for (var i = 1; i < len; i++) {
                                                    var handler = this._fulfillmentHandlerAt(i);
                                                    var promise = this._promiseAt(i);
                                                    var receiver = this._receiverAt(i);
                                                    this._clearCallbackDataAtIndex(i);
                                                    this._settlePromise(promise, handler, receiver, value);
                                                }
                                            };
                                            Promise.prototype._rejectPromises = function (len, reason) {
                                                for (var i = 1; i < len; i++) {
                                                    var handler = this._rejectionHandlerAt(i);
                                                    var promise = this._promiseAt(i);
                                                    var receiver = this._receiverAt(i);
                                                    this._clearCallbackDataAtIndex(i);
                                                    this._settlePromise(promise, handler, receiver, reason);
                                                }
                                            };
                                            Promise.prototype._settlePromises = function () {
                                                var bitField = this._bitField;
                                                var len = bitField & 65535;
                                                if (len > 0) {
                                                    if ((bitField & 16842752) !== 0) {
                                                        var reason = this._fulfillmentHandler0;
                                                        this._settlePromise0(this._rejectionHandler0, reason, bitField);
                                                        this._rejectPromises(len, reason);
                                                    } else {
                                                        var value = this._rejectionHandler0;
                                                        this._settlePromise0(this._fulfillmentHandler0, value, bitField);
                                                        this._fulfillPromises(len, value);
                                                    }
                                                    this._setLength(0);
                                                }
                                                this._clearCancellationData();
                                            };
                                            Promise.prototype._settledValue = function () {
                                                var bitField = this._bitField;
                                                if ((bitField & 33554432) !== 0) {
                                                    return this._rejectionHandler0;
                                                } else if ((bitField & 16777216) !== 0) {
                                                    return this._fulfillmentHandler0;
                                                }
                                            };
                                            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                                                es5.defineProperty(Promise.prototype, Symbol.toStringTag, {
                                                    get: function get() {
                                                        return "Object";
                                                    },
                                                });
                                            }
                                            function deferResolve(v) {
                                                this.promise._resolveCallback(v);
                                            }
                                            function deferReject(v) {
                                                this.promise._rejectCallback(v, false);
                                            }
                                            Promise.defer = Promise.pending = function () {
                                                debug.deprecated("Promise.defer", "new Promise");
                                                var promise = new Promise(INTERNAL);
                                                return { promise: promise, resolve: deferResolve, reject: deferReject };
                                            };
                                            util.notEnumerableProp(Promise, "_makeSelfResolutionError", makeSelfResolutionError);
                                            _dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug);
                                            _dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
                                            _dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
                                            _dereq_("./direct_resolve")(Promise);
                                            _dereq_("./synchronous_inspection")(Promise);
                                            _dereq_("./join")(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async);
                                            Promise.Promise = Promise;
                                            Promise.version = "3.7.2";
                                            _dereq_("./call_get.js")(Promise);
                                            _dereq_("./generators.js")(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
                                            _dereq_("./map.js")(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                                            _dereq_("./nodeify.js")(Promise);
                                            _dereq_("./promisify.js")(Promise, INTERNAL);
                                            _dereq_("./props.js")(Promise, PromiseArray, tryConvertToPromise, apiRejection);
                                            _dereq_("./race.js")(Promise, INTERNAL, tryConvertToPromise, apiRejection);
                                            _dereq_("./reduce.js")(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                                            _dereq_("./settle.js")(Promise, PromiseArray, debug);
                                            _dereq_("./some.js")(Promise, PromiseArray, apiRejection);
                                            _dereq_("./timers.js")(Promise, INTERNAL, debug);
                                            _dereq_("./using.js")(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
                                            _dereq_("./any.js")(Promise);
                                            _dereq_("./each.js")(Promise, INTERNAL);
                                            _dereq_("./filter.js")(Promise, INTERNAL);
                                            util.toFastProperties(Promise);
                                            util.toFastProperties(Promise.prototype);
                                            function fillTypes(value) {
                                                var p = new Promise(INTERNAL);
                                                p._fulfillmentHandler0 = value;
                                                p._rejectionHandler0 = value;
                                                p._promise0 = value;
                                                p._receiver0 = value;
                                            } // Complete slack tracking, opt out of field-type tracking and
                                            // stabilize map
                                            fillTypes({ a: 1 });
                                            fillTypes({ b: 2 });
                                            fillTypes({ c: 3 });
                                            fillTypes(1);
                                            fillTypes(function () {});
                                            fillTypes(undefined);
                                            fillTypes(false);
                                            fillTypes(new Promise(INTERNAL));
                                            debug.setBounds(Async.firstLineError, util.lastLineError);
                                            return Promise;
                                        };
                                    },
                                    {
                                        "./any.js": 1,
                                        "./async": 2,
                                        "./bind": 3,
                                        "./call_get.js": 5,
                                        "./cancel": 6,
                                        "./catch_filter": 7,
                                        "./context": 8,
                                        "./debuggability": 9,
                                        "./direct_resolve": 10,
                                        "./each.js": 11,
                                        "./errors": 12,
                                        "./es5": 13,
                                        "./filter.js": 14,
                                        "./finally": 15,
                                        "./generators.js": 16,
                                        "./join": 17,
                                        "./map.js": 18,
                                        "./method": 19,
                                        "./nodeback": 20,
                                        "./nodeify.js": 21,
                                        "./promise_array": 23,
                                        "./promisify.js": 24,
                                        "./props.js": 25,
                                        "./race.js": 27,
                                        "./reduce.js": 28,
                                        "./settle.js": 30,
                                        "./some.js": 31,
                                        "./synchronous_inspection": 32,
                                        "./thenables": 33,
                                        "./timers.js": 34,
                                        "./using.js": 35,
                                        "./util": 36,
                                        async_hooks: undefined,
                                    },
                                ],
                                23: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
                                            var util = _dereq_("./util");
                                            var isArray = util.isArray;
                                            function toResolutionValue(val) {
                                                switch (val) {
                                                    case -2:
                                                        return [];
                                                    case -3:
                                                        return {};
                                                    case -6:
                                                        return new Map();
                                                }
                                            }
                                            function PromiseArray(values) {
                                                var promise = (this._promise = new Promise(INTERNAL));
                                                if (values instanceof Promise) {
                                                    promise._propagateFrom(values, 3);
                                                    values.suppressUnhandledRejections();
                                                }
                                                promise._setOnCancel(this);
                                                this._values = values;
                                                this._length = 0;
                                                this._totalResolved = 0;
                                                this._init(undefined, -2);
                                            }
                                            util.inherits(PromiseArray, Proxyable);
                                            PromiseArray.prototype.length = function () {
                                                return this._length;
                                            };
                                            PromiseArray.prototype.promise = function () {
                                                return this._promise;
                                            };
                                            PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
                                                var values = tryConvertToPromise(this._values, this._promise);
                                                if (values instanceof Promise) {
                                                    values = values._target();
                                                    var bitField = values._bitField;
                                                    this._values = values;
                                                    if ((bitField & 50397184) === 0) {
                                                        this._promise._setAsyncGuaranteed();
                                                        return values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
                                                    } else if ((bitField & 33554432) !== 0) {
                                                        values = values._value();
                                                    } else if ((bitField & 16777216) !== 0) {
                                                        return this._reject(values._reason());
                                                    } else {
                                                        return this._cancel();
                                                    }
                                                }
                                                values = util.asArray(values);
                                                if (values === null) {
                                                    var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();
                                                    this._promise._rejectCallback(err, false);
                                                    return;
                                                }
                                                if (values.length === 0) {
                                                    if (resolveValueIfEmpty === -5) {
                                                        this._resolveEmptyArray();
                                                    } else {
                                                        this._resolve(toResolutionValue(resolveValueIfEmpty));
                                                    }
                                                    return;
                                                }
                                                this._iterate(values);
                                            };
                                            PromiseArray.prototype._iterate = function (values) {
                                                var len = this.getActualLength(values.length);
                                                this._length = len;
                                                this._values = this.shouldCopyValues() ? new Array(len) : this._values;
                                                var result = this._promise;
                                                var isResolved = false;
                                                var bitField = null;
                                                for (var i = 0; i < len; ++i) {
                                                    var maybePromise = tryConvertToPromise(values[i], result);
                                                    if (maybePromise instanceof Promise) {
                                                        maybePromise = maybePromise._target();
                                                        bitField = maybePromise._bitField;
                                                    } else {
                                                        bitField = null;
                                                    }
                                                    if (isResolved) {
                                                        if (bitField !== null) {
                                                            maybePromise.suppressUnhandledRejections();
                                                        }
                                                    } else if (bitField !== null) {
                                                        if ((bitField & 50397184) === 0) {
                                                            maybePromise._proxy(this, i);
                                                            this._values[i] = maybePromise;
                                                        } else if ((bitField & 33554432) !== 0) {
                                                            isResolved = this._promiseFulfilled(maybePromise._value(), i);
                                                        } else if ((bitField & 16777216) !== 0) {
                                                            isResolved = this._promiseRejected(maybePromise._reason(), i);
                                                        } else {
                                                            isResolved = this._promiseCancelled(i);
                                                        }
                                                    } else {
                                                        isResolved = this._promiseFulfilled(maybePromise, i);
                                                    }
                                                }
                                                if (!isResolved) result._setAsyncGuaranteed();
                                            };
                                            PromiseArray.prototype._isResolved = function () {
                                                return this._values === null;
                                            };
                                            PromiseArray.prototype._resolve = function (value) {
                                                this._values = null;
                                                this._promise._fulfill(value);
                                            };
                                            PromiseArray.prototype._cancel = function () {
                                                if (this._isResolved() || !this._promise._isCancellable()) return;
                                                this._values = null;
                                                this._promise._cancel();
                                            };
                                            PromiseArray.prototype._reject = function (reason) {
                                                this._values = null;
                                                this._promise._rejectCallback(reason, false);
                                            };
                                            PromiseArray.prototype._promiseFulfilled = function (value, index) {
                                                this._values[index] = value;
                                                var totalResolved = ++this._totalResolved;
                                                if (totalResolved >= this._length) {
                                                    this._resolve(this._values);
                                                    return true;
                                                }
                                                return false;
                                            };
                                            PromiseArray.prototype._promiseCancelled = function () {
                                                this._cancel();
                                                return true;
                                            };
                                            PromiseArray.prototype._promiseRejected = function (reason) {
                                                this._totalResolved++;
                                                this._reject(reason);
                                                return true;
                                            };
                                            PromiseArray.prototype._resultCancelled = function () {
                                                if (this._isResolved()) return;
                                                var values = this._values;
                                                this._cancel();
                                                if (values instanceof Promise) {
                                                    values.cancel();
                                                } else {
                                                    for (var i = 0; i < values.length; ++i) {
                                                        if (values[i] instanceof Promise) {
                                                            values[i].cancel();
                                                        }
                                                    }
                                                }
                                            };
                                            PromiseArray.prototype.shouldCopyValues = function () {
                                                return true;
                                            };
                                            PromiseArray.prototype.getActualLength = function (len) {
                                                return len;
                                            };
                                            return PromiseArray;
                                        };
                                    },
                                    { "./util": 36 },
                                ],
                                24: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, INTERNAL) {
                                            var THIS = {};
                                            var util = _dereq_("./util");
                                            var nodebackForPromise = _dereq_("./nodeback");
                                            var withAppended = util.withAppended;
                                            var maybeWrapAsError = util.maybeWrapAsError;
                                            var canEvaluate = util.canEvaluate;
                                            var TypeError = _dereq_("./errors").TypeError;
                                            var defaultSuffix = "Async";
                                            var defaultPromisified = { __isPromisified__: true };
                                            var noCopyProps = ["arity", "length", "name", "arguments", "caller", "callee", "prototype", "__isPromisified__"];
                                            var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
                                            var defaultFilter = function defaultFilter(name) {
                                                return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
                                            };
                                            function propsFilter(key) {
                                                return !noCopyPropsPattern.test(key);
                                            }
                                            function isPromisified(fn) {
                                                try {
                                                    return fn.__isPromisified__ === true;
                                                } catch (e) {
                                                    return false;
                                                }
                                            }
                                            function hasPromisified(obj, key, suffix) {
                                                var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
                                                return val ? isPromisified(val) : false;
                                            }
                                            function checkValid(ret, suffix, suffixRegexp) {
                                                for (var i = 0; i < ret.length; i += 2) {
                                                    var key = ret[i];
                                                    if (suffixRegexp.test(key)) {
                                                        var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
                                                        for (var j = 0; j < ret.length; j += 2) {
                                                            if (ret[j] === keyWithoutAsyncSuffix) {
                                                                throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s", suffix));
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
                                                var keys = util.inheritedDataKeys(obj);
                                                var ret = [];
                                                for (var i = 0; i < keys.length; ++i) {
                                                    var key = keys[i];
                                                    var value = obj[key];
                                                    var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
                                                    if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) {
                                                        ret.push(key, value);
                                                    }
                                                }
                                                checkValid(ret, suffix, suffixRegexp);
                                                return ret;
                                            }
                                            var escapeIdentRegex = function escapeIdentRegex(str) {
                                                return str.replace(/([$])/, "\\$");
                                            };
                                            var makeNodePromisifiedEval;
                                            if (!true) {
                                                var switchCaseArgumentOrder = function switchCaseArgumentOrder(likelyArgumentCount) {
                                                    var ret = [likelyArgumentCount];
                                                    var min = Math.max(0, likelyArgumentCount - 1 - 3);
                                                    for (var i = likelyArgumentCount - 1; i >= min; --i) {
                                                        ret.push(i);
                                                    }
                                                    for (var i = likelyArgumentCount + 1; i <= 3; ++i) {
                                                        ret.push(i);
                                                    }
                                                    return ret;
                                                };
                                                var argumentSequence = function argumentSequence(argumentCount) {
                                                    return util.filledRange(argumentCount, "_arg", "");
                                                };
                                                var parameterDeclaration = function parameterDeclaration(parameterCount) {
                                                    return util.filledRange(Math.max(parameterCount, 3), "_arg", "");
                                                };
                                                var parameterCount = function parameterCount(fn) {
                                                    if (typeof fn.length === "number") {
                                                        return Math.max(Math.min(fn.length, 1023 + 1), 0);
                                                    }
                                                    return 0;
                                                };
                                                makeNodePromisifiedEval = function makeNodePromisifiedEval(callback, receiver, originalName, fn, _, multiArgs) {
                                                    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
                                                    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
                                                    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
                                                    function generateCallForArgumentCount(count) {
                                                        var args = argumentSequence(count).join(", ");
                                                        var comma = count > 0 ? ", " : "";
                                                        var ret;
                                                        if (shouldProxyThis) {
                                                            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
                                                        } else {
                                                            ret = receiver === undefined ? "ret = callback({{args}}, nodeback); break;\n" : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
                                                        }
                                                        return ret.replace("{{args}}", args).replace(", ", comma);
                                                    }
                                                    function generateArgumentSwitchCase() {
                                                        var ret = "";
                                                        for (var i = 0; i < argumentOrder.length; ++i) {
                                                            ret += "case " + argumentOrder[i] + ":" + generateCallForArgumentCount(argumentOrder[i]);
                                                        }
                                                        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace(
                                                            "[CodeForCall]",
                                                            shouldProxyThis ? "ret = callback.apply(this, args);\n" : "ret = callback.apply(receiver, args);\n"
                                                        );
                                                        return ret;
                                                    }
                                                    var getFunctionCode = typeof callback === "string" ? "this != null ? this['" + callback + "'] : fn" : "fn";
                                                    var body =
                                                        "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " +
                                                        multiArgs +
                                                        ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    "
                                                            .replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
                                                            .replace("[GetFunctionCode]", getFunctionCode);
                                                    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
                                                    return new Function("Promise", "fn", "receiver", "withAppended", "maybeWrapAsError", "nodebackForPromise", "tryCatch", "errorObj", "notEnumerableProp", "INTERNAL", body)(
                                                        Promise,
                                                        fn,
                                                        receiver,
                                                        withAppended,
                                                        maybeWrapAsError,
                                                        nodebackForPromise,
                                                        util.tryCatch,
                                                        util.errorObj,
                                                        util.notEnumerableProp,
                                                        INTERNAL
                                                    );
                                                };
                                            }
                                            function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
                                                var defaultThis = (function () {
                                                    return this;
                                                })();
                                                var method = callback;
                                                if (typeof method === "string") {
                                                    callback = fn;
                                                }
                                                function promisified() {
                                                    var _receiver = receiver;
                                                    if (receiver === THIS) _receiver = this;
                                                    var promise = new Promise(INTERNAL);
                                                    promise._captureStackTrace();
                                                    var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
                                                    var fn = nodebackForPromise(promise, multiArgs);
                                                    try {
                                                        cb.apply(_receiver, withAppended(arguments, fn));
                                                    } catch (e) {
                                                        promise._rejectCallback(maybeWrapAsError(e), true, true);
                                                    }
                                                    if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
                                                    return promise;
                                                }
                                                util.notEnumerableProp(promisified, "__isPromisified__", true);
                                                return promisified;
                                            }
                                            var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
                                            function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
                                                var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
                                                var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
                                                for (var i = 0, len = methods.length; i < len; i += 2) {
                                                    var key = methods[i];
                                                    var fn = methods[i + 1];
                                                    var promisifiedKey = key + suffix;
                                                    if (promisifier === makeNodePromisified) {
                                                        obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                                                    } else {
                                                        var promisified = promisifier(fn, function () {
                                                            return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                                                        });
                                                        util.notEnumerableProp(promisified, "__isPromisified__", true);
                                                        obj[promisifiedKey] = promisified;
                                                    }
                                                }
                                                util.toFastProperties(obj);
                                                return obj;
                                            }
                                            function promisify(callback, receiver, multiArgs) {
                                                return makeNodePromisified(callback, receiver, undefined, callback, null, multiArgs);
                                            }
                                            Promise.promisify = function (fn, options) {
                                                if (typeof fn !== "function") {
                                                    throw new TypeError("expecting a function but got " + util.classString(fn));
                                                }
                                                if (isPromisified(fn)) {
                                                    return fn;
                                                }
                                                options = Object(options);
                                                var receiver = options.context === undefined ? THIS : options.context;
                                                var multiArgs = !!options.multiArgs;
                                                var ret = promisify(fn, receiver, multiArgs);
                                                util.copyDescriptors(fn, ret, propsFilter);
                                                return ret;
                                            };
                                            Promise.promisifyAll = function (target, options) {
                                                if (typeof target !== "function" && _typeof(target) !== "object") {
                                                    throw new TypeError("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");
                                                }
                                                options = Object(options);
                                                var multiArgs = !!options.multiArgs;
                                                var suffix = options.suffix;
                                                if (typeof suffix !== "string") suffix = defaultSuffix;
                                                var filter = options.filter;
                                                if (typeof filter !== "function") filter = defaultFilter;
                                                var promisifier = options.promisifier;
                                                if (typeof promisifier !== "function") promisifier = makeNodePromisified;
                                                if (!util.isIdentifier(suffix)) {
                                                    throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");
                                                }
                                                var keys = util.inheritedDataKeys(target);
                                                for (var i = 0; i < keys.length; ++i) {
                                                    var value = target[keys[i]];
                                                    if (keys[i] !== "constructor" && util.isClass(value)) {
                                                        promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
                                                        promisifyAll(value, suffix, filter, promisifier, multiArgs);
                                                    }
                                                }
                                                return promisifyAll(target, suffix, filter, promisifier, multiArgs);
                                            };
                                        };
                                    },
                                    { "./errors": 12, "./nodeback": 20, "./util": 36 },
                                ],
                                25: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, PromiseArray, tryConvertToPromise, apiRejection) {
                                            var util = _dereq_("./util");
                                            var isObject = util.isObject;
                                            var es5 = _dereq_("./es5");
                                            var Es6Map;
                                            if (typeof Map === "function") Es6Map = Map;
                                            var mapToEntries = (function () {
                                                var index = 0;
                                                var size = 0;
                                                function extractEntry(value, key) {
                                                    this[index] = value;
                                                    this[index + size] = key;
                                                    index++;
                                                }
                                                return function mapToEntries(map) {
                                                    size = map.size;
                                                    index = 0;
                                                    var ret = new Array(map.size * 2);
                                                    map.forEach(extractEntry, ret);
                                                    return ret;
                                                };
                                            })();
                                            var entriesToMap = function entriesToMap(entries) {
                                                var ret = new Es6Map();
                                                var length = (entries.length / 2) | 0;
                                                for (var i = 0; i < length; ++i) {
                                                    var key = entries[length + i];
                                                    var value = entries[i];
                                                    ret.set(key, value);
                                                }
                                                return ret;
                                            };
                                            function PropertiesPromiseArray(obj) {
                                                var isMap = false;
                                                var entries;
                                                if (Es6Map !== undefined && obj instanceof Es6Map) {
                                                    entries = mapToEntries(obj);
                                                    isMap = true;
                                                } else {
                                                    var keys = es5.keys(obj);
                                                    var len = keys.length;
                                                    entries = new Array(len * 2);
                                                    for (var i = 0; i < len; ++i) {
                                                        var key = keys[i];
                                                        entries[i] = obj[key];
                                                        entries[i + len] = key;
                                                    }
                                                }
                                                this.constructor$(entries);
                                                this._isMap = isMap;
                                                this._init$(undefined, isMap ? -6 : -3);
                                            }
                                            util.inherits(PropertiesPromiseArray, PromiseArray);
                                            PropertiesPromiseArray.prototype._init = function () {};
                                            PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
                                                this._values[index] = value;
                                                var totalResolved = ++this._totalResolved;
                                                if (totalResolved >= this._length) {
                                                    var val;
                                                    if (this._isMap) {
                                                        val = entriesToMap(this._values);
                                                    } else {
                                                        val = {};
                                                        var keyOffset = this.length();
                                                        for (var i = 0, len = this.length(); i < len; ++i) {
                                                            val[this._values[i + keyOffset]] = this._values[i];
                                                        }
                                                    }
                                                    this._resolve(val);
                                                    return true;
                                                }
                                                return false;
                                            };
                                            PropertiesPromiseArray.prototype.shouldCopyValues = function () {
                                                return false;
                                            };
                                            PropertiesPromiseArray.prototype.getActualLength = function (len) {
                                                return len >> 1;
                                            };
                                            function props(promises) {
                                                var ret;
                                                var castValue = tryConvertToPromise(promises);
                                                if (!isObject(castValue)) {
                                                    return apiRejection("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n");
                                                } else if (castValue instanceof Promise) {
                                                    ret = castValue._then(Promise.props, undefined, undefined, undefined, undefined);
                                                } else {
                                                    ret = new PropertiesPromiseArray(castValue).promise();
                                                }
                                                if (castValue instanceof Promise) {
                                                    ret._propagateFrom(castValue, 2);
                                                }
                                                return ret;
                                            }
                                            Promise.prototype.props = function () {
                                                return props(this);
                                            };
                                            Promise.props = function (promises) {
                                                return props(promises);
                                            };
                                        };
                                    },
                                    { "./es5": 13, "./util": 36 },
                                ],
                                26: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        function arrayMove(src, srcIndex, dst, dstIndex, len) {
                                            for (var j = 0; j < len; ++j) {
                                                dst[j + dstIndex] = src[j + srcIndex];
                                                src[j + srcIndex] = void 0;
                                            }
                                        }
                                        function Queue(capacity) {
                                            this._capacity = capacity;
                                            this._length = 0;
                                            this._front = 0;
                                        }
                                        Queue.prototype._willBeOverCapacity = function (size) {
                                            return this._capacity < size;
                                        };
                                        Queue.prototype._pushOne = function (arg) {
                                            var length = this.length();
                                            this._checkCapacity(length + 1);
                                            var i = (this._front + length) & (this._capacity - 1);
                                            this[i] = arg;
                                            this._length = length + 1;
                                        };
                                        Queue.prototype.push = function (fn, receiver, arg) {
                                            var length = this.length() + 3;
                                            if (this._willBeOverCapacity(length)) {
                                                this._pushOne(fn);
                                                this._pushOne(receiver);
                                                this._pushOne(arg);
                                                return;
                                            }
                                            var j = this._front + length - 3;
                                            this._checkCapacity(length);
                                            var wrapMask = this._capacity - 1;
                                            this[(j + 0) & wrapMask] = fn;
                                            this[(j + 1) & wrapMask] = receiver;
                                            this[(j + 2) & wrapMask] = arg;
                                            this._length = length;
                                        };
                                        Queue.prototype.shift = function () {
                                            var front = this._front,
                                                ret = this[front];
                                            this[front] = undefined;
                                            this._front = (front + 1) & (this._capacity - 1);
                                            this._length--;
                                            return ret;
                                        };
                                        Queue.prototype.length = function () {
                                            return this._length;
                                        };
                                        Queue.prototype._checkCapacity = function (size) {
                                            if (this._capacity < size) {
                                                this._resizeTo(this._capacity << 1);
                                            }
                                        };
                                        Queue.prototype._resizeTo = function (capacity) {
                                            var oldCapacity = this._capacity;
                                            this._capacity = capacity;
                                            var front = this._front;
                                            var length = this._length;
                                            var moveItemsCount = (front + length) & (oldCapacity - 1);
                                            arrayMove(this, 0, this, oldCapacity, moveItemsCount);
                                        };
                                        module.exports = Queue;
                                    },
                                    {},
                                ],
                                27: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection) {
                                            var util = _dereq_("./util");
                                            var raceLater = function raceLater(promise) {
                                                return promise.then(function (array) {
                                                    return race(array, promise);
                                                });
                                            };
                                            function race(promises, parent) {
                                                var maybePromise = tryConvertToPromise(promises);
                                                if (maybePromise instanceof Promise) {
                                                    return raceLater(maybePromise);
                                                } else {
                                                    promises = util.asArray(promises);
                                                    if (promises === null) return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
                                                }
                                                var ret = new Promise(INTERNAL);
                                                if (parent !== undefined) {
                                                    ret._propagateFrom(parent, 3);
                                                }
                                                var fulfill = ret._fulfill;
                                                var reject = ret._reject;
                                                for (var i = 0, len = promises.length; i < len; ++i) {
                                                    var val = promises[i];
                                                    if (val === undefined && !(i in promises)) {
                                                        continue;
                                                    }
                                                    Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
                                                }
                                                return ret;
                                            }
                                            Promise.race = function (promises) {
                                                return race(promises, undefined);
                                            };
                                            Promise.prototype.race = function () {
                                                return race(this, undefined);
                                            };
                                        };
                                    },
                                    { "./util": 36 },
                                ],
                                28: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                                            var util = _dereq_("./util");
                                            var tryCatch = util.tryCatch;
                                            function ReductionPromiseArray(promises, fn, initialValue, _each) {
                                                this.constructor$(promises);
                                                var context = Promise._getContext();
                                                this._fn = util.contextBind(context, fn);
                                                if (initialValue !== undefined) {
                                                    initialValue = Promise.resolve(initialValue);
                                                    initialValue._attachCancellationCallback(this);
                                                }
                                                this._initialValue = initialValue;
                                                this._currentCancellable = null;
                                                if (_each === INTERNAL) {
                                                    this._eachValues = Array(this._length);
                                                } else if (_each === 0) {
                                                    this._eachValues = null;
                                                } else {
                                                    this._eachValues = undefined;
                                                }
                                                this._promise._captureStackTrace();
                                                this._init$(undefined, -5);
                                            }
                                            util.inherits(ReductionPromiseArray, PromiseArray);
                                            ReductionPromiseArray.prototype._gotAccum = function (accum) {
                                                if (this._eachValues !== undefined && this._eachValues !== null && accum !== INTERNAL) {
                                                    this._eachValues.push(accum);
                                                }
                                            };
                                            ReductionPromiseArray.prototype._eachComplete = function (value) {
                                                if (this._eachValues !== null) {
                                                    this._eachValues.push(value);
                                                }
                                                return this._eachValues;
                                            };
                                            ReductionPromiseArray.prototype._init = function () {};
                                            ReductionPromiseArray.prototype._resolveEmptyArray = function () {
                                                this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue);
                                            };
                                            ReductionPromiseArray.prototype.shouldCopyValues = function () {
                                                return false;
                                            };
                                            ReductionPromiseArray.prototype._resolve = function (value) {
                                                this._promise._resolveCallback(value);
                                                this._values = null;
                                            };
                                            ReductionPromiseArray.prototype._resultCancelled = function (sender) {
                                                if (sender === this._initialValue) return this._cancel();
                                                if (this._isResolved()) return;
                                                this._resultCancelled$();
                                                if (this._currentCancellable instanceof Promise) {
                                                    this._currentCancellable.cancel();
                                                }
                                                if (this._initialValue instanceof Promise) {
                                                    this._initialValue.cancel();
                                                }
                                            };
                                            ReductionPromiseArray.prototype._iterate = function (values) {
                                                this._values = values;
                                                var value;
                                                var i;
                                                var length = values.length;
                                                if (this._initialValue !== undefined) {
                                                    value = this._initialValue;
                                                    i = 0;
                                                } else {
                                                    value = Promise.resolve(values[0]);
                                                    i = 1;
                                                }
                                                this._currentCancellable = value;
                                                for (var j = i; j < length; ++j) {
                                                    var maybePromise = values[j];
                                                    if (maybePromise instanceof Promise) {
                                                        maybePromise.suppressUnhandledRejections();
                                                    }
                                                }
                                                if (!value.isRejected()) {
                                                    for (; i < length; ++i) {
                                                        var ctx = { accum: null, value: values[i], index: i, length: length, array: this };
                                                        value = value._then(gotAccum, undefined, undefined, ctx, undefined);
                                                        if ((i & 127) === 0) {
                                                            value._setNoAsyncGuarantee();
                                                        }
                                                    }
                                                }
                                                if (this._eachValues !== undefined) {
                                                    value = value._then(this._eachComplete, undefined, undefined, this, undefined);
                                                }
                                                value._then(completed, completed, undefined, value, this);
                                            };
                                            Promise.prototype.reduce = function (fn, initialValue) {
                                                return reduce(this, fn, initialValue, null);
                                            };
                                            Promise.reduce = function (promises, fn, initialValue, _each) {
                                                return reduce(promises, fn, initialValue, _each);
                                            };
                                            function completed(valueOrReason, array) {
                                                if (this.isFulfilled()) {
                                                    array._resolve(valueOrReason);
                                                } else {
                                                    array._reject(valueOrReason);
                                                }
                                            }
                                            function reduce(promises, fn, initialValue, _each) {
                                                if (typeof fn !== "function") {
                                                    return apiRejection("expecting a function but got " + util.classString(fn));
                                                }
                                                var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
                                                return array.promise();
                                            }
                                            function gotAccum(accum) {
                                                this.accum = accum;
                                                this.array._gotAccum(accum);
                                                var value = tryConvertToPromise(this.value, this.array._promise);
                                                if (value instanceof Promise) {
                                                    this.array._currentCancellable = value;
                                                    return value._then(gotValue, undefined, undefined, this, undefined);
                                                } else {
                                                    return gotValue.call(this, value);
                                                }
                                            }
                                            function gotValue(value) {
                                                var array = this.array;
                                                var promise = array._promise;
                                                var fn = tryCatch(array._fn);
                                                promise._pushContext();
                                                var ret;
                                                if (array._eachValues !== undefined) {
                                                    ret = fn.call(promise._boundValue(), value, this.index, this.length);
                                                } else {
                                                    ret = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
                                                }
                                                if (ret instanceof Promise) {
                                                    array._currentCancellable = ret;
                                                }
                                                var promiseCreated = promise._popContext();
                                                debug.checkForgottenReturns(ret, promiseCreated, array._eachValues !== undefined ? "Promise.each" : "Promise.reduce", promise);
                                                return ret;
                                            }
                                        };
                                    },
                                    { "./util": 36 },
                                ],
                                29: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        var util = _dereq_("./util");
                                        var schedule;
                                        var noAsyncScheduler = function noAsyncScheduler() {
                                            throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
                                        };
                                        var NativePromise = util.getNativePromise();
                                        if (util.isNode && typeof MutationObserver === "undefined") {
                                            var GlobalSetImmediate = global.setImmediate;
                                            var ProcessNextTick = process.nextTick;
                                            schedule = util.isRecentNode
                                                ? function (fn) {
                                                      GlobalSetImmediate.call(global, fn);
                                                  }
                                                : function (fn) {
                                                      ProcessNextTick.call(process, fn);
                                                  };
                                        } else if (typeof NativePromise === "function" && typeof NativePromise.resolve === "function") {
                                            var nativePromise = NativePromise.resolve();
                                            schedule = function schedule(fn) {
                                                nativePromise.then(fn);
                                            };
                                        } else if (
                                            typeof MutationObserver !== "undefined" &&
                                            !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova)) &&
                                            "classList" in document.documentElement
                                        ) {
                                            schedule = (function () {
                                                var div = document.createElement("div");
                                                var opts = { attributes: true };
                                                var toggleScheduled = false;
                                                var div2 = document.createElement("div");
                                                var o2 = new MutationObserver(function () {
                                                    div.classList.toggle("foo");
                                                    toggleScheduled = false;
                                                });
                                                o2.observe(div2, opts);
                                                var scheduleToggle = function scheduleToggle() {
                                                    if (toggleScheduled) return;
                                                    toggleScheduled = true;
                                                    div2.classList.toggle("foo");
                                                };
                                                return function schedule(fn) {
                                                    var o = new MutationObserver(function () {
                                                        o.disconnect();
                                                        fn();
                                                    });
                                                    o.observe(div, opts);
                                                    scheduleToggle();
                                                };
                                            })();
                                        } else if (typeof setImmediate !== "undefined") {
                                            schedule = function schedule(fn) {
                                                setImmediate(fn);
                                            };
                                        } else if (typeof setTimeout !== "undefined") {
                                            schedule = function schedule(fn) {
                                                setTimeout(fn, 0);
                                            };
                                        } else {
                                            schedule = noAsyncScheduler;
                                        }
                                        module.exports = schedule;
                                    },
                                    { "./util": 36 },
                                ],
                                30: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, PromiseArray, debug) {
                                            var PromiseInspection = Promise.PromiseInspection;
                                            var util = _dereq_("./util");
                                            function SettledPromiseArray(values) {
                                                this.constructor$(values);
                                            }
                                            util.inherits(SettledPromiseArray, PromiseArray);
                                            SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
                                                this._values[index] = inspection;
                                                var totalResolved = ++this._totalResolved;
                                                if (totalResolved >= this._length) {
                                                    this._resolve(this._values);
                                                    return true;
                                                }
                                                return false;
                                            };
                                            SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
                                                var ret = new PromiseInspection();
                                                ret._bitField = 33554432;
                                                ret._settledValueField = value;
                                                return this._promiseResolved(index, ret);
                                            };
                                            SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
                                                var ret = new PromiseInspection();
                                                ret._bitField = 16777216;
                                                ret._settledValueField = reason;
                                                return this._promiseResolved(index, ret);
                                            };
                                            Promise.settle = function (promises) {
                                                debug.deprecated(".settle()", ".reflect()");
                                                return new SettledPromiseArray(promises).promise();
                                            };
                                            Promise.allSettled = function (promises) {
                                                return new SettledPromiseArray(promises).promise();
                                            };
                                            Promise.prototype.settle = function () {
                                                return Promise.settle(this);
                                            };
                                        };
                                    },
                                    { "./util": 36 },
                                ],
                                31: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, PromiseArray, apiRejection) {
                                            var util = _dereq_("./util");
                                            var RangeError = _dereq_("./errors").RangeError;
                                            var AggregateError = _dereq_("./errors").AggregateError;
                                            var isArray = util.isArray;
                                            var CANCELLATION = {};
                                            function SomePromiseArray(values) {
                                                this.constructor$(values);
                                                this._howMany = 0;
                                                this._unwrap = false;
                                                this._initialized = false;
                                            }
                                            util.inherits(SomePromiseArray, PromiseArray);
                                            SomePromiseArray.prototype._init = function () {
                                                if (!this._initialized) {
                                                    return;
                                                }
                                                if (this._howMany === 0) {
                                                    this._resolve([]);
                                                    return;
                                                }
                                                this._init$(undefined, -5);
                                                var isArrayResolved = isArray(this._values);
                                                if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) {
                                                    this._reject(this._getRangeError(this.length()));
                                                }
                                            };
                                            SomePromiseArray.prototype.init = function () {
                                                this._initialized = true;
                                                this._init();
                                            };
                                            SomePromiseArray.prototype.setUnwrap = function () {
                                                this._unwrap = true;
                                            };
                                            SomePromiseArray.prototype.howMany = function () {
                                                return this._howMany;
                                            };
                                            SomePromiseArray.prototype.setHowMany = function (count) {
                                                this._howMany = count;
                                            };
                                            SomePromiseArray.prototype._promiseFulfilled = function (value) {
                                                this._addFulfilled(value);
                                                if (this._fulfilled() === this.howMany()) {
                                                    this._values.length = this.howMany();
                                                    if (this.howMany() === 1 && this._unwrap) {
                                                        this._resolve(this._values[0]);
                                                    } else {
                                                        this._resolve(this._values);
                                                    }
                                                    return true;
                                                }
                                                return false;
                                            };
                                            SomePromiseArray.prototype._promiseRejected = function (reason) {
                                                this._addRejected(reason);
                                                return this._checkOutcome();
                                            };
                                            SomePromiseArray.prototype._promiseCancelled = function () {
                                                if (this._values instanceof Promise || this._values == null) {
                                                    return this._cancel();
                                                }
                                                this._addRejected(CANCELLATION);
                                                return this._checkOutcome();
                                            };
                                            SomePromiseArray.prototype._checkOutcome = function () {
                                                if (this.howMany() > this._canPossiblyFulfill()) {
                                                    var e = new AggregateError();
                                                    for (var i = this.length(); i < this._values.length; ++i) {
                                                        if (this._values[i] !== CANCELLATION) {
                                                            e.push(this._values[i]);
                                                        }
                                                    }
                                                    if (e.length > 0) {
                                                        this._reject(e);
                                                    } else {
                                                        this._cancel();
                                                    }
                                                    return true;
                                                }
                                                return false;
                                            };
                                            SomePromiseArray.prototype._fulfilled = function () {
                                                return this._totalResolved;
                                            };
                                            SomePromiseArray.prototype._rejected = function () {
                                                return this._values.length - this.length();
                                            };
                                            SomePromiseArray.prototype._addRejected = function (reason) {
                                                this._values.push(reason);
                                            };
                                            SomePromiseArray.prototype._addFulfilled = function (value) {
                                                this._values[this._totalResolved++] = value;
                                            };
                                            SomePromiseArray.prototype._canPossiblyFulfill = function () {
                                                return this.length() - this._rejected();
                                            };
                                            SomePromiseArray.prototype._getRangeError = function (count) {
                                                var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
                                                return new RangeError(message);
                                            };
                                            SomePromiseArray.prototype._resolveEmptyArray = function () {
                                                this._reject(this._getRangeError(0));
                                            };
                                            function some(promises, howMany) {
                                                if ((howMany | 0) !== howMany || howMany < 0) {
                                                    return apiRejection("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");
                                                }
                                                var ret = new SomePromiseArray(promises);
                                                var promise = ret.promise();
                                                ret.setHowMany(howMany);
                                                ret.init();
                                                return promise;
                                            }
                                            Promise.some = function (promises, howMany) {
                                                return some(promises, howMany);
                                            };
                                            Promise.prototype.some = function (howMany) {
                                                return some(this, howMany);
                                            };
                                            Promise._SomePromiseArray = SomePromiseArray;
                                        };
                                    },
                                    { "./errors": 12, "./util": 36 },
                                ],
                                32: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise) {
                                            function PromiseInspection(promise) {
                                                if (promise !== undefined) {
                                                    promise = promise._target();
                                                    this._bitField = promise._bitField;
                                                    this._settledValueField = promise._isFateSealed() ? promise._settledValue() : undefined;
                                                } else {
                                                    this._bitField = 0;
                                                    this._settledValueField = undefined;
                                                }
                                            }
                                            PromiseInspection.prototype._settledValue = function () {
                                                return this._settledValueField;
                                            };
                                            var value = (PromiseInspection.prototype.value = function () {
                                                if (!this.isFulfilled()) {
                                                    throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");
                                                }
                                                return this._settledValue();
                                            });
                                            var reason = (PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function () {
                                                if (!this.isRejected()) {
                                                    throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");
                                                }
                                                return this._settledValue();
                                            });
                                            var isFulfilled = (PromiseInspection.prototype.isFulfilled = function () {
                                                return (this._bitField & 33554432) !== 0;
                                            });
                                            var isRejected = (PromiseInspection.prototype.isRejected = function () {
                                                return (this._bitField & 16777216) !== 0;
                                            });
                                            var isPending = (PromiseInspection.prototype.isPending = function () {
                                                return (this._bitField & 50397184) === 0;
                                            });
                                            var isResolved = (PromiseInspection.prototype.isResolved = function () {
                                                return (this._bitField & 50331648) !== 0;
                                            });
                                            PromiseInspection.prototype.isCancelled = function () {
                                                return (this._bitField & 8454144) !== 0;
                                            };
                                            Promise.prototype.__isCancelled = function () {
                                                return (this._bitField & 65536) === 65536;
                                            };
                                            Promise.prototype._isCancelled = function () {
                                                return this._target().__isCancelled();
                                            };
                                            Promise.prototype.isCancelled = function () {
                                                return (this._target()._bitField & 8454144) !== 0;
                                            };
                                            Promise.prototype.isPending = function () {
                                                return isPending.call(this._target());
                                            };
                                            Promise.prototype.isRejected = function () {
                                                return isRejected.call(this._target());
                                            };
                                            Promise.prototype.isFulfilled = function () {
                                                return isFulfilled.call(this._target());
                                            };
                                            Promise.prototype.isResolved = function () {
                                                return isResolved.call(this._target());
                                            };
                                            Promise.prototype.value = function () {
                                                return value.call(this._target());
                                            };
                                            Promise.prototype.reason = function () {
                                                var target = this._target();
                                                target._unsetRejectionIsUnhandled();
                                                return reason.call(target);
                                            };
                                            Promise.prototype._value = function () {
                                                return this._settledValue();
                                            };
                                            Promise.prototype._reason = function () {
                                                this._unsetRejectionIsUnhandled();
                                                return this._settledValue();
                                            };
                                            Promise.PromiseInspection = PromiseInspection;
                                        };
                                    },
                                    {},
                                ],
                                33: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, INTERNAL) {
                                            var util = _dereq_("./util");
                                            var errorObj = util.errorObj;
                                            var isObject = util.isObject;
                                            function tryConvertToPromise(obj, context) {
                                                if (isObject(obj)) {
                                                    if (obj instanceof Promise) return obj;
                                                    var then = getThen(obj);
                                                    if (then === errorObj) {
                                                        if (context) context._pushContext();
                                                        var ret = Promise.reject(then.e);
                                                        if (context) context._popContext();
                                                        return ret;
                                                    } else if (typeof then === "function") {
                                                        if (isAnyBluebirdPromise(obj)) {
                                                            var ret = new Promise(INTERNAL);
                                                            obj._then(ret._fulfill, ret._reject, undefined, ret, null);
                                                            return ret;
                                                        }
                                                        return doThenable(obj, then, context);
                                                    }
                                                }
                                                return obj;
                                            }
                                            function doGetThen(obj) {
                                                return obj.then;
                                            }
                                            function getThen(obj) {
                                                try {
                                                    return doGetThen(obj);
                                                } catch (e) {
                                                    errorObj.e = e;
                                                    return errorObj;
                                                }
                                            }
                                            var hasProp = {}.hasOwnProperty;
                                            function isAnyBluebirdPromise(obj) {
                                                try {
                                                    return hasProp.call(obj, "_promise0");
                                                } catch (e) {
                                                    return false;
                                                }
                                            }
                                            function doThenable(x, then, context) {
                                                var promise = new Promise(INTERNAL);
                                                var ret = promise;
                                                if (context) context._pushContext();
                                                promise._captureStackTrace();
                                                if (context) context._popContext();
                                                var synchronous = true;
                                                var result = util.tryCatch(then).call(x, resolve, reject);
                                                synchronous = false;
                                                if (promise && result === errorObj) {
                                                    promise._rejectCallback(result.e, true, true);
                                                    promise = null;
                                                }
                                                function resolve(value) {
                                                    if (!promise) return;
                                                    promise._resolveCallback(value);
                                                    promise = null;
                                                }
                                                function reject(reason) {
                                                    if (!promise) return;
                                                    promise._rejectCallback(reason, synchronous, true);
                                                    promise = null;
                                                }
                                                return ret;
                                            }
                                            return tryConvertToPromise;
                                        };
                                    },
                                    { "./util": 36 },
                                ],
                                34: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, INTERNAL, debug) {
                                            var util = _dereq_("./util");
                                            var TimeoutError = Promise.TimeoutError;
                                            function HandleWrapper(handle) {
                                                this.handle = handle;
                                            }
                                            HandleWrapper.prototype._resultCancelled = function () {
                                                clearTimeout(this.handle);
                                            };
                                            var afterValue = function afterValue(value) {
                                                return delay(+this).thenReturn(value);
                                            };
                                            var delay = (Promise.delay = function (ms, value) {
                                                var ret;
                                                var handle;
                                                if (value !== undefined) {
                                                    ret = Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
                                                    if (debug.cancellation() && value instanceof Promise) {
                                                        ret._setOnCancel(value);
                                                    }
                                                } else {
                                                    ret = new Promise(INTERNAL);
                                                    handle = setTimeout(function () {
                                                        ret._fulfill();
                                                    }, +ms);
                                                    if (debug.cancellation()) {
                                                        ret._setOnCancel(new HandleWrapper(handle));
                                                    }
                                                    ret._captureStackTrace();
                                                }
                                                ret._setAsyncGuaranteed();
                                                return ret;
                                            });
                                            Promise.prototype.delay = function (ms) {
                                                return delay(ms, this);
                                            };
                                            var afterTimeout = function afterTimeout(promise, message, parent) {
                                                var err;
                                                if (typeof message !== "string") {
                                                    if (message instanceof Error) {
                                                        err = message;
                                                    } else {
                                                        err = new TimeoutError("operation timed out");
                                                    }
                                                } else {
                                                    err = new TimeoutError(message);
                                                }
                                                util.markAsOriginatingFromRejection(err);
                                                promise._attachExtraTrace(err);
                                                promise._reject(err);
                                                if (parent != null) {
                                                    parent.cancel();
                                                }
                                            };
                                            function successClear(value) {
                                                clearTimeout(this.handle);
                                                return value;
                                            }
                                            function failureClear(reason) {
                                                clearTimeout(this.handle);
                                                throw reason;
                                            }
                                            Promise.prototype.timeout = function (ms, message) {
                                                ms = +ms;
                                                var ret, parent;
                                                var handleWrapper = new HandleWrapper(
                                                    setTimeout(function timeoutTimeout() {
                                                        if (ret.isPending()) {
                                                            afterTimeout(ret, message, parent);
                                                        }
                                                    }, ms)
                                                );
                                                if (debug.cancellation()) {
                                                    parent = this.then();
                                                    ret = parent._then(successClear, failureClear, undefined, handleWrapper, undefined);
                                                    ret._setOnCancel(handleWrapper);
                                                } else {
                                                    ret = this._then(successClear, failureClear, undefined, handleWrapper, undefined);
                                                }
                                                return ret;
                                            };
                                        };
                                    },
                                    { "./util": 36 },
                                ],
                                35: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        module.exports = function (Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug) {
                                            var util = _dereq_("./util");
                                            var TypeError = _dereq_("./errors").TypeError;
                                            var inherits = _dereq_("./util").inherits;
                                            var errorObj = util.errorObj;
                                            var tryCatch = util.tryCatch;
                                            var NULL = {};
                                            function thrower(e) {
                                                setTimeout(function () {
                                                    throw e;
                                                }, 0);
                                            }
                                            function castPreservingDisposable(thenable) {
                                                var maybePromise = tryConvertToPromise(thenable);
                                                if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) {
                                                    maybePromise._setDisposable(thenable._getDisposer());
                                                }
                                                return maybePromise;
                                            }
                                            function dispose(resources, inspection) {
                                                var i = 0;
                                                var len = resources.length;
                                                var ret = new Promise(INTERNAL);
                                                function iterator() {
                                                    if (i >= len) return ret._fulfill();
                                                    var maybePromise = castPreservingDisposable(resources[i++]);
                                                    if (maybePromise instanceof Promise && maybePromise._isDisposable()) {
                                                        try {
                                                            maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
                                                        } catch (e) {
                                                            return thrower(e);
                                                        }
                                                        if (maybePromise instanceof Promise) {
                                                            return maybePromise._then(iterator, thrower, null, null, null);
                                                        }
                                                    }
                                                    iterator();
                                                }
                                                iterator();
                                                return ret;
                                            }
                                            function Disposer(data, promise, context) {
                                                this._data = data;
                                                this._promise = promise;
                                                this._context = context;
                                            }
                                            Disposer.prototype.data = function () {
                                                return this._data;
                                            };
                                            Disposer.prototype.promise = function () {
                                                return this._promise;
                                            };
                                            Disposer.prototype.resource = function () {
                                                if (this.promise().isFulfilled()) {
                                                    return this.promise().value();
                                                }
                                                return NULL;
                                            };
                                            Disposer.prototype.tryDispose = function (inspection) {
                                                var resource = this.resource();
                                                var context = this._context;
                                                if (context !== undefined) context._pushContext();
                                                var ret = resource !== NULL ? this.doDispose(resource, inspection) : null;
                                                if (context !== undefined) context._popContext();
                                                this._promise._unsetDisposable();
                                                this._data = null;
                                                return ret;
                                            };
                                            Disposer.isDisposer = function (d) {
                                                return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
                                            };
                                            function FunctionDisposer(fn, promise, context) {
                                                this.constructor$(fn, promise, context);
                                            }
                                            inherits(FunctionDisposer, Disposer);
                                            FunctionDisposer.prototype.doDispose = function (resource, inspection) {
                                                var fn = this.data();
                                                return fn.call(resource, resource, inspection);
                                            };
                                            function maybeUnwrapDisposer(value) {
                                                if (Disposer.isDisposer(value)) {
                                                    this.resources[this.index]._setDisposable(value);
                                                    return value.promise();
                                                }
                                                return value;
                                            }
                                            function ResourceList(length) {
                                                this.length = length;
                                                this.promise = null;
                                                this[length - 1] = null;
                                            }
                                            ResourceList.prototype._resultCancelled = function () {
                                                var len = this.length;
                                                for (var i = 0; i < len; ++i) {
                                                    var item = this[i];
                                                    if (item instanceof Promise) {
                                                        item.cancel();
                                                    }
                                                }
                                            };
                                            Promise.using = function () {
                                                var len = arguments.length;
                                                if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
                                                var fn = arguments[len - 1];
                                                if (typeof fn !== "function") {
                                                    return apiRejection("expecting a function but got " + util.classString(fn));
                                                }
                                                var input;
                                                var spreadArgs = true;
                                                if (len === 2 && Array.isArray(arguments[0])) {
                                                    input = arguments[0];
                                                    len = input.length;
                                                    spreadArgs = false;
                                                } else {
                                                    input = arguments;
                                                    len--;
                                                }
                                                var resources = new ResourceList(len);
                                                for (var i = 0; i < len; ++i) {
                                                    var resource = input[i];
                                                    if (Disposer.isDisposer(resource)) {
                                                        var disposer = resource;
                                                        resource = resource.promise();
                                                        resource._setDisposable(disposer);
                                                    } else {
                                                        var maybePromise = tryConvertToPromise(resource);
                                                        if (maybePromise instanceof Promise) {
                                                            resource = maybePromise._then(maybeUnwrapDisposer, null, null, { resources: resources, index: i }, undefined);
                                                        }
                                                    }
                                                    resources[i] = resource;
                                                }
                                                var reflectedResources = new Array(resources.length);
                                                for (var i = 0; i < reflectedResources.length; ++i) {
                                                    reflectedResources[i] = Promise.resolve(resources[i]).reflect();
                                                }
                                                var resultPromise = Promise.all(reflectedResources).then(function (inspections) {
                                                    for (var i = 0; i < inspections.length; ++i) {
                                                        var inspection = inspections[i];
                                                        if (inspection.isRejected()) {
                                                            errorObj.e = inspection.error();
                                                            return errorObj;
                                                        } else if (!inspection.isFulfilled()) {
                                                            resultPromise.cancel();
                                                            return;
                                                        }
                                                        inspections[i] = inspection.value();
                                                    }
                                                    promise._pushContext();
                                                    fn = tryCatch(fn);
                                                    var ret = spreadArgs ? fn.apply(undefined, inspections) : fn(inspections);
                                                    var promiseCreated = promise._popContext();
                                                    debug.checkForgottenReturns(ret, promiseCreated, "Promise.using", promise);
                                                    return ret;
                                                });
                                                var promise = resultPromise.lastly(function () {
                                                    var inspection = new Promise.PromiseInspection(resultPromise);
                                                    return dispose(resources, inspection);
                                                });
                                                resources.promise = promise;
                                                promise._setOnCancel(resources);
                                                return promise;
                                            };
                                            Promise.prototype._setDisposable = function (disposer) {
                                                this._bitField = this._bitField | 131072;
                                                this._disposer = disposer;
                                            };
                                            Promise.prototype._isDisposable = function () {
                                                return (this._bitField & 131072) > 0;
                                            };
                                            Promise.prototype._getDisposer = function () {
                                                return this._disposer;
                                            };
                                            Promise.prototype._unsetDisposable = function () {
                                                this._bitField = this._bitField & ~131072;
                                                this._disposer = undefined;
                                            };
                                            Promise.prototype.disposer = function (fn) {
                                                if (typeof fn === "function") {
                                                    return new FunctionDisposer(fn, this, createContext());
                                                }
                                                throw new TypeError();
                                            };
                                        };
                                    },
                                    { "./errors": 12, "./util": 36 },
                                ],
                                36: [
                                    function (_dereq_, module, exports) {
                                        "use strict";
                                        var es5 = _dereq_("./es5");
                                        var canEvaluate = typeof navigator == "undefined";
                                        var errorObj = { e: {} };
                                        var tryCatchTarget;
                                        var globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : this !== undefined ? this : null;
                                        function tryCatcher() {
                                            try {
                                                var target = tryCatchTarget;
                                                tryCatchTarget = null;
                                                return target.apply(this, arguments);
                                            } catch (e) {
                                                errorObj.e = e;
                                                return errorObj;
                                            }
                                        }
                                        function tryCatch(fn) {
                                            tryCatchTarget = fn;
                                            return tryCatcher;
                                        }
                                        var inherits = function inherits(Child, Parent) {
                                            var hasProp = {}.hasOwnProperty;
                                            function T() {
                                                this.constructor = Child;
                                                this.constructor$ = Parent;
                                                for (var propertyName in Parent.prototype) {
                                                    if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") {
                                                        this[propertyName + "$"] = Parent.prototype[propertyName];
                                                    }
                                                }
                                            }
                                            T.prototype = Parent.prototype;
                                            Child.prototype = new T();
                                            return Child.prototype;
                                        };
                                        function isPrimitive(val) {
                                            return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
                                        }
                                        function isObject(value) {
                                            return typeof value === "function" || (_typeof(value) === "object" && value !== null);
                                        }
                                        function maybeWrapAsError(maybeError) {
                                            if (!isPrimitive(maybeError)) return maybeError;
                                            return new Error(safeToString(maybeError));
                                        }
                                        function withAppended(target, appendee) {
                                            var len = target.length;
                                            var ret = new Array(len + 1);
                                            var i;
                                            for (i = 0; i < len; ++i) {
                                                ret[i] = target[i];
                                            }
                                            ret[i] = appendee;
                                            return ret;
                                        }
                                        function getDataPropertyOrDefault(obj, key, defaultValue) {
                                            if (es5.isES5) {
                                                var desc = Object.getOwnPropertyDescriptor(obj, key);
                                                if (desc != null) {
                                                    return desc.get == null && desc.set == null ? desc.value : defaultValue;
                                                }
                                            } else {
                                                return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
                                            }
                                        }
                                        function notEnumerableProp(obj, name, value) {
                                            if (isPrimitive(obj)) return obj;
                                            var descriptor = { value: value, configurable: true, enumerable: false, writable: true };
                                            es5.defineProperty(obj, name, descriptor);
                                            return obj;
                                        }
                                        function thrower(r) {
                                            throw r;
                                        }
                                        var inheritedDataKeys = (function () {
                                            var excludedPrototypes = [Array.prototype, Object.prototype, Function.prototype];
                                            var isExcludedProto = function isExcludedProto(val) {
                                                for (var i = 0; i < excludedPrototypes.length; ++i) {
                                                    if (excludedPrototypes[i] === val) {
                                                        return true;
                                                    }
                                                }
                                                return false;
                                            };
                                            if (es5.isES5) {
                                                var getKeys = Object.getOwnPropertyNames;
                                                return function (obj) {
                                                    var ret = [];
                                                    var visitedKeys = Object.create(null);
                                                    while (obj != null && !isExcludedProto(obj)) {
                                                        var keys;
                                                        try {
                                                            keys = getKeys(obj);
                                                        } catch (e) {
                                                            return ret;
                                                        }
                                                        for (var i = 0; i < keys.length; ++i) {
                                                            var key = keys[i];
                                                            if (visitedKeys[key]) continue;
                                                            visitedKeys[key] = true;
                                                            var desc = Object.getOwnPropertyDescriptor(obj, key);
                                                            if (desc != null && desc.get == null && desc.set == null) {
                                                                ret.push(key);
                                                            }
                                                        }
                                                        obj = es5.getPrototypeOf(obj);
                                                    }
                                                    return ret;
                                                };
                                            } else {
                                                var hasProp = {}.hasOwnProperty;
                                                return function (obj) {
                                                    if (isExcludedProto(obj)) return [];
                                                    var ret = [];
                                                    /*jshint forin:false */ enumeration: for (var key in obj) {
                                                        if (hasProp.call(obj, key)) {
                                                            ret.push(key);
                                                        } else {
                                                            for (var i = 0; i < excludedPrototypes.length; ++i) {
                                                                if (hasProp.call(excludedPrototypes[i], key)) {
                                                                    continue enumeration;
                                                                }
                                                            }
                                                            ret.push(key);
                                                        }
                                                    }
                                                    return ret;
                                                };
                                            }
                                        })();
                                        var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
                                        function isClass(fn) {
                                            try {
                                                if (typeof fn === "function") {
                                                    var keys = es5.names(fn.prototype);
                                                    var hasMethods = es5.isES5 && keys.length > 1;
                                                    var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
                                                    var hasThisAssignmentAndStaticMethods = thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
                                                    if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) {
                                                        return true;
                                                    }
                                                }
                                                return false;
                                            } catch (e) {
                                                return false;
                                            }
                                        }
                                        function toFastProperties(obj) {
                                            /*jshint -W027,-W055,-W031*/ function FakeConstructor() {}
                                            FakeConstructor.prototype = obj;
                                            var receiver = new FakeConstructor();
                                            function ic() {
                                                return _typeof(receiver.foo);
                                            }
                                            ic();
                                            ic();
                                            return obj;
                                            eval(obj);
                                        }
                                        var rident = /^[a-z$_][a-z$_0-9]*$/i;
                                        function isIdentifier(str) {
                                            return rident.test(str);
                                        }
                                        function filledRange(count, prefix, suffix) {
                                            var ret = new Array(count);
                                            for (var i = 0; i < count; ++i) {
                                                ret[i] = prefix + i + suffix;
                                            }
                                            return ret;
                                        }
                                        function safeToString(obj) {
                                            try {
                                                return obj + "";
                                            } catch (e) {
                                                return "[no string representation]";
                                            }
                                        }
                                        function isError(obj) {
                                            return obj instanceof Error || (obj !== null && _typeof(obj) === "object" && typeof obj.message === "string" && typeof obj.name === "string");
                                        }
                                        function markAsOriginatingFromRejection(e) {
                                            try {
                                                notEnumerableProp(e, "isOperational", true);
                                            } catch (ignore) {}
                                        }
                                        function originatesFromRejection(e) {
                                            if (e == null) return false;
                                            return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
                                        }
                                        function canAttachTrace(obj) {
                                            return isError(obj) && es5.propertyIsWritable(obj, "stack");
                                        }
                                        var ensureErrorObject = (function () {
                                            if (!("stack" in new Error())) {
                                                return function (value) {
                                                    if (canAttachTrace(value)) return value;
                                                    try {
                                                        throw new Error(safeToString(value));
                                                    } catch (err) {
                                                        return err;
                                                    }
                                                };
                                            } else {
                                                return function (value) {
                                                    if (canAttachTrace(value)) return value;
                                                    return new Error(safeToString(value));
                                                };
                                            }
                                        })();
                                        function classString(obj) {
                                            return {}.toString.call(obj);
                                        }
                                        function copyDescriptors(from, to, filter) {
                                            var keys = es5.names(from);
                                            for (var i = 0; i < keys.length; ++i) {
                                                var key = keys[i];
                                                if (filter(key)) {
                                                    try {
                                                        es5.defineProperty(to, key, es5.getDescriptor(from, key));
                                                    } catch (ignore) {}
                                                }
                                            }
                                        }
                                        var asArray = function asArray(v) {
                                            if (es5.isArray(v)) {
                                                return v;
                                            }
                                            return null;
                                        };
                                        if (typeof Symbol !== "undefined" && Symbol.iterator) {
                                            var ArrayFrom =
                                                typeof Array.from === "function"
                                                    ? function (v) {
                                                          return Array.from(v);
                                                      }
                                                    : function (v) {
                                                          var ret = [];
                                                          var it = v[Symbol.iterator]();
                                                          var itResult;
                                                          while (!(itResult = it.next()).done) {
                                                              ret.push(itResult.value);
                                                          }
                                                          return ret;
                                                      };
                                            asArray = function asArray(v) {
                                                if (es5.isArray(v)) {
                                                    return v;
                                                } else if (v != null && typeof v[Symbol.iterator] === "function") {
                                                    return ArrayFrom(v);
                                                }
                                                return null;
                                            };
                                        }
                                        var isNode = typeof process !== "undefined" && classString(process).toLowerCase() === "[object process]";
                                        var hasEnvVariables = typeof process !== "undefined" && typeof process.env !== "undefined";
                                        function env(key) {
                                            return hasEnvVariables ? process.env[key] : undefined;
                                        }
                                        function getNativePromise() {
                                            if (typeof Promise === "function") {
                                                try {
                                                    var promise = new Promise(function () {});
                                                    if (classString(promise) === "[object Promise]") {
                                                        return Promise;
                                                    }
                                                } catch (e) {}
                                            }
                                        }
                                        var reflectHandler;
                                        function contextBind(ctx, cb) {
                                            if (ctx === null || typeof cb !== "function" || cb === reflectHandler) {
                                                return cb;
                                            }
                                            if (ctx.domain !== null) {
                                                cb = ctx.domain.bind(cb);
                                            }
                                            var async = ctx.async;
                                            if (async !== null) {
                                                var old = cb;
                                                cb = function cb() {
                                                    var args = new Array(2).concat([].slice.call(arguments));
                                                    args[0] = old;
                                                    args[1] = this;
                                                    return async.runInAsyncScope.apply(async, args);
                                                };
                                            }
                                            return cb;
                                        }
                                        var ret = {
                                            setReflectHandler: function setReflectHandler(fn) {
                                                reflectHandler = fn;
                                            },
                                            isClass: isClass,
                                            isIdentifier: isIdentifier,
                                            inheritedDataKeys: inheritedDataKeys,
                                            getDataPropertyOrDefault: getDataPropertyOrDefault,
                                            thrower: thrower,
                                            isArray: es5.isArray,
                                            asArray: asArray,
                                            notEnumerableProp: notEnumerableProp,
                                            isPrimitive: isPrimitive,
                                            isObject: isObject,
                                            isError: isError,
                                            canEvaluate: canEvaluate,
                                            errorObj: errorObj,
                                            tryCatch: tryCatch,
                                            inherits: inherits,
                                            withAppended: withAppended,
                                            maybeWrapAsError: maybeWrapAsError,
                                            toFastProperties: toFastProperties,
                                            filledRange: filledRange,
                                            toString: safeToString,
                                            canAttachTrace: canAttachTrace,
                                            ensureErrorObject: ensureErrorObject,
                                            originatesFromRejection: originatesFromRejection,
                                            markAsOriginatingFromRejection: markAsOriginatingFromRejection,
                                            classString: classString,
                                            copyDescriptors: copyDescriptors,
                                            isNode: isNode,
                                            hasEnvVariables: hasEnvVariables,
                                            env: env,
                                            global: globalObject,
                                            getNativePromise: getNativePromise,
                                            contextBind: contextBind,
                                        };
                                        ret.isRecentNode =
                                            ret.isNode &&
                                            (function () {
                                                var version;
                                                if (process.versions && process.versions.node) {
                                                    version = process.versions.node.split(".").map(Number);
                                                } else if (process.version) {
                                                    version = process.version.split(".").map(Number);
                                                }
                                                return (version[0] === 0 && version[1] > 10) || version[0] > 0;
                                            })();
                                        ret.nodeSupportsAsyncResource =
                                            ret.isNode &&
                                            (function () {
                                                var supportsAsync = false;
                                                try {
                                                    var res = _dereq_("async_hooks").AsyncResource;
                                                    supportsAsync = typeof res.prototype.runInAsyncScope === "function";
                                                } catch (e) {
                                                    supportsAsync = false;
                                                }
                                                return supportsAsync;
                                            })();
                                        if (ret.isNode) ret.toFastProperties(process);
                                        try {
                                            throw new Error();
                                        } catch (e) {
                                            ret.lastLineError = e;
                                        }
                                        module.exports = ret;
                                    },
                                    { "./es5": 13, async_hooks: undefined },
                                ],
                            },
                            {},
                            [4]
                        )(4);
                    });
                    if (typeof window !== "undefined" && window !== null) {
                        window.P = window.Promise;
                    } else if (typeof self !== "undefined" && self !== null) {
                        self.P = self.Promise;
                    }
                }.call(this, require("rH1JPG"), typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {}));
            },
            { rH1JPG: 66 },
        ],
        53: [
            function (require, module, exports) {
                "use strict";
                require("./index").polyfill();
            },
            { "./index": 54 },
        ],
        54: [
            function (require, module, exports) {
                /**
                 * Code refactored from Mozilla Developer Network:
                 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
                 */ "use strict";
                function assign(target, firstSource) {
                    if (target === undefined || target === null) {
                        throw new TypeError("Cannot convert first argument to object");
                    }
                    var to = Object(target);
                    for (var i = 1; i < arguments.length; i++) {
                        var nextSource = arguments[i];
                        if (nextSource === undefined || nextSource === null) {
                            continue;
                        }
                        var keysArray = Object.keys(Object(nextSource));
                        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                            var nextKey = keysArray[nextIndex];
                            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                            if (desc !== undefined && desc.enumerable) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                    return to;
                }
                function polyfill() {
                    if (!Object.assign) {
                        Object.defineProperty(Object, "assign", { enumerable: false, configurable: true, writable: true, value: assign });
                    }
                }
                module.exports = { assign: assign, polyfill: polyfill };
            },
            {},
        ],
        55: [
            function (require, module, exports) {
                "use strict";
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 *
                 * This source code is licensed under the MIT license found in the
                 * LICENSE file in the root directory of this source tree.
                 *
                 *
                 */ function makeEmptyFunction(arg) {
                    return function () {
                        return arg;
                    };
                }
                /**
                 * This function accepts and discards inputs; it has no side effects. This is
                 * primarily useful idiomatically for overridable function endpoints which
                 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
                 */ var emptyFunction = function emptyFunction() {};
                emptyFunction.thatReturns = makeEmptyFunction;
                emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
                emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
                emptyFunction.thatReturnsNull = makeEmptyFunction(null);
                emptyFunction.thatReturnsThis = function () {
                    return this;
                };
                emptyFunction.thatReturnsArgument = function (arg) {
                    return arg;
                };
                module.exports = emptyFunction;
            },
            {},
        ],
        56: [
            function (require, module, exports) {
                (function (process) {
                    /**
                     * Copyright (c) 2013-present, Facebook, Inc.
                     *
                     * This source code is licensed under the MIT license found in the
                     * LICENSE file in the root directory of this source tree.
                     *
                     */ "use strict";
                    var emptyObject = {};
                    if (process.env.NODE_ENV !== "production") {
                        Object.freeze(emptyObject);
                    }
                    module.exports = emptyObject;
                }.call(this, require("rH1JPG")));
            },
            { rH1JPG: 66 },
        ],
        57: [
            function (require, module, exports) {
                (function (process) {
                    /**
                     * Copyright (c) 2013-present, Facebook, Inc.
                     *
                     * This source code is licensed under the MIT license found in the
                     * LICENSE file in the root directory of this source tree.
                     *
                     */ "use strict";
                    /**
                     * Use invariant() to assert state which your program assumes to be true.
                     *
                     * Provide sprintf-style format (only %s is supported) and arguments
                     * to provide information about what broke and what you were
                     * expecting.
                     *
                     * The invariant message will be stripped in production, but the invariant
                     * will remain to ensure logic does not differ in production.
                     */ var validateFormat = function validateFormat(format) {};
                    if (process.env.NODE_ENV !== "production") {
                        validateFormat = function validateFormat(format) {
                            if (format === undefined) {
                                throw new Error("invariant requires an error message argument");
                            }
                        };
                    }
                    function invariant(condition, format, a, b, c, d, e, f) {
                        validateFormat(format);
                        if (!condition) {
                            var error;
                            if (format === undefined) {
                                error = new Error("Minified exception occurred; use the non-minified dev environment " + "for the full error message and additional helpful warnings.");
                            } else {
                                var args = [a, b, c, d, e, f];
                                var argIndex = 0;
                                error = new Error(
                                    format.replace(/%s/g, function () {
                                        return args[argIndex++];
                                    })
                                );
                                error.name = "Invariant Violation";
                            }
                            error.framesToPop = 1; // we don't care about invariant's own frame
                            throw error;
                        }
                    }
                    module.exports = invariant;
                }.call(this, require("rH1JPG")));
            },
            { rH1JPG: 66 },
        ],
        58: [
            function (require, module, exports) {
                (function (process) {
                    /**
                     * Copyright (c) 2014-present, Facebook, Inc.
                     *
                     * This source code is licensed under the MIT license found in the
                     * LICENSE file in the root directory of this source tree.
                     *
                     */ "use strict";
                    var emptyFunction = require("./emptyFunction");
                    /**
                     * Similar to invariant but only logs a warning if the condition is not met.
                     * This can be used to log issues in development environments in critical
                     * paths. Removing the logging code for production environments will keep the
                     * same logic and follow the same code paths.
                     */ var warning = emptyFunction;
                    if (process.env.NODE_ENV !== "production") {
                        var printWarning = function printWarning(format) {
                            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                                args[_key - 1] = arguments[_key];
                            }
                            var argIndex = 0;
                            var message =
                                "Warning: " +
                                format.replace(/%s/g, function () {
                                    return args[argIndex++];
                                });
                            if (typeof console !== "undefined") {
                                console.error(message);
                            }
                            try {
                                // --- Welcome to debugging React ---
                                // This error was thrown as a convenience so that you can use this stack
                                // to find the callsite that caused this warning to fire.
                                throw new Error(message);
                            } catch (x) {}
                        };
                        warning = function warning(condition, format) {
                            if (format === undefined) {
                                throw new Error("`warning(condition, format, ...args)` requires a warning " + "message argument");
                            }
                            if (format.indexOf("Failed Composite propType: ") === 0) {
                                return; // Ignore CompositeComponent proptype check.
                            }
                            if (!condition) {
                                for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                                    args[_key2 - 2] = arguments[_key2];
                                }
                                printWarning.apply(undefined, [format].concat(args));
                            }
                        };
                    }
                    module.exports = warning;
                }.call(this, require("rH1JPG")));
            },
            { "./emptyFunction": 55, rH1JPG: 66 },
        ],
        59: [
            function (require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", { value: true });
                var surrogate_pairs_1 = require("./surrogate-pairs");
                var HTML_ALPHA = [
                    "apos",
                    "nbsp",
                    "iexcl",
                    "cent",
                    "pound",
                    "curren",
                    "yen",
                    "brvbar",
                    "sect",
                    "uml",
                    "copy",
                    "ordf",
                    "laquo",
                    "not",
                    "shy",
                    "reg",
                    "macr",
                    "deg",
                    "plusmn",
                    "sup2",
                    "sup3",
                    "acute",
                    "micro",
                    "para",
                    "middot",
                    "cedil",
                    "sup1",
                    "ordm",
                    "raquo",
                    "frac14",
                    "frac12",
                    "frac34",
                    "iquest",
                    "Agrave",
                    "Aacute",
                    "Acirc",
                    "Atilde",
                    "Auml",
                    "Aring",
                    "AElig",
                    "Ccedil",
                    "Egrave",
                    "Eacute",
                    "Ecirc",
                    "Euml",
                    "Igrave",
                    "Iacute",
                    "Icirc",
                    "Iuml",
                    "ETH",
                    "Ntilde",
                    "Ograve",
                    "Oacute",
                    "Ocirc",
                    "Otilde",
                    "Ouml",
                    "times",
                    "Oslash",
                    "Ugrave",
                    "Uacute",
                    "Ucirc",
                    "Uuml",
                    "Yacute",
                    "THORN",
                    "szlig",
                    "agrave",
                    "aacute",
                    "acirc",
                    "atilde",
                    "auml",
                    "aring",
                    "aelig",
                    "ccedil",
                    "egrave",
                    "eacute",
                    "ecirc",
                    "euml",
                    "igrave",
                    "iacute",
                    "icirc",
                    "iuml",
                    "eth",
                    "ntilde",
                    "ograve",
                    "oacute",
                    "ocirc",
                    "otilde",
                    "ouml",
                    "divide",
                    "oslash",
                    "ugrave",
                    "uacute",
                    "ucirc",
                    "uuml",
                    "yacute",
                    "thorn",
                    "yuml",
                    "quot",
                    "amp",
                    "lt",
                    "gt",
                    "OElig",
                    "oelig",
                    "Scaron",
                    "scaron",
                    "Yuml",
                    "circ",
                    "tilde",
                    "ensp",
                    "emsp",
                    "thinsp",
                    "zwnj",
                    "zwj",
                    "lrm",
                    "rlm",
                    "ndash",
                    "mdash",
                    "lsquo",
                    "rsquo",
                    "sbquo",
                    "ldquo",
                    "rdquo",
                    "bdquo",
                    "dagger",
                    "Dagger",
                    "permil",
                    "lsaquo",
                    "rsaquo",
                    "euro",
                    "fnof",
                    "Alpha",
                    "Beta",
                    "Gamma",
                    "Delta",
                    "Epsilon",
                    "Zeta",
                    "Eta",
                    "Theta",
                    "Iota",
                    "Kappa",
                    "Lambda",
                    "Mu",
                    "Nu",
                    "Xi",
                    "Omicron",
                    "Pi",
                    "Rho",
                    "Sigma",
                    "Tau",
                    "Upsilon",
                    "Phi",
                    "Chi",
                    "Psi",
                    "Omega",
                    "alpha",
                    "beta",
                    "gamma",
                    "delta",
                    "epsilon",
                    "zeta",
                    "eta",
                    "theta",
                    "iota",
                    "kappa",
                    "lambda",
                    "mu",
                    "nu",
                    "xi",
                    "omicron",
                    "pi",
                    "rho",
                    "sigmaf",
                    "sigma",
                    "tau",
                    "upsilon",
                    "phi",
                    "chi",
                    "psi",
                    "omega",
                    "thetasym",
                    "upsih",
                    "piv",
                    "bull",
                    "hellip",
                    "prime",
                    "Prime",
                    "oline",
                    "frasl",
                    "weierp",
                    "image",
                    "real",
                    "trade",
                    "alefsym",
                    "larr",
                    "uarr",
                    "rarr",
                    "darr",
                    "harr",
                    "crarr",
                    "lArr",
                    "uArr",
                    "rArr",
                    "dArr",
                    "hArr",
                    "forall",
                    "part",
                    "exist",
                    "empty",
                    "nabla",
                    "isin",
                    "notin",
                    "ni",
                    "prod",
                    "sum",
                    "minus",
                    "lowast",
                    "radic",
                    "prop",
                    "infin",
                    "ang",
                    "and",
                    "or",
                    "cap",
                    "cup",
                    "int",
                    "there4",
                    "sim",
                    "cong",
                    "asymp",
                    "ne",
                    "equiv",
                    "le",
                    "ge",
                    "sub",
                    "sup",
                    "nsub",
                    "sube",
                    "supe",
                    "oplus",
                    "otimes",
                    "perp",
                    "sdot",
                    "lceil",
                    "rceil",
                    "lfloor",
                    "rfloor",
                    "lang",
                    "rang",
                    "loz",
                    "spades",
                    "clubs",
                    "hearts",
                    "diams",
                ];
                var HTML_CODES = [
                    39,
                    160,
                    161,
                    162,
                    163,
                    164,
                    165,
                    166,
                    167,
                    168,
                    169,
                    170,
                    171,
                    172,
                    173,
                    174,
                    175,
                    176,
                    177,
                    178,
                    179,
                    180,
                    181,
                    182,
                    183,
                    184,
                    185,
                    186,
                    187,
                    188,
                    189,
                    190,
                    191,
                    192,
                    193,
                    194,
                    195,
                    196,
                    197,
                    198,
                    199,
                    200,
                    201,
                    202,
                    203,
                    204,
                    205,
                    206,
                    207,
                    208,
                    209,
                    210,
                    211,
                    212,
                    213,
                    214,
                    215,
                    216,
                    217,
                    218,
                    219,
                    220,
                    221,
                    222,
                    223,
                    224,
                    225,
                    226,
                    227,
                    228,
                    229,
                    230,
                    231,
                    232,
                    233,
                    234,
                    235,
                    236,
                    237,
                    238,
                    239,
                    240,
                    241,
                    242,
                    243,
                    244,
                    245,
                    246,
                    247,
                    248,
                    249,
                    250,
                    251,
                    252,
                    253,
                    254,
                    255,
                    34,
                    38,
                    60,
                    62,
                    338,
                    339,
                    352,
                    353,
                    376,
                    710,
                    732,
                    8194,
                    8195,
                    8201,
                    8204,
                    8205,
                    8206,
                    8207,
                    8211,
                    8212,
                    8216,
                    8217,
                    8218,
                    8220,
                    8221,
                    8222,
                    8224,
                    8225,
                    8240,
                    8249,
                    8250,
                    8364,
                    402,
                    913,
                    914,
                    915,
                    916,
                    917,
                    918,
                    919,
                    920,
                    921,
                    922,
                    923,
                    924,
                    925,
                    926,
                    927,
                    928,
                    929,
                    931,
                    932,
                    933,
                    934,
                    935,
                    936,
                    937,
                    945,
                    946,
                    947,
                    948,
                    949,
                    950,
                    951,
                    952,
                    953,
                    954,
                    955,
                    956,
                    957,
                    958,
                    959,
                    960,
                    961,
                    962,
                    963,
                    964,
                    965,
                    966,
                    967,
                    968,
                    969,
                    977,
                    978,
                    982,
                    8226,
                    8230,
                    8242,
                    8243,
                    8254,
                    8260,
                    8472,
                    8465,
                    8476,
                    8482,
                    8501,
                    8592,
                    8593,
                    8594,
                    8595,
                    8596,
                    8629,
                    8656,
                    8657,
                    8658,
                    8659,
                    8660,
                    8704,
                    8706,
                    8707,
                    8709,
                    8711,
                    8712,
                    8713,
                    8715,
                    8719,
                    8721,
                    8722,
                    8727,
                    8730,
                    8733,
                    8734,
                    8736,
                    8743,
                    8744,
                    8745,
                    8746,
                    8747,
                    8756,
                    8764,
                    8773,
                    8776,
                    8800,
                    8801,
                    8804,
                    8805,
                    8834,
                    8835,
                    8836,
                    8838,
                    8839,
                    8853,
                    8855,
                    8869,
                    8901,
                    8968,
                    8969,
                    8970,
                    8971,
                    9001,
                    9002,
                    9674,
                    9824,
                    9827,
                    9829,
                    9830,
                ];
                var alphaIndex = {};
                var numIndex = {};
                (function () {
                    var i = 0;
                    var length = HTML_ALPHA.length;
                    while (i < length) {
                        var a = HTML_ALPHA[i];
                        var c = HTML_CODES[i];
                        alphaIndex[a] = String.fromCharCode(c);
                        numIndex[c] = a;
                        i++;
                    }
                })();
                var Html4Entities = /** @class */ (function () {
                    function Html4Entities() {}
                    Html4Entities.prototype.decode = function (str) {
                        if (!str || !str.length) {
                            return "";
                        }
                        return str.replace(/&(#?[\w\d]+);?/g, function (s, entity) {
                            var chr;
                            if (entity.charAt(0) === "#") {
                                var code = entity.charAt(1).toLowerCase() === "x" ? parseInt(entity.substr(2), 16) : parseInt(entity.substr(1));
                                if (!isNaN(code) || code >= -32768) {
                                    if (code <= 65535) {
                                        chr = String.fromCharCode(code);
                                    } else {
                                        chr = surrogate_pairs_1.fromCodePoint(code);
                                    }
                                }
                            } else {
                                chr = alphaIndex[entity];
                            }
                            return chr || s;
                        });
                    };
                    Html4Entities.decode = function (str) {
                        return new Html4Entities().decode(str);
                    };
                    Html4Entities.prototype.encode = function (str) {
                        if (!str || !str.length) {
                            return "";
                        }
                        var strLength = str.length;
                        var result = "";
                        var i = 0;
                        while (i < strLength) {
                            var alpha = numIndex[str.charCodeAt(i)];
                            result += alpha ? "&" + alpha + ";" : str.charAt(i);
                            i++;
                        }
                        return result;
                    };
                    Html4Entities.encode = function (str) {
                        return new Html4Entities().encode(str);
                    };
                    Html4Entities.prototype.encodeNonUTF = function (str) {
                        if (!str || !str.length) {
                            return "";
                        }
                        var strLength = str.length;
                        var result = "";
                        var i = 0;
                        while (i < strLength) {
                            var cc = str.charCodeAt(i);
                            var alpha = numIndex[cc];
                            if (alpha) {
                                result += "&" + alpha + ";";
                            } else if (cc < 32 || cc > 126) {
                                if (cc >= surrogate_pairs_1.highSurrogateFrom && cc <= surrogate_pairs_1.highSurrogateTo) {
                                    result += "&#" + surrogate_pairs_1.getCodePoint(str, i) + ";";
                                    i++;
                                } else {
                                    result += "&#" + cc + ";";
                                }
                            } else {
                                result += str.charAt(i);
                            }
                            i++;
                        }
                        return result;
                    };
                    Html4Entities.encodeNonUTF = function (str) {
                        return new Html4Entities().encodeNonUTF(str);
                    };
                    Html4Entities.prototype.encodeNonASCII = function (str) {
                        if (!str || !str.length) {
                            return "";
                        }
                        var strLength = str.length;
                        var result = "";
                        var i = 0;
                        while (i < strLength) {
                            var c = str.charCodeAt(i);
                            if (c <= 255) {
                                result += str[i++];
                                continue;
                            }
                            if (c >= surrogate_pairs_1.highSurrogateFrom && c <= surrogate_pairs_1.highSurrogateTo) {
                                result += "&#" + surrogate_pairs_1.getCodePoint(str, i) + ";";
                                i++;
                            } else {
                                result += "&#" + c + ";";
                            }
                            i++;
                        }
                        return result;
                    };
                    Html4Entities.encodeNonASCII = function (str) {
                        return new Html4Entities().encodeNonASCII(str);
                    };
                    return Html4Entities;
                })();
                exports.Html4Entities = Html4Entities;
            },
            { "./surrogate-pairs": 62 },
        ],
        60: [
            function (require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", { value: true });
                var surrogate_pairs_1 = require("./surrogate-pairs");
                var ENTITIES = [
                    ["Aacute", [193]],
                    ["aacute", [225]],
                    ["Abreve", [258]],
                    ["abreve", [259]],
                    ["ac", [8766]],
                    ["acd", [8767]],
                    ["acE", [8766, 819]],
                    ["Acirc", [194]],
                    ["acirc", [226]],
                    ["acute", [180]],
                    ["Acy", [1040]],
                    ["acy", [1072]],
                    ["AElig", [198]],
                    ["aelig", [230]],
                    ["af", [8289]],
                    ["Afr", [120068]],
                    ["afr", [120094]],
                    ["Agrave", [192]],
                    ["agrave", [224]],
                    ["alefsym", [8501]],
                    ["aleph", [8501]],
                    ["Alpha", [913]],
                    ["alpha", [945]],
                    ["Amacr", [256]],
                    ["amacr", [257]],
                    ["amalg", [10815]],
                    ["amp", [38]],
                    ["AMP", [38]],
                    ["andand", [10837]],
                    ["And", [10835]],
                    ["and", [8743]],
                    ["andd", [10844]],
                    ["andslope", [10840]],
                    ["andv", [10842]],
                    ["ang", [8736]],
                    ["ange", [10660]],
                    ["angle", [8736]],
                    ["angmsdaa", [10664]],
                    ["angmsdab", [10665]],
                    ["angmsdac", [10666]],
                    ["angmsdad", [10667]],
                    ["angmsdae", [10668]],
                    ["angmsdaf", [10669]],
                    ["angmsdag", [10670]],
                    ["angmsdah", [10671]],
                    ["angmsd", [8737]],
                    ["angrt", [8735]],
                    ["angrtvb", [8894]],
                    ["angrtvbd", [10653]],
                    ["angsph", [8738]],
                    ["angst", [197]],
                    ["angzarr", [9084]],
                    ["Aogon", [260]],
                    ["aogon", [261]],
                    ["Aopf", [120120]],
                    ["aopf", [120146]],
                    ["apacir", [10863]],
                    ["ap", [8776]],
                    ["apE", [10864]],
                    ["ape", [8778]],
                    ["apid", [8779]],
                    ["apos", [39]],
                    ["ApplyFunction", [8289]],
                    ["approx", [8776]],
                    ["approxeq", [8778]],
                    ["Aring", [197]],
                    ["aring", [229]],
                    ["Ascr", [119964]],
                    ["ascr", [119990]],
                    ["Assign", [8788]],
                    ["ast", [42]],
                    ["asymp", [8776]],
                    ["asympeq", [8781]],
                    ["Atilde", [195]],
                    ["atilde", [227]],
                    ["Auml", [196]],
                    ["auml", [228]],
                    ["awconint", [8755]],
                    ["awint", [10769]],
                    ["backcong", [8780]],
                    ["backepsilon", [1014]],
                    ["backprime", [8245]],
                    ["backsim", [8765]],
                    ["backsimeq", [8909]],
                    ["Backslash", [8726]],
                    ["Barv", [10983]],
                    ["barvee", [8893]],
                    ["barwed", [8965]],
                    ["Barwed", [8966]],
                    ["barwedge", [8965]],
                    ["bbrk", [9141]],
                    ["bbrktbrk", [9142]],
                    ["bcong", [8780]],
                    ["Bcy", [1041]],
                    ["bcy", [1073]],
                    ["bdquo", [8222]],
                    ["becaus", [8757]],
                    ["because", [8757]],
                    ["Because", [8757]],
                    ["bemptyv", [10672]],
                    ["bepsi", [1014]],
                    ["bernou", [8492]],
                    ["Bernoullis", [8492]],
                    ["Beta", [914]],
                    ["beta", [946]],
                    ["beth", [8502]],
                    ["between", [8812]],
                    ["Bfr", [120069]],
                    ["bfr", [120095]],
                    ["bigcap", [8898]],
                    ["bigcirc", [9711]],
                    ["bigcup", [8899]],
                    ["bigodot", [10752]],
                    ["bigoplus", [10753]],
                    ["bigotimes", [10754]],
                    ["bigsqcup", [10758]],
                    ["bigstar", [9733]],
                    ["bigtriangledown", [9661]],
                    ["bigtriangleup", [9651]],
                    ["biguplus", [10756]],
                    ["bigvee", [8897]],
                    ["bigwedge", [8896]],
                    ["bkarow", [10509]],
                    ["blacklozenge", [10731]],
                    ["blacksquare", [9642]],
                    ["blacktriangle", [9652]],
                    ["blacktriangledown", [9662]],
                    ["blacktriangleleft", [9666]],
                    ["blacktriangleright", [9656]],
                    ["blank", [9251]],
                    ["blk12", [9618]],
                    ["blk14", [9617]],
                    ["blk34", [9619]],
                    ["block", [9608]],
                    ["bne", [61, 8421]],
                    ["bnequiv", [8801, 8421]],
                    ["bNot", [10989]],
                    ["bnot", [8976]],
                    ["Bopf", [120121]],
                    ["bopf", [120147]],
                    ["bot", [8869]],
                    ["bottom", [8869]],
                    ["bowtie", [8904]],
                    ["boxbox", [10697]],
                    ["boxdl", [9488]],
                    ["boxdL", [9557]],
                    ["boxDl", [9558]],
                    ["boxDL", [9559]],
                    ["boxdr", [9484]],
                    ["boxdR", [9554]],
                    ["boxDr", [9555]],
                    ["boxDR", [9556]],
                    ["boxh", [9472]],
                    ["boxH", [9552]],
                    ["boxhd", [9516]],
                    ["boxHd", [9572]],
                    ["boxhD", [9573]],
                    ["boxHD", [9574]],
                    ["boxhu", [9524]],
                    ["boxHu", [9575]],
                    ["boxhU", [9576]],
                    ["boxHU", [9577]],
                    ["boxminus", [8863]],
                    ["boxplus", [8862]],
                    ["boxtimes", [8864]],
                    ["boxul", [9496]],
                    ["boxuL", [9563]],
                    ["boxUl", [9564]],
                    ["boxUL", [9565]],
                    ["boxur", [9492]],
                    ["boxuR", [9560]],
                    ["boxUr", [9561]],
                    ["boxUR", [9562]],
                    ["boxv", [9474]],
                    ["boxV", [9553]],
                    ["boxvh", [9532]],
                    ["boxvH", [9578]],
                    ["boxVh", [9579]],
                    ["boxVH", [9580]],
                    ["boxvl", [9508]],
                    ["boxvL", [9569]],
                    ["boxVl", [9570]],
                    ["boxVL", [9571]],
                    ["boxvr", [9500]],
                    ["boxvR", [9566]],
                    ["boxVr", [9567]],
                    ["boxVR", [9568]],
                    ["bprime", [8245]],
                    ["breve", [728]],
                    ["Breve", [728]],
                    ["brvbar", [166]],
                    ["bscr", [119991]],
                    ["Bscr", [8492]],
                    ["bsemi", [8271]],
                    ["bsim", [8765]],
                    ["bsime", [8909]],
                    ["bsolb", [10693]],
                    ["bsol", [92]],
                    ["bsolhsub", [10184]],
                    ["bull", [8226]],
                    ["bullet", [8226]],
                    ["bump", [8782]],
                    ["bumpE", [10926]],
                    ["bumpe", [8783]],
                    ["Bumpeq", [8782]],
                    ["bumpeq", [8783]],
                    ["Cacute", [262]],
                    ["cacute", [263]],
                    ["capand", [10820]],
                    ["capbrcup", [10825]],
                    ["capcap", [10827]],
                    ["cap", [8745]],
                    ["Cap", [8914]],
                    ["capcup", [10823]],
                    ["capdot", [10816]],
                    ["CapitalDifferentialD", [8517]],
                    ["caps", [8745, 65024]],
                    ["caret", [8257]],
                    ["caron", [711]],
                    ["Cayleys", [8493]],
                    ["ccaps", [10829]],
                    ["Ccaron", [268]],
                    ["ccaron", [269]],
                    ["Ccedil", [199]],
                    ["ccedil", [231]],
                    ["Ccirc", [264]],
                    ["ccirc", [265]],
                    ["Cconint", [8752]],
                    ["ccups", [10828]],
                    ["ccupssm", [10832]],
                    ["Cdot", [266]],
                    ["cdot", [267]],
                    ["cedil", [184]],
                    ["Cedilla", [184]],
                    ["cemptyv", [10674]],
                    ["cent", [162]],
                    ["centerdot", [183]],
                    ["CenterDot", [183]],
                    ["cfr", [120096]],
                    ["Cfr", [8493]],
                    ["CHcy", [1063]],
                    ["chcy", [1095]],
                    ["check", [10003]],
                    ["checkmark", [10003]],
                    ["Chi", [935]],
                    ["chi", [967]],
                    ["circ", [710]],
                    ["circeq", [8791]],
                    ["circlearrowleft", [8634]],
                    ["circlearrowright", [8635]],
                    ["circledast", [8859]],
                    ["circledcirc", [8858]],
                    ["circleddash", [8861]],
                    ["CircleDot", [8857]],
                    ["circledR", [174]],
                    ["circledS", [9416]],
                    ["CircleMinus", [8854]],
                    ["CirclePlus", [8853]],
                    ["CircleTimes", [8855]],
                    ["cir", [9675]],
                    ["cirE", [10691]],
                    ["cire", [8791]],
                    ["cirfnint", [10768]],
                    ["cirmid", [10991]],
                    ["cirscir", [10690]],
                    ["ClockwiseContourIntegral", [8754]],
                    ["clubs", [9827]],
                    ["clubsuit", [9827]],
                    ["colon", [58]],
                    ["Colon", [8759]],
                    ["Colone", [10868]],
                    ["colone", [8788]],
                    ["coloneq", [8788]],
                    ["comma", [44]],
                    ["commat", [64]],
                    ["comp", [8705]],
                    ["compfn", [8728]],
                    ["complement", [8705]],
                    ["complexes", [8450]],
                    ["cong", [8773]],
                    ["congdot", [10861]],
                    ["Congruent", [8801]],
                    ["conint", [8750]],
                    ["Conint", [8751]],
                    ["ContourIntegral", [8750]],
                    ["copf", [120148]],
                    ["Copf", [8450]],
                    ["coprod", [8720]],
                    ["Coproduct", [8720]],
                    ["copy", [169]],
                    ["COPY", [169]],
                    ["copysr", [8471]],
                    ["CounterClockwiseContourIntegral", [8755]],
                    ["crarr", [8629]],
                    ["cross", [10007]],
                    ["Cross", [10799]],
                    ["Cscr", [119966]],
                    ["cscr", [119992]],
                    ["csub", [10959]],
                    ["csube", [10961]],
                    ["csup", [10960]],
                    ["csupe", [10962]],
                    ["ctdot", [8943]],
                    ["cudarrl", [10552]],
                    ["cudarrr", [10549]],
                    ["cuepr", [8926]],
                    ["cuesc", [8927]],
                    ["cularr", [8630]],
                    ["cularrp", [10557]],
                    ["cupbrcap", [10824]],
                    ["cupcap", [10822]],
                    ["CupCap", [8781]],
                    ["cup", [8746]],
                    ["Cup", [8915]],
                    ["cupcup", [10826]],
                    ["cupdot", [8845]],
                    ["cupor", [10821]],
                    ["cups", [8746, 65024]],
                    ["curarr", [8631]],
                    ["curarrm", [10556]],
                    ["curlyeqprec", [8926]],
                    ["curlyeqsucc", [8927]],
                    ["curlyvee", [8910]],
                    ["curlywedge", [8911]],
                    ["curren", [164]],
                    ["curvearrowleft", [8630]],
                    ["curvearrowright", [8631]],
                    ["cuvee", [8910]],
                    ["cuwed", [8911]],
                    ["cwconint", [8754]],
                    ["cwint", [8753]],
                    ["cylcty", [9005]],
                    ["dagger", [8224]],
                    ["Dagger", [8225]],
                    ["daleth", [8504]],
                    ["darr", [8595]],
                    ["Darr", [8609]],
                    ["dArr", [8659]],
                    ["dash", [8208]],
                    ["Dashv", [10980]],
                    ["dashv", [8867]],
                    ["dbkarow", [10511]],
                    ["dblac", [733]],
                    ["Dcaron", [270]],
                    ["dcaron", [271]],
                    ["Dcy", [1044]],
                    ["dcy", [1076]],
                    ["ddagger", [8225]],
                    ["ddarr", [8650]],
                    ["DD", [8517]],
                    ["dd", [8518]],
                    ["DDotrahd", [10513]],
                    ["ddotseq", [10871]],
                    ["deg", [176]],
                    ["Del", [8711]],
                    ["Delta", [916]],
                    ["delta", [948]],
                    ["demptyv", [10673]],
                    ["dfisht", [10623]],
                    ["Dfr", [120071]],
                    ["dfr", [120097]],
                    ["dHar", [10597]],
                    ["dharl", [8643]],
                    ["dharr", [8642]],
                    ["DiacriticalAcute", [180]],
                    ["DiacriticalDot", [729]],
                    ["DiacriticalDoubleAcute", [733]],
                    ["DiacriticalGrave", [96]],
                    ["DiacriticalTilde", [732]],
                    ["diam", [8900]],
                    ["diamond", [8900]],
                    ["Diamond", [8900]],
                    ["diamondsuit", [9830]],
                    ["diams", [9830]],
                    ["die", [168]],
                    ["DifferentialD", [8518]],
                    ["digamma", [989]],
                    ["disin", [8946]],
                    ["div", [247]],
                    ["divide", [247]],
                    ["divideontimes", [8903]],
                    ["divonx", [8903]],
                    ["DJcy", [1026]],
                    ["djcy", [1106]],
                    ["dlcorn", [8990]],
                    ["dlcrop", [8973]],
                    ["dollar", [36]],
                    ["Dopf", [120123]],
                    ["dopf", [120149]],
                    ["Dot", [168]],
                    ["dot", [729]],
                    ["DotDot", [8412]],
                    ["doteq", [8784]],
                    ["doteqdot", [8785]],
                    ["DotEqual", [8784]],
                    ["dotminus", [8760]],
                    ["dotplus", [8724]],
                    ["dotsquare", [8865]],
                    ["doublebarwedge", [8966]],
                    ["DoubleContourIntegral", [8751]],
                    ["DoubleDot", [168]],
                    ["DoubleDownArrow", [8659]],
                    ["DoubleLeftArrow", [8656]],
                    ["DoubleLeftRightArrow", [8660]],
                    ["DoubleLeftTee", [10980]],
                    ["DoubleLongLeftArrow", [10232]],
                    ["DoubleLongLeftRightArrow", [10234]],
                    ["DoubleLongRightArrow", [10233]],
                    ["DoubleRightArrow", [8658]],
                    ["DoubleRightTee", [8872]],
                    ["DoubleUpArrow", [8657]],
                    ["DoubleUpDownArrow", [8661]],
                    ["DoubleVerticalBar", [8741]],
                    ["DownArrowBar", [10515]],
                    ["downarrow", [8595]],
                    ["DownArrow", [8595]],
                    ["Downarrow", [8659]],
                    ["DownArrowUpArrow", [8693]],
                    ["DownBreve", [785]],
                    ["downdownarrows", [8650]],
                    ["downharpoonleft", [8643]],
                    ["downharpoonright", [8642]],
                    ["DownLeftRightVector", [10576]],
                    ["DownLeftTeeVector", [10590]],
                    ["DownLeftVectorBar", [10582]],
                    ["DownLeftVector", [8637]],
                    ["DownRightTeeVector", [10591]],
                    ["DownRightVectorBar", [10583]],
                    ["DownRightVector", [8641]],
                    ["DownTeeArrow", [8615]],
                    ["DownTee", [8868]],
                    ["drbkarow", [10512]],
                    ["drcorn", [8991]],
                    ["drcrop", [8972]],
                    ["Dscr", [119967]],
                    ["dscr", [119993]],
                    ["DScy", [1029]],
                    ["dscy", [1109]],
                    ["dsol", [10742]],
                    ["Dstrok", [272]],
                    ["dstrok", [273]],
                    ["dtdot", [8945]],
                    ["dtri", [9663]],
                    ["dtrif", [9662]],
                    ["duarr", [8693]],
                    ["duhar", [10607]],
                    ["dwangle", [10662]],
                    ["DZcy", [1039]],
                    ["dzcy", [1119]],
                    ["dzigrarr", [10239]],
                    ["Eacute", [201]],
                    ["eacute", [233]],
                    ["easter", [10862]],
                    ["Ecaron", [282]],
                    ["ecaron", [283]],
                    ["Ecirc", [202]],
                    ["ecirc", [234]],
                    ["ecir", [8790]],
                    ["ecolon", [8789]],
                    ["Ecy", [1069]],
                    ["ecy", [1101]],
                    ["eDDot", [10871]],
                    ["Edot", [278]],
                    ["edot", [279]],
                    ["eDot", [8785]],
                    ["ee", [8519]],
                    ["efDot", [8786]],
                    ["Efr", [120072]],
                    ["efr", [120098]],
                    ["eg", [10906]],
                    ["Egrave", [200]],
                    ["egrave", [232]],
                    ["egs", [10902]],
                    ["egsdot", [10904]],
                    ["el", [10905]],
                    ["Element", [8712]],
                    ["elinters", [9191]],
                    ["ell", [8467]],
                    ["els", [10901]],
                    ["elsdot", [10903]],
                    ["Emacr", [274]],
                    ["emacr", [275]],
                    ["empty", [8709]],
                    ["emptyset", [8709]],
                    ["EmptySmallSquare", [9723]],
                    ["emptyv", [8709]],
                    ["EmptyVerySmallSquare", [9643]],
                    ["emsp13", [8196]],
                    ["emsp14", [8197]],
                    ["emsp", [8195]],
                    ["ENG", [330]],
                    ["eng", [331]],
                    ["ensp", [8194]],
                    ["Eogon", [280]],
                    ["eogon", [281]],
                    ["Eopf", [120124]],
                    ["eopf", [120150]],
                    ["epar", [8917]],
                    ["eparsl", [10723]],
                    ["eplus", [10865]],
                    ["epsi", [949]],
                    ["Epsilon", [917]],
                    ["epsilon", [949]],
                    ["epsiv", [1013]],
                    ["eqcirc", [8790]],
                    ["eqcolon", [8789]],
                    ["eqsim", [8770]],
                    ["eqslantgtr", [10902]],
                    ["eqslantless", [10901]],
                    ["Equal", [10869]],
                    ["equals", [61]],
                    ["EqualTilde", [8770]],
                    ["equest", [8799]],
                    ["Equilibrium", [8652]],
                    ["equiv", [8801]],
                    ["equivDD", [10872]],
                    ["eqvparsl", [10725]],
                    ["erarr", [10609]],
                    ["erDot", [8787]],
                    ["escr", [8495]],
                    ["Escr", [8496]],
                    ["esdot", [8784]],
                    ["Esim", [10867]],
                    ["esim", [8770]],
                    ["Eta", [919]],
                    ["eta", [951]],
                    ["ETH", [208]],
                    ["eth", [240]],
                    ["Euml", [203]],
                    ["euml", [235]],
                    ["euro", [8364]],
                    ["excl", [33]],
                    ["exist", [8707]],
                    ["Exists", [8707]],
                    ["expectation", [8496]],
                    ["exponentiale", [8519]],
                    ["ExponentialE", [8519]],
                    ["fallingdotseq", [8786]],
                    ["Fcy", [1060]],
                    ["fcy", [1092]],
                    ["female", [9792]],
                    ["ffilig", [64259]],
                    ["fflig", [64256]],
                    ["ffllig", [64260]],
                    ["Ffr", [120073]],
                    ["ffr", [120099]],
                    ["filig", [64257]],
                    ["FilledSmallSquare", [9724]],
                    ["FilledVerySmallSquare", [9642]],
                    ["fjlig", [102, 106]],
                    ["flat", [9837]],
                    ["fllig", [64258]],
                    ["fltns", [9649]],
                    ["fnof", [402]],
                    ["Fopf", [120125]],
                    ["fopf", [120151]],
                    ["forall", [8704]],
                    ["ForAll", [8704]],
                    ["fork", [8916]],
                    ["forkv", [10969]],
                    ["Fouriertrf", [8497]],
                    ["fpartint", [10765]],
                    ["frac12", [189]],
                    ["frac13", [8531]],
                    ["frac14", [188]],
                    ["frac15", [8533]],
                    ["frac16", [8537]],
                    ["frac18", [8539]],
                    ["frac23", [8532]],
                    ["frac25", [8534]],
                    ["frac34", [190]],
                    ["frac35", [8535]],
                    ["frac38", [8540]],
                    ["frac45", [8536]],
                    ["frac56", [8538]],
                    ["frac58", [8541]],
                    ["frac78", [8542]],
                    ["frasl", [8260]],
                    ["frown", [8994]],
                    ["fscr", [119995]],
                    ["Fscr", [8497]],
                    ["gacute", [501]],
                    ["Gamma", [915]],
                    ["gamma", [947]],
                    ["Gammad", [988]],
                    ["gammad", [989]],
                    ["gap", [10886]],
                    ["Gbreve", [286]],
                    ["gbreve", [287]],
                    ["Gcedil", [290]],
                    ["Gcirc", [284]],
                    ["gcirc", [285]],
                    ["Gcy", [1043]],
                    ["gcy", [1075]],
                    ["Gdot", [288]],
                    ["gdot", [289]],
                    ["ge", [8805]],
                    ["gE", [8807]],
                    ["gEl", [10892]],
                    ["gel", [8923]],
                    ["geq", [8805]],
                    ["geqq", [8807]],
                    ["geqslant", [10878]],
                    ["gescc", [10921]],
                    ["ges", [10878]],
                    ["gesdot", [10880]],
                    ["gesdoto", [10882]],
                    ["gesdotol", [10884]],
                    ["gesl", [8923, 65024]],
                    ["gesles", [10900]],
                    ["Gfr", [120074]],
                    ["gfr", [120100]],
                    ["gg", [8811]],
                    ["Gg", [8921]],
                    ["ggg", [8921]],
                    ["gimel", [8503]],
                    ["GJcy", [1027]],
                    ["gjcy", [1107]],
                    ["gla", [10917]],
                    ["gl", [8823]],
                    ["glE", [10898]],
                    ["glj", [10916]],
                    ["gnap", [10890]],
                    ["gnapprox", [10890]],
                    ["gne", [10888]],
                    ["gnE", [8809]],
                    ["gneq", [10888]],
                    ["gneqq", [8809]],
                    ["gnsim", [8935]],
                    ["Gopf", [120126]],
                    ["gopf", [120152]],
                    ["grave", [96]],
                    ["GreaterEqual", [8805]],
                    ["GreaterEqualLess", [8923]],
                    ["GreaterFullEqual", [8807]],
                    ["GreaterGreater", [10914]],
                    ["GreaterLess", [8823]],
                    ["GreaterSlantEqual", [10878]],
                    ["GreaterTilde", [8819]],
                    ["Gscr", [119970]],
                    ["gscr", [8458]],
                    ["gsim", [8819]],
                    ["gsime", [10894]],
                    ["gsiml", [10896]],
                    ["gtcc", [10919]],
                    ["gtcir", [10874]],
                    ["gt", [62]],
                    ["GT", [62]],
                    ["Gt", [8811]],
                    ["gtdot", [8919]],
                    ["gtlPar", [10645]],
                    ["gtquest", [10876]],
                    ["gtrapprox", [10886]],
                    ["gtrarr", [10616]],
                    ["gtrdot", [8919]],
                    ["gtreqless", [8923]],
                    ["gtreqqless", [10892]],
                    ["gtrless", [8823]],
                    ["gtrsim", [8819]],
                    ["gvertneqq", [8809, 65024]],
                    ["gvnE", [8809, 65024]],
                    ["Hacek", [711]],
                    ["hairsp", [8202]],
                    ["half", [189]],
                    ["hamilt", [8459]],
                    ["HARDcy", [1066]],
                    ["hardcy", [1098]],
                    ["harrcir", [10568]],
                    ["harr", [8596]],
                    ["hArr", [8660]],
                    ["harrw", [8621]],
                    ["Hat", [94]],
                    ["hbar", [8463]],
                    ["Hcirc", [292]],
                    ["hcirc", [293]],
                    ["hearts", [9829]],
                    ["heartsuit", [9829]],
                    ["hellip", [8230]],
                    ["hercon", [8889]],
                    ["hfr", [120101]],
                    ["Hfr", [8460]],
                    ["HilbertSpace", [8459]],
                    ["hksearow", [10533]],
                    ["hkswarow", [10534]],
                    ["hoarr", [8703]],
                    ["homtht", [8763]],
                    ["hookleftarrow", [8617]],
                    ["hookrightarrow", [8618]],
                    ["hopf", [120153]],
                    ["Hopf", [8461]],
                    ["horbar", [8213]],
                    ["HorizontalLine", [9472]],
                    ["hscr", [119997]],
                    ["Hscr", [8459]],
                    ["hslash", [8463]],
                    ["Hstrok", [294]],
                    ["hstrok", [295]],
                    ["HumpDownHump", [8782]],
                    ["HumpEqual", [8783]],
                    ["hybull", [8259]],
                    ["hyphen", [8208]],
                    ["Iacute", [205]],
                    ["iacute", [237]],
                    ["ic", [8291]],
                    ["Icirc", [206]],
                    ["icirc", [238]],
                    ["Icy", [1048]],
                    ["icy", [1080]],
                    ["Idot", [304]],
                    ["IEcy", [1045]],
                    ["iecy", [1077]],
                    ["iexcl", [161]],
                    ["iff", [8660]],
                    ["ifr", [120102]],
                    ["Ifr", [8465]],
                    ["Igrave", [204]],
                    ["igrave", [236]],
                    ["ii", [8520]],
                    ["iiiint", [10764]],
                    ["iiint", [8749]],
                    ["iinfin", [10716]],
                    ["iiota", [8489]],
                    ["IJlig", [306]],
                    ["ijlig", [307]],
                    ["Imacr", [298]],
                    ["imacr", [299]],
                    ["image", [8465]],
                    ["ImaginaryI", [8520]],
                    ["imagline", [8464]],
                    ["imagpart", [8465]],
                    ["imath", [305]],
                    ["Im", [8465]],
                    ["imof", [8887]],
                    ["imped", [437]],
                    ["Implies", [8658]],
                    ["incare", [8453]],
                    ["in", [8712]],
                    ["infin", [8734]],
                    ["infintie", [10717]],
                    ["inodot", [305]],
                    ["intcal", [8890]],
                    ["int", [8747]],
                    ["Int", [8748]],
                    ["integers", [8484]],
                    ["Integral", [8747]],
                    ["intercal", [8890]],
                    ["Intersection", [8898]],
                    ["intlarhk", [10775]],
                    ["intprod", [10812]],
                    ["InvisibleComma", [8291]],
                    ["InvisibleTimes", [8290]],
                    ["IOcy", [1025]],
                    ["iocy", [1105]],
                    ["Iogon", [302]],
                    ["iogon", [303]],
                    ["Iopf", [120128]],
                    ["iopf", [120154]],
                    ["Iota", [921]],
                    ["iota", [953]],
                    ["iprod", [10812]],
                    ["iquest", [191]],
                    ["iscr", [119998]],
                    ["Iscr", [8464]],
                    ["isin", [8712]],
                    ["isindot", [8949]],
                    ["isinE", [8953]],
                    ["isins", [8948]],
                    ["isinsv", [8947]],
                    ["isinv", [8712]],
                    ["it", [8290]],
                    ["Itilde", [296]],
                    ["itilde", [297]],
                    ["Iukcy", [1030]],
                    ["iukcy", [1110]],
                    ["Iuml", [207]],
                    ["iuml", [239]],
                    ["Jcirc", [308]],
                    ["jcirc", [309]],
                    ["Jcy", [1049]],
                    ["jcy", [1081]],
                    ["Jfr", [120077]],
                    ["jfr", [120103]],
                    ["jmath", [567]],
                    ["Jopf", [120129]],
                    ["jopf", [120155]],
                    ["Jscr", [119973]],
                    ["jscr", [119999]],
                    ["Jsercy", [1032]],
                    ["jsercy", [1112]],
                    ["Jukcy", [1028]],
                    ["jukcy", [1108]],
                    ["Kappa", [922]],
                    ["kappa", [954]],
                    ["kappav", [1008]],
                    ["Kcedil", [310]],
                    ["kcedil", [311]],
                    ["Kcy", [1050]],
                    ["kcy", [1082]],
                    ["Kfr", [120078]],
                    ["kfr", [120104]],
                    ["kgreen", [312]],
                    ["KHcy", [1061]],
                    ["khcy", [1093]],
                    ["KJcy", [1036]],
                    ["kjcy", [1116]],
                    ["Kopf", [120130]],
                    ["kopf", [120156]],
                    ["Kscr", [119974]],
                    ["kscr", [120000]],
                    ["lAarr", [8666]],
                    ["Lacute", [313]],
                    ["lacute", [314]],
                    ["laemptyv", [10676]],
                    ["lagran", [8466]],
                    ["Lambda", [923]],
                    ["lambda", [955]],
                    ["lang", [10216]],
                    ["Lang", [10218]],
                    ["langd", [10641]],
                    ["langle", [10216]],
                    ["lap", [10885]],
                    ["Laplacetrf", [8466]],
                    ["laquo", [171]],
                    ["larrb", [8676]],
                    ["larrbfs", [10527]],
                    ["larr", [8592]],
                    ["Larr", [8606]],
                    ["lArr", [8656]],
                    ["larrfs", [10525]],
                    ["larrhk", [8617]],
                    ["larrlp", [8619]],
                    ["larrpl", [10553]],
                    ["larrsim", [10611]],
                    ["larrtl", [8610]],
                    ["latail", [10521]],
                    ["lAtail", [10523]],
                    ["lat", [10923]],
                    ["late", [10925]],
                    ["lates", [10925, 65024]],
                    ["lbarr", [10508]],
                    ["lBarr", [10510]],
                    ["lbbrk", [10098]],
                    ["lbrace", [123]],
                    ["lbrack", [91]],
                    ["lbrke", [10635]],
                    ["lbrksld", [10639]],
                    ["lbrkslu", [10637]],
                    ["Lcaron", [317]],
                    ["lcaron", [318]],
                    ["Lcedil", [315]],
                    ["lcedil", [316]],
                    ["lceil", [8968]],
                    ["lcub", [123]],
                    ["Lcy", [1051]],
                    ["lcy", [1083]],
                    ["ldca", [10550]],
                    ["ldquo", [8220]],
                    ["ldquor", [8222]],
                    ["ldrdhar", [10599]],
                    ["ldrushar", [10571]],
                    ["ldsh", [8626]],
                    ["le", [8804]],
                    ["lE", [8806]],
                    ["LeftAngleBracket", [10216]],
                    ["LeftArrowBar", [8676]],
                    ["leftarrow", [8592]],
                    ["LeftArrow", [8592]],
                    ["Leftarrow", [8656]],
                    ["LeftArrowRightArrow", [8646]],
                    ["leftarrowtail", [8610]],
                    ["LeftCeiling", [8968]],
                    ["LeftDoubleBracket", [10214]],
                    ["LeftDownTeeVector", [10593]],
                    ["LeftDownVectorBar", [10585]],
                    ["LeftDownVector", [8643]],
                    ["LeftFloor", [8970]],
                    ["leftharpoondown", [8637]],
                    ["leftharpoonup", [8636]],
                    ["leftleftarrows", [8647]],
                    ["leftrightarrow", [8596]],
                    ["LeftRightArrow", [8596]],
                    ["Leftrightarrow", [8660]],
                    ["leftrightarrows", [8646]],
                    ["leftrightharpoons", [8651]],
                    ["leftrightsquigarrow", [8621]],
                    ["LeftRightVector", [10574]],
                    ["LeftTeeArrow", [8612]],
                    ["LeftTee", [8867]],
                    ["LeftTeeVector", [10586]],
                    ["leftthreetimes", [8907]],
                    ["LeftTriangleBar", [10703]],
                    ["LeftTriangle", [8882]],
                    ["LeftTriangleEqual", [8884]],
                    ["LeftUpDownVector", [10577]],
                    ["LeftUpTeeVector", [10592]],
                    ["LeftUpVectorBar", [10584]],
                    ["LeftUpVector", [8639]],
                    ["LeftVectorBar", [10578]],
                    ["LeftVector", [8636]],
                    ["lEg", [10891]],
                    ["leg", [8922]],
                    ["leq", [8804]],
                    ["leqq", [8806]],
                    ["leqslant", [10877]],
                    ["lescc", [10920]],
                    ["les", [10877]],
                    ["lesdot", [10879]],
                    ["lesdoto", [10881]],
                    ["lesdotor", [10883]],
                    ["lesg", [8922, 65024]],
                    ["lesges", [10899]],
                    ["lessapprox", [10885]],
                    ["lessdot", [8918]],
                    ["lesseqgtr", [8922]],
                    ["lesseqqgtr", [10891]],
                    ["LessEqualGreater", [8922]],
                    ["LessFullEqual", [8806]],
                    ["LessGreater", [8822]],
                    ["lessgtr", [8822]],
                    ["LessLess", [10913]],
                    ["lesssim", [8818]],
                    ["LessSlantEqual", [10877]],
                    ["LessTilde", [8818]],
                    ["lfisht", [10620]],
                    ["lfloor", [8970]],
                    ["Lfr", [120079]],
                    ["lfr", [120105]],
                    ["lg", [8822]],
                    ["lgE", [10897]],
                    ["lHar", [10594]],
                    ["lhard", [8637]],
                    ["lharu", [8636]],
                    ["lharul", [10602]],
                    ["lhblk", [9604]],
                    ["LJcy", [1033]],
                    ["ljcy", [1113]],
                    ["llarr", [8647]],
                    ["ll", [8810]],
                    ["Ll", [8920]],
                    ["llcorner", [8990]],
                    ["Lleftarrow", [8666]],
                    ["llhard", [10603]],
                    ["lltri", [9722]],
                    ["Lmidot", [319]],
                    ["lmidot", [320]],
                    ["lmoustache", [9136]],
                    ["lmoust", [9136]],
                    ["lnap", [10889]],
                    ["lnapprox", [10889]],
                    ["lne", [10887]],
                    ["lnE", [8808]],
                    ["lneq", [10887]],
                    ["lneqq", [8808]],
                    ["lnsim", [8934]],
                    ["loang", [10220]],
                    ["loarr", [8701]],
                    ["lobrk", [10214]],
                    ["longleftarrow", [10229]],
                    ["LongLeftArrow", [10229]],
                    ["Longleftarrow", [10232]],
                    ["longleftrightarrow", [10231]],
                    ["LongLeftRightArrow", [10231]],
                    ["Longleftrightarrow", [10234]],
                    ["longmapsto", [10236]],
                    ["longrightarrow", [10230]],
                    ["LongRightArrow", [10230]],
                    ["Longrightarrow", [10233]],
                    ["looparrowleft", [8619]],
                    ["looparrowright", [8620]],
                    ["lopar", [10629]],
                    ["Lopf", [120131]],
                    ["lopf", [120157]],
                    ["loplus", [10797]],
                    ["lotimes", [10804]],
                    ["lowast", [8727]],
                    ["lowbar", [95]],
                    ["LowerLeftArrow", [8601]],
                    ["LowerRightArrow", [8600]],
                    ["loz", [9674]],
                    ["lozenge", [9674]],
                    ["lozf", [10731]],
                    ["lpar", [40]],
                    ["lparlt", [10643]],
                    ["lrarr", [8646]],
                    ["lrcorner", [8991]],
                    ["lrhar", [8651]],
                    ["lrhard", [10605]],
                    ["lrm", [8206]],
                    ["lrtri", [8895]],
                    ["lsaquo", [8249]],
                    ["lscr", [120001]],
                    ["Lscr", [8466]],
                    ["lsh", [8624]],
                    ["Lsh", [8624]],
                    ["lsim", [8818]],
                    ["lsime", [10893]],
                    ["lsimg", [10895]],
                    ["lsqb", [91]],
                    ["lsquo", [8216]],
                    ["lsquor", [8218]],
                    ["Lstrok", [321]],
                    ["lstrok", [322]],
                    ["ltcc", [10918]],
                    ["ltcir", [10873]],
                    ["lt", [60]],
                    ["LT", [60]],
                    ["Lt", [8810]],
                    ["ltdot", [8918]],
                    ["lthree", [8907]],
                    ["ltimes", [8905]],
                    ["ltlarr", [10614]],
                    ["ltquest", [10875]],
                    ["ltri", [9667]],
                    ["ltrie", [8884]],
                    ["ltrif", [9666]],
                    ["ltrPar", [10646]],
                    ["lurdshar", [10570]],
                    ["luruhar", [10598]],
                    ["lvertneqq", [8808, 65024]],
                    ["lvnE", [8808, 65024]],
                    ["macr", [175]],
                    ["male", [9794]],
                    ["malt", [10016]],
                    ["maltese", [10016]],
                    ["Map", [10501]],
                    ["map", [8614]],
                    ["mapsto", [8614]],
                    ["mapstodown", [8615]],
                    ["mapstoleft", [8612]],
                    ["mapstoup", [8613]],
                    ["marker", [9646]],
                    ["mcomma", [10793]],
                    ["Mcy", [1052]],
                    ["mcy", [1084]],
                    ["mdash", [8212]],
                    ["mDDot", [8762]],
                    ["measuredangle", [8737]],
                    ["MediumSpace", [8287]],
                    ["Mellintrf", [8499]],
                    ["Mfr", [120080]],
                    ["mfr", [120106]],
                    ["mho", [8487]],
                    ["micro", [181]],
                    ["midast", [42]],
                    ["midcir", [10992]],
                    ["mid", [8739]],
                    ["middot", [183]],
                    ["minusb", [8863]],
                    ["minus", [8722]],
                    ["minusd", [8760]],
                    ["minusdu", [10794]],
                    ["MinusPlus", [8723]],
                    ["mlcp", [10971]],
                    ["mldr", [8230]],
                    ["mnplus", [8723]],
                    ["models", [8871]],
                    ["Mopf", [120132]],
                    ["mopf", [120158]],
                    ["mp", [8723]],
                    ["mscr", [120002]],
                    ["Mscr", [8499]],
                    ["mstpos", [8766]],
                    ["Mu", [924]],
                    ["mu", [956]],
                    ["multimap", [8888]],
                    ["mumap", [8888]],
                    ["nabla", [8711]],
                    ["Nacute", [323]],
                    ["nacute", [324]],
                    ["nang", [8736, 8402]],
                    ["nap", [8777]],
                    ["napE", [10864, 824]],
                    ["napid", [8779, 824]],
                    ["napos", [329]],
                    ["napprox", [8777]],
                    ["natural", [9838]],
                    ["naturals", [8469]],
                    ["natur", [9838]],
                    ["nbsp", [160]],
                    ["nbump", [8782, 824]],
                    ["nbumpe", [8783, 824]],
                    ["ncap", [10819]],
                    ["Ncaron", [327]],
                    ["ncaron", [328]],
                    ["Ncedil", [325]],
                    ["ncedil", [326]],
                    ["ncong", [8775]],
                    ["ncongdot", [10861, 824]],
                    ["ncup", [10818]],
                    ["Ncy", [1053]],
                    ["ncy", [1085]],
                    ["ndash", [8211]],
                    ["nearhk", [10532]],
                    ["nearr", [8599]],
                    ["neArr", [8663]],
                    ["nearrow", [8599]],
                    ["ne", [8800]],
                    ["nedot", [8784, 824]],
                    ["NegativeMediumSpace", [8203]],
                    ["NegativeThickSpace", [8203]],
                    ["NegativeThinSpace", [8203]],
                    ["NegativeVeryThinSpace", [8203]],
                    ["nequiv", [8802]],
                    ["nesear", [10536]],
                    ["nesim", [8770, 824]],
                    ["NestedGreaterGreater", [8811]],
                    ["NestedLessLess", [8810]],
                    ["nexist", [8708]],
                    ["nexists", [8708]],
                    ["Nfr", [120081]],
                    ["nfr", [120107]],
                    ["ngE", [8807, 824]],
                    ["nge", [8817]],
                    ["ngeq", [8817]],
                    ["ngeqq", [8807, 824]],
                    ["ngeqslant", [10878, 824]],
                    ["nges", [10878, 824]],
                    ["nGg", [8921, 824]],
                    ["ngsim", [8821]],
                    ["nGt", [8811, 8402]],
                    ["ngt", [8815]],
                    ["ngtr", [8815]],
                    ["nGtv", [8811, 824]],
                    ["nharr", [8622]],
                    ["nhArr", [8654]],
                    ["nhpar", [10994]],
                    ["ni", [8715]],
                    ["nis", [8956]],
                    ["nisd", [8954]],
                    ["niv", [8715]],
                    ["NJcy", [1034]],
                    ["njcy", [1114]],
                    ["nlarr", [8602]],
                    ["nlArr", [8653]],
                    ["nldr", [8229]],
                    ["nlE", [8806, 824]],
                    ["nle", [8816]],
                    ["nleftarrow", [8602]],
                    ["nLeftarrow", [8653]],
                    ["nleftrightarrow", [8622]],
                    ["nLeftrightarrow", [8654]],
                    ["nleq", [8816]],
                    ["nleqq", [8806, 824]],
                    ["nleqslant", [10877, 824]],
                    ["nles", [10877, 824]],
                    ["nless", [8814]],
                    ["nLl", [8920, 824]],
                    ["nlsim", [8820]],
                    ["nLt", [8810, 8402]],
                    ["nlt", [8814]],
                    ["nltri", [8938]],
                    ["nltrie", [8940]],
                    ["nLtv", [8810, 824]],
                    ["nmid", [8740]],
                    ["NoBreak", [8288]],
                    ["NonBreakingSpace", [160]],
                    ["nopf", [120159]],
                    ["Nopf", [8469]],
                    ["Not", [10988]],
                    ["not", [172]],
                    ["NotCongruent", [8802]],
                    ["NotCupCap", [8813]],
                    ["NotDoubleVerticalBar", [8742]],
                    ["NotElement", [8713]],
                    ["NotEqual", [8800]],
                    ["NotEqualTilde", [8770, 824]],
                    ["NotExists", [8708]],
                    ["NotGreater", [8815]],
                    ["NotGreaterEqual", [8817]],
                    ["NotGreaterFullEqual", [8807, 824]],
                    ["NotGreaterGreater", [8811, 824]],
                    ["NotGreaterLess", [8825]],
                    ["NotGreaterSlantEqual", [10878, 824]],
                    ["NotGreaterTilde", [8821]],
                    ["NotHumpDownHump", [8782, 824]],
                    ["NotHumpEqual", [8783, 824]],
                    ["notin", [8713]],
                    ["notindot", [8949, 824]],
                    ["notinE", [8953, 824]],
                    ["notinva", [8713]],
                    ["notinvb", [8951]],
                    ["notinvc", [8950]],
                    ["NotLeftTriangleBar", [10703, 824]],
                    ["NotLeftTriangle", [8938]],
                    ["NotLeftTriangleEqual", [8940]],
                    ["NotLess", [8814]],
                    ["NotLessEqual", [8816]],
                    ["NotLessGreater", [8824]],
                    ["NotLessLess", [8810, 824]],
                    ["NotLessSlantEqual", [10877, 824]],
                    ["NotLessTilde", [8820]],
                    ["NotNestedGreaterGreater", [10914, 824]],
                    ["NotNestedLessLess", [10913, 824]],
                    ["notni", [8716]],
                    ["notniva", [8716]],
                    ["notnivb", [8958]],
                    ["notnivc", [8957]],
                    ["NotPrecedes", [8832]],
                    ["NotPrecedesEqual", [10927, 824]],
                    ["NotPrecedesSlantEqual", [8928]],
                    ["NotReverseElement", [8716]],
                    ["NotRightTriangleBar", [10704, 824]],
                    ["NotRightTriangle", [8939]],
                    ["NotRightTriangleEqual", [8941]],
                    ["NotSquareSubset", [8847, 824]],
                    ["NotSquareSubsetEqual", [8930]],
                    ["NotSquareSuperset", [8848, 824]],
                    ["NotSquareSupersetEqual", [8931]],
                    ["NotSubset", [8834, 8402]],
                    ["NotSubsetEqual", [8840]],
                    ["NotSucceeds", [8833]],
                    ["NotSucceedsEqual", [10928, 824]],
                    ["NotSucceedsSlantEqual", [8929]],
                    ["NotSucceedsTilde", [8831, 824]],
                    ["NotSuperset", [8835, 8402]],
                    ["NotSupersetEqual", [8841]],
                    ["NotTilde", [8769]],
                    ["NotTildeEqual", [8772]],
                    ["NotTildeFullEqual", [8775]],
                    ["NotTildeTilde", [8777]],
                    ["NotVerticalBar", [8740]],
                    ["nparallel", [8742]],
                    ["npar", [8742]],
                    ["nparsl", [11005, 8421]],
                    ["npart", [8706, 824]],
                    ["npolint", [10772]],
                    ["npr", [8832]],
                    ["nprcue", [8928]],
                    ["nprec", [8832]],
                    ["npreceq", [10927, 824]],
                    ["npre", [10927, 824]],
                    ["nrarrc", [10547, 824]],
                    ["nrarr", [8603]],
                    ["nrArr", [8655]],
                    ["nrarrw", [8605, 824]],
                    ["nrightarrow", [8603]],
                    ["nRightarrow", [8655]],
                    ["nrtri", [8939]],
                    ["nrtrie", [8941]],
                    ["nsc", [8833]],
                    ["nsccue", [8929]],
                    ["nsce", [10928, 824]],
                    ["Nscr", [119977]],
                    ["nscr", [120003]],
                    ["nshortmid", [8740]],
                    ["nshortparallel", [8742]],
                    ["nsim", [8769]],
                    ["nsime", [8772]],
                    ["nsimeq", [8772]],
                    ["nsmid", [8740]],
                    ["nspar", [8742]],
                    ["nsqsube", [8930]],
                    ["nsqsupe", [8931]],
                    ["nsub", [8836]],
                    ["nsubE", [10949, 824]],
                    ["nsube", [8840]],
                    ["nsubset", [8834, 8402]],
                    ["nsubseteq", [8840]],
                    ["nsubseteqq", [10949, 824]],
                    ["nsucc", [8833]],
                    ["nsucceq", [10928, 824]],
                    ["nsup", [8837]],
                    ["nsupE", [10950, 824]],
                    ["nsupe", [8841]],
                    ["nsupset", [8835, 8402]],
                    ["nsupseteq", [8841]],
                    ["nsupseteqq", [10950, 824]],
                    ["ntgl", [8825]],
                    ["Ntilde", [209]],
                    ["ntilde", [241]],
                    ["ntlg", [8824]],
                    ["ntriangleleft", [8938]],
                    ["ntrianglelefteq", [8940]],
                    ["ntriangleright", [8939]],
                    ["ntrianglerighteq", [8941]],
                    ["Nu", [925]],
                    ["nu", [957]],
                    ["num", [35]],
                    ["numero", [8470]],
                    ["numsp", [8199]],
                    ["nvap", [8781, 8402]],
                    ["nvdash", [8876]],
                    ["nvDash", [8877]],
                    ["nVdash", [8878]],
                    ["nVDash", [8879]],
                    ["nvge", [8805, 8402]],
                    ["nvgt", [62, 8402]],
                    ["nvHarr", [10500]],
                    ["nvinfin", [10718]],
                    ["nvlArr", [10498]],
                    ["nvle", [8804, 8402]],
                    ["nvlt", [60, 8402]],
                    ["nvltrie", [8884, 8402]],
                    ["nvrArr", [10499]],
                    ["nvrtrie", [8885, 8402]],
                    ["nvsim", [8764, 8402]],
                    ["nwarhk", [10531]],
                    ["nwarr", [8598]],
                    ["nwArr", [8662]],
                    ["nwarrow", [8598]],
                    ["nwnear", [10535]],
                    ["Oacute", [211]],
                    ["oacute", [243]],
                    ["oast", [8859]],
                    ["Ocirc", [212]],
                    ["ocirc", [244]],
                    ["ocir", [8858]],
                    ["Ocy", [1054]],
                    ["ocy", [1086]],
                    ["odash", [8861]],
                    ["Odblac", [336]],
                    ["odblac", [337]],
                    ["odiv", [10808]],
                    ["odot", [8857]],
                    ["odsold", [10684]],
                    ["OElig", [338]],
                    ["oelig", [339]],
                    ["ofcir", [10687]],
                    ["Ofr", [120082]],
                    ["ofr", [120108]],
                    ["ogon", [731]],
                    ["Ograve", [210]],
                    ["ograve", [242]],
                    ["ogt", [10689]],
                    ["ohbar", [10677]],
                    ["ohm", [937]],
                    ["oint", [8750]],
                    ["olarr", [8634]],
                    ["olcir", [10686]],
                    ["olcross", [10683]],
                    ["oline", [8254]],
                    ["olt", [10688]],
                    ["Omacr", [332]],
                    ["omacr", [333]],
                    ["Omega", [937]],
                    ["omega", [969]],
                    ["Omicron", [927]],
                    ["omicron", [959]],
                    ["omid", [10678]],
                    ["ominus", [8854]],
                    ["Oopf", [120134]],
                    ["oopf", [120160]],
                    ["opar", [10679]],
                    ["OpenCurlyDoubleQuote", [8220]],
                    ["OpenCurlyQuote", [8216]],
                    ["operp", [10681]],
                    ["oplus", [8853]],
                    ["orarr", [8635]],
                    ["Or", [10836]],
                    ["or", [8744]],
                    ["ord", [10845]],
                    ["order", [8500]],
                    ["orderof", [8500]],
                    ["ordf", [170]],
                    ["ordm", [186]],
                    ["origof", [8886]],
                    ["oror", [10838]],
                    ["orslope", [10839]],
                    ["orv", [10843]],
                    ["oS", [9416]],
                    ["Oscr", [119978]],
                    ["oscr", [8500]],
                    ["Oslash", [216]],
                    ["oslash", [248]],
                    ["osol", [8856]],
                    ["Otilde", [213]],
                    ["otilde", [245]],
                    ["otimesas", [10806]],
                    ["Otimes", [10807]],
                    ["otimes", [8855]],
                    ["Ouml", [214]],
                    ["ouml", [246]],
                    ["ovbar", [9021]],
                    ["OverBar", [8254]],
                    ["OverBrace", [9182]],
                    ["OverBracket", [9140]],
                    ["OverParenthesis", [9180]],
                    ["para", [182]],
                    ["parallel", [8741]],
                    ["par", [8741]],
                    ["parsim", [10995]],
                    ["parsl", [11005]],
                    ["part", [8706]],
                    ["PartialD", [8706]],
                    ["Pcy", [1055]],
                    ["pcy", [1087]],
                    ["percnt", [37]],
                    ["period", [46]],
                    ["permil", [8240]],
                    ["perp", [8869]],
                    ["pertenk", [8241]],
                    ["Pfr", [120083]],
                    ["pfr", [120109]],
                    ["Phi", [934]],
                    ["phi", [966]],
                    ["phiv", [981]],
                    ["phmmat", [8499]],
                    ["phone", [9742]],
                    ["Pi", [928]],
                    ["pi", [960]],
                    ["pitchfork", [8916]],
                    ["piv", [982]],
                    ["planck", [8463]],
                    ["planckh", [8462]],
                    ["plankv", [8463]],
                    ["plusacir", [10787]],
                    ["plusb", [8862]],
                    ["pluscir", [10786]],
                    ["plus", [43]],
                    ["plusdo", [8724]],
                    ["plusdu", [10789]],
                    ["pluse", [10866]],
                    ["PlusMinus", [177]],
                    ["plusmn", [177]],
                    ["plussim", [10790]],
                    ["plustwo", [10791]],
                    ["pm", [177]],
                    ["Poincareplane", [8460]],
                    ["pointint", [10773]],
                    ["popf", [120161]],
                    ["Popf", [8473]],
                    ["pound", [163]],
                    ["prap", [10935]],
                    ["Pr", [10939]],
                    ["pr", [8826]],
                    ["prcue", [8828]],
                    ["precapprox", [10935]],
                    ["prec", [8826]],
                    ["preccurlyeq", [8828]],
                    ["Precedes", [8826]],
                    ["PrecedesEqual", [10927]],
                    ["PrecedesSlantEqual", [8828]],
                    ["PrecedesTilde", [8830]],
                    ["preceq", [10927]],
                    ["precnapprox", [10937]],
                    ["precneqq", [10933]],
                    ["precnsim", [8936]],
                    ["pre", [10927]],
                    ["prE", [10931]],
                    ["precsim", [8830]],
                    ["prime", [8242]],
                    ["Prime", [8243]],
                    ["primes", [8473]],
                    ["prnap", [10937]],
                    ["prnE", [10933]],
                    ["prnsim", [8936]],
                    ["prod", [8719]],
                    ["Product", [8719]],
                    ["profalar", [9006]],
                    ["profline", [8978]],
                    ["profsurf", [8979]],
                    ["prop", [8733]],
                    ["Proportional", [8733]],
                    ["Proportion", [8759]],
                    ["propto", [8733]],
                    ["prsim", [8830]],
                    ["prurel", [8880]],
                    ["Pscr", [119979]],
                    ["pscr", [120005]],
                    ["Psi", [936]],
                    ["psi", [968]],
                    ["puncsp", [8200]],
                    ["Qfr", [120084]],
                    ["qfr", [120110]],
                    ["qint", [10764]],
                    ["qopf", [120162]],
                    ["Qopf", [8474]],
                    ["qprime", [8279]],
                    ["Qscr", [119980]],
                    ["qscr", [120006]],
                    ["quaternions", [8461]],
                    ["quatint", [10774]],
                    ["quest", [63]],
                    ["questeq", [8799]],
                    ["quot", [34]],
                    ["QUOT", [34]],
                    ["rAarr", [8667]],
                    ["race", [8765, 817]],
                    ["Racute", [340]],
                    ["racute", [341]],
                    ["radic", [8730]],
                    ["raemptyv", [10675]],
                    ["rang", [10217]],
                    ["Rang", [10219]],
                    ["rangd", [10642]],
                    ["range", [10661]],
                    ["rangle", [10217]],
                    ["raquo", [187]],
                    ["rarrap", [10613]],
                    ["rarrb", [8677]],
                    ["rarrbfs", [10528]],
                    ["rarrc", [10547]],
                    ["rarr", [8594]],
                    ["Rarr", [8608]],
                    ["rArr", [8658]],
                    ["rarrfs", [10526]],
                    ["rarrhk", [8618]],
                    ["rarrlp", [8620]],
                    ["rarrpl", [10565]],
                    ["rarrsim", [10612]],
                    ["Rarrtl", [10518]],
                    ["rarrtl", [8611]],
                    ["rarrw", [8605]],
                    ["ratail", [10522]],
                    ["rAtail", [10524]],
                    ["ratio", [8758]],
                    ["rationals", [8474]],
                    ["rbarr", [10509]],
                    ["rBarr", [10511]],
                    ["RBarr", [10512]],
                    ["rbbrk", [10099]],
                    ["rbrace", [125]],
                    ["rbrack", [93]],
                    ["rbrke", [10636]],
                    ["rbrksld", [10638]],
                    ["rbrkslu", [10640]],
                    ["Rcaron", [344]],
                    ["rcaron", [345]],
                    ["Rcedil", [342]],
                    ["rcedil", [343]],
                    ["rceil", [8969]],
                    ["rcub", [125]],
                    ["Rcy", [1056]],
                    ["rcy", [1088]],
                    ["rdca", [10551]],
                    ["rdldhar", [10601]],
                    ["rdquo", [8221]],
                    ["rdquor", [8221]],
                    ["CloseCurlyDoubleQuote", [8221]],
                    ["rdsh", [8627]],
                    ["real", [8476]],
                    ["realine", [8475]],
                    ["realpart", [8476]],
                    ["reals", [8477]],
                    ["Re", [8476]],
                    ["rect", [9645]],
                    ["reg", [174]],
                    ["REG", [174]],
                    ["ReverseElement", [8715]],
                    ["ReverseEquilibrium", [8651]],
                    ["ReverseUpEquilibrium", [10607]],
                    ["rfisht", [10621]],
                    ["rfloor", [8971]],
                    ["rfr", [120111]],
                    ["Rfr", [8476]],
                    ["rHar", [10596]],
                    ["rhard", [8641]],
                    ["rharu", [8640]],
                    ["rharul", [10604]],
                    ["Rho", [929]],
                    ["rho", [961]],
                    ["rhov", [1009]],
                    ["RightAngleBracket", [10217]],
                    ["RightArrowBar", [8677]],
                    ["rightarrow", [8594]],
                    ["RightArrow", [8594]],
                    ["Rightarrow", [8658]],
                    ["RightArrowLeftArrow", [8644]],
                    ["rightarrowtail", [8611]],
                    ["RightCeiling", [8969]],
                    ["RightDoubleBracket", [10215]],
                    ["RightDownTeeVector", [10589]],
                    ["RightDownVectorBar", [10581]],
                    ["RightDownVector", [8642]],
                    ["RightFloor", [8971]],
                    ["rightharpoondown", [8641]],
                    ["rightharpoonup", [8640]],
                    ["rightleftarrows", [8644]],
                    ["rightleftharpoons", [8652]],
                    ["rightrightarrows", [8649]],
                    ["rightsquigarrow", [8605]],
                    ["RightTeeArrow", [8614]],
                    ["RightTee", [8866]],
                    ["RightTeeVector", [10587]],
                    ["rightthreetimes", [8908]],
                    ["RightTriangleBar", [10704]],
                    ["RightTriangle", [8883]],
                    ["RightTriangleEqual", [8885]],
                    ["RightUpDownVector", [10575]],
                    ["RightUpTeeVector", [10588]],
                    ["RightUpVectorBar", [10580]],
                    ["RightUpVector", [8638]],
                    ["RightVectorBar", [10579]],
                    ["RightVector", [8640]],
                    ["ring", [730]],
                    ["risingdotseq", [8787]],
                    ["rlarr", [8644]],
                    ["rlhar", [8652]],
                    ["rlm", [8207]],
                    ["rmoustache", [9137]],
                    ["rmoust", [9137]],
                    ["rnmid", [10990]],
                    ["roang", [10221]],
                    ["roarr", [8702]],
                    ["robrk", [10215]],
                    ["ropar", [10630]],
                    ["ropf", [120163]],
                    ["Ropf", [8477]],
                    ["roplus", [10798]],
                    ["rotimes", [10805]],
                    ["RoundImplies", [10608]],
                    ["rpar", [41]],
                    ["rpargt", [10644]],
                    ["rppolint", [10770]],
                    ["rrarr", [8649]],
                    ["Rrightarrow", [8667]],
                    ["rsaquo", [8250]],
                    ["rscr", [120007]],
                    ["Rscr", [8475]],
                    ["rsh", [8625]],
                    ["Rsh", [8625]],
                    ["rsqb", [93]],
                    ["rsquo", [8217]],
                    ["rsquor", [8217]],
                    ["CloseCurlyQuote", [8217]],
                    ["rthree", [8908]],
                    ["rtimes", [8906]],
                    ["rtri", [9657]],
                    ["rtrie", [8885]],
                    ["rtrif", [9656]],
                    ["rtriltri", [10702]],
                    ["RuleDelayed", [10740]],
                    ["ruluhar", [10600]],
                    ["rx", [8478]],
                    ["Sacute", [346]],
                    ["sacute", [347]],
                    ["sbquo", [8218]],
                    ["scap", [10936]],
                    ["Scaron", [352]],
                    ["scaron", [353]],
                    ["Sc", [10940]],
                    ["sc", [8827]],
                    ["sccue", [8829]],
                    ["sce", [10928]],
                    ["scE", [10932]],
                    ["Scedil", [350]],
                    ["scedil", [351]],
                    ["Scirc", [348]],
                    ["scirc", [349]],
                    ["scnap", [10938]],
                    ["scnE", [10934]],
                    ["scnsim", [8937]],
                    ["scpolint", [10771]],
                    ["scsim", [8831]],
                    ["Scy", [1057]],
                    ["scy", [1089]],
                    ["sdotb", [8865]],
                    ["sdot", [8901]],
                    ["sdote", [10854]],
                    ["searhk", [10533]],
                    ["searr", [8600]],
                    ["seArr", [8664]],
                    ["searrow", [8600]],
                    ["sect", [167]],
                    ["semi", [59]],
                    ["seswar", [10537]],
                    ["setminus", [8726]],
                    ["setmn", [8726]],
                    ["sext", [10038]],
                    ["Sfr", [120086]],
                    ["sfr", [120112]],
                    ["sfrown", [8994]],
                    ["sharp", [9839]],
                    ["SHCHcy", [1065]],
                    ["shchcy", [1097]],
                    ["SHcy", [1064]],
                    ["shcy", [1096]],
                    ["ShortDownArrow", [8595]],
                    ["ShortLeftArrow", [8592]],
                    ["shortmid", [8739]],
                    ["shortparallel", [8741]],
                    ["ShortRightArrow", [8594]],
                    ["ShortUpArrow", [8593]],
                    ["shy", [173]],
                    ["Sigma", [931]],
                    ["sigma", [963]],
                    ["sigmaf", [962]],
                    ["sigmav", [962]],
                    ["sim", [8764]],
                    ["simdot", [10858]],
                    ["sime", [8771]],
                    ["simeq", [8771]],
                    ["simg", [10910]],
                    ["simgE", [10912]],
                    ["siml", [10909]],
                    ["simlE", [10911]],
                    ["simne", [8774]],
                    ["simplus", [10788]],
                    ["simrarr", [10610]],
                    ["slarr", [8592]],
                    ["SmallCircle", [8728]],
                    ["smallsetminus", [8726]],
                    ["smashp", [10803]],
                    ["smeparsl", [10724]],
                    ["smid", [8739]],
                    ["smile", [8995]],
                    ["smt", [10922]],
                    ["smte", [10924]],
                    ["smtes", [10924, 65024]],
                    ["SOFTcy", [1068]],
                    ["softcy", [1100]],
                    ["solbar", [9023]],
                    ["solb", [10692]],
                    ["sol", [47]],
                    ["Sopf", [120138]],
                    ["sopf", [120164]],
                    ["spades", [9824]],
                    ["spadesuit", [9824]],
                    ["spar", [8741]],
                    ["sqcap", [8851]],
                    ["sqcaps", [8851, 65024]],
                    ["sqcup", [8852]],
                    ["sqcups", [8852, 65024]],
                    ["Sqrt", [8730]],
                    ["sqsub", [8847]],
                    ["sqsube", [8849]],
                    ["sqsubset", [8847]],
                    ["sqsubseteq", [8849]],
                    ["sqsup", [8848]],
                    ["sqsupe", [8850]],
                    ["sqsupset", [8848]],
                    ["sqsupseteq", [8850]],
                    ["square", [9633]],
                    ["Square", [9633]],
                    ["SquareIntersection", [8851]],
                    ["SquareSubset", [8847]],
                    ["SquareSubsetEqual", [8849]],
                    ["SquareSuperset", [8848]],
                    ["SquareSupersetEqual", [8850]],
                    ["SquareUnion", [8852]],
                    ["squarf", [9642]],
                    ["squ", [9633]],
                    ["squf", [9642]],
                    ["srarr", [8594]],
                    ["Sscr", [119982]],
                    ["sscr", [120008]],
                    ["ssetmn", [8726]],
                    ["ssmile", [8995]],
                    ["sstarf", [8902]],
                    ["Star", [8902]],
                    ["star", [9734]],
                    ["starf", [9733]],
                    ["straightepsilon", [1013]],
                    ["straightphi", [981]],
                    ["strns", [175]],
                    ["sub", [8834]],
                    ["Sub", [8912]],
                    ["subdot", [10941]],
                    ["subE", [10949]],
                    ["sube", [8838]],
                    ["subedot", [10947]],
                    ["submult", [10945]],
                    ["subnE", [10955]],
                    ["subne", [8842]],
                    ["subplus", [10943]],
                    ["subrarr", [10617]],
                    ["subset", [8834]],
                    ["Subset", [8912]],
                    ["subseteq", [8838]],
                    ["subseteqq", [10949]],
                    ["SubsetEqual", [8838]],
                    ["subsetneq", [8842]],
                    ["subsetneqq", [10955]],
                    ["subsim", [10951]],
                    ["subsub", [10965]],
                    ["subsup", [10963]],
                    ["succapprox", [10936]],
                    ["succ", [8827]],
                    ["succcurlyeq", [8829]],
                    ["Succeeds", [8827]],
                    ["SucceedsEqual", [10928]],
                    ["SucceedsSlantEqual", [8829]],
                    ["SucceedsTilde", [8831]],
                    ["succeq", [10928]],
                    ["succnapprox", [10938]],
                    ["succneqq", [10934]],
                    ["succnsim", [8937]],
                    ["succsim", [8831]],
                    ["SuchThat", [8715]],
                    ["sum", [8721]],
                    ["Sum", [8721]],
                    ["sung", [9834]],
                    ["sup1", [185]],
                    ["sup2", [178]],
                    ["sup3", [179]],
                    ["sup", [8835]],
                    ["Sup", [8913]],
                    ["supdot", [10942]],
                    ["supdsub", [10968]],
                    ["supE", [10950]],
                    ["supe", [8839]],
                    ["supedot", [10948]],
                    ["Superset", [8835]],
                    ["SupersetEqual", [8839]],
                    ["suphsol", [10185]],
                    ["suphsub", [10967]],
                    ["suplarr", [10619]],
                    ["supmult", [10946]],
                    ["supnE", [10956]],
                    ["supne", [8843]],
                    ["supplus", [10944]],
                    ["supset", [8835]],
                    ["Supset", [8913]],
                    ["supseteq", [8839]],
                    ["supseteqq", [10950]],
                    ["supsetneq", [8843]],
                    ["supsetneqq", [10956]],
                    ["supsim", [10952]],
                    ["supsub", [10964]],
                    ["supsup", [10966]],
                    ["swarhk", [10534]],
                    ["swarr", [8601]],
                    ["swArr", [8665]],
                    ["swarrow", [8601]],
                    ["swnwar", [10538]],
                    ["szlig", [223]],
                    ["Tab", [9]],
                    ["target", [8982]],
                    ["Tau", [932]],
                    ["tau", [964]],
                    ["tbrk", [9140]],
                    ["Tcaron", [356]],
                    ["tcaron", [357]],
                    ["Tcedil", [354]],
                    ["tcedil", [355]],
                    ["Tcy", [1058]],
                    ["tcy", [1090]],
                    ["tdot", [8411]],
                    ["telrec", [8981]],
                    ["Tfr", [120087]],
                    ["tfr", [120113]],
                    ["there4", [8756]],
                    ["therefore", [8756]],
                    ["Therefore", [8756]],
                    ["Theta", [920]],
                    ["theta", [952]],
                    ["thetasym", [977]],
                    ["thetav", [977]],
                    ["thickapprox", [8776]],
                    ["thicksim", [8764]],
                    ["ThickSpace", [8287, 8202]],
                    ["ThinSpace", [8201]],
                    ["thinsp", [8201]],
                    ["thkap", [8776]],
                    ["thksim", [8764]],
                    ["THORN", [222]],
                    ["thorn", [254]],
                    ["tilde", [732]],
                    ["Tilde", [8764]],
                    ["TildeEqual", [8771]],
                    ["TildeFullEqual", [8773]],
                    ["TildeTilde", [8776]],
                    ["timesbar", [10801]],
                    ["timesb", [8864]],
                    ["times", [215]],
                    ["timesd", [10800]],
                    ["tint", [8749]],
                    ["toea", [10536]],
                    ["topbot", [9014]],
                    ["topcir", [10993]],
                    ["top", [8868]],
                    ["Topf", [120139]],
                    ["topf", [120165]],
                    ["topfork", [10970]],
                    ["tosa", [10537]],
                    ["tprime", [8244]],
                    ["trade", [8482]],
                    ["TRADE", [8482]],
                    ["triangle", [9653]],
                    ["triangledown", [9663]],
                    ["triangleleft", [9667]],
                    ["trianglelefteq", [8884]],
                    ["triangleq", [8796]],
                    ["triangleright", [9657]],
                    ["trianglerighteq", [8885]],
                    ["tridot", [9708]],
                    ["trie", [8796]],
                    ["triminus", [10810]],
                    ["TripleDot", [8411]],
                    ["triplus", [10809]],
                    ["trisb", [10701]],
                    ["tritime", [10811]],
                    ["trpezium", [9186]],
                    ["Tscr", [119983]],
                    ["tscr", [120009]],
                    ["TScy", [1062]],
                    ["tscy", [1094]],
                    ["TSHcy", [1035]],
                    ["tshcy", [1115]],
                    ["Tstrok", [358]],
                    ["tstrok", [359]],
                    ["twixt", [8812]],
                    ["twoheadleftarrow", [8606]],
                    ["twoheadrightarrow", [8608]],
                    ["Uacute", [218]],
                    ["uacute", [250]],
                    ["uarr", [8593]],
                    ["Uarr", [8607]],
                    ["uArr", [8657]],
                    ["Uarrocir", [10569]],
                    ["Ubrcy", [1038]],
                    ["ubrcy", [1118]],
                    ["Ubreve", [364]],
                    ["ubreve", [365]],
                    ["Ucirc", [219]],
                    ["ucirc", [251]],
                    ["Ucy", [1059]],
                    ["ucy", [1091]],
                    ["udarr", [8645]],
                    ["Udblac", [368]],
                    ["udblac", [369]],
                    ["udhar", [10606]],
                    ["ufisht", [10622]],
                    ["Ufr", [120088]],
                    ["ufr", [120114]],
                    ["Ugrave", [217]],
                    ["ugrave", [249]],
                    ["uHar", [10595]],
                    ["uharl", [8639]],
                    ["uharr", [8638]],
                    ["uhblk", [9600]],
                    ["ulcorn", [8988]],
                    ["ulcorner", [8988]],
                    ["ulcrop", [8975]],
                    ["ultri", [9720]],
                    ["Umacr", [362]],
                    ["umacr", [363]],
                    ["uml", [168]],
                    ["UnderBar", [95]],
                    ["UnderBrace", [9183]],
                    ["UnderBracket", [9141]],
                    ["UnderParenthesis", [9181]],
                    ["Union", [8899]],
                    ["UnionPlus", [8846]],
                    ["Uogon", [370]],
                    ["uogon", [371]],
                    ["Uopf", [120140]],
                    ["uopf", [120166]],
                    ["UpArrowBar", [10514]],
                    ["uparrow", [8593]],
                    ["UpArrow", [8593]],
                    ["Uparrow", [8657]],
                    ["UpArrowDownArrow", [8645]],
                    ["updownarrow", [8597]],
                    ["UpDownArrow", [8597]],
                    ["Updownarrow", [8661]],
                    ["UpEquilibrium", [10606]],
                    ["upharpoonleft", [8639]],
                    ["upharpoonright", [8638]],
                    ["uplus", [8846]],
                    ["UpperLeftArrow", [8598]],
                    ["UpperRightArrow", [8599]],
                    ["upsi", [965]],
                    ["Upsi", [978]],
                    ["upsih", [978]],
                    ["Upsilon", [933]],
                    ["upsilon", [965]],
                    ["UpTeeArrow", [8613]],
                    ["UpTee", [8869]],
                    ["upuparrows", [8648]],
                    ["urcorn", [8989]],
                    ["urcorner", [8989]],
                    ["urcrop", [8974]],
                    ["Uring", [366]],
                    ["uring", [367]],
                    ["urtri", [9721]],
                    ["Uscr", [119984]],
                    ["uscr", [120010]],
                    ["utdot", [8944]],
                    ["Utilde", [360]],
                    ["utilde", [361]],
                    ["utri", [9653]],
                    ["utrif", [9652]],
                    ["uuarr", [8648]],
                    ["Uuml", [220]],
                    ["uuml", [252]],
                    ["uwangle", [10663]],
                    ["vangrt", [10652]],
                    ["varepsilon", [1013]],
                    ["varkappa", [1008]],
                    ["varnothing", [8709]],
                    ["varphi", [981]],
                    ["varpi", [982]],
                    ["varpropto", [8733]],
                    ["varr", [8597]],
                    ["vArr", [8661]],
                    ["varrho", [1009]],
                    ["varsigma", [962]],
                    ["varsubsetneq", [8842, 65024]],
                    ["varsubsetneqq", [10955, 65024]],
                    ["varsupsetneq", [8843, 65024]],
                    ["varsupsetneqq", [10956, 65024]],
                    ["vartheta", [977]],
                    ["vartriangleleft", [8882]],
                    ["vartriangleright", [8883]],
                    ["vBar", [10984]],
                    ["Vbar", [10987]],
                    ["vBarv", [10985]],
                    ["Vcy", [1042]],
                    ["vcy", [1074]],
                    ["vdash", [8866]],
                    ["vDash", [8872]],
                    ["Vdash", [8873]],
                    ["VDash", [8875]],
                    ["Vdashl", [10982]],
                    ["veebar", [8891]],
                    ["vee", [8744]],
                    ["Vee", [8897]],
                    ["veeeq", [8794]],
                    ["vellip", [8942]],
                    ["verbar", [124]],
                    ["Verbar", [8214]],
                    ["vert", [124]],
                    ["Vert", [8214]],
                    ["VerticalBar", [8739]],
                    ["VerticalLine", [124]],
                    ["VerticalSeparator", [10072]],
                    ["VerticalTilde", [8768]],
                    ["VeryThinSpace", [8202]],
                    ["Vfr", [120089]],
                    ["vfr", [120115]],
                    ["vltri", [8882]],
                    ["vnsub", [8834, 8402]],
                    ["vnsup", [8835, 8402]],
                    ["Vopf", [120141]],
                    ["vopf", [120167]],
                    ["vprop", [8733]],
                    ["vrtri", [8883]],
                    ["Vscr", [119985]],
                    ["vscr", [120011]],
                    ["vsubnE", [10955, 65024]],
                    ["vsubne", [8842, 65024]],
                    ["vsupnE", [10956, 65024]],
                    ["vsupne", [8843, 65024]],
                    ["Vvdash", [8874]],
                    ["vzigzag", [10650]],
                    ["Wcirc", [372]],
                    ["wcirc", [373]],
                    ["wedbar", [10847]],
                    ["wedge", [8743]],
                    ["Wedge", [8896]],
                    ["wedgeq", [8793]],
                    ["weierp", [8472]],
                    ["Wfr", [120090]],
                    ["wfr", [120116]],
                    ["Wopf", [120142]],
                    ["wopf", [120168]],
                    ["wp", [8472]],
                    ["wr", [8768]],
                    ["wreath", [8768]],
                    ["Wscr", [119986]],
                    ["wscr", [120012]],
                    ["xcap", [8898]],
                    ["xcirc", [9711]],
                    ["xcup", [8899]],
                    ["xdtri", [9661]],
                    ["Xfr", [120091]],
                    ["xfr", [120117]],
                    ["xharr", [10231]],
                    ["xhArr", [10234]],
                    ["Xi", [926]],
                    ["xi", [958]],
                    ["xlarr", [10229]],
                    ["xlArr", [10232]],
                    ["xmap", [10236]],
                    ["xnis", [8955]],
                    ["xodot", [10752]],
                    ["Xopf", [120143]],
                    ["xopf", [120169]],
                    ["xoplus", [10753]],
                    ["xotime", [10754]],
                    ["xrarr", [10230]],
                    ["xrArr", [10233]],
                    ["Xscr", [119987]],
                    ["xscr", [120013]],
                    ["xsqcup", [10758]],
                    ["xuplus", [10756]],
                    ["xutri", [9651]],
                    ["xvee", [8897]],
                    ["xwedge", [8896]],
                    ["Yacute", [221]],
                    ["yacute", [253]],
                    ["YAcy", [1071]],
                    ["yacy", [1103]],
                    ["Ycirc", [374]],
                    ["ycirc", [375]],
                    ["Ycy", [1067]],
                    ["ycy", [1099]],
                    ["yen", [165]],
                    ["Yfr", [120092]],
                    ["yfr", [120118]],
                    ["YIcy", [1031]],
                    ["yicy", [1111]],
                    ["Yopf", [120144]],
                    ["yopf", [120170]],
                    ["Yscr", [119988]],
                    ["yscr", [120014]],
                    ["YUcy", [1070]],
                    ["yucy", [1102]],
                    ["yuml", [255]],
                    ["Yuml", [376]],
                    ["Zacute", [377]],
                    ["zacute", [378]],
                    ["Zcaron", [381]],
                    ["zcaron", [382]],
                    ["Zcy", [1047]],
                    ["zcy", [1079]],
                    ["Zdot", [379]],
                    ["zdot", [380]],
                    ["zeetrf", [8488]],
                    ["ZeroWidthSpace", [8203]],
                    ["Zeta", [918]],
                    ["zeta", [950]],
                    ["zfr", [120119]],
                    ["Zfr", [8488]],
                    ["ZHcy", [1046]],
                    ["zhcy", [1078]],
                    ["zigrarr", [8669]],
                    ["zopf", [120171]],
                    ["Zopf", [8484]],
                    ["Zscr", [119989]],
                    ["zscr", [120015]],
                    ["zwj", [8205]],
                    ["zwnj", [8204]],
                ];
                var DECODE_ONLY_ENTITIES = [["NewLine", [10]]];
                var alphaIndex = {};
                var charIndex = {};
                createIndexes(alphaIndex, charIndex);
                var Html5Entities = /** @class */ (function () {
                    function Html5Entities() {}
                    Html5Entities.prototype.decode = function (str) {
                        if (!str || !str.length) {
                            return "";
                        }
                        return str.replace(/&(#?[\w\d]+);?/g, function (s, entity) {
                            var chr;
                            if (entity.charAt(0) === "#") {
                                var code = entity.charAt(1) === "x" ? parseInt(entity.substr(2).toLowerCase(), 16) : parseInt(entity.substr(1));
                                if (!isNaN(code) || code >= -32768) {
                                    if (code <= 65535) {
                                        chr = String.fromCharCode(code);
                                    } else {
                                        chr = surrogate_pairs_1.fromCodePoint(code);
                                    }
                                }
                            } else {
                                chr = alphaIndex[entity];
                            }
                            return chr || s;
                        });
                    };
                    Html5Entities.decode = function (str) {
                        return new Html5Entities().decode(str);
                    };
                    Html5Entities.prototype.encode = function (str) {
                        if (!str || !str.length) {
                            return "";
                        }
                        var strLength = str.length;
                        var result = "";
                        var i = 0;
                        while (i < strLength) {
                            var charInfo = charIndex[str.charCodeAt(i)];
                            if (charInfo) {
                                var alpha = charInfo[str.charCodeAt(i + 1)];
                                if (alpha) {
                                    i++;
                                } else {
                                    alpha = charInfo[""];
                                }
                                if (alpha) {
                                    result += "&" + alpha + ";";
                                    i++;
                                    continue;
                                }
                            }
                            result += str.charAt(i);
                            i++;
                        }
                        return result;
                    };
                    Html5Entities.encode = function (str) {
                        return new Html5Entities().encode(str);
                    };
                    Html5Entities.prototype.encodeNonUTF = function (str) {
                        if (!str || !str.length) {
                            return "";
                        }
                        var strLength = str.length;
                        var result = "";
                        var i = 0;
                        while (i < strLength) {
                            var c = str.charCodeAt(i);
                            var charInfo = charIndex[c];
                            if (charInfo) {
                                var alpha = charInfo[str.charCodeAt(i + 1)];
                                if (alpha) {
                                    i++;
                                } else {
                                    alpha = charInfo[""];
                                }
                                if (alpha) {
                                    result += "&" + alpha + ";";
                                    i++;
                                    continue;
                                }
                            }
                            if (c < 32 || c > 126) {
                                if (c >= surrogate_pairs_1.highSurrogateFrom && c <= surrogate_pairs_1.highSurrogateTo) {
                                    result += "&#" + surrogate_pairs_1.getCodePoint(str, i) + ";";
                                    i++;
                                } else {
                                    result += "&#" + c + ";";
                                }
                            } else {
                                result += str.charAt(i);
                            }
                            i++;
                        }
                        return result;
                    };
                    Html5Entities.encodeNonUTF = function (str) {
                        return new Html5Entities().encodeNonUTF(str);
                    };
                    Html5Entities.prototype.encodeNonASCII = function (str) {
                        if (!str || !str.length) {
                            return "";
                        }
                        var strLength = str.length;
                        var result = "";
                        var i = 0;
                        while (i < strLength) {
                            var c = str.charCodeAt(i);
                            if (c <= 255) {
                                result += str[i++];
                                continue;
                            }
                            if (c >= surrogate_pairs_1.highSurrogateFrom && c <= surrogate_pairs_1.highSurrogateTo) {
                                result += "&#" + surrogate_pairs_1.getCodePoint(str, i) + ";";
                                i += 2;
                            } else {
                                result += "&#" + c + ";";
                                i++;
                            }
                        }
                        return result;
                    };
                    Html5Entities.encodeNonASCII = function (str) {
                        return new Html5Entities().encodeNonASCII(str);
                    };
                    return Html5Entities;
                })();
                exports.Html5Entities = Html5Entities;
                function createIndexes(alphaIndex, charIndex) {
                    var i = ENTITIES.length;
                    while (i--) {
                        var _a = ENTITIES[i],
                            alpha = _a[0],
                            _b = _a[1],
                            chr = _b[0],
                            chr2 = _b[1];
                        var addChar = chr < 32 || chr > 126 || chr === 62 || chr === 60 || chr === 38 || chr === 34 || chr === 39;
                        var charInfo = void 0;
                        if (addChar) {
                            charInfo = charIndex[chr] = charIndex[chr] || {};
                        }
                        if (chr2) {
                            alphaIndex[alpha] = String.fromCharCode(chr) + String.fromCharCode(chr2);
                            addChar && (charInfo[chr2] = alpha);
                        } else {
                            alphaIndex[alpha] = String.fromCharCode(chr);
                            addChar && (charInfo[""] = alpha);
                        }
                    }
                    i = DECODE_ONLY_ENTITIES.length;
                    while (i--) {
                        var _c = DECODE_ONLY_ENTITIES[i],
                            alpha = _c[0],
                            _d = _c[1],
                            chr = _d[0],
                            chr2 = _d[1];
                        alphaIndex[alpha] = String.fromCharCode(chr) + (chr2 ? String.fromCharCode(chr2) : "");
                    }
                }
            },
            { "./surrogate-pairs": 62 },
        ],
        61: [
            function (require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", { value: true });
                var xml_entities_1 = require("./xml-entities");
                exports.XmlEntities = xml_entities_1.XmlEntities;
                var html4_entities_1 = require("./html4-entities");
                exports.Html4Entities = html4_entities_1.Html4Entities;
                var html5_entities_1 = require("./html5-entities");
                exports.Html5Entities = html5_entities_1.Html5Entities;
                exports.AllHtmlEntities = html5_entities_1.Html5Entities;
            },
            { "./html4-entities": 59, "./html5-entities": 60, "./xml-entities": 63 },
        ],
        62: [
            function (require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", { value: true });
                exports.fromCodePoint =
                    String.fromCodePoint ||
                    function (astralCodePoint) {
                        return String.fromCharCode(Math.floor((astralCodePoint - 0x10000) / 0x400) + 0xd800, ((astralCodePoint - 0x10000) % 0x400) + 0xdc00);
                    };
                exports.getCodePoint = String.prototype.codePointAt
                    ? function (input, position) {
                          return input.codePointAt(position);
                      }
                    : function (input, position) {
                          return (input.charCodeAt(position) - 0xd800) * 0x400 + input.charCodeAt(position + 1) - 0xdc00 + 0x10000;
                      };
                exports.highSurrogateFrom = 0xd800;
                exports.highSurrogateTo = 0xdbff;
            },
            {},
        ],
        63: [
            function (require, module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", { value: true });
                var surrogate_pairs_1 = require("./surrogate-pairs");
                var ALPHA_INDEX = { "&lt": "<", "&gt": ">", "&quot": '"', "&apos": "'", "&amp": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&apos;": "'", "&amp;": "&" };
                var CHAR_INDEX = { 60: "lt", 62: "gt", 34: "quot", 39: "apos", 38: "amp" };
                var CHAR_S_INDEX = { "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&apos;", "&": "&amp;" };
                var XmlEntities = /** @class */ (function () {
                    function XmlEntities() {}
                    XmlEntities.prototype.encode = function (str) {
                        if (!str || !str.length) {
                            return "";
                        }
                        return str.replace(/[<>"'&]/g, function (s) {
                            return CHAR_S_INDEX[s];
                        });
                    };
                    XmlEntities.encode = function (str) {
                        return new XmlEntities().encode(str);
                    };
                    XmlEntities.prototype.decode = function (str) {
                        if (!str || !str.length) {
                            return "";
                        }
                        return str.replace(/&#?[0-9a-zA-Z]+;?/g, function (s) {
                            if (s.charAt(1) === "#") {
                                var code = s.charAt(2).toLowerCase() === "x" ? parseInt(s.substr(3), 16) : parseInt(s.substr(2));
                                if (!isNaN(code) || code >= -32768) {
                                    if (code <= 65535) {
                                        return String.fromCharCode(code);
                                    } else {
                                        return surrogate_pairs_1.fromCodePoint(code);
                                    }
                                }
                                return "";
                            }
                            return ALPHA_INDEX[s] || s;
                        });
                    };
                    XmlEntities.decode = function (str) {
                        return new XmlEntities().decode(str);
                    };
                    XmlEntities.prototype.encodeNonUTF = function (str) {
                        if (!str || !str.length) {
                            return "";
                        }
                        var strLength = str.length;
                        var result = "";
                        var i = 0;
                        while (i < strLength) {
                            var c = str.charCodeAt(i);
                            var alpha = CHAR_INDEX[c];
                            if (alpha) {
                                result += "&" + alpha + ";";
                                i++;
                                continue;
                            }
                            if (c < 32 || c > 126) {
                                if (c >= surrogate_pairs_1.highSurrogateFrom && c <= surrogate_pairs_1.highSurrogateTo) {
                                    result += "&#" + surrogate_pairs_1.getCodePoint(str, i) + ";";
                                    i++;
                                } else {
                                    result += "&#" + c + ";";
                                }
                            } else {
                                result += str.charAt(i);
                            }
                            i++;
                        }
                        return result;
                    };
                    XmlEntities.encodeNonUTF = function (str) {
                        return new XmlEntities().encodeNonUTF(str);
                    };
                    XmlEntities.prototype.encodeNonASCII = function (str) {
                        if (!str || !str.length) {
                            return "";
                        }
                        var strLength = str.length;
                        var result = "";
                        var i = 0;
                        while (i < strLength) {
                            var c = str.charCodeAt(i);
                            if (c <= 255) {
                                result += str[i++];
                                continue;
                            }
                            if (c >= surrogate_pairs_1.highSurrogateFrom && c <= surrogate_pairs_1.highSurrogateTo) {
                                result += "&#" + surrogate_pairs_1.getCodePoint(str, i) + ";";
                                i++;
                            } else {
                                result += "&#" + c + ";";
                            }
                            i++;
                        }
                        return result;
                    };
                    XmlEntities.encodeNonASCII = function (str) {
                        return new XmlEntities().encodeNonASCII(str);
                    };
                    return XmlEntities;
                })();
                exports.XmlEntities = XmlEntities;
            },
            { "./surrogate-pairs": 62 },
        ],
        64: [
            function (require, module, exports) {
                // the whatwg-fetch polyfill installs the fetch() function
                // on the global object (window or self)
                //
                // Return that as the export for use in Webpack, Browserify etc.
                require("whatwg-fetch");
                module.exports = self.fetch.bind(self);
            },
            { "whatwg-fetch": 75 },
        ],
        65: [
            function (require, module, exports) {
                /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
                /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var propIsEnumerable = Object.prototype.propertyIsEnumerable;
                function toObject(val) {
                    if (val === null || val === undefined) {
                        throw new TypeError("Object.assign cannot be called with null or undefined");
                    }
                    return Object(val);
                }
                function shouldUseNative() {
                    try {
                        if (!Object.assign) {
                            return false;
                        } // Detect buggy property enumeration order in older V8 versions.
                        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
                        test1[5] = "de";
                        if (Object.getOwnPropertyNames(test1)[0] === "5") {
                            return false;
                        } // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test2 = {};
                        for (var i = 0; i < 10; i++) {
                            test2["_" + String.fromCharCode(i)] = i;
                        }
                        var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
                            return test2[n];
                        });
                        if (order2.join("") !== "0123456789") {
                            return false;
                        } // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test3 = {};
                        "abcdefghijklmnopqrst".split("").forEach(function (letter) {
                            test3[letter] = letter;
                        });
                        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
                            return false;
                        }
                        return true;
                    } catch (err) {
                        // We don't expect any of the above to throw, but better to be safe.
                        return false;
                    }
                }
                module.exports = shouldUseNative()
                    ? Object.assign
                    : function (target, source) {
                          var from;
                          var to = toObject(target);
                          var symbols;
                          for (var s = 1; s < arguments.length; s++) {
                              from = Object(arguments[s]);
                              for (var key in from) {
                                  if (hasOwnProperty.call(from, key)) {
                                      to[key] = from[key];
                                  }
                              }
                              if (getOwnPropertySymbols) {
                                  symbols = getOwnPropertySymbols(from);
                                  for (var i = 0; i < symbols.length; i++) {
                                      if (propIsEnumerable.call(from, symbols[i])) {
                                          to[symbols[i]] = from[symbols[i]];
                                      }
                                  }
                              }
                          }
                          return to;
                      };
            },
            {},
        ],
        66: [
            function (require, module, exports) {
                // shim for using process in browser
                var process = (module.exports = {});
                process.nextTick = (function () {
                    var canSetImmediate = typeof window !== "undefined" && window.setImmediate;
                    var canPost = typeof window !== "undefined" && window.postMessage && window.addEventListener;
                    if (canSetImmediate) {
                        return function (f) {
                            return window.setImmediate(f);
                        };
                    }
                    if (canPost) {
                        var queue = [];
                        window.addEventListener(
                            "message",
                            function (ev) {
                                var source = ev.source;
                                if ((source === window || source === null) && ev.data === "process-tick") {
                                    ev.stopPropagation();
                                    if (queue.length > 0) {
                                        var fn = queue.shift();
                                        fn();
                                    }
                                }
                            },
                            true
                        );
                        return function nextTick(fn) {
                            queue.push(fn);
                            window.postMessage("process-tick", "*");
                        };
                    }
                    return function nextTick(fn) {
                        setTimeout(fn, 0);
                    };
                })();
                process.title = "browser";
                process.browser = true;
                process.env = {};
                process.argv = [];
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.binding = function (name) {
                    throw new Error("process.binding is not supported");
                }; // TODO(shtylman)
                process.cwd = function () {
                    return "/";
                };
                process.chdir = function (dir) {
                    throw new Error("process.chdir is not supported");
                };
            },
            {},
        ],
        67: [
            function (require, module, exports) {
                (function (process) {
                    /**
                     * Copyright (c) 2013-present, Facebook, Inc.
                     *
                     * This source code is licensed under the MIT license found in the
                     * LICENSE file in the root directory of this source tree.
                     */ "use strict";
                    var printWarning = function printWarning() {};
                    if (process.env.NODE_ENV !== "production") {
                        var ReactPropTypesSecret = require("./lib/ReactPropTypesSecret");
                        var loggedTypeFailures = {};
                        printWarning = function printWarning(text) {
                            var message = "Warning: " + text;
                            if (typeof console !== "undefined") {
                                console.error(message);
                            }
                            try {
                                // --- Welcome to debugging React ---
                                // This error was thrown as a convenience so that you can use this stack
                                // to find the callsite that caused this warning to fire.
                                throw new Error(message);
                            } catch (x) {}
                        };
                    }
                    /**
                     * Assert that the values match with the type specs.
                     * Error messages are memorized and will only be shown once.
                     *
                     * @param {object} typeSpecs Map of name to a ReactPropType
                     * @param {object} values Runtime values that need to be type-checked
                     * @param {string} location e.g. "prop", "context", "child context"
                     * @param {string} componentName Name of the component for error messages.
                     * @param {?Function} getStack Returns the component stack.
                     * @private
                     */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
                        if (process.env.NODE_ENV !== "production") {
                            for (var typeSpecName in typeSpecs) {
                                if (typeSpecs.hasOwnProperty(typeSpecName)) {
                                    var error; // Prop type validation may throw. In case they do, we don't want to
                                    // fail the render phase where it didn't fail before. So we log it.
                                    // After these have been cleaned up, we'll let them throw.
                                    try {
                                        // This is intentionally an invariant that gets caught. It's the same
                                        // behavior as without this statement except with a better message.
                                        if (typeof typeSpecs[typeSpecName] !== "function") {
                                            var err = Error(
                                                (componentName || "React class") +
                                                    ": " +
                                                    location +
                                                    " type `" +
                                                    typeSpecName +
                                                    "` is invalid; " +
                                                    "it must be a function, usually from the `prop-types` package, but received `" +
                                                    _typeof(typeSpecs[typeSpecName]) +
                                                    "`."
                                            );
                                            err.name = "Invariant Violation";
                                            throw err;
                                        }
                                        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                                    } catch (ex) {
                                        error = ex;
                                    }
                                    if (error && !(error instanceof Error)) {
                                        printWarning(
                                            (componentName || "React class") +
                                                ": type specification of " +
                                                location +
                                                " `" +
                                                typeSpecName +
                                                "` is invalid; the type checker " +
                                                "function must return `null` or an `Error` but returned a " +
                                                _typeof(error) +
                                                ". " +
                                                "You may have forgotten to pass an argument to the type checker " +
                                                "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " +
                                                "shape all require an argument)."
                                        );
                                    }
                                    if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                                        // Only monitor this failure once because there tends to be a lot of the
                                        // same error.
                                        loggedTypeFailures[error.message] = true;
                                        var stack = getStack ? getStack() : "";
                                        printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
                                    }
                                }
                            }
                        }
                    }
                    module.exports = checkPropTypes;
                }.call(this, require("rH1JPG")));
            },
            { "./lib/ReactPropTypesSecret": 71, rH1JPG: 66 },
        ],
        68: [
            function (require, module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 *
                 * This source code is licensed under the MIT license found in the
                 * LICENSE file in the root directory of this source tree.
                 */ "use strict";
                var ReactPropTypesSecret = require("./lib/ReactPropTypesSecret");
                function emptyFunction() {}
                module.exports = function () {
                    function shim(props, propName, componentName, location, propFullName, secret) {
                        if (secret === ReactPropTypesSecret) {
                            // It is still safe when called from React.
                            return;
                        }
                        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. " + "Use PropTypes.checkPropTypes() to call them. " + "Read more at http://fb.me/use-check-prop-types");
                        err.name = "Invariant Violation";
                        throw err;
                    }
                    shim.isRequired = shim;
                    function getShim() {
                        return shim;
                    } // Important!
                    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
                    var ReactPropTypes = {
                        array: shim,
                        bool: shim,
                        func: shim,
                        number: shim,
                        object: shim,
                        string: shim,
                        symbol: shim,
                        any: shim,
                        arrayOf: getShim,
                        element: shim,
                        instanceOf: getShim,
                        node: shim,
                        objectOf: getShim,
                        oneOf: getShim,
                        oneOfType: getShim,
                        shape: getShim,
                        exact: getShim,
                    };
                    ReactPropTypes.checkPropTypes = emptyFunction;
                    ReactPropTypes.PropTypes = ReactPropTypes;
                    return ReactPropTypes;
                };
            },
            { "./lib/ReactPropTypesSecret": 71 },
        ],
        69: [
            function (require, module, exports) {
                (function (process) {
                    /**
                     * Copyright (c) 2013-present, Facebook, Inc.
                     *
                     * This source code is licensed under the MIT license found in the
                     * LICENSE file in the root directory of this source tree.
                     */ "use strict";
                    var assign = require("object-assign");
                    var ReactPropTypesSecret = require("./lib/ReactPropTypesSecret");
                    var checkPropTypes = require("./checkPropTypes");
                    var printWarning = function printWarning() {};
                    if (process.env.NODE_ENV !== "production") {
                        printWarning = function printWarning(text) {
                            var message = "Warning: " + text;
                            if (typeof console !== "undefined") {
                                console.error(message);
                            }
                            try {
                                // --- Welcome to debugging React ---
                                // This error was thrown as a convenience so that you can use this stack
                                // to find the callsite that caused this warning to fire.
                                throw new Error(message);
                            } catch (x) {}
                        };
                    }
                    function emptyFunctionThatReturnsNull() {
                        return null;
                    }
                    module.exports = function (isValidElement, throwOnDirectAccess) {
                        /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
                        var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
                        /**
                         * Returns the iterator method function contained on the iterable object.
                         *
                         * Be sure to invoke the function with the iterable as context:
                         *
                         *     var iteratorFn = getIteratorFn(myIterable);
                         *     if (iteratorFn) {
                         *       var iterator = iteratorFn.call(myIterable);
                         *       ...
                         *     }
                         *
                         * @param {?object} maybeIterable
                         * @return {?function}
                         */ function getIteratorFn(maybeIterable) {
                            var iteratorFn = maybeIterable && ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                            if (typeof iteratorFn === "function") {
                                return iteratorFn;
                            }
                        }
                        /**
                         * Collection of methods that allow declaration and validation of props that are
                         * supplied to React components. Example usage:
                         *
                         *   var Props = require('ReactPropTypes');
                         *   var MyArticle = React.createClass({
                         *     propTypes: {
                         *       // An optional string prop named "description".
                         *       description: Props.string,
                         *
                         *       // A required enum prop named "category".
                         *       category: Props.oneOf(['News','Photos']).isRequired,
                         *
                         *       // A prop named "dialog" that requires an instance of Dialog.
                         *       dialog: Props.instanceOf(Dialog).isRequired
                         *     },
                         *     render: function() { ... }
                         *   });
                         *
                         * A more formal specification of how these methods are used:
                         *
                         *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
                         *   decl := ReactPropTypes.{type}(.isRequired)?
                         *
                         * Each and every declaration produces a function with the same signature. This
                         * allows the creation of custom validation functions. For example:
                         *
                         *  var MyLink = React.createClass({
                         *    propTypes: {
                         *      // An optional string or URI prop named "href".
                         *      href: function(props, propName, componentName) {
                         *        var propValue = props[propName];
                         *        if (propValue != null && typeof propValue !== 'string' &&
                         *            !(propValue instanceof URI)) {
                         *          return new Error(
                         *            'Expected a string or an URI for ' + propName + ' in ' +
                         *            componentName
                         *          );
                         *        }
                         *      }
                         *    },
                         *    render: function() {...}
                         *  });
                         *
                         * @internal
                         */ var ANONYMOUS = "<<anonymous>>"; // Important!
                        // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
                        var ReactPropTypes = {
                            array: createPrimitiveTypeChecker("array"),
                            bool: createPrimitiveTypeChecker("boolean"),
                            func: createPrimitiveTypeChecker("function"),
                            number: createPrimitiveTypeChecker("number"),
                            object: createPrimitiveTypeChecker("object"),
                            string: createPrimitiveTypeChecker("string"),
                            symbol: createPrimitiveTypeChecker("symbol"),
                            any: createAnyTypeChecker(),
                            arrayOf: createArrayOfTypeChecker,
                            element: createElementTypeChecker(),
                            instanceOf: createInstanceTypeChecker,
                            node: createNodeChecker(),
                            objectOf: createObjectOfTypeChecker,
                            oneOf: createEnumTypeChecker,
                            oneOfType: createUnionTypeChecker,
                            shape: createShapeTypeChecker,
                            exact: createStrictShapeTypeChecker,
                        };
                        /**
                         * inlined Object.is polyfill to avoid requiring consumers ship their own
                         * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
                         */ /*eslint-disable no-self-compare*/ function is(x, y) {
                            // SameValue algorithm
                            if (x === y) {
                                // Steps 1-5, 7-10
                                // Steps 6.b-6.e: +0 != -0
                                return x !== 0 || 1 / x === 1 / y;
                            } else {
                                // Step 6.a: NaN == NaN
                                return x !== x && y !== y;
                            }
                        }
                        /*eslint-enable no-self-compare*/ /**
                         * We use an Error-like object for backward compatibility as people may call
                         * PropTypes directly and inspect their output. However, we don't use real
                         * Errors anymore. We don't inspect their stack anyway, and creating them
                         * is prohibitively expensive if they are created too often, such as what
                         * happens in oneOfType() for any type before the one that matched.
                         */ function PropTypeError(message) {
                            this.message = message;
                            this.stack = "";
                        } // Make `instanceof Error` still work for returned errors.
                        PropTypeError.prototype = Error.prototype;
                        function createChainableTypeChecker(validate) {
                            if (process.env.NODE_ENV !== "production") {
                                var manualPropTypeCallCache = {};
                                var manualPropTypeWarningCount = 0;
                            }
                            function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                                componentName = componentName || ANONYMOUS;
                                propFullName = propFullName || propName;
                                if (secret !== ReactPropTypesSecret) {
                                    if (throwOnDirectAccess) {
                                        // New behavior only for users of `prop-types` package
                                        var err = new Error(
                                            "Calling PropTypes validators directly is not supported by the `prop-types` package. " + "Use `PropTypes.checkPropTypes()` to call them. " + "Read more at http://fb.me/use-check-prop-types"
                                        );
                                        err.name = "Invariant Violation";
                                        throw err;
                                    } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
                                        // Old behavior for people using React.PropTypes
                                        var cacheKey = componentName + ":" + propName;
                                        if (
                                            !manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                                            manualPropTypeWarningCount < 3
                                        ) {
                                            printWarning(
                                                "You are manually calling a React.PropTypes validation " +
                                                    "function for the `" +
                                                    propFullName +
                                                    "` prop on `" +
                                                    componentName +
                                                    "`. This is deprecated " +
                                                    "and will throw in the standalone `prop-types` package. " +
                                                    "You may be seeing this warning due to a third-party PropTypes " +
                                                    "library. See https://fb.me/react-warning-dont-call-proptypes " +
                                                    "for details."
                                            );
                                            manualPropTypeCallCache[cacheKey] = true;
                                            manualPropTypeWarningCount++;
                                        }
                                    }
                                }
                                if (props[propName] == null) {
                                    if (isRequired) {
                                        if (props[propName] === null) {
                                            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                                        }
                                        return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                                    }
                                    return null;
                                } else {
                                    return validate(props, propName, componentName, location, propFullName);
                                }
                            }
                            var chainedCheckType = checkType.bind(null, false);
                            chainedCheckType.isRequired = checkType.bind(null, true);
                            return chainedCheckType;
                        }
                        function createPrimitiveTypeChecker(expectedType) {
                            function validate(props, propName, componentName, location, propFullName, secret) {
                                var propValue = props[propName];
                                var propType = getPropType(propValue);
                                if (propType !== expectedType) {
                                    // `propValue` being instance of, say, date/regexp, pass the 'object'
                                    // check, but we can offer a more precise error message here rather than
                                    // 'of type `object`'.
                                    var preciseType = getPreciseType(propValue);
                                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."));
                                }
                                return null;
                            }
                            return createChainableTypeChecker(validate);
                        }
                        function createAnyTypeChecker() {
                            return createChainableTypeChecker(emptyFunctionThatReturnsNull);
                        }
                        function createArrayOfTypeChecker(typeChecker) {
                            function validate(props, propName, componentName, location, propFullName) {
                                if (typeof typeChecker !== "function") {
                                    return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                                }
                                var propValue = props[propName];
                                if (!Array.isArray(propValue)) {
                                    var propType = getPropType(propValue);
                                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
                                }
                                for (var i = 0; i < propValue.length; i++) {
                                    var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                                    if (error instanceof Error) {
                                        return error;
                                    }
                                }
                                return null;
                            }
                            return createChainableTypeChecker(validate);
                        }
                        function createElementTypeChecker() {
                            function validate(props, propName, componentName, location, propFullName) {
                                var propValue = props[propName];
                                if (!isValidElement(propValue)) {
                                    var propType = getPropType(propValue);
                                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
                                }
                                return null;
                            }
                            return createChainableTypeChecker(validate);
                        }
                        function createInstanceTypeChecker(expectedClass) {
                            function validate(props, propName, componentName, location, propFullName) {
                                if (!(props[propName] instanceof expectedClass)) {
                                    var expectedClassName = expectedClass.name || ANONYMOUS;
                                    var actualClassName = getClassName(props[propName]);
                                    return new PropTypeError(
                                        "Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`.")
                                    );
                                }
                                return null;
                            }
                            return createChainableTypeChecker(validate);
                        }
                        function createEnumTypeChecker(expectedValues) {
                            if (!Array.isArray(expectedValues)) {
                                process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOf, expected an instance of array.") : void 0;
                                return emptyFunctionThatReturnsNull;
                            }
                            function validate(props, propName, componentName, location, propFullName) {
                                var propValue = props[propName];
                                for (var i = 0; i < expectedValues.length; i++) {
                                    if (is(propValue, expectedValues[i])) {
                                        return null;
                                    }
                                }
                                var valuesString = JSON.stringify(expectedValues);
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
                            }
                            return createChainableTypeChecker(validate);
                        }
                        function createObjectOfTypeChecker(typeChecker) {
                            function validate(props, propName, componentName, location, propFullName) {
                                if (typeof typeChecker !== "function") {
                                    return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                                }
                                var propValue = props[propName];
                                var propType = getPropType(propValue);
                                if (propType !== "object") {
                                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
                                }
                                for (var key in propValue) {
                                    if (propValue.hasOwnProperty(key)) {
                                        var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                        if (error instanceof Error) {
                                            return error;
                                        }
                                    }
                                }
                                return null;
                            }
                            return createChainableTypeChecker(validate);
                        }
                        function createUnionTypeChecker(arrayOfTypeCheckers) {
                            if (!Array.isArray(arrayOfTypeCheckers)) {
                                process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
                                return emptyFunctionThatReturnsNull;
                            }
                            for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                                var checker = arrayOfTypeCheckers[i];
                                if (typeof checker !== "function") {
                                    printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but " + "received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                                    return emptyFunctionThatReturnsNull;
                                }
                            }
                            function validate(props, propName, componentName, location, propFullName) {
                                for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                                    var checker = arrayOfTypeCheckers[i];
                                    if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
                                        return null;
                                    }
                                }
                                return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`."));
                            }
                            return createChainableTypeChecker(validate);
                        }
                        function createNodeChecker() {
                            function validate(props, propName, componentName, location, propFullName) {
                                if (!isNode(props[propName])) {
                                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
                                }
                                return null;
                            }
                            return createChainableTypeChecker(validate);
                        }
                        function createShapeTypeChecker(shapeTypes) {
                            function validate(props, propName, componentName, location, propFullName) {
                                var propValue = props[propName];
                                var propType = getPropType(propValue);
                                if (propType !== "object") {
                                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                                }
                                for (var key in shapeTypes) {
                                    var checker = shapeTypes[key];
                                    if (!checker) {
                                        continue;
                                    }
                                    var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                    if (error) {
                                        return error;
                                    }
                                }
                                return null;
                            }
                            return createChainableTypeChecker(validate);
                        }
                        function createStrictShapeTypeChecker(shapeTypes) {
                            function validate(props, propName, componentName, location, propFullName) {
                                var propValue = props[propName];
                                var propType = getPropType(propValue);
                                if (propType !== "object") {
                                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                                } // We need to check all keys in case some are required but missing from
                                // props.
                                var allKeys = assign({}, props[propName], shapeTypes);
                                for (var key in allKeys) {
                                    var checker = shapeTypes[key];
                                    if (!checker) {
                                        return new PropTypeError(
                                            "Invalid " +
                                                location +
                                                " `" +
                                                propFullName +
                                                "` key `" +
                                                key +
                                                "` supplied to `" +
                                                componentName +
                                                "`." +
                                                "\nBad object: " +
                                                JSON.stringify(props[propName], null, "  ") +
                                                "\nValid keys: " +
                                                JSON.stringify(Object.keys(shapeTypes), null, "  ")
                                        );
                                    }
                                    var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                                    if (error) {
                                        return error;
                                    }
                                }
                                return null;
                            }
                            return createChainableTypeChecker(validate);
                        }
                        function isNode(propValue) {
                            switch (_typeof(propValue)) {
                                case "number":
                                case "string":
                                case "undefined":
                                    return true;
                                case "boolean":
                                    return !propValue;
                                case "object":
                                    if (Array.isArray(propValue)) {
                                        return propValue.every(isNode);
                                    }
                                    if (propValue === null || isValidElement(propValue)) {
                                        return true;
                                    }
                                    var iteratorFn = getIteratorFn(propValue);
                                    if (iteratorFn) {
                                        var iterator = iteratorFn.call(propValue);
                                        var step;
                                        if (iteratorFn !== propValue.entries) {
                                            while (!(step = iterator.next()).done) {
                                                if (!isNode(step.value)) {
                                                    return false;
                                                }
                                            }
                                        } else {
                                            // Iterator will provide entry [k,v] tuples rather than values.
                                            while (!(step = iterator.next()).done) {
                                                var entry = step.value;
                                                if (entry) {
                                                    if (!isNode(entry[1])) {
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                    } else {
                                        return false;
                                    }
                                    return true;
                                default:
                                    return false;
                            }
                        }
                        function isSymbol(propType, propValue) {
                            // Native Symbol.
                            if (propType === "symbol") {
                                return true;
                            } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
                            if (propValue["@@toStringTag"] === "Symbol") {
                                return true;
                            } // Fallback for non-spec compliant Symbols which are polyfilled.
                            if (typeof Symbol === "function" && propValue instanceof Symbol) {
                                return true;
                            }
                            return false;
                        } // Equivalent of `typeof` but with special handling for array and regexp.
                        function getPropType(propValue) {
                            var propType = _typeof(propValue);
                            if (Array.isArray(propValue)) {
                                return "array";
                            }
                            if (propValue instanceof RegExp) {
                                // Old webkits (at least until Android 4.0) return 'function' rather than
                                // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
                                // passes PropTypes.object.
                                return "object";
                            }
                            if (isSymbol(propType, propValue)) {
                                return "symbol";
                            }
                            return propType;
                        } // This handles more types than `getPropType`. Only used for error messages.
                        // See `createPrimitiveTypeChecker`.
                        function getPreciseType(propValue) {
                            if (typeof propValue === "undefined" || propValue === null) {
                                return "" + propValue;
                            }
                            var propType = getPropType(propValue);
                            if (propType === "object") {
                                if (propValue instanceof Date) {
                                    return "date";
                                } else if (propValue instanceof RegExp) {
                                    return "regexp";
                                }
                            }
                            return propType;
                        } // Returns a string that is postfixed to a warning about an invalid type.
                        // For example, "undefined" or "of type array"
                        function getPostfixForTypeWarning(value) {
                            var type = getPreciseType(value);
                            switch (type) {
                                case "array":
                                case "object":
                                    return "an " + type;
                                case "boolean":
                                case "date":
                                case "regexp":
                                    return "a " + type;
                                default:
                                    return type;
                            }
                        } // Returns class name of the object, if any.
                        function getClassName(propValue) {
                            if (!propValue.constructor || !propValue.constructor.name) {
                                return ANONYMOUS;
                            }
                            return propValue.constructor.name;
                        }
                        ReactPropTypes.checkPropTypes = checkPropTypes;
                        ReactPropTypes.PropTypes = ReactPropTypes;
                        return ReactPropTypes;
                    };
                }.call(this, require("rH1JPG")));
            },
            { "./checkPropTypes": 67, "./lib/ReactPropTypesSecret": 71, "object-assign": 65, rH1JPG: 66 },
        ],
        70: [
            function (require, module, exports) {
                (function (process) {
                    /**
                     * Copyright (c) 2013-present, Facebook, Inc.
                     *
                     * This source code is licensed under the MIT license found in the
                     * LICENSE file in the root directory of this source tree.
                     */ if (process.env.NODE_ENV !== "production") {
                        var REACT_ELEMENT_TYPE = (typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element")) || 0xeac7;
                        var isValidElement = function isValidElement(object) {
                            return _typeof(object) === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
                        }; // By explicitly using `prop-types` you are opting into new development behavior.
                        // http://fb.me/prop-types-in-prod
                        var throwOnDirectAccess = true;
                        module.exports = require("./factoryWithTypeCheckers")(isValidElement, throwOnDirectAccess);
                    } else {
                        // By explicitly using `prop-types` you are opting into new production behavior.
                        // http://fb.me/prop-types-in-prod
                        module.exports = require("./factoryWithThrowingShims")();
                    }
                }.call(this, require("rH1JPG")));
            },
            { "./factoryWithThrowingShims": 68, "./factoryWithTypeCheckers": 69, rH1JPG: 66 },
        ],
        71: [
            function (require, module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 *
                 * This source code is licensed under the MIT license found in the
                 * LICENSE file in the root directory of this source tree.
                 */ "use strict";
                var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
                module.exports = ReactPropTypesSecret;
            },
            {},
        ],
        72: [
            function (require, module, exports) {
                (function (process) {
                    /** @license React v16.4.2
                     * react.development.js
                     *
                     * Copyright (c) 2013-present, Facebook, Inc.
                     *
                     * This source code is licensed under the MIT license found in the
                     * LICENSE file in the root directory of this source tree.
                     */ "use strict";
                    if (process.env.NODE_ENV !== "production") {
                        (function () {
                            "use strict";
                            var _assign = require("object-assign");
                            var invariant = require("fbjs/lib/invariant");
                            var emptyObject = require("fbjs/lib/emptyObject");
                            var warning = require("fbjs/lib/warning");
                            var emptyFunction = require("fbjs/lib/emptyFunction");
                            var checkPropTypes = require("prop-types/checkPropTypes"); // TODO: this is special because it gets imported during build.
                            var ReactVersion = "16.4.2"; // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
                            // nor polyfill, then a plain number is used for performance.
                            var hasSymbol = typeof Symbol === "function" && Symbol["for"];
                            var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]("react.element") : 0xeac7;
                            var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]("react.portal") : 0xeaca;
                            var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]("react.fragment") : 0xeacb;
                            var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]("react.strict_mode") : 0xeacc;
                            var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]("react.profiler") : 0xead2;
                            var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]("react.provider") : 0xeacd;
                            var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]("react.context") : 0xeace;
                            var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]("react.async_mode") : 0xeacf;
                            var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]("react.forward_ref") : 0xead0;
                            var REACT_TIMEOUT_TYPE = hasSymbol ? Symbol["for"]("react.timeout") : 0xead1;
                            var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
                            var FAUX_ITERATOR_SYMBOL = "@@iterator";
                            function getIteratorFn(maybeIterable) {
                                if (maybeIterable === null || typeof maybeIterable === "undefined") {
                                    return null;
                                }
                                var maybeIterator = (MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL]) || maybeIterable[FAUX_ITERATOR_SYMBOL];
                                if (typeof maybeIterator === "function") {
                                    return maybeIterator;
                                }
                                return null;
                            } // Relying on the `invariant()` implementation lets us
                            // have preserve the format and params in the www builds.
                            // Exports ReactDOM.createRoot
                            // Experimental error-boundary API that can recover from errors within a single
                            // render phase
                            // Suspense
                            var enableSuspense = false; // Helps identify side effects in begin-phase lifecycle hooks and setState reducers:
                            // In some cases, StrictMode should also double-render lifecycles.
                            // This can be confusing for tests though,
                            // And it can be bad for performance in production.
                            // This feature flag can be used to control the behavior:
                            // To preserve the "Pause on caught exceptions" behavior of the debugger, we
                            // replay the begin phase of a failed component inside invokeGuardedCallback.
                            // Warn about deprecated, async-unsafe lifecycles; relates to RFC #6:
                            // Warn about legacy context API
                            // Gather advanced timing metrics for Profiler subtrees.
                            // Only used in www builds.
                            /**
                             * Forked from fbjs/warning:
                             * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
                             *
                             * Only change is we use console.warn instead of console.error,
                             * and do nothing when 'console' is not supported.
                             * This really simplifies the code.
                             * ---
                             * Similar to invariant but only logs a warning if the condition is not met.
                             * This can be used to log issues in development environments in critical
                             * paths. Removing the logging code for production environments will keep the
                             * same logic and follow the same code paths.
                             */ var lowPriorityWarning = function lowPriorityWarning() {};
                            {
                                var printWarning = function printWarning(format) {
                                    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                                        args[_key - 1] = arguments[_key];
                                    }
                                    var argIndex = 0;
                                    var message =
                                        "Warning: " +
                                        format.replace(/%s/g, function () {
                                            return args[argIndex++];
                                        });
                                    if (typeof console !== "undefined") {
                                        console.warn(message);
                                    }
                                    try {
                                        // --- Welcome to debugging React ---
                                        // This error was thrown as a convenience so that you can use this stack
                                        // to find the callsite that caused this warning to fire.
                                        throw new Error(message);
                                    } catch (x) {}
                                };
                                lowPriorityWarning = function lowPriorityWarning(condition, format) {
                                    if (format === undefined) {
                                        throw new Error("`warning(condition, format, ...args)` requires a warning " + "message argument");
                                    }
                                    if (!condition) {
                                        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                                            args[_key2 - 2] = arguments[_key2];
                                        }
                                        printWarning.apply(undefined, [format].concat(args));
                                    }
                                };
                            }
                            var lowPriorityWarning$1 = lowPriorityWarning;
                            var didWarnStateUpdateForUnmountedComponent = {};
                            function warnNoop(publicInstance, callerName) {
                                {
                                    var _constructor = publicInstance.constructor;
                                    var componentName = (_constructor && (_constructor.displayName || _constructor.name)) || "ReactClass";
                                    var warningKey = componentName + "." + callerName;
                                    if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
                                        return;
                                    }
                                    warning(
                                        false,
                                        "Can't call %s on a component that is not yet mounted. " +
                                            "This is a no-op, but it might indicate a bug in your application. " +
                                            "Instead, assign to `this.state` directly or define a `state = {};` " +
                                            "class property with the desired state in the %s component.",
                                        callerName,
                                        componentName
                                    );
                                    didWarnStateUpdateForUnmountedComponent[warningKey] = true;
                                }
                            }
                            /**
                             * This is the abstract API for an update queue.
                             */ var ReactNoopUpdateQueue = {
                                /**
                                 * Checks whether or not this composite component is mounted.
                                 * @param {ReactClass} publicInstance The instance we want to test.
                                 * @return {boolean} True if mounted, false otherwise.
                                 * @protected
                                 * @final
                                 */ isMounted: function isMounted(publicInstance) {
                                    return false;
                                },
                                /**
                                 * Forces an update. This should only be invoked when it is known with
                                 * certainty that we are **not** in a DOM transaction.
                                 *
                                 * You may want to call this when you know that some deeper aspect of the
                                 * component's state has changed but `setState` was not called.
                                 *
                                 * This will not invoke `shouldComponentUpdate`, but it will invoke
                                 * `componentWillUpdate` and `componentDidUpdate`.
                                 *
                                 * @param {ReactClass} publicInstance The instance that should rerender.
                                 * @param {?function} callback Called after component is updated.
                                 * @param {?string} callerName name of the calling function in the public API.
                                 * @internal
                                 */ enqueueForceUpdate: function enqueueForceUpdate(publicInstance, callback, callerName) {
                                    warnNoop(publicInstance, "forceUpdate");
                                },
                                /**
                                 * Replaces all of the state. Always use this or `setState` to mutate state.
                                 * You should treat `this.state` as immutable.
                                 *
                                 * There is no guarantee that `this.state` will be immediately updated, so
                                 * accessing `this.state` after calling this method may return the old value.
                                 *
                                 * @param {ReactClass} publicInstance The instance that should rerender.
                                 * @param {object} completeState Next state.
                                 * @param {?function} callback Called after component is updated.
                                 * @param {?string} callerName name of the calling function in the public API.
                                 * @internal
                                 */ enqueueReplaceState: function enqueueReplaceState(publicInstance, completeState, callback, callerName) {
                                    warnNoop(publicInstance, "replaceState");
                                },
                                /**
                                 * Sets a subset of the state. This only exists because _pendingState is
                                 * internal. This provides a merging strategy that is not available to deep
                                 * properties which is confusing. TODO: Expose pendingState or don't use it
                                 * during the merge.
                                 *
                                 * @param {ReactClass} publicInstance The instance that should rerender.
                                 * @param {object} partialState Next partial state to be merged with state.
                                 * @param {?function} callback Called after component is updated.
                                 * @param {?string} Name of the calling function in the public API.
                                 * @internal
                                 */ enqueueSetState: function enqueueSetState(publicInstance, partialState, callback, callerName) {
                                    warnNoop(publicInstance, "setState");
                                },
                            };
                            /**
                             * Base class helpers for the updating state of a component.
                             */ function Component(props, context, updater) {
                                this.props = props;
                                this.context = context;
                                this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
                                // renderer.
                                this.updater = updater || ReactNoopUpdateQueue;
                            }
                            Component.prototype.isReactComponent = {};
                            /**
                             * Sets a subset of the state. Always use this to mutate
                             * state. You should treat `this.state` as immutable.
                             *
                             * There is no guarantee that `this.state` will be immediately updated, so
                             * accessing `this.state` after calling this method may return the old value.
                             *
                             * There is no guarantee that calls to `setState` will run synchronously,
                             * as they may eventually be batched together.  You can provide an optional
                             * callback that will be executed when the call to setState is actually
                             * completed.
                             *
                             * When a function is provided to setState, it will be called at some point in
                             * the future (not synchronously). It will be called with the up to date
                             * component arguments (state, props, context). These values can be different
                             * from this.* because your function may be called after receiveProps but before
                             * shouldComponentUpdate, and this new state, props, and context will not yet be
                             * assigned to this.
                             *
                             * @param {object|function} partialState Next partial state or function to
                             *        produce next partial state to be merged with current state.
                             * @param {?function} callback Called after state is updated.
                             * @final
                             * @protected
                             */ Component.prototype.setState = function (partialState, callback) {
                                !(_typeof(partialState) === "object" || typeof partialState === "function" || partialState == null)
                                    ? invariant(false, "setState(...): takes an object of state variables to update or a function which returns an object of state variables.")
                                    : void 0;
                                this.updater.enqueueSetState(this, partialState, callback, "setState");
                            };
                            /**
                             * Forces an update. This should only be invoked when it is known with
                             * certainty that we are **not** in a DOM transaction.
                             *
                             * You may want to call this when you know that some deeper aspect of the
                             * component's state has changed but `setState` was not called.
                             *
                             * This will not invoke `shouldComponentUpdate`, but it will invoke
                             * `componentWillUpdate` and `componentDidUpdate`.
                             *
                             * @param {?function} callback Called after update is complete.
                             * @final
                             * @protected
                             */ Component.prototype.forceUpdate = function (callback) {
                                this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
                            };
                            /**
                             * Deprecated APIs. These APIs used to exist on classic React classes but since
                             * we would like to deprecate them, we're not going to move them over to this
                             * modern base class. Instead, we define a getter that warns if it's accessed.
                             */ {
                                var deprecatedAPIs = {
                                    isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in " + "componentWillUnmount to prevent memory leaks."],
                                    replaceState: ["replaceState", "Refactor your code to use setState instead (see " + "https://github.com/facebook/react/issues/3236)."],
                                };
                                var defineDeprecationWarning = function defineDeprecationWarning(methodName, info) {
                                    Object.defineProperty(Component.prototype, methodName, {
                                        get: function get() {
                                            lowPriorityWarning$1(false, "%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                                            return undefined;
                                        },
                                    });
                                };
                                for (var fnName in deprecatedAPIs) {
                                    if (deprecatedAPIs.hasOwnProperty(fnName)) {
                                        defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
                                    }
                                }
                            }
                            function ComponentDummy() {}
                            ComponentDummy.prototype = Component.prototype;
                            /**
                             * Convenience component with default shallow equality check for sCU.
                             */ function PureComponent(props, context, updater) {
                                this.props = props;
                                this.context = context;
                                this.refs = emptyObject;
                                this.updater = updater || ReactNoopUpdateQueue;
                            }
                            var pureComponentPrototype = (PureComponent.prototype = new ComponentDummy());
                            pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
                            _assign(pureComponentPrototype, Component.prototype);
                            pureComponentPrototype.isPureReactComponent = true; // an immutable object with a single mutable value
                            function createRef() {
                                var refObject = { current: null };
                                {
                                    Object.seal(refObject);
                                }
                                return refObject;
                            }
                            /**
                             * Keeps track of the current owner.
                             *
                             * The current owner is the component who should own any components that are
                             * currently being constructed.
                             */ var ReactCurrentOwner = {
                                /**
                                 * @internal
                                 * @type {ReactComponent}
                                 */ current: null,
                            };
                            var hasOwnProperty = Object.prototype.hasOwnProperty;
                            var RESERVED_PROPS = { key: true, ref: true, __self: true, __source: true };
                            var specialPropKeyWarningShown = void 0;
                            var specialPropRefWarningShown = void 0;
                            function hasValidRef(config) {
                                {
                                    if (hasOwnProperty.call(config, "ref")) {
                                        var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
                                        if (getter && getter.isReactWarning) {
                                            return false;
                                        }
                                    }
                                }
                                return config.ref !== undefined;
                            }
                            function hasValidKey(config) {
                                {
                                    if (hasOwnProperty.call(config, "key")) {
                                        var getter = Object.getOwnPropertyDescriptor(config, "key").get;
                                        if (getter && getter.isReactWarning) {
                                            return false;
                                        }
                                    }
                                }
                                return config.key !== undefined;
                            }
                            function defineKeyPropWarningGetter(props, displayName) {
                                var warnAboutAccessingKey = function warnAboutAccessingKey() {
                                    if (!specialPropKeyWarningShown) {
                                        specialPropKeyWarningShown = true;
                                        warning(
                                            false,
                                            "%s: `key` is not a prop. Trying to access it will result " +
                                                "in `undefined` being returned. If you need to access the same " +
                                                "value within the child component, you should pass it as a different " +
                                                "prop. (https://fb.me/react-special-props)",
                                            displayName
                                        );
                                    }
                                };
                                warnAboutAccessingKey.isReactWarning = true;
                                Object.defineProperty(props, "key", { get: warnAboutAccessingKey, configurable: true });
                            }
                            function defineRefPropWarningGetter(props, displayName) {
                                var warnAboutAccessingRef = function warnAboutAccessingRef() {
                                    if (!specialPropRefWarningShown) {
                                        specialPropRefWarningShown = true;
                                        warning(
                                            false,
                                            "%s: `ref` is not a prop. Trying to access it will result " +
                                                "in `undefined` being returned. If you need to access the same " +
                                                "value within the child component, you should pass it as a different " +
                                                "prop. (https://fb.me/react-special-props)",
                                            displayName
                                        );
                                    }
                                };
                                warnAboutAccessingRef.isReactWarning = true;
                                Object.defineProperty(props, "ref", { get: warnAboutAccessingRef, configurable: true });
                            }
                            /**
                             * Factory method to create a new React element. This no longer adheres to
                             * the class pattern, so do not use new to call it. Also, no instanceof check
                             * will work. Instead test $$typeof field against Symbol.for('react.element') to check
                             * if something is a React Element.
                             *
                             * @param {*} type
                             * @param {*} key
                             * @param {string|object} ref
                             * @param {*} self A *temporary* helper to detect places where `this` is
                             * different from the `owner` when React.createElement is called, so that we
                             * can warn. We want to get rid of owner and replace string `ref`s with arrow
                             * functions, and as long as `this` and owner are the same, there will be no
                             * change in behavior.
                             * @param {*} source An annotation object (added by a transpiler or otherwise)
                             * indicating filename, line number, and/or other information.
                             * @param {*} owner
                             * @param {*} props
                             * @internal
                             */ var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
                                var element = {
                                    // This tag allows us to uniquely identify this as a React Element
                                    $$typeof: REACT_ELEMENT_TYPE, // Built-in properties that belong on the element
                                    type: type,
                                    key: key,
                                    ref: ref,
                                    props: props, // Record the component responsible for creating this element.
                                    _owner: owner,
                                };
                                {
                                    // The validation flag is currently mutative. We put it on
                                    // an external backing store so that we can freeze the whole object.
                                    // This can be replaced with a WeakMap once they are implemented in
                                    // commonly used development environments.
                                    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
                                    // the validation flag non-enumerable (where possible, which should
                                    // include every environment we run tests in), so the test framework
                                    // ignores it.
                                    Object.defineProperty(element._store, "validated", { configurable: false, enumerable: false, writable: true, value: false }); // self and source are DEV only properties.
                                    Object.defineProperty(element, "_self", { configurable: false, enumerable: false, writable: false, value: self }); // Two elements created in two different places should be considered
                                    // equal for testing purposes and therefore we hide it from enumeration.
                                    Object.defineProperty(element, "_source", { configurable: false, enumerable: false, writable: false, value: source });
                                    if (Object.freeze) {
                                        Object.freeze(element.props);
                                        Object.freeze(element);
                                    }
                                }
                                return element;
                            };
                            /**
                             * Create and return a new ReactElement of the given type.
                             * See https://reactjs.org/docs/react-api.html#createelement
                             */ function createElement(type, config, children) {
                                var propName = void 0; // Reserved names are extracted
                                var props = {};
                                var key = null;
                                var ref = null;
                                var self = null;
                                var source = null;
                                if (config != null) {
                                    if (hasValidRef(config)) {
                                        ref = config.ref;
                                    }
                                    if (hasValidKey(config)) {
                                        key = "" + config.key;
                                    }
                                    self = config.__self === undefined ? null : config.__self;
                                    source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
                                    for (propName in config) {
                                        if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                                            props[propName] = config[propName];
                                        }
                                    }
                                } // Children can be more than one argument, and those are transferred onto
                                // the newly allocated props object.
                                var childrenLength = arguments.length - 2;
                                if (childrenLength === 1) {
                                    props.children = children;
                                } else if (childrenLength > 1) {
                                    var childArray = Array(childrenLength);
                                    for (var i = 0; i < childrenLength; i++) {
                                        childArray[i] = arguments[i + 2];
                                    }
                                    {
                                        if (Object.freeze) {
                                            Object.freeze(childArray);
                                        }
                                    }
                                    props.children = childArray;
                                } // Resolve default props
                                if (type && type.defaultProps) {
                                    var defaultProps = type.defaultProps;
                                    for (propName in defaultProps) {
                                        if (props[propName] === undefined) {
                                            props[propName] = defaultProps[propName];
                                        }
                                    }
                                }
                                {
                                    if (key || ref) {
                                        if (typeof props.$$typeof === "undefined" || props.$$typeof !== REACT_ELEMENT_TYPE) {
                                            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
                                            if (key) {
                                                defineKeyPropWarningGetter(props, displayName);
                                            }
                                            if (ref) {
                                                defineRefPropWarningGetter(props, displayName);
                                            }
                                        }
                                    }
                                }
                                return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
                            }
                            /**
                             * Return a function that produces ReactElements of a given type.
                             * See https://reactjs.org/docs/react-api.html#createfactory
                             */ function cloneAndReplaceKey(oldElement, newKey) {
                                var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
                                return newElement;
                            }
                            /**
                             * Clone and return a new ReactElement using element as the starting point.
                             * See https://reactjs.org/docs/react-api.html#cloneelement
                             */ function cloneElement(element, config, children) {
                                !!(element === null || element === undefined) ? invariant(false, "React.cloneElement(...): The argument must be a React element, but you passed %s.", element) : void 0;
                                var propName = void 0; // Original props are copied
                                var props = _assign({}, element.props); // Reserved names are extracted
                                var key = element.key;
                                var ref = element.ref; // Self is preserved since the owner is preserved.
                                var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
                                // transpiler, and the original source is probably a better indicator of the
                                // true owner.
                                var source = element._source; // Owner will be preserved, unless ref is overridden
                                var owner = element._owner;
                                if (config != null) {
                                    if (hasValidRef(config)) {
                                        // Silently steal the ref from the parent.
                                        ref = config.ref;
                                        owner = ReactCurrentOwner.current;
                                    }
                                    if (hasValidKey(config)) {
                                        key = "" + config.key;
                                    } // Remaining properties override existing props
                                    var defaultProps = void 0;
                                    if (element.type && element.type.defaultProps) {
                                        defaultProps = element.type.defaultProps;
                                    }
                                    for (propName in config) {
                                        if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                                            if (config[propName] === undefined && defaultProps !== undefined) {
                                                // Resolve default props
                                                props[propName] = defaultProps[propName];
                                            } else {
                                                props[propName] = config[propName];
                                            }
                                        }
                                    }
                                } // Children can be more than one argument, and those are transferred onto
                                // the newly allocated props object.
                                var childrenLength = arguments.length - 2;
                                if (childrenLength === 1) {
                                    props.children = children;
                                } else if (childrenLength > 1) {
                                    var childArray = Array(childrenLength);
                                    for (var i = 0; i < childrenLength; i++) {
                                        childArray[i] = arguments[i + 2];
                                    }
                                    props.children = childArray;
                                }
                                return ReactElement(element.type, key, ref, self, source, owner, props);
                            }
                            /**
                             * Verifies the object is a ReactElement.
                             * See https://reactjs.org/docs/react-api.html#isvalidelement
                             * @param {?object} object
                             * @return {boolean} True if `object` is a valid component.
                             * @final
                             */ function isValidElement(object) {
                                return _typeof(object) === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
                            }
                            var ReactDebugCurrentFrame = {};
                            {
                                // Component that is being worked on
                                ReactDebugCurrentFrame.getCurrentStack = null;
                                ReactDebugCurrentFrame.getStackAddendum = function () {
                                    var impl = ReactDebugCurrentFrame.getCurrentStack;
                                    if (impl) {
                                        return impl();
                                    }
                                    return null;
                                };
                            }
                            var SEPARATOR = ".";
                            var SUBSEPARATOR = ":";
                            /**
                             * Escape and wrap key so it is safe to use as a reactid
                             *
                             * @param {string} key to be escaped.
                             * @return {string} the escaped key.
                             */ function escape(key) {
                                var escapeRegex = /[=:]/g;
                                var escaperLookup = { "=": "=0", ":": "=2" };
                                var escapedString = ("" + key).replace(escapeRegex, function (match) {
                                    return escaperLookup[match];
                                });
                                return "$" + escapedString;
                            }
                            /**
                             * TODO: Test that a single child and an array with one item have the same key
                             * pattern.
                             */ var didWarnAboutMaps = false;
                            var userProvidedKeyEscapeRegex = /\/+/g;
                            function escapeUserProvidedKey(text) {
                                return ("" + text).replace(userProvidedKeyEscapeRegex, "$&/");
                            }
                            var POOL_SIZE = 10;
                            var traverseContextPool = [];
                            function getPooledTraverseContext(mapResult, keyPrefix, mapFunction, mapContext) {
                                if (traverseContextPool.length) {
                                    var traverseContext = traverseContextPool.pop();
                                    traverseContext.result = mapResult;
                                    traverseContext.keyPrefix = keyPrefix;
                                    traverseContext.func = mapFunction;
                                    traverseContext.context = mapContext;
                                    traverseContext.count = 0;
                                    return traverseContext;
                                } else {
                                    return { result: mapResult, keyPrefix: keyPrefix, func: mapFunction, context: mapContext, count: 0 };
                                }
                            }
                            function releaseTraverseContext(traverseContext) {
                                traverseContext.result = null;
                                traverseContext.keyPrefix = null;
                                traverseContext.func = null;
                                traverseContext.context = null;
                                traverseContext.count = 0;
                                if (traverseContextPool.length < POOL_SIZE) {
                                    traverseContextPool.push(traverseContext);
                                }
                            }
                            /**
                             * @param {?*} children Children tree container.
                             * @param {!string} nameSoFar Name of the key path so far.
                             * @param {!function} callback Callback to invoke with each child found.
                             * @param {?*} traverseContext Used to pass information throughout the traversal
                             * process.
                             * @return {!number} The number of children in this subtree.
                             */ function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
                                var type = _typeof(children);
                                if (type === "undefined" || type === "boolean") {
                                    // All of the above are perceived as null.
                                    children = null;
                                }
                                var invokeCallback = false;
                                if (children === null) {
                                    invokeCallback = true;
                                } else {
                                    switch (type) {
                                        case "string":
                                        case "number":
                                            invokeCallback = true;
                                            break;
                                        case "object":
                                            switch (children.$$typeof) {
                                                case REACT_ELEMENT_TYPE:
                                                case REACT_PORTAL_TYPE:
                                                    invokeCallback = true;
                                            }
                                    }
                                }
                                if (invokeCallback) {
                                    callback(
                                        traverseContext,
                                        children, // If it's the only child, treat the name as if it was wrapped in an array
                                        // so that it's consistent if the number of children grows.
                                        nameSoFar === "" ? SEPARATOR + getComponentKey(children, 0) : nameSoFar
                                    );
                                    return 1;
                                }
                                var child = void 0;
                                var nextName = void 0;
                                var subtreeCount = 0; // Count of children found in the current subtree.
                                var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
                                if (Array.isArray(children)) {
                                    for (var i = 0; i < children.length; i++) {
                                        child = children[i];
                                        nextName = nextNamePrefix + getComponentKey(child, i);
                                        subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                                    }
                                } else {
                                    var iteratorFn = getIteratorFn(children);
                                    if (typeof iteratorFn === "function") {
                                        {
                                            // Warn about using Maps as children
                                            if (iteratorFn === children.entries) {
                                                !didWarnAboutMaps
                                                    ? warning(
                                                          false,
                                                          "Using Maps as children is unsupported and will likely yield " + "unexpected results. Convert it to a sequence/iterable of keyed " + "ReactElements instead.%s",
                                                          ReactDebugCurrentFrame.getStackAddendum()
                                                      )
                                                    : void 0;
                                                didWarnAboutMaps = true;
                                            }
                                        }
                                        var iterator = iteratorFn.call(children);
                                        var step = void 0;
                                        var ii = 0;
                                        while (!(step = iterator.next()).done) {
                                            child = step.value;
                                            nextName = nextNamePrefix + getComponentKey(child, ii++);
                                            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                                        }
                                    } else if (type === "object") {
                                        var addendum = "";
                                        {
                                            addendum = " If you meant to render a collection of children, use an array " + "instead." + ReactDebugCurrentFrame.getStackAddendum();
                                        }
                                        var childrenString = "" + children;
                                        invariant(
                                            false,
                                            "Objects are not valid as a React child (found: %s).%s",
                                            childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString,
                                            addendum
                                        );
                                    }
                                }
                                return subtreeCount;
                            }
                            /**
                             * Traverses children that are typically specified as `props.children`, but
                             * might also be specified through attributes:
                             *
                             * - `traverseAllChildren(this.props.children, ...)`
                             * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
                             *
                             * The `traverseContext` is an optional argument that is passed through the
                             * entire traversal. It can be used to store accumulations or anything else that
                             * the callback might find relevant.
                             *
                             * @param {?*} children Children tree object.
                             * @param {!function} callback To invoke upon traversing each child.
                             * @param {?*} traverseContext Context for traversal.
                             * @return {!number} The number of children in this subtree.
                             */ function traverseAllChildren(children, callback, traverseContext) {
                                if (children == null) {
                                    return 0;
                                }
                                return traverseAllChildrenImpl(children, "", callback, traverseContext);
                            }
                            /**
                             * Generate a key string that identifies a component within a set.
                             *
                             * @param {*} component A component that could contain a manual key.
                             * @param {number} index Index that is used if a manual key is not provided.
                             * @return {string}
                             */ function getComponentKey(component, index) {
                                // Do some typechecking here since we call this blindly. We want to ensure
                                // that we don't block potential future ES APIs.
                                if (_typeof(component) === "object" && component !== null && component.key != null) {
                                    // Explicit key
                                    return escape(component.key);
                                } // Implicit key determined by the index in the set
                                return index.toString(36);
                            }
                            function forEachSingleChild(bookKeeping, child, name) {
                                var func = bookKeeping.func,
                                    context = bookKeeping.context;
                                func.call(context, child, bookKeeping.count++);
                            }
                            /**
                             * Iterates through children that are typically specified as `props.children`.
                             *
                             * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
                             *
                             * The provided forEachFunc(child, index) will be called for each
                             * leaf child.
                             *
                             * @param {?*} children Children tree container.
                             * @param {function(*, int)} forEachFunc
                             * @param {*} forEachContext Context for forEachContext.
                             */ function forEachChildren(children, forEachFunc, forEachContext) {
                                if (children == null) {
                                    return children;
                                }
                                var traverseContext = getPooledTraverseContext(null, null, forEachFunc, forEachContext);
                                traverseAllChildren(children, forEachSingleChild, traverseContext);
                                releaseTraverseContext(traverseContext);
                            }
                            function mapSingleChildIntoContext(bookKeeping, child, childKey) {
                                var result = bookKeeping.result,
                                    keyPrefix = bookKeeping.keyPrefix,
                                    func = bookKeeping.func,
                                    context = bookKeeping.context;
                                var mappedChild = func.call(context, child, bookKeeping.count++);
                                if (Array.isArray(mappedChild)) {
                                    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
                                } else if (mappedChild != null) {
                                    if (isValidElement(mappedChild)) {
                                        mappedChild = cloneAndReplaceKey(
                                            mappedChild, // Keep both the (mapped) and old keys if they differ, just as
                                            // traverseAllChildren used to do for objects as children
                                            keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + "/" : "") + childKey
                                        );
                                    }
                                    result.push(mappedChild);
                                }
                            }
                            function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
                                var escapedPrefix = "";
                                if (prefix != null) {
                                    escapedPrefix = escapeUserProvidedKey(prefix) + "/";
                                }
                                var traverseContext = getPooledTraverseContext(array, escapedPrefix, func, context);
                                traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
                                releaseTraverseContext(traverseContext);
                            }
                            /**
                             * Maps children that are typically specified as `props.children`.
                             *
                             * See https://reactjs.org/docs/react-api.html#reactchildrenmap
                             *
                             * The provided mapFunction(child, key, index) will be called for each
                             * leaf child.
                             *
                             * @param {?*} children Children tree container.
                             * @param {function(*, int)} func The map function.
                             * @param {*} context Context for mapFunction.
                             * @return {object} Object containing the ordered map of results.
                             */ function mapChildren(children, func, context) {
                                if (children == null) {
                                    return children;
                                }
                                var result = [];
                                mapIntoWithKeyPrefixInternal(children, result, null, func, context);
                                return result;
                            }
                            /**
                             * Count the number of children that are typically specified as
                             * `props.children`.
                             *
                             * See https://reactjs.org/docs/react-api.html#reactchildrencount
                             *
                             * @param {?*} children Children tree container.
                             * @return {number} The number of children.
                             */ function countChildren(children) {
                                return traverseAllChildren(children, emptyFunction.thatReturnsNull, null);
                            }
                            /**
                             * Flatten a children object (typically specified as `props.children`) and
                             * return an array with appropriately re-keyed children.
                             *
                             * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
                             */ function toArray(children) {
                                var result = [];
                                mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
                                return result;
                            }
                            /**
                             * Returns the first child in a collection of children and verifies that there
                             * is only one child in the collection.
                             *
                             * See https://reactjs.org/docs/react-api.html#reactchildrenonly
                             *
                             * The current implementation of this function assumes that a single child gets
                             * passed without a wrapper, but the purpose of this helper function is to
                             * abstract away the particular structure of children.
                             *
                             * @param {?object} children Child collection structure.
                             * @return {ReactElement} The first and only `ReactElement` contained in the
                             * structure.
                             */ function onlyChild(children) {
                                !isValidElement(children) ? invariant(false, "React.Children.only expected to receive a single React element child.") : void 0;
                                return children;
                            }
                            function createContext(defaultValue, calculateChangedBits) {
                                if (calculateChangedBits === undefined) {
                                    calculateChangedBits = null;
                                } else {
                                    {
                                        !(calculateChangedBits === null || typeof calculateChangedBits === "function")
                                            ? warning(false, "createContext: Expected the optional second argument to be a " + "function. Instead received: %s", calculateChangedBits)
                                            : void 0;
                                    }
                                }
                                var context = {
                                    $$typeof: REACT_CONTEXT_TYPE,
                                    _calculateChangedBits: calculateChangedBits,
                                    _defaultValue: defaultValue,
                                    _currentValue: defaultValue, // As a workaround to support multiple concurrent renderers, we categorize
                                    // some renderers as primary and others as secondary. We only expect
                                    // there to be two concurrent renderers at most: React Native (primary) and
                                    // Fabric (secondary); React DOM (primary) and React ART (secondary).
                                    // Secondary renderers store their context values on separate fields.
                                    _currentValue2: defaultValue,
                                    _changedBits: 0,
                                    _changedBits2: 0, // These are circular
                                    Provider: null,
                                    Consumer: null,
                                };
                                context.Provider = { $$typeof: REACT_PROVIDER_TYPE, _context: context };
                                context.Consumer = context;
                                {
                                    context._currentRenderer = null;
                                    context._currentRenderer2 = null;
                                }
                                return context;
                            }
                            function forwardRef(render) {
                                {
                                    !(typeof render === "function") ? warning(false, "forwardRef requires a render function but was given %s.", render === null ? "null" : _typeof(render)) : void 0;
                                    if (render != null) {
                                        !(render.defaultProps == null && render.propTypes == null)
                                            ? warning(false, "forwardRef render functions do not support propTypes or defaultProps. " + "Did you accidentally pass a React component?")
                                            : void 0;
                                    }
                                }
                                return { $$typeof: REACT_FORWARD_REF_TYPE, render: render };
                            }
                            var describeComponentFrame = function describeComponentFrame(name, source, ownerName) {
                                return "\n    in " + (name || "Unknown") + (source ? " (at " + source.fileName.replace(/^.*[\\\/]/, "") + ":" + source.lineNumber + ")" : ownerName ? " (created by " + ownerName + ")" : "");
                            };
                            function isValidElementType(type) {
                                return (
                                    typeof type === "string" ||
                                    typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                                    type === REACT_FRAGMENT_TYPE ||
                                    type === REACT_ASYNC_MODE_TYPE ||
                                    type === REACT_PROFILER_TYPE ||
                                    type === REACT_STRICT_MODE_TYPE ||
                                    type === REACT_TIMEOUT_TYPE ||
                                    (_typeof(type) === "object" && type !== null && (type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE))
                                );
                            }
                            function getComponentName(fiber) {
                                var type = fiber.type;
                                if (typeof type === "function") {
                                    return type.displayName || type.name;
                                }
                                if (typeof type === "string") {
                                    return type;
                                }
                                switch (type) {
                                    case REACT_ASYNC_MODE_TYPE:
                                        return "AsyncMode";
                                    case REACT_CONTEXT_TYPE:
                                        return "Context.Consumer";
                                    case REACT_FRAGMENT_TYPE:
                                        return "ReactFragment";
                                    case REACT_PORTAL_TYPE:
                                        return "ReactPortal";
                                    case REACT_PROFILER_TYPE:
                                        return "Profiler(" + fiber.pendingProps.id + ")";
                                    case REACT_PROVIDER_TYPE:
                                        return "Context.Provider";
                                    case REACT_STRICT_MODE_TYPE:
                                        return "StrictMode";
                                    case REACT_TIMEOUT_TYPE:
                                        return "Timeout";
                                }
                                if (_typeof(type) === "object" && type !== null) {
                                    switch (type.$$typeof) {
                                        case REACT_FORWARD_REF_TYPE:
                                            var functionName = type.render.displayName || type.render.name || "";
                                            return functionName !== "" ? "ForwardRef(" + functionName + ")" : "ForwardRef";
                                    }
                                }
                                return null;
                            }
                            /**
                             * ReactElementValidator provides a wrapper around a element factory
                             * which validates the props passed to the element. This is intended to be
                             * used only in DEV and could be replaced by a static type checker for languages
                             * that support it.
                             */ var currentlyValidatingElement = void 0;
                            var propTypesMisspellWarningShown = void 0;
                            var getDisplayName = function getDisplayName() {};
                            var getStackAddendum = function getStackAddendum() {};
                            {
                                currentlyValidatingElement = null;
                                propTypesMisspellWarningShown = false;
                                getDisplayName = function getDisplayName(element) {
                                    if (element == null) {
                                        return "#empty";
                                    } else if (typeof element === "string" || typeof element === "number") {
                                        return "#text";
                                    } else if (typeof element.type === "string") {
                                        return element.type;
                                    }
                                    var type = element.type;
                                    if (type === REACT_FRAGMENT_TYPE) {
                                        return "React.Fragment";
                                    } else if (_typeof(type) === "object" && type !== null && type.$$typeof === REACT_FORWARD_REF_TYPE) {
                                        var functionName = type.render.displayName || type.render.name || "";
                                        return functionName !== "" ? "ForwardRef(" + functionName + ")" : "ForwardRef";
                                    } else {
                                        return type.displayName || type.name || "Unknown";
                                    }
                                };
                                getStackAddendum = function getStackAddendum() {
                                    var stack = "";
                                    if (currentlyValidatingElement) {
                                        var name = getDisplayName(currentlyValidatingElement);
                                        var owner = currentlyValidatingElement._owner;
                                        stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner));
                                    }
                                    stack += ReactDebugCurrentFrame.getStackAddendum() || "";
                                    return stack;
                                };
                            }
                            function getDeclarationErrorAddendum() {
                                if (ReactCurrentOwner.current) {
                                    var name = getComponentName(ReactCurrentOwner.current);
                                    if (name) {
                                        return "\n\nCheck the render method of `" + name + "`.";
                                    }
                                }
                                return "";
                            }
                            function getSourceInfoErrorAddendum(elementProps) {
                                if (elementProps !== null && elementProps !== undefined && elementProps.__source !== undefined) {
                                    var source = elementProps.__source;
                                    var fileName = source.fileName.replace(/^.*[\\\/]/, "");
                                    var lineNumber = source.lineNumber;
                                    return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
                                }
                                return "";
                            }
                            /**
                             * Warn if there's no key explicitly set on dynamic arrays of children or
                             * object keys are not valid. This allows us to keep track of children between
                             * updates.
                             */ var ownerHasKeyUseWarning = {};
                            function getCurrentComponentErrorInfo(parentType) {
                                var info = getDeclarationErrorAddendum();
                                if (!info) {
                                    var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
                                    if (parentName) {
                                        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
                                    }
                                }
                                return info;
                            }
                            /**
                             * Warn if the element doesn't have an explicit key assigned to it.
                             * This element is in an array. The array could grow and shrink or be
                             * reordered. All children that haven't already been validated are required to
                             * have a "key" property assigned to it. Error statuses are cached so a warning
                             * will only be shown once.
                             *
                             * @internal
                             * @param {ReactElement} element Element that requires a key.
                             * @param {*} parentType element's parent's type.
                             */ function validateExplicitKey(element, parentType) {
                                if (!element._store || element._store.validated || element.key != null) {
                                    return;
                                }
                                element._store.validated = true;
                                var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
                                if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
                                    return;
                                }
                                ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
                                // property, it may be the creator of the child that's responsible for
                                // assigning it a key.
                                var childOwner = "";
                                if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
                                    // Give the component that originally created this child.
                                    childOwner = " It was passed a child from " + getComponentName(element._owner) + ".";
                                }
                                currentlyValidatingElement = element;
                                {
                                    warning(
                                        false,
                                        'Each child in an array or iterator should have a unique "key" prop.' + "%s%s See https://fb.me/react-warning-keys for more information.%s",
                                        currentComponentErrorInfo,
                                        childOwner,
                                        getStackAddendum()
                                    );
                                }
                                currentlyValidatingElement = null;
                            }
                            /**
                             * Ensure that every element either is passed in a static location, in an
                             * array with an explicit keys property defined, or in an object literal
                             * with valid key property.
                             *
                             * @internal
                             * @param {ReactNode} node Statically passed child of any type.
                             * @param {*} parentType node's parent's type.
                             */ function validateChildKeys(node, parentType) {
                                if (_typeof(node) !== "object") {
                                    return;
                                }
                                if (Array.isArray(node)) {
                                    for (var i = 0; i < node.length; i++) {
                                        var child = node[i];
                                        if (isValidElement(child)) {
                                            validateExplicitKey(child, parentType);
                                        }
                                    }
                                } else if (isValidElement(node)) {
                                    // This element was passed in a valid location.
                                    if (node._store) {
                                        node._store.validated = true;
                                    }
                                } else if (node) {
                                    var iteratorFn = getIteratorFn(node);
                                    if (typeof iteratorFn === "function") {
                                        // Entry iterators used to provide implicit keys,
                                        // but now we print a separate warning for them later.
                                        if (iteratorFn !== node.entries) {
                                            var iterator = iteratorFn.call(node);
                                            var step = void 0;
                                            while (!(step = iterator.next()).done) {
                                                if (isValidElement(step.value)) {
                                                    validateExplicitKey(step.value, parentType);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            /**
                             * Given an element, validate that its props follow the propTypes definition,
                             * provided by the type.
                             *
                             * @param {ReactElement} element
                             */ function validatePropTypes(element) {
                                var type = element.type;
                                var name = void 0,
                                    propTypes = void 0;
                                if (typeof type === "function") {
                                    // Class or functional component
                                    name = type.displayName || type.name;
                                    propTypes = type.propTypes;
                                } else if (_typeof(type) === "object" && type !== null && type.$$typeof === REACT_FORWARD_REF_TYPE) {
                                    // ForwardRef
                                    var functionName = type.render.displayName || type.render.name || "";
                                    name = functionName !== "" ? "ForwardRef(" + functionName + ")" : "ForwardRef";
                                    propTypes = type.propTypes;
                                } else {
                                    return;
                                }
                                if (propTypes) {
                                    currentlyValidatingElement = element;
                                    checkPropTypes(propTypes, element.props, "prop", name, getStackAddendum);
                                    currentlyValidatingElement = null;
                                } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
                                    propTypesMisspellWarningShown = true;
                                    warning(false, "Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", name || "Unknown");
                                }
                                if (typeof type.getDefaultProps === "function") {
                                    !type.getDefaultProps.isReactClassApproved ? warning(false, "getDefaultProps is only used on classic React.createClass " + "definitions. Use a static property named `defaultProps` instead.") : void 0;
                                }
                            }
                            /**
                             * Given a fragment, validate that it can only be provided with fragment props
                             * @param {ReactElement} fragment
                             */ function validateFragmentProps(fragment) {
                                currentlyValidatingElement = fragment;
                                var keys = Object.keys(fragment.props);
                                for (var i = 0; i < keys.length; i++) {
                                    var key = keys[i];
                                    if (key !== "children" && key !== "key") {
                                        warning(false, "Invalid prop `%s` supplied to `React.Fragment`. " + "React.Fragment can only have `key` and `children` props.%s", key, getStackAddendum());
                                        break;
                                    }
                                }
                                if (fragment.ref !== null) {
                                    warning(false, "Invalid attribute `ref` supplied to `React.Fragment`.%s", getStackAddendum());
                                }
                                currentlyValidatingElement = null;
                            }
                            function createElementWithValidation(type, props, children) {
                                var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
                                // succeed and there will likely be errors in render.
                                if (!validType) {
                                    var info = "";
                                    if (type === undefined || (_typeof(type) === "object" && type !== null && Object.keys(type).length === 0)) {
                                        info += " You likely forgot to export your component from the file " + "it's defined in, or you might have mixed up default and named imports.";
                                    }
                                    var sourceInfo = getSourceInfoErrorAddendum(props);
                                    if (sourceInfo) {
                                        info += sourceInfo;
                                    } else {
                                        info += getDeclarationErrorAddendum();
                                    }
                                    info += getStackAddendum() || "";
                                    var typeString = void 0;
                                    if (type === null) {
                                        typeString = "null";
                                    } else if (Array.isArray(type)) {
                                        typeString = "array";
                                    } else {
                                        typeString = _typeof(type);
                                    }
                                    warning(false, "React.createElement: type is invalid -- expected a string (for " + "built-in components) or a class/function (for composite " + "components) but got: %s.%s", typeString, info);
                                }
                                var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
                                // TODO: Drop this when these are no longer allowed as the type argument.
                                if (element == null) {
                                    return element;
                                } // Skip key warning if the type isn't valid since our key validation logic
                                // doesn't expect a non-string/function type and can throw confusing errors.
                                // We don't want exception behavior to differ between dev and prod.
                                // (Rendering will throw with a helpful message and as soon as the type is
                                // fixed, the key warnings will appear.)
                                if (validType) {
                                    for (var i = 2; i < arguments.length; i++) {
                                        validateChildKeys(arguments[i], type);
                                    }
                                }
                                if (type === REACT_FRAGMENT_TYPE) {
                                    validateFragmentProps(element);
                                } else {
                                    validatePropTypes(element);
                                }
                                return element;
                            }
                            function createFactoryWithValidation(type) {
                                var validatedFactory = createElementWithValidation.bind(null, type);
                                validatedFactory.type = type; // Legacy hook: remove it
                                {
                                    Object.defineProperty(validatedFactory, "type", {
                                        enumerable: false,
                                        get: function get() {
                                            lowPriorityWarning$1(false, "Factory.type is deprecated. Access the class directly " + "before passing it to createFactory.");
                                            Object.defineProperty(this, "type", { value: type });
                                            return type;
                                        },
                                    });
                                }
                                return validatedFactory;
                            }
                            function cloneElementWithValidation(element, props, children) {
                                var newElement = cloneElement.apply(this, arguments);
                                for (var i = 2; i < arguments.length; i++) {
                                    validateChildKeys(arguments[i], newElement.type);
                                }
                                validatePropTypes(newElement);
                                return newElement;
                            }
                            var React = {
                                Children: { map: mapChildren, forEach: forEachChildren, count: countChildren, toArray: toArray, only: onlyChild },
                                createRef: createRef,
                                Component: Component,
                                PureComponent: PureComponent,
                                createContext: createContext,
                                forwardRef: forwardRef,
                                Fragment: REACT_FRAGMENT_TYPE,
                                StrictMode: REACT_STRICT_MODE_TYPE,
                                unstable_AsyncMode: REACT_ASYNC_MODE_TYPE,
                                unstable_Profiler: REACT_PROFILER_TYPE,
                                createElement: createElementWithValidation,
                                cloneElement: cloneElementWithValidation,
                                createFactory: createFactoryWithValidation,
                                isValidElement: isValidElement,
                                version: ReactVersion,
                                __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
                                    ReactCurrentOwner: ReactCurrentOwner, // Used by renderers to avoid bundling object-assign twice in UMD bundles:
                                    assign: _assign,
                                },
                            };
                            if (enableSuspense) {
                                React.Timeout = REACT_TIMEOUT_TYPE;
                            }
                            {
                                _assign(React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, {
                                    // These should not be included in production.
                                    ReactDebugCurrentFrame: ReactDebugCurrentFrame, // Shim for React DOM 16.0.0 which still destructured (but not used) this.
                                    // TODO: remove in React 17.0.
                                    ReactComponentTreeHook: {},
                                });
                            }
                            var React$2 = Object.freeze({ default: React });
                            var React$3 = (React$2 && React) || React$2; // TODO: decide on the top-level export form.
                            // This is hacky but makes it work with both Rollup and Jest.
                            var react = React$3["default"] ? React$3["default"] : React$3;
                            module.exports = react;
                        })();
                    }
                }.call(this, require("rH1JPG")));
            },
            { "fbjs/lib/emptyFunction": 55, "fbjs/lib/emptyObject": 56, "fbjs/lib/invariant": 57, "fbjs/lib/warning": 58, "object-assign": 65, "prop-types/checkPropTypes": 67, rH1JPG: 66 },
        ],
        73: [
            function (require, module, exports) {
                /** @license React v16.4.2
                 * react.production.min.js
                 *
                 * Copyright (c) 2013-present, Facebook, Inc.
                 *
                 * This source code is licensed under the MIT license found in the
                 * LICENSE file in the root directory of this source tree.
                 */ "use strict";
                var k = require("object-assign"),
                    n = require("fbjs/lib/invariant"),
                    p = require("fbjs/lib/emptyObject"),
                    q = require("fbjs/lib/emptyFunction"),
                    r = "function" === typeof Symbol && Symbol["for"],
                    t = r ? Symbol["for"]("react.element") : 60103,
                    u = r ? Symbol["for"]("react.portal") : 60106,
                    v = r ? Symbol["for"]("react.fragment") : 60107,
                    w = r ? Symbol["for"]("react.strict_mode") : 60108,
                    x = r ? Symbol["for"]("react.profiler") : 60114,
                    y = r ? Symbol["for"]("react.provider") : 60109,
                    z = r ? Symbol["for"]("react.context") : 60110,
                    A = r ? Symbol["for"]("react.async_mode") : 60111,
                    B = r ? Symbol["for"]("react.forward_ref") : 60112;
                r && Symbol["for"]("react.timeout");
                var C = "function" === typeof Symbol && Symbol.iterator;
                function D(a) {
                    for (var b = arguments.length - 1, e = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 0; c < b; c++) {
                        e += "&args[]=" + encodeURIComponent(arguments[c + 1]);
                    }
                    n(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", e);
                }
                var E = {
                    isMounted: function isMounted() {
                        return !1;
                    },
                    enqueueForceUpdate: function enqueueForceUpdate() {},
                    enqueueReplaceState: function enqueueReplaceState() {},
                    enqueueSetState: function enqueueSetState() {},
                };
                function F(a, b, e) {
                    this.props = a;
                    this.context = b;
                    this.refs = p;
                    this.updater = e || E;
                }
                F.prototype.isReactComponent = {};
                F.prototype.setState = function (a, b) {
                    "object" !== _typeof(a) && "function" !== typeof a && null != a ? D("85") : void 0;
                    this.updater.enqueueSetState(this, a, b, "setState");
                };
                F.prototype.forceUpdate = function (a) {
                    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
                };
                function G() {}
                G.prototype = F.prototype;
                function H(a, b, e) {
                    this.props = a;
                    this.context = b;
                    this.refs = p;
                    this.updater = e || E;
                }
                var I = (H.prototype = new G());
                I.constructor = H;
                k(I, F.prototype);
                I.isPureReactComponent = !0;
                var J = { current: null },
                    K = Object.prototype.hasOwnProperty,
                    L = { key: !0, ref: !0, __self: !0, __source: !0 };
                function M(a, b, e) {
                    var c = void 0,
                        d = {},
                        g = null,
                        h = null;
                    if (null != b)
                        for (c in (void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (g = "" + b.key), b)) {
                            K.call(b, c) && !L.hasOwnProperty(c) && (d[c] = b[c]);
                        }
                    var f = arguments.length - 2;
                    if (1 === f) d.children = e;
                    else if (1 < f) {
                        for (var l = Array(f), m = 0; m < f; m++) {
                            l[m] = arguments[m + 2];
                        }
                        d.children = l;
                    }
                    if (a && a.defaultProps)
                        for (c in ((f = a.defaultProps), f)) {
                            void 0 === d[c] && (d[c] = f[c]);
                        }
                    return { $$typeof: t, type: a, key: g, ref: h, props: d, _owner: J.current };
                }
                function N(a) {
                    return "object" === _typeof(a) && null !== a && a.$$typeof === t;
                }
                function escape(a) {
                    var b = { "=": "=0", ":": "=2" };
                    return (
                        "$" +
                        ("" + a).replace(/[=:]/g, function (a) {
                            return b[a];
                        })
                    );
                }
                var O = /\/+/g,
                    P = [];
                function Q(a, b, e, c) {
                    if (P.length) {
                        var d = P.pop();
                        d.result = a;
                        d.keyPrefix = b;
                        d.func = e;
                        d.context = c;
                        d.count = 0;
                        return d;
                    }
                    return { result: a, keyPrefix: b, func: e, context: c, count: 0 };
                }
                function R(a) {
                    a.result = null;
                    a.keyPrefix = null;
                    a.func = null;
                    a.context = null;
                    a.count = 0;
                    10 > P.length && P.push(a);
                }
                function S(a, b, e, c) {
                    var d = _typeof(a);
                    if ("undefined" === d || "boolean" === d) a = null;
                    var g = !1;
                    if (null === a) g = !0;
                    else
                        switch (d) {
                            case "string":
                            case "number":
                                g = !0;
                                break;
                            case "object":
                                switch (a.$$typeof) {
                                    case t:
                                    case u:
                                        g = !0;
                                }
                        }
                    if (g) return e(c, a, "" === b ? "." + T(a, 0) : b), 1;
                    g = 0;
                    b = "" === b ? "." : b + ":";
                    if (Array.isArray(a))
                        for (var h = 0; h < a.length; h++) {
                            d = a[h];
                            var f = b + T(d, h);
                            g += S(d, f, e, c);
                        }
                    else if ((null === a || "undefined" === typeof a ? (f = null) : ((f = (C && a[C]) || a["@@iterator"]), (f = "function" === typeof f ? f : null)), "function" === typeof f))
                        for (a = f.call(a), h = 0; !(d = a.next()).done; ) {
                            (d = d.value), (f = b + T(d, h++)), (g += S(d, f, e, c));
                        }
                    else "object" === d && ((e = "" + a), D("31", "[object Object]" === e ? "object with keys {" + Object.keys(a).join(", ") + "}" : e, ""));
                    return g;
                }
                function T(a, b) {
                    return "object" === _typeof(a) && null !== a && null != a.key ? escape(a.key) : b.toString(36);
                }
                function U(a, b) {
                    a.func.call(a.context, b, a.count++);
                }
                function V(a, b, e) {
                    var c = a.result,
                        d = a.keyPrefix;
                    a = a.func.call(a.context, b, a.count++);
                    Array.isArray(a)
                        ? W(a, c, e, q.thatReturnsArgument)
                        : null != a &&
                          (N(a) && ((b = d + (!a.key || (b && b.key === a.key) ? "" : ("" + a.key).replace(O, "$&/") + "/") + e), (a = { $$typeof: t, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner })), c.push(a));
                }
                function W(a, b, e, c, d) {
                    var g = "";
                    null != e && (g = ("" + e).replace(O, "$&/") + "/");
                    b = Q(b, g, c, d);
                    null == a || S(a, "", V, b);
                    R(b);
                }
                var X = {
                        Children: {
                            map: function map(a, b, e) {
                                if (null == a) return a;
                                var c = [];
                                W(a, c, null, b, e);
                                return c;
                            },
                            forEach: function forEach(a, b, e) {
                                if (null == a) return a;
                                b = Q(null, null, b, e);
                                null == a || S(a, "", U, b);
                                R(b);
                            },
                            count: function count(a) {
                                return null == a ? 0 : S(a, "", q.thatReturnsNull, null);
                            },
                            toArray: function toArray(a) {
                                var b = [];
                                W(a, b, null, q.thatReturnsArgument);
                                return b;
                            },
                            only: function only(a) {
                                N(a) ? void 0 : D("143");
                                return a;
                            },
                        },
                        createRef: function createRef() {
                            return { current: null };
                        },
                        Component: F,
                        PureComponent: H,
                        createContext: function createContext(a, b) {
                            void 0 === b && (b = null);
                            a = { $$typeof: z, _calculateChangedBits: b, _defaultValue: a, _currentValue: a, _currentValue2: a, _changedBits: 0, _changedBits2: 0, Provider: null, Consumer: null };
                            a.Provider = { $$typeof: y, _context: a };
                            return (a.Consumer = a);
                        },
                        forwardRef: function forwardRef(a) {
                            return { $$typeof: B, render: a };
                        },
                        Fragment: v,
                        StrictMode: w,
                        unstable_AsyncMode: A,
                        unstable_Profiler: x,
                        createElement: M,
                        cloneElement: function cloneElement(a, b, e) {
                            null === a || void 0 === a ? D("267", a) : void 0;
                            var c = void 0,
                                d = k({}, a.props),
                                g = a.key,
                                h = a.ref,
                                f = a._owner;
                            if (null != b) {
                                void 0 !== b.ref && ((h = b.ref), (f = J.current));
                                void 0 !== b.key && (g = "" + b.key);
                                var l = void 0;
                                a.type && a.type.defaultProps && (l = a.type.defaultProps);
                                for (c in b) {
                                    K.call(b, c) && !L.hasOwnProperty(c) && (d[c] = void 0 === b[c] && void 0 !== l ? l[c] : b[c]);
                                }
                            }
                            c = arguments.length - 2;
                            if (1 === c) d.children = e;
                            else if (1 < c) {
                                l = Array(c);
                                for (var m = 0; m < c; m++) {
                                    l[m] = arguments[m + 2];
                                }
                                d.children = l;
                            }
                            return { $$typeof: t, type: a.type, key: g, ref: h, props: d, _owner: f };
                        },
                        createFactory: function createFactory(a) {
                            var b = M.bind(null, a);
                            b.type = a;
                            return b;
                        },
                        isValidElement: N,
                        version: "16.4.2",
                        __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { ReactCurrentOwner: J, assign: k },
                    },
                    Y = { default: X },
                    Z = (Y && X) || Y;
                module.exports = Z["default"] ? Z["default"] : Z;
            },
            { "fbjs/lib/emptyFunction": 55, "fbjs/lib/emptyObject": 56, "fbjs/lib/invariant": 57, "object-assign": 65 },
        ],
        74: [
            function (require, module, exports) {
                (function (process) {
                    "use strict";
                    if (process.env.NODE_ENV === "production") {
                        module.exports = require("./cjs/react.production.min.js");
                    } else {
                        module.exports = require("./cjs/react.development.js");
                    }
                }.call(this, require("rH1JPG")));
            },
            { "./cjs/react.development.js": 72, "./cjs/react.production.min.js": 73, rH1JPG: 66 },
        ],
        75: [
            function (require, module, exports) {
                (function (global, factory) {
                    _typeof(exports) === "object" && typeof module !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define(["exports"], factory) : factory((global.WHATWGFetch = {}));
                })(this, function (exports) {
                    "use strict";
                    var global = (typeof globalThis !== "undefined" && globalThis) || (typeof self !== "undefined" && self) || (typeof global !== "undefined" && global);
                    var support = {
                        searchParams: "URLSearchParams" in global,
                        iterable: "Symbol" in global && "iterator" in Symbol,
                        blob:
                            "FileReader" in global &&
                            "Blob" in global &&
                            (function () {
                                try {
                                    new Blob();
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            })(),
                        formData: "FormData" in global,
                        arrayBuffer: "ArrayBuffer" in global,
                    };
                    function isDataView(obj) {
                        return obj && DataView.prototype.isPrototypeOf(obj);
                    }
                    if (support.arrayBuffer) {
                        var viewClasses = [
                            "[object Int8Array]",
                            "[object Uint8Array]",
                            "[object Uint8ClampedArray]",
                            "[object Int16Array]",
                            "[object Uint16Array]",
                            "[object Int32Array]",
                            "[object Uint32Array]",
                            "[object Float32Array]",
                            "[object Float64Array]",
                        ];
                        var isArrayBufferView =
                            ArrayBuffer.isView ||
                            function (obj) {
                                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
                            };
                    }
                    function normalizeName(name) {
                        if (typeof name !== "string") {
                            name = String(name);
                        }
                        if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") {
                            throw new TypeError('Invalid character in header field name: "' + name + '"');
                        }
                        return name.toLowerCase();
                    }
                    function normalizeValue(value) {
                        if (typeof value !== "string") {
                            value = String(value);
                        }
                        return value;
                    } // Build a destructive iterator for the value list
                    function iteratorFor(items) {
                        var iterator = {
                            next: function next() {
                                var value = items.shift();
                                return { done: value === undefined, value: value };
                            },
                        };
                        if (support.iterable) {
                            iterator[Symbol.iterator] = function () {
                                return iterator;
                            };
                        }
                        return iterator;
                    }
                    function Headers(headers) {
                        this.map = {};
                        if (headers instanceof Headers) {
                            headers.forEach(function (value, name) {
                                this.append(name, value);
                            }, this);
                        } else if (Array.isArray(headers)) {
                            headers.forEach(function (header) {
                                this.append(header[0], header[1]);
                            }, this);
                        } else if (headers) {
                            Object.getOwnPropertyNames(headers).forEach(function (name) {
                                this.append(name, headers[name]);
                            }, this);
                        }
                    }
                    Headers.prototype.append = function (name, value) {
                        name = normalizeName(name);
                        value = normalizeValue(value);
                        var oldValue = this.map[name];
                        this.map[name] = oldValue ? oldValue + ", " + value : value;
                    };
                    Headers.prototype["delete"] = function (name) {
                        delete this.map[normalizeName(name)];
                    };
                    Headers.prototype.get = function (name) {
                        name = normalizeName(name);
                        return this.has(name) ? this.map[name] : null;
                    };
                    Headers.prototype.has = function (name) {
                        return this.map.hasOwnProperty(normalizeName(name));
                    };
                    Headers.prototype.set = function (name, value) {
                        this.map[normalizeName(name)] = normalizeValue(value);
                    };
                    Headers.prototype.forEach = function (callback, thisArg) {
                        for (var name in this.map) {
                            if (this.map.hasOwnProperty(name)) {
                                callback.call(thisArg, this.map[name], name, this);
                            }
                        }
                    };
                    Headers.prototype.keys = function () {
                        var items = [];
                        this.forEach(function (value, name) {
                            items.push(name);
                        });
                        return iteratorFor(items);
                    };
                    Headers.prototype.values = function () {
                        var items = [];
                        this.forEach(function (value) {
                            items.push(value);
                        });
                        return iteratorFor(items);
                    };
                    Headers.prototype.entries = function () {
                        var items = [];
                        this.forEach(function (value, name) {
                            items.push([name, value]);
                        });
                        return iteratorFor(items);
                    };
                    if (support.iterable) {
                        Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
                    }
                    function consumed(body) {
                        if (body.bodyUsed) {
                            return Promise.reject(new TypeError("Already read"));
                        }
                        body.bodyUsed = true;
                    }
                    function fileReaderReady(reader) {
                        return new Promise(function (resolve, reject) {
                            reader.onload = function () {
                                resolve(reader.result);
                            };
                            reader.onerror = function () {
                                reject(reader.error);
                            };
                        });
                    }
                    function readBlobAsArrayBuffer(blob) {
                        var reader = new FileReader();
                        var promise = fileReaderReady(reader);
                        reader.readAsArrayBuffer(blob);
                        return promise;
                    }
                    function readBlobAsText(blob) {
                        var reader = new FileReader();
                        var promise = fileReaderReady(reader);
                        reader.readAsText(blob);
                        return promise;
                    }
                    function readArrayBufferAsText(buf) {
                        var view = new Uint8Array(buf);
                        var chars = new Array(view.length);
                        for (var i = 0; i < view.length; i++) {
                            chars[i] = String.fromCharCode(view[i]);
                        }
                        return chars.join("");
                    }
                    function bufferClone(buf) {
                        if (buf.slice) {
                            return buf.slice(0);
                        } else {
                            var view = new Uint8Array(buf.byteLength);
                            view.set(new Uint8Array(buf));
                            return view.buffer;
                        }
                    }
                    function Body() {
                        this.bodyUsed = false;
                        this._initBody = function (body) {
                            /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ this.bodyUsed = this.bodyUsed;
                            this._bodyInit = body;
                            if (!body) {
                                this._bodyText = "";
                            } else if (typeof body === "string") {
                                this._bodyText = body;
                            } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
                                this._bodyBlob = body;
                            } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
                                this._bodyFormData = body;
                            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                                this._bodyText = body.toString();
                            } else if (support.arrayBuffer && support.blob && isDataView(body)) {
                                this._bodyArrayBuffer = bufferClone(body.buffer); // IE 10-11 can't handle a DataView body.
                                this._bodyInit = new Blob([this._bodyArrayBuffer]);
                            } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
                                this._bodyArrayBuffer = bufferClone(body);
                            } else {
                                this._bodyText = body = Object.prototype.toString.call(body);
                            }
                            if (!this.headers.get("content-type")) {
                                if (typeof body === "string") {
                                    this.headers.set("content-type", "text/plain;charset=UTF-8");
                                } else if (this._bodyBlob && this._bodyBlob.type) {
                                    this.headers.set("content-type", this._bodyBlob.type);
                                } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                                    this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                                }
                            }
                        };
                        if (support.blob) {
                            this.blob = function () {
                                var rejected = consumed(this);
                                if (rejected) {
                                    return rejected;
                                }
                                if (this._bodyBlob) {
                                    return Promise.resolve(this._bodyBlob);
                                } else if (this._bodyArrayBuffer) {
                                    return Promise.resolve(new Blob([this._bodyArrayBuffer]));
                                } else if (this._bodyFormData) {
                                    throw new Error("could not read FormData body as blob");
                                } else {
                                    return Promise.resolve(new Blob([this._bodyText]));
                                }
                            };
                            this.arrayBuffer = function () {
                                if (this._bodyArrayBuffer) {
                                    var isConsumed = consumed(this);
                                    if (isConsumed) {
                                        return isConsumed;
                                    }
                                    if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
                                        return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                                    } else {
                                        return Promise.resolve(this._bodyArrayBuffer);
                                    }
                                } else {
                                    return this.blob().then(readBlobAsArrayBuffer);
                                }
                            };
                        }
                        this.text = function () {
                            var rejected = consumed(this);
                            if (rejected) {
                                return rejected;
                            }
                            if (this._bodyBlob) {
                                return readBlobAsText(this._bodyBlob);
                            } else if (this._bodyArrayBuffer) {
                                return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                            } else if (this._bodyFormData) {
                                throw new Error("could not read FormData body as text");
                            } else {
                                return Promise.resolve(this._bodyText);
                            }
                        };
                        if (support.formData) {
                            this.formData = function () {
                                return this.text().then(decode);
                            };
                        }
                        this.json = function () {
                            return this.text().then(JSON.parse);
                        };
                        return this;
                    } // HTTP methods whose capitalization should be normalized
                    var methods = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
                    function normalizeMethod(method) {
                        var upcased = method.toUpperCase();
                        return methods.indexOf(upcased) > -1 ? upcased : method;
                    }
                    function Request(input, options) {
                        if (!(this instanceof Request)) {
                            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                        }
                        options = options || {};
                        var body = options.body;
                        if (input instanceof Request) {
                            if (input.bodyUsed) {
                                throw new TypeError("Already read");
                            }
                            this.url = input.url;
                            this.credentials = input.credentials;
                            if (!options.headers) {
                                this.headers = new Headers(input.headers);
                            }
                            this.method = input.method;
                            this.mode = input.mode;
                            this.signal = input.signal;
                            if (!body && input._bodyInit != null) {
                                body = input._bodyInit;
                                input.bodyUsed = true;
                            }
                        } else {
                            this.url = String(input);
                        }
                        this.credentials = options.credentials || this.credentials || "same-origin";
                        if (options.headers || !this.headers) {
                            this.headers = new Headers(options.headers);
                        }
                        this.method = normalizeMethod(options.method || this.method || "GET");
                        this.mode = options.mode || this.mode || null;
                        this.signal = options.signal || this.signal;
                        this.referrer = null;
                        if ((this.method === "GET" || this.method === "HEAD") && body) {
                            throw new TypeError("Body not allowed for GET or HEAD requests");
                        }
                        this._initBody(body);
                        if (this.method === "GET" || this.method === "HEAD") {
                            if (options.cache === "no-store" || options.cache === "no-cache") {
                                // Search for a '_' parameter in the query string
                                var reParamSearch = /([?&])_=[^&]*/;
                                if (reParamSearch.test(this.url)) {
                                    // If it already exists then set the value with the current time
                                    this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
                                } else {
                                    // Otherwise add a new '_' parameter to the end with the current time
                                    var reQueryString = /\?/;
                                    this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
                                }
                            }
                        }
                    }
                    Request.prototype.clone = function () {
                        return new Request(this, { body: this._bodyInit });
                    };
                    function decode(body) {
                        var form = new FormData();
                        body.trim()
                            .split("&")
                            .forEach(function (bytes) {
                                if (bytes) {
                                    var split = bytes.split("=");
                                    var name = split.shift().replace(/\+/g, " ");
                                    var value = split.join("=").replace(/\+/g, " ");
                                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                                }
                            });
                        return form;
                    }
                    function parseHeaders(rawHeaders) {
                        var headers = new Headers(); // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
                        // https://tools.ietf.org/html/rfc7230#section-3.2
                        var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " "); // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
                        // https://github.com/github/fetch/issues/748
                        // https://github.com/zloirock/core-js/issues/751
                        preProcessedHeaders
                            .split("\r")
                            .map(function (header) {
                                return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
                            })
                            .forEach(function (line) {
                                var parts = line.split(":");
                                var key = parts.shift().trim();
                                if (key) {
                                    var value = parts.join(":").trim();
                                    headers.append(key, value);
                                }
                            });
                        return headers;
                    }
                    Body.call(Request.prototype);
                    function Response(bodyInit, options) {
                        if (!(this instanceof Response)) {
                            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                        }
                        if (!options) {
                            options = {};
                        }
                        this.type = "default";
                        this.status = options.status === undefined ? 200 : options.status;
                        this.ok = this.status >= 200 && this.status < 300;
                        this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
                        this.headers = new Headers(options.headers);
                        this.url = options.url || "";
                        this._initBody(bodyInit);
                    }
                    Body.call(Response.prototype);
                    Response.prototype.clone = function () {
                        return new Response(this._bodyInit, { status: this.status, statusText: this.statusText, headers: new Headers(this.headers), url: this.url });
                    };
                    Response.error = function () {
                        var response = new Response(null, { status: 0, statusText: "" });
                        response.type = "error";
                        return response;
                    };
                    var redirectStatuses = [301, 302, 303, 307, 308];
                    Response.redirect = function (url, status) {
                        if (redirectStatuses.indexOf(status) === -1) {
                            throw new RangeError("Invalid status code");
                        }
                        return new Response(null, { status: status, headers: { location: url } });
                    };
                    exports.DOMException = global.DOMException;
                    try {
                        new exports.DOMException();
                    } catch (err) {
                        exports.DOMException = function (message, name) {
                            this.message = message;
                            this.name = name;
                            var error = Error(message);
                            this.stack = error.stack;
                        };
                        exports.DOMException.prototype = Object.create(Error.prototype);
                        exports.DOMException.prototype.constructor = exports.DOMException;
                    }
                    function fetch(input, init) {
                        return new Promise(function (resolve, reject) {
                            var request = new Request(input, init);
                            if (request.signal && request.signal.aborted) {
                                return reject(new exports.DOMException("Aborted", "AbortError"));
                            }
                            var xhr = new XMLHttpRequest();
                            function abortXhr() {
                                xhr.abort();
                            }
                            xhr.onload = function () {
                                var options = { status: xhr.status, statusText: xhr.statusText, headers: parseHeaders(xhr.getAllResponseHeaders() || "") };
                                options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                                var body = "response" in xhr ? xhr.response : xhr.responseText;
                                setTimeout(function () {
                                    resolve(new Response(body, options));
                                }, 0);
                            };
                            xhr.onerror = function () {
                                setTimeout(function () {
                                    reject(new TypeError("Network request failed"));
                                }, 0);
                            };
                            xhr.ontimeout = function () {
                                setTimeout(function () {
                                    reject(new TypeError("Network request failed"));
                                }, 0);
                            };
                            xhr.onabort = function () {
                                setTimeout(function () {
                                    reject(new exports.DOMException("Aborted", "AbortError"));
                                }, 0);
                            };
                            function fixUrl(url) {
                                try {
                                    return url === "" && global.location.href ? global.location.href : url;
                                } catch (e) {
                                    return url;
                                }
                            }
                            xhr.open(request.method, fixUrl(request.url), true);
                            if (request.credentials === "include") {
                                xhr.withCredentials = true;
                            } else if (request.credentials === "omit") {
                                xhr.withCredentials = false;
                            }
                            if ("responseType" in xhr) {
                                if (support.blob) {
                                    xhr.responseType = "blob";
                                } else if (support.arrayBuffer && request.headers.get("Content-Type") && request.headers.get("Content-Type").indexOf("application/octet-stream") !== -1) {
                                    xhr.responseType = "arraybuffer";
                                }
                            }
                            if (init && _typeof(init.headers) === "object" && !(init.headers instanceof Headers)) {
                                Object.getOwnPropertyNames(init.headers).forEach(function (name) {
                                    xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                                });
                            } else {
                                request.headers.forEach(function (value, name) {
                                    xhr.setRequestHeader(name, value);
                                });
                            }
                            if (request.signal) {
                                request.signal.addEventListener("abort", abortXhr);
                                xhr.onreadystatechange = function () {
                                    // DONE (success or failure)
                                    if (xhr.readyState === 4) {
                                        request.signal.removeEventListener("abort", abortXhr);
                                    }
                                };
                            }
                            xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
                        });
                    }
                    fetch.polyfill = true;
                    if (!global.fetch) {
                        global.fetch = fetch;
                        global.Headers = Headers;
                        global.Request = Request;
                        global.Response = Response;
                    }
                    exports.Headers = Headers;
                    exports.Request = Request;
                    exports.Response = Response;
                    exports.fetch = fetch;
                    Object.defineProperty(exports, "__esModule", { value: true });
                });
            },
            {},
        ],
        76: [
            function (require, module, exports) {
                (function (window) {
                    var YouTubeIframeLoader = {
                        src: "https://www.youtube.com/iframe_api",
                        loading: false,
                        loaded: false,
                        listeners: [],
                        load: function load(callback) {
                            var _this = this;
                            this.listeners.push(callback);
                            if (this.loaded) {
                                setTimeout(function () {
                                    _this.done();
                                });
                                return;
                            }
                            if (this.loading) {
                                return;
                            }
                            this.loading = true;
                            window.onYouTubeIframeAPIReady = function () {
                                _this.loaded = true;
                                _this.done();
                            };
                            var script = document.createElement("script");
                            script.type = "text/javascript";
                            script.src = this.src;
                            document.body.appendChild(script);
                        },
                        done: function done() {
                            delete window.onYouTubeIframeAPIReady;
                            while (this.listeners.length) {
                                this.listeners.pop()(window.YT);
                            }
                        },
                    };
                    if (typeof module !== "undefined" && module.exports) {
                        module.exports = YouTubeIframeLoader;
                    } else {
                        window.YouTubeIframeLoader = YouTubeIframeLoader;
                    }
                })(window);
            },
            {},
        ],
    },
    {},
    [2]
);
